(function (root, factory) {
	if (typeof module === "object" && module.exports) {
		module.exports = factory()
	} else {
		root.game = {
			config: factory(),
		}
	}
})(typeof self !== "undefined" ? self : this, function () {
	return {
		build_time: "09.02.2021 15:02:23",
		build_version: 680,
		channel: "poki",
		game_title: "Bouncy Woods",
		game_title_short: "Bouncy Woods",
		game_slug: "bouncy-woods",
	}
})
;
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var game;
(function (game) {
    var Config = /** @class */ (function () {
        function Config() {
        }
        Config.GAME_TITLE = "Bouncy_Woods";
        Config.SERVER_URL = "https://robowhale.com/html5/bouncy-woods-levels/";
        Config.SOURCE_GAME_WIDTH = 750;
        Config.SOURCE_GAME_HEIGHT = 1334;
        Config.IS_LANDSCAPE = Config.SOURCE_GAME_WIDTH > Config.SOURCE_GAME_HEIGHT;
        Config.IS_PORTRAIT = Config.SOURCE_GAME_HEIGHT > Config.SOURCE_GAME_WIDTH;
        Config.GAME_WIDTH = Config.SOURCE_GAME_WIDTH;
        Config.GAME_HEIGHT = Config.SOURCE_GAME_HEIGHT;
        Config.HALF_GAME_WIDTH = Config.GAME_WIDTH * 0.5;
        Config.HALF_GAME_HEIGHT = Config.GAME_HEIGHT * 0.5;
        Config.ASPECT_RATIO = Config.SOURCE_GAME_WIDTH / Config.SOURCE_GAME_HEIGHT;
        Config.ZOOM = 1;
        Config.ASSETS_SCALE = 1;
        return Config;
    }());
    game.Config = Config;
})(game || (game = {}));
var game;
(function (game_1) {
    var WebGLRenderer = Phaser.Renderer.WebGL.WebGLRenderer;
    var CanvasRenderer = Phaser.Renderer.Canvas.CanvasRenderer;
    var GameConfigCreator = /** @class */ (function () {
        function GameConfigCreator() {
        }
        GameConfigCreator.create = function () {
            return {
                type: this.getRenderType(),
                scale: this.createScaleConfig(),
                audio: this.createAudioConfig(),
                parent: "canvas-container",
                input: {
                    windowEvents: true,
                    smoothFactor: 0.5,
                },
                render: {
                    clearBeforeRender: false,
                    transparent: false,
                    failIfMajorPerformanceCaveat: true,
                    powerPreference: "high-performance",
                    antialias: this.disableAntialias() === false,
                },
                banner: {
                    background: ["rgba(0,0,255,0.4)"],
                },
                plugins: {
                    global: [
                        {
                            key: "gacha",
                            plugin: rexgashaponplugin,
                            start: true,
                        },
                        {
                            key: "rexWebfontLoader",
                            plugin: rexwebfontloaderplugin,
                            start: true,
                        },
                        {
                            key: "rexawaitloaderplugin",
                            plugin: rexawaitloaderplugin,
                            start: true,
                        },
                    ],
                },
                callbacks: {
                    preBoot: this.preBootCallback.bind(this),
                    postBoot: this.postBootCallback.bind(this),
                },
            };
        };
        GameConfigCreator.getRenderType = function () {
            var canvas = utils.NetUtil.getParam("forceCanvas");
            if (canvas === "1") {
                return Phaser.CANVAS;
            }
            return Phaser.AUTO;
        };
        GameConfigCreator.createScaleConfig = function () {
            return utils.DeviceUtil.isDesktop()
                ? this.createDesktopScaleConfig()
                : this.createMobileScaleConfig();
        };
        GameConfigCreator.createDesktopScaleConfig = function () {
            game_1.Config.SOURCE_GAME_HEIGHT = 960;
            game_1.Config.GAME_HEIGHT = game_1.Config.SOURCE_GAME_HEIGHT;
            game_1.Config.HALF_GAME_HEIGHT = game_1.Config.GAME_HEIGHT / 2;
            game_1.Config.ASPECT_RATIO = game_1.Config.SOURCE_GAME_WIDTH / game_1.Config.SOURCE_GAME_HEIGHT;
            var config = {
                width: game_1.Config.SOURCE_GAME_WIDTH,
                height: game_1.Config.SOURCE_GAME_HEIGHT,
                autoCenter: Phaser.Scale.CENTER_VERTICALLY,
                mode: Phaser.Scale.FIT,
            };
            var originalSize = utils.NetUtil.getParamBool("originalSize");
            if (originalSize) {
                config.max = {
                    width: game_1.Config.SOURCE_GAME_WIDTH,
                    height: game_1.Config.SOURCE_GAME_HEIGHT,
                };
            }
            return config;
        };
        GameConfigCreator.createMobileScaleConfig = function () {
            return {
                width: game_1.Config.SOURCE_GAME_WIDTH,
                height: game_1.Config.SOURCE_GAME_HEIGHT,
                mode: Phaser.Scale.NONE,
            };
        };
        GameConfigCreator.createAudioConfig = function () {
            var _a;
            var AudioContext = (_a = window["AudioContext"]) !== null && _a !== void 0 ? _a : window["webkitAudioContext"];
            var isAudioContextAvailable = typeof AudioContext !== "undefined";
            if (isAudioContextAvailable === false) {
                return {
                    disableWebAudio: true,
                };
            }
            var context = this.createAudioContext(AudioContext);
            if (typeof context.resume === "undefined" || typeof context.suspend === "undefined") {
                return {
                    disableWebAudio: true,
                };
            }
            var noWebAudio = utils.NetUtil.getParamBool("noWebAudio");
            return {
                disableWebAudio: noWebAudio,
                context: context,
            };
        };
        GameConfigCreator.createAudioContext = function (AudioContext) {
            var options = {
                sampleRate: 44100,
                latencyHint: "playback",
            };
            var context;
            try {
                context = new AudioContext(options);
            }
            catch (e) {
                context = new AudioContext();
            }
            return context;
        };
        GameConfigCreator.disableAntialias = function () {
            return utils.NetUtil.getParamBool("noaa");
        };
        GameConfigCreator.preBootCallback = function (game) {
        };
        GameConfigCreator.postBootCallback = function (game) {
            game.audioType = game_1.GameAudio.getAudioType(game.sound);
            game.rendererType = this.getRendererType(game.renderer);
            game.raven = new game_1.RavenWrapper(game);
            game.raven.setContextsOnStart();
        };
        GameConfigCreator.getRendererType = function (renderer) {
            if (renderer instanceof WebGLRenderer) {
                return game_1.RendererType.WEBGL;
            }
            else if (renderer instanceof CanvasRenderer) {
                return game_1.RendererType.CANVAS;
            }
            return game_1.RendererType.HEADLESS;
        };
        return GameConfigCreator;
    }());
    game_1.GameConfigCreator = GameConfigCreator;
})(game || (game = {}));
var game;
(function (game_2) {
    var RavenWrapper = /** @class */ (function () {
        function RavenWrapper(game) {
            this._enabled = false;
            this.game = game;
            this._enabled = typeof Raven !== "undefined" && Raven.isSetup();
        }
        Object.defineProperty(RavenWrapper.prototype, "enabled", {
            get: function () {
                return this._enabled;
            },
            enumerable: false,
            configurable: true
        });
        RavenWrapper.prototype.captureBreadcrumb = function (crumb) {
            if (this._enabled === false) {
                return;
            }
            Raven.captureBreadcrumb(crumb);
        };
        RavenWrapper.prototype.addTagsContext = function (tags) {
            if (this._enabled === false) {
                return;
            }
            Raven.setTagsContext(tags);
        };
        RavenWrapper.prototype.addExtraContext = function (context) {
            if (this._enabled === false) {
                return;
            }
            Raven.setExtraContext(context);
        };
        RavenWrapper.prototype.setContextsOnStart = function () {
            var _a;
            if (this._enabled === false) {
                return;
            }
            Raven.setTagsContext({
                renderer: this.game.rendererType,
                audio: this.game.audioType,
                browserLanguage: navigator.language,
                audioSampleRate: (_a = this.game.sound["context"]) === null || _a === void 0 ? void 0 : _a.sampleRate,
            });
            var device = this.game.device;
            Raven.setExtraContext({
                gameplayLoaded: false,
                levelsMapLoaded: false,
                device: {
                    fullscreen: device.fullscreen.available,
                    vibration: device.features.vibration,
                    canvas: device.features.canvas,
                    webgl: device.features.webGL,
                    audio: {
                        mp3: device.audio.mp3,
                        m4a: device.audio.m4a,
                        wav: device.audio.wav,
                    },
                },
            });
        };
        RavenWrapper.prototype.trackSceneChanges = function (transition) {
            if (this._enabled === false) {
                return;
            }
            transition.on(game_2.SceneTransitionEvent.COMPLETE, this.onSceneTransitionComplete, this);
        };
        RavenWrapper.prototype.onSceneTransitionComplete = function (transition, oldSceneKey, newSceneKey, newSceneData) {
            Raven.setExtraContext({
                lastScene: oldSceneKey,
                currentScene: newSceneKey,
                currentSceneData: newSceneData,
            });
            this.trackSceneInput(newSceneKey);
        };
        RavenWrapper.prototype.trackSceneInput = function (sceneKey) {
            var _a;
            if (this._enabled === false) {
                return;
            }
            var scene = this.game.scene.getScene(sceneKey);
            if (scene) {
                scene.events.once(Phaser.Scenes.Events.SHUTDOWN, this.removePointerDownListener.bind(this, scene));
                (_a = scene.input) === null || _a === void 0 ? void 0 : _a.on(Phaser.Input.Events.POINTER_DOWN, this.onPointerDown, this);
            }
        };
        RavenWrapper.prototype.removePointerDownListener = function (scene) {
            var _a;
            (_a = scene.input) === null || _a === void 0 ? void 0 : _a.off(Phaser.Input.Events.POINTER_DOWN, this.onPointerDown, this);
        };
        RavenWrapper.prototype.onPointerDown = function (pointer, objects) {
            var clicked = objects.map(function (obj) {
                var _a, _b;
                return obj.name || ((_a = obj["frame"]) === null || _a === void 0 ? void 0 : _a.name) || ((_b = obj["texture"]) === null || _b === void 0 ? void 0 : _b.key);
            });
            if (clicked.length === 0) {
                return;
            }
            Raven.setExtraContext({
                lastClick: clicked.join(),
            });
        };
        RavenWrapper.prototype.captureMessage = function (message, level) {
            if (level === void 0) { level = "info"; }
            if (this._enabled) {
                Raven.captureMessage(message, { level: level });
            }
        };
        RavenWrapper.prototype.captureException = function (exception, options) {
            if (this._enabled) {
                Raven.captureException(exception, options);
            }
        };
        return RavenWrapper;
    }());
    game_2.RavenWrapper = RavenWrapper;
})(game || (game = {}));
var game;
(function (game) {
    var FontWeight;
    (function (FontWeight) {
        FontWeight["BOLD"] = "700";
        FontWeight["BLACK"] = "900";
    })(FontWeight = game.FontWeight || (game.FontWeight = {}));
    var GameFontsEvent;
    (function (GameFontsEvent) {
        GameFontsEvent["WEBFONT_ACTIVE"] = "webfontactive";
        GameFontsEvent["WEBFONT_INACTIVE"] = "webfontinactive";
    })(GameFontsEvent = game.GameFontsEvent || (game.GameFontsEvent = {}));
    var GameFont;
    (function (GameFont) {
        GameFont["SOUSES"] = "Souses";
        GameFont["DEFAULT"] = "Souses";
    })(GameFont = game.GameFont || (game.GameFont = {}));
    var BitmapGameFont;
    (function (BitmapGameFont) {
        BitmapGameFont["GAMEPLAY_BOOSTERS"] = "GAMEPLAY_BOOSTERS";
        BitmapGameFont["GAMEPLAY_GUI_BOOSTERS"] = "GAMEPLAY_GUI_BOOSTERS";
        BitmapGameFont["BLOCKS_LABEL_COMPLETE"] = "BLOCKS_LABEL_COMPLETE";
        BitmapGameFont["BLOCKS_LABEL"] = "BLOCKS_LABEL";
        BitmapGameFont["INGAME_GUI_DIGITS"] = "ingame_gui_digits";
        BitmapGameFont["EDITOR_BLOCK_LIVES"] = "editor_block_lives";
        BitmapGameFont["EDITOR_ROW_NUMBERS"] = "editor_row_numbers";
        BitmapGameFont["LEVELS_MAP_NUMBERS_COMPLETE"] = "LEVELS_MAP_NUMBERS_COMPLETE";
        BitmapGameFont["LEVELS_MAP_NUMBERS_UNLOCKED"] = "LEVELS_MAP_NUMBERS_UNLOCKED";
        BitmapGameFont["BLOCK_DAMAGE_FX"] = "BLOCK_DAMAGE_FX";
        BitmapGameFont["BLOCK_LIVES"] = "BLOCK_LIVES";
    })(BitmapGameFont = game.BitmapGameFont || (game.BitmapGameFont = {}));
    var GameFonts = /** @class */ (function (_super) {
        __extends(GameFonts, _super);
        function GameFonts(_game) {
            var _this = _super.call(this) || this;
            _this.game = _game;
            return _this;
        }
        return GameFonts;
    }(Phaser.Events.EventEmitter));
    game.GameFonts = GameFonts;
})(game || (game = {}));
///<reference path="ITexts.ts"/>
var game;
(function (game) {
    var EventEmitter = Phaser.Events.EventEmitter;
    game.LANGUAGES_MAP = {
        "ru": "Русский",
        "en": "English",
        "fr": "Français",
        "it": "Italiano",
        "de": "Deutsch",
        "es": "Español",
        "nl": "Nederlands",
        "no": "Norsk",
        "fi": "Suomi",
        "br": "Brasileiro",
        "pt": "Português",
    };
    function getLanguageTitle(shortCode) {
        return game.LANGUAGES_MAP[shortCode];
    }
    game.getLanguageTitle = getLanguageTitle;
    var GameTextsEvent;
    (function (GameTextsEvent) {
        GameTextsEvent["LANGUAGE_CHANGE"] = "GameTexts_LANGUAGE_CHANGE";
    })(GameTextsEvent = game.GameTextsEvent || (game.GameTextsEvent = {}));
    var GameTexts = /** @class */ (function (_super) {
        __extends(GameTexts, _super);
        function GameTexts(_game) {
            var _this = _super.call(this) || this;
            _this.game = _game;
            _this.allTexts = _this.game.cache.json.get("texts");
            _this.allLanguages = Object.keys(_this.allTexts);
            _this._language = _this.detectLanguage();
            _this.texts = _this.allTexts[_this._language];
            _this.game.raven.addTagsContext({ gameLanguage: _this._language });
            console.info("Language: " + _this._language);
            return _this;
            // console.groupCollapsed("Texts")
            // console.log(this.texts)
            // console.groupEnd()
        }
        Object.defineProperty(GameTexts.prototype, "language", {
            get: function () {
                return this._language;
            },
            enumerable: false,
            configurable: true
        });
        GameTexts.prototype.detectLanguage = function () {
            return (this.getLanguageFromUrlParam() ||
                this.getSavedLanguage() ||
                this.getLanguageFromBrowser() ||
                "en");
        };
        GameTexts.prototype.getLanguageFromUrlParam = function () {
            var language = utils.NetUtil.getParam("lang") || utils.NetUtil.getParam("language");
            if (language && typeof language === "string" && this.isLanguageSupported(language)) {
                return language;
            }
            return null;
        };
        GameTexts.prototype.getSavedLanguage = function () {
            return this.game.store.getValue(game.GameStoreKey.LANGUAGE);
        };
        GameTexts.prototype.getLanguageFromBrowser = function () {
            var langugage = navigator.language.split("-")[0].toLowerCase();
            if (langugage && this.isLanguageSupported(langugage)) {
                return langugage;
            }
            return;
        };
        GameTexts.prototype.isLanguageSupported = function (language) {
            return this.allLanguages.includes(language);
        };
        GameTexts.prototype.injectTextsIntoScenes = function () {
            var _this = this;
            this.game.scene.getScenes(false).forEach(function (scene) {
                scene["texts"] = _this.texts;
            });
        };
        GameTexts.prototype.setLanguage = function (language) {
            if (!this.isLanguageSupported(language)) {
                console.warn("Language " + language + " is not supported!");
                return false;
            }
            this._language = language;
            this.texts = this.allTexts[language];
            this.game.raven.addTagsContext({ gameLanguage: this._language });
            this.injectTextsIntoScenes();
            this.emit(GameTextsEvent.LANGUAGE_CHANGE, language);
            return true;
        };
        return GameTexts;
    }(EventEmitter));
    game.GameTexts = GameTexts;
})(game || (game = {}));
///<reference path="IStorage.ts"/>
var game;
(function (game) {
    var RuntimeStorage /*implements IStorage*/ = /** @class */ (function () {
        function RuntimeStorage() {
            this.name = "Runtime Storage";
            this.storage = {};
        }
        Object.defineProperty(RuntimeStorage.prototype, "namespace", {
            get: function () {
                return this._namespace;
            },
            enumerable: false,
            configurable: true
        });
        RuntimeStorage.prototype.init = function () { };
        RuntimeStorage.prototype.setNamespace = function (namespace) {
            this._namespace = namespace;
        };
        RuntimeStorage.prototype.saveValue = function (key, value) {
            this.storage[this.getSaveKey(key)] = value;
        };
        RuntimeStorage.prototype.getValue = function (key) {
            return this.storage[this.getSaveKey(key)];
        };
        RuntimeStorage.prototype.getNumber = function (key) {
            return this.getValue(key) || 0;
        };
        RuntimeStorage.prototype.getBoolean = function (key) {
            return this.getValue(key) || false;
        };
        RuntimeStorage.prototype.getString = function (key) {
            return this.getValue(key) || "";
        };
        RuntimeStorage.prototype.getObject = function (key) {
            return this.getValue(key) || {};
        };
        RuntimeStorage.prototype.getContent = function (ignoreNamespace) {
            var _this = this;
            if (ignoreNamespace === void 0) { ignoreNamespace = false; }
            if (ignoreNamespace) {
                return this.storage;
            }
            else {
                var keys = Object.keys(this.storage).filter(function (key) {
                    return key.indexOf(_this._namespace) > -1;
                });
                var content_1 = {};
                keys.forEach(function (key) {
                    content_1[key] = _this.storage[key];
                });
                return content_1;
            }
        };
        RuntimeStorage.prototype.clear = function (ignoreNamespace) {
            var _this = this;
            if (ignoreNamespace === void 0) { ignoreNamespace = false; }
            if (ignoreNamespace) {
                this.storage = {};
            }
            else {
                var keysToDelete = Object.keys(this.storage).filter(function (key) {
                    return key.indexOf(_this._namespace) > -1;
                });
                keysToDelete.forEach(function (key) {
                    delete _this.storage[key];
                });
            }
        };
        RuntimeStorage.prototype.getSaveKey = function (key) {
            return this._namespace + "__" + key;
        };
        return RuntimeStorage;
    }());
    game.RuntimeStorage = RuntimeStorage;
})(game || (game = {}));
var game;
(function (game) {
    var LocalForageWrapper = /** @class */ (function () {
        function LocalForageWrapper(storeName) {
            this.type = "Local Forage";
            this.storeName = storeName;
        }
        LocalForageWrapper.prototype.init = function () {
            return __awaiter(this, void 0, void 0, function () {
                var testKey, results, error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            this.instance = localforage.createInstance({
                                driver: [localforage.LOCALSTORAGE, localforage.INDEXEDDB],
                                storeName: this.storeName,
                                name: "robowhale",
                            });
                            testKey = "testKey";
                            return [4 /*yield*/, Promise.all([
                                    this.instance.setItem(testKey, testKey),
                                    this.instance.getItem(testKey),
                                    this.instance.removeItem(testKey),
                                ])];
                        case 1:
                            results = _a.sent();
                            return [2 /*return*/, Promise.resolve()];
                        case 2:
                            error_1 = _a.sent();
                            this.instance = null;
                            return [2 /*return*/, Promise.reject(error_1)];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        LocalForageWrapper.prototype.saveValue = function (key, value) {
            var _a;
            var dataToSave = typeof value === "string"
                ? value
                : JSON.stringify(value);
            return (_a = this.instance) === null || _a === void 0 ? void 0 : _a.setItem(this.getStorageKey(key), dataToSave);
        };
        LocalForageWrapper.prototype.getStorageKey = function (key) {
            return "__" + key;
        };
        LocalForageWrapper.prototype.getValue = function (key) {
            var _a;
            return Promise.resolve((_a = this.instance) === null || _a === void 0 ? void 0 : _a.getItem(this.getStorageKey(key)));
        };
        LocalForageWrapper.prototype.getNumber = function (key) {
            return __awaiter(this, void 0, void 0, function () {
                var value, num;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.getValue(key)];
                        case 1:
                            value = _a.sent();
                            if (value === null) {
                                return [2 /*return*/, Promise.resolve(0)];
                            }
                            else {
                                num = parseFloat(value) || 0;
                                return [2 /*return*/, Promise.resolve(num)];
                            }
                            return [2 /*return*/];
                    }
                });
            });
        };
        LocalForageWrapper.prototype.getBoolean = function (key) {
            return __awaiter(this, void 0, void 0, function () {
                var value, bool;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.getValue(key)];
                        case 1:
                            value = _a.sent();
                            if (value === null) {
                                return [2 /*return*/, Promise.resolve(false)];
                            }
                            else {
                                bool = value === "true";
                                return [2 /*return*/, Promise.resolve(bool)];
                            }
                            return [2 /*return*/];
                    }
                });
            });
        };
        LocalForageWrapper.prototype.getString = function (key) {
            return __awaiter(this, void 0, void 0, function () {
                var value;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.getValue(key)];
                        case 1:
                            value = _a.sent();
                            if (value === null) {
                                return [2 /*return*/, Promise.resolve("")];
                            }
                            else {
                                return [2 /*return*/, Promise.resolve(value)];
                            }
                            return [2 /*return*/];
                    }
                });
            });
        };
        LocalForageWrapper.prototype.getObject = function (key) {
            return __awaiter(this, void 0, void 0, function () {
                var value, obj;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.getValue(key)];
                        case 1:
                            value = _a.sent();
                            obj = null;
                            try {
                                obj = JSON.parse(value);
                            }
                            catch (e) {
                                console.error(e);
                            }
                            return [2 /*return*/, Promise.resolve(obj)];
                    }
                });
            });
        };
        LocalForageWrapper.prototype.remove = function (key) {
            var _a;
            (_a = this.instance) === null || _a === void 0 ? void 0 : _a.removeItem(this.getStorageKey(key));
        };
        LocalForageWrapper.prototype.clear = function () {
            var _this = this;
            Object.keys(this.instance)
                .filter(function (key) { return key.includes(_this.storeName); })
                .forEach(function (key) {
                var _a;
                (_a = _this.instance) === null || _a === void 0 ? void 0 : _a.removeItem(key);
            });
            return Promise.resolve();
        };
        LocalForageWrapper.prototype.getDriverType = function () {
            if (!this.instance) {
                return "none";
            }
            switch (this.instance["_driver"]) {
                case localforage.LOCALSTORAGE:
                    return "localStorage";
                case localforage.INDEXEDDB:
                    return "indexed db";
                case localforage.WEBSQL:
                    return "websql";
                default:
                    return "none";
            }
        };
        return LocalForageWrapper;
    }());
    game.LocalForageWrapper = LocalForageWrapper;
})(game || (game = {}));
///<reference path="robowhale/storage/IStorage.ts"/>
///<reference path="robowhale/storage/RuntimeStorage.ts"/>
///<reference path="robowhale/storage/LocalForageWrapper.ts"/>
var game;
(function (game_3) {
    var EventEmitter = Phaser.Events.EventEmitter;
    var GameStoreKey;
    (function (GameStoreKey) {
        GameStoreKey["LEVEL_GIFTS"] = "level_gifts";
        GameStoreKey["INGAME_BOOSTERS"] = "ingame_boosters";
        GameStoreKey["LEVELS"] = "levels";
        GameStoreKey["LANGUAGE"] = "language";
        GameStoreKey["SOUND_MUTED"] = "sound_muted";
        GameStoreKey["EDITOR_ZOOM"] = "editor_zoom";
        GameStoreKey["FAST_FORWARD_WAS_USED"] = "fast_forward_was_used";
        GameStoreKey["LOSE_TUTORIAL_COMPLETE"] = "lose_tutorial_complete";
    })(GameStoreKey = game_3.GameStoreKey || (game_3.GameStoreKey = {}));
    var GameStoreEvent;
    (function (GameStoreEvent) {
        GameStoreEvent["CLEAR"] = "GameStore_CLEAR";
    })(GameStoreEvent = game_3.GameStoreEvent || (game_3.GameStoreEvent = {}));
    var GameStore = /** @class */ (function (_super) {
        __extends(GameStore, _super);
        function GameStore(game, storeName) {
            var _this = _super.call(this) || this;
            _this.game = game;
            _this.storeName = storeName;
            _this.initRuntimeStorage();
            return _this;
        }
        GameStore.prototype.initRuntimeStorage = function () {
            this._runtimeStorage = new game_3.RuntimeStorage();
            this._runtimeStorage.setNamespace(game.Config.GAME_TITLE);
        };
        GameStore.prototype.initActualStorage = function () {
            return this.useLocalForage();
        };
        GameStore.prototype.useLocalForage = function () {
            var _this = this;
            var forage = new game_3.LocalForageWrapper(this.storeName);
            return new Promise(function (resolve, reject) {
                forage.init()
                    .then(function () {
                    _this.setStorage(forage);
                    resolve();
                })
                    .catch(function (error) {
                    reject(error);
                })
                    .finally(function () {
                    var _a, _b;
                    var storageType = forage.getDriverType();
                    (_a = _this.game.raven) === null || _a === void 0 ? void 0 : _a.addTagsContext({ storage: storageType });
                    (_b = _this.game.analytics) === null || _b === void 0 ? void 0 : _b.sendDesignEvent("Storage:" + storageType);
                });
            });
        };
        GameStore.prototype.setStorage = function (storage) {
            this._storage = storage;
        };
        GameStore.prototype.getValue = function (key) {
            return this._runtimeStorage.getValue(key);
        };
        GameStore.prototype.getBoolean = function (key) {
            return this._runtimeStorage.getBoolean(key);
        };
        GameStore.prototype.getNumber = function (key) {
            return this._runtimeStorage.getNumber(key);
        };
        GameStore.prototype.getObject = function (key) {
            return this._runtimeStorage.getObject(key);
        };
        GameStore.prototype.saveValue = function (key, value) {
            var _a;
            (_a = this._storage) === null || _a === void 0 ? void 0 : _a.saveValue(key, value);
            this._runtimeStorage.saveValue(key, value);
        };
        GameStore.prototype.changeNumber = function (key, delta, min, max) {
            if (min === void 0) { min = Number.MIN_SAFE_INTEGER; }
            if (max === void 0) { max = Number.MAX_SAFE_INTEGER; }
            var oldValue = this.getNumber(key);
            var newValue = oldValue + delta;
            newValue = Phaser.Math.Clamp(newValue, min, max);
            this.saveValue(key, newValue);
            return newValue;
        };
        GameStore.prototype.getLevelResult = function (levelNumber) {
            var allData = this.getObject(GameStoreKey.LEVELS);
            return allData[levelNumber];
        };
        GameStore.prototype.saveLevelResult = function (levelNumber, data) {
            var _a;
            var allData = this.getObject(GameStoreKey.LEVELS);
            var newData = __assign(__assign({}, allData), (_a = {}, _a[levelNumber] = data, _a));
            this.saveValue(GameStoreKey.LEVELS, newData);
        };
        GameStore.prototype.loadInitialValues = function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, Promise.all([
                                this.loadValue(GameStoreKey.LANGUAGE, ""),
                                this.loadValue(GameStoreKey.SOUND_MUTED, false),
                                this.loadValue(GameStoreKey.LEVELS, {}),
                                this.loadValue(GameStoreKey.LEVEL_GIFTS, {}),
                                this.loadValue(GameStoreKey.INGAME_BOOSTERS, {}),
                                this.loadValue(GameStoreKey.EDITOR_ZOOM, 1),
                                this.loadValue(GameStoreKey.FAST_FORWARD_WAS_USED, false),
                                this.loadValue(GameStoreKey.LOSE_TUTORIAL_COMPLETE, false),
                            ])];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        };
        GameStore.prototype.loadValue = function (key, defaultValue, callback, callbackContext) {
            return __awaiter(this, void 0, void 0, function () {
                var cb, cbContext, value;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!this._storage) {
                                this._runtimeStorage.saveValue(key, defaultValue);
                                return [2 /*return*/];
                            }
                            cb = callback || this.getLoadCallbackByValueType(defaultValue);
                            cbContext = callbackContext || this._storage;
                            return [4 /*yield*/, cb.call(cbContext, key)];
                        case 1:
                            value = (_a.sent()) || defaultValue;
                            this._runtimeStorage.saveValue(key, value);
                            return [2 /*return*/];
                    }
                });
            });
        };
        GameStore.prototype.getLoadCallbackByValueType = function (value) {
            var valueType = typeof value;
            switch (valueType) {
                case "number":
                    return this._storage.getNumber;
                case "string":
                    return this._storage.getValue;
                case "boolean":
                    return this._storage.getBoolean;
                case "object":
                    return this._storage.getObject;
                default:
                    return this._storage.getValue;
            }
        };
        GameStore.prototype.checkLoadedValues = function () {
            var keys = Object.keys(GameStoreKey).map(function (key) {
                return GameStoreKey[key];
            });
            var loadedKeys = Object.keys(this._runtimeStorage.getContent()).map(function (key) {
                return key.split("__")[1];
            });
            var diff = _.xor(keys, loadedKeys);
            if (diff.length > 0) {
                console.warn("Not all saved values were loaded!", diff);
            }
        };
        GameStore.prototype.clear = function () {
            this.saveValue(GameStoreKey.LEVELS, {});
            this.saveValue(GameStoreKey.LEVEL_GIFTS, {});
            this.saveValue(GameStoreKey.INGAME_BOOSTERS, {});
            this.saveValue(GameStoreKey.EDITOR_ZOOM, 1);
            this.saveValue(GameStoreKey.FAST_FORWARD_WAS_USED, false);
            this.saveValue(GameStoreKey.LOSE_TUTORIAL_COMPLETE, false);
            this.emit(GameStoreEvent.CLEAR, this);
        };
        GameStore.prototype.migrateSaveData = function () {
            var _a;
            var _this = this;
            try {
                var transformValueMap_1 = (_a = {},
                    _a[GameStoreKey.INGAME_BOOSTERS] = function (value) { return JSON.parse(value); },
                    _a[GameStoreKey.LEVEL_GIFTS] = function (value) { return JSON.parse(value); },
                    _a[GameStoreKey.LEVELS] = function (value) { return JSON.parse(value); },
                    _a[GameStoreKey.LANGUAGE] = function (value) { return value; },
                    _a[GameStoreKey.EDITOR_ZOOM] = function (value) { return parseFloat(value); },
                    _a[GameStoreKey.SOUND_MUTED] = function (value) { return value === "true"; },
                    _a[GameStoreKey.FAST_FORWARD_WAS_USED] = function (value) { return value === "true"; },
                    _a[GameStoreKey.LOSE_TUTORIAL_COMPLETE] = function (value) { return value === "true"; },
                    _a);
                Object.keys(localStorage)
                    .filter(function (key) { return key.includes("Bouncy_Woods"); })
                    .forEach(function (key) {
                    var newKey = key.split("__")[1];
                    var transformValueCallback = transformValueMap_1[newKey];
                    if (transformValueCallback) {
                        var oldValue = localStorage.getItem(key);
                        var newValue = transformValueCallback(oldValue);
                        _this.saveValue(newKey, newValue);
                        localStorage.removeItem(key);
                    }
                });
            }
            catch (error) {
            }
        };
        return GameStore;
    }(EventEmitter));
    game_3.GameStore = GameStore;
})(game || (game = {}));
var game;
(function (game) {
    var GameSoundKey;
    (function (GameSoundKey) {
        GameSoundKey["MENU_LOOP"] = "menu_loop";
        GameSoundKey["GAMEPLAY_LOOP"] = "forest_sounds";
        //
        GameSoundKey["TAP"] = "tap";
        GameSoundKey["FANCY_TAP"] = "fancy_tap";
        GameSoundKey["GIFT_REVEAL"] = "gift_reveal";
        GameSoundKey["GIFT_CHARGE"] = "gift_charge_1";
        GameSoundKey["GIFT_EXPLODE"] = "gift_explode";
        GameSoundKey["CATCH_YOU_SHOUT"] = "catch_you_shout";
        GameSoundKey["STOP_SHOUT"] = "stop_shout";
        GameSoundKey["BOOSTER_STOP_ACTIVE"] = "booster_stop_active";
        GameSoundKey["BOOSTER_BOMB_IGNITE"] = "booster_bomb_ignite";
        GameSoundKey["BOOSTER_CRACKER"] = "booster_cracker";
        GameSoundKey["BOOSTER_CRACKER_PUNCH"] = "booster_cracker_punch";
        GameSoundKey["AIM_1"] = "aim_1_1";
        GameSoundKey["AIM_2"] = "aim_1_2";
        GameSoundKey["AIM_3"] = "aim_1_8";
        GameSoundKey["BALL_THROW"] = "ball_throw_2";
        GameSoundKey["BALL_HIT_1"] = "ball_hit_1";
        GameSoundKey["BALL_HIT_2"] = "ball_hit_2";
        GameSoundKey["BALL_HIT_3"] = "ball_hit_3";
        GameSoundKey["BLOCK_HIT"] = "block_hit";
        GameSoundKey["BLOCK_ZAPPED"] = "block_zapped_1";
        GameSoundKey["BLOCK_COLLECTED_WHOOSH"] = "block_collected_whoosh";
        GameSoundKey["BLOCK_COLLECTED"] = "block_collected";
        GameSoundKey["PINATA"] = "block_pinata";
        GameSoundKey["EXPLOSION"] = "explosion1";
        GameSoundKey["SPINNER"] = "spinner";
        GameSoundKey["LIGHTNING"] = "lightning_1";
        GameSoundKey["NEW_BALL_HIT"] = "new_ball_hit_2";
        GameSoundKey["NEW_BALL_LANDED"] = "new_ball_landed_3";
        GameSoundKey["MOVE_ITEMS_UP"] = "move_items_up";
        GameSoundKey["MOVE_ITEMS_DOWN"] = "move_items_down";
        GameSoundKey["CLEAR_FIELD_MOVE_COMPLETE"] = "clear_field_move_complete";
        GameSoundKey["CLEAR_FIELD"] = "clear_field";
        GameSoundKey["TURN_COMPLETE_TEXT"] = "turn_complete_text";
        GameSoundKey["WINNING_BALL_WHOOSH"] = "winning_ball_whoosh";
        GameSoundKey["POP_1"] = "pop_1";
        GameSoundKey["LEVEL_COMPLETE_TEXT"] = "level_complete_text";
        GameSoundKey["LEVEL_COMPLETE"] = "level_complete";
        GameSoundKey["LEVEL_COMPLETE_STAR_SHOW_1"] = "level_complete_star_show1";
        GameSoundKey["LEVEL_COMPLETE_STAR_SHOW_2"] = "level_complete_star_show2";
        GameSoundKey["LEVEL_COMPLETE_STAR_SHOW_3"] = "level_complete_star_show3";
        GameSoundKey["FOX_OOH"] = "fox_ooh";
        GameSoundKey["FOX_UH_OH_1"] = "fox_uh_oh_1";
        GameSoundKey["FOX_UH_OH_2"] = "fox_uh_oh_2";
        GameSoundKey["BLOCK_STOMP_WHOOSH"] = "block_stomp_whoosh";
        GameSoundKey["BLOCK_STOMP_HIT"] = "block_stomp_hit_1";
        GameSoundKey["DUCK_SCREAM"] = "duck_scream_2";
        GameSoundKey["LEVEL_FAILED"] = "level_failed_2";
        GameSoundKey["FAST_FORWARD"] = "fast_forward";
        GameSoundKey["DROP_BALLS_DOWN"] = "drop_balls_down_3";
        GameSoundKey["STAR_TWINKLE_1"] = "star_twinkle_2";
        GameSoundKey["STAR_TWINKLE_2"] = "star_twinkle_3";
    })(GameSoundKey = game.GameSoundKey || (game.GameSoundKey = {}));
})(game || (game = {}));
///<reference path='GameSoundKey.ts' />
var game;
(function (game) {
    var WebAudioSoundManager = Phaser.Sound.WebAudioSoundManager;
    var HTML5AudioSoundManager = Phaser.Sound.HTML5AudioSoundManager;
    var SoundManagerType;
    (function (SoundManagerType) {
        SoundManagerType["NO_AUDIO"] = "no_audio";
        SoundManagerType["HTML5_AUDIO"] = "html5_audio";
        SoundManagerType["WEB_AUDIO"] = "web_audio";
    })(SoundManagerType = game.SoundManagerType || (game.SoundManagerType = {}));
    var GameAudio = /** @class */ (function () {
        function GameAudio(scene) {
            this.scene = scene;
            this.sound = this.scene.sound;
            this.wasMuted = this.sound.mute;
            this.sound.pauseOnBlur = false;
            this.iOS = this.scene.game.device.os.iOS;
            this.onFocusThrottled = _.throttle(this.onFocus.bind(this), 100); // on iOS focus event fires twice sometimes
            this.startTrackingVisibility();
        }
        GameAudio.getAudioType = function (sound) {
            if (sound instanceof WebAudioSoundManager) {
                return SoundManagerType.WEB_AUDIO;
            }
            else if (sound instanceof HTML5AudioSoundManager) {
                return SoundManagerType.HTML5_AUDIO;
            }
            return SoundManagerType.NO_AUDIO;
        };
        GameAudio.prototype.startTrackingVisibility = function () {
            this.scene.game.events.on(Phaser.Core.Events.BLUR, this.onBlur, this);
            this.scene.game.events.on(Phaser.Core.Events.FOCUS, this.onFocusThrottled);
        };
        GameAudio.prototype.stopTrackingVisibility = function () {
            this.scene.game.events.off(Phaser.Core.Events.BLUR, this.onBlur, this);
            this.scene.game.events.off(Phaser.Core.Events.FOCUS, this.onFocusThrottled);
        };
        GameAudio.prototype.onBlur = function () {
            this.wasMuted = this.sound.mute;
            this.sound.mute = true;
        };
        GameAudio.prototype.onFocus = function () {
            this.sound.mute = this.wasMuted;
        };
        GameAudio.prototype.suspendAudioContext = function () {
            var _a;
            if (((_a = this.sound.context) === null || _a === void 0 ? void 0 : _a.state) === "running") {
                return this.sound.context.suspend();
            }
            return Promise.resolve();
        };
        GameAudio.prototype.resumeAudioContext = function () {
            var _a;
            if (((_a = this.sound.context) === null || _a === void 0 ? void 0 : _a.state) === "suspended") {
                return this.sound.context.resume();
            }
            return Promise.resolve();
        };
        GameAudio.prototype.listenToScenesChange = function (sceneTransition) {
            sceneTransition.on(game.SceneTransitionEvent.START, this.onSceneChangeStart, this);
        };
        GameAudio.prototype.onSceneChangeStart = function (transition, currentScene, newScene) {
            if (newScene === game.SceneKey.LEVELS_MAP) {
                this.switchToMainLoop();
                return;
            }
            if (newScene === game.SceneKey.GAMEPLAY_ROOT) {
                this.switchToGameplayLoop();
                return;
            }
        };
        GameAudio.prototype.switchToMainLoop = function () {
            this.stopLoop(this.gameplayLoop);
            this.playLoop(this.menuLoop, 0.5);
        };
        GameAudio.prototype.switchToGameplayLoop = function () {
            this.stopLoop(this.menuLoop);
            this.playLoop(this.gameplayLoop, 1);
        };
        GameAudio.prototype.loadMute = function () {
            this.sound.mute = this.scene.game.store.getBoolean(game.GameStoreKey.SOUND_MUTED);
        };
        GameAudio.prototype.addMenuLoop = function () {
            this.menuLoop = this.addLoop(game.GameSoundKey.MENU_LOOP);
        };
        GameAudio.prototype.addGameplayLoop = function () {
            this.gameplayLoop = this.addLoop(game.GameSoundKey.GAMEPLAY_LOOP);
        };
        GameAudio.prototype.onGameplayLoopLoaded = function () {
            this.addGameplayLoop();
            if (this.isGameplayActive()) {
                this.playLoop(this.gameplayLoop, 1);
            }
        };
        GameAudio.prototype.isGameplayActive = function () {
            return this.scene.game.scene.getScenes(true).some(function (scene) { return scene.scene.key === game.SceneKey.GAMEPLAY_ROOT; });
        };
        GameAudio.prototype.addLoop = function (key) {
            var isSoundAvailable = this.scene.cache.audio.has(key);
            if (isSoundAvailable === false) {
                return null;
            }
            return this.sound.add(key, { loop: true });
        };
        GameAudio.prototype.playLoop = function (loop, volume) {
            if (!loop || loop.isPlaying) {
                return;
            }
            loop.volume = 0;
            loop.play();
            this.scene.tweens.killTweensOf(loop);
            this.scene.tweens.add({
                targets: loop,
                duration: 1300,
                ease: Phaser.Math.Easing.Cubic.In,
                volume: volume,
            });
        };
        GameAudio.prototype.stopLoop = function (loop) {
            if (!loop) {
                return;
            }
            this.scene.tweens.killTweensOf(loop);
            this.scene.tweens.add({
                targets: loop,
                duration: 1000,
                ease: Phaser.Math.Easing.Cubic.Out,
                volume: 0,
                onComplete: function () {
                    loop.stop();
                },
            });
        };
        GameAudio.prototype.playClickSound = function (volume) {
            if (volume === void 0) { volume = 1; }
            if (this.scene.cache.audio.has(game.GameSoundKey.TAP)) {
                this.sound.play(game.GameSoundKey.TAP, { volume: volume });
            }
        };
        return GameAudio;
    }());
    game.GameAudio = GameAudio;
})(game || (game = {}));
var game;
(function (game) {
    var Toast = /** @class */ (function (_super) {
        __extends(Toast, _super);
        function Toast(scene, options) {
            var _this = _super.call(this, scene) || this;
            _this.name = "toast";
            _this.options = options;
            _this.addBack();
            _this.addText(options.message);
            _this.setInteractive(new Phaser.Geom.Rectangle(-_this.back.width / 2, -_this.back.height / 2, _this.back.width, _this.back.height), Phaser.Geom.Rectangle.Contains);
            _this.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, _this.dismiss, _this);
            _this.input.cursor = "pointer";
            return _this;
        }
        Toast.prototype.addBack = function () {
            this.back = this.scene.add.graphics({
                fillStyle: {
                    color: 0xE3E3E3,
                    alpha: 1,
                },
                lineStyle: {
                    width: 0,
                },
            });
            var width = game.Config.SOURCE_GAME_WIDTH * 0.7;
            var height = 100;
            this.back.fillRoundedRect(-width / 2, -height / 2, width, height, { tl: 20, bl: 0, br: 0, tr: 20 });
            this.back.width = width;
            this.back.height = height;
            this.add(this.back);
        };
        Toast.prototype.addText = function (textContent) {
            var style = {
                fontFamily: game.GameFont.SOUSES,
                fontStyle: game.FontWeight.BOLD,
                fontSize: "30px",
                color: "#205466",
                align: "center",
            };
            this.text = this.scene.add.text(0, 0, textContent, style);
            this.text.setOrigin(0.5, 0.5);
            this.text.setLineSpacing(-4);
            this.text.setWordWrapWidth(this.back.width * 0.9);
            this.add(this.text);
            this.adjustTextSize();
        };
        Toast.prototype.adjustTextSize = function () {
            var maxHeight = this.back.height * 0.8;
            this.text.scale = Math.min(1, maxHeight / this.text.height);
        };
        Toast.prototype.show = function (lifespan) {
            var deltaY = 20;
            this.alpha = 0;
            this.y += deltaY;
            this.scene.tweens.add({
                targets: this,
                duration: 150,
                ease: Phaser.Math.Easing.Cubic.Out,
                alpha: 1,
                y: this.y - deltaY,
                onComplete: this.onShowCompelete.bind(this, lifespan),
            });
        };
        Toast.prototype.onShowCompelete = function (lifespan) {
            var _this = this;
            this.dismissTimerEvent = this.scene.time.delayedCall(lifespan, function () {
                _this.dismiss();
            });
        };
        Toast.prototype.dismiss = function () {
            if (this.dismissTimerEvent) {
                this.dismissTimerEvent.remove();
            }
            this.scene.tweens.add({
                targets: this,
                duration: 150,
                ease: Phaser.Math.Easing.Linear.Linear,
                alpha: 0,
                y: "+=15",
                onComplete: this.destroy.bind(this),
            });
        };
        Toast.prototype.getWidth = function () {
            return this.back.width;
        };
        Toast.prototype.getHeight = function () {
            return this.back.height;
        };
        Toast.prototype.preDestroy = function () {
            if (this.dismissTimerEvent) {
                this.dismissTimerEvent.remove();
            }
            this.scene.tweens.killTweensOf(this);
        };
        return Toast;
    }(Phaser.GameObjects.Container));
    game.Toast = Toast;
})(game || (game = {}));
///<reference path='Toast.ts' />
var game;
(function (game) {
    var ToastsManager = /** @class */ (function (_super) {
        __extends(ToastsManager, _super);
        function ToastsManager(scene) {
            var _this = _super.call(this, scene) || this;
            _this.name = "toasts_container";
            _this.toasts = [];
            _this.setSize(game.Config.SOURCE_GAME_WIDTH, game.Config.SOURCE_GAME_HEIGHT);
            return _this;
        }
        ToastsManager.prototype.onToastDestroy = function (toast) {
            var index = this.toasts.indexOf(toast);
            if (index > -1) {
                this.toasts.splice(index, 1);
            }
        };
        ToastsManager.prototype.dismissAll = function () {
            this.toasts.forEach(function (toast) { return toast.dismiss(); });
        };
        ToastsManager.prototype.getGameHeight = function () {
            return game.Config.GAME_HEIGHT / this.scale;
        };
        ToastsManager.prototype.resize = function () {
        };
        ToastsManager.prototype.show = function (options) {
            this.dismissAll();
            var margin = 0;
            var toast = new game.Toast(this.scene, options);
            // toast.x = this.width / 2 - toast.getWidth() / 2 - margin
            toast.y = this.getGameHeight() / 2 - toast.getHeight() / 2 - margin;
            toast.once(Phaser.GameObjects.Events.DESTROY, this.onToastDestroy, this);
            toast.show(options.lifespan);
            this.toasts.push(toast);
            this.add(toast);
        };
        ToastsManager.prototype.showNoRewardedAdsWarning = function () {
            this.show({
                message: this.scene.texts.ads.adblock_video_ads,
                lifespan: 2500,
            });
        };
        ToastsManager.prototype.showRewardedAdsDontSkipWarning = function () {
            this.show({
                message: this.scene.texts.ads.dont_skip,
                lifespan: 2500,
            });
        };
        return ToastsManager;
    }(Phaser.GameObjects.Container));
    game.ToastsManager = ToastsManager;
})(game || (game = {}));
var Phaser;
(function (Phaser) {
    var GameObjects;
    (function (GameObjects) {
        var Screen = /** @class */ (function (_super) {
            __extends(Screen, _super);
            function Screen(scene, options) {
                var _this = _super.call(this, scene) || this;
                _this.name = "screen";
                _this.options = __assign({ backgroundAlpha: 0.8 }, options);
                _this.addBackground();
                return _this;
            }
            Screen.prototype.addBackground = function () {
                this.background = this.scene.add.image(0, 0, this.options.backgroundKey, this.options.backgroundFrame);
                this.background.alpha = this.options.backgroundAlpha;
                this.background.displayWidth = game.Config.SOURCE_GAME_WIDTH;
                this.background.displayHeight = game.Config.SOURCE_GAME_HEIGHT;
                this.add(this.background);
            };
            Screen.prototype.resize = function (gameplay) {
            };
            return Screen;
        }(Phaser.GameObjects.Container));
        GameObjects.Screen = Screen;
    })(GameObjects = Phaser.GameObjects || (Phaser.GameObjects = {}));
})(Phaser || (Phaser = {}));
var Phaser;
(function (Phaser) {
    var GameObjects;
    (function (GameObjects) {
        var ButtonEvent;
        (function (ButtonEvent) {
            ButtonEvent["PRESS"] = "button_press";
            ButtonEvent["RELEASE"] = "button_release";
        })(ButtonEvent = GameObjects.ButtonEvent || (GameObjects.ButtonEvent = {}));
        var Button = /** @class */ (function (_super) {
            __extends(Button, _super);
            function Button(scene, texture, frame, parent) {
                var _this = _super.call(this, scene, 0, 0, texture, frame) || this;
                _this._enabled = true;
                _this.originalScale = 1;
                _this.areTweensEnabled = true;
                _this.checkIfOver = true;
                _this.soundKey = "tap";
                _this.soundVolume = 1;
                if (parent) {
                    parent.add(_this);
                }
                else {
                    _this.scene.add.existing(_this);
                }
                _this.setInteractive();
                _this.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, _this.onPointerDown, _this);
                _this.scene.input.on(Phaser.Input.Events.POINTER_UP, _this.onScenePointerUp, _this);
                _this.input.cursor = "pointer";
                return _this;
            }
            Object.defineProperty(Button.prototype, "enabled", {
                get: function () {
                    return this._enabled;
                },
                set: function (value) {
                    this._enabled = value;
                    this._enabled ? this.setInteractive() : this.disableInteractive();
                },
                enumerable: false,
                configurable: true
            });
            Button.prototype.onPointerDown = function (pointer) {
                if (this.scene.cache.audio.has(this.soundKey)) {
                    this.scene.sound.play(this.soundKey);
                }
                this.playPressedTween();
                this.playSound();
                this.emit(ButtonEvent.PRESS, this, pointer);
                this.currentPointer = pointer;
            };
            Button.prototype.playPressedTween = function () {
                if (!this.areTweensEnabled) {
                    return;
                }
                this.originalScale = this.scale;
                this.scene.tweens.add({
                    targets: this,
                    scale: this.scale * 0.9,
                    ease: Phaser.Math.Easing.Cubic.Out,
                    duration: 50,
                });
            };
            Button.prototype.playSound = function () {
                if (this.scene.cache.audio.has(this.soundKey)) {
                    this.scene.sound.play(this.soundKey, { volume: this.soundVolume });
                }
            };
            Button.prototype.onScenePointerUp = function (pointer, objects) {
                if (this.currentPointer && this.currentPointer === pointer) {
                    this.currentPointer = null;
                    var isPointerOverButton = objects.includes(this);
                    if (this.checkIfOver === false || isPointerOverButton) {
                        this.onPointerUp();
                        this.emit(ButtonEvent.RELEASE, this, pointer);
                    }
                    this.playReleasedTween();
                }
            };
            Button.prototype.playReleasedTween = function () {
                // button could be destroyed during up callback so we have to check for this.scene
                if (!this.scene) {
                    return;
                }
                if (!this.areTweensEnabled) {
                    return;
                }
                this.scene.tweens.add({
                    targets: this,
                    scale: this.originalScale,
                    ease: Phaser.Math.Easing.Back.Out,
                    duration: 300,
                });
            };
            Button.prototype.onPointerUp = function () {
            };
            Button.prototype.destroy = function (fromScene) {
                if (this.scene) {
                    this.scene.input.off(Phaser.Input.Events.POINTER_UP, this.onScenePointerUp, this);
                }
                _super.prototype.destroy.call(this, fromScene);
            };
            return Button;
        }(Phaser.GameObjects.Image));
        GameObjects.Button = Button;
    })(GameObjects = Phaser.GameObjects || (Phaser.GameObjects = {}));
})(Phaser || (Phaser = {}));
var Phaser;
(function (Phaser) {
    var GameObjects;
    (function (GameObjects) {
        var ToggleButtonState;
        (function (ToggleButtonState) {
            ToggleButtonState[ToggleButtonState["STATE_1"] = 0] = "STATE_1";
            ToggleButtonState[ToggleButtonState["STATE_2"] = 1] = "STATE_2";
        })(ToggleButtonState = GameObjects.ToggleButtonState || (GameObjects.ToggleButtonState = {}));
        var ToggleButton = /** @class */ (function (_super) {
            __extends(ToggleButton, _super);
            function ToggleButton(scene, texture, frame_1, frame_2, parent) {
                var _this = _super.call(this, scene, texture, frame_1, parent) || this;
                _this.frame_1 = frame_1;
                _this.frame_2 = frame_2;
                _this._buttonState = ToggleButtonState.STATE_1;
                return _this;
            }
            ToggleButton.prototype.onPointerUp = function () {
                _super.prototype.onPointerUp.call(this);
                this.switchTextures();
            };
            ToggleButton.prototype.switchTextures = function () {
                this.buttonState = this._buttonState === ToggleButtonState.STATE_1 ? ToggleButtonState.STATE_2 : ToggleButtonState.STATE_1;
            };
            Object.defineProperty(ToggleButton.prototype, "buttonState", {
                get: function () {
                    return this._buttonState;
                },
                set: function (value) {
                    this._buttonState = value;
                    this._buttonState === ToggleButtonState.STATE_1
                        ? this.setFrame(this.frame_1)
                        : this.setFrame(this.frame_2);
                },
                enumerable: false,
                configurable: true
            });
            return ToggleButton;
        }(Phaser.GameObjects.Button));
        GameObjects.ToggleButton = ToggleButton;
    })(GameObjects = Phaser.GameObjects || (Phaser.GameObjects = {}));
})(Phaser || (Phaser = {}));
var Phaser;
(function (Phaser) {
    var GameObjects;
    (function (GameObjects) {
        var GameStoreKey = game.GameStoreKey;
        var SoundButton = /** @class */ (function (_super) {
            __extends(SoundButton, _super);
            function SoundButton(scene, texture, frame_1, frame_2, parent) {
                var _this = _super.call(this, scene, texture, frame_1, parent) || this;
                _this.frame_1 = frame_1;
                _this.frame_2 = frame_2;
                _this.store = _this.scene.game.store;
                _this.soundManager = _this.scene.sound;
                _this.soundManager.on(Phaser.Sound.Events.GLOBAL_MUTE, _this.onMuteChange, _this);
                _this.updateFrame(_this.soundManager.mute);
                return _this;
            }
            SoundButton.prototype.onMuteChange = function (sound, mute) {
                this.updateFrame(mute);
            };
            SoundButton.prototype.updateFrame = function (mute) {
                this.setFrame(mute ? this.frame_2 : this.frame_1);
            };
            SoundButton.prototype.onPointerUp = function () {
                _super.prototype.onPointerUp.call(this);
                this.soundManager.mute = !this.soundManager.mute;
                this.store.saveValue(GameStoreKey.SOUND_MUTED, !this.soundManager.mute);
            };
            SoundButton.prototype.destroy = function (fromScene) {
                this.soundManager.off(Phaser.Sound.Events.GLOBAL_MUTE, this.onMuteChange, this);
                _super.prototype.destroy.call(this, fromScene);
            };
            return SoundButton;
        }(Phaser.GameObjects.Button));
        GameObjects.SoundButton = SoundButton;
    })(GameObjects = Phaser.GameObjects || (Phaser.GameObjects = {}));
})(Phaser || (Phaser = {}));
var Phaser;
(function (Phaser) {
    var GameObjects;
    (function (GameObjects) {
        var ComplexButton = /** @class */ (function (_super) {
            __extends(ComplexButton, _super);
            function ComplexButton(scene, atlas, frame) {
                var _this = _super.call(this, scene) || this;
                _this.soundKey = "tap";
                _this.tweensEnabled = true;
                _this.checkIfOver = true;
                _this.name = "button";
                _this.addBack(atlas, frame);
                return _this;
            }
            ComplexButton.prototype.enableInput = function () {
                this.back.setInteractive();
            };
            ComplexButton.prototype.disableInput = function () {
                this.back.disableInteractive();
            };
            ComplexButton.prototype.addBack = function (atlas, frame) {
                this.back = this.scene.add.image(0, 0, atlas, frame);
                this.back.setInteractive();
                this.back.input.cursor = "pointer";
                this.back.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.onPointerDown, this);
                this.scene.input.on(Phaser.Input.Events.POINTER_UP, this.onScenePointerUp, this);
                this.add(this.back);
            };
            ComplexButton.prototype.onPointerDown = function (pointer) {
                if (this.scene.cache.audio.has(this.soundKey)) {
                    this.scene.sound.play(this.soundKey);
                }
                if (this.tweensEnabled) {
                    this.scene.tweens.add({
                        targets: this,
                        scale: 0.9,
                        ease: Phaser.Math.Easing.Cubic.Out,
                        duration: 50,
                    });
                }
                this.emit(GameObjects.ButtonEvent.PRESS, this, pointer);
                this.currentPointer = pointer;
            };
            ComplexButton.prototype.onScenePointerUp = function (pointer, objects) {
                if (this.currentPointer && this.currentPointer === pointer) {
                    this.currentPointer = null;
                    var isPointerOverButton = objects.includes(this.back);
                    if (this.checkIfOver === false || isPointerOverButton) {
                        this.onPointerUp();
                        this.emit(Phaser.GameObjects.ButtonEvent.RELEASE, this, pointer);
                    }
                    if (this.tweensEnabled && this.scene) {
                        this.scene.tweens.add({
                            targets: this,
                            scale: 1,
                            ease: Phaser.Math.Easing.Back.Out,
                            duration: 300,
                        });
                    }
                }
            };
            ComplexButton.prototype.onPointerUp = function () {
            };
            ComplexButton.prototype.addBitmapText = function (content, font, fontSize, offsetX, offsetY) {
                if (offsetX === void 0) { offsetX = 0; }
                if (offsetY === void 0) { offsetY = 0; }
                this.bitmapText = this.scene.add.bitmapText(0, 0, font, content, fontSize);
                this.bitmapText.align = Phaser.Display.Align.CENTER;
                this.bitmapText.setOrigin(0.5, 0.5);
                this.bitmapText.x = this.back.x + offsetX;
                this.bitmapText.y = this.back.y + offsetY;
                this.add(this.bitmapText);
                return this.bitmapText;
            };
            ComplexButton.prototype.addText = function (content, style, offsetX, offsetY) {
                if (offsetX === void 0) { offsetX = 0; }
                if (offsetY === void 0) { offsetY = 0; }
                this.text = this.scene.make.text({
                    text: content,
                    style: style,
                });
                this.text.setOrigin(0.5, 0.5);
                this.text.x = this.back.x + offsetX;
                this.text.y = this.back.y + offsetY;
                this.add(this.text);
                return this.text;
            };
            return ComplexButton;
        }(Phaser.GameObjects.Container));
        GameObjects.ComplexButton = ComplexButton;
    })(GameObjects = Phaser.GameObjects || (Phaser.GameObjects = {}));
})(Phaser || (Phaser = {}));
var game;
(function (game) {
    var KineticScroll = /** @class */ (function () {
        function KineticScroll(scene, settings) {
            this.thresholdOfTapTime = 100;
            this.thresholdOfTapDistance = 10;
            this.moveTimestamp = 0;
            this.scene = scene;
            var defaultSettings = {
                camera: this.scene.cameras.main,
                kineticMovement: true,
                timeConstantScroll: 325,
                horizontalScroll: true,
                verticalScroll: true,
                horizontalWheel: false,
                verticalWheel: false,
                wheelDeceleration: 0.95,
                onUpdate: null,
                scrollMultiplier: 1,
            };
            this.settings = __assign(__assign({}, defaultSettings), settings);
            this.tempCameraBounds = new Phaser.Geom.Rectangle();
        }
        KineticScroll.prototype.addPointerListeners = function () {
            this.scene.input.on("pointerdown", this.beginMove, this);
            this.scene.input.on("pointerup", this.endMove, this);
            this.scene.input.on("pointermove", this.move, this);
        };
        KineticScroll.prototype.removePointerListeners = function () {
            this.scene.input.off("pointerdown", this.beginMove, this);
            this.scene.input.off("pointerup", this.endMove, this);
            this.scene.input.off("pointermove", this.move, this);
        };
        KineticScroll.prototype.beginMove = function (pointer) {
            this.pointerId = pointer.id;
            this.startX = this.scene.input.x;
            this.startY = this.scene.input.y;
            this.screenX = pointer.screenX;
            this.screenY = pointer.screenY;
            this.pressedDown = true;
            // the time of press down
            this.timestamp = this.getNow();
            this.beginTime = this.timestamp;
            this.velocityY = this.amplitudeY = this.velocityX = this.amplitudeX = 0;
        };
        KineticScroll.prototype.canCameraMoveY = function () {
            var camera = this.settings.camera;
            camera.getBounds(this.tempCameraBounds);
            return camera.scrollY > 0 && camera.scrollY + camera.height < this.tempCameraBounds.height;
        };
        KineticScroll.prototype.canCameraMoveX = function () {
            var camera = this.settings.camera;
            camera.getBounds(this.tempCameraBounds);
            return camera.scrollX > 0 && camera.scrollX + camera.width < this.tempCameraBounds.right;
        };
        KineticScroll.prototype.move = function (pointer) {
            var x = pointer.x;
            var y = pointer.y;
            if (!this.pressedDown) {
                return;
            }
            if (this.pointerId !== pointer.id) {
                return;
            }
            this.now = this.getNow();
            var elapsed = this.now - this.timestamp;
            this.timestamp = this.now;
            var deltaX = 0;
            var deltaY = 0;
            if (this.isTap(pointer)) {
                return;
            }
            var cam = this.settings.camera;
            if (this.settings.horizontalScroll) {
                deltaX = x - this.startX;
                if (deltaX !== 0) {
                    this.dragging = true;
                }
                this.startX = x;
                this.velocityX = 0.8 * ((1000 * deltaX) / (1 + elapsed)) + 0.2 * this.velocityX;
                cam.setScroll(cam.scrollX - deltaX, cam.scrollY);
            }
            if (this.settings.verticalScroll) {
                deltaY = (y - this.startY) * this.settings.scrollMultiplier;
                if (deltaY !== 0) {
                    this.dragging = true;
                }
                this.startY = y;
                this.velocityY = 0.8 * ((1000 * deltaY) / (1 + elapsed)) + 0.2 * this.velocityY;
                cam.setScroll(cam.scrollX, cam.scrollY - deltaY);
            }
            this.callCustomUpdate(deltaX, deltaY);
            this.moveTimestamp = this.getNow();
        };
        KineticScroll.prototype.callCustomUpdate = function (deltaX, deltaY) {
            if (typeof this.settings.onUpdate !== "function") {
                return;
            }
            var updateX = this.canCameraMoveX() ? deltaX : 0;
            var updateY = this.canCameraMoveY() ? deltaY : 0;
            this.settings.onUpdate(updateX, updateY);
        };
        KineticScroll.prototype.isTap = function (pointer) {
            return (this.now - this.beginTime < this.thresholdOfTapTime &&
                Math.abs(pointer.screenY - this.screenY) < this.thresholdOfTapDistance &&
                Math.abs(pointer.screenX - this.screenX) < this.thresholdOfTapDistance);
        };
        KineticScroll.prototype.endMove = function () {
            this.pointerId = null;
            this.pressedDown = false;
            this.autoScrollX = false;
            this.autoScrollY = false;
            if (!this.settings.kineticMovement) {
                return;
            }
            this.now = this.getNow();
            var cam = this.settings.camera;
            if (this.withinGame()) {
                if (this.velocityX > 10 || this.velocityX < -10) {
                    this.amplitudeX = 0.8 * this.velocityX;
                    this.targetX = Math.round(cam.scrollX - this.amplitudeX);
                    this.autoScrollX = true;
                }
                if (this.velocityY > 10 || this.velocityY < -10) {
                    this.amplitudeY = 0.8 * this.velocityY;
                    this.targetY = Math.round(cam.scrollY - this.amplitudeY);
                    this.autoScrollY = true;
                }
            }
            if (!this.withinGame()) {
                this.velocityWheelXAbs = Math.abs(this.velocityWheelX);
                this.velocityWheelYAbs = Math.abs(this.velocityWheelY);
                if (this.settings.horizontalScroll && (this.velocityWheelXAbs < 0.1 || !this.withinGame())) {
                    this.autoScrollX = true;
                }
                if (this.settings.verticalScroll && (this.velocityWheelYAbs < 0.1 || !this.withinGame())) {
                    this.autoScrollY = true;
                }
            }
        };
        KineticScroll.prototype.update = function () {
            var timeSinceMove = this.getNow() - this.moveTimestamp;
            if (timeSinceMove > 20) {
                this.velocityX = 0;
                this.velocityY = 0;
            }
            this.elapsed = this.getNow() - this.timestamp;
            this.velocityWheelXAbs = Math.abs(this.velocityWheelX);
            this.velocityWheelYAbs = Math.abs(this.velocityWheelY);
            var delta = 0;
            var cam = this.settings.camera;
            if (this.autoScrollX && this.amplitudeX !== 0) {
                delta = -this.amplitudeX * Math.exp(-this.elapsed / this.settings.timeConstantScroll);
                if (this.canCameraMoveX() && (delta > 0.5 || delta < -0.5)) {
                    cam.setScroll(this.targetX - delta, cam.scrollY);
                }
                else {
                    this.autoScrollX = false;
                    cam.setScroll(this.targetX, cam.scrollY);
                }
            }
            if (this.autoScrollY && this.amplitudeY !== 0) {
                delta = -this.amplitudeY * Math.exp(-this.elapsed / this.settings.timeConstantScroll);
                if (this.canCameraMoveY() && (delta > 0.5 || delta < -0.5)) {
                    cam.setScroll(cam.scrollX, this.targetY - delta);
                }
                else {
                    this.autoScrollY = false;
                    cam.setScroll(cam.scrollX, this.targetY);
                }
            }
            if (!this.autoScrollX && !this.autoScrollY) {
                this.dragging = false;
            }
            if (this.settings.horizontalWheel && this.velocityWheelXAbs > 0.1) {
                this.dragging = true;
                this.amplitudeX = 0;
                this.autoScrollX = false;
                cam.setScroll(cam.scrollX - this.velocityWheelX, cam.scrollY);
                this.velocityWheelX *= this.settings.wheelDeceleration;
            }
            if (this.settings.verticalWheel && this.velocityWheelYAbs > 0.1) {
                this.dragging = true;
                this.autoScrollY = false;
                cam.setScroll(cam.scrollX, cam.scrollY - this.velocityWheelY);
                this.velocityWheelY *= this.settings.wheelDeceleration;
            }
        };
        KineticScroll.prototype.getNow = function () {
            if (performance && performance.now) {
                return performance.now();
            }
            return Date.now();
        };
        KineticScroll.prototype.withinGame = function () {
            return true;
        };
        KineticScroll.prototype.resetScroll = function () {
            this.autoScrollX = false;
            this.autoScrollY = false;
            this.velocityWheelX = 0;
            this.velocityWheelY = 0;
        };
        return KineticScroll;
    }());
    game.KineticScroll = KineticScroll;
})(game || (game = {}));
var utils;
(function (utils) {
    var ParticleUtil = /** @class */ (function () {
        function ParticleUtil() {
        }
        ParticleUtil.getTextureEmitZone = function (scene, image) {
            var origin = image.getTopLeft();
            var getRandomPoint = function (vec) {
                do {
                    var x = Phaser.Math.Between(0, image.width);
                    var y = Phaser.Math.Between(0, image.height);
                    var pixel = scene.textures.getPixel(x, y, image.texture.key);
                } while (pixel.alpha < 255);
                return vec.setTo(x + origin.x, y + origin.y);
            };
            return {
                getRandomPoint: getRandomPoint,
            };
        };
        ParticleUtil.getCircleEdgeEmitZone = function (radius, quantity, randomize) {
            if (quantity === void 0) { quantity = 360; }
            if (randomize === void 0) { randomize = true; }
            var circle = new Phaser.Geom.Circle(0, 0, radius);
            var emitZone = { source: circle, type: "edge", quantity: quantity };
            var getRotation = function (particle) {
                var emitter = particle.emitter;
                var emitterX = emitter.follow ? emitter.follow.x : emitter.x.propertyValue;
                var emitterY = emitter.follow ? emitter.follow.y : emitter.y.propertyValue;
                return Math.atan2(particle.y - emitterY, particle.x - emitterX);
            };
            var randomizeProperties = randomize
                ? {
                    emitCallback: function (particle, emitter) {
                        var emitZone = emitter.emitZone;
                        emitZone.counter = Phaser.Math.RND.between(0, emitZone.points.length);
                    },
                }
                : {};
            return __assign(__assign({}, randomizeProperties), { emitZone: emitZone, angle: {
                    onEmit: function (particle) {
                        return getRotation(particle) * Phaser.Math.RAD_TO_DEG;
                    },
                }, rotate: {
                    onEmit: function (particle) {
                        return (getRotation(particle) + Math.PI / 2) * Phaser.Math.RAD_TO_DEG;
                    },
                } });
        };
        return ParticleUtil;
    }());
    utils.ParticleUtil = ParticleUtil;
})(utils || (utils = {}));
var utils;
(function (utils) {
    var AnimationsPool = /** @class */ (function () {
        function AnimationsPool(scene, options) {
            this.counter = 0;
            this.scene = scene;
            this.options = options;
            this.pool = this.createAnimations(this.options.initialNum);
        }
        AnimationsPool.prototype.createAnimations = function (num) {
            var _this = this;
            var filterBooleans = function (value) {
                return typeof value !== "boolean";
            };
            return Array(num)
                .fill(0)
                .map(function () { return _this.createAnimation(); })
                .filter(filterBooleans)
                .map(function (animation) {
                animation.active = false;
                return animation;
            });
        };
        AnimationsPool.prototype.createAnimation = function () {
            this.counter++;
            return this.scene.anims.create(__assign(__assign({}, this.options.animationConfig), { key: this.options.prefix + "_" + this.counter.toString(), frames: this.scene.anims.getFrameNames(this.options.atlas, this.options.prefix) }));
        };
        AnimationsPool.prototype.getInactive = function () {
            var anim = this.pool.find(function (item) { return item.active === false; });
            if (!anim) {
                anim = this.createAnimation();
                this.pool.push(anim);
                console.warn("Enlarge " + this.options.name + " animations pool! New size is " + this.pool.length + ".");
            }
            anim.active = true;
            return anim;
        };
        AnimationsPool.prototype.recycleActive = function (anim) {
            anim.active = false;
        };
        AnimationsPool.prototype.recycleAll = function () {
            this.pool.forEach(function (anim) { return (anim.active = false); });
        };
        AnimationsPool.prototype.getState = function () {
            var activeNum = this.pool.filter(function (item) { return item.active; }).length;
            var inactiveNum = this.pool.length - activeNum;
            var itemsStr = this.pool
                .map(function (item) {
                return item.key + ": " + item.active.toString();
            })
                .join("\n");
            return "\n\t\t\tActive: " + activeNum + "\n\t\t\tInactive: " + inactiveNum + "\n\t\t\tTotal: " + this.pool.length + "\n\t\t\t=============================\n\t\t\t" + itemsStr + "\n\t\t\t";
        };
        AnimationsPool.prototype.destroy = function () {
            this.pool.forEach(function (item) { return item.destroy(); });
            this.pool = null;
        };
        return AnimationsPool;
    }());
    utils.AnimationsPool = AnimationsPool;
})(utils || (utils = {}));
var utils;
(function (utils) {
    var NetUtil = /** @class */ (function () {
        function NetUtil() {
        }
        NetUtil.getCurrentHost = function () {
            if (location && location.hostname) {
                return location.hostname;
            }
            return null;
        };
        NetUtil.isLocalhost = function () {
            var localhostAliases = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                localhostAliases[_i] = arguments[_i];
            }
            return NetUtil.isHostAllowed(__spreadArrays(localhostAliases, ["localhost"]));
        };
        NetUtil.isHostAllowed = function (allowedHosts) {
            var currentHost = NetUtil.getCurrentHost();
            if (currentHost) {
                return allowedHosts.some(function (host) {
                    return currentHost.includes(host);
                });
            }
            return false;
        };
        NetUtil.inIFrame = function () {
            try {
                return window.self !== window.top;
            }
            catch (e) {
                return true;
            }
        };
        NetUtil.getParam = function (name) {
            var normalizedName = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
            var regex = new RegExp("[\\?&]" + normalizedName + "=([^&#]*)");
            var results = regex.exec(location.search);
            return results === null ? null : decodeURIComponent(results[1].replace(/\+/g, " "));
        };
        NetUtil.getParamInt = function (name, _default) {
            if (_default === void 0) { _default = 0; }
            var value = this.getParam(name);
            if (value) {
                var num = parseInt(value);
                return isNaN(num) ? _default : num;
            }
            return _default;
        };
        NetUtil.getParamFloat = function (name, _default) {
            if (_default === void 0) { _default = 0; }
            var value = this.getParam(name);
            if (value) {
                var num = parseFloat(value);
                return isNaN(num) ? _default : num;
            }
            return _default;
        };
        NetUtil.getParamBool = function (name, expectedValue) {
            if (expectedValue === void 0) { expectedValue = "1"; }
            var value = NetUtil.getParam(name);
            return !!(value && value === expectedValue);
        };
        return NetUtil;
    }());
    utils.NetUtil = NetUtil;
})(utils || (utils = {}));
var utils;
(function (utils) {
    var Polyfills = /** @class */ (function () {
        function Polyfills() {
        }
        Polyfills.polyfill = function () {
            var extendMethods = Object.keys(Polyfills);
            extendMethods.forEach(function (methodName) {
                if (methodName === "polyfill") {
                    return;
                }
                if (methodName.startsWith("_")) {
                    return;
                }
                Polyfills[methodName]();
            });
        };
        Polyfills.nodeRemove = function () {
            var arr = [Element, CharacterData, DocumentType];
            var args = [];
            arr.forEach(function (item) {
                if (item) {
                    args.push(item.prototype);
                }
            });
            // from:https://github.com/jserz/js_piece/blob/master/DOM/ChildNode/remove()/remove().md
            (function (arr) {
                arr.forEach(function (item) {
                    if (item.hasOwnProperty("remove")) {
                        return;
                    }
                    Object.defineProperty(item, "remove", {
                        configurable: true,
                        enumerable: true,
                        writable: true,
                        value: function remove() {
                            this.parentNode.removeChild(this);
                        },
                    });
                });
            })(args);
        };
        return Polyfills;
    }());
    utils.Polyfills = Polyfills;
})(utils || (utils = {}));
var utils;
(function (utils) {
    var Phaser3Extensions = /** @class */ (function () {
        function Phaser3Extensions() {
        }
        Phaser3Extensions.extend = function () {
            var extendMethods = Object.keys(Phaser3Extensions);
            extendMethods.forEach(function (method) {
                if (method !== "extend") {
                    Phaser3Extensions[method]();
                }
            });
        };
        Phaser3Extensions.addGetGlobalPosition = function () {
            var getWorldPosition = function (out) {
                var worldMatrix = this.getWorldTransformMatrix();
                out = out !== null && out !== void 0 ? out : { x: 0, y: 0 };
                out.x = worldMatrix.tx;
                out.y = worldMatrix.ty;
                return out;
            };
            // noinspection JSUnusedLocalSymbols
            var classes = [
                Phaser.GameObjects.Container,
                Phaser.GameObjects.Image,
                Phaser.GameObjects.Sprite,
                Phaser.GameObjects.Graphics,
                Phaser.GameObjects.Shape,
            ].forEach(function (clazz) {
                clazz.prototype.getWorldPosition = getWorldPosition;
            });
        };
        Phaser3Extensions.addKillRevive = function () {
            var kill = function () {
                this.visible = false;
                this.active = false;
            };
            var revive = function () {
                this.visible = true;
                this.active = true;
            };
            // noinspection JSUnusedLocalSymbols
            var classes = [
                Phaser.GameObjects.Container,
                Phaser.GameObjects.Image,
                Phaser.GameObjects.Sprite,
                Phaser.GameObjects.Graphics,
                Phaser.GameObjects.Shape,
                Phaser.GameObjects.Text,
                Phaser.GameObjects.BitmapText,
                Phaser.GameObjects.TileSprite,
            ].forEach(function (clazz) {
                clazz.prototype.kill = kill;
                clazz.prototype.revive = revive;
            });
        };
        Phaser3Extensions.extendContainer = function () {
            Phaser.GameObjects.Container.prototype.gridAlign = function (options, startIndex, endIndex) {
                if (typeof startIndex === "undefined") {
                    startIndex = 0;
                }
                if (typeof endIndex === "undefined") {
                    endIndex = this.length;
                }
                var items = this.list.slice(startIndex, endIndex);
                Phaser.Actions.GridAlign(items, options);
                return this;
            };
        };
        Phaser3Extensions.extendAnimationManager = function () {
            var sortByFrameNumbers = function (frame_1, frame_2) {
                var index_1 = getFrameNumber(frame_1);
                var index_2 = getFrameNumber(frame_2);
                return index_1 - index_2;
            };
            var getFrameNumber = function (frameName, zeroPad) {
                if (zeroPad === void 0) { zeroPad = 4; }
                return parseInt(frameName.slice(-zeroPad));
            };
            Phaser.Animations.AnimationManager.prototype.getFrameNames = function (atlasKey, prefix) {
                var allFrames = this.game.textures.get(atlasKey).getFrameNames();
                var animationFrameNames = allFrames.filter(function (frameName) { return frameName.includes(prefix); }).sort(sortByFrameNumbers);
                return animationFrameNames.map(function (frameName) {
                    return {
                        key: atlasKey,
                        frame: frameName,
                    };
                });
            };
        };
        Phaser3Extensions.extendMath = function () {
            Phaser.Math.Sign = function (value) {
                return value >= 0 ? 1 : -1;
            };
            Phaser.Math.MapLinear = function (x, a1, a2, b1, b2) {
                return b1 + ((x - a1) * (b2 - b1)) / (a2 - a1);
            };
        };
        Phaser3Extensions.extendRandomDataGenerator = function () {
            Phaser.Math.RandomDataGenerator.prototype.bool = function () {
                return this.frac() > 0.5;
            };
            Phaser.Math.RandomDataGenerator.prototype.pickExcept = function (array, exception, safetyCounter) {
                if (safetyCounter === void 0) { safetyCounter = 100; }
                var item;
                do {
                    item = this.pick(array);
                } while (exception === item && --safetyCounter > 0);
                return item;
            };
            Phaser.Math.RandomDataGenerator.prototype.pickExceptMultiple = function (array, exceptions, safetyCounter) {
                if (safetyCounter === void 0) { safetyCounter = 100; }
                var item;
                do {
                    item = this.pick(array);
                } while (exceptions.includes(item) && --safetyCounter > 0);
                return item;
            };
        };
        Phaser3Extensions.extendFactory = function () {
            var factory = Phaser.GameObjects.GameObjectFactory.prototype;
            factory.existingMultiple = function (children) {
                var _this = this;
                return children.map(function (child) { return _this.existing(child); });
            };
            factory.button = function (texture, frame, parent) {
                return new Phaser.GameObjects.Button(this.scene, texture, frame, parent);
            };
            factory.toggleButton = function (texture, frame_1, frame_2, parent) {
                return new Phaser.GameObjects.ToggleButton(this.scene, texture, frame_1, frame_2, parent);
            };
            factory.soundButton = function (texture, frame_1, frame_2, parent) {
                return new Phaser.GameObjects.SoundButton(this.scene, texture, frame_1, frame_2, parent);
            };
        };
        Phaser3Extensions.addScaleMethods = function () {
            var hasScale = function (object) {
                return typeof object.setScale !== "undefined";
            };
            Phaser.GameObjects.GameObject.prototype.fitWidth = function (width) {
                if (hasScale(this) === false) {
                    return;
                }
                this.setScale(1);
                this.setScale(width / this.width);
            };
            Phaser.GameObjects.GameObject.prototype.fitHeight = function (maxHeight) {
                if (hasScale(this) === false) {
                    return;
                }
                this.setScale(Math.min(1, maxHeight / this.height));
            };
            Phaser.GameObjects.GameObject.prototype.fitIn = function (maxWidth, maxHeight) {
                if (hasScale(this) === false) {
                    return;
                }
                var scaleX = maxWidth / this.width;
                var scaleY = maxHeight / this.height;
                this.scale = Math.min(1, scaleX, scaleY);
            };
            Phaser.GameObjects.GameObject.prototype.fillWidth = function (maxWidth) {
                if (hasScale(this) === false) {
                    return;
                }
                this.setScale(Math.max(1, maxWidth / this.width));
            };
            Phaser.GameObjects.GameObject.prototype.fillHeight = function (maxHeight) {
                if (hasScale(this) === false) {
                    return;
                }
                this.setScale(Math.max(1, maxHeight / this.height));
            };
            Phaser.GameObjects.GameObject.prototype.envelop = function (maxWidth, maxHeight) {
                if (hasScale(this) === false) {
                    return;
                }
                var scaleX = maxWidth / this.width;
                var scaleY = maxHeight / this.height;
                this.scale = Math.max(scaleX, scaleY);
            };
        };
        Phaser3Extensions.addAlighMethods = function () {
            Object.defineProperty(Phaser.GameObjects.GameObject.prototype, "top", {
                get: function () {
                    return Phaser.Display.Bounds.GetTop(this);
                },
                set: function (value) {
                    return Phaser.Display.Bounds.SetTop(this, value);
                },
            });
            Object.defineProperty(Phaser.GameObjects.GameObject.prototype, "right", {
                get: function () {
                    return Phaser.Display.Bounds.GetRight(this);
                },
                set: function (value) {
                    return Phaser.Display.Bounds.SetRight(this, value);
                },
            });
            Object.defineProperty(Phaser.GameObjects.GameObject.prototype, "bottom", {
                get: function () {
                    return Phaser.Display.Bounds.GetBottom(this);
                },
                set: function (value) {
                    return Phaser.Display.Bounds.SetBottom(this, value);
                },
            });
            Object.defineProperty(Phaser.GameObjects.GameObject.prototype, "left", {
                get: function () {
                    return Phaser.Display.Bounds.GetLeft(this);
                },
                set: function (value) {
                    return Phaser.Display.Bounds.SetLeft(this, value);
                },
            });
        };
        Phaser3Extensions.extendLoader = function () {
            Phaser.Loader.LoaderPlugin.prototype.bitmapFontFromAtlas = function (fontKey, atlasKey, atlasFrame, dataURL, xSpacing, ySpacing) {
                var _this = this;
                var xmlKey = fontKey + "_data";
                this.xml(xmlKey, dataURL);
                this.once(Phaser.Loader.Events.COMPLETE, function () {
                    var wasParsed = Phaser.GameObjects.BitmapText.ParseFromAtlas(_this.scene, fontKey, atlasKey, atlasFrame, xmlKey, xSpacing, ySpacing);
                    if (wasParsed === false) {
                        console.warn("Can't add bitmap font " + fontKey);
                    }
                });
                return this;
            };
        };
        return Phaser3Extensions;
    }());
    utils.Phaser3Extensions = Phaser3Extensions;
})(utils || (utils = {}));
var utils;
(function (utils) {
    var MatterExtensions = /** @class */ (function () {
        function MatterExtensions() {
        }
        MatterExtensions.extend = function () {
            var extendMethods = Object.keys(MatterExtensions);
            extendMethods.forEach(function (method) {
                if (method !== "extend") {
                    MatterExtensions[method]();
                }
            });
        };
        MatterExtensions.addIgnoreCollisionCategory = function () {
            var ignoreCollisionCategory = function (value) {
                this.body.collisionFilter.mask &= ~value;
                return this;
            };
            Phaser.Physics.Matter.Image.prototype.ignoreCollisionCategory = ignoreCollisionCategory;
            Phaser.Physics.Matter.Sprite.prototype.ignoreCollisionCategory = ignoreCollisionCategory;
        };
        MatterExtensions.addGetContactPoint = function () {
            Phaser.Physics.Matter.World.prototype.getContactPoint = function (pair, out) {
                var contact = pair.activeContacts[0];
                var x = contact.vertex.x - pair.collision.penetration.x;
                var y = contact.vertex.y - pair.collision.penetration.y;
                out = out !== null && out !== void 0 ? out : (out || { x: x, y: y });
                return out;
            };
        };
        return MatterExtensions;
    }());
    utils.MatterExtensions = MatterExtensions;
})(utils || (utils = {}));
var utils;
(function (utils) {
    var DeviceUtil = /** @class */ (function () {
        function DeviceUtil() {
        }
        DeviceUtil.webP = function () {
            var match = navigator.userAgent.match(/(Edge|Firefox)\/(\d+)\./);
            if (match) {
                return (match[1] === "Firefox" && +match[2] >= 65)
                    || (match[1] === "Edge" && +match[2] >= 18);
            }
            // Use canvas hack for webkit-based browsers
            // Kudos to Rui Marques: https://stackoverflow.com/a/27232658/7897049
            var e = document.createElement("canvas");
            return e.toDataURL
                ? e.toDataURL("image/webp").indexOf("data:image/webp") == 0
                : false;
        };
        DeviceUtil.getDeviceInfo = function () {
            var ua = navigator.userAgent;
            var OS = {
                android: false,
                chromeOS: false,
                cordova: false,
                crosswalk: false,
                desktop: false,
                ejecta: false,
                electron: false,
                iOS: false,
                iOSVersion: 0,
                iPad: false,
                iPhone: false,
                kindle: false,
                linux: false,
                macOS: false,
                node: false,
                nodeWebkit: false,
                pixelRatio: 1,
                webApp: false,
                windows: false,
                windowsPhone: false,
            };
            if (/Windows/.test(ua)) {
                OS.windows = true;
            }
            else if (/Mac OS/.test(ua) && !/like Mac OS/.test(ua)) {
                OS.macOS = true;
            }
            else if (/Android/.test(ua)) {
                OS.android = true;
            }
            else if (/Linux/.test(ua)) {
                OS.linux = true;
            }
            else if (/iP[ao]d|iPhone/i.test(ua)) {
                OS.iOS = true;
                navigator.appVersion.match(/OS (\d+)/);
                OS.iOSVersion = parseInt(RegExp.$1, 10);
                OS.iPhone = ua.toLowerCase().indexOf("iphone") !== -1;
                OS.iPad = ua.toLowerCase().indexOf("ipad") !== -1;
            }
            else if (/Kindle/.test(ua) || /\bKF[A-Z][A-Z]+/.test(ua) || /Silk.*Mobile Safari/.test(ua)) {
                OS.kindle = true;
                // This will NOT detect early generations of Kindle Fire, I think there is no reliable way...
                // E.g. "Mozilla/5.0 (Macintosh; U; Intel Mac OS X 10_6_3; en-us; Silk/1.1.0-80) AppleWebKit/533.16 (KHTML, like Gecko) Version/5.0 Safari/533.16 Silk-Accelerated=true"
            }
            else if (/CrOS/.test(ua)) {
                OS.chromeOS = true;
            }
            if (/Windows Phone/i.test(ua) || /IEMobile/i.test(ua)) {
                OS.android = false;
                OS.iOS = false;
                OS.macOS = false;
                OS.windows = true;
                OS.windowsPhone = true;
            }
            var silk = /Silk/.test(ua);
            if (OS.windows || OS.macOS || (OS.linux && !silk) || OS.chromeOS) {
                OS.desktop = true;
            }
            //  Windows Phone / Table reset
            if (OS.windowsPhone || (/Windows NT/i.test(ua) && /Touch/i.test(ua))) {
                OS.desktop = false;
            }
            return OS;
        };
        DeviceUtil.isIpad = function (device) {
            device = device !== null && device !== void 0 ? device : this.getDeviceInfo();
            return device.macOS && navigator.maxTouchPoints && navigator.maxTouchPoints > 2;
        };
        DeviceUtil.isDesktop = function () {
            return this.getDeviceInfo().desktop;
        };
        return DeviceUtil;
    }());
    utils.DeviceUtil = DeviceUtil;
})(utils || (utils = {}));
var Phaser;
(function (Phaser) {
    var Math;
    (function (Math) {
        var EasingString;
        (function (EasingString) {
            EasingString["Power0"] = "Linear";
            EasingString["Power1"] = "Quadratic.Out";
            EasingString["Power2"] = "Cubic.Out";
            EasingString["Power3"] = "Quartic.Out";
            EasingString["Power4"] = "Quintic.Out";
            EasingString["Linear"] = "Linear";
            EasingString["Quad"] = "Quadratic.Out";
            EasingString["Cubic"] = "Cubic.Out";
            EasingString["Quart"] = "Quartic.Out";
            EasingString["Quint"] = "Quintic.Out";
            EasingString["Sine"] = "Sine.Out";
            EasingString["Expo"] = "Expo.Out";
            EasingString["Circ"] = "Circular.Out";
            EasingString["Elastic"] = "Elastic.Out";
            EasingString["Back"] = "Back.Out";
            EasingString["Bounce"] = "Bounce.Out";
            EasingString["Stepped"] = "Stepped";
            EasingString["QuadEaseIn"] = "Quadratic.In";
            EasingString["CubicEaseIn"] = "Cubic.In";
            EasingString["QuartEaseIn"] = "Quartic.In";
            EasingString["QuintEaseIn"] = "Quintic.In";
            EasingString["SineEaseIn"] = "Sine.In";
            EasingString["ExpoEaseIn"] = "Expo.In";
            EasingString["CircEaseIn"] = "Circular.In";
            EasingString["ElasticEaseIn"] = "Elastic.In";
            EasingString["BackEaseIn"] = "Back.In";
            EasingString["BounceEaseIn"] = "Bounce.In";
            EasingString["QuadEaseOut"] = "Quadratic.Out";
            EasingString["CubicEaseOut"] = "Cubic.Out";
            EasingString["QuartEaseOut"] = "Quartic.Out";
            EasingString["QuintEaseOut"] = "Quintic.Out";
            EasingString["SineEaseOut"] = "Sine.Out";
            EasingString["ExpoEaseOut"] = "Expo.Out";
            EasingString["CircEaseOut"] = "Circular.Out";
            EasingString["ElasticEaseOut"] = "Elastic.Out";
            EasingString["BackEaseOut"] = "Back.Out";
            EasingString["BounceEaseOut"] = "Bounce.Out";
            EasingString["QuadEaseInOut"] = "Quadratic.InOut";
            EasingString["CubicEaseInOut"] = "Cubic.InOut";
            EasingString["QuartEaseInOut"] = "Quartic.InOut";
            EasingString["QuintEaseInOut"] = "Quintic.InOut";
            EasingString["SineEaseInOut"] = "Sine.InOut";
            EasingString["ExpoEaseInOut"] = "Expo.InOut";
            EasingString["CircEaseInOut"] = "Circular.InOut";
            EasingString["ElasticEaseInOut"] = "Elastic.InOut";
            EasingString["BackEaseInOut"] = "Back.InOut";
            EasingString["BounceEaseInOut"] = "Bounce.InOut";
        })(EasingString = Math.EasingString || (Math.EasingString = {}));
    })(Math = Phaser.Math || (Phaser.Math = {}));
})(Phaser || (Phaser = {}));
var game;
(function (game) {
    var BaseScene = /** @class */ (function (_super) {
        __extends(BaseScene, _super);
        function BaseScene() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Object.defineProperty(BaseScene.prototype, "keyboard", {
            get: function () {
                return this.input.keyboard;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(BaseScene.prototype, "activePointer", {
            get: function () {
                return this.input.activePointer;
            },
            enumerable: false,
            configurable: true
        });
        BaseScene.prototype.init = function (data) {
            this.events.once("shutdown", this.shutdown, this);
        };
        BaseScene.prototype.create = function () {
        };
        BaseScene.prototype.resize = function () {
        };
        BaseScene.prototype.restart = function (data) {
            this.game.restartScene(this.scene.key, data);
        };
        BaseScene.prototype.onKeyDown = function (key, callback, context) {
            this.keyboard.on("keydown-" + key, callback, context);
        };
        BaseScene.prototype.onceKeyDown = function (key, callback, context) {
            this.keyboard.once("keydown-" + key, callback, context);
        };
        BaseScene.prototype.shutdown = function () {
        };
        return BaseScene;
    }(Phaser.Scene));
    game.BaseScene = BaseScene;
})(game || (game = {}));
var game;
(function (game) {
    var SceneKey;
    (function (SceneKey) {
        SceneKey["TEST_EMITTERS"] = "TEST_EMITTERS";
        SceneKey["TEST_TRAIL"] = "TEST_TRAIL";
        SceneKey["TEST_LINE"] = "TEST_LINE";
        SceneKey["TEST_LIGHTNING"] = "TEST_LIGHTNING";
        SceneKey["TEST_ANIMATIONS"] = "TEST_ANIMATIONS";
        SceneKey["GLOBAL"] = "GLOBAL";
        SceneKey["BOOT"] = "BOOT";
        SceneKey["PRELOADER"] = "PRELOADER";
        SceneKey["LEVELS_MAP"] = "LEVELS_MAP";
        SceneKey["LEVELS_MAP_DEV"] = "LEVELS_MAP_DEV";
        SceneKey["GAMEPLAY_ROOT"] = "GAMEPLAY_ROOT";
        SceneKey["GAMEPLAY"] = "GAMEPLAY";
        SceneKey["GAMEPLAY_COPY"] = "GAMEPLAY_COPY";
        SceneKey["GAMEPLAY_GUI"] = "GAMEPLAY_GUI";
        SceneKey["TUTORIAL_EDITOR"] = "TUTORIAL_EDITOR";
        SceneKey["LEVELS_MAP_EDITOR"] = "LEVELS_MAP_EDITOR";
        SceneKey["LEVEL_EDITOR_ROOT"] = "LEVEL_EDITOR_ROOT";
        SceneKey["LEVEL_EDITOR"] = "LEVEL_EDITOR";
        SceneKey["LEVEL_EDITOR_GUI"] = "LEVEL_EDITOR_GUI";
    })(SceneKey = game.SceneKey || (game.SceneKey = {}));
})(game || (game = {}));
var utils;
(function (utils) {
    var RenderStatsDOM = /** @class */ (function () {
        function RenderStatsDOM(scene) {
            this.timer = 0;
            this.updateInterval = 100;
            this.drawCallsNum = 0;
            this.scene = scene;
            this.gameLoop = this.scene.game.loop;
            this.span = document.createElement("span");
            this.span.id = "stats";
            this.span.addEventListener("click", this.toggleVisibility.bind(this));
            document.body.appendChild(this.span);
            this.scene.scale.on(Phaser.Scale.Events.RESIZE, this.onResize, this);
            this.onResize();
            this.hookToWebGL();
        }
        RenderStatsDOM.prototype.toggleVisibility = function () {
            if (this.span.style.opacity === "0") {
                this.span.style.opacity = "1";
            }
            else {
                this.span.style.opacity = "0";
            }
        };
        RenderStatsDOM.prototype.onResize = function () {
            this.span.style.left = this.scene.scale.canvasBounds.left + "px";
        };
        RenderStatsDOM.prototype.hookToWebGL = function () {
            var _this = this;
            var renderer = this.scene.sys.renderer;
            if (renderer instanceof Phaser.Renderer.WebGL.WebGLRenderer) {
                this.scene.game.events.on(Phaser.Core.Events.POST_STEP, function () {
                    _this.drawCallsNum = 0;
                });
                var gl = WebGLRenderingContext.prototype;
                gl.incrementDrawCalls = function () {
                    _this.drawCallsNum++;
                };
                gl.realDrawArrays = WebGLRenderingContext.prototype.drawArrays;
                gl.drawArrays = function (mode, first, count) {
                    this.incrementDrawCalls();
                    this.realDrawArrays(mode, first, count);
                };
            }
        };
        RenderStatsDOM.prototype.update = function (delta) {
            this.timer += delta;
            if (this.timer >= this.updateInterval) {
                this.timer -= this.updateInterval;
                this.updateStats();
            }
        };
        RenderStatsDOM.prototype.updateStats = function () {
            var fps = "FPS: " + Math.round(this.gameLoop.actualFps);
            var drawCalls = "DC: " + this.drawCallsNum;
            var result = fps + " | " + drawCalls;
            this.span.innerText = result;
        };
        return RenderStatsDOM;
    }());
    utils.RenderStatsDOM = RenderStatsDOM;
})(utils || (utils = {}));
var game;
(function (game) {
    var SceneTransitionEvent;
    (function (SceneTransitionEvent) {
        SceneTransitionEvent["START"] = "start";
        SceneTransitionEvent["COMPLETE"] = "complete";
    })(SceneTransitionEvent = game.SceneTransitionEvent || (game.SceneTransitionEvent = {}));
})(game || (game = {}));
var game;
(function (game) {
    var SceneTransition = /** @class */ (function (_super) {
        __extends(SceneTransition, _super);
        function SceneTransition(scene, config) {
            var _this = _super.call(this, scene) || this;
            _this.instantChange = false;
            _this.name = "scene_transition";
            _this.sceneManager = _this.scene.game.scene;
            _this.addMask(config);
            _this.addBackground(config);
            _this.resize();
            return _this;
        }
        SceneTransition.prototype.changeScene = function (currentSceneKey, newSceneKey, newSceneData) {
            if (this.instantChange) {
                this.emit(game.SceneTransitionEvent.START, this, currentSceneKey, newSceneKey, newSceneData);
                this.emit(game.SceneTransitionEvent.COMPLETE, this, currentSceneKey, newSceneKey, newSceneData);
                var currenScene = this.sceneManager.getScene(currentSceneKey);
                currenScene.scene.start(newSceneKey, newSceneData);
                return;
            }
            this.revive();
            this.emit(game.SceneTransitionEvent.START, this, currentSceneKey, newSceneKey, newSceneData);
            this.resize();
            this.reApplyMask();
            this.fadeIn();
            this.hideScreen(currentSceneKey, newSceneKey, newSceneData);
        };
        SceneTransition.prototype.resize = function () {
            this.background.displayWidth = game.Config.GAME_WIDTH + 4;
            this.background.displayHeight = game.Config.GAME_HEIGHT + 4;
            this.background.x = game.Config.HALF_GAME_WIDTH;
            this.background.y = game.Config.HALF_GAME_HEIGHT;
            this.maskImage.x = game.Config.HALF_GAME_WIDTH;
            this.maskImage.y = game.Config.HALF_GAME_HEIGHT;
        };
        SceneTransition.prototype.addMask = function (config) {
            this.maskImage = this.scene.make.image({ add: false, key: config.textureKey, frame: config.maskFrameName });
        };
        SceneTransition.prototype.addBackground = function (config) {
            this.background = this.scene.add.image(0, 0, config.textureKey, config.backgroundFrameName);
            this.background.setTint(config.fillColor);
            this.add(this.background);
        };
        SceneTransition.prototype.reApplyMask = function () {
            if (this.background.mask) {
                this.background.mask.destroy();
            }
            this.background.mask = this.maskImage.createBitmapMask();
            this.background.mask.invertAlpha = true;
        };
        SceneTransition.prototype.fadeIn = function () {
            this.alpha = 0;
            this.scene.tweens.add({
                targets: this,
                alpha: 1,
                duration: 270,
                ease: Phaser.Math.Easing.Cubic.Out,
            });
        };
        SceneTransition.prototype.hideScreen = function (currentScene, newScene, newSceneData) {
            var _this = this;
            this.maskImage.scale = this.getMaskScale(this.maskImage);
            this.scene.tweens.add({
                targets: this.maskImage,
                scale: 0,
                duration: 270,
                ease: Phaser.Math.Easing.Cubic.Out,
                onComplete: function () {
                    _this.doChangeScenes(currentScene, newScene, newSceneData);
                },
            });
        };
        SceneTransition.prototype.doChangeScenes = function (currentSceneKey, newSceneKey, newSceneData) {
            var currentScene = this.sceneManager.getScene(currentSceneKey);
            currentScene.events.once(Phaser.Scenes.Events.SHUTDOWN, this.revealScreen.bind(this, currentSceneKey, newSceneKey, newSceneData));
            currentScene.scene.start(newSceneKey, newSceneData);
        };
        SceneTransition.prototype.revealScreen = function (prevSceneKey, newSceneKey) {
            var _this = this;
            this.scene.tweens.add({
                targets: this,
                alpha: 0,
                duration: 400,
                ease: Phaser.Math.Easing.Linear.Linear,
                onComplete: function () {
                    _this.kill();
                    _this.emit(game.SceneTransitionEvent.COMPLETE, _this, prevSceneKey, newSceneKey);
                },
            });
        };
        SceneTransition.prototype.getMaskScale = function (mask) {
            var scaleX = game.Config.GAME_WIDTH / mask.width;
            var scaleY = game.Config.GAME_HEIGHT / mask.height;
            var scale = Math.max(scaleX, scaleY);
            return scale;
        };
        return SceneTransition;
    }(Phaser.GameObjects.Container));
    game.SceneTransition = SceneTransition;
})(game || (game = {}));
var game;
(function (game) {
    var CanvasSceneTransition = /** @class */ (function (_super) {
        __extends(CanvasSceneTransition, _super);
        function CanvasSceneTransition(scene, key, frame) {
            var _this = _super.call(this, scene, 0, 0, key, frame) || this;
            _this.sceneManager = _this.scene.game.scene;
            return _this;
        }
        CanvasSceneTransition.prototype.changeScene = function (currentSceneKey, newSceneKey, newSceneData) {
            if (this.instantChange) {
                this.emit(game.SceneTransitionEvent.START, this, currentSceneKey, newSceneKey);
                this.emit(game.SceneTransitionEvent.COMPLETE, this, currentSceneKey, newSceneKey);
                var currenScene = this.sceneManager.getScene(currentSceneKey);
                currenScene.scene.start(newSceneKey, newSceneData);
                return;
            }
            this.emit(game.SceneTransitionEvent.START, this, currentSceneKey, newSceneKey);
            this.resize();
            this.fadeIn(currentSceneKey, newSceneKey, newSceneData);
        };
        CanvasSceneTransition.prototype.fadeIn = function (currentSceneKey, newSceneKey, newSceneData) {
            var _this = this;
            this.revive();
            this.alpha = 0;
            this.scene.tweens.add({
                targets: this,
                duration: 200,
                ease: Phaser.Math.Easing.Quadratic.In,
                alpha: 1,
                onComplete: function () {
                    _this.doChangeScenes(currentSceneKey, newSceneKey, newSceneData);
                },
            });
        };
        CanvasSceneTransition.prototype.doChangeScenes = function (currentSceneKey, newSceneKey, newSceneData) {
            var currentScene = this.sceneManager.getScene(currentSceneKey);
            currentScene.events.once(Phaser.Scenes.Events.SHUTDOWN, this.fadeOut.bind(this, currentSceneKey, newSceneKey));
            currentScene.scene.start(newSceneKey, newSceneData);
        };
        CanvasSceneTransition.prototype.fadeOut = function () {
            var _this = this;
            this.scene.tweens.add({
                targets: this,
                duration: 400,
                ease: Phaser.Math.Easing.Quadratic.In,
                alpha: 0,
                onComplete: function () {
                    _this.kill();
                },
            });
        };
        CanvasSceneTransition.prototype.resize = function () {
            this.setDisplaySize(game.Config.GAME_WIDTH + 4, game.Config.GAME_HEIGHT + 4);
            this.x = game.Config.HALF_GAME_WIDTH;
            this.y = game.Config.HALF_GAME_HEIGHT;
        };
        CanvasSceneTransition.prototype.destroy = function (fromScene) {
            _super.prototype.destroy.call(this, fromScene);
        };
        return CanvasSceneTransition;
    }(Phaser.GameObjects.Image));
    game.CanvasSceneTransition = CanvasSceneTransition;
})(game || (game = {}));
var game;
(function (game) {
    var DelayedLoaderEvent;
    (function (DelayedLoaderEvent) {
        DelayedLoaderEvent["GAMEPLAY_ASSETS_READY"] = "__GAMEPLAY_ASSETS_READY";
    })(DelayedLoaderEvent = game.DelayedLoaderEvent || (game.DelayedLoaderEvent = {}));
    var DelayedLoader = /** @class */ (function (_super) {
        __extends(DelayedLoader, _super);
        function DelayedLoader(scene) {
            var _this = _super.call(this, scene) || this;
            _this.areGameplayAssetsLoaded = false;
            return _this;
        }
        DelayedLoader.prototype.startLoading = function () {
            this.json("physics", "assets/configs/physics_shapes.json");
            this.loadGameplayGraphics();
            this.loadGameplayFonts();
            this.loadGameplayAudio();
            this.once(Phaser.Loader.Events.COMPLETE, this.onGameplayAssetsLoadComplete, this);
            this.start();
        };
        DelayedLoader.prototype.loadGameplayGraphics = function () {
            this.atlas("backgrounds", "assets/graphics/backgrounds.png", "assets/graphics/backgrounds.json");
            this.atlas("gameplay", "assets/graphics/gameplay.png", "assets/graphics/gameplay.json");
            this.atlas("gameplay_gui", "assets/graphics/gameplay_gui.png", "assets/graphics/gameplay_gui.json");
        };
        DelayedLoader.prototype.loadGameplayFonts = function () {
            this.bitmapFontFromAtlas(game.BitmapGameFont.GAMEPLAY_GUI_BOOSTERS, "gameplay_gui", "boosters_label", "assets/fonts/bitmap/boosters_label.fnt", -1);
            this.bitmapFontFromAtlas(game.BitmapGameFont.GAMEPLAY_BOOSTERS, "gameplay", "boosters_label", "assets/fonts/bitmap/boosters_label.fnt", -1);
            this.bitmapFontFromAtlas(game.BitmapGameFont.BLOCK_LIVES, "gameplay", "block_lives", "assets/fonts/bitmap/block_lives.fnt", -1);
            this.bitmapFontFromAtlas(game.BitmapGameFont.BLOCK_DAMAGE_FX, "gameplay", "block_lives_fx", "assets/fonts/bitmap/block_lives_fx.fnt", -1);
            this.bitmapFontFromAtlas(game.BitmapGameFont.INGAME_GUI_DIGITS, "gameplay_gui", "ingame_gui_digits", "assets/fonts/bitmap/ingame_gui_digits.fnt");
            this.bitmapFontFromAtlas(game.BitmapGameFont.BLOCKS_LABEL, "gameplay_gui", "blocks_label", "assets/fonts/bitmap/blocks_label.fnt", 1);
            this.bitmapFontFromAtlas(game.BitmapGameFont.BLOCKS_LABEL_COMPLETE, "gameplay_gui", "blocks_label_complete", "assets/fonts/bitmap/blocks_label_complete.fnt");
        };
        DelayedLoader.prototype.loadGameplayAudio = function () {
            this.loadSound(game.GameSoundKey.BALL_HIT_1);
            this.loadSound(game.GameSoundKey.BALL_HIT_2);
            this.loadSound(game.GameSoundKey.BALL_HIT_3);
            this.loadSound(game.GameSoundKey.AIM_1);
            this.loadSound(game.GameSoundKey.AIM_2);
            this.loadSound(game.GameSoundKey.AIM_3);
        };
        DelayedLoader.prototype.loadSound = function (key, fileFormat) {
            if (fileFormat === void 0) { fileFormat = "mp3"; }
            this.audio(key, "assets/audio/" + key + "." + fileFormat);
        };
        DelayedLoader.prototype.onGameplayAssetsLoadComplete = function () {
            this.areGameplayAssetsLoaded = true;
            this.emit(DelayedLoaderEvent.GAMEPLAY_ASSETS_READY, this);
            this.loadRemainingAudio();
            this.on(Phaser.Loader.Events.FILE_COMPLETE, this.onSoundLoadComplete, this);
            this.start();
        };
        DelayedLoader.prototype.loadRemainingAudio = function () {
            if (this.scene.game.audioType === game.SoundManagerType.HTML5_AUDIO) {
                this.loadGameplayLoop();
                return;
            }
            this.loadGameplayLoop();
            this.loadSound(game.GameSoundKey.FANCY_TAP);
            this.loadSound(game.GameSoundKey.GIFT_EXPLODE);
            this.loadSound(game.GameSoundKey.GIFT_CHARGE);
            this.loadSound(game.GameSoundKey.GIFT_REVEAL);
            this.loadSound(game.GameSoundKey.STOP_SHOUT);
            this.loadSound(game.GameSoundKey.CATCH_YOU_SHOUT);
            this.loadSound(game.GameSoundKey.BOOSTER_BOMB_IGNITE);
            this.loadSound(game.GameSoundKey.BOOSTER_STOP_ACTIVE);
            this.loadSound(game.GameSoundKey.BOOSTER_CRACKER);
            this.loadSound(game.GameSoundKey.BOOSTER_CRACKER_PUNCH);
            this.loadSound(game.GameSoundKey.POP_1, "wav");
            this.loadSound(game.GameSoundKey.BALL_THROW, "wav");
            this.loadSound(game.GameSoundKey.BLOCK_HIT);
            this.loadSound(game.GameSoundKey.BLOCK_ZAPPED);
            this.loadSound(game.GameSoundKey.BLOCK_COLLECTED);
            this.loadSound(game.GameSoundKey.BLOCK_COLLECTED_WHOOSH);
            this.loadSound(game.GameSoundKey.PINATA);
            this.loadSound(game.GameSoundKey.EXPLOSION);
            this.loadSound(game.GameSoundKey.NEW_BALL_HIT);
            this.loadSound(game.GameSoundKey.NEW_BALL_LANDED);
            this.loadSound(game.GameSoundKey.SPINNER);
            this.loadSound(game.GameSoundKey.LIGHTNING);
            this.loadSound(game.GameSoundKey.MOVE_ITEMS_UP);
            this.loadSound(game.GameSoundKey.MOVE_ITEMS_DOWN);
            this.loadSound(game.GameSoundKey.TURN_COMPLETE_TEXT);
            this.loadSound(game.GameSoundKey.CLEAR_FIELD);
            this.loadSound(game.GameSoundKey.CLEAR_FIELD_MOVE_COMPLETE, "wav");
            this.loadSound(game.GameSoundKey.WINNING_BALL_WHOOSH);
            this.loadSound(game.GameSoundKey.LEVEL_COMPLETE_TEXT);
            this.loadSound(game.GameSoundKey.FOX_OOH);
            this.loadSound(game.GameSoundKey.FOX_UH_OH_1);
            this.loadSound(game.GameSoundKey.FOX_UH_OH_2);
            this.loadSound(game.GameSoundKey.BLOCK_STOMP_HIT);
            this.loadSound(game.GameSoundKey.BLOCK_STOMP_WHOOSH);
            this.loadSound(game.GameSoundKey.DUCK_SCREAM);
            this.loadSound(game.GameSoundKey.LEVEL_FAILED);
            this.loadSound(game.GameSoundKey.LEVEL_COMPLETE);
            this.loadSound(game.GameSoundKey.LEVEL_COMPLETE_STAR_SHOW_1);
            this.loadSound(game.GameSoundKey.LEVEL_COMPLETE_STAR_SHOW_2);
            this.loadSound(game.GameSoundKey.LEVEL_COMPLETE_STAR_SHOW_3);
            this.loadSound(game.GameSoundKey.DROP_BALLS_DOWN);
            this.loadSound(game.GameSoundKey.FAST_FORWARD);
            this.loadSound(game.GameSoundKey.STAR_TWINKLE_1);
            this.loadSound(game.GameSoundKey.STAR_TWINKLE_2);
        };
        DelayedLoader.prototype.loadGameplayLoop = function () {
            this.audio(game.GameSoundKey.GAMEPLAY_LOOP, "assets/audio/forest_sounds.mp3");
        };
        DelayedLoader.prototype.onSoundLoadComplete = function (key) {
            if (key === game.GameSoundKey.GAMEPLAY_LOOP) {
                this.scene.game.audio.onGameplayLoopLoaded();
            }
        };
        return DelayedLoader;
    }(Phaser.Loader.LoaderPlugin));
    game.DelayedLoader = DelayedLoader;
})(game || (game = {}));
///<reference path='../../robowhale/phaser3/RenderStatsDOM.ts' />
///<reference path='../../sceneTransition/ISceneTransition.ts' />
///<reference path='../../sceneTransition/SceneTransition.ts' />
///<reference path='../../sceneTransition/CanvasSceneTransition.ts' />
///<reference path='DelayedLoader.ts' />
var game;
(function (game) {
    var GlobalScene = /** @class */ (function (_super) {
        __extends(GlobalScene, _super);
        function GlobalScene() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        GlobalScene.prototype.init = function () {
        };
        GlobalScene.prototype.create = function () {
            var showRenderStats = utils.NetUtil.getParamBool("stats");
            if (showRenderStats) {
                this.addRenderStats();
            }
        };
        GlobalScene.prototype.addRenderStats = function () {
            this.renderStats = new utils.RenderStatsDOM(this);
        };
        GlobalScene.prototype.addIngamePreloader = function () {
            this.preloader = new game.IngamePreloader(this);
            this.preloader.kill();
            this.add.existing(this.preloader);
        };
        GlobalScene.prototype.addSceneTranstion = function (transition) {
            this.sceneTransition = transition;
            this.sceneTransition.visible = false;
            this.sceneTransition.active = false;
            this.add.existing(this.sceneTransition);
        };
        GlobalScene.prototype.addToasts = function () {
            this.toasts = new game.ToastsManager(this);
            this.add.existing(this.toasts);
            this.resize();
            return this.toasts;
        };
        GlobalScene.prototype.addDelayedLoader = function () {
            this.delayedLoader = new game.DelayedLoader(this);
        };
        GlobalScene.prototype.update = function (time, delta) {
            if (this.renderStats) {
                this.renderStats.update(delta);
            }
        };
        GlobalScene.prototype.resize = function () {
            if (this.toasts) {
                this.toasts.scale = game.Config.GAME_WIDTH / game.Config.SOURCE_GAME_WIDTH;
                this.toasts.x = game.Config.HALF_GAME_WIDTH;
                this.toasts.y = game.Config.HALF_GAME_HEIGHT;
                this.toasts.resize();
            }
        };
        return GlobalScene;
    }(Phaser.Scene));
    game.GlobalScene = GlobalScene;
})(game || (game = {}));
var game;
(function (game) {
    function isLocalStorageAvailable() {
        try {
            var key = "__storage_test__";
            localStorage.setItem(key, key);
            localStorage.removeItem(key);
            return true;
        }
        catch (e) {
            return false;
        }
    }
    game.isLocalStorageAvailable = isLocalStorageAvailable;
    var LocalStorageWrapper = /** @class */ (function () {
        function LocalStorageWrapper(storeName) {
            this.type = "Local Storage";
            this.prefix = storeName;
        }
        LocalStorageWrapper.prototype.init = function () {
            return Promise.resolve();
        };
        LocalStorageWrapper.prototype.saveValue = function (key, value) {
            if (typeof value === "string") {
                localStorage.setItem(this.getStorageKey(key), value);
            }
            else {
                var dataToSave = JSON.stringify(value);
                localStorage.setItem(this.getStorageKey(key), dataToSave);
            }
            return Promise.resolve();
        };
        LocalStorageWrapper.prototype.getStorageKey = function (key) {
            return this.prefix + "__" + key;
        };
        LocalStorageWrapper.prototype.getValue = function (key) {
            // returns null if key is not present
            return Promise.resolve(localStorage.getItem(this.getStorageKey(key)));
        };
        LocalStorageWrapper.prototype.getNumber = function (key) {
            return __awaiter(this, void 0, void 0, function () {
                var value, num;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.getValue(key)];
                        case 1:
                            value = _a.sent();
                            if (value === null) {
                                return [2 /*return*/, Promise.resolve(0)];
                            }
                            else {
                                num = parseFloat(value) || 0;
                                return [2 /*return*/, Promise.resolve(num)];
                            }
                            return [2 /*return*/];
                    }
                });
            });
        };
        LocalStorageWrapper.prototype.getBoolean = function (key) {
            return __awaiter(this, void 0, void 0, function () {
                var value, bool;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.getValue(key)];
                        case 1:
                            value = _a.sent();
                            if (value === null) {
                                return [2 /*return*/, Promise.resolve(false)];
                            }
                            else {
                                bool = value === "true";
                                return [2 /*return*/, Promise.resolve(bool)];
                            }
                            return [2 /*return*/];
                    }
                });
            });
        };
        LocalStorageWrapper.prototype.getString = function (key) {
            return __awaiter(this, void 0, void 0, function () {
                var value;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.getValue(key)];
                        case 1:
                            value = _a.sent();
                            if (value === null) {
                                return [2 /*return*/, Promise.resolve("")];
                            }
                            else {
                                return [2 /*return*/, Promise.resolve(value)];
                            }
                            return [2 /*return*/];
                    }
                });
            });
        };
        LocalStorageWrapper.prototype.getObject = function (key) {
            return __awaiter(this, void 0, void 0, function () {
                var value, obj;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.getValue(key)];
                        case 1:
                            value = _a.sent();
                            obj = null;
                            try {
                                obj = JSON.parse(value);
                            }
                            catch (e) {
                                console.error(e);
                            }
                            return [2 /*return*/, Promise.resolve(obj)];
                    }
                });
            });
        };
        LocalStorageWrapper.prototype.remove = function (key) {
            localStorage.removeItem(this.getStorageKey(key));
        };
        LocalStorageWrapper.prototype.clear = function () {
            var _this = this;
            Object.keys(localStorage)
                .filter(function (key) { return key.includes(_this.prefix); })
                .forEach(function (key) {
                localStorage.removeItem(key);
            });
            return Promise.resolve();
        };
        return LocalStorageWrapper;
    }());
    game.LocalStorageWrapper = LocalStorageWrapper;
})(game || (game = {}));
///<reference path='./global/GlobalScene.ts' />
///<reference path='../robowhale/storage/LocalStorageWrapper.ts' />
var game;
(function (game) {
    var ImageFile = Phaser.Loader.FileTypes.ImageFile;
    var AudioFile = Phaser.Loader.FileTypes.AudioFile;
    var Boot = /** @class */ (function (_super) {
        __extends(Boot, _super);
        function Boot() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.wasPaused = false;
            _this.wasIncorrectOrientation = false;
            return _this;
        }
        Boot.prototype.init = function () {
            return __awaiter(this, void 0, void 0, function () {
                var localStorage, _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            localStorage = game.isLocalStorageAvailable() ? window.localStorage : null;
                            _a = this.game;
                            return [4 /*yield*/, this.checkAvifSupport(localStorage)];
                        case 1:
                            _a.avif = _b.sent();
                            this.game.webp = this.checkWebpSupport(localStorage);
                            if (this.game.avif || this.game.webp) {
                                this.patchImageLoader();
                            }
                            this.setPageBackground();
                            this.patchAudioFileLoading();
                            return [2 /*return*/];
                    }
                });
            });
        };
        Boot.prototype.checkAvifSupport = function (localStorage) {
            var disableAvif = utils.NetUtil.getParamBool("noAvif");
            if (disableAvif) {
                return Promise.resolve(false);
            }
            var isDevelop = window.environment === GameEnvironment.DEVELOP;
            if (isDevelop) {
                return Promise.resolve(false);
            }
            var localStorageKey = "robowhale__avif";
            if ((localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem(localStorageKey)) === "true") {
                return Promise.resolve(true);
            }
            return new Promise(function (resolve) {
                var callback = function () {
                    if (image.height === 2) {
                        localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem(localStorageKey, "true");
                        resolve(true);
                    }
                    else {
                        resolve(false);
                    }
                };
                var image = new Image();
                image.onload = callback;
                image.onerror = callback;
                image.src = "data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAAB0AAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAIAAAACAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQ0MAAAAABNjb2xybmNseAACAAIAAYAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAACVtZGF0EgAKCBgANogQEAwgMg8f8D///8WfhwB8+ErK42A=";
            });
        };
        Boot.prototype.checkWebpSupport = function (localStorage) {
            var disableWebP = utils.NetUtil.getParamBool("noWebp");
            if (disableWebP) {
                return false;
            }
            var isDevelop = window.environment === GameEnvironment.DEVELOP;
            if (isDevelop) {
                return false;
            }
            var localStorageKey = "robowhale__webp";
            if ((localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem(localStorageKey)) === "true") {
                return true;
            }
            var isSupported = this.doCheckWebP();
            if (isSupported) {
                localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem(localStorageKey, "true");
            }
            return isSupported;
        };
        Boot.prototype.doCheckWebP = function () {
            var match = navigator.userAgent.match(/(Edge|Firefox)\/(\d+)\.(\d*)/);
            if (match && match[1] === "Firefox" && +match[2] >= 65) {
                return true;
            }
            // https://web.archive.org/web/20190626051700/https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/19618851/
            if (match && match[1] === "Edge" && +match[2] === 18 && +match[3] === 17763) {
                return false;
            }
            var canvas = Phaser.Display.Canvas.CanvasPool.create(document);
            var supported = canvas.toDataURL
                ? canvas.toDataURL("image/webp").indexOf("data:image/webp") == 0
                : false;
            Phaser.Display.Canvas.CanvasPool.remove(canvas);
            return supported;
        };
        Boot.prototype.patchImageLoader = function () {
            var newFormat = this.getDefaultImageFormat(".png");
            var formats = [".png", ".jpg"];
            var replaceUrl = function (file) {
                if (file instanceof ImageFile) {
                    var fileUrl_1 = file.url;
                    var format = formats.find(function (format) { return fileUrl_1.includes(format); });
                    if (format) {
                        file.url = file.url.replace(format, newFormat);
                    }
                }
            };
            Phaser.Loader.LoaderPlugin.prototype["addFileOld"] = Phaser.Loader.LoaderPlugin.prototype.addFile;
            Phaser.Loader.LoaderPlugin.prototype.addFile = function (files) {
                if (Array.isArray(files)) {
                    files.forEach(function (file) { return replaceUrl(file); });
                }
                else {
                    replaceUrl(files);
                }
                return this["addFileOld"](files);
            };
        };
        Boot.prototype.getDefaultImageFormat = function (defaultFormat) {
            if (this.game.avif) {
                return ".avif";
            }
            else if (this.game.webp) {
                return ".webp";
            }
            else {
                return defaultFormat;
            }
        };
        Boot.prototype.setPageBackground = function () {
            this.game.canvas.parentElement.style.backgroundImage = "url('assets/graphics/page_background" + this.getDefaultImageFormat(".jpg") + "')";
        };
        Boot.prototype.patchAudioFileLoading = function () {
            AudioFile.prototype["onProcessOld"] = AudioFile.prototype.onProcess;
            AudioFile.prototype.onProcess = function () {
                var _a, _b, _c;
                try {
                    this["onProcessOld"]();
                }
                catch (e) {
                    (_c = (_b = (_a = this.loader) === null || _a === void 0 ? void 0 : _a.scene) === null || _b === void 0 ? void 0 : _b.raven) === null || _c === void 0 ? void 0 : _c.captureException("Error processing audio " + this.key + " - " + e);
                }
            };
        };
        Boot.prototype.preload = function () {
            this.load.atlas("preloader", "assets/graphics/preloader.png", "assets/graphics/preloader.json");
            this.loadWebFonts();
        };
        Boot.prototype.loadWebFonts = function () {
            // this.load.on(GameFontsEvent.WEBFONT_ACTIVE, this.onWebFontActive, this)
            this.load.on(game.GameFontsEvent.WEBFONT_INACTIVE, this.onWebFontInactive, this);
            this.load.rexWebFont({
                custom: {
                    families: ["Souses:n7,n9"],
                    urls: ["css/fonts.css"],
                },
            });
        };
        Boot.prototype.onWebFontActive = function () {
            // console.log("Boot.onWebFontActive", arguments)
        };
        Boot.prototype.onWebFontInactive = function (loader, fontFamily, fontStyle) {
            var message = "Can't load webfont " + fontFamily + ":" + fontStyle;
            console.warn(message);
        };
        Boot.prototype.create = function () {
            var _this = this;
            this.game.raven.addTagsContext({
                avif: this.game.avif,
                webP: this.game.webp,
            });
            this.game.injectIntoScenes(this.game.raven, "raven");
            this.addThrottling();
            this.disableScrollBySpacebar();
            this.setupAnalytics();
            this.setupScale();
            this.setupPoki()
                .finally(function () {
                _this.launchGlobalScene();
            });
        };
        Boot.prototype.addThrottling = function () {
            var throttle = utils.NetUtil.getParamInt("throttle");
            if (throttle > 0) {
                this.events.on(Phaser.Scenes.Events.PRE_UPDATE, function () {
                    var i = throttle * 1000000;
                    var a = 0;
                    while (--i) {
                        a += Math.sqrt(i);
                    }
                });
            }
        };
        Boot.prototype.disableScrollBySpacebar = function () {
            if (this.game.device.os.desktop) {
                return;
            }
            this.game.input.keyboard.addCapture(32);
        };
        Boot.prototype.setupAnalytics = function () {
            this.game.analytics = new game.GameAnalyticsWrapper(this.game);
            this.game.injectIntoScenes(this.game.analytics, "analytics");
        };
        Boot.prototype.launchGlobalScene = function () {
            var globalScene = this.scene.get(game.SceneKey.GLOBAL);
            globalScene.events.once(Phaser.Scenes.Events.READY, this.onGlobalSceneReady.bind(this, globalScene));
            globalScene.scene.start(game.SceneKey.GLOBAL);
        };
        Boot.prototype.onGlobalSceneReady = function (globalScene) {
            this.game.globalScene = globalScene;
            globalScene.scene.launch(game.SceneKey.PRELOADER);
            globalScene.scene.bringToTop();
        };
        Boot.prototype.setupScale = function () {
            if (this.game.config.scaleMode === Phaser.Scale.NONE) {
                this.scaleForMobile();
                this.updateScreenConstants();
            }
        };
        Boot.prototype.scaleForMobile = function () {
            var scale = this.game.scale;
            scale.orientation = Phaser.Scale.Orientation.PORTRAIT;
            this.wasIncorrectOrientation = true;
            window.addEventListener("resize", this.onWindowResize.bind(this));
            this.onWindowResize();
        };
        Boot.prototype.onWindowResize = function () {
            var _a;
            var width = window.innerWidth;
            var height = window.innerHeight;
            var dpr = Math.min(window.devicePixelRatio, 1.5);
            this.game.raven.captureBreadcrumb({
                category: "game",
                message: "resize",
                data: {
                    width: width,
                    height: height,
                    dpr: window.devicePixelRatio,
                    orientation: (_a = screen.orientation) === null || _a === void 0 ? void 0 : _a.type,
                },
            });
            this.scale.zoom = 1 / dpr;
            this.scale.resize(width * dpr, height * dpr);
            var isCorrectOrientation = this.isCorrectOrientation();
            if (isCorrectOrientation) {
                this.updateScreenConstants();
                this.resizeActiveScenes();
                this.hideRotateIcon();
                if (this.wasPaused) {
                    this.game.loop.resume();
                    this.wasPaused = false;
                }
            }
            else {
                this.showRotateIcon();
                this.game.loop.pause();
                this.wasPaused = true;
            }
            var isSameOrientation = !this.wasIncorrectOrientation && isCorrectOrientation;
            if (isSameOrientation) {
                this.handleScroll();
            }
            var enterCorrectOrientation = this.wasIncorrectOrientation && isCorrectOrientation;
            if (enterCorrectOrientation) {
                this.fillViewport();
            }
            this.wasIncorrectOrientation = !isCorrectOrientation;
        };
        Boot.prototype.handleScroll = function () {
            if (typeof this.scrollTimeout == "undefined") {
                clearTimeout(this.scrollTimeout);
            }
            this.scrollTimeout = setTimeout(function () {
                window.scrollTo(0, -window.innerHeight);
            }, 500);
        };
        Boot.prototype.fillViewport = function () {
            if (typeof this.resizeTimeout !== "undefined") {
                clearTimeout(this.resizeTimeout);
            }
            this.resizeTimeout = setTimeout(function () {
                document.body.style.width = "100vw";
                document.body.style.height = "100vh";
            }, 500);
        };
        Boot.prototype.isCorrectOrientation = function () {
            var correctPortrait = game.Config.IS_PORTRAIT && this.isPortrait();
            var correctLandscape = game.Config.IS_LANDSCAPE && this.isLandscape();
            return correctPortrait || correctLandscape;
        };
        Boot.prototype.resizeActiveScenes = function () {
            this.game.scene.getScenes(true).forEach(function (scene) {
                if (scene.resize) {
                    scene.resize();
                }
            });
        };
        Boot.prototype.setupPoki = function () {
            this.game.poki = new game.PokiSdkWrapper(this.game);
            this.game.poki.injectIntoScenes();
            return this.game.poki.init();
        };
        Boot.prototype.updateScreenConstants = function () {
            game.Config.GAME_WIDTH = this.game.scale.width;
            game.Config.GAME_HEIGHT = this.game.scale.height;
            game.Config.HALF_GAME_WIDTH = game.Config.GAME_WIDTH * 0.5;
            game.Config.HALF_GAME_HEIGHT = game.Config.GAME_HEIGHT * 0.5;
            game.Config.ASPECT_RATIO = game.Config.GAME_WIDTH / game.Config.GAME_HEIGHT;
            game.Config.ZOOM = this.game.scale.zoom;
            game.Config.ASSETS_SCALE = game.Config.IS_PORTRAIT
                ? game.Config.GAME_WIDTH / game.Config.SOURCE_GAME_WIDTH
                : game.Config.GAME_HEIGHT / game.Config.SOURCE_GAME_HEIGHT;
        };
        Boot.prototype.showRotateIcon = function () {
            this.getRotateElement().style.display = "flex";
        };
        Boot.prototype.hideRotateIcon = function () {
            this.getRotateElement().style.display = "none";
        };
        Boot.prototype.getRotateElement = function () {
            return document.getElementById("rotate");
        };
        Boot.prototype.isLandscape = function () {
            return window.innerWidth > window.innerHeight;
        };
        Boot.prototype.isPortrait = function () {
            return window.innerHeight > window.innerWidth;
        };
        return Boot;
    }(Phaser.Scene));
    game.Boot = Boot;
})(game || (game = {}));
var game;
(function (game) {
    var LoadingLogo = /** @class */ (function (_super) {
        __extends(LoadingLogo, _super);
        function LoadingLogo(scene, atlasKey) {
            if (atlasKey === void 0) { atlasKey = "preloader"; }
            var _this = _super.call(this, scene) || this;
            _this.name = "loading_logo";
            _this.atlasKey = atlasKey;
            _this.addLogo();
            _this.addLogoCrop();
            return _this;
        }
        LoadingLogo.prototype.addLogo = function () {
            this.logoShadow = this.scene.add.image(0, 0, this.atlasKey, "fox_head_black");
            this.logoShadow.y = 10;
            this.logoShadow.alpha = 0.15;
            this.logoBack = this.scene.add.image(0, 0, this.atlasKey, "fox_head_beige");
            this.logo = this.scene.add.image(0, 0, this.atlasKey, "fox_head");
            this.add([this.logoShadow, this.logoBack, this.logo]);
        };
        LoadingLogo.prototype.addLogoCrop = function () {
            var initialHeight = 1;
            this.logoCrop = new Phaser.Geom.Rectangle(0, this.logo.height - initialHeight, this.logo.width, initialHeight);
            this.logo.setCrop(this.logoCrop);
        };
        LoadingLogo.prototype.setProgressInstant = function (progress) {
            this.scene.tweens.killTweensOf(this.logoCrop);
            var crop = this.getLogoCropParams(progress);
            this.logoCrop.height = crop.height;
            this.logoCrop.y = crop.y;
            this.logo.setCrop(this.logoCrop);
        };
        LoadingLogo.prototype.setProgress = function (progress) {
            var _this = this;
            var crop = this.getLogoCropParams(progress);
            this.scene.tweens.killTweensOf(this.logoCrop);
            this.scene.tweens.add({
                targets: this.logoCrop,
                duration: 200,
                ease: Phaser.Math.Easing.Linear.Linear,
                y: crop.y,
                height: crop.height,
                onUpdate: function () {
                    _this.logo.setCrop(_this.logoCrop);
                },
            });
        };
        LoadingLogo.prototype.getLogoCropParams = function (loadProgress) {
            var originalHeight = this.logo.height;
            var height = originalHeight * Math.max(0.001, loadProgress); // because canvas renderer fails when cropHeight is zero
            return {
                height: height,
                y: originalHeight - height,
            };
        };
        LoadingLogo.prototype.getWidth = function () {
            return this.logoBack.width;
        };
        return LoadingLogo;
    }(Phaser.GameObjects.Container));
    game.LoadingLogo = LoadingLogo;
})(game || (game = {}));
///<reference path='LoadingLogo.ts' />
var game;
(function (game) {
    var NetUtil = utils.NetUtil;
    var Preloader = /** @class */ (function (_super) {
        __extends(Preloader, _super);
        function Preloader() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Preloader.prototype.init = function () {
            this.events.on("shutdown", this.shutdown, this);
            this.addBackground();
            this.addLogo();
            this.addCopyright();
            this.events.on(Phaser.Scenes.Events.UPDATE, this.scrollBackground, this);
            this.resize();
        };
        Preloader.prototype.addBackground = function () {
            this.background = this.add.tileSprite(0, 0, 0, 0, "preloader", "bg");
        };
        Preloader.prototype.addLogo = function () {
            this.logo = new game.LoadingLogo(this);
            this.add.existing(this.logo);
        };
        Preloader.prototype.addCopyright = function () {
            var content = this.getCopyrightContent();
            var style = {
                fontFamily: game.GameFont.SOUSES,
                fontStyle: game.FontWeight.BOLD,
                fontSize: "28px",
                color: "#FDF2E7",
                align: "center",
            };
            this.copyright = this.add.text(0, 0, content, style);
            this.copyright.setOrigin(0.5, 1);
            this.copyright.setShadow(0, 2, "rgba(0,0,0,0.2)");
            this.copyright.visible = utils.NetUtil.isHostAllowed(["192.168", "localhost", "robowhale.com"]);
            this.copyright.kill();
        };
        Preloader.prototype.getCopyrightContent = function () {
            var developmentYear = 2020;
            var currentYear = new Date().getUTCFullYear();
            var years = currentYear === developmentYear ? currentYear.toString() : developmentYear + "-" + currentYear;
            return "Developed by RoboWhale, " + years + "\nUse with permission";
        };
        Preloader.prototype.preload = function () {
            this.analytics.sendLoadingEvent("main", "start");
            this.poki.sdk.gameLoadingStart();
            this.game.loadingOverlay.fadeOut();
            this.load.maxParallelDownloads = this.game.device.os.android ? 6 : 32;
            this.load.cacheBuster = window.game.config.build_version;
            this.load.on(Phaser.Loader.Events.PROGRESS, this.onLoadProgress, this);
            this.load.on(Phaser.Loader.Events.COMPLETE, this.onLoadComplete, this);
            this.loadOtherAssets();
            this.loadFonts();
            this.loadAudio();
            this.loadGraphics();
            this.loadEditor();
            this.loadSaveData();
        };
        Preloader.prototype.onLoadProgress = function () {
            this.logo.setProgress(this.load.progress);
        };
        Preloader.prototype.onLoadComplete = function () {
            this.load.off(Phaser.Loader.Events.FILE_COMPLETE, this.onLoadProgress, this);
        };
        Preloader.prototype.loadOtherAssets = function () {
            this.load.json("texts", "assets/texts.json");
            this.loadLevelConfigs();
            this.loadLevelsMapConfig();
        };
        Preloader.prototype.loadLevelConfigs = function () {
            var _a;
            var loadRemote = utils.NetUtil.getParamBool("loadRemote");
            var filename = (_a = utils.NetUtil.getParam("levelsFile")) !== null && _a !== void 0 ? _a : "levels";
            var fullFilename = filename + ".json";
            var url = loadRemote ? game.Config.SERVER_URL + fullFilename : "assets/configs/" + fullFilename;
            this.load.json("levels", url);
        };
        Preloader.prototype.loadLevelsMapConfig = function () {
            var loadRemote = utils.NetUtil.getParamBool("loadRemote");
            var url = loadRemote
                ? game.Config.SERVER_URL + "levels_map.json"
                : "assets/configs/levels_map_config.json";
            this.load.json(game.LevelsMap.CONFIG_KEY, url);
        };
        Preloader.prototype.loadFonts = function () {
            this.load.bitmapFontFromAtlas(game.BitmapGameFont.LEVELS_MAP_NUMBERS_COMPLETE, "levels_map", "level_icons_font_complete", "assets/fonts/bitmap/level_icons_font_complete.fnt");
            this.load.bitmapFontFromAtlas(game.BitmapGameFont.LEVELS_MAP_NUMBERS_UNLOCKED, "levels_map", "level_icons_font_unlocked", "assets/fonts/bitmap/level_icons_font_unlocked.fnt");
        };
        Preloader.prototype.loadAudio = function () {
            this.load.audio(game.GameSoundKey.MENU_LOOP, "assets/audio/menu_loop.mp3");
            if (this.game.audioType === game.SoundManagerType.WEB_AUDIO) {
                this.load.audio(game.GameSoundKey.TAP, "assets/audio/tap.mp3");
            }
        };
        Preloader.prototype.loadGraphics = function () {
            this.load.image("levels_map_bg_1", "assets/graphics/levels_map_bg_1.jpg");
            this.load.image("levels_map_bg_2", "assets/graphics/levels_map_bg_2.jpg");
            this.load.image("levels_map_bg_3", "assets/graphics/levels_map_bg_3.jpg");
            this.load.atlas("levels_map", "assets/graphics/levels_map.png", "assets/graphics/levels_map.json");
        };
        Preloader.prototype.loadEditor = function () {
            if (game.Main.editorEnabled === false) {
                return;
            }
            this.load.script("tweakpane", "js/tweakpane.min.js");
            this.load.atlas("editor", "assets/graphics/editor.png", "assets/graphics/editor.json");
            this.load.bitmapFontFromAtlas(game.BitmapGameFont.EDITOR_BLOCK_LIVES, "editor", "block_lives", "assets/fonts/bitmap/block_lives.fnt", -1);
            this.load.bitmapFontFromAtlas(game.BitmapGameFont.EDITOR_ROW_NUMBERS, "editor", "row_numbers", "assets/fonts/bitmap/row_numbers.fnt", -1);
        };
        Preloader.prototype.loadSaveData = function () {
            var _this = this;
            this.load.rexAwait("init_game_store", {
                callback: function (onSuccess) {
                    _this.game.store.initActualStorage()
                        .catch(function (error) {
                        _this.sendStorageErrorToAnalytics(error);
                    })
                        .finally(function () { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, this.game.store.loadInitialValues()];
                                case 1:
                                    _a.sent();
                                    return [4 /*yield*/, this.game.store.migrateSaveData()];
                                case 2:
                                    _a.sent();
                                    onSuccess();
                                    return [2 /*return*/];
                            }
                        });
                    }); });
                },
            });
        };
        Preloader.prototype.sendStorageErrorToAnalytics = function (error) {
            var _a;
            var errorText = error instanceof DOMException
                ? error.message
                : error.toString();
            (_a = this.game.analytics) === null || _a === void 0 ? void 0 : _a.sendError("LocalStorage:" + errorText);
        };
        Preloader.prototype.create = function () {
            this.addSidebards();
            this.initTexts();
            this.initBoosters();
            this.initLevelConfigs();
            this.addIngamePreloader();
            this.addScenesTransition();
            this.addToasts();
            this.initAudio(); // audio should be init only after scene transition is ready
            this.initDelayedLoader();
            this.poki.sdk.gameLoadingFinished();
            this.analytics.sendLoadingEvent("main", "complete");
            this.startGame();
        };
        Preloader.prototype.addSidebards = function () {
            this.setSidebackground("left-sidebar", "page_left_sidebar");
            this.setSidebackground("right-sidebar", "page_right_sidebar");
        };
        Preloader.prototype.setSidebackground = function (sidebarId, imageKey) {
            var sidebar = document.getElementById(sidebarId);
            if (!sidebar) {
                return;
            }
            var format = this.game.getDefaultImageFormat("png");
            var file = imageKey + "." + format;
            sidebar.style.backgroundImage = "url('assets/graphics/" + file + "')";
        };
        Preloader.prototype.initTexts = function () {
            this.game.texts = new game.GameTexts(this.game);
            this.game.texts.injectTextsIntoScenes();
        };
        Preloader.prototype.initBoosters = function () {
            this.game.boosters = new game.BoostersManager(this.game);
            var cheatBoosters = utils.NetUtil.getParamBool("boosters");
            if (cheatBoosters) {
                this.game.boosters.boosters.forEach(function (booster) {
                    booster.num = 99;
                });
            }
        };
        Preloader.prototype.initLevelConfigs = function () {
            var configs = this.cache.json.get("levels");
            this.game.levelConfigs = new game.LevelConfigsManager(configs);
        };
        Preloader.prototype.initAudio = function () {
            var audio = new game.GameAudio(this.game.globalScene);
            audio.loadMute();
            audio.addMenuLoop();
            audio.listenToScenesChange(this.game.globalScene.sceneTransition);
            this.game.audio = audio;
        };
        Preloader.prototype.initDelayedLoader = function () {
            this.game.globalScene.addDelayedLoader();
            this.game.globalScene.delayedLoader.startLoading();
        };
        Preloader.prototype.addIngamePreloader = function () {
            this.game.globalScene.addIngamePreloader();
        };
        Preloader.prototype.addScenesTransition = function () {
            var transition = new game.CanvasSceneTransition(this.game.globalScene, "preloader", "black_rect");
            this.game.globalScene.addSceneTranstion(transition);
            this.game.globalScene.sceneTransition.instantChange = utils.NetUtil.getParamBool("instantSceneChange");
            this.game.raven.trackSceneChanges(transition);
        };
        Preloader.prototype.addToasts = function () {
            this.game.toasts = this.game.globalScene.addToasts();
        };
        Preloader.prototype.startGame = function () {
            if (window.environment === GameEnvironment.DEVELOP) {
                this.startGameOnDev();
            }
            else {
                this.startGameOnDeploy();
            }
        };
        Preloader.prototype.startGameOnDev = function () {
            var level = NetUtil.getParamInt("level");
            if (level > 0 && this.game.levelConfigs.check(level)) {
                this.startScene(game.SceneKey.GAMEPLAY_ROOT, { levelNumber: level });
                return;
            }
            var levelEditor = NetUtil.getParamInt("levelEditor");
            if (levelEditor > 0 && this.game.levelConfigs.check(levelEditor)) {
                this.startScene(game.SceneKey.LEVEL_EDITOR_ROOT, { levelNumber: levelEditor });
                return;
            }
            this.startScene(game.SceneKey.LEVELS_MAP);
            // this.startScene(SceneKey.LEVELS_MAP_DEV)
            // this.startScene(SceneKey.GAMEPLAY_ROOT, { levelNumber: this.getLevelFromUrl() || 41 })
            // this.startScene(SceneKey.LEVEL_EDITOR_ROOT, { levelNumber: this.getLevelFromUrl() || 45 })
            // this.startScene(SceneKey.TUTORIAL_EDITOR, { levelNumber: 5 })
            // this.startScene(SceneKey.LEVELS_MAP_EDITOR)
        };
        Preloader.prototype.startGameOnDeploy = function () {
            if (game.Main.editorEnabled) {
                this.startScene(game.SceneKey.LEVELS_MAP_DEV);
                return;
            }
            var levelNumber = this.getLevelFromUrl();
            if (levelNumber) {
                this.startScene(game.SceneKey.GAMEPLAY_ROOT, { levelNumber: levelNumber });
            }
            else {
                this.startScene(game.SceneKey.LEVELS_MAP);
            }
        };
        Preloader.prototype.getLevelFromUrl = function () {
            var levelNumber = utils.NetUtil.getParam("level");
            if (levelNumber === null) {
                return null;
            }
            return parseInt(levelNumber);
        };
        Preloader.prototype.startScene = function (scene, data) {
            var isEditorScene = [game.SceneKey.LEVELS_MAP_DEV, game.SceneKey.LEVEL_EDITOR_ROOT, game.SceneKey.LEVELS_MAP_EDITOR, game.SceneKey.TUTORIAL_EDITOR].includes(scene);
            if (isEditorScene && game.Main.editorEnabled === false) {
                console.warn("Can't start " + scene + " scene. Add editor=1 to enable editor!");
                return;
            }
            this.game.changeScene(this.scene.key, scene, data);
        };
        Preloader.prototype.scrollBackground = function (time, delta) {
            this.background.tilePositionY += 0.066 * delta;
        };
        Preloader.prototype.resize = function () {
            this.resizeBackground();
            this.alignLogo();
            this.alignCopyright();
        };
        Preloader.prototype.resizeBackground = function () {
            this.background.envelop(game.Config.GAME_WIDTH, game.Config.GAME_HEIGHT);
            this.background.x = game.Config.HALF_GAME_WIDTH;
            this.background.y = game.Config.HALF_GAME_HEIGHT;
        };
        Preloader.prototype.alignLogo = function () {
            var maxWidth = game.Config.GAME_WIDTH * 0.45;
            this.logo.scale = Math.min(1, maxWidth / this.logo.getWidth());
            this.logo.x = game.Config.HALF_GAME_WIDTH;
            this.logo.y = game.Config.HALF_GAME_HEIGHT;
        };
        Preloader.prototype.alignCopyright = function () {
            var maxWidth = game.Config.GAME_WIDTH * 0.66;
            this.copyright.scale = 1;
            this.copyright.scale = Math.min(1, maxWidth / this.copyright.width);
            this.copyright.x = game.Config.HALF_GAME_WIDTH;
            this.copyright.y = game.Config.GAME_HEIGHT - 20;
        };
        Preloader.prototype.shutdown = function () {
            this.events.off(Phaser.Scenes.Events.UPDATE, this.scrollBackground, this);
        };
        return Preloader;
    }(Phaser.Scene));
    game.Preloader = Preloader;
})(game || (game = {}));
var game;
(function (game) {
    var EditorCell = /** @class */ (function (_super) {
        __extends(EditorCell, _super);
        function EditorCell(scene, texture, frame, column, row) {
            var _this = _super.call(this, scene, 0, 0, texture, frame) || this;
            _this.originalAlpha = 1;
            _this._isSelected = false;
            _this._column = column;
            _this._row = row;
            _this.name = "cell";
            _this.setInteractive();
            _this.on(Phaser.Input.Events.GAMEOBJECT_POINTER_OVER, _this.onPointerOver, _this);
            _this.on(Phaser.Input.Events.GAMEOBJECT_POINTER_OUT, _this.onPointerOut, _this);
            return _this;
        }
        Object.defineProperty(EditorCell.prototype, "isSelected", {
            get: function () {
                return this._isSelected;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(EditorCell.prototype, "row", {
            get: function () {
                return this._row;
            },
            set: function (value) {
                this._row = value;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(EditorCell.prototype, "column", {
            get: function () {
                return this._column;
            },
            enumerable: false,
            configurable: true
        });
        EditorCell.prototype.onPointerOver = function () {
            this.scale = 1.2;
        };
        EditorCell.prototype.onPointerOut = function () {
            this.scale = 1;
        };
        EditorCell.prototype.getSelectedAlpha = function () {
            return this.originalAlpha * 3;
        };
        EditorCell.prototype.setSelected = function (value) {
            if (this._isSelected === value) {
                return;
            }
            this._isSelected = value;
            if (this._isSelected) {
                this.setFrame("cell_with_plus");
                this.alpha = this.getSelectedAlpha();
            }
            else {
                this.setFrame("cell");
                this.alpha = this.originalAlpha;
            }
        };
        EditorCell.prototype.destroy = function (fromScene) {
            _super.prototype.destroy.call(this, fromScene);
        };
        return EditorCell;
    }(Phaser.GameObjects.Image));
    game.EditorCell = EditorCell;
})(game || (game = {}));
///<reference path='EditorCell.ts' />
var game;
(function (game) {
    var EditorGridEvent;
    (function (EditorGridEvent) {
        EditorGridEvent["ADD_ROW"] = "add_row";
        EditorGridEvent["REMOVE_ROW"] = "remove_row";
    })(EditorGridEvent = game.EditorGridEvent || (game.EditorGridEvent = {}));
    var EditorGrid = /** @class */ (function (_super) {
        __extends(EditorGrid, _super);
        function EditorGrid(scene, columns, rows) {
            var _this = _super.call(this, scene) || this;
            scene.add.existing(_this);
            _this.editor = _this.scene;
            _this.selectedCells = [];
            _this.rowLabels = [];
            _this.removeRowButtons = [];
            _this.name = "grid";
            _this.initialColumns = columns;
            _this.initialRows = rows;
            _this._columns = columns;
            _this._rows = 0;
            _this.addInitialRows();
            _this.addVisibleRowsSeparator();
            _this.addColumnLabels();
            _this.addAddRowButton();
            return _this;
        }
        Object.defineProperty(EditorGrid.prototype, "columns", {
            get: function () {
                return this._columns;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(EditorGrid.prototype, "rows", {
            get: function () {
                return this._rows;
            },
            enumerable: false,
            configurable: true
        });
        EditorGrid.prototype.addSelectedCell = function (cell) {
            cell.setSelected(true);
            this.lastSelectedCell = cell;
            this.selectedCells.push(cell);
        };
        EditorGrid.prototype.removeSelectedCell = function (cell) {
            cell.setSelected(false);
            _.pull(this.selectedCells, cell);
            if (this.lastSelectedCell === cell) {
                this.lastSelectedCell = null;
            }
        };
        EditorGrid.prototype.resetSelectedCells = function () {
            this.selectedCells.forEach(function (cell) {
                cell.setSelected(false);
            });
            this.lastSelectedCell = null;
            this.selectedCells.length = 0;
        };
        EditorGrid.prototype.addInitialRows = function () {
            this.cells = [];
            _.times(this.initialRows, this.addRow.bind(this));
        };
        EditorGrid.prototype.addRow = function () {
            this.addRowOfCells(this._rows);
            this.addRowLabel(this._rows);
            this.addRemoveRowButton(this._rows);
            this._rows++;
            this.emit(EditorGridEvent.ADD_ROW, this, this._rows);
        };
        EditorGrid.prototype.addRowOfCells = function (rowNumber) {
            var _this = this;
            _.times(this._columns, function (index) {
                _this.addCell(index, rowNumber);
            });
        };
        EditorGrid.prototype.addCell = function (column, row) {
            var cell = new game.EditorCell(this.scene, "editor", "cell", column, row);
            cell.x = EditorGrid.CELL_SIZE / 2 + column * EditorGrid.CELL_SIZE;
            cell.y = -EditorGrid.CELL_SIZE / 2 - row * EditorGrid.CELL_SIZE;
            cell.alpha = 0.2;
            cell.originalAlpha = cell.alpha;
            this.cells.push(cell);
            this.add(cell);
            return cell;
        };
        EditorGrid.prototype.addVisibleRowsSeparator = function () {
            var y = -game.GameGrid.ROWS * game.GameGrid.CELL_SIZE;
            var line = this.scene.add.line(this.getWidth() / 2, 0, 0, y, this.getWidth(), y, 0xffffff);
            line.setLineWidth(6);
            this.addAt(line, 0);
        };
        EditorGrid.prototype.addColumnLabels = function () {
            var _this = this;
            _.times(this._columns, function (column) {
                var content = column.toString();
                var label = _this.scene.add.bitmapText(0, 0, game.BitmapGameFont.EDITOR_ROW_NUMBERS, content, 28, Phaser.RIGHT);
                label.x = column * EditorGrid.CELL_SIZE + EditorGrid.CELL_SIZE / 2;
                label.y = 20;
                label.setData("column", column);
                _this.add(label);
                label.setInteractive();
                label.input.cursor = "pointer";
                label.setData("type", "column_label");
                return label;
            });
        };
        EditorGrid.prototype.addRowLabel = function (rowNumber) {
            var content = rowNumber.toString();
            var label = this.scene.add.bitmapText(0, 0, game.BitmapGameFont.EDITOR_ROW_NUMBERS, content, 28, Phaser.RIGHT);
            label.setOrigin(1, 0.5);
            label.x = -16;
            label.y = -rowNumber * EditorGrid.CELL_SIZE - EditorGrid.CELL_SIZE / 2 + 4;
            label.setData("row", rowNumber);
            this.add(label);
            this.rowLabels.push(label);
            label.setInteractive();
            label.input.cursor = "pointer";
            label.setData("type", "row_label");
            return label;
        };
        EditorGrid.prototype.addRemoveRowButton = function (rowNumber) {
            var button = this.scene.add.button("editor", "remove_row_button", this);
            button.on(Phaser.GameObjects.ButtonEvent.RELEASE, this.onRemoveRowButtonClick, this);
            button.setData("row", rowNumber);
            button.x = this.getWidth() + button.displayWidth / 2 + 10;
            button.y = -rowNumber * EditorGrid.CELL_SIZE - EditorGrid.CELL_SIZE / 2;
            this.removeRowButtons.push(button);
        };
        EditorGrid.prototype.onRemoveRowButtonClick = function (button) {
            if (this._rows <= game.GameGrid.ROWS) {
                console.warn("Should be at least " + game.GameGrid.ROWS + " rows!");
                return;
            }
            var rowNumber = button.getData("row");
            this.removeRow(rowNumber);
        };
        EditorGrid.prototype.removeRow = function (rowNumber) {
            this.removeCellsByRow(rowNumber);
            this.removeRowLabel(rowNumber);
            this.removeRemoveRowButton(rowNumber);
            this.updateRowsAbove(rowNumber);
            this._rows--;
            this.alignAddRowButton();
            this.emit(EditorGridEvent.REMOVE_ROW, rowNumber);
        };
        EditorGrid.prototype.removeCellsByRow = function (rowNumber) {
            var cellsToRemove = this.cells.filter(function (cell) { return cell.row === rowNumber; });
            cellsToRemove.forEach(function (cell) { return cell.destroy(); });
            _.pull.apply(_, __spreadArrays([this.cells], cellsToRemove));
        };
        EditorGrid.prototype.removeRowLabel = function (rowNumber) {
            var indexToRemove = this.rowLabels.findIndex(function (label) { return label.getData("row") === rowNumber; });
            if (indexToRemove === -1) {
                return;
            }
            this.rowLabels[indexToRemove].destroy();
            this.rowLabels.splice(indexToRemove, 1);
        };
        EditorGrid.prototype.removeRemoveRowButton = function (rowNumber) {
            var indexToRemove = this.removeRowButtons.findIndex(function (button) { return button.getData("row") === rowNumber; });
            if (indexToRemove === -1) {
                return;
            }
            this.removeRowButtons[indexToRemove].destroy();
            this.removeRowButtons.splice(indexToRemove, 1);
        };
        EditorGrid.prototype.addAddRowButton = function () {
            this.addRowButton = this.scene.add.button("editor", "add_row_button", this);
            this.addRowButton.on(Phaser.GameObjects.ButtonEvent.RELEASE, this.onAddRowClick, this);
            this.alignAddRowButton();
        };
        EditorGrid.prototype.alignAddRowButton = function () {
            this.addRowButton.x = this.getWidth() / 2;
            this.addRowButton.y = -EditorGrid.CELL_SIZE / 2 - this._rows * EditorGrid.CELL_SIZE;
        };
        EditorGrid.prototype.onAddRowClick = function () {
            var rowsToAdd = this.editor.shiftKey.isDown ? 5 : 1;
            for (var i = 0; i < rowsToAdd; i++) {
                this.addRow();
                this.alignAddRowButton();
            }
        };
        EditorGrid.prototype.getWidth = function () {
            return this._columns * EditorGrid.CELL_SIZE;
        };
        EditorGrid.prototype.getHeight = function () {
            return this._rows * EditorGrid.CELL_SIZE;
        };
        EditorGrid.prototype.getDisplayWidth = function () {
            return this.initialColumns * EditorGrid.CELL_SIZE;
        };
        EditorGrid.prototype.getCellAt = function (row, column) {
            return this.cells.find(function (cell) { return cell.row === row && cell.column === column; });
        };
        EditorGrid.prototype.getCellAtXY = function (x, y) {
            var row = Math.floor(y / EditorGrid.CELL_SIZE);
            var column = Math.floor(x / EditorGrid.CELL_SIZE);
            return this.getCellAt(row, column);
        };
        EditorGrid.prototype.getRandomColumns = function (num) {
            var allColumns = _.times(this._columns);
            return Phaser.Math.RND.shuffle(allColumns).slice(0, num);
        };
        EditorGrid.prototype.updateRowsAbove = function (rowNumber) {
            var _this = this;
            this.cells
                .filter(function (cell) { return cell.row > rowNumber; })
                .forEach(function (cell) {
                cell.row--;
                cell.y = _this.getYByRow(cell.row);
            });
            this.rowLabels
                .filter(function (label) { return label.getData("row") > rowNumber; })
                .forEach(function (label) {
                var newRow = label.getData("row") - 1;
                label.setData("row", newRow);
                label.y = _this.getYByRow(newRow);
                label.text = newRow.toString();
            });
            this.removeRowButtons
                .filter(function (button) { return button.getData("row") > rowNumber; })
                .forEach(function (button) {
                var newRow = button.getData("row") - 1;
                button.setData("row", newRow);
                button.y = _this.getYByRow(newRow);
            });
        };
        EditorGrid.prototype.getYByRow = function (row) {
            return -EditorGrid.CELL_SIZE / 2 - row * EditorGrid.CELL_SIZE;
        };
        EditorGrid.prototype.addSelectedRow = function (rowNumber) {
            var _this = this;
            this.cells.filter(function (cell) { return cell.row === rowNumber; }).forEach(function (cell) { return _this.addSelectedCell(cell); });
        };
        EditorGrid.prototype.hasRow = function (rowNumber) {
            return this.cells.some(function (cell) { return cell.row === rowNumber; });
        };
        EditorGrid.CELL_SIZE = 100;
        return EditorGrid;
    }(Phaser.GameObjects.Container));
    game.EditorGrid = EditorGrid;
})(game || (game = {}));
var game;
(function (game) {
    var ItemIconsGrid = /** @class */ (function (_super) {
        __extends(ItemIconsGrid, _super);
        function ItemIconsGrid(scene) {
            var _this = _super.call(this, scene) || this;
            _this.itemTypes = game.ItemTypeUtil.getAllTypes();
            _this.cellSize = 120;
            _this.name = "item_icons";
            _this.addIcons();
            _this.alignIcons();
            return _this;
        }
        ItemIconsGrid.prototype.addIcons = function () {
            var _this = this;
            this.icons = this.itemTypes.map(function (itemType) {
                var frame = game.ItemTypeUtil.getFrameName(itemType);
                var icon = _this.scene.add.image(0, 0, "editor", frame);
                icon.setData("type", "add_item_icon");
                icon.setData(game.ITEM_TYPE, itemType);
                icon.setInteractive();
                icon.on(Phaser.Input.Events.GAMEOBJECT_POINTER_OVER, _this.onPointerOver.bind(_this, icon));
                icon.on(Phaser.Input.Events.GAMEOBJECT_POINTER_OUT, _this.onPointerOut.bind(_this, icon));
                icon.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, _this.onPointerDown.bind(_this, icon));
                return icon;
            });
            this.add(this.icons);
        };
        ItemIconsGrid.prototype.alignIcons = function () {
            Phaser.Actions.GridAlign(this.icons, {
                width: 5,
                position: Phaser.Display.Align.CENTER,
                cellWidth: this.cellSize,
                cellHeight: this.cellSize,
                x: this.cellSize / 2,
                y: this.cellSize / 2,
            });
        };
        ItemIconsGrid.prototype.onPointerOver = function (icon) {
            icon.scale = 1.1;
        };
        ItemIconsGrid.prototype.onPointerOut = function (icon) {
            icon.scale = 1;
        };
        ItemIconsGrid.prototype.onPointerDown = function (icon) { };
        ItemIconsGrid.prototype.updateEnabledItems = function (allowedTypes) {
            this.icons.forEach(function (icon) {
                var isTypeAllowed = allowedTypes.includes(icon.getData(game.ITEM_TYPE));
                icon.visible = isTypeAllowed;
            });
            this.icons = Phaser.Utils.Array.StableSort(this.icons, this.sortByVisible.bind(this));
            this.alignIcons();
            this.emit("resize");
        };
        ItemIconsGrid.prototype.sortByVisible = function (a, b) {
            var an = a.visible ? 1 : 0;
            var bn = b.visible ? 1 : 0;
            return bn - an;
        };
        ItemIconsGrid.prototype.getRealBounds = function () {
            var visibleIcons = this.icons.filter(function (icon) { return icon.visible; });
            if (visibleIcons.length === 0) {
                return { width: 0, height: 0 };
            }
            var leftIcon = _.minBy(visibleIcons, "x");
            var rightIcon = _.maxBy(visibleIcons, "x");
            var topIcon = _.minBy(visibleIcons, "y");
            var bottomIcon = _.maxBy(visibleIcons, "y");
            var left = leftIcon.x - this.cellSize / 2;
            var right = rightIcon.x + this.cellSize / 2;
            var top = topIcon.y - this.cellSize / 2;
            var bottom = bottomIcon.y + this.cellSize / 2;
            return {
                width: right - left,
                height: bottom - top,
            };
        };
        return ItemIconsGrid;
    }(Phaser.GameObjects.Container));
    game.ItemIconsGrid = ItemIconsGrid;
})(game || (game = {}));
///<reference path='ItemIconsGrid.ts' />
var game;
(function (game) {
    var AddItemPanel = /** @class */ (function (_super) {
        __extends(AddItemPanel, _super);
        function AddItemPanel(scene) {
            var _this = _super.call(this, scene) || this;
            _this.name = "add_block_panel";
            _this.addBack();
            _this.addIcons();
            _this.alignIcons();
            return _this;
        }
        AddItemPanel.prototype.addBack = function () {
            this.back = this.scene.add.image(0, 0, "editor", "add_block_back");
            this.back.setOrigin(0.5, 1);
            this.add(this.back);
        };
        AddItemPanel.prototype.addIcons = function () {
            this.icons = new game.ItemIconsGrid(this.scene);
            this.icons.on("resize", this.alignIcons, this);
            this.add(this.icons);
        };
        AddItemPanel.prototype.alignIcons = function () {
            this.icons.setScale(1);
            var iconsBounds = this.icons.getRealBounds();
            var iconsWidth = iconsBounds.width;
            var iconsHeight = iconsBounds.height;
            var backHeigth = 270;
            var maxWidth = this.back.width * 0.9;
            var maxHeight = backHeigth * 0.9;
            var scaleX = maxWidth / iconsWidth;
            var scaleY = maxHeight / iconsHeight;
            this.icons.scale = Math.min(1, scaleX, scaleY);
            var topLeft = this.back.getTopLeft();
            this.icons.x = topLeft.x + (this.back.width - iconsWidth * this.icons.scale) / 2;
            this.icons.y = topLeft.y + (backHeigth - iconsHeight * this.icons.scale) / 2;
        };
        AddItemPanel.prototype.revive = function () {
            this.visible = true;
            this.active = true;
        };
        AddItemPanel.prototype.kill = function () {
            this.visible = false;
            this.active = false;
        };
        AddItemPanel.prototype.show = function () {
            this.revive();
            this.alpha = 0;
            this.scale = 0.75;
            this.scene.tweens.killTweensOf(this);
            this.scene.tweens.add({
                targets: this,
                duration: 200,
                ease: Phaser.Math.Easing.Cubic.Out,
                scale: 1,
                alpha: 1,
            });
        };
        AddItemPanel.prototype.hide = function () {
            this.kill();
        };
        AddItemPanel.prototype.updateIcons = function (allowedTypes) {
            this.icons.updateEnabledItems(allowedTypes);
        };
        return AddItemPanel;
    }(Phaser.GameObjects.Container));
    game.AddItemPanel = AddItemPanel;
})(game || (game = {}));
var game;
(function (game) {
    var EditorItemParam;
    (function (EditorItemParam) {
        EditorItemParam["HEALTH"] = "health";
        EditorItemParam["FRAME"] = "frame";
    })(EditorItemParam = game.EditorItemParam || (game.EditorItemParam = {}));
    var EditorItemEvent;
    (function (EditorItemEvent) {
        EditorItemEvent["SELECTED"] = "selected";
        EditorItemEvent["DESELECTED"] = "deselected";
        EditorItemEvent["PARAMS_CHANGED"] = "params_changed";
    })(EditorItemEvent = game.EditorItemEvent || (game.EditorItemEvent = {}));
    var EditorItem = /** @class */ (function (_super) {
        __extends(EditorItem, _super);
        function EditorItem(scene, atlas, itemType) {
            var _this = _super.call(this, scene, 0, 0, atlas, game.ItemTypeUtil.getFrameName(itemType)) || this;
            _this._isSelected = false;
            _this.manuallyAdded = false;
            _this.params = {};
            _this.itemType = itemType;
            _this.setData("type", "item");
            _this.setInteractive();
            _this.on(Phaser.Input.Events.GAMEOBJECT_POINTER_OVER, _this.onPointerOver, _this);
            _this.on(Phaser.Input.Events.GAMEOBJECT_POINTER_OUT, _this.onPointerOut, _this);
            return _this;
        }
        Object.defineProperty(EditorItem.prototype, "isSelected", {
            get: function () {
                return this._isSelected;
            },
            enumerable: false,
            configurable: true
        });
        EditorItem.prototype.loadParams = function (params) {
            var _this = this;
            Object.keys(params).forEach(function (key) {
                _this.updateParams(key, params[key]);
            });
        };
        EditorItem.prototype.updateParams = function (key, value) {
            this.params[key] = value;
            if (key === EditorItemParam.FRAME) {
                this.setFrame(value);
            }
            this.emit(EditorItemEvent.PARAMS_CHANGED, this, key, value);
        };
        EditorItem.prototype.onPointerOver = function () {
            this.scene.tweens.killTweensOf(this);
            this.scene.tweens.add({
                targets: this,
                duration: 100,
                ease: Phaser.Math.Easing.Cubic.Out,
                scale: 1.2,
            });
            this.parentContainer.bringToTop(this);
        };
        EditorItem.prototype.onPointerOut = function () {
            this.scene.tweens.killTweensOf(this);
            this.scene.tweens.add({
                targets: this,
                duration: 100,
                ease: Phaser.Math.Easing.Cubic.Out,
                scale: 1,
            });
        };
        EditorItem.prototype.setSelected = function (value) {
            if (this._isSelected === value) {
                return;
            }
            this._isSelected = value;
            if (this._isSelected) {
                this.emit(EditorItemEvent.SELECTED, this);
            }
            else {
                this.emit(EditorItemEvent.DESELECTED, this);
            }
        };
        EditorItem.prototype.getConfig = function () {
            var params = __assign(__assign({}, this.params), (this.itemType === game.ItemType.TRIANGLE && { frame: this.frame.name }));
            return __assign(__assign({}, (this.manuallyAdded && { manuallyAdded: true })), { column: this.column, row: this.row, type: this.itemType, params: params });
        };
        EditorItem.prototype.destroy = function (fromScene) {
            _super.prototype.destroy.call(this, fromScene);
        };
        return EditorItem;
    }(Phaser.GameObjects.Image));
    game.EditorItem = EditorItem;
})(game || (game = {}));
var game;
(function (game) {
    var EditorItemLivesCounter = /** @class */ (function (_super) {
        __extends(EditorItemLivesCounter, _super);
        function EditorItemLivesCounter(scene, item, blockOffset) {
            var _this = _super.call(this, scene, 0, 0, game.BitmapGameFont.EDITOR_BLOCK_LIVES, item.params[game.EditorItemParam.HEALTH] || "0", 28) || this;
            _this.setOrigin(0.5, 0.5);
            _this.blockOffset = blockOffset;
            _this.block = item;
            _this.block.on(game.EditorItemEvent.PARAMS_CHANGED, _this.onItemParamsChanged, _this);
            _this.block.on(Phaser.GameObjects.Events.DESTROY, _this.onBlockDestroy, _this);
            _this.scene.events.on("postupdate", _this.followBlock, _this);
            return _this;
        }
        EditorItemLivesCounter.prototype.onItemParamsChanged = function (item, key, value) {
            if (key === game.EditorItemParam.HEALTH) {
                this.setText(value.toString());
            }
        };
        EditorItemLivesCounter.prototype.onBlockDestroy = function () {
            this.destroy();
        };
        EditorItemLivesCounter.prototype.followBlock = function () {
            if (this.visible === false) {
                return;
            }
            this.x = this.block.x + this.blockOffset.x;
            this.y = this.block.y + this.blockOffset.y;
        };
        EditorItemLivesCounter.prototype.destroy = function (fromScene) {
            if (this.scene) {
                this.scene.events.on("postupdate", this.followBlock, this);
            }
            _super.prototype.destroy.call(this, fromScene);
        };
        return EditorItemLivesCounter;
    }(Phaser.GameObjects.BitmapText));
    game.EditorItemLivesCounter = EditorItemLivesCounter;
})(game || (game = {}));
var game;
(function (game) {
    var EditorItemCopy = /** @class */ (function (_super) {
        __extends(EditorItemCopy, _super);
        function EditorItemCopy(scene, originalItem) {
            var _this = _super.call(this, scene, 0, 0, originalItem.texture.key, originalItem.frame.name) || this;
            _this.setTintFill(0xffffff);
            _this.setAlpha(0.5);
            _this.hide();
            _this.originalItem = originalItem;
            _this.originalItem.on(game.EditorItemEvent.SELECTED, _this.show, _this);
            _this.originalItem.on(game.EditorItemEvent.DESELECTED, _this.hide, _this);
            _this.originalItem.on(game.EditorItemEvent.PARAMS_CHANGED, _this.onItemParamChanged, _this);
            _this.originalItem.on(Phaser.Input.Events.GAMEOBJECT_POINTER_OVER, _this.onOriginalItemPointerOver, _this);
            _this.originalItem.on(Phaser.GameObjects.Events.DESTROY, function () {
                _this.destroy(false);
            });
            _this.scene.events.on("postupdate", _this.followOriginalItem, _this);
            return _this;
        }
        EditorItemCopy.prototype.onItemParamChanged = function (item, param, value) {
            if (param === game.EditorItemParam.FRAME) {
                this.setFrame(value);
            }
        };
        EditorItemCopy.prototype.show = function () {
            this.visible = true;
            this.alpha = 0;
            this.scene.tweens.killTweensOf(this);
            this.scene.tweens.add({
                targets: this,
                duration: 100,
                ease: Phaser.Math.Easing.Cubic.Out,
                alpha: 0.5,
            });
        };
        EditorItemCopy.prototype.hide = function () {
            this.visible = false;
        };
        EditorItemCopy.prototype.onOriginalItemPointerOver = function () {
            this.parentContainer.bringToTop(this);
        };
        EditorItemCopy.prototype.followOriginalItem = function () {
            if (this.visible === false) {
                return;
            }
            this.x = this.originalItem.x;
            this.y = this.originalItem.y;
            this.scale = this.originalItem.scale;
        };
        EditorItemCopy.prototype.destroy = function (fromScene) {
            if (this.scene) {
                this.scene.events.off("postupdate", this.followOriginalItem, this);
            }
            _super.prototype.destroy.call(this, fromScene);
        };
        return EditorItemCopy;
    }(Phaser.GameObjects.Image));
    game.EditorItemCopy = EditorItemCopy;
})(game || (game = {}));
var game;
(function (game) {
    var EditorPanel = /** @class */ (function () {
        function EditorPanel(scene, title) {
            this.scene = scene;
            this.events = new Phaser.Events.EventEmitter();
            this.panel = new Tweakpane({ title: title, container: document.getElementById("editor-panels") });
        }
        EditorPanel.prototype.disableInput = function () {
            this.panel.containerElem_.classList.add("disable-panel-input");
        };
        EditorPanel.prototype.enableInput = function () {
            this.panel.containerElem_.classList.remove("disable-panel-input");
        };
        EditorPanel.prototype.refresh = function () {
            this.panel.refresh();
        };
        EditorPanel.prototype.destroy = function () {
            this.panel.dispose();
        };
        return EditorPanel;
    }());
    game.EditorPanel = EditorPanel;
})(game || (game = {}));
var game;
(function (game) {
    var LevelConfigPanelEvent;
    (function (LevelConfigPanelEvent) {
        LevelConfigPanelEvent["AUTO_THROW_CHANGE"] = "AUTO_THROW_CHANGE";
    })(LevelConfigPanelEvent = game.LevelConfigPanelEvent || (game.LevelConfigPanelEvent = {}));
    var LevelConfigPanel = /** @class */ (function (_super) {
        __extends(LevelConfigPanel, _super);
        function LevelConfigPanel(scene, levelConfig) {
            var _this = _super.call(this, scene, "Level " + levelConfig.levelNumber) || this;
            _this.levelConfig = levelConfig;
            _this.panel.addInput(_this.levelConfig, "balls", { step: 1 });
            _this.bgInput = _this.panel.addInput(_this.levelConfig, "background", { options: _this.getBackgrounds() });
            _this.addAutoThrowFolder();
            _this.addGiftsFolder();
            _this.addButtons();
            return _this;
        }
        LevelConfigPanel.prototype.getBackgrounds = function () {
            return [
                { text: "green", value: "background_1" },
                { text: "pink", value: "background_2" },
                { text: "night", value: "background_3" },
            ];
        };
        LevelConfigPanel.prototype.addAutoThrowFolder = function () {
            var autoThrowFolder = this.panel.addFolder({
                title: "Auto throw",
            });
            autoThrowFolder.addInput(this.levelConfig.autoThrow, "enabled").on("change", this.onAutoThrowChange.bind(this));
            autoThrowFolder.addInput(this.levelConfig.autoThrow, "fastForward");
            autoThrowFolder.addInput(this.levelConfig.autoThrow, "snapping");
            autoThrowFolder.addInput(this.levelConfig.autoThrow, "delay", { min: 0, max: 1000, step: 50 });
        };
        LevelConfigPanel.prototype.onAutoThrowChange = function (value) {
            this.events.emit(LevelConfigPanelEvent.AUTO_THROW_CHANGE, value);
        };
        LevelConfigPanel.prototype.addGiftsFolder = function () {
            var giftsFolder = this.panel.addFolder({
                title: "Gifts",
            });
            if (!this.levelConfig.gift) {
                this.levelConfig.gift = this.createDefaultGiftConfig();
            }
            var giftConfig = this.levelConfig.gift;
            Object.keys(giftConfig).forEach(function (boosterType) {
                giftsFolder.addInput(giftConfig, boosterType, { min: 0, max: 10, step: 1 });
            });
        };
        LevelConfigPanel.prototype.createDefaultGiftConfig = function () {
            var _a;
            return _a = {},
                _a[game.BoosterType.BOMB] = 0,
                _a[game.BoosterType.CRACKER] = 0,
                _a[game.BoosterType.STOP] = 0,
                _a;
        };
        LevelConfigPanel.prototype.addButtons = function () {
            this.tutorialButton = this.panel.addButton({ title: "Tutorial" });
            this.removeButton = this.panel.addButton({ title: "Remove" });
            this.playButton = this.panel.addButton({ title: "Play" });
        };
        return LevelConfigPanel;
    }(game.EditorPanel));
    game.LevelConfigPanel = LevelConfigPanel;
})(game || (game = {}));
var game;
(function (game) {
    var LevelGeneratorPanelEvent;
    (function (LevelGeneratorPanelEvent) {
        LevelGeneratorPanelEvent["ITEM_TYPE_CHANGE"] = "item_type_change";
        LevelGeneratorPanelEvent["CLEAR"] = "clear";
        LevelGeneratorPanelEvent["GENERATE"] = "generate";
    })(LevelGeneratorPanelEvent = game.LevelGeneratorPanelEvent || (game.LevelGeneratorPanelEvent = {}));
    var LevelGeneratorPanel = /** @class */ (function (_super) {
        __extends(LevelGeneratorPanel, _super);
        function LevelGeneratorPanel(scene, generatorConfig) {
            var _this = _super.call(this, scene, "Generator") || this;
            _this.generator = generatorConfig;
            _this.panel.addInput(_this.generator, "general", { step: 1, min: 1, max: 100 });
            _this.panel.addInput(_this.generator, "sides", { step: 1, min: 0, max: 100 });
            _this.panel.addInput(_this.generator, "startRow", { step: 1, min: 2, max: 20 });
            _this.panel.addInput(_this.generator, "targetItemType", { options: _this.getTargetItemTypes() }).on("change", _this.onTargetItemTypeChanged.bind(_this));
            _this.panel.addInput(_this.generator, "targetItemsNum", { step: 1 });
            _this.addSeedControls();
            _this.addHealthFolder();
            _this.addItemTypesFolder();
            _this.addWeightsFolder();
            _this.addButtons();
            return _this;
        }
        LevelGeneratorPanel.prototype.addHealthFolder = function () {
            var healthFolder = this.panel.addFolder({
                title: "Health",
                expanded: true,
            });
            healthFolder.addInput(this.generator, "minHealth", { step: 1, label: "min" }).on("change", this.onMinHealthChange.bind(this));
            healthFolder.addInput(this.generator, "maxHealth", { step: 1, label: "max" }).on("change", this.onMaxHealthChange.bind(this));
            healthFolder.addInput(this.generator, "incrementHealth", { step: 0.05, min: 0.1, max: 1, label: "increment" });
            healthFolder.addInput(this.generator, "deltaHealth", { step: 1, min: 0, max: 10, label: "delta" });
        };
        LevelGeneratorPanel.prototype.onMinHealthChange = function (newValue) {
            this.generator.minHealth = Math.min(newValue, this.generator.maxHealth);
            this.panel.refresh();
        };
        LevelGeneratorPanel.prototype.onMaxHealthChange = function (newValue) {
            this.generator.maxHealth = Math.max(newValue, this.generator.minHealth);
            this.panel.refresh();
        };
        LevelGeneratorPanel.prototype.onTargetItemTypeChanged = function (itemType) {
            this.generator.itemTypes[itemType] = true;
            this.panel.refresh();
        };
        LevelGeneratorPanel.prototype.addSeedControls = function () {
            this.panel.addInput(this.generator, "seed");
            this.panel.addButton({ title: "New seed" }).on("click", this.onSeedButtonClick.bind(this));
        };
        LevelGeneratorPanel.prototype.onSeedButtonClick = function () {
            this.generator.seed = this.getNewSeed();
            this.panel.refresh();
        };
        LevelGeneratorPanel.prototype.getNewSeed = function () {
            return _.shuffle(Date.now().toString().split("")).join("");
        };
        LevelGeneratorPanel.prototype.getTargetItemTypes = function () {
            var typesToRemove = [game.ItemType.SHATTER_BLOCK_PIECE];
            var blockTypes = game.ItemTypeUtil.getBlockTypes();
            var keys = _.without.apply(_, __spreadArrays([blockTypes], typesToRemove));
            var values = __spreadArrays(keys);
            return _.zipObject(keys, values);
        };
        LevelGeneratorPanel.prototype.addItemTypesFolder = function () {
            var _this = this;
            var itemsFolder = this.panel.addFolder({
                title: "Item types",
                expanded: true,
            });
            Object.keys(this.generator.itemTypes)
                .sort(this.sortItemTypes.bind(this))
                .forEach(function (key) {
                itemsFolder.addInput(_this.generator.itemTypes, key).on("change", _this.onItemTypeChange.bind(_this, key));
            });
            this.selectAllButton = itemsFolder.addButton({ title: "Select all" });
            this.selectAllButton.on("click", this.onSelectAllButtonClick.bind(this));
            this.deselectAllButton = itemsFolder.addButton({ title: "Deselect all" });
            this.deselectAllButton.on("click", this.onDeselectAllButtonClick.bind(this));
        };
        LevelGeneratorPanel.prototype.sortItemTypes = function (type_1, type_2) {
            var block_1 = game.ItemTypeUtil.isBlockType(type_1);
            var block_2 = game.ItemTypeUtil.isBlockType(type_2);
            if (block_1 && block_2 === false) {
                return -1;
            }
            if (block_1 === false && block_2) {
                return 1;
            }
            if (block_1 && block_2) {
                return type_1.toString().charCodeAt(0) - type_2.toString().charCodeAt(0);
            }
            return 0;
        };
        LevelGeneratorPanel.prototype.onSelectAllButtonClick = function () {
            this.updateAllItemTypesInConfig(true);
            this.panel.refresh();
        };
        LevelGeneratorPanel.prototype.onDeselectAllButtonClick = function () {
            this.updateAllItemTypesInConfig(false);
            // this.generator.itemTypes[this.generator.targetItemType] = true
            this.panel.refresh();
        };
        LevelGeneratorPanel.prototype.updateAllItemTypesInConfig = function (value) {
            var _this = this;
            Object.keys(this.generator.itemTypes).forEach(function (key) {
                _this.generator.itemTypes[key] = value;
            });
        };
        LevelGeneratorPanel.prototype.onItemTypeChange = function (key, value) {
            this.events.emit(LevelGeneratorPanelEvent.ITEM_TYPE_CHANGE, key, value);
            this.updateWeightsFolder();
        };
        LevelGeneratorPanel.prototype.updateWeightsFolder = function () {
            this.weightsFolder.dispose();
            this.clearButton.dispose();
            this.generateButton.dispose();
            this.addWeightsFolder();
            this.addButtons();
        };
        LevelGeneratorPanel.prototype.addWeightsFolder = function () {
            var _this = this;
            this.weightsFolder = this.panel.addFolder({
                title: "Weights",
            });
            this.getAllowedItemTypes().forEach(function (key) {
                _this.weightsFolder.addInput(_this.generator.weights, key, { step: 1, min: 0, max: 200 });
            });
            this.weightsFolder.addButton({ title: "Reset" }).on("click", this.onResetWeightsClick.bind(this));
        };
        LevelGeneratorPanel.prototype.getAllowedItemTypes = function () {
            var _this = this;
            return Object.keys(this.generator.itemTypes).filter(function (itemType) { return _this.generator.itemTypes[itemType] === true; });
        };
        LevelGeneratorPanel.prototype.onResetWeightsClick = function () {
            var _this = this;
            Object.keys(this.generator.weights).forEach(function (key) {
                _this.generator.weights[key] = 100;
            });
            this.panel.refresh();
        };
        LevelGeneratorPanel.prototype.addButtons = function () {
            var _this = this;
            this.clearButton = this.panel.addButton({ title: "Clear" });
            this.clearButton.on("click", function () {
                _this.events.emit(LevelGeneratorPanelEvent.CLEAR);
            });
            this.generateButton = this.panel.addButton({ title: "Generate" });
            this.generateButton.on("click", function () {
                _this.events.emit(LevelGeneratorPanelEvent.GENERATE);
            });
        };
        return LevelGeneratorPanel;
    }(game.EditorPanel));
    game.LevelGeneratorPanel = LevelGeneratorPanel;
})(game || (game = {}));
var game;
(function (game) {
    var ItemsGenerator = /** @class */ (function () {
        function ItemsGenerator(scene, levelConfig) {
            this.scene = scene;
            this.levelConfig = levelConfig;
            this.rnd = new Phaser.Math.RandomDataGenerator([levelConfig.generator.seed]);
            this.gacha = this.createGacha(this.levelConfig.generator.itemTypes, this.levelConfig.generator.weights, this.rnd);
        }
        ItemsGenerator.prototype.createGacha = function (itemTypes, weights, rnd) {
            var plugin = this.scene.plugins.get("gacha");
            var allowedItemTypes = Object.keys(itemTypes).filter(function (itemType) { return itemTypes[itemType] === true; });
            var allowedWeights = allowedItemTypes.reduce(function (acc, itemType) {
                return (acc[itemType] = weights[itemType]), acc;
            }, {});
            return plugin.add({
                mode: "shuffle",
                rnd: rnd,
                items: __assign({}, allowedWeights),
            });
        };
        ItemsGenerator.prototype.canGenerateItem = function () {
            return this.rnd.between(0, 100) < this.levelConfig.generator.general;
        };
        ItemsGenerator.prototype.canGenerateItemOnSide = function () {
            return this.rnd.between(0, 100) < this.levelConfig.generator.sides;
        };
        ItemsGenerator.prototype.getItemType = function () {
            return this.gacha.next();
        };
        ItemsGenerator.prototype.getItemTypeForPinata = function () {
            var itemType = game.ItemType.PINATA_BLOCK;
            while (itemType === game.ItemType.PINATA_BLOCK) {
                itemType = this.gacha.next();
            }
            return itemType;
        };
        ItemsGenerator.prototype.getItemParams = function (itemType, startRow, currentRow) {
            var params = {};
            var isBlock = game.ItemTypeUtil.isBlockType(itemType);
            if (isBlock) {
                params[game.EditorItemParam.HEALTH] = ItemsGenerator.getBlockHealth(currentRow, startRow, this.rnd, this.levelConfig.generator);
            }
            var isTriangle = itemType === game.ItemType.TRIANGLE;
            if (isTriangle) {
                var frames_1 = [1, 2, 3, 4].map(function (num) { return game.TriangleBlock.getFrame(num); });
                var frame = this.rnd.pick(frames_1);
                params[game.EditorItemParam.FRAME] = frame;
            }
            return params;
        };
        ItemsGenerator.getBlockHealth = function (currentRow, startRow, rnd, generator) {
            var minHealth = generator.minHealth;
            var maxHealth = generator.maxHealth;
            var increment = generator.incrementHealth;
            var baseHealth = minHealth + Math.floor((currentRow - startRow) * increment);
            var delta = generator.deltaHealth * rnd.sign();
            return Phaser.Math.Clamp(baseHealth + delta, minHealth, maxHealth);
        };
        return ItemsGenerator;
    }());
    game.ItemsGenerator = ItemsGenerator;
})(game || (game = {}));
///<reference path='grid/EditorGrid.ts' />
///<reference path='ILevelConfig.ts' />
///<reference path='gui/AddItemPanel.ts' />
///<reference path='items/EditorItem.ts' />
///<reference path='items/EditorItemLivesCounter.ts' />
///<reference path='items/EditorItemCopy.ts' />
///<reference path='panels/EditorPanel.ts' />
///<reference path='panels/LevelConfigPanel.ts' />
///<reference path='panels/LevelGeneratorPanel.ts' />
///<reference path='ItemsGenerator.ts' />
var game;
(function (game) {
    var EditorEvent;
    (function (EditorEvent) {
        EditorEvent["GOTO_TUTORIAL_EDITOR"] = "goto_tutorial_editor";
        EditorEvent["BACKGROUND_CHANGE"] = "background_change";
        EditorEvent["CONFIG_REMOVE"] = "config_remove";
        EditorEvent["TEST_LEVEL"] = "test_level";
        EditorEvent["CHANGE_LEVEL"] = "change_level";
    })(EditorEvent = game.EditorEvent || (game.EditorEvent = {}));
    var Editor = /** @class */ (function (_super) {
        __extends(Editor, _super);
        function Editor() {
            return _super.call(this, {}) || this;
        }
        Editor.prototype.init = function (data) {
            this.events.once("shutdown", this.shutdown, this);
            this.levelConfig = data;
            this.levelNumber = data.levelNumber;
            this.configPanel = null;
            this.generatorPanel = null;
            this.items = [];
        };
        Editor.prototype.create = function () {
            this.addEditorPanels();
            this.addGrid();
            this.addItemsContainer();
            this.addFox();
            this.addLivesCounterLayer();
            this.addCrosshair();
            this.addAddBlockPanel();
            this.onBackgroundChange(this.levelConfig.background);
            this.loadItems();
            this.addPointerCallbacks();
            this.addKeyboardCallbacks();
        };
        Editor.prototype.addEditorPanels = function () {
            this.addConfigPanel();
            this.addGeneratorPanel();
            var zoom = this.game.store.getNumber(game.GameStoreKey.EDITOR_ZOOM);
            this.panelsContainer = document.getElementById("editor-panels");
            this.panelsContainer.style.visibility = "visible";
            this.panelsContainer.style.zoom = zoom.toString();
        };
        Editor.prototype.enablePanels = function () {
            this.configPanel.enableInput();
            this.generatorPanel.enableInput();
        };
        Editor.prototype.disablePanels = function () {
            this.configPanel.disableInput();
            this.generatorPanel.disableInput();
        };
        Editor.prototype.addConfigPanel = function () {
            this.configPanel = new game.LevelConfigPanel(this, this.levelConfig);
            this.configPanel.events.on(game.LevelConfigPanelEvent.AUTO_THROW_CHANGE, this.onAutoThrowChange, this);
            this.configPanel.bgInput.on("change", this.onBackgroundChange.bind(this));
            this.configPanel.tutorialButton.on("click", this.gotoTutorialEditor.bind(this));
            this.configPanel.removeButton.on("click", this.onRemoveButtonClick.bind(this));
            this.configPanel.playButton.on("click", this.testLevel.bind(this));
        };
        Editor.prototype.gotoTutorialEditor = function () {
            this.events.emit(EditorEvent.GOTO_TUTORIAL_EDITOR);
        };
        Editor.prototype.onAutoThrowChange = function (value) {
            this.crosshairContainer.visible = value;
        };
        Editor.prototype.testLevel = function () {
            this.updateLevelConfig();
            this.events.emit(EditorEvent.TEST_LEVEL, {
                levelNumber: this.levelNumber,
                fromEditor: true,
            });
        };
        Editor.prototype.onBackgroundChange = function (newBackground) {
            this.events.emit(EditorEvent.BACKGROUND_CHANGE, newBackground);
        };
        Editor.prototype.onRemoveButtonClick = function () {
            return __awaiter(this, void 0, void 0, function () {
                var isConfirmed;
                var _this = this;
                return __generator(this, function (_a) {
                    isConfirmed = window.confirm("Do you want to remove level " + this.levelNumber + " config?");
                    if (isConfirmed === false) {
                        return [2 /*return*/];
                    }
                    this.disablePanels();
                    this.game.levelConfigs.remove(this.levelNumber);
                    this.game.levelConfigs.saveLocally();
                    this.game.levelConfigs
                        .saveRemotely()
                        .then(function () {
                        console.info("Level " + _this.levelNumber + " config was succesfully removed! \u2714");
                        _this.events.emit(EditorEvent.CONFIG_REMOVE);
                    })
                        .catch(function (xhr) {
                        console.warn("Can't remove level " + _this.levelNumber + " config. Please try again!");
                    })
                        .finally(function () {
                        _this.enablePanels();
                    });
                    return [2 /*return*/];
                });
            });
        };
        Editor.prototype.saveLevelConfigAs = function () {
            var _this = this;
            var existingLevelNumbers = this.game.levelConfigs.getLevelNumbers();
            var suggestedLevelNumber = Math.max.apply(Math, existingLevelNumbers) + 1 || 1;
            var levelNumberStr = prompt("Enter level number", suggestedLevelNumber.toString());
            if (!levelNumberStr) {
                console.warn("Please enter valid level number!", levelNumberStr);
                return;
            }
            var levelNumber = parseInt(levelNumberStr);
            if (!levelNumber) {
                console.warn("Please enter valid level number!", levelNumber);
                return;
            }
            var isLevelExist = existingLevelNumbers.includes(levelNumber);
            if (isLevelExist) {
                console.warn("Level " + levelNumber + " config exists already, please enter another number!");
                return;
            }
            this.gui.saveButton.alpha = 0.5;
            this.gui.saveButton.enabled = false;
            this.disablePanels();
            var newLevelConfig = __assign(__assign({}, this.levelConfig), { levelNumber: levelNumber });
            this.game.levelConfigs.add(newLevelConfig);
            this.game.levelConfigs.saveLocally();
            this.game.levelConfigs
                .saveRemotely()
                .then(function () {
                console.log("Level " + levelNumber + " config was successfully saved!");
                _this.events.emit(EditorEvent.CHANGE_LEVEL, levelNumber);
            })
                .catch(function () {
                console.warn("Can't save level " + levelNumber + " config!");
            });
        };
        Editor.prototype.saveLevelConfig = function () {
            var _this = this;
            var targetBlocksType = this.levelConfig.generator.targetItemType;
            var targetBlocksNum = this.levelConfig.generator.targetItemsNum;
            var actualBlocksNum = this.items.filter(function (item) { return item.itemType === targetBlocksType; }).length;
            if (actualBlocksNum > targetBlocksNum) {
                console.warn("Can't export level! [" + targetBlocksType + ": " + actualBlocksNum + "/" + targetBlocksNum + "]");
                console.warn("Please remove " + (actualBlocksNum - targetBlocksNum) + " " + targetBlocksType.toUpperCase() + "(S).");
                return;
            }
            else if (actualBlocksNum < targetBlocksNum) {
                console.warn("targetBlocksNum was set to " + targetBlocksNum + ", but actually there were only " + actualBlocksNum + " of " + targetBlocksType.toUpperCase() + "S");
                console.warn("But don't you worry - I've fixed targetBlocksNum for you. You are welcome.");
                this.levelConfig.generator.targetItemsNum = actualBlocksNum;
                this.generatorPanel.refresh();
            }
            this.gui.saveButton.alpha = 0.5;
            this.gui.saveButton.enabled = false;
            this.disablePanels();
            this.updateLevelConfig();
            console.log("Uploading level " + this.levelNumber + " config...", _.omit(this.levelConfig, "items"));
            this.game.levelConfigs
                .saveLocally()
                .then(function (success) {
                if (success) {
                    console.log("Local save complete! ✔");
                }
                else {
                    console.log("Local save is not available!");
                }
            })
                .catch(function (xhr) {
                console.warn("Local save failed!");
            });
            this.game.levelConfigs
                .saveRemotely()
                .then(function () {
                console.log("Upload complete! ✔");
            })
                .catch(function (xhr) {
                console.warn("Upload failed!");
            })
                .finally(function () {
                _this.gui.saveButton.alpha = 1;
                _this.gui.saveButton.enabled = true;
                _this.enablePanels();
            });
        };
        Editor.prototype.updateLevelConfig = function () {
            this.levelConfig.autoThrow.x = Phaser.Math.RoundTo(this.crosshair.x, -2);
            this.levelConfig.autoThrow.y = Phaser.Math.RoundTo(this.crosshair.y, -2);
            this.levelConfig.items = this.items.map(function (item) { return item.getConfig(); });
            this.levelConfig.stars = Editor.createStarsConfig(this.levelConfig.levelNumber, this.levelConfig.items);
        };
        Editor.createStarsConfig = function (levelNumber, items) {
            var totalHealth = items.reduce(function (sum, item) {
                var hasHealth = typeof item.params["health"] !== "undefined";
                return hasHealth
                    ? sum + item.params["health"]
                    : sum;
            }, 0);
            if (levelNumber === 1) {
                return Editor.getFirstLevelStars(totalHealth);
            }
            var oneStar = Math.round(totalHealth * 0.7);
            var twoStars = Math.round(totalHealth * 1);
            var threeStars = Math.round(totalHealth * 1.3);
            return [oneStar, twoStars, threeStars];
        };
        Editor.getFirstLevelStars = function (totalHealthPoints) {
            var oneStar = Math.round(totalHealthPoints * 0.33);
            var twoStars = Math.round(totalHealthPoints * 0.66);
            var threeStars = totalHealthPoints;
            return [oneStar, twoStars, threeStars];
        };
        Editor.prototype.addGeneratorPanel = function () {
            this.generatorPanel = new game.LevelGeneratorPanel(this, this.levelConfig.generator);
            this.generatorPanel.events.on(game.LevelGeneratorPanelEvent.ITEM_TYPE_CHANGE, this.onItemTypesChange, this);
            this.generatorPanel.events.on(game.LevelGeneratorPanelEvent.CLEAR, this.clearGeneratedItems, this);
            this.generatorPanel.events.on(game.LevelGeneratorPanelEvent.GENERATE, this.onGenerateButtonClick, this);
        };
        Editor.prototype.clearGeneratedItems = function () {
            this.getItemsToClear().forEach(function (item) { return item.destroy(); });
            this.clearTopEmptyRows();
            this.scrollToHome();
        };
        Editor.prototype.getItemsToClear = function () {
            var clearAll = this.shiftKey.isDown;
            return clearAll
                ? this.items.slice()
                : this.items.filter(function (item) { return !item.manuallyAdded; });
        };
        Editor.prototype.onGenerateButtonClick = function () {
            var areItemTypesSet = Object.values(this.levelConfig.generator.itemTypes).some(function (value) { return value === true; });
            if (areItemTypesSet === false) {
                console.warn("Select some item types!");
                return;
            }
            this.clearGeneratedItems();
            this.generateItems();
        };
        Editor.prototype.clearTopEmptyRows = function () {
            var maxTopRow = game.GameGrid.ROWS - 1;
            var topItem = _.maxBy(this.items, "row");
            var topRow = Math.max(topItem === null || topItem === void 0 ? void 0 : topItem.row, maxTopRow) || maxTopRow;
            var totalRows = this.grid.rows;
            for (var row = totalRows - 1; row > topRow; row--) {
                this.grid.removeRow(row);
            }
        };
        Editor.prototype.generateItems = function () {
            var generatorConfig = this.levelConfig.generator;
            var itemsGenerator = new game.ItemsGenerator(this, this.levelConfig);
            var targetBlocksGenerated = this.items.filter(function (item) { return item.itemType === generatorConfig.targetItemType; }).length;
            if (targetBlocksGenerated === generatorConfig.targetItemsNum) {
                return;
            }
            for (var row = generatorConfig.startRow; row < 1000; row++) {
                var isRowExist = !!this.grid.getCellAt(row, 0);
                if (isRowExist === false) {
                    this.grid.addRow();
                    this.grid.alignAddRowButton();
                }
                for (var column = 0; column < this.grid.columns; column++) {
                    if (this.isCellFree(column, row) === false) {
                        continue;
                    }
                    var generateItem = itemsGenerator.canGenerateItem();
                    if (generateItem === false) {
                        continue;
                    }
                    var itemType = itemsGenerator.getItemType();
                    var isBlock = game.ItemTypeUtil.isBlockType(itemType);
                    var isSideColumn = column === 0 || column === game.GameGrid.COLUMNS - 1;
                    if (isBlock && isSideColumn) {
                        var canGenerateOnSide = itemsGenerator.canGenerateItemOnSide();
                        if (canGenerateOnSide === false) {
                            continue;
                        }
                    }
                    var cell = this.grid.getCellAt(row, column);
                    var params = itemsGenerator.getItemParams(itemType, generatorConfig.startRow, row);
                    this.addItem(itemType, cell, params, true);
                    if (itemType === generatorConfig.targetItemType) {
                        if (++targetBlocksGenerated === generatorConfig.targetItemsNum) {
                            return;
                        }
                    }
                }
            }
        };
        Editor.prototype.onItemTypesChange = function () {
            var allowedTypes = this.getAllowedItemTypes();
            this.addBlockPanel.updateIcons(allowedTypes);
        };
        Editor.prototype.getAllowedItemTypes = function () {
            var _this = this;
            return Object.keys(this.levelConfig.generator.itemTypes).filter(function (key) { return _this.levelConfig.generator.itemTypes[key] === true; });
        };
        Editor.prototype.addGrid = function () {
            var rows = this.getGridRowsFromLevelConfig();
            this.grid = new game.EditorGrid(this, game.GameGrid.COLUMNS, rows);
            this.grid.alpha = 0.66;
            this.grid.on(game.EditorGridEvent.ADD_ROW, this.onAddRow, this);
            this.grid.on(game.EditorGridEvent.REMOVE_ROW, this.onRemoveRow, this);
        };
        Editor.prototype.getGridRowsFromLevelConfig = function () {
            var rows = this.levelConfig.items.map(function (item) { return item.row; });
            var topRow = Math.max.apply(Math, rows);
            return Math.max(game.GameGrid.ROWS, topRow + 1);
        };
        Editor.prototype.onAddRow = function (grid) {
        };
        Editor.prototype.onRemoveRow = function (row) {
            var _this = this;
            var itemsToRemove = this.items.filter(function (item) { return item.row === row; });
            itemsToRemove.forEach(function (item) {
                item.destroy();
                _.pull(_this.items, item);
            });
            var itemsToUpdate = this.items.filter(function (item) { return item.row > row; });
            itemsToUpdate.forEach(function (item) {
                item.row--;
                item.y += game.EditorGrid.CELL_SIZE;
            });
        };
        Editor.prototype.addFox = function () {
            this.fox = this.add.image(0, 0, "editor", "FOX_IDLE0001");
            this.fox.setOrigin(0.45, 0.8);
            this.fox.x = this.grid.getWidth() / 2;
            this.itemsContainer.add(this.fox);
        };
        Editor.prototype.getFoxHandPosition = function () {
            return {
                x: this.fox.x,
                y: this.fox.y - this.fox.height * 0.28,
            };
        };
        Editor.prototype.addItemsContainer = function () {
            this.itemsContainer = this.add.container(0, 0);
            this.itemsContainer.name = "items";
        };
        Editor.prototype.addLivesCounterLayer = function () {
            this.liveCountersContainer = this.add.container(0, 0);
            this.liveCountersContainer.name = "live_counters";
        };
        Editor.prototype.addCrosshair = function () {
            this.crosshairLine = this.add.line(0, 0);
            this.crosshairLine.setStrokeStyle(3, 0xffffff);
            this.crosshairLine.setOrigin(0, 0);
            this.crosshair = this.add.image(0, 0, "editor", "crosshair");
            this.crosshair.name = "crosshair";
            this.crosshair.setInteractive();
            this.crosshair.input.cursor = "pointer";
            this.crosshair.on(Phaser.Input.Events.DRAG_END, this.onCrosshairDragEnd, this);
            this.crosshair.on(Phaser.Input.Events.DRAG, this.onCrosshairDrag, this);
            this.input.setDraggable(this.crosshair);
            var autoThrowConfig = this.levelConfig.autoThrow;
            if (autoThrowConfig.x === 0 && autoThrowConfig.y === 0) {
                this.crosshair.x = this.grid.getWidth() / 2;
                this.crosshair.y = -game.EditorGrid.CELL_SIZE * 2.5;
            }
            else {
                this.crosshair.x = autoThrowConfig.x;
                this.crosshair.y = autoThrowConfig.y;
            }
            this.crosshairContainer = this.add.container(0, 0);
            this.crosshairContainer.name = "crosshair_container";
            this.crosshairContainer.visible = autoThrowConfig.enabled;
            this.crosshairContainer.add(this.crosshairLine);
            this.crosshairContainer.add(this.crosshair);
            this.redrawCrosshairLine();
        };
        Editor.prototype.onCrosshairDrag = function (pointer, dragX, dragY) {
            this.crosshair.x = Phaser.Math.Clamp(dragX, 0, this.grid.getWidth());
            this.crosshair.y = Phaser.Math.Clamp(dragY, -this.grid.getHeight(), this.getFoxHandPosition().y);
            this.redrawCrosshairLine();
        };
        Editor.prototype.redrawCrosshairLine = function () {
            var _a = this.getFoxHandPosition(), startX = _a.x, startY = _a.y;
            this.crosshairLine.setTo(startX, startY, this.crosshair.x, this.crosshair.y);
        };
        Editor.prototype.onCrosshairDragEnd = function () {
            if (this.levelConfig.autoThrow.snapping === false) {
                return;
            }
            var gap = game.EditorGrid.CELL_SIZE / 2;
            this.crosshair.x = Phaser.Math.Snap.To(this.crosshair.x, gap);
            this.crosshair.y = Phaser.Math.Snap.To(this.crosshair.y, gap);
            this.redrawCrosshairLine();
        };
        Editor.prototype.addAddBlockPanel = function () {
            this.addBlockPanel = new game.AddItemPanel(this);
            this.addBlockPanel.x = 300;
            this.addBlockPanel.y = 300;
            this.addBlockPanel.kill();
            this.addBlockPanel.updateIcons(this.getAllowedItemTypes());
            this.add.existing(this.addBlockPanel);
        };
        Editor.prototype.loadItems = function () {
            var _this = this;
            this.levelConfig.items.forEach(function (itemConfig) {
                var cell = _this.grid.getCellAt(itemConfig.row, itemConfig.column);
                var item = _this.addItem(itemConfig.type, cell, itemConfig.params, true);
                item.manuallyAdded = itemConfig.manuallyAdded;
            });
        };
        Editor.prototype.addPointerCallbacks = function () {
            this.input.on(Phaser.Input.Events.POINTER_DOWN, this.onPointerDown, this);
            this.input.on(Phaser.Input.Events.POINTER_WHEEL, this.onPointerWheel, this);
        };
        Editor.prototype.onPointerDown = function (pointer, objects) {
            var cell = objects.find(function (object) { return object.name === "cell"; });
            if (cell) {
                this.onCellClick(cell);
                return;
            }
            var rowLabel = objects.find(function (obj) { return obj.getData("type") === "row_label"; });
            if (rowLabel) {
                this.onRowLabelClick(rowLabel);
                return;
            }
            var itemIcon = objects.find(function (object) { return object.getData("type") === "add_item_icon"; });
            if (itemIcon) {
                this.addItems(itemIcon);
                this.grid.resetSelectedCells();
                this.addBlockPanel.hide();
                return;
            }
            var item = objects.find(function (object) { return object.getData("type") === "item"; });
            if (item) {
                this.onItemClick(item);
                return;
            }
            this.resetSelectedItems();
            this.grid.resetSelectedCells();
            this.addBlockPanel.hide();
        };
        Editor.prototype.onItemClick = function (item) {
            if (item.isSelected) {
                item.setSelected(false);
            }
            else {
                if (this.shiftKey.isDown === false) {
                    this.resetSelectedItems();
                }
                item.setSelected(true);
            }
        };
        Editor.prototype.onRowLabelClick = function (rowLabel) {
            var rowNumber = rowLabel.getData("row");
            if (this.shiftKey.isDown) {
                this.grid.addSelectedRow(rowNumber);
            }
            else {
                this.grid.resetSelectedCells();
                this.grid.addSelectedRow(rowNumber);
            }
        };
        Editor.prototype.onCellClick = function (cell) {
            if (cell.isSelected) {
                this.grid.removeSelectedCell(cell);
                this.addBlockPanel.hide();
            }
            else {
                if (this.shiftKey.isDown === false) {
                    this.grid.resetSelectedCells();
                }
                this.grid.addSelectedCell(cell);
                this.showAddItemPanel(cell);
            }
        };
        Editor.prototype.showAddItemPanel = function (cell) {
            var _a = cell.getWorldPosition(), x = _a.x, y = _a.y;
            this.addBlockPanel.x = x;
            this.addBlockPanel.y = y;
            this.addBlockPanel.show();
        };
        Editor.prototype.resetSelectedItems = function () {
            this.getSelectedItems().forEach(function (item) { return item.setSelected(false); });
        };
        Editor.prototype.addItems = function (itemIcon) {
            var _this = this;
            var newItemType = itemIcon.getData(game.ITEM_TYPE);
            var newItems = this.grid.selectedCells.map(function (cell) {
                var itemParams = _this.createItemParams(newItemType, cell.row);
                var item = _this.addItem(newItemType, cell, itemParams);
                item.manuallyAdded = true;
                return item;
            });
            if (newItemType === this.levelConfig.generator.targetItemType) {
                this.levelConfig.generator.targetItemsNum += newItems.length;
                this.generatorPanel.refresh();
            }
        };
        Editor.prototype.createItemParams = function (itemType, row) {
            var params = {};
            var isBlock = game.ItemTypeUtil.isBlockType(itemType);
            if (isBlock) {
                params[game.EditorItemParam.HEALTH] = game.ItemsGenerator.getBlockHealth(row, this.levelConfig.generator.startRow, Phaser.Math.RND, this.levelConfig.generator);
            }
            return params;
        };
        Editor.prototype.addItem = function (itemType, cell, params, instant) {
            if (params === void 0) { params = {}; }
            if (instant === void 0) { instant = false; }
            if (cell.row < 2) {
                console.warn("First 2 rows should be empty!");
                return;
            }
            var isCellBusy = !!this.getItemAtCell(cell.column, cell.row);
            if (isCellBusy) {
                console.warn("Can't add item at {x: " + cell.column + ", y: " + cell.row + "}. Cell is busy by another item.");
                return;
            }
            var item = new game.EditorItem(this, "editor", itemType);
            item.x = cell.x;
            item.y = cell.y;
            item.column = cell.column;
            item.row = cell.row;
            item.loadParams(params);
            item.on(Phaser.GameObjects.Events.DESTROY, this.onItemDestroy, this);
            this.itemsContainer.add(item);
            this.items.push(item);
            this.addItemCopy(item);
            this.addLiveCounter(item);
            if (instant === false) {
                this.tweens.add({
                    targets: item,
                    duration: 200,
                    ease: Phaser.Math.Easing.Cubic.Out,
                    scale: { from: 0.75, to: 1 },
                    alpha: { from: 0, to: 1 },
                });
            }
            return item;
        };
        Editor.prototype.isCellFree = function (column, row) {
            return !this.getItemAtCell(column, row);
        };
        Editor.prototype.getItemAtCell = function (column, row) {
            return this.items.find(function (item) {
                return item.column === column && item.row === row;
            });
        };
        Editor.prototype.onItemDestroy = function (item) {
            _.pull(this.items, item);
        };
        Editor.prototype.addItemCopy = function (item) {
            var copy = new game.EditorItemCopy(this, item);
            this.itemsContainer.add(copy);
        };
        Editor.prototype.addLiveCounter = function (item) {
            var blocks = game.ItemTypeUtil.getBlockTypes();
            var isBlock = blocks.includes(item.itemType);
            if (isBlock === false) {
                return;
            }
            var offset = { x: -3, y: -item.displayHeight / 2 + 16 };
            var liveCounter = new game.EditorItemLivesCounter(this, item, offset);
            this.liveCountersContainer.add(liveCounter);
        };
        Editor.prototype.onPointerWheel = function (pointer, objects, dx, dy) {
            var block = this.getBlock(objects);
            if (block && block.isSelected) {
                var health = block.params[game.EditorItemParam.HEALTH];
                var deltaHealth = dy > 0 ? -1 : 1;
                var newHealth = Math.max(1, health + deltaHealth);
                block.updateParams(game.EditorItemParam.HEALTH, newHealth);
                return;
            }
            var sign = dy >= 0 ? 1 : -1;
            this.cameras.main.scrollY += game.EditorGrid.CELL_SIZE * sign;
        };
        Editor.prototype.getBlock = function (objects) {
            var item = objects.find(function (object) { return object.getData("type") === "item"; });
            if (!item) {
                return null;
            }
            var isBlock = game.ItemTypeUtil.getBlockTypes().includes(item.itemType);
            if (isBlock === false) {
                return null;
            }
            return item;
        };
        Editor.prototype.addKeyboardCallbacks = function () {
            this.shiftKey = this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.SHIFT);
            this.input.keyboard.on("keydown-S", this.onKeyDownS, this);
            this.input.keyboard.on("keydown-ENTER", this.testLevel, this);
            this.input.keyboard.on("keydown-HOME", this.scrollToHome, this);
            this.input.keyboard.on("keydown-END", this.scrollToEnd, this);
            this.input.keyboard.on("keydown-DELETE", this.removeItems, this);
            this.input.keyboard.on("keydown-UP", this.moveSelectedItems.bind(this, 0, -1));
            this.input.keyboard.on("keydown-RIGHT", this.moveSelectedItems.bind(this, 1, 0));
            this.input.keyboard.on("keydown-DOWN", this.moveSelectedItems.bind(this, 0, 1));
            this.input.keyboard.on("keydown-LEFT", this.moveSelectedItems.bind(this, -1, 0));
            this.input.keyboard.on("keydown-PLUS", this.changeEditorPanelsZoom.bind(this, 1));
            this.input.keyboard.on("keydown-MINUS", this.changeEditorPanelsZoom.bind(this, -1));
            this.input.keyboard.on("keydown-ZERO", this.resetEditorPanelsZoom, this);
            this.input.keyboard.on("keydown-OPEN_BRACKET", this.changeCanvasMargin.bind(this, -1));
            this.input.keyboard.on("keydown-CLOSED_BRACKET", this.changeCanvasMargin.bind(this, 1));
            this.input.keyboard.on("keydown-BACK_SLASH", this.resetCanvasMargin, this);
            this.input.keyboard.on("keydown-ONE", this.updateSelectedItemsFrame.bind(this, 1));
            this.input.keyboard.on("keydown-TWO", this.updateSelectedItemsFrame.bind(this, 2));
            this.input.keyboard.on("keydown-THREE", this.updateSelectedItemsFrame.bind(this, 3));
            this.input.keyboard.on("keydown-FOUR", this.updateSelectedItemsFrame.bind(this, 4));
        };
        Editor.prototype.onKeyDownS = function () {
            if (this.shiftKey.isDown) {
                this.saveLevelConfigAs();
            }
            else {
                this.saveLevelConfig();
            }
        };
        Editor.prototype.updateSelectedItemsFrame = function (frame) {
            this.setSelectedTrianglesFrame(frame);
            this.setSelectedShatterPiecesFrame(frame);
        };
        Editor.prototype.setSelectedTrianglesFrame = function (frameNumber) {
            this.getSelectedTriangles().forEach(function (triangle) {
                var newFrameName = game.TriangleBlock.getFrame(frameNumber);
                triangle.updateParams(game.EditorItemParam.FRAME, newFrameName);
            });
        };
        Editor.prototype.setSelectedShatterPiecesFrame = function (frameNumber) {
            var frame = game.ShatterBlockPiece.getFrame(frameNumber);
            this.getSelectedShatterPieces().forEach(function (piece) { return piece.updateParams(game.EditorItemParam.FRAME, frame); });
        };
        Editor.prototype.getSelectedShatterPieces = function () {
            return this.getSelectedItems().filter(function (item) { return item.itemType === game.ItemType.SHATTER_BLOCK_PIECE; });
        };
        Editor.prototype.getSelectedTriangles = function () {
            return this.getSelectedItems().filter(function (item) { return item.itemType === game.ItemType.TRIANGLE; });
        };
        Editor.prototype.moveSelectedItems = function (deltaColumns, deltaRows) {
            var _this = this;
            var selectedItems = this.getSelectedItems();
            var currentCells = selectedItems.map(function (item) { return _this.grid.getCellAt(item.row, item.column); });
            var newCells = selectedItems.map(function (item) {
                return _this.grid.getCellAt(item.row - deltaRows, item.column + deltaColumns);
            });
            var cellsToCheck = _.without.apply(_, __spreadArrays([newCells], currentCells));
            var cellsAreFree = cellsToCheck.every(function (cell) {
                if (!cell) {
                    return false;
                }
                if (cell.row < 2) {
                    return false;
                }
                var itemInCell = _this.getItemAtCell(cell.column, cell.row);
                return !itemInCell;
            });
            if (cellsAreFree) {
                this.moveItems(selectedItems, deltaColumns, deltaRows);
            }
        };
        Editor.prototype.moveItems = function (items, deltaColumns, deltaRows) {
            items.forEach(function (item) {
                item.row -= deltaRows;
                item.column += deltaColumns;
                item.x += game.EditorGrid.CELL_SIZE * deltaColumns;
                item.y += game.EditorGrid.CELL_SIZE * deltaRows;
            });
        };
        Editor.prototype.removeItems = function () {
            var _this = this;
            var targetItemType = this.levelConfig.generator.targetItemType;
            this.getSelectedItems().forEach(function (item) {
                if (item.itemType === targetItemType) {
                    _this.levelConfig.generator.targetItemsNum--;
                }
                item.destroy();
            });
            this.generatorPanel.refresh();
        };
        Editor.prototype.getSelectedItems = function () {
            return this.items.filter(function (item) { return item.isSelected; });
        };
        Editor.prototype.changeEditorPanelsZoom = function (sign) {
            if (sign === void 0) { sign = 1; }
            var zoom = parseFloat(this.panelsContainer.style.zoom) || 1;
            var newZoom = zoom + Phaser.Math.Sign(sign) * 0.1;
            newZoom = Math.max(0.2, newZoom);
            this.panelsContainer.style.zoom = newZoom.toString();
            this.game.store.saveValue(game.GameStoreKey.EDITOR_ZOOM, newZoom);
        };
        Editor.prototype.resetEditorPanelsZoom = function () {
            var zoom = 1;
            this.panelsContainer.style.zoom = zoom.toString();
            this.game.store.saveValue(game.GameStoreKey.EDITOR_ZOOM, zoom);
        };
        Editor.prototype.changeCanvasMargin = function (sign) {
            var canvasStyle = this.game.canvas.style;
            var marginStr = canvasStyle.marginLeft.slice(0, -2);
            var margin = parseFloat(marginStr);
            var newMargin = margin + 50 * sign;
            canvasStyle.marginLeft = newMargin + "px";
        };
        Editor.prototype.resetCanvasMargin = function () {
            this.scale.updateCenter();
        };
        Editor.prototype.scrollToHome = function () {
            this.cameras.main.scrollY = 0;
        };
        Editor.prototype.scrollToEnd = function () {
            // this.cameras.main.scrollY = -this.grid.getHeight() * this.grid.scale
        };
        Editor.prototype.toggleMatterAutoUpdate = function () {
            this.matter.world.autoUpdate = !this.matter.world.autoUpdate;
            console.log("Matter AutoUpdate is " + (this.matter.world.autoUpdate ? "OFF" : "ON"));
        };
        Editor.prototype.onAnyKeyDown = function () {
            console.log("onAnyKeyDown", arguments);
        };
        Editor.prototype.togglePhysicsDebug = function () {
            if (this.matter.config.debug === false) {
                return;
            }
            this.matter.world.drawDebug = !this.matter.world.drawDebug;
            if (this.matter.world.drawDebug === false) {
                this.matter.world.debugGraphic.clear();
            }
        };
        Editor.prototype.doResize = function () {
            this.alignGrid();
            this.alignItems();
            this.alignLiveCounters();
            this.alignCrosshairContainer();
            this.resizeCamera();
        };
        Editor.prototype.alignGrid = function () {
            var gridDisplayWidth = this.grid.getDisplayWidth();
            var maxWidth = game.Config.GAME_WIDTH * 0.66;
            var scale = maxWidth / gridDisplayWidth;
            this.grid.scale = scale;
            this.grid.x = (game.Config.GAME_WIDTH - this.grid.getDisplayWidth() * scale) / 2;
            this.grid.y = game.Config.GAME_HEIGHT - 80;
        };
        Editor.prototype.alignItems = function () {
            this.itemsContainer.scale = this.grid.scale;
            this.itemsContainer.x = this.grid.x;
            this.itemsContainer.y = this.grid.y;
        };
        Editor.prototype.alignLiveCounters = function () {
            this.liveCountersContainer.scale = this.grid.scale;
            this.liveCountersContainer.x = this.grid.x;
            this.liveCountersContainer.y = this.grid.y;
        };
        Editor.prototype.alignCrosshairContainer = function () {
            this.crosshairContainer.scale = this.grid.scale;
            this.crosshairContainer.x = this.grid.x;
            this.crosshairContainer.y = this.grid.y;
        };
        Editor.prototype.resizeCamera = function () {
            var camera = this.cameras.main;
            camera.setViewport(0, 0, game.Config.GAME_WIDTH, game.Config.GAME_HEIGHT);
        };
        Editor.prototype.onGuiCreated = function () {
        };
        Editor.prototype.update = function (time, delta) {
        };
        Editor.prototype.shutdown = function () {
            this.destroyPanels();
        };
        Editor.prototype.destroyPanels = function () {
            this.panelsContainer.style.visibility = "hidden";
            this.panelsContainer = null;
            if (this.configPanel) {
                this.configPanel.destroy();
            }
            if (this.generatorPanel) {
                this.generatorPanel.destroy();
            }
        };
        return Editor;
    }(Phaser.Scene));
    game.Editor = Editor;
})(game || (game = {}));
var game;
(function (game) {
    var EditorLevelLabel = /** @class */ (function (_super) {
        __extends(EditorLevelLabel, _super);
        function EditorLevelLabel(scene, levelNumber) {
            var _this = _super.call(this, scene) || this;
            _this.buttonsMargin = 12;
            _this.name = "level_label";
            _this.addLabelBack();
            _this.addLabel(levelNumber);
            _this.addPrevLevelButton();
            _this.addNextLevelButton();
            return _this;
        }
        EditorLevelLabel.prototype.addLabelBack = function () {
            this.labelBack = this.scene.add.image(0, 0, "editor", "level_label_back");
            this.add(this.labelBack);
        };
        EditorLevelLabel.prototype.addLabel = function (levelNumber) {
            var content = "LEVEL " + levelNumber;
            var style = {
                fontFamily: game.GameFont.SOUSES,
                fontStyle: game.FontWeight.BLACK,
                fontSize: "36px",
                color: "#ffffff",
                align: "center",
            };
            this.label = this.scene.add.text(0, 0, content, style);
            this.label.setOrigin(0.5, 0.5);
            this.add(this.label);
        };
        EditorLevelLabel.prototype.addPrevLevelButton = function () {
            this.prevLevelButton = this.scene.add.button("editor", "prev_level_button", this);
            this.prevLevelButton.x = this.labelBack.left - this.prevLevelButton.displayWidth / 2 - this.buttonsMargin;
        };
        EditorLevelLabel.prototype.addNextLevelButton = function () {
            this.nextLevelButton = this.scene.add.button("editor", "next_level_button", this);
            this.nextLevelButton.x = this.labelBack.right + this.nextLevelButton.displayWidth / 2 + this.buttonsMargin;
        };
        return EditorLevelLabel;
    }(Phaser.GameObjects.Container));
    game.EditorLevelLabel = EditorLevelLabel;
})(game || (game = {}));
///<reference path='EditorLevelLabel.ts' />
var game;
(function (game) {
    var EditorGui = /** @class */ (function (_super) {
        __extends(EditorGui, _super);
        function EditorGui() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        EditorGui.prototype.init = function (data) {
            this.levelConfig = data.levelConfig;
        };
        EditorGui.prototype.create = function () {
            this.addLevelLabel();
            this.addSaveButton();
        };
        EditorGui.prototype.addLevelLabel = function () {
            this.levelLabel = new game.EditorLevelLabel(this, this.levelConfig.levelNumber);
            this.add.existing(this.levelLabel);
        };
        EditorGui.prototype.addSaveButton = function () {
            this.saveButton = this.add.button("editor", "save_button");
        };
        EditorGui.prototype.doResize = function () {
            this.alignLevelLabel();
            this.alignSaveButton();
        };
        EditorGui.prototype.alignLevelLabel = function () {
            this.levelLabel.scale = 0.66;
            this.levelLabel.x = game.Config.HALF_GAME_WIDTH;
            this.levelLabel.y = this.levelLabel.getBounds().height / 2 + 20;
        };
        EditorGui.prototype.alignSaveButton = function () {
            var margin = 50;
            this.saveButton.x = game.Config.GAME_WIDTH - margin;
            this.saveButton.y = game.Config.GAME_HEIGHT - margin + 4;
        };
        EditorGui.prototype.shutdown = function () {
        };
        return EditorGui;
    }(Phaser.Scene));
    game.EditorGui = EditorGui;
})(game || (game = {}));
///<reference path='Editor.ts' />
///<reference path='gui/EditorGui.ts' />
var game;
(function (game) {
    var ButtonEvent = Phaser.GameObjects.ButtonEvent;
    var EditorRoot = /** @class */ (function (_super) {
        __extends(EditorRoot, _super);
        function EditorRoot() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        EditorRoot.prototype.init = function (data) {
            this.levelNumber = data ? data.levelNumber : 1;
            this.levelConfig = this.getLevelConfig(this.levelNumber);
            console.group("Level Editor - Level " + this.levelNumber);
            this.events.once("shutdown", this.shutdown, this);
            this.editor = null;
            this.editorGui = null;
        };
        EditorRoot.prototype.getLevelConfig = function (levelNumber) {
            var isConfigExist = this.game.levelConfigs.check(levelNumber);
            if (isConfigExist) {
                return this.game.levelConfigs.get(levelNumber);
            }
            return this.game.levelConfigs.create(levelNumber);
        };
        EditorRoot.prototype.create = function () {
            this.addBackground();
            this.addKeyboardCallbacks();
            this.launchEditorScene();
        };
        EditorRoot.prototype.addBackground = function () {
            this.background = this.add.image(0, 0, "editor", this.levelConfig.background);
            this.background.setOrigin(0.5, 1);
        };
        EditorRoot.prototype.addKeyboardCallbacks = function () {
            this.input.keyboard.once("keydown-R", this.restart, this);
            this.input.keyboard.once("keydown-T", this.gotoTutorialEditor, this);
            this.input.keyboard.once("keydown-ESC", this.gotoLevelsMapDev, this);
        };
        EditorRoot.prototype.gotoTutorialEditor = function () {
            this.scene.start(game.SceneKey.TUTORIAL_EDITOR, { levelNumber: this.levelNumber });
        };
        EditorRoot.prototype.restart = function () {
            this.game.changeScene(game.SceneKey.LEVEL_EDITOR_ROOT, game.SceneKey.LEVEL_EDITOR_ROOT, { levelNumber: this.levelNumber });
        };
        EditorRoot.prototype.gotoPrevLevel = function () {
            this.gotoLevel(this.levelNumber - 1);
        };
        EditorRoot.prototype.gotoNextLevel = function () {
            this.gotoLevel(this.levelNumber + 1);
        };
        EditorRoot.prototype.gotoLevel = function (levelNumber) {
            var isLevelExist = this.game.levelConfigs.check(levelNumber);
            if (isLevelExist === false) {
                console.warn("Level " + levelNumber + " doesn't exist!");
                return;
            }
            this.scene.start(game.SceneKey.LEVEL_EDITOR_ROOT, { levelNumber: levelNumber });
        };
        EditorRoot.prototype.gotoLevelsMapDev = function () {
            this.scene.start(game.SceneKey.LEVELS_MAP_DEV);
        };
        EditorRoot.prototype.launchEditorScene = function () {
            this.editor = this.launchScene(game.SceneKey.LEVEL_EDITOR, this.levelConfig);
            this.editor.events.on(Phaser.Scenes.Events.CREATE, this.launchEditorGuiScene, this);
            this.editor.events.on(game.EditorEvent.BACKGROUND_CHANGE, this.onBackgroundChange, this);
            this.editor.events.on(game.EditorEvent.CONFIG_REMOVE, this.gotoLevelsMapDev, this);
            this.editor.events.once(game.EditorEvent.TEST_LEVEL, this.testLevelConfig, this);
            this.editor.events.once(game.EditorEvent.CHANGE_LEVEL, this.gotoLevel, this);
            this.editor.events.once(game.EditorEvent.GOTO_TUTORIAL_EDITOR, this.gotoTutorialEditor, this);
        };
        EditorRoot.prototype.launchEditorGuiScene = function () {
            this.editorGui = this.launchScene(game.SceneKey.LEVEL_EDITOR_GUI, { levelConfig: this.levelConfig });
            this.editorGui.events.on(Phaser.Scenes.Events.CREATE, this.onGuiCreated, this);
        };
        EditorRoot.prototype.onGuiCreated = function () {
            this.editor.gui = this.editorGui;
            this.editor.onGuiCreated();
            this.editorGui.saveButton.on(ButtonEvent.RELEASE, this.onSaveButtonClick, this);
            this.editorGui.levelLabel.nextLevelButton.once(ButtonEvent.PRESS, this.gotoNextLevel, this);
            this.editorGui.levelLabel.prevLevelButton.once(ButtonEvent.PRESS, this.gotoPrevLevel, this);
            this.resize();
        };
        EditorRoot.prototype.onSaveButtonClick = function (button, pointer) {
            if (pointer.event.shiftKey) {
                this.editor.saveLevelConfigAs();
            }
            else {
                this.editor.saveLevelConfig();
            }
        };
        EditorRoot.prototype.onBackgroundChange = function (backgroundFrame) {
            this.background.setFrame(backgroundFrame);
            this.background.setOrigin(0.5, 1);
        };
        EditorRoot.prototype.testLevelConfig = function (data) {
            this.scene.start(game.SceneKey.GAMEPLAY_ROOT, data);
        };
        EditorRoot.prototype.launchScene = function (key, data) {
            return this.scene.launch(key, data).get(key);
        };
        EditorRoot.prototype.resize = function () {
            this.resizeBackground();
            this.editorGui.doResize();
            this.editor.doResize();
        };
        EditorRoot.prototype.resizeBackground = function () {
            this.background.envelop(game.Config.GAME_WIDTH, game.Config.GAME_HEIGHT);
            this.background.x = game.Config.HALF_GAME_WIDTH;
            this.background.y = game.Config.GAME_HEIGHT;
        };
        EditorRoot.prototype.shutdown = function () {
            console.groupEnd();
            if (this.editor) {
                this.scene.stop(this.editor.scene.key);
                this.editor.events.off(Phaser.Scenes.Events.CREATE, this.launchEditorGuiScene, this);
                this.editor.events.off(game.EditorEvent.BACKGROUND_CHANGE, this.onBackgroundChange, this);
                this.editor.events.off(game.EditorEvent.CONFIG_REMOVE, this.gotoLevelsMapDev, this);
                this.editor.events.off(game.EditorEvent.TEST_LEVEL, this.testLevelConfig, this);
                this.editor.events.off(game.EditorEvent.CHANGE_LEVEL, this.gotoLevel, this);
                this.editor.events.off(game.EditorEvent.GOTO_TUTORIAL_EDITOR, this.gotoTutorialEditor, this);
            }
            if (this.editorGui) {
                this.scene.stop(this.editorGui.scene.key);
                this.editorGui.events.off(Phaser.Scenes.Events.CREATE, this.onGuiCreated, this);
            }
        };
        return EditorRoot;
    }(Phaser.Scene));
    game.EditorRoot = EditorRoot;
})(game || (game = {}));
var game;
(function (game) {
    var MapEditorPanelEvent;
    (function (MapEditorPanelEvent) {
    })(MapEditorPanelEvent = game.MapEditorPanelEvent || (game.MapEditorPanelEvent = {}));
    var MapEditorPanel = /** @class */ (function (_super) {
        __extends(MapEditorPanel, _super);
        function MapEditorPanel(scene, levelConfig) {
            var _this = _super.call(this, scene, "Levels Map Config") || this;
            _this.config = levelConfig;
            _this.addButtons();
            return _this;
        }
        MapEditorPanel.prototype.addButtons = function () {
            this.saveButton = this.panel.addButton({ title: "Save" });
            this.testButton = this.panel.addButton({ title: "Test" });
        };
        return MapEditorPanel;
    }(game.EditorPanel));
    game.MapEditorPanel = MapEditorPanel;
})(game || (game = {}));
var game;
(function (game) {
    var LevelsMapEditorLevelIcon = /** @class */ (function (_super) {
        __extends(LevelsMapEditorLevelIcon, _super);
        function LevelsMapEditorLevelIcon(scene, levelNumber) {
            var _this = _super.call(this, scene) || this;
            _this._levelNumber = 0;
            _this._isSelected = false;
            _this._levelNumber = levelNumber;
            _this.addBack();
            _this.addText();
            _this.setSize(_this.back.width, _this.back.height);
            _this.setInteractive();
            _this.input.cursor = "pointer";
            _this.on(Phaser.Input.Events.GAMEOBJECT_POINTER_WHEEL, _this.onPointerWheel, _this);
            _this.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, _this.onPointerDown, _this);
            return _this;
        }
        Object.defineProperty(LevelsMapEditorLevelIcon.prototype, "isSelected", {
            get: function () {
                return this._isSelected;
            },
            set: function (value) {
                this._isSelected = value;
                this._isSelected ? this.back.setFrame("LevelMapButtonButtonRed") : this.back.setFrame("LevelMapButtonButtonBlue");
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(LevelsMapEditorLevelIcon.prototype, "levelNumber", {
            get: function () {
                return this._levelNumber;
            },
            enumerable: false,
            configurable: true
        });
        LevelsMapEditorLevelIcon.prototype.addBack = function () {
            this.back = this.scene.add.image(0, 0, "levels_map", "LevelMapButtonButtonBlue");
            this.add(this.back);
        };
        LevelsMapEditorLevelIcon.prototype.onPointerWheel = function (pointer, dx, dy) {
            var newLevelNumber = this._levelNumber - Phaser.Math.Sign(dy);
            this._levelNumber = Phaser.Math.Clamp(newLevelNumber, 1, 40);
            this.setLevelNumber(this._levelNumber);
        };
        LevelsMapEditorLevelIcon.prototype.onPointerDown = function () {
            this.isSelected = !this.isSelected;
        };
        LevelsMapEditorLevelIcon.prototype.addText = function () {
            this.text = this.scene.add.bitmapText(0, 0, game.BitmapGameFont.LEVELS_MAP_NUMBERS_COMPLETE, this._levelNumber.toString(), 34);
            this.text.align = Phaser.Display.Align.CENTER;
            this.text.setOrigin(0.5, 0.5);
            this.text.x = this.back.x;
            this.text.y = this.back.y - 3;
            this.add(this.text);
        };
        LevelsMapEditorLevelIcon.prototype.setLevelNumber = function (levelNumber) {
            this._levelNumber = levelNumber;
            this.text.setText(this._levelNumber.toString());
        };
        return LevelsMapEditorLevelIcon;
    }(Phaser.GameObjects.Container));
    game.LevelsMapEditorLevelIcon = LevelsMapEditorLevelIcon;
})(game || (game = {}));
///<reference path='panels/MapEditorPanel.ts' />
///<reference path='ILevelsMapConfig.ts' />
///<reference path='LevelsMapEditorLevelIcon.ts' />
var game;
(function (game) {
    var FixedKeyControl = Phaser.Cameras.Controls.FixedKeyControl;
    var LevelsMapEditor = /** @class */ (function (_super) {
        __extends(LevelsMapEditor, _super);
        function LevelsMapEditor() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.lastTapTime = 0;
            return _this;
        }
        LevelsMapEditor.prototype.init = function () {
            this.config = this.cache.json.get("levels_map_config");
            this.events.once("shutdown", this.shutdown, this);
            console.group("Levels Map Editor");
            console.log("Config", this.config);
        };
        LevelsMapEditor.prototype.create = function () {
            this.addEditorPanel();
            this.addMainContainer();
            this.addBackgrounds();
            this.addLevelIcons();
            this.addClouds();
            this.setupCamera();
            this.addCameraKeyboardControls();
            this.addCameraScroll();
            this.addPointerCallbacks();
            this.addKeyboardCallbacks();
            this.resize();
        };
        LevelsMapEditor.prototype.addEditorPanel = function () {
            this.mapEditorPanel = new game.MapEditorPanel(this, this.config);
            this.mapEditorPanel.saveButton.on("click", this.onSaveButtonClick.bind(this));
            this.mapEditorPanel.testButton.on("click", this.onTestButtonClick.bind(this));
            this.panelsContainer = document.getElementById("editor-panels");
            this.panelsContainer.style.visibility = "visible";
        };
        LevelsMapEditor.prototype.onSaveButtonClick = function () {
            var _this = this;
            var config = this.createLevelsMapConfig();
            if (!config) {
                return;
            }
            this.cache.json.remove("levels_map_config");
            this.cache.json.add("levels_map_config", config);
            this.config = config;
            console.log("Saving levels map config...", this.config);
            this.mapEditorPanel.disableInput();
            this.uploadConfig(config)
                .then(function (data) {
                console.log("Levels map config was successfully saved!", data.responseText);
            })
                .catch(function (error) {
                console.warn("Can't save levels map config!", error);
            })
                .finally(function () {
                _this.mapEditorPanel.enableInput();
            });
        };
        LevelsMapEditor.prototype.onTestButtonClick = function () {
            var config = this.createLevelsMapConfig();
            if (!config) {
                return;
            }
            this.cache.json.remove("levels_map_config");
            this.cache.json.add("levels_map_config", config);
            this.game.changeScene(game.SceneKey.LEVELS_MAP_EDITOR, game.SceneKey.LEVELS_MAP);
        };
        LevelsMapEditor.prototype.createLevelsMapConfig = function () {
            var levelIconsConfig = this.createLevelIconsConfig();
            var validationResult = this.validateLevelIconConfig(levelIconsConfig);
            if (validationResult.success === false) {
                console.warn("Invalid level_icons config!", validationResult.errors);
                return null;
            }
            // prettier-ignore
            return {
                backgrounds: __spreadArrays(this.config.backgrounds),
                level_icons: levelIconsConfig,
                decor: __spreadArrays([
                    this.config.decor.find(function (item) { return item.type === game.LevelsMapDecor.FOX_IN_HOLE; }),
                    this.config.decor.find(function (item) { return item.type === game.LevelsMapDecor.FOX; }),
                    this.config.decor.find(function (item) { return item.type === game.LevelsMapDecor.FIRE; })
                ], this.getCloudsConfigs()),
            };
        };
        LevelsMapEditor.prototype.createLevelIconsConfig = function () {
            var getIconConfig = function (icon) {
                return {
                    level_number: icon.levelNumber,
                    x: Phaser.Math.RoundTo(icon.x, -2),
                    y: Phaser.Math.RoundTo(icon.y, -2),
                };
            };
            var configs = this.levelIcons.map(function (icon) { return getIconConfig(icon); });
            configs = _.sortBy(configs, "level_number");
            return configs;
        };
        LevelsMapEditor.prototype.getCloudsConfigs = function () {
            return this.clouds.map(function (cloud) {
                return {
                    type: game.LevelsMapDecor.CLOUD,
                    frame: cloud.frame.name,
                    x: cloud.x,
                    y: cloud.y,
                };
            });
        };
        LevelsMapEditor.prototype.validateLevelIconConfig = function (config) {
            var result = { success: true, errors: [] };
            var count = _.countBy(config, "level_number");
            for (var levelNumber in count) {
                if (count.hasOwnProperty(levelNumber) === false) {
                    continue;
                }
                var num = count[levelNumber];
                if (num > 1) {
                    result.success = false;
                    result.errors.push("Check level number = " + levelNumber + ". There are " + num + " instances of it.");
                }
            }
            return result;
        };
        LevelsMapEditor.prototype.uploadConfig = function (config) {
            var _this = this;
            return new Promise(function (resolve, reject) {
                var data = {
                    filename: "levels_map.json",
                    content: JSON.stringify(config),
                };
                var uploadURL = game.Config.SERVER_URL + "upload.php";
                var xhr = new XMLHttpRequest();
                xhr.open("POST", uploadURL, true);
                xhr.onload = function () {
                    resolve(xhr);
                };
                xhr.onerror = function () {
                    reject(xhr);
                };
                xhr.send(_this.convertObjectToURLSearchParams(data));
            });
        };
        LevelsMapEditor.prototype.convertObjectToURLSearchParams = function (obj) {
            return new URLSearchParams(obj);
        };
        LevelsMapEditor.prototype.addMainContainer = function () {
            this.mainContainer = this.add.container(0, 0);
            this.mainContainer.name = "main_container";
        };
        LevelsMapEditor.prototype.addBackgrounds = function () {
            var _this = this;
            this.backgrounds = this.config.backgrounds.map(function (frame, index) {
                var bg = _this.add.image(0, 0, frame);
                bg.setOrigin(0, 0);
                bg.y = bg.height * index;
                _this.mainContainer.add(bg);
                return bg;
            });
        };
        LevelsMapEditor.prototype.addLevelIcons = function () {
            var _this = this;
            this.levelIcons = [];
            this.config.level_icons.forEach(function (config) {
                _this.doAddLevelIcon(config.level_number, config.x, config.y);
            });
        };
        LevelsMapEditor.prototype.addClouds = function () {
            var _this = this;
            this.clouds = [];
            this.config.decor
                .filter(function (item) { return item.type === game.LevelsMapDecor.CLOUD; })
                .forEach(function (cloudConfig) {
                _this.doAddCloud(cloudConfig.x, cloudConfig.y, cloudConfig.frame);
            });
        };
        LevelsMapEditor.prototype.setupCamera = function () {
            this.camera = this.cameras.main;
        };
        LevelsMapEditor.prototype.addCameraKeyboardControls = function () {
            var cursors = this.input.keyboard.createCursorKeys();
            this.cameraControl = new FixedKeyControl({
                camera: this.camera,
                left: cursors.left,
                right: cursors.right,
                up: cursors.up,
                down: cursors.down,
                speed: 4,
            });
        };
        LevelsMapEditor.prototype.addCameraScroll = function () {
            var _this = this;
            this.cameraScroll = new game.KineticScroll(this, {
                kineticMovement: true,
                timeConstantScroll: 300,
                horizontalScroll: false,
                verticalScroll: true,
            });
            this.input.on("pointerup", function () {
                _this.cameraScroll.endMove();
            });
            this.input.on("pointermove", function (pointer) {
                _this.cameraScroll.move(pointer);
            });
        };
        LevelsMapEditor.prototype.addPointerCallbacks = function () {
            this.input.on(Phaser.Input.Events.POINTER_DOWN, this.onPointerDown, this);
            this.input.on("drag", function (pointer, gameObject, dragX, dragY) {
                gameObject.x = dragX;
                gameObject.y = dragY;
            });
        };
        LevelsMapEditor.prototype.onPointerDown = function (pointer, objects) {
            var now = Date.now();
            if (objects.length > 0) {
                this.lastTapTime = now;
                return;
            }
            this.cameraScroll.beginMove(pointer);
            var deltaTapTime = now - this.lastTapTime;
            if (deltaTapTime < 300) {
                this.addLevelIcon();
            }
            this.lastTapTime = now;
        };
        LevelsMapEditor.prototype.addKeyboardCallbacks = function () {
            this.input.keyboard.on("keydown-PLUS", this.addLevelIcon, this);
            this.input.keyboard.on("keydown-DELETE", this.onDeleteKeyPress, this);
            this.input.keyboard.on("keydown-HOME", this.scrollToTop, this);
            this.input.keyboard.on("keydown-END", this.scrollToBottom, this);
            this.input.keyboard.on("keydown-F", this.addFire, this);
            this.input.keyboard.on("keydown-C", this.addCloudByKey, this);
        };
        LevelsMapEditor.prototype.addCloudByKey = function () {
            var positionToCamera = this.input.activePointer.positionToCamera(this.camera);
            this.doAddCloud(positionToCamera.x, positionToCamera.y);
        };
        LevelsMapEditor.prototype.doAddCloud = function (x, y, frame) {
            var cloud = this.add.image(0, 0, "levels_map", frame || LevelsMapEditor.CLOUD_FRAMES[0]);
            cloud.x = x;
            cloud.y = y;
            cloud.setInteractive();
            cloud.on(Phaser.Input.Events.GAMEOBJECT_POINTER_WHEEL, this.onCloudPointerWheel.bind(this, cloud));
            this.input.setDraggable(cloud);
            this.mainContainer.add(cloud);
            this.clouds.push(cloud);
            return cloud;
        };
        LevelsMapEditor.prototype.onCloudPointerWheel = function (cloud, pointer, dx, dy) {
            var currentFrame = cloud.frame.name;
            var currentIndex = LevelsMapEditor.CLOUD_FRAMES.indexOf(currentFrame);
            var newIndex = currentIndex + Phaser.Math.Sign(dy);
            newIndex = Phaser.Math.Wrap(newIndex, 0, LevelsMapEditor.CLOUD_FRAMES.length);
            cloud.setFrame(LevelsMapEditor.CLOUD_FRAMES[newIndex]);
        };
        LevelsMapEditor.prototype.addFire = function () { };
        LevelsMapEditor.prototype.addLevelIcon = function () {
            var pointerWorldPosition = { x: this.input.activePointer.worldX, y: this.input.activePointer.worldY };
            var containerPosition = this.mainContainer.pointToContainer(pointerWorldPosition);
            var levelNumber = Math.max.apply(Math, __spreadArrays(this.levelIcons.map(function (icon) { return icon.levelNumber; }), [0])) + 1;
            this.doAddLevelIcon(levelNumber, containerPosition.x, containerPosition.y);
        };
        LevelsMapEditor.prototype.doAddLevelIcon = function (levelNumber, x, y) {
            var icon = new game.LevelsMapEditorLevelIcon(this, levelNumber);
            icon.x = x;
            icon.y = y;
            this.input.setDraggable(icon);
            this.mainContainer.add(icon);
            this.levelIcons.push(icon);
            return icon;
        };
        LevelsMapEditor.prototype.onDeleteKeyPress = function () {
            var _this = this;
            this.getSelectedLevelIcons().forEach(function (icon) {
                icon.destroy();
                _.pull(_this.levelIcons, icon);
            });
        };
        LevelsMapEditor.prototype.getSelectedLevelIcons = function () {
            return this.levelIcons.filter(function (icon) { return icon.isSelected; });
        };
        LevelsMapEditor.prototype.scrollToTop = function () {
            this.camera.scrollY = 0;
        };
        LevelsMapEditor.prototype.scrollToBottom = function () {
            this.camera.scrollY = this.camera.getBounds().height;
        };
        LevelsMapEditor.prototype.update = function (time, delta) {
            this.cameraScroll.update();
            this.cameraControl.update(delta);
        };
        LevelsMapEditor.prototype.resize = function () {
            this.resizeMainContainer();
            this.updateCameraBounds();
        };
        LevelsMapEditor.prototype.resizeMainContainer = function () {
            this.mainContainer.scale = game.Config.GAME_WIDTH / this.backgrounds[0].width;
        };
        LevelsMapEditor.prototype.updateCameraBounds = function () {
            var top = Phaser.Display.Bounds.GetTop(this.backgrounds[0]);
            var bottom = Phaser.Display.Bounds.GetBottom(this.backgrounds[this.backgrounds.length - 1]);
            var totalHeight = bottom - top;
            this.camera.setBounds(0, 0, game.Config.GAME_WIDTH, totalHeight * this.mainContainer.scale);
        };
        LevelsMapEditor.prototype.shutdown = function () {
            console.groupEnd();
            this.destroyPanels();
        };
        LevelsMapEditor.prototype.destroyPanels = function () {
            this.panelsContainer.style.visibility = "hidden";
            this.panelsContainer = null;
            if (this.mapEditorPanel) {
                this.mapEditorPanel.destroy();
            }
        };
        LevelsMapEditor.CLOUD_FRAMES = [
            "decor/Clouds/cloud_1_01",
            "decor/Clouds/cloud_1_02",
            "decor/Clouds/cloud_1_03",
            "decor/Clouds/cloud_2_01",
            "decor/Clouds/cloud_2_02",
            "decor/Clouds/cloud_2_03",
            "decor/Clouds/cloud_3_01",
            "decor/Clouds/cloud_3_02",
            "decor/Clouds/cloud_3_03",
        ];
        return LevelsMapEditor;
    }(Phaser.Scene));
    game.LevelsMapEditor = LevelsMapEditor;
})(game || (game = {}));
var game;
(function (game) {
    var LevelIconDev = /** @class */ (function (_super) {
        __extends(LevelIconDev, _super);
        function LevelIconDev(scene, levelNumber) {
            var _this = _super.call(this, scene, "editor", "level_icon_back") || this;
            _this.name = "level_icon";
            _this.levelNumber = levelNumber;
            _this.addBitmapText(levelNumber.toString(), game.BitmapGameFont.EDITOR_ROW_NUMBERS, 32, -1, -4);
            _this.addTutorialIcon();
            return _this;
        }
        LevelIconDev.prototype.addTutorialIcon = function () {
            var levelConfig = this.scene.game.levelConfigs.get(this.levelNumber);
            var tutorialConfig = levelConfig.tutorial;
            if (!tutorialConfig) {
                return;
            }
            var icon = this.scene.add.image(0, 0, "editor", "tutorial_icon");
            this.add(icon);
            Phaser.Display.Align.In.BottomRight(icon, this.back, -15, -15);
        };
        LevelIconDev.prototype.getWidth = function () {
            return this.back.width;
        };
        LevelIconDev.prototype.getHeight = function () {
            return this.back.height;
        };
        return LevelIconDev;
    }(Phaser.GameObjects.ComplexButton));
    game.LevelIconDev = LevelIconDev;
})(game || (game = {}));
///<reference path='LevelIconDev.ts' />
var game;
(function (game) {
    var LevelsMapDev = /** @class */ (function (_super) {
        __extends(LevelsMapDev, _super);
        function LevelsMapDev() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        LevelsMapDev.prototype.init = function () {
            this.events.once("shutdown", this.shutdown, this);
        };
        LevelsMapDev.prototype.create = function () {
            this.addBackground();
            this.addBackButton();
            this.addLevelIcons();
            this.addNewLevelButton();
            this.addPointerCallbacks();
            this.addKeyboardCallbacks();
            this.resize();
        };
        LevelsMapDev.prototype.addBackground = function () {
            this.background = this.add.image(0, 0, "editor", "background_1");
            this.background.setScrollFactor(0, 0);
        };
        LevelsMapDev.prototype.addBackButton = function () {
            this.backButton = this.add.button("editor", "button_close");
            this.backButton.once(Phaser.GameObjects.ButtonEvent.PRESS, this.gotoLevelsMap, this);
            this.backButton.setScrollFactor(0, 0);
        };
        LevelsMapDev.prototype.gotoLevelsMap = function () {
            this.game.changeScene(this.scene.key, game.SceneKey.LEVELS_MAP);
        };
        LevelsMapDev.prototype.addLevelIcons = function () {
            var levelNumbers = this.game.levelConfigs.getLevelNumbers();
            this.levelIcons = this.createLevelIcons(levelNumbers);
            this.levelIconsContainer = this.add.container(0, 0, this.levelIcons);
        };
        LevelsMapDev.prototype.createLevelIcons = function (levelNumbers) {
            var _this = this;
            return levelNumbers.map(function (levelNumber) {
                var icon = new game.LevelIconDev(_this, levelNumber);
                icon.once(Phaser.GameObjects.ButtonEvent.PRESS, _this.onLevelIconClick, _this);
                return icon;
            });
        };
        LevelsMapDev.prototype.onLevelIconClick = function (levelIcon) {
            var levelNumber = levelIcon.levelNumber;
            if (this.shiftKey.isDown) {
                this.tryToRemoveLevelConfig(levelNumber);
            }
            else if (this.tKey.isDown) {
                this.gotoTutorialEditor(levelNumber);
            }
            else {
                this.editLevel(levelNumber);
            }
        };
        LevelsMapDev.prototype.gotoTutorialEditor = function (levelNumber) {
            this.game.changeScene(this.scene.key, game.SceneKey.TUTORIAL_EDITOR, { levelNumber: levelNumber });
        };
        LevelsMapDev.prototype.tryToRemoveLevelConfig = function (levelNumber) {
            var confirmed = window.confirm("Do you want to delete level " + levelNumber + " config?");
            if (confirmed) {
                this.shiftKey.reset();
                this.removeLevelConfig(levelNumber);
            }
        };
        LevelsMapDev.prototype.removeLevelConfig = function (levelNumber) {
            var _this = this;
            this.levelIconsContainer.alpha = 0.66;
            this.levelIcons.forEach(function (icon) { return icon.disableInput(); });
            this.game.levelConfigs.remove(levelNumber);
            this.game.levelConfigs.saveLocally();
            this.game.levelConfigs.saveRemotely()
                .then(function () {
                console.log("Level " + levelNumber + " config was succesfully removed!");
                _this.onConfigRemoved(levelNumber);
            })
                .catch(function (xhr) {
                console.warn("Can't remove level " + levelNumber + " config. Please try again!");
            })
                .finally(function () {
                _this.levelIconsContainer.alpha = 1;
                _this.levelIcons.forEach(function (icon) { return icon.enableInput(); });
            });
        };
        LevelsMapDev.prototype.onConfigRemoved = function (levelNumber) {
            var indexToRemove = this.levelIcons.findIndex(function (icon) { return icon.levelNumber === levelNumber; });
            if (indexToRemove > -1) {
                this.levelIcons[indexToRemove].destroy();
                this.levelIcons.splice(indexToRemove, 1);
                this.alignIcons();
                this.alignNewLevelButton();
            }
        };
        LevelsMapDev.prototype.editLevel = function (levelNumber) {
            this.scene.start(game.SceneKey.LEVEL_EDITOR_ROOT, { levelNumber: levelNumber });
        };
        LevelsMapDev.prototype.addNewLevelButton = function () {
            this.newLevelButton = this.add.button("editor", "add_level_button");
            this.newLevelButton.on(Phaser.GameObjects.ButtonEvent.RELEASE, this.onNewLevelClick, this);
        };
        LevelsMapDev.prototype.onNewLevelClick = function () {
            var _default = Math.max.apply(Math, __spreadArrays(this.game.levelConfigs.getLevelNumbers(), [0])) + 1;
            var levelNumberStr = window.prompt("Enter new level number", _default.toString());
            if (!levelNumberStr) {
                return;
            }
            var levelNumber = parseInt(levelNumberStr);
            if (!levelNumber) {
                console.warn("Please enter valid number!", levelNumberStr);
                return;
            }
            var isLevelExist = this.game.levelConfigs.check(levelNumber);
            if (isLevelExist) {
                console.warn("Level " + levelNumberStr + " exists already!");
                return;
            }
            this.editLevel(levelNumber);
        };
        LevelsMapDev.prototype.addPointerCallbacks = function () {
            this.input.on(Phaser.Input.Events.POINTER_WHEEL, this.onPointerWheel, this);
        };
        LevelsMapDev.prototype.onPointerWheel = function (pointer, objects, dx, dy) {
            this.cameras.main.scrollY += dy;
        };
        LevelsMapDev.prototype.addKeyboardCallbacks = function () {
            this.input.keyboard.on("keydown-R", this.restart, this);
            this.input.keyboard.on("keydown-PLUS", this.onNewLevelClick, this);
            this.input.keyboard.on("keydown-M", this.gotoLevelsMap, this);
            this.input.keyboard.on("keydown-SPACE", this.gotoLastExistingLevel, this);
            this.shiftKey = this.input.keyboard.addKey("shift");
            this.tKey = this.input.keyboard.addKey("T");
        };
        LevelsMapDev.prototype.restart = function () {
            this.game.changeScene(this.scene.key, game.SceneKey.LEVELS_MAP_DEV);
        };
        LevelsMapDev.prototype.gotoLastExistingLevel = function () {
            var lastLevel = Math.max.apply(Math, this.game.levelConfigs.getLevelNumbers());
            this.editLevel(lastLevel);
        };
        LevelsMapDev.prototype.resize = function () {
            this.alignBackground();
            this.alignBackButton();
            this.alignIcons();
            this.alignNewLevelButton();
        };
        LevelsMapDev.prototype.alignBackground = function () {
            this.background.envelop(game.Config.GAME_WIDTH, game.Config.GAME_HEIGHT);
            this.background.x = game.Config.HALF_GAME_WIDTH;
            this.background.y = game.Config.HALF_GAME_HEIGHT;
        };
        LevelsMapDev.prototype.alignBackButton = function () {
            var margin = 50;
            this.backButton.x = game.Config.GAME_WIDTH - margin;
            this.backButton.y = margin;
        };
        LevelsMapDev.prototype.alignIcons = function () {
            this.gridAlignIcons();
            this.scaleIcons();
        };
        LevelsMapDev.prototype.gridAlignIcons = function () {
            if (this.levelIcons.length === 0) {
                return;
            }
            this.levelIconsContainer.gridAlign({
                cellWidth: 120,
                width: 5,
                position: Phaser.Display.Align.CENTER,
                x: this.levelIcons[0].getWidth() / 2,
                y: this.levelIcons[0].getHeight() / 2,
            });
        };
        LevelsMapDev.prototype.scaleIcons = function () {
            var maxWidth = game.Config.GAME_WIDTH * 0.8;
            var width = this.levelIconsContainer.getBounds().width;
            var scale = Math.min(1, maxWidth / width);
            this.levelIconsContainer.scale = scale;
            this.levelIconsContainer.x = (game.Config.GAME_WIDTH - this.levelIconsContainer.getBounds().width) / 2;
            this.levelIconsContainer.y = 70;
        };
        LevelsMapDev.prototype.alignNewLevelButton = function () {
            var iconsBottom = this.levelIconsContainer.y + this.levelIconsContainer.getBounds().height;
            this.newLevelButton.scale = this.levelIconsContainer.scale;
            this.newLevelButton.x = game.Config.HALF_GAME_WIDTH;
            this.newLevelButton.y = iconsBottom + this.newLevelButton.displayHeight / 2 + 20 * this.newLevelButton.scale;
        };
        LevelsMapDev.prototype.shutdown = function () {
        };
        return LevelsMapDev;
    }(Phaser.Scene));
    game.LevelsMapDev = LevelsMapDev;
})(game || (game = {}));
var game;
(function (game) {
    var GridAlign = Phaser.Actions.GridAlign;
    var LevelIconStars = /** @class */ (function (_super) {
        __extends(LevelIconStars, _super);
        function LevelIconStars(scene) {
            var _this = _super.call(this, scene) || this;
            _this.name = "stars";
            _this.addStars();
            _this.alignStars();
            _this.finetuneAligment();
            return _this;
        }
        LevelIconStars.prototype.addStars = function () {
            var _this = this;
            this.stars = _.times(3, function (index) {
                return _this.scene.add.image(0, 0, "levels_map", "small_star");
            });
            this.add(this.stars);
        };
        LevelIconStars.prototype.alignStars = function () {
            var cellWidth = 41;
            GridAlign(this.stars, {
                height: 1,
                width: this.stars.length,
                position: Phaser.Display.Align.TOP_CENTER,
                cellWidth: cellWidth,
                x: -(this.stars.length * cellWidth) / 2 + this.stars[0].width / 2,
            });
        };
        LevelIconStars.prototype.finetuneAligment = function () {
            var sideAngle = 30;
            this.stars[0].angle = -sideAngle;
            this.stars[2].angle = sideAngle;
            this.stars[1].y -= 11.2;
        };
        LevelIconStars.prototype.setActiveNum = function (num) {
            this.stars.forEach(function (star, index) {
                var frame = index < num ? "small_star" : "small_star_inactive";
                var alpha = index < num ? 1 : 0.66;
                star.setFrame(frame);
                star.alpha = alpha;
            });
        };
        return LevelIconStars;
    }(Phaser.GameObjects.Container));
    game.LevelIconStars = LevelIconStars;
})(game || (game = {}));
///<reference path='LevelIconStars.ts' />
var game;
(function (game) {
    var LevelIconState;
    (function (LevelIconState) {
        LevelIconState["LOCKED"] = "LOCKED";
        LevelIconState["UNLOCKED"] = "UNLOCKED";
        LevelIconState["COMPLETE"] = "COMPLETE";
    })(LevelIconState = game.LevelIconState || (game.LevelIconState = {}));
    var LevelIcon = /** @class */ (function (_super) {
        __extends(LevelIcon, _super);
        function LevelIcon(scene, data) {
            var _this = _super.call(this, scene) || this;
            _this.iconData = data;
            _this.name = "level_icon_" + _this.iconData.levelNumber.toString();
            _this._levelNumber = _this.iconData.levelNumber;
            _this.addBack();
            _this.addUnlockedText();
            _this.addCompleteText();
            _this.addStars();
            _this.setSize(_this.back.width, _this.back.height);
            _this.setInitialState();
            return _this;
        }
        Object.defineProperty(LevelIcon.prototype, "levelNumber", {
            get: function () {
                return this._levelNumber;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(LevelIcon.prototype, "iconState", {
            get: function () {
                return this._iconState;
            },
            enumerable: false,
            configurable: true
        });
        LevelIcon.prototype.setInitialState = function () {
            if (this.iconData.locked) {
                this.setLocked();
            }
            else {
                if (this.iconData.complete) {
                    this.setComplete();
                }
                else {
                    this.setUnlocked();
                }
            }
        };
        LevelIcon.prototype.setLocked = function () {
            this._iconState = LevelIconState.LOCKED;
            this.back.setFrame("LevelMapButtonButtonLocked");
            this.completeText.visible = false;
            this.unlockedText.visible = false;
            this.stars.visible = false;
            this.removeInteractive();
        };
        LevelIcon.prototype.setUnlocked = function () {
            this._iconState = LevelIconState.UNLOCKED;
            this.back.setFrame("LevelMapButtonButtonRed");
            this.stars.visible = false;
            this.completeText.visible = false;
            this.unlockedText.visible = true;
            this.setInteractive();
            this.input.cursor = "pointer";
        };
        LevelIcon.prototype.setComplete = function () {
            this._iconState = LevelIconState.COMPLETE;
            this.back.setFrame("LevelMapButtonButtonBlue");
            this.stars.visible = true;
            this.unlockedText.visible = false;
            this.completeText.visible = true;
            this.setInteractive();
            this.input.cursor = "pointer";
        };
        LevelIcon.prototype.addBack = function () {
            this.back = this.scene.add.image(0, 0, "levels_map", "LevelMapButtonButtonBlue");
            this.add(this.back);
        };
        LevelIcon.prototype.addUnlockedText = function () {
            this.unlockedText = this.scene.add.bitmapText(0, 0, game.BitmapGameFont.LEVELS_MAP_NUMBERS_UNLOCKED, this._levelNumber.toString(), 32);
            this.unlockedText.setOrigin(0.5, 0.5);
            this.unlockedText.x = this.back.x;
            this.unlockedText.y = this.back.y - 4;
            this.add(this.unlockedText);
        };
        LevelIcon.prototype.addCompleteText = function () {
            this.completeText = this.scene.add.bitmapText(0, 0, game.BitmapGameFont.LEVELS_MAP_NUMBERS_COMPLETE, this._levelNumber.toString(), 32);
            this.completeText.setOrigin(0.5, 0.5);
            this.completeText.x = this.unlockedText.x;
            this.completeText.y = this.unlockedText.y;
            this.add(this.completeText);
        };
        LevelIcon.prototype.addStars = function () {
            this.stars = new game.LevelIconStars(this.scene);
            this.stars.x = 1;
            this.stars.y = this.back.y - this.back.height / 2 - 11;
            this.stars.setActiveNum(this.iconData.stars);
            this.add(this.stars);
        };
        return LevelIcon;
    }(Phaser.GameObjects.Container));
    game.LevelIcon = LevelIcon;
})(game || (game = {}));
var game;
(function (game) {
    var LevelCompleteStarEvent;
    (function (LevelCompleteStarEvent) {
        LevelCompleteStarEvent["EXPLODE"] = "explode";
    })(LevelCompleteStarEvent = game.LevelCompleteStarEvent || (game.LevelCompleteStarEvent = {}));
    var LevelCompleteStar = /** @class */ (function (_super) {
        __extends(LevelCompleteStar, _super);
        function LevelCompleteStar(scene, atlas, activeStarFrame, inactiveStarFrame, whiteStarFrame) {
            var _this = _super.call(this, scene) || this;
            _this._isActive = true;
            _this.isTwinklingEnabled = true;
            _this.name = "star";
            _this.inactiveStar = _this.scene.add.image(0, 0, atlas, inactiveStarFrame);
            _this.activeStar = _this.scene.add.image(0, 0, atlas, activeStarFrame);
            _this.whiteStar = _this.scene.add.image(0, 0, atlas, whiteStarFrame).setVisible(false);
            _this.hideActiveStar();
            _this.add(_this.inactiveStar);
            _this.add(_this.activeStar);
            _this.add(_this.whiteStar);
            return _this;
        }
        Object.defineProperty(LevelCompleteStar.prototype, "isActive", {
            get: function () {
                return this._isActive;
            },
            enumerable: false,
            configurable: true
        });
        LevelCompleteStar.prototype.showActiveStar = function () {
            this.activeStar.visible = true;
            this.activeStar.active = true;
            this._isActive = true;
        };
        LevelCompleteStar.prototype.hideActiveStar = function () {
            this.activeStar.visible = false;
            this.activeStar.active = false;
            this._isActive = false;
        };
        LevelCompleteStar.prototype.tweenActiveStar = function (delay) {
            var _this = this;
            this.activeStar.alpha = 0;
            this.scene.tweens.add({
                targets: this.activeStar,
                delay: delay,
                duration: 150,
                ease: Phaser.Math.Easing.Cubic.Out,
                alpha: 1,
            });
            this.activeStar.scale = 2.5;
            this.scene.tweens.add({
                targets: this.activeStar,
                delay: delay,
                duration: 400,
                ease: Phaser.Math.Easing.Cubic.Out,
                scale: 1,
                onStart: function () {
                    _this.parentContainer.bringToTop(_this);
                },
                onComplete: function () {
                    _this.inactiveStar.visible = false;
                },
            });
            this.scene.time.delayedCall(delay + 300, function () {
                _this.emit(LevelCompleteStarEvent.EXPLODE, _this);
                _this.showWhiteStar();
            });
        };
        LevelCompleteStar.prototype.showWhiteStar = function () {
            var _this = this;
            this.whiteStar.visible = true;
            this.whiteStar.alpha = 0.4;
            this.scene.tweens.add({
                targets: this.whiteStar,
                scale: { value: 1.55, duration: 400, ease: Phaser.Math.Easing.Linear.Linear },
                alpha: { value: 0, duration: 400, ease: Phaser.Math.Easing.Cubic.Out },
                onComplete: function () {
                    _this.whiteStar.visible = false;
                    _this.whiteStar.scale = 1;
                    _this.twinkle();
                },
            });
        };
        LevelCompleteStar.prototype.twinkle = function () {
            if (!this.isTwinklingEnabled) {
                return;
            }
            this.scene.time.addEvent({
                delay: 3000,
                startAt: 2300,
                loop: true,
                callback: this.doTwinkle,
                callbackScope: this,
            });
        };
        LevelCompleteStar.prototype.doTwinkle = function () {
            this.scene.tweens.add({
                targets: this,
                duration: 200,
                ease: Phaser.Math.Easing.Sine.InOut,
                scale: this.scale * 1.17,
                yoyo: true,
            });
            this.twinkleWhiteStar();
        };
        LevelCompleteStar.prototype.twinkleWhiteStar = function () {
            var _this = this;
            this.whiteStar.visible = true;
            this.whiteStar.alpha = 0;
            this.scene.tweens.add({
                targets: this.whiteStar,
                duration: 150,
                ease: Phaser.Math.Easing.Cubic.Out,
                alpha: 0.33,
                onComplete: function () {
                    _this.scene.tweens.add({
                        targets: _this.whiteStar,
                        duration: 400,
                        ease: Phaser.Math.Easing.Cubic.In,
                        alpha: 0,
                        onComplete: function () {
                            _this.whiteStar.visible = false;
                        },
                    });
                },
            });
        };
        return LevelCompleteStar;
    }(Phaser.GameObjects.Container));
    game.LevelCompleteStar = LevelCompleteStar;
})(game || (game = {}));
///<reference path='LevelCompleteStar.ts' />
var game;
(function (game) {
    var LevelCompleteStarsEvent;
    (function (LevelCompleteStarsEvent) {
        LevelCompleteStarsEvent["ANIMATION_COMPLETE"] = "animation_complete";
    })(LevelCompleteStarsEvent = game.LevelCompleteStarsEvent || (game.LevelCompleteStarsEvent = {}));
    var LevelCompleteStars = /** @class */ (function (_super) {
        __extends(LevelCompleteStars, _super);
        function LevelCompleteStars(scene, props) {
            var _this = _super.call(this, scene) || this;
            _this.SIDE_STAR_ANGLE = 15;
            _this.SIDE_STAR_SCALE = 0.8;
            _this.SIDE_STAR_X_OFFSET = 140;
            _this.SIDE_STAR_Y = 26;
            _this.activeStarsNum = 0;
            _this.starsExploded = 0;
            _this.name = "stars";
            _this.props = props;
            _this.addStars();
            return _this;
        }
        LevelCompleteStars.prototype.addStars = function () {
            this.leftStar = new game.LevelCompleteStar(this.scene, this.props.atlas, this.props.activeStarFrame, this.props.inactiveStarFrame, this.props.whiteStarFrame);
            this.leftStar.angle = -this.SIDE_STAR_ANGLE;
            this.leftStar.scale = this.SIDE_STAR_SCALE;
            this.leftStar.x = -this.SIDE_STAR_X_OFFSET;
            this.leftStar.y = this.SIDE_STAR_Y;
            this.centralStar = new game.LevelCompleteStar(this.scene, this.props.atlas, this.props.activeStarFrame, this.props.inactiveStarFrame, this.props.whiteStarFrame);
            this.rightStar = new game.LevelCompleteStar(this.scene, this.props.atlas, this.props.activeStarFrame, this.props.inactiveStarFrame, this.props.whiteStarFrame);
            this.rightStar.angle = this.SIDE_STAR_ANGLE;
            this.rightStar.scale = this.SIDE_STAR_SCALE;
            this.rightStar.x = this.SIDE_STAR_X_OFFSET;
            this.rightStar.y = this.SIDE_STAR_Y;
            this.allStars = [this.leftStar, this.centralStar, this.rightStar];
            this.add(this.allStars);
            this.bringToTop(this.centralStar);
        };
        LevelCompleteStars.prototype.updateData = function (starsNum) {
            this.activeStarsNum = starsNum;
        };
        LevelCompleteStars.prototype.showActiveStarsInstant = function () {
            var _this = this;
            this.allStars.forEach(function (star, index) {
                if (index < _this.activeStarsNum) {
                    star.showActiveStar();
                }
                else {
                    star.hideActiveStar();
                }
            });
        };
        LevelCompleteStars.prototype.showActiveStars = function (initialDelay) {
            var _this = this;
            if (this.activeStarsNum === 0) {
                this.emit(LevelCompleteStarsEvent.ANIMATION_COMPLETE, this);
            }
            this.allStars.forEach(function (star, index) {
                if (index < _this.activeStarsNum) {
                    var delay = initialDelay + index * 300;
                    _this.playStarSound(index, delay);
                    star.on(game.LevelCompleteStarEvent.EXPLODE, _this.onStarExplode, _this);
                    star.showActiveStar();
                    star.tweenActiveStar(delay);
                }
            });
        };
        LevelCompleteStars.prototype.playStarSound = function (index, initialDelay) {
            var key = "level_complete_star_show" + (index + 1);
            var delay = (initialDelay + 300) / 1000;
            if (this.scene.cache.audio.has(key)) {
                this.scene.sound.play(key, {
                    volume: 1,
                    delay: delay,
                });
            }
        };
        LevelCompleteStars.prototype.onStarExplode = function (star) {
            if (this.explodeEmitter) {
                var worldMatrix = star.getWorldTransformMatrix();
                this.explodeEmitter.explode(16, worldMatrix.tx, worldMatrix.ty);
            }
            if (++this.starsExploded === this.activeStarsNum) {
                this.emit(LevelCompleteStarsEvent.ANIMATION_COMPLETE, this);
            }
        };
        LevelCompleteStars.prototype.addEmitter = function (atlas, particleFrame, depth) {
            this.manager = this.scene.add.particles(atlas);
            this.manager.setDepth(depth);
            this.explodeEmitter = this.manager.createEmitter({
                emitZone: {
                    source: new Phaser.Geom.Circle(0, 0, 60),
                    type: "random",
                },
                frame: particleFrame,
                speed: 25,
                scale: { start: 0.75, end: 0.15, ease: Phaser.Math.EasingString.Cubic },
                alpha: { start: 0.75, end: 0, ease: Phaser.Math.EasingString.Cubic },
                lifespan: 2000,
                on: false,
            });
        };
        LevelCompleteStars.prototype.startFloating = function () {
            var _this = this;
            this.allStars.forEach(function (star, index) {
                _this.scene.tweens.add({
                    targets: star,
                    duration: 800,
                    delay: index * 200,
                    ease: Phaser.Math.Easing.Sine.InOut,
                    y: "-=14",
                    yoyo: true,
                    repeat: -1,
                });
            });
        };
        return LevelCompleteStars;
    }(Phaser.GameObjects.Container));
    game.LevelCompleteStars = LevelCompleteStars;
})(game || (game = {}));
var game;
(function (game) {
    var _a;
    game.ITEM_TYPE = "item_type";
    var ItemType;
    (function (ItemType) {
        ItemType["TRIANGLE"] = "triangle";
        ItemType["BASIC_BLOCK"] = "basic_block";
        ItemType["DYNAMITE_BLOCK"] = "dynamite_block";
        ItemType["ICE_BLOCK"] = "ice_block";
        ItemType["ICE_RHOMB"] = "ice_rhomb";
        ItemType["ICE_OCTAGON"] = "ice_octagon";
        ItemType["PINATA_BLOCK"] = "pinata_block";
        ItemType["SHATTER_BLOCK"] = "shatter_block";
        ItemType["SHATTER_BLOCK_PIECE"] = "shatter_block_piece";
        ItemType["LIGHTNING"] = "lightning";
        ItemType["COLLECTABLE_BALL"] = "collectable_ball";
        ItemType["SPINNER"] = "spinner";
    })(ItemType = game.ItemType || (game.ItemType = {}));
    var ItemTypeUtil = /** @class */ (function () {
        function ItemTypeUtil() {
        }
        ItemTypeUtil.getAllTypes = function () {
            return Object.values(ItemType);
        };
        ItemTypeUtil.isBlockType = function (type) {
            return ItemTypeUtil.getBlockTypes().includes(type);
        };
        ItemTypeUtil.getBlockTypes = function () {
            return ItemTypeUtil.BLOCK_TYPES;
        };
        ItemTypeUtil.getFrameName = function (itemType) {
            return ItemTypeUtil.FRAMES_MAP[itemType];
        };
        ItemTypeUtil.isBlock = function (item) {
            return ItemTypeUtil.isBlockType(item.itemType);
        };
        ItemTypeUtil.BLOCK_TYPES = [
            ItemType.BASIC_BLOCK,
            ItemType.TRIANGLE,
            ItemType.DYNAMITE_BLOCK,
            ItemType.ICE_BLOCK,
            ItemType.ICE_RHOMB,
            ItemType.ICE_OCTAGON,
            ItemType.PINATA_BLOCK,
            ItemType.SHATTER_BLOCK,
            ItemType.SHATTER_BLOCK_PIECE,
        ];
        ItemTypeUtil.FRAMES_MAP = (_a = {},
            _a[ItemType.BASIC_BLOCK] = "blocks/basic_block_01",
            _a[ItemType.SHATTER_BLOCK] = "blocks/shatter_block_02",
            _a[ItemType.SHATTER_BLOCK_PIECE] = "blocks/shatter_block_02_left",
            _a[ItemType.TRIANGLE] = "blocks/triangle_01",
            _a[ItemType.ICE_BLOCK] = "blocks/ice_block",
            _a[ItemType.ICE_RHOMB] = "blocks/ice_romb",
            _a[ItemType.ICE_OCTAGON] = "blocks/ice_octagon",
            _a[ItemType.PINATA_BLOCK] = "blocks/pinata_block",
            _a[ItemType.DYNAMITE_BLOCK] = "blocks/dynamite_block",
            _a[ItemType.SPINNER] = "spinner/spinner0001",
            _a[ItemType.LIGHTNING] = "lightning/lightning0001",
            _a[ItemType.COLLECTABLE_BALL] = "ball_collectable",
            _a);
        return ItemTypeUtil;
    }());
    game.ItemTypeUtil = ItemTypeUtil;
})(game || (game = {}));
var game;
(function (game) {
    var StartLevelPopupBlocksLabel = /** @class */ (function (_super) {
        __extends(StartLevelPopupBlocksLabel, _super);
        function StartLevelPopupBlocksLabel(scene) {
            var _this = _super.call(this, scene) || this;
            _this.name = "blocks_label";
            _this.addBack();
            _this.addBlock();
            _this.addText();
            _this.align();
            return _this;
        }
        StartLevelPopupBlocksLabel.prototype.addBack = function () {
            this.back = this.scene.add.image(0, 0, "levels_map", "popup/label_back");
            this.add(this.back);
        };
        StartLevelPopupBlocksLabel.prototype.addBlock = function () {
            this.block = this.scene.add.image(0, 0, "levels_map", "popup/blocks/basic_block_01");
            this.add(this.block);
        };
        StartLevelPopupBlocksLabel.prototype.addText = function () {
            var content = this.getTextContent(0);
            var style = {
                fontFamily: game.GameFont.SOUSES,
                fontStyle: game.FontWeight.BOLD,
                fontSize: "36px",
                color: "#B72C35",
                align: "center",
            };
            this.text = this.scene.add.text(0, 0, content, style);
            this.text.setOrigin(0.5, 0.5);
            this.add(this.text);
        };
        StartLevelPopupBlocksLabel.prototype.getTextContent = function (blocksNum) {
            return this.scene.texts.start_level_popup.task.replace("#", blocksNum.toString());
        };
        StartLevelPopupBlocksLabel.prototype.align = function () {
            this.block.x = this.back.left + this.block.width / 2 + 20;
            this.block.y = this.back.getCenter().y;
            this.alignText();
        };
        StartLevelPopupBlocksLabel.prototype.alignText = function () {
            var left = this.block.right;
            var right = this.back.right;
            var width = right - left;
            this.text.setWordWrapWidth(width * 0.75);
            this.text.x = left + width / 2;
            this.text.y = this.back.getCenter().y;
        };
        StartLevelPopupBlocksLabel.prototype.updateData = function (blockType, blocksNum) {
            this.block.setFrame(this.getBlockFrame(blockType));
            this.text.text = this.getTextContent(blocksNum);
        };
        StartLevelPopupBlocksLabel.prototype.getBlockFrame = function (blocksType) {
            var _a;
            var prefix = "popup/blocks/";
            var map = (_a = {},
                _a[game.ItemType.BASIC_BLOCK] = prefix + "basic_block_01",
                _a[game.ItemType.TRIANGLE] = prefix + "triangle_01",
                _a[game.ItemType.ICE_BLOCK] = prefix + "ice_block",
                _a[game.ItemType.PINATA_BLOCK] = prefix + "pinata_block",
                _a[game.ItemType.DYNAMITE_BLOCK] = prefix + "dynamite_block_3",
                _a);
            return map[blocksType] || map[game.ItemType.BASIC_BLOCK];
        };
        StartLevelPopupBlocksLabel.prototype.getHeight = function () {
            return this.back.height;
        };
        StartLevelPopupBlocksLabel.prototype.getWidth = function () {
            return this.back.width;
        };
        return StartLevelPopupBlocksLabel;
    }(Phaser.GameObjects.Container));
    game.StartLevelPopupBlocksLabel = StartLevelPopupBlocksLabel;
})(game || (game = {}));
///<reference path='StartLevelPopupBlocksLabel.ts' />
var game;
(function (game) {
    var StartLevelPopup = /** @class */ (function (_super) {
        __extends(StartLevelPopup, _super);
        function StartLevelPopup(scene) {
            var _this = _super.call(this, scene) || this;
            _this.name = "popup";
            _this.addBack();
            _this.addBanner();
            _this.addFoxBody();
            _this.addBlocksLabel();
            _this.addFoxPaws();
            _this.addTick();
            _this.addHighscore();
            _this.addCloseButton();
            _this.addFirefly();
            _this.align();
            _this.bringToTop(_this.highscore);
            _this.bringToTop(_this.banner);
            return _this;
        }
        StartLevelPopup.prototype.addBack = function () {
            this.back = this.scene.add.image(0, 0, "levels_map", "popup/popup_back");
            this.add(this.back);
        };
        StartLevelPopup.prototype.addBanner = function () {
            var bannerBack = this.scene.make.image({
                key: "levels_map",
                frame: "popup/banner",
                add: false,
            });
            var maxWidth = 360;
            this.bannerText = this.createBannerText();
            this.bannerText.setOrigin(0.5, 0.5);
            this.bannerText.scale = Math.min(1, maxWidth / this.bannerText.width);
            this.bannerText.y = -34;
            this.bannerText.name = "title";
            this.banner = this.scene.add.container(0, 0, [bannerBack, this.bannerText]);
            this.add(this.banner);
        };
        StartLevelPopup.prototype.createBannerText = function () {
            var text = this.scene.make.text({
                add: false,
                text: this.getBannerContent(1),
                style: {
                    fontFamily: game.GameFont.SOUSES,
                    fontStyle: game.FontWeight.BLACK,
                    fontSize: "52px",
                    color: "#FAD353",
                    align: "center",
                },
            });
            text.setShadow(0, 4, "rgba(0,0,0,0.15)");
            return text;
        };
        StartLevelPopup.prototype.getBannerContent = function (levelNumber) {
            var template = this.scene.texts.start_level_popup.title;
            return template.replace("#", levelNumber.toString());
        };
        StartLevelPopup.prototype.addFoxBody = function () {
            this.foxBody = this.scene.add.image(0, 0, "levels_map", "popup/Fox");
            this.add(this.foxBody);
        };
        StartLevelPopup.prototype.addBlocksLabel = function () {
            this.blocksLabel = new game.StartLevelPopupBlocksLabel(this.scene);
            this.add(this.blocksLabel);
        };
        StartLevelPopup.prototype.addFoxPaws = function () {
            this.foxPaws = this.scene.add.image(0, 0, "levels_map", "popup/FoxPaws");
            this.add(this.foxPaws);
        };
        StartLevelPopup.prototype.addTick = function () {
            this.tick = this.scene.add.image(0, 0, "levels_map", "popup/tick");
            this.add(this.tick);
        };
        StartLevelPopup.prototype.addHighscore = function () {
            this.highscoreBack = this.scene.add.image(0, 0, "levels_map", "popup/highscore_label_back");
            this.add(this.highscoreBack);
            var content = this.getHighscoreContent(0);
            var style = {
                fontFamily: game.GameFont.SOUSES,
                fontStyle: game.FontWeight.BOLD,
                fontSize: "33px",
                color: "#ECD397",
                align: "center",
            };
            this.highscore = this.scene.add.text(0, 0, content, style);
            this.highscore.setOrigin(0.5, 0.5);
            this.add(this.highscore);
        };
        StartLevelPopup.prototype.getHighscoreContent = function (value) {
            var template = this.scene.texts.start_level_popup.highscore;
            return template.replace("#", value.toLocaleString());
        };
        StartLevelPopup.prototype.addCloseButton = function () {
            this.closeButton = this.scene.add.button("levels_map", "popup/button_close", this);
            this.closeButton.setScrollFactor(0, 0);
        };
        StartLevelPopup.prototype.addFirefly = function () {
            this.scene.anims.create({
                key: "firefly",
                repeat: -1,
                frames: this.scene.anims.getFrameNames("levels_map", "decor/firefly/firefly"),
                frameRate: 24,
            });
            this.firefly = this.scene.add.sprite(0, 0, "levels_map", "decor/firefly/firefly0002");
            this.firefly.play("firefly");
            this.firefly.scale = 0.66;
            this.add(this.firefly);
            this.scene.tweens.add({
                targets: this.firefly,
                duration: 400,
                ease: Phaser.Math.Easing.Sine.InOut,
                y: "+=8",
                repeat: -1,
                yoyo: true,
            });
            this.scene.tweens.add({
                targets: this.firefly,
                duration: 600,
                ease: Phaser.Math.Easing.Sine.InOut,
                x: "+=8",
                repeat: -1,
                yoyo: true,
            });
        };
        StartLevelPopup.prototype.align = function () {
            this.alignBanner();
            this.alignBlocksLabel();
            this.alignTick();
            this.alignFox();
            this.alignHighscore();
            this.alignCloseButton();
            this.alignFirefly();
        };
        StartLevelPopup.prototype.alignFirefly = function () {
            var Align = Phaser.Display.Align;
            var margin = 45;
            var align = Phaser.Math.RND.bool() ? Align.TOP_LEFT : Align.TOP_RIGHT;
            Phaser.Display.Align.In.QuickSet(this.firefly, this.back, align, -margin, -margin);
        };
        StartLevelPopup.prototype.alignBanner = function () {
            this.banner.y = this.back.top - 6;
        };
        StartLevelPopup.prototype.alignBlocksLabel = function () {
            Phaser.Display.Align.In.Center(this.blocksLabel, this.back, 0, 16);
        };
        StartLevelPopup.prototype.alignTick = function () {
            this.tick.x = this.blocksLabel.x + this.blocksLabel.getWidth() / 2 - 7;
            this.tick.y = this.blocksLabel.y + this.blocksLabel.getHeight() / 2 - 14;
        };
        StartLevelPopup.prototype.alignFox = function () {
            Phaser.Display.Align.To.TopCenter(this.foxBody, this.blocksLabel);
            this.foxBody.x = this.blocksLabel.x;
            this.foxPaws.x = this.foxBody.x - 1;
            this.foxPaws.y = this.foxBody.y;
        };
        StartLevelPopup.prototype.alignHighscore = function () {
            Phaser.Display.Align.In.BottomCenter(this.highscoreBack, this.back, 0, -57);
            Phaser.Display.Align.In.Center(this.highscore, this.highscoreBack, 0, 0);
        };
        StartLevelPopup.prototype.alignCloseButton = function () {
            var offset = this.closeButton.width / 2 - 6;
            Phaser.Display.Align.In.TopRight(this.closeButton, this.back, offset, offset);
        };
        StartLevelPopup.prototype.updateData = function (data) {
            this.bannerText.text = this.getBannerContent(data.levelNumber);
            this.blocksLabel.updateData(data.blocksType, data.blocksNum);
            this.tick.visible = data.levelComplete;
            this.highscore.text = data.levelComplete ? this.getHighscoreContent(data.highscore) : this.getHighscoreContent(0);
        };
        StartLevelPopup.prototype.getWidth = function () {
            return this.back.width;
        };
        StartLevelPopup.prototype.getHeight = function () {
            return this.back.displayHeight;
        };
        return StartLevelPopup;
    }(Phaser.GameObjects.Container));
    game.StartLevelPopup = StartLevelPopup;
})(game || (game = {}));
///<reference path='../../gameplay/gui/levelComplete/stars/LevelCompleteStars.ts' />
///<reference path='../../gameplay/items/ItemType.ts' />
///<reference path='StartLevelPopup.ts' />
var game;
(function (game) {
    var ButtonEvent = Phaser.GameObjects.ButtonEvent;
    var StartLevelScreenEvent;
    (function (StartLevelScreenEvent) {
        StartLevelScreenEvent["SHOW"] = "show";
        StartLevelScreenEvent["HIDE"] = "hide";
    })(StartLevelScreenEvent = game.StartLevelScreenEvent || (game.StartLevelScreenEvent = {}));
    var StartLevelScreen = /** @class */ (function (_super) {
        __extends(StartLevelScreen, _super);
        function StartLevelScreen(scene) {
            var _this = _super.call(this, scene) || this;
            _this.backgroundAlpha = 0.75;
            _this.levelNumber = 1;
            _this.name = "start_level_screen";
            _this.addBack();
            _this.addStars();
            _this.addPopup();
            _this.addPlayButton();
            _this.bringToTop(_this.popup);
            return _this;
        }
        StartLevelScreen.prototype.addBack = function () {
            this.background = this.scene.add.image(0, 0, "levels_map", "black_rect");
            this.background.alpha = this.backgroundAlpha;
            this.add(this.background);
        };
        StartLevelScreen.prototype.addStars = function () {
            var props = {
                atlas: "levels_map",
                activeStarFrame: "popup/star_with_glow",
                inactiveStarFrame: "popup/star_inactive",
                whiteStarFrame: "popup/star_white",
            };
            this.stars = new game.LevelCompleteStars(this.scene, props);
            this.stars.startFloating();
            this.add(this.stars);
        };
        StartLevelScreen.prototype.addPopup = function () {
            this.popup = new game.StartLevelPopup(this.scene);
            this.popup.closeButton.on(ButtonEvent.RELEASE, this.hide, this);
            this.add(this.popup);
        };
        StartLevelScreen.prototype.addPlayButton = function () {
            this.playButton = this.scene.add.button("levels_map", "popup/button_play", this);
            this.playButton.setScrollFactor(0, 0);
        };
        StartLevelScreen.prototype.resize = function () {
            this.resizeBackground();
            this.alignPopup();
            this.alignStars();
            this.alignPlayButton();
        };
        StartLevelScreen.prototype.resizeBackground = function () {
            this.background.setDisplaySize(game.Config.GAME_WIDTH + 4, game.Config.GAME_HEIGHT + 4);
            this.background.x = game.Config.HALF_GAME_WIDTH;
            this.background.y = game.Config.HALF_GAME_HEIGHT;
        };
        StartLevelScreen.prototype.alignPopup = function () {
            var maxWidth = game.Config.GAME_WIDTH * 0.8;
            var maxHeight = game.Config.GAME_HEIGHT * 0.42;
            var scaleX = maxWidth / this.popup.getWidth();
            var scaleY = maxHeight / this.popup.getHeight();
            this.popup.scale = Math.min(scaleX, scaleY);
            this.popup.x = game.Config.HALF_GAME_WIDTH;
            this.popup.y = game.Config.HALF_GAME_HEIGHT;
        };
        StartLevelScreen.prototype.alignStars = function () {
            var popupTop = this.popup.y - (this.popup.getHeight() * this.popup.scale) / 2;
            this.stars.scale = this.popup.scale;
            this.stars.x = game.Config.HALF_GAME_WIDTH;
            this.stars.y = popupTop - 200 * this.popup.scale;
        };
        StartLevelScreen.prototype.alignPlayButton = function () {
            var popupBottom = this.popup.y + (this.popup.getHeight() * this.popup.scale) / 2;
            this.playButton.scale = this.popup.scale;
            this.playButton.x = game.Config.HALF_GAME_WIDTH;
            this.playButton.y = popupBottom + this.playButton.displayHeight / 2 + 50 * this.playButton.scale;
        };
        StartLevelScreen.prototype.updateData = function (data) {
            this.levelNumber = data.levelNumber;
            this.stars.updateData(data.stars);
            this.stars.showActiveStarsInstant();
            this.popup.updateData(data);
        };
        StartLevelScreen.prototype.kill = function () {
            this.visible = false;
            this.active = false;
        };
        StartLevelScreen.prototype.revive = function () {
            this.visible = true;
            this.active = true;
        };
        StartLevelScreen.prototype.show = function () {
            this.emit(StartLevelScreenEvent.SHOW, this);
            this.alpha = 1;
            this.revive();
            this.resize();
            this.showBackground();
            this.showItems(0);
        };
        StartLevelScreen.prototype.showBackground = function () {
            this.background.alpha = 0;
            this.scene.tweens.add({
                targets: this.background,
                duration: 100,
                ease: Phaser.Math.Easing.Cubic.Out,
                alpha: this.backgroundAlpha,
            });
        };
        StartLevelScreen.prototype.showItems = function (staggerDelay) {
            var _this = this;
            if (staggerDelay === void 0) { staggerDelay = 0; }
            ;
            [this.stars, this.popup, this.playButton].forEach(function (item, index) {
                var delay = index * staggerDelay;
                item.alpha = 0;
                _this.scene.tweens.add({
                    delay: delay,
                    targets: item,
                    alpha: { value: 1, ease: Phaser.Math.Easing.Cubic.Out, duration: 200 },
                });
                var originalScale = item.scale;
                item.scale = originalScale * 0.85;
                _this.scene.tweens.add({
                    delay: delay,
                    targets: item,
                    duration: 1000,
                    ease: Phaser.Math.Easing.Elastic.Out,
                    easeParams: [0.1, 0.45],
                    scale: originalScale,
                });
            });
        };
        StartLevelScreen.prototype.hide = function () {
            var _this = this;
            this.scene.tweens.add({
                targets: this,
                duration: 100,
                ease: Phaser.Math.Easing.Cubic.Out,
                alpha: 0,
                onComplete: function () {
                    _this.kill();
                    _this.emit(StartLevelScreenEvent.HIDE, _this);
                },
            });
        };
        StartLevelScreen.prototype.destroy = function (fromScene) {
            _super.prototype.destroy.call(this, fromScene);
        };
        return StartLevelScreen;
    }(Phaser.GameObjects.Container));
    game.StartLevelScreen = StartLevelScreen;
})(game || (game = {}));
var game;
(function (game) {
    var LevelsMapFire = /** @class */ (function (_super) {
        __extends(LevelsMapFire, _super);
        function LevelsMapFire(scene) {
            var _this = _super.call(this, scene) || this;
            _this.originalX = 0;
            _this.originalY = 0;
            _this.name = "fire";
            _this.base = _this.scene.add.image(0, 0, "levels_map", "decor/fire_base");
            _this.flame = _this.scene.add.image(0, 0, "levels_map", "decor/fire_flame");
            _this.add([_this.base, _this.flame]);
            _this.animateFlame();
            return _this;
        }
        LevelsMapFire.prototype.animateFlame = function () {
            this.flame.angle = -4;
            this.scene.tweens.add({
                targets: this.flame,
                duration: 900,
                ease: Phaser.Math.Easing.Sine.InOut,
                angle: Math.abs(this.flame.angle),
                repeat: -1,
                yoyo: true,
            });
            this.scene.tweens.add({
                targets: this.flame,
                duration: 600,
                ease: Phaser.Math.Easing.Sine.InOut,
                scaleX: 1.02,
                scaleY: 0.87,
                repeat: -1,
                yoyo: true,
            });
        };
        return LevelsMapFire;
    }(Phaser.GameObjects.Container));
    game.LevelsMapFire = LevelsMapFire;
})(game || (game = {}));
var game;
(function (game) {
    var LevelMapCloud = /** @class */ (function (_super) {
        __extends(LevelMapCloud, _super);
        function LevelMapCloud(scene, frame, worldWidth) {
            var _this = _super.call(this, scene, 0, 0, "levels_map", frame) || this;
            _this.velocity = 0;
            _this.worldWidth = worldWidth;
            _this.velocity = Phaser.Math.RND.realInRange(0.05, 0.1);
            return _this;
        }
        LevelMapCloud.prototype.preUpdate = function (time, delta) {
            this.x += this.velocity * delta;
            if (this.x > this.worldWidth + this.width / 2) {
                this.x = -this.width / 2;
            }
        };
        LevelMapCloud.prototype.destroy = function (fromScene) {
            _super.prototype.destroy.call(this, fromScene);
        };
        return LevelMapCloud;
    }(Phaser.GameObjects.Image));
    game.LevelMapCloud = LevelMapCloud;
})(game || (game = {}));
var game;
(function (game) {
    var Scrollbar = /** @class */ (function (_super) {
        __extends(Scrollbar, _super);
        function Scrollbar(scene) {
            var _this = _super.call(this, scene, 0, 0, "levels_map", "scrollbar") || this;
            _this.isDragged = false;
            _this.scrollTop = 0;
            _this.scrollBottom = 0;
            _this.scrollHeight = 0;
            _this.setInteractive();
            _this.input.cursor = "pointer";
            _this.on(Phaser.Input.Events.GAMEOBJECT_DRAG_START, _this.onScrollbarDragStart, _this);
            _this.on(Phaser.Input.Events.GAMEOBJECT_DRAG_END, _this.onScrollbarDragEnd, _this);
            return _this;
        }
        Scrollbar.prototype.onScrollbarDragStart = function (pointer) {
            this.isDragged = true;
        };
        Scrollbar.prototype.onScrollbarDragEnd = function () {
            this.isDragged = false;
        };
        Scrollbar.prototype.destroy = function (fromScene) {
            _super.prototype.destroy.call(this, fromScene);
        };
        Scrollbar.prototype.onResize = function () {
            var scrollOffset = this.displayHeight / 2 + 6 * this.scaleY;
            this.scrollTop = scrollOffset;
            this.scrollBottom = game.Config.GAME_HEIGHT - scrollOffset;
            this.scrollHeight = this.scrollBottom - this.scrollTop;
        };
        return Scrollbar;
    }(Phaser.GameObjects.Image));
    game.Scrollbar = Scrollbar;
})(game || (game = {}));
var game;
(function (game) {
    var Avatar = /** @class */ (function (_super) {
        __extends(Avatar, _super);
        function Avatar(scene) {
            var _this = _super.call(this, scene) || this;
            _this.originalScale = 1;
            _this.wasInCamera = false;
            _this.name = "fox_avatar";
            _this.addFox();
            _this.addBack();
            _this.setInteractive(_this.back.getBounds(), Phaser.Geom.Rectangle.Contains);
            _this.input.cursor = "pointer";
            return _this;
        }
        Avatar.prototype.enableInput = function () {
            this.input.enabled = true;
        };
        Avatar.prototype.disableInput = function () {
            this.input.enabled = false;
        };
        Avatar.prototype.addFox = function () {
            this.fox = this.scene.add.image(0, 0, "levels_map", "avatar_fox");
            this.add(this.fox);
        };
        Avatar.prototype.addBack = function () {
            this.back = this.scene.add.image(0, 0, "levels_map", "avatar_back");
            this.add(this.back);
        };
        Avatar.prototype.lookUp = function () {
            this.back.angle = -180;
        };
        Avatar.prototype.lookBottom = function () {
            this.back.angle = 0;
        };
        Avatar.prototype.getDisplayHeight = function () {
            return (this.fox.height + 50) * this.scaleY;
        };
        Avatar.prototype.scaleTo = function (scaleK) {
            if (this.scaleTween) {
                this.scaleTween.remove();
                this.scaleTween = null;
            }
            this.scaleTween = this.scene.tweens.add({
                targets: this,
                duration: 200,
                ease: Phaser.Math.Easing.Linear.Linear,
                scale: this.originalScale * scaleK,
            });
            return this.scaleTween;
        };
        Avatar.prototype.startWiggle = function () {
            this.wiggleTween = this.scene.tweens.add({
                targets: this,
                duration: 600,
                ease: Phaser.Math.Easing.Sine.InOut,
                scale: this.originalScale * 0.9,
                repeat: -1,
                yoyo: true,
            });
        };
        Avatar.prototype.stopWiggle = function () {
            if (this.wiggleTween) {
                this.wiggleTween.remove();
                this.wiggleTween = null;
            }
        };
        return Avatar;
    }(Phaser.GameObjects.Container));
    game.Avatar = Avatar;
})(game || (game = {}));
var game;
(function (game) {
    var LanguagesButton = /** @class */ (function (_super) {
        __extends(LanguagesButton, _super);
        function LanguagesButton(scene, parent) {
            var _this = _super.call(this, scene) || this;
            if (parent) {
                parent.add(_this);
            }
            else {
                _this.scene.add.existing(_this);
            }
            _this.addBack();
            _this.addArrows();
            _this.addText();
            return _this;
        }
        LanguagesButton.prototype.addBack = function () {
            this.back = this.scene.add.image(0, 0, "levels_map", "settings_screen/button_large_base");
            this.add(this.back);
        };
        LanguagesButton.prototype.addArrows = function () {
            var dx = 160;
            var y = -6;
            this.leftArrow = this.scene.add.button("levels_map", "settings_screen/arrow_left", this);
            this.leftArrow.x = -dx;
            this.rightArrow = this.scene.add.button("levels_map", "settings_screen/arrow_right", this);
            this.rightArrow.x = dx;
            var arrows = [this.leftArrow, this.rightArrow];
            arrows.forEach(function (arrow) {
                arrow.setScrollFactor(0);
                arrow.y = y;
            });
        };
        LanguagesButton.prototype.addText = function () {
            this.text = this.scene.add.text(0, 0, "Language", this.getTextStyle());
            this.text.setOrigin(0.5, 0.5);
            this.text.x = 6;
            this.text.y = -12;
            this.add(this.text);
        };
        LanguagesButton.prototype.getTextStyle = function () {
            return {
                color: "#FFFFFF",
                fontFamily: game.GameFont.SOUSES,
                fontStyle: game.FontWeight.BLACK,
                fontSize: "45px",
                align: "center",
                padding: {
                    x: 2,
                    y: 6,
                },
                shadow: {
                    fill: true,
                    blur: 0,
                    offsetY: 3,
                    color: "rgba(0,0,0,0.2)",
                },
            };
        };
        LanguagesButton.prototype.updateText = function (content) {
            var _this = this;
            this.scene.tweens.killTweensOf(this.text);
            this.scene.tweens.add({
                targets: this.text,
                duration: 66,
                ease: Phaser.Math.Easing.Linear.Linear,
                alpha: 0,
                onComplete: function () {
                    _this.text.setText(content);
                    _this.adjustTextSize();
                    _this.scene.tweens.add({
                        targets: _this.text,
                        duration: 150,
                        ease: Phaser.Math.Easing.Cubic.Out,
                        alpha: 1,
                    });
                },
            });
        };
        LanguagesButton.prototype.adjustTextSize = function () {
            var left = this.leftArrow.right;
            var right = this.rightArrow.left;
            var width = right - left;
            var maxWidth = width * 0.9;
            this.text.scale = Math.min(1, maxWidth / this.text.width);
        };
        return LanguagesButton;
    }(Phaser.GameObjects.Container));
    game.LanguagesButton = LanguagesButton;
})(game || (game = {}));
///<reference path='LanguagesButton.ts' />
var game;
(function (game) {
    var ToggleButtonState = Phaser.GameObjects.ToggleButtonState;
    var ButtonEvent = Phaser.GameObjects.ButtonEvent;
    var SettingsScreenContent = /** @class */ (function (_super) {
        __extends(SettingsScreenContent, _super);
        function SettingsScreenContent(scene, atlasKey) {
            var _this = _super.call(this, scene) || this;
            _this.atlasKey = atlasKey;
            _this.name = "buttons_container";
            _this.addBackground();
            _this.addButtons();
            _this.addRoboWhaleInfo();
            _this.alignItems();
            _this.settingsContent = [_this.soundButton, _this.deleteButton, _this.fullscreenButton, _this.languagesButton];
            _this.settingsContent.forEach(function (button) {
                button.setScrollFactor(0);
            });
            _this.creditsContent = [_this.robowhaleInfo];
            _this.settingsButton.buttonState = ToggleButtonState.STATE_2;
            _this.showSettingsContent();
            return _this;
        }
        SettingsScreenContent.prototype.showContent = function (content) {
            content.forEach(function (item) { return (item.visible = true); });
            this.scene.tweens.add({
                targets: content,
                alpha: { from: 0, to: 1, ease: Phaser.Math.Easing.Cubic.Out, duration: 200 },
                scale: { from: 0.75, to: 1, ease: Phaser.Math.Easing.Back.Out, duration: 400 },
            });
        };
        SettingsScreenContent.prototype.hideContent = function (content) {
            content.forEach(function (item) { return (item.visible = false); });
        };
        SettingsScreenContent.prototype.showSettingsContent = function () {
            this.showContent(this.settingsContent);
            this.hideContent(this.creditsContent);
            this.settingsButton.disableInteractive();
            this.creditsButton.buttonState = ToggleButtonState.STATE_1;
            this.creditsButton.setInteractive();
        };
        SettingsScreenContent.prototype.showCreditsContent = function () {
            this.showContent(this.creditsContent);
            this.hideContent(this.settingsContent);
            this.creditsButton.disableInteractive();
            this.settingsButton.buttonState = ToggleButtonState.STATE_1;
            this.settingsButton.setInteractive();
        };
        SettingsScreenContent.prototype.sendCreditsCheckEvent = function () {
            this.scene.analytics.sendDesignEvent("Credits");
        };
        SettingsScreenContent.prototype.addBackground = function () {
            this.background = this.scene.add.image(0, 0, this.atlasKey, "white_rect");
            this.background.displayWidth = 465;
            this.background.displayHeight = 485;
            this.background.alpha = 0;
            this.add(this.background);
        };
        SettingsScreenContent.prototype.addButtons = function () {
            this.settingsButton = this.scene.add.toggleButton(this.atlasKey, "settings_screen/button_settings", "settings_screen/button_settings_inactive", this);
            this.settingsButton.on(Phaser.Input.Events.GAMEOBJECT_POINTER_UP, this.showSettingsContent, this);
            this.settingsButton.setScrollFactor(0);
            this.creditsButton = this.scene.add.toggleButton(this.atlasKey, "settings_screen/button_credits", "settings_screen/button_credits_inactive", this);
            this.creditsButton.on(Phaser.Input.Events.GAMEOBJECT_POINTER_UP, this.showCreditsContent, this);
            this.creditsButton.once(Phaser.Input.Events.GAMEOBJECT_POINTER_UP, this.sendCreditsCheckEvent, this);
            this.creditsButton.setScrollFactor(0);
            this.soundButton = this.scene.add.soundButton(this.atlasKey, "settings_screen/button_sound_on", "settings_screen/button_sound_off", this);
            this.deleteButton = this.scene.add.button(this.atlasKey, "settings_screen/button_delete", this);
            this.deleteButton.on(ButtonEvent.RELEASE, this.onDeleteDataButtonClick, this);
            this.fullscreenButton = this.scene.add.toggleButton(this.atlasKey, "settings_screen/button_fullscreen_on", "settings_screen/button_fullscreen_off", this);
            this.disableFullscreenButton();
            this.addLanguageButton();
        };
        SettingsScreenContent.prototype.addLanguageButton = function () {
            var content = game.getLanguageTitle(this.scene.game.texts.language);
            this.languagesButton = new game.LanguagesButton(this.scene, this);
            this.languagesButton.leftArrow.on(ButtonEvent.PRESS, this.updateLanguage.bind(this, -1));
            this.languagesButton.rightArrow.on(ButtonEvent.PRESS, this.updateLanguage.bind(this, 1));
            this.languagesButton.updateText(content);
        };
        SettingsScreenContent.prototype.updateLanguage = function (direction) {
            var texts = this.scene.game.texts;
            var currentLanguage = texts.language;
            var languages = texts.allLanguages;
            var currentIndex = languages.indexOf(currentLanguage);
            var newIndex = Phaser.Math.Wrap(currentIndex + direction, 0, languages.length);
            var newLanguage = languages[newIndex];
            this.scene.game.store.saveValue(game.GameStoreKey.LANGUAGE, newLanguage);
            this.scene.game.texts.setLanguage(newLanguage);
            this.languagesButton.updateText(game.getLanguageTitle(newLanguage));
        };
        SettingsScreenContent.prototype.onDeleteDataButtonClick = function () {
            var _this = this;
            if (this.scene.game.device.os.iOS === false) {
                this.clearSavedData();
                return;
            }
            this.scene.game.audio.suspendAudioContext()
                .finally(function () {
                _this.clearSavedData();
                _this.scene.game.audio.resumeAudioContext();
            });
        };
        SettingsScreenContent.prototype.clearSavedData = function () {
            var title = this.scene.texts.clear_save;
            var subtitle = this.scene.texts.progress_lost_warinig;
            var doClear = typeof window.confirm !== "undefined" ? window.confirm(title + "\n" + subtitle) : true;
            if (doClear) {
                this.scene.game.store.clear();
                this.scene.game.restartScene(this.scene.scene.key);
            }
        };
        SettingsScreenContent.prototype.addRoboWhaleInfo = function () {
            this.robowhaleInfo = this.scene.add.image(0, 0, this.atlasKey, "settings_screen/robowhale_info");
            // this.robowhaleInfo.setInteractive()
            // this.robowhaleInfo.input.cursor = "pointer"
            // this.robowhaleInfo.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.onRobowhaleClick, this)
            this.add(this.robowhaleInfo);
        };
        SettingsScreenContent.prototype.onRobowhaleClick = function () {
            window.open("https://robowhale.com/?utm_source=Bouncy_Woods");
        };
        SettingsScreenContent.prototype.alignItems = function () {
            var bounds = this.background.getBounds();
            var xOffset = 86;
            var topButtonsY = bounds.top + this.settingsButton.displayHeight / 2;
            this.settingsButton.x = bounds.centerX - xOffset;
            this.settingsButton.y = topButtonsY;
            this.creditsButton.x = bounds.centerX + xOffset;
            this.creditsButton.y = topButtonsY;
            var middleButtonsY = bounds.centerY;
            this.soundButton.x = bounds.left + this.soundButton.displayWidth / 2;
            this.soundButton.y = middleButtonsY;
            this.deleteButton.x = bounds.centerX;
            this.deleteButton.y = middleButtonsY;
            this.fullscreenButton.x = bounds.right - this.fullscreenButton.displayWidth / 2;
            this.fullscreenButton.y = middleButtonsY;
            this.languagesButton.y = bounds.bottom - this.languagesButton.getBounds().height / 2;
            this.robowhaleInfo.bottom = bounds.bottom;
        };
        SettingsScreenContent.prototype.disableFullscreenButton = function () {
            this.fullscreenButton.setFrame("settings_screen/button_fullscreen_disabled");
            this.fullscreenButton.removeInteractive();
        };
        SettingsScreenContent.prototype.getWidth = function () {
            return this.background.displayWidth;
        };
        return SettingsScreenContent;
    }(Phaser.GameObjects.Container));
    game.SettingsScreenContent = SettingsScreenContent;
})(game || (game = {}));
///<reference path='SettingsScreenContent.ts' />
var game;
(function (game) {
    var SettingsScreenEvent;
    (function (SettingsScreenEvent) {
        SettingsScreenEvent["SHOW"] = "SettingsScreen_show";
        SettingsScreenEvent["HIDE"] = "SettingsScreen_hide";
    })(SettingsScreenEvent = game.SettingsScreenEvent || (game.SettingsScreenEvent = {}));
    var SettingsScreen = /** @class */ (function (_super) {
        __extends(SettingsScreen, _super);
        function SettingsScreen(scene) {
            var _this = _super.call(this, scene) || this;
            _this.atlasKey = "levels_map";
            _this.backgroundAlpha = 0.85;
            _this.name = "settings_screen";
            _this.addBackground();
            _this.addCloseButton();
            _this.addContent();
            _this.addBuildInfo();
            return _this;
        }
        SettingsScreen.prototype.addBackground = function () {
            this.background = this.scene.add.image(0, 0, this.atlasKey, "black_rect");
            this.background.alpha = this.backgroundAlpha;
            this.add(this.background);
        };
        SettingsScreen.prototype.addCloseButton = function () {
            this.closeButton = this.scene.add.button(this.atlasKey, "settings_screen/button_small_close", this);
            this.closeButton.setScrollFactor(0);
        };
        SettingsScreen.prototype.addContent = function () {
            this.content = new game.SettingsScreenContent(this.scene, this.atlasKey);
            this.add(this.content);
        };
        SettingsScreen.prototype.addBuildInfo = function () {
            var buildVersion = window.game.config.build_version;
            var buildDate = window.game.config.build_time;
            var content = "Build #" + buildVersion + " " + buildDate;
            var style = {
                fontFamily: game.GameFont.SOUSES,
                fontStyle: "normal",
                fontSize: "24px",
                color: "#ffffff",
            };
            var alpha = 0.75;
            this.buildInfo = this.scene.add.text(0, 0, content, style);
            this.buildInfo.setOrigin(0.5, 1);
            this.buildInfo.alpha = alpha;
            this.buildInfo.setData("originalAlpha", alpha);
            this.add(this.buildInfo);
        };
        SettingsScreen.prototype.resize = function (settingsButton) {
            this.resizeBackground();
            this.alignCloseButton(settingsButton);
            this.resizeButtons();
            this.alignBuildInfo();
        };
        SettingsScreen.prototype.resizeBackground = function () {
            this.background.setDisplaySize(game.Config.GAME_WIDTH + 4, game.Config.GAME_HEIGHT + 4);
            this.background.x = game.Config.HALF_GAME_WIDTH;
            this.background.y = game.Config.HALF_GAME_HEIGHT;
        };
        SettingsScreen.prototype.alignCloseButton = function (settingsButton) {
            this.closeButton.scale = settingsButton.scale;
            this.closeButton.x = settingsButton.x;
            this.closeButton.y = settingsButton.y;
        };
        SettingsScreen.prototype.resizeButtons = function () {
            var maxWidth = game.Config.GAME_WIDTH * 0.6;
            this.content.scale = Math.min(1, maxWidth / this.content.getWidth());
            this.content.x = game.Config.HALF_GAME_WIDTH;
            this.content.y = game.Config.HALF_GAME_HEIGHT;
        };
        SettingsScreen.prototype.alignBuildInfo = function () {
            this.buildInfo.scale = this.content.scale;
            this.buildInfo.x = game.Config.HALF_GAME_WIDTH;
            this.buildInfo.y = game.Config.GAME_HEIGHT - 25;
        };
        SettingsScreen.prototype.kill = function () {
            this.active = false;
            this.visible = false;
        };
        SettingsScreen.prototype.revive = function () {
            this.active = true;
            this.visible = true;
        };
        SettingsScreen.prototype.show = function () {
            this.revive();
            this.alpha = 1;
            this.scene.tweens.add({
                targets: this.background,
                duration: 200,
                ease: Phaser.Math.Easing.Cubic.Out,
                alpha: { from: 0, to: this.backgroundAlpha },
            });
            this.scene.tweens.add({
                targets: this.buildInfo,
                duration: 1000,
                ease: Phaser.Math.Easing.Cubic.Out,
                alpha: { from: 0, to: this.buildInfo.getData("originalAlpha") },
            });
            var originalScale = this.content.scale;
            this.scene.tweens.add({
                targets: this.content,
                alpha: { from: 0, to: 1, duration: 200, ease: Phaser.Math.Easing.Cubic.Out },
                scale: {
                    from: originalScale * 0.8,
                    to: originalScale,
                    duration: 400,
                    ease: Phaser.Math.Easing.Back.Out,
                },
            });
            this.emit(SettingsScreenEvent.SHOW, this);
        };
        SettingsScreen.prototype.hide = function () {
            var _this = this;
            this.scene.tweens.add({
                targets: this,
                duration: 100,
                ease: Phaser.Math.Easing.Cubic.Out,
                alpha: 0,
                onComplete: function () {
                    _this.kill();
                    _this.emit(SettingsScreenEvent.HIDE, _this);
                },
            });
        };
        return SettingsScreen;
    }(Phaser.GameObjects.Container));
    game.SettingsScreen = SettingsScreen;
})(game || (game = {}));
///<reference path='LevelIcon.ts' />
///<reference path='startLevel/StartLevelScreen.ts' />
///<reference path='decor/LevelsMapFire.ts' />
///<reference path='decor/LevelMapCloud.ts' />
///<reference path='Scrollbar.ts' />
///<reference path='Avatar.ts' />
///<reference path='./settings/SettingsScreen.ts' />
var game;
(function (game) {
    var FixedKeyControl = Phaser.Cameras.Controls.FixedKeyControl;
    var ButtonEvent = Phaser.GameObjects.ButtonEvent;
    var EasingString = Phaser.Math.EasingString;
    var LevelsMapDecor;
    (function (LevelsMapDecor) {
        LevelsMapDecor["CLOUD"] = "cloud";
        LevelsMapDecor["FIRE"] = "fire";
        LevelsMapDecor["FOX"] = "fox";
        LevelsMapDecor["FOX_IN_HOLE"] = "fox_in_hole";
    })(LevelsMapDecor = game.LevelsMapDecor || (game.LevelsMapDecor = {}));
    var LevelsMap = /** @class */ (function (_super) {
        __extends(LevelsMap, _super);
        function LevelsMap() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.pointerWasDragged = false;
            return _this;
        }
        LevelsMap.prototype.init = function () {
            this.events.once("shutdown", this.shutdown, this);
            this.config = this.cache.json.get(LevelsMap.CONFIG_KEY);
            this.pointerDownPosition = { x: 0, y: 0 };
            this.pointerWasDragged = false;
            this.cameraScrollTween = null;
            this.wheelListener = null;
        };
        LevelsMap.prototype.create = function () {
            this.addMainContainer();
            this.addBackgrounds();
            this.addFoxInHole();
            this.addLevelIcons();
            this.addFire();
            this.addFireEmitterManager();
            this.addAvatar();
            this.addClouds();
            this.addScrollbar();
            this.addSettingsButton();
            this.addStartLevelPopup();
            this.addSettingsScreen();
            // this.pointAvatarToLastUnlockedLevel()
            this.setupCamera();
            this.addCameraKeyboardControl();
            this.addCameraScroll();
            this.addPointerCallbacks();
            this.addKeyboardCallbacks();
            this.resize();
            this.doInitialCameraScroll();
            // this.scrollToBottom()
            // this.scrollToLevel(31)
            // this.openStartLevelPopup(21)
            if (utils.NetUtil.getParamBool("unlockLevels")) {
                this.unlockAllLevels();
            }
        };
        LevelsMap.prototype.addMainContainer = function () {
            this.mainContainer = this.add.container(0, 0);
            this.mainContainer.name = "main";
        };
        LevelsMap.prototype.addBackgrounds = function () {
            var _this = this;
            this.backgrounds = this.config.backgrounds.map(function (frame, index) {
                var bg = _this.add.image(0, 0, frame);
                bg.setOrigin(0, 0);
                bg.y = index * bg.height;
                _this.mainContainer.add(bg);
                return bg;
            });
        };
        LevelsMap.prototype.addFoxInHole = function () {
            var config = this.getDecorConfig(LevelsMapDecor.FOX_IN_HOLE);
            if (!config) {
                return;
            }
            this.anims.create({
                key: LevelsMapDecor.FOX_IN_HOLE,
                repeat: -1,
                repeatDelay: 7000,
                frames: this.anims.getFrameNames("levels_map", "decor/fox_in_hole/FOX_in_HOLE"),
                frameRate: 15,
            });
            this.foxInHole = this.add.sprite(0, 0, "levels_map", "decor/fox_in_hole/FOX_in_HOLE0001");
            this.foxInHole.x = config.x;
            this.foxInHole.y = config.y;
            this.foxInHole.anims.delayedPlay(1500, LevelsMapDecor.FOX_IN_HOLE);
            this.mainContainer.add(this.foxInHole);
            this.sys.updateList.add(this.foxInHole);
        };
        LevelsMap.prototype.addLevelIcons = function () {
            var _this = this;
            this.levelIcons = this.config.level_icons.map(function (config) {
                var data = _this.getLevelIconData(config.level_number);
                var icon = new game.LevelIcon(_this, data);
                icon.x = config.x;
                icon.y = config.y;
                icon.setData("type", "LevelIcon");
                _this.mainContainer.add(icon);
                return icon;
            });
            this.lastUnlockedIcon = this.getLastUnlockedLevelIcon();
        };
        LevelsMap.prototype.getLevelIconData = function (levelNumber) {
            var levelResult = this.game.store.getLevelResult(levelNumber);
            if (levelResult) {
                return {
                    levelNumber: levelNumber,
                    complete: true,
                    locked: false,
                    stars: levelResult.stars,
                };
            }
            return {
                levelNumber: levelNumber,
                complete: false,
                locked: this.isLevelLocked(levelNumber),
                stars: 0,
            };
        };
        LevelsMap.prototype.isLevelLocked = function (levelNumber) {
            if (levelNumber === 1) {
                return false;
            }
            var prevLevelNumber = levelNumber - 1;
            var prevLevelResult = this.game.store.getLevelResult(prevLevelNumber);
            return !prevLevelResult;
        };
        LevelsMap.prototype.gotoLevel = function (levelNumber) {
            this.game.changeScene(this.scene.key, game.SceneKey.GAMEPLAY_ROOT, { levelNumber: levelNumber });
        };
        LevelsMap.prototype.addFire = function () {
            var fireConfig = this.getDecorConfig(LevelsMapDecor.FIRE);
            if (!fireConfig) {
                return;
            }
            this.fire = new game.LevelsMapFire(this);
            this.fire.originalX = fireConfig.x;
            this.fire.originalY = fireConfig.y;
            this.add.existing(this.fire);
        };
        LevelsMap.prototype.getDecorConfig = function (decorType) {
            return this.config.decor.find(function (config) { return config.type === decorType; });
        };
        LevelsMap.prototype.addFireEmitterManager = function () {
            this.fireEmitterManager = this.add.particles("levels_map", "decor/fire_particle");
        };
        LevelsMap.prototype.addAvatar = function () {
            this.avatar = new game.Avatar(this);
            this.avatar.on(Phaser.Input.Events.GAMEOBJECT_POINTER_UP, this.onAvatarClick, this);
            this.add.existing(this.avatar);
        };
        LevelsMap.prototype.onAvatarClick = function () {
            var _this = this;
            if (this.cameraScrollTween) {
                return;
            }
            var levelIcon = this.lastUnlockedIcon;
            if (!levelIcon) {
                return;
            }
            this.game.audio.playClickSound();
            this.cameraScroll.resetScroll();
            var targetY = Phaser.Display.Bounds.GetCenterY(levelIcon) * this.mainContainer.scale - game.Config.GAME_HEIGHT / 2;
            this.cameraScrollTween = this.tweens.add({
                targets: this.camera,
                duration: 500,
                ease: Phaser.Math.Easing.Quadratic.Out,
                scrollY: targetY,
                onComplete: function () {
                    _this.cameraScrollTween = null;
                },
            });
        };
        LevelsMap.prototype.addClouds = function () {
            var _this = this;
            this.clouds = this.config.decor
                .filter(function (item) { return item.type === LevelsMapDecor.CLOUD; })
                .map(function (cloudConfig) {
                var cloud = new game.LevelMapCloud(_this, cloudConfig.frame, _this.backgrounds[0].width);
                cloud.x = cloudConfig.x;
                cloud.y = cloudConfig.y;
                _this.mainContainer.add(cloud);
                _this.sys.updateList.add(cloud);
                return cloud;
            });
        };
        LevelsMap.prototype.addScrollbar = function () {
            this.scrollbar = new game.Scrollbar(this);
            this.scrollbar.setScrollFactor(0);
            this.scrollbar.alpha = 0.5;
            this.scrollbar.on(Phaser.Input.Events.GAMEOBJECT_DRAG_START, this.onDragStart, this);
            this.scrollbar.on(Phaser.Input.Events.GAMEOBJECT_DRAG_END, this.onDragEnd, this);
            this.add.existing(this.scrollbar);
            this.input.setDraggable(this.scrollbar);
        };
        LevelsMap.prototype.onDragStart = function () {
            var _this = this;
            document.onpointermove = function (event) {
                _this.setScrollbarY(_this.scale.transformY(event.pageY));
                _this.updateCameraByScrollbar();
            };
        };
        LevelsMap.prototype.onDragEnd = function () {
            document.onpointermove = null;
        };
        LevelsMap.prototype.setScrollbarY = function (value) {
            this.scrollbar.y = Phaser.Math.Clamp(value, this.scrollbar.scrollTop, this.scrollbar.scrollBottom);
        };
        LevelsMap.prototype.updateCameraByScrollbar = function () {
            var percent = (this.scrollbar.y - this.scrollbar.scrollTop) / this.scrollbar.scrollHeight;
            var cameraBounds = this.camera.getBounds();
            var cameraTop = cameraBounds.y;
            var cameraBottom = cameraBounds.bottom - game.Config.GAME_HEIGHT;
            this.camera.scrollY = (cameraBottom - cameraTop) * percent;
        };
        LevelsMap.prototype.addStartLevelPopup = function () {
            this.startLevelPopup = new game.StartLevelScreen(this);
            this.startLevelPopup.playButton.once(ButtonEvent.PRESS, this.onPlayButtonClick, this);
            this.startLevelPopup.setScrollFactor(0, 0);
            this.startLevelPopup.on(game.StartLevelScreenEvent.SHOW, this.onStartLevelPopupShow, this);
            this.startLevelPopup.on(game.StartLevelScreenEvent.HIDE, this.onStartLevelPopupHide, this);
            this.startLevelPopup.kill();
            this.add.existing(this.startLevelPopup);
        };
        LevelsMap.prototype.onPlayButtonClick = function () {
            var _this = this;
            this.poki.commercialBreak("LevelMap:PlayButton")
                .catch(function () { })
                .finally(function () {
                _this.gotoLevel(_this.startLevelPopup.levelNumber);
            });
        };
        LevelsMap.prototype.onStartLevelPopupShow = function () {
            this.settingsButton.enabled = false;
            this.disableScroll();
            this.disableLevelIcons();
        };
        LevelsMap.prototype.disableScroll = function () {
            // this.scrollbar.disableInteractive()
            this.cameraScroll.removePointerListeners();
            this.cameraScroll.settings.verticalWheel = false;
            this.cameraKeyboardControl.active = false;
        };
        LevelsMap.prototype.onStartLevelPopupHide = function () {
            // this.scrollbar.setInteractive()
            this.settingsButton.enabled = true;
            this.enableScroll();
            this.enableLevelIcons();
        };
        LevelsMap.prototype.enableScroll = function () {
            this.cameraScroll.addPointerListeners();
            this.cameraScroll.settings.verticalWheel = true;
            this.cameraKeyboardControl.active = true;
        };
        LevelsMap.prototype.enableLevelIcons = function () {
            this.levelIcons
                .filter(function (icon) { return icon.iconState !== game.LevelIconState.LOCKED; })
                .forEach(function (icon) {
                icon.setInteractive();
            });
        };
        LevelsMap.prototype.disableLevelIcons = function () {
            this.levelIcons
                .filter(function (icon) { return icon.iconState !== game.LevelIconState.LOCKED; })
                .forEach(function (icon) {
                icon.disableInteractive();
            });
        };
        LevelsMap.prototype.addSettingsButton = function () {
            this.settingsButton = this.add.button("levels_map", "settings_screen/button_small_settings");
            this.settingsButton.on(ButtonEvent.PRESS, this.showSettings, this);
            this.settingsButton.setScrollFactor(0);
        };
        LevelsMap.prototype.addSettingsScreen = function () {
            this.settingsScreen = new game.SettingsScreen(this);
            this.settingsScreen.closeButton.on(ButtonEvent.PRESS, this.hideSettings, this);
            this.settingsScreen.on(game.SettingsScreenEvent.SHOW, this.onSettingsShow, this);
            this.settingsScreen.on(game.SettingsScreenEvent.HIDE, this.onSettingsHide, this);
            this.settingsScreen.kill();
            this.settingsScreen.setScrollFactor(0);
            this.add.existing(this.settingsScreen);
        };
        LevelsMap.prototype.onSettingsShow = function () {
            this.settingsScreen.closeButton.enabled = true;
            this.settingsButton.enabled = false;
            this.disableScroll();
            this.disableLevelIcons();
        };
        LevelsMap.prototype.onSettingsHide = function () {
            this.settingsScreen.closeButton.enabled = false;
            this.settingsButton.enabled = true;
            this.enableScroll();
            this.enableLevelIcons();
        };
        LevelsMap.prototype.showSettings = function () {
            if (this.settingsScreen.visible === false) {
                this.settingsScreen.show();
            }
        };
        LevelsMap.prototype.hideSettings = function () {
            this.settingsScreen.hide();
        };
        LevelsMap.prototype.addPointerCallbacks = function () {
            this.input.on(Phaser.Input.Events.POINTER_DOWN, this.onPointerDown, this);
            this.input.on(Phaser.Input.Events.POINTER_UP, this.onPointerUp, this);
            this.wheelListener = this.onWheel.bind(this);
            this.game.canvas.parentElement.addEventListener("wheel", this.wheelListener);
        };
        LevelsMap.prototype.onWheel = function (event) {
            event.preventDefault();
            if (this.cameraScroll.settings.verticalWheel === false) {
                return;
            }
            this.cameraScroll.velocityWheelY = -event.deltaY / 2.5;
        };
        LevelsMap.prototype.onPointerDown = function (pointer) {
            this.pointerDownPosition.x = pointer.x;
            this.pointerDownPosition.y = pointer.y;
        };
        LevelsMap.prototype.onPointerUp = function (pointer, items) {
            var distance = Phaser.Math.Distance.Between(this.pointerDownPosition.x, this.pointerDownPosition.y, pointer.x, pointer.y);
            this.pointerWasDragged = distance > 5;
            if (this.pointerWasDragged) {
                return;
            }
            var levelIcon = items.find(function (item) { return item.getData("type") === "LevelIcon"; });
            if (levelIcon) {
                this.onLevelIconClick(levelIcon);
            }
        };
        LevelsMap.prototype.onLevelIconClick = function (levelIcon) {
            this.game.audio.playClickSound();
            this.openStartLevelPopup(levelIcon.levelNumber);
        };
        LevelsMap.prototype.openStartLevelPopup = function (levelNumber) {
            var data = this.getStartLevelPopupData(levelNumber);
            if (!data) {
                return;
            }
            this.startLevelPopup.updateData(data);
            this.startLevelPopup.show();
        };
        LevelsMap.prototype.getStartLevelPopupData = function (levelNumber) {
            var levelConfig = this.game.levelConfigs.get(levelNumber);
            if (!levelConfig) {
                console.warn("Config for level " + levelNumber + " doesn't exist!");
                return null;
            }
            var levelResult = this.game.store.getLevelResult(levelNumber);
            if (levelResult) {
                return {
                    levelNumber: levelNumber,
                    levelComplete: true,
                    highscore: levelResult.highscore,
                    stars: levelResult.stars,
                    blocksNum: levelConfig.generator.targetItemsNum,
                    blocksType: levelConfig.generator.targetItemType,
                };
            }
            return {
                levelNumber: levelNumber,
                levelComplete: false,
                highscore: 0,
                stars: 0,
                blocksNum: levelConfig.generator.targetItemsNum,
                blocksType: levelConfig.generator.targetItemType,
            };
        };
        LevelsMap.prototype.addKeyboardCallbacks = function () {
            if (game.Main.development) {
                if (game.Main.editorEnabled) {
                    this.input.keyboard.on("keydown-E", this.gotoLevelsMapEditor, this);
                }
                this.input.keyboard.on("keydown-D", this.gotoLevelsMapDev, this);
                this.input.keyboard.on("keydown-U", this.unlockAllLevels, this);
                this.input.keyboard.on("keydown-L", this.lockAllLevels, this);
            }
            this.input.keyboard.on("keydown-ESC", this.onEscPressed, this);
            this.input.keyboard.on("keydown-R", this.restart, this);
            this.input.keyboard.on("keydown-SPACE", this.onSpacePressed, this);
            this.input.keyboard.on("keydown-PAGE_DOWN", this.onScollPageDown, this);
            this.input.keyboard.on("keydown-PAGE_UP", this.onScollPageUp, this);
            this.input.keyboard.on("keydown-HOME", this.scrollToTop, this);
            this.input.keyboard.on("keydown-END", this.scrollToBottom, this);
            this.input.keyboard.on("keydown-LEFT", this.scrollToLastUnlockedLevel, this);
            this.input.keyboard.on("keydown-RIGHT", this.scrollToLastUnlockedLevel, this);
        };
        LevelsMap.prototype.unlockAllLevels = function () {
            this.levelIcons.filter(function (icon) { return icon.iconState === game.LevelIconState.LOCKED; }).forEach(function (icon) { return icon.setUnlocked(); });
            this.lastUnlockedIcon = this.getLastUnlockedLevelIcon();
        };
        LevelsMap.prototype.lockAllLevels = function () {
            this.levelIcons.forEach(function (icon) { return icon.setLocked(); });
        };
        LevelsMap.prototype.gotoLevelsMapDev = function () {
            this.game.changeScene(this.scene.key, game.SceneKey.LEVELS_MAP_DEV);
        };
        LevelsMap.prototype.gotoLevelsMapEditor = function () {
            this.game.changeScene(this.scene.key, game.SceneKey.LEVELS_MAP_EDITOR);
        };
        LevelsMap.prototype.onEscPressed = function () {
            if (this.startLevelPopup.visible) {
                this.startLevelPopup.hide();
                return;
            }
            this.gotoMainMenu();
        };
        LevelsMap.prototype.gotoMainMenu = function () {
            // this.game.changeScene(SceneKey.LEVELS_MAP, SceneKey.MAIN_MENU)
        };
        LevelsMap.prototype.restart = function () {
            this.game.changeScene(this.scene.key, this.scene.key);
        };
        LevelsMap.prototype.onSpacePressed = function () {
            if (this.settingsScreen.visible) {
                return;
            }
            if (this.startLevelPopup.visible) {
                this.gotoLevel(this.startLevelPopup.levelNumber);
                return;
            }
            var levelIcon = this.getLastUnlockedLevelIcon();
            if (levelIcon) {
                this.scrollToLevelIcon(levelIcon);
                this.openStartLevelPopup(levelIcon.levelNumber);
            }
        };
        LevelsMap.prototype.onScollPageDown = function () {
            this.camera.scrollY += game.Config.GAME_HEIGHT;
        };
        LevelsMap.prototype.onScollPageUp = function () {
            this.camera.scrollY -= game.Config.GAME_HEIGHT;
        };
        LevelsMap.prototype.scrollToBottom = function () {
            this.camera.scrollY = this.mainContainer.getBounds().height;
        };
        LevelsMap.prototype.scrollToTop = function () {
            this.camera.scrollY = 0;
        };
        LevelsMap.prototype.scrollToLastUnlockedLevel = function () {
            var levelIcon = this.getLastUnlockedLevelIcon();
            if (levelIcon) {
                this.scrollToLevelIcon(levelIcon);
            }
        };
        LevelsMap.prototype.scrollToLevel = function (levelNumber) {
            var levelIcon = this.levelIcons.find(function (icon) { return icon.levelNumber === levelNumber; });
            if (levelIcon) {
                this.scrollToLevelIcon(levelIcon);
            }
        };
        LevelsMap.prototype.scrollToLevelIcon = function (levelIcon) {
            this.camera.scrollY = Phaser.Display.Bounds.GetCenterY(levelIcon) * this.mainContainer.scale - game.Config.GAME_HEIGHT / 2;
        };
        LevelsMap.prototype.resize = function () {
            this.resizeMainContainer();
            this.resizeAvatar();
            this.updateFirePositionAndScale();
            this.updateFireEmitter();
            this.updateCameraBounds();
            this.alignScrollbar();
            this.alignSettingsButton();
            this.settingsScreen.resize(this.settingsButton);
            this.startLevelPopup.resize();
        };
        LevelsMap.prototype.resizeMainContainer = function () {
            this.mainContainer.scale = game.Config.GAME_WIDTH / this.backgrounds[0].width;
        };
        LevelsMap.prototype.resizeAvatar = function () {
            this.avatar.scale = this.mainContainer.scale;
            this.avatar.originalScale = this.avatar.scale;
        };
        LevelsMap.prototype.updateFirePositionAndScale = function () {
            if (!this.fire) {
                return;
            }
            this.fire.scale = this.mainContainer.scale;
            this.fire.x = this.fire.originalX * this.fire.scale;
            this.fire.y = this.fire.originalY * this.fire.scale;
        };
        LevelsMap.prototype.updateFireEmitter = function () {
            if (this.fireEmitter) {
                this.fireEmitter.killAll();
                this.fireEmitter.remove();
            }
            this.addFireEmitter();
        };
        LevelsMap.prototype.addFireEmitter = function () {
            var position = this.fire.getWorldPosition();
            var scale = this.mainContainer.scale;
            this.fireEmitter = this.fireEmitterManager.createEmitter({
                frame: "decor/fire_particle",
                x: position.x,
                y: position.y - 45 * scale,
                emitZone: {
                    type: "random",
                    source: this.getFireEmitRect(scale),
                },
                frequency: 200,
                quantity: 1,
                gravityY: -20 * scale,
                speedY: { min: -80 * scale, max: -50 * scale },
                speedX: { min: -30 * scale, max: 30 * scale },
                scale: { start: scale, end: 0, ease: EasingString.Cubic },
                lifespan: 3500,
                on: true,
            });
        };
        LevelsMap.prototype.getFireEmitRect = function (scale) {
            var width = 40 * scale;
            var height = 40 * scale;
            return new Phaser.Geom.Rectangle(-width / 2, -height / 2, width, height);
        };
        LevelsMap.prototype.updateCameraBounds = function () {
            var top = Phaser.Display.Bounds.GetTop(this.backgrounds[0]);
            var bottom = Phaser.Display.Bounds.GetBottom(this.backgrounds[this.backgrounds.length - 1]);
            var totalHeight = bottom - top;
            this.camera.setBounds(0, 0, game.Config.GAME_WIDTH, totalHeight * this.mainContainer.scale);
        };
        LevelsMap.prototype.alignScrollbar = function () {
            var scale = this.mainContainer.scale;
            this.scrollbar.scale = scale;
            this.scrollbar.x = game.Config.GAME_WIDTH - 10 * scale;
            this.scrollbar.onResize();
        };
        LevelsMap.prototype.alignSettingsButton = function () {
            var scale = game.Config.ASSETS_SCALE;
            var margin = 60 * scale;
            this.settingsButton.scale = scale;
            this.settingsButton.x = game.Config.GAME_WIDTH - margin;
            this.settingsButton.y = margin;
        };
        LevelsMap.prototype.setupCamera = function () {
            this.camera = this.cameras.main;
        };
        LevelsMap.prototype.addCameraKeyboardControl = function () {
            var cursors = this.input.keyboard.createCursorKeys();
            this.cameraKeyboardControl = new FixedKeyControl({
                camera: this.camera,
                left: cursors.left,
                right: cursors.right,
                up: cursors.up,
                down: cursors.down,
                speed: 4,
            });
        };
        LevelsMap.prototype.addCameraScroll = function () {
            this.cameraScroll = new game.KineticScroll(this, {
                camera: this.camera,
                kineticMovement: true,
                timeConstantScroll: 300,
                horizontalWheel: false,
                horizontalScroll: false,
                verticalWheel: true,
                verticalScroll: true,
                wheelDeceleration: 0.92,
                scrollMultiplier: 2,
            });
            this.cameraScroll.addPointerListeners();
        };
        LevelsMap.prototype.update = function (time, delta) {
            _super.prototype.update.call(this, time, delta);
            this.cameraKeyboardControl.update(delta);
            this.cameraScroll.update();
            this.updateScrollbar();
            this.updateAvatar();
        };
        LevelsMap.prototype.updateScrollbar = function () {
            if (this.scrollbar.isDragged) {
                return;
            }
            var cameraBounds = this.camera.getBounds();
            var cameraTop = cameraBounds.y;
            var cameraBottom = cameraBounds.bottom - game.Config.GAME_HEIGHT;
            var cameraY = Math.max(0, this.camera.scrollY);
            var percent = Phaser.Math.Clamp(cameraY / (cameraBottom - cameraTop), 0, 1);
            this.scrollbar.y = this.scrollbar.scrollTop + (this.scrollbar.scrollBottom - this.scrollbar.scrollTop) * percent;
        };
        LevelsMap.prototype.updateAvatar = function () {
            var _this = this;
            if (!this.lastUnlockedIcon) {
                return;
            }
            var cameraBounds = this.camera.getBounds();
            var cameraTop = Phaser.Math.Clamp(this.camera.scrollY, 0, cameraBounds.bottom - game.Config.GAME_HEIGHT);
            var cameraBottom = cameraTop + this.camera.height;
            var iconGlobalPosition = this.lastUnlockedIcon.getWorldPosition();
            var iconGlobalY = iconGlobalPosition.y - 32 * this.mainContainer.scale;
            var inCamera = iconGlobalY > cameraTop && iconGlobalY < cameraBottom;
            if (inCamera) {
                this.avatar.y = iconGlobalY - this.avatar.getDisplayHeight() / 2;
                this.avatar.lookBottom();
            }
            else {
                var cameraHeight = cameraBottom - cameraTop;
                var cameraCenterY = cameraTop + cameraHeight / 2;
                if (iconGlobalY > cameraCenterY) {
                    this.avatar.y = cameraBottom - this.avatar.getDisplayHeight() / 2;
                    this.avatar.lookBottom();
                }
                else {
                    this.avatar.y = cameraTop + this.avatar.getDisplayHeight() / 2;
                    this.avatar.lookUp();
                }
            }
            if (this.avatar.wasInCamera && inCamera === false) {
                this.avatar.stopWiggle();
                this.avatar.scaleTo(0.75);
                this.avatar.enableInput();
            }
            else if (this.avatar.wasInCamera === false && inCamera) {
                this.avatar.scaleTo(1).on(Phaser.Tweens.Events.TWEEN_COMPLETE, function () {
                    _this.avatar.startWiggle();
                });
                this.avatar.disableInput();
            }
            this.avatar.x = iconGlobalPosition.x;
            this.avatar.wasInCamera = inCamera;
        };
        LevelsMap.prototype.getLastUnlockedLevelIcon = function () {
            var unlockedLevelNumbers = this.levelIcons
                .filter(function (icon) { return icon.iconState === game.LevelIconState.UNLOCKED; })
                .map(function (icon) { return icon.levelNumber; });
            var last = Math.max.apply(Math, unlockedLevelNumbers);
            return this.levelIcons.find(function (icon) { return icon.levelNumber === last; });
        };
        LevelsMap.prototype.doInitialCameraScroll = function () {
            var lastUnlockedLevel = this.getLastUnlockedLevelIcon();
            if (lastUnlockedLevel) {
                this.scrollToLevelIcon(lastUnlockedLevel);
            }
            else {
                this.scrollToBottom();
            }
        };
        LevelsMap.prototype.shutdown = function () {
            document.onpointermove = null;
            if (this.wheelListener) {
                this.game.canvas.parentElement.removeEventListener("wheel", this.wheelListener);
            }
            this.removeCameraScroll();
        };
        LevelsMap.prototype.removeCameraScroll = function () {
            this.input.off("pointerdown");
            this.input.off("pointerup");
            this.input.off("pointermove");
        };
        LevelsMap.CONFIG_KEY = "levels_map_config";
        return LevelsMap;
    }(Phaser.Scene));
    game.LevelsMap = LevelsMap;
})(game || (game = {}));
var game;
(function (game) {
    var Vector2 = Phaser.Math.Vector2;
    var TrailEvent;
    (function (TrailEvent) {
        TrailEvent["SHOW"] = "trail_show";
        TrailEvent["HIDE"] = "trail_hide";
    })(TrailEvent = game.TrailEvent || (game.TrailEvent = {}));
    var Trail = /** @class */ (function () {
        function Trail(scene, canvas, owner, options) {
            this._active = false;
            this.scene = scene;
            this.canvas = canvas;
            this.options = options;
            this.owner = owner;
            this.owner.on(TrailEvent.SHOW, this.activate, this);
            this.owner.on(TrailEvent.HIDE, this.deactivate, this);
            this.curve = new Phaser.Curves.Spline();
            this.tempCurvePoint = new Vector2();
            this.initTangents();
        }
        Object.defineProperty(Trail.prototype, "active", {
            get: function () {
                return this._active;
            },
            enumerable: false,
            configurable: true
        });
        Trail.prototype.initTangents = function () {
            this.tempTangent = new Vector2();
            this.leftTangents = _.times(this.options.accuracy + 1, function () {
                return new Vector2();
            });
            this.rightTangents = _.times(this.options.accuracy + 1, function () {
                return new Vector2();
            });
        };
        Trail.prototype.activate = function () {
            if (this._active) {
                return;
            }
            this.curve.points.length = 0;
            this._active = true;
        };
        Trail.prototype.deactivate = function () {
            if (!this._active) {
                return;
            }
            this._active = false;
        };
        Trail.prototype.draw = function () {
            if (this._active === false) {
                return;
            }
            this.curve.points.push({ x: this.owner.x, y: this.owner.y });
            var length = this.curve.points.length;
            if (length < 2) {
                return;
            }
            if (length > this.options.length) {
                this.curve.points = this.curve.points.slice(-this.options.length);
            }
            // TODO truncate trails lenght because they are too long during fast forward
            this.truncate();
            this.canvas.fillPoints(this.getDrawingPoints(), true);
        };
        Trail.prototype.truncate = function () {
            /*let maxLength: number = 200
            let length: number = 0
            let index:number
            for (index = this.curve.points.length - 1; index > 0; index--) {
                let point: Vector2Like = this.curve.points[index]
                let nextPoint: Vector2Like = this.curve.points[index - 1]
                let distance: number = Phaser.Math.Distance.BetweenPoints(point, nextPoint)
                length += distance
                if (length > maxLength) {
                    let remainder:number = maxLength - length
                    let x:number =
                }
            }*/
        };
        Trail.prototype.getDrawingPoints = function () {
            for (var t = this.options.accuracy; t >= 0; t--) {
                var realT = t / this.options.accuracy;
                var radius = this.owner.getTrailSize() * realT;
                this.curve.getPoint(realT, this.tempCurvePoint);
                this.curve.getTangentAt(realT, this.tempTangent);
                this.rightTangents[t].copy(this.tempTangent).normalizeRightHand().scale(radius).add(this.tempCurvePoint);
                this.leftTangents[t].copy(this.tempTangent).normalizeRightHand().scale(-radius).add(this.tempCurvePoint);
            }
            return __spreadArrays(this.rightTangents, this.leftTangents.reverse());
        };
        Trail.prototype.destroy = function () {
            this.owner.off(TrailEvent.SHOW, this.activate, this);
            this.owner.off(TrailEvent.HIDE, this.deactivate, this);
            this.owner = null;
            this.curve = null;
        };
        return Trail;
    }());
    game.Trail = Trail;
})(game || (game = {}));
var game;
(function (game) {
    var TrailsCanvas = /** @class */ (function (_super) {
        __extends(TrailsCanvas, _super);
        function TrailsCanvas(scene, defaultOptions) {
            var _this = _super.call(this, scene) || this;
            _this.name = "ball_trails_canvas";
            _this.defaultOptions = defaultOptions;
            _this.trails = [];
            _this.scene.events.on(Phaser.Scenes.Events.POST_UPDATE, _this.onPostUpdate, _this);
            return _this;
        }
        TrailsCanvas.prototype.addTrail = function (owner, options) {
            var trail = new game.Trail(this.scene, this, owner, __assign(__assign({}, this.defaultOptions), options));
            this.trails.push(trail);
            owner.on(game.TrailEvent.SHOW, this.onTrailShow, this);
            owner.on(game.TrailEvent.HIDE, this.onTrailHide, this);
            owner.once(Phaser.GameObjects.Events.DESTROY, this.onOwnerDestroy.bind(this, trail, owner));
            return trail;
        };
        TrailsCanvas.prototype.onTrailShow = function () {
            if (!this.scene) {
                return;
            }
            if (this.hasActiveTrails()) {
                this.revive();
            }
        };
        TrailsCanvas.prototype.onTrailHide = function () {
            if (!this.scene) {
                return;
            }
            var areAllInactive = this.hasActiveTrails() === false;
            if (areAllInactive) {
                this.clear();
                this.kill();
            }
        };
        TrailsCanvas.prototype.hasActiveTrails = function () {
            return this.trails.some(function (trail) { return trail.active; });
        };
        TrailsCanvas.prototype.onOwnerDestroy = function (trail, owner) {
            if (!this.scene) {
                return;
            }
            var index = this.trails.indexOf(trail);
            if (index > -1) {
                this.trails.splice(index, 1);
                owner.off(game.TrailEvent.SHOW, this.onTrailShow, this);
                owner.off(game.TrailEvent.HIDE, this.onTrailHide, this);
                trail.destroy();
            }
        };
        TrailsCanvas.prototype.onPostUpdate = function (time, delta) {
            var _this = this;
            this.clear();
            this.trails.forEach(function (trail) {
                _this.fillStyle(trail.options.color, trail.options.alpha);
                trail.draw();
            });
        };
        TrailsCanvas.prototype.destroy = function (fromScene) {
            if (!this.scene) {
                return;
            }
            this.trails.forEach(function (trail) { return trail.destroy(); });
            this.trails = null;
            this.scene.events.off(Phaser.Scenes.Events.POST_UPDATE, this.onPostUpdate, this);
            _super.prototype.destroy.call(this, fromScene);
        };
        return TrailsCanvas;
    }(Phaser.GameObjects.Graphics));
    game.TrailsCanvas = TrailsCanvas;
})(game || (game = {}));
var game;
(function (game) {
    var FoxAnimation;
    (function (FoxAnimation) {
        FoxAnimation["IDLE"] = "fox_idle";
        FoxAnimation["HAPPY"] = "fox_happy";
        FoxAnimation["AIM"] = "fox_aim";
        FoxAnimation["SHOT"] = "fox_shot";
    })(FoxAnimation = game.FoxAnimation || (game.FoxAnimation = {}));
    var Fox = /** @class */ (function (_super) {
        __extends(Fox, _super);
        function Fox(scene) {
            var _this = _super.call(this, scene, 0, 0, Fox.ATLAS_KEY, "FOX_IDLE0001") || this;
            _this.setOrigin(0.45, 0.8);
            _this.createAnimations();
            _this.resetAnimationOrigins();
            _this.on("animationcomplete-" + FoxAnimation.SHOT, _this.onShotAnimationComplete, _this);
            return _this;
        }
        Fox.prototype.createAnimations = function () {
            this.scene.anims.create({
                key: FoxAnimation.IDLE,
                frames: this.getAnimationFrames("FOX_IDLE"),
                repeat: -1,
            });
            this.scene.anims.create({
                key: FoxAnimation.AIM,
                frames: this.getAnimationFrames("FOX_AIM"),
                repeat: -1,
            });
            this.scene.anims.create({
                key: FoxAnimation.SHOT,
                frames: this.getAnimationFrames("FOX_SHOT"),
                frameRate: 60,
            });
            this.scene.anims.create({
                key: FoxAnimation.HAPPY,
                frames: this.getAnimationFrames("FOX_HAPPY"),
                repeat: -1,
                frameRate: 30,
            });
        };
        Fox.prototype.getAnimationFrames = function (prefix) {
            return this.scene.anims.getFrameNames(Fox.ATLAS_KEY, prefix);
        };
        Fox.prototype.resetAnimationOrigins = function () {
            var _this = this;
            var animationKeys = Object.values(FoxAnimation);
            animationKeys.forEach(function (animKey) {
                _this.scene.anims.get(animKey).frames.forEach(function (frame) {
                    frame.frame.customPivot = false;
                });
            });
        };
        Fox.prototype.onShotAnimationComplete = function () {
            this.play(FoxAnimation.IDLE);
        };
        Fox.prototype.getHandsPosition = function (out) {
            var _out = out || { x: 0, y: 0 };
            _out.x = this.x;
            _out.y = this.y - this.height * 0.28;
            return _out;
        };
        Fox.prototype.moveTo = function (targetX) {
            var duration = Math.abs(targetX - this.x) * 2;
            this.scene.tweens.add({
                targets: this,
                x: targetX,
                duration: Math.min(400, duration),
                ease: Phaser.Math.Easing.Cubic.Out,
            });
        };
        Fox.prototype.playIdleAnimation = function () {
            this.play(FoxAnimation.IDLE);
        };
        Fox.prototype.playHappyAnimation = function () {
            this.play(FoxAnimation.HAPPY);
        };
        Fox.prototype.playShotAnimation = function () {
            this.play(FoxAnimation.SHOT);
        };
        Fox.prototype.showLoseFrame = function () {
            this.play(FoxAnimation.AIM);
            this.anims.currentAnim.pause();
        };
        Fox.prototype.showWorriedFrame = function () {
            var _this = this;
            this.play(FoxAnimation.AIM);
            this.anims.currentAnim.pause();
            this.scene.time.delayedCall(1600, function () {
                _this.playIdleAnimation();
            });
        };
        Fox.prototype.destroy = function () {
            _super.prototype.destroy.call(this, true);
        };
        Fox.ATLAS_KEY = "gameplay";
        return Fox;
    }(Phaser.GameObjects.Sprite));
    game.Fox = Fox;
})(game || (game = {}));
var game;
(function (game) {
    var FoxTalkBubble = /** @class */ (function (_super) {
        __extends(FoxTalkBubble, _super);
        function FoxTalkBubble(scene) {
            var _this = _super.call(this, scene) || this;
            _this.name = "fox_talk_bubble";
            _this.addBubble();
            _this.addContent();
            return _this;
        }
        FoxTalkBubble.prototype.addBubble = function () {
            this.bubble = this.scene.add.image(0, 0, "gameplay", "fox_bubble_talk");
            this.add(this.bubble);
        };
        FoxTalkBubble.prototype.addContent = function () {
            this.content = this.scene.add.image(0, 0, "gameplay", "fox_bubble_talk_content");
            this.content.x = this.bubble.x - 46;
            this.content.y = this.bubble.y - 62;
            this.content.originalX = this.content.x;
            this.content.originalY = this.content.y;
            this.add(this.content);
        };
        FoxTalkBubble.prototype.show = function () {
            this.alpha = 0;
            this.scale = 0.75;
            this.scene.tweens.add({
                targets: this,
                duration: 200,
                ease: Phaser.Math.Easing.Cubic.Out,
                alpha: 1,
            });
            this.scene.tweens.add({
                targets: this,
                duration: 800,
                ease: Phaser.Math.Easing.Elastic.Out,
                easeParams: [0.1, 0.4],
                scale: 1,
                completeDelay: 900,
                onComplete: this.hide.bind(this),
            });
            this.content.x = this.content.originalX;
            this.scene.tweens.add({
                targets: this.content,
                duration: 66,
                ease: Phaser.Math.Easing.Sine.InOut,
                x: "-=4",
                yoyo: true,
                repeat: 3,
            });
        };
        FoxTalkBubble.prototype.hide = function () {
            this.scene.tweens.killTweensOf(this.content);
            this.scene.tweens.add({
                targets: this,
                duration: 133,
                ease: Phaser.Math.Easing.Linear.Linear,
                alpha: 0,
                scale: 0.5,
                onComplete: this.kill.bind(this),
            });
        };
        return FoxTalkBubble;
    }(Phaser.GameObjects.Container));
    game.FoxTalkBubble = FoxTalkBubble;
})(game || (game = {}));
var game;
(function (game) {
    var ThrownFox = /** @class */ (function (_super) {
        __extends(ThrownFox, _super);
        function ThrownFox(world, frame) {
            return _super.call(this, world, 0, 0, frame.texture.key, frame.name, {
                ignoreGravity: false,
                isSensor: true,
                render: {
                    sprite: {
                        xOffset: frame.pivotX - 0.5,
                        yOffset: frame.pivotY - 0.5,
                    },
                },
            }) || this;
        }
        ThrownFox.prototype.throw = function () {
            var k = 16.66667 / this.scene.game.loop.delta;
            var x = Phaser.Math.RND.sign() * 0.25 * k;
            var y = -5.45 * k;
            this.applyForce({ x: x, y: y });
            this.scene.tweens.add({
                targets: this,
                duration: 600,
                ease: Phaser.Math.Easing.Back.Out,
                scale: 1.2,
            });
        };
        ThrownFox.prototype.preUpdate = function (time, delta) {
            this.angle += 0.25 * delta * Phaser.Math.Sign(this.body.velocity.x);
        };
        ThrownFox.prototype.destroyAfter = function (delay) {
            this.scene.time.delayedCall(delay, this.destroy, null, this);
        };
        return ThrownFox;
    }(Phaser.Physics.Matter.Image));
    game.ThrownFox = ThrownFox;
})(game || (game = {}));
var game;
(function (game) {
    var TrajectorySounds = /** @class */ (function () {
        function TrajectorySounds(scene) {
            this.isEnabled = false;
            this.showTimestamp = 0;
            this.scene = scene;
            this.sound = this.scene.sound;
            this.isEnabled = this.scene.game.audioType === game.SoundManagerType.WEB_AUDIO;
            this.addSounds();
        }
        TrajectorySounds.prototype.addSounds = function () {
            if (this.isEnabled === false) {
                return;
            }
            this.allSounds = this.createSounds();
        };
        TrajectorySounds.prototype.createSounds = function () {
            var _this = this;
            var sounds = [
                { key: game.GameSoundKey.AIM_1, volume: 1 },
                { key: game.GameSoundKey.AIM_2, volume: 0.5 },
                { key: game.GameSoundKey.AIM_3, volume: 0.5 },
            ];
            return sounds.map(function (soundOptions) {
                var isSoundAvailable = _this.scene.cache.audio.has(soundOptions.key);
                if (isSoundAvailable) {
                    return _this.sound.add(soundOptions.key, { volume: soundOptions.volume });
                }
            });
        };
        TrajectorySounds.prototype.onShow = function () {
            var _a;
            if (this.isEnabled === false) {
                return;
            }
            this.showTimestamp = Date.now();
            this.scene.input.on(Phaser.Input.Events.POINTER_MOVE, this.onPointerMove, this);
            (_a = this.allSounds[0]) === null || _a === void 0 ? void 0 : _a.play();
        };
        TrajectorySounds.prototype.onPointerMove = function () {
            var deltaTime = Date.now() - this.showTimestamp;
            if (deltaTime > 1000) {
                var sound = Phaser.Math.RND.bool() ? this.allSounds[1] : this.allSounds[2];
                if (sound) {
                    sound.play();
                }
                this.scene.input.off(Phaser.Input.Events.POINTER_MOVE, this.onPointerMove, this);
            }
        };
        TrajectorySounds.prototype.onHide = function () {
            if (this.isEnabled === false) {
                return;
            }
            this.allSounds.forEach(function (sound) { return sound === null || sound === void 0 ? void 0 : sound.stop(); });
            this.scene.input.off(Phaser.Input.Events.POINTER_MOVE, this.onPointerMove, this);
        };
        TrajectorySounds.prototype.destroy = function () {
            if (this.allSounds) {
                this.allSounds.forEach(function (sound) { return sound === null || sound === void 0 ? void 0 : sound.destroy(); });
                this.allSounds = null;
            }
            if (this.scene) {
                this.scene.input.off(Phaser.Input.Events.POINTER_MOVE, this.onPointerMove, this);
            }
        };
        return TrajectorySounds;
    }());
    game.TrajectorySounds = TrajectorySounds;
})(game || (game = {}));
///<reference path='TrajectorySounds.ts' />
var game;
(function (game) {
    var Trajectory = /** @class */ (function (_super) {
        __extends(Trajectory, _super);
        function Trajectory(scene) {
            var _this = _super.call(this, scene) || this;
            _this._bouncesNum = 1;
            _this.isHidden = false;
            _this.name = "trajectory";
            _this.gameplay = _this.scene;
            _this.worldCopy = _this.gameplay.worldCopy;
            _this.trajectoryStart = { x: 0, y: 0 };
            _this.trajectoryEnd = { x: 0, y: 0 };
            _this.cameraPointerPosition = { x: 0, y: 0 };
            _this.sounds = new game.TrajectorySounds(_this.scene);
            _this.addDots();
            _this.addPointer();
            return _this;
        }
        Trajectory.prototype.addDots = function () {
            var _this = this;
            this.dots = _.times(100, function (index) {
                var dot = _this.scene.add.image(0, 0, "gameplay", "trajectory_dot");
                _this.add(dot);
                return dot;
            });
        };
        Trajectory.prototype.addPointer = function () {
            this.pointer = this.scene.add.image(0, 0, "gameplay", "trajectory_pointer");
            this.add(this.pointer);
        };
        Trajectory.prototype.setBounces = function (num) {
            this._bouncesNum = Phaser.Math.Clamp(num, 1, 5);
        };
        Trajectory.prototype.show = function () {
            this.revive();
            this.playShowTween();
            this.sounds.onShow();
            this.isHidden = false;
            var hasIceBlocks = this.gameplay.items.some(function (item) { return item.itemType.includes("ice"); });
            if (hasIceBlocks) {
                this.scene.events.on(Phaser.Scenes.Events.UPDATE, this.draw, this);
            }
            else {
                this.draw();
                this.scene.input.on(Phaser.Input.Events.POINTER_MOVE, this.draw, this);
            }
        };
        Trajectory.prototype.playShowTween = function () {
            this.alpha = 0;
            this.scene.tweens.killTweensOf(this);
            this.scene.tweens.add({
                targets: this,
                duration: 150,
                ease: Phaser.Math.Easing.Cubic.Out,
                alpha: 1,
            });
        };
        Trajectory.prototype.hide = function () {
            this.kill();
            this.removeSceneEventListeners();
            this.sounds.onHide();
        };
        Trajectory.prototype.removeSceneEventListeners = function () {
            this.scene.events.off(Phaser.Scenes.Events.UPDATE, this.draw, this);
            this.scene.input.off(Phaser.Input.Events.POINTER_MOVE, this.draw, this);
        };
        Trajectory.prototype.kill = function () {
            this.visible = false;
            this.active = false;
        };
        Trajectory.prototype.revive = function () {
            this.visible = true;
            this.active = true;
        };
        Trajectory.prototype.draw = function () {
            this.trajectoryStart = this.gameplay.fox.getHandsPosition(this.trajectoryStart);
            this.trajectoryEnd = this.getEndPoint();
            this.doDraw(this.trajectoryStart.x, this.trajectoryStart.y, this.trajectoryEnd.x, this.trajectoryEnd.y);
        };
        Trajectory.prototype.getEndPoint = function () {
            this.scene.input.activePointer.positionToCamera(this.scene.cameras.main, this.cameraPointerPosition);
            var t = 1;
            var x = this.trajectoryEnd.x + (this.cameraPointerPosition.x - this.trajectoryEnd.x) * t;
            var y = this.trajectoryEnd.y + (this.cameraPointerPosition.y - this.trajectoryEnd.y) * t;
            return { x: x, y: y };
        };
        Trajectory.prototype.doDraw = function (startX, startY, endX, endY) {
            var rotation = Math.atan2(endY - startY, endX - startX);
            if (rotation > 0) {
                if (this.isHidden === false) {
                    this.isHidden = true;
                    this.sounds.onHide();
                    this.hideDots();
                }
                return;
            }
            var points = this.worldCopy.getTrajectoryPoints(startX, startY, rotation, this._bouncesNum);
            if (points.length > 0) {
                points = __spreadArrays([{ x: startX, y: startY }], points);
                this.showDots(points);
                this.showPointer(points);
                this.isHidden = false;
            }
        };
        Trajectory.prototype.hideDots = function () {
            this.dots.forEach(function (dot) { return dot.visible = false; });
            this.pointer.visible = false;
        };
        Trajectory.prototype.showDots = function (keyPoints) {
            var dotIndex = 0;
            var distance = 0;
            var stepRate = 22;
            for (var i = 0; i < keyPoints.length - 1; i++) {
                var point_1 = keyPoints[i];
                var point_2 = keyPoints[i + 1];
                if (point_2) {
                    var lineLength = Phaser.Math.Distance.BetweenPoints(point_1, point_2);
                    var lineAngle = Phaser.Math.Angle.BetweenPoints(point_1, point_2);
                    var linePointsNum = Math.floor(lineLength / stepRate);
                    for (var j = 0; j <= linePointsNum; j++) {
                        distance = j * stepRate;
                        var dot = this.dots[dotIndex++];
                        if (dot) {
                            dot.visible = true;
                            dot.x = point_1.x + Math.cos(lineAngle) * distance;
                            dot.y = point_1.y + Math.sin(lineAngle) * distance;
                        }
                        else {
                            console.warn("Not enough dots");
                            break;
                        }
                    }
                }
            }
            this.hideRemainingDots(dotIndex);
        };
        Trajectory.prototype.hideRemainingDots = function (dotIndex) {
            this.dots.forEach(function (dot, index) {
                if (index >= dotIndex) {
                    dot.visible = false;
                }
            });
        };
        Trajectory.prototype.showPointer = function (points) {
            var last = points[points.length - 1];
            var lastButOne = points[points.length - 2];
            var rotation = Phaser.Math.Angle.BetweenPoints(lastButOne, last);
            var distance = game.Ball.RADIUS;
            this.pointer.visible = true;
            this.pointer.x = last.x + Math.cos(rotation) * distance;
            this.pointer.y = last.y + Math.sin(rotation) * distance;
            this.pointer.rotation = rotation + Math.PI / 2;
        };
        Trajectory.prototype.destroy = function (fromScene) {
            if (this.scene) {
                this.removeSceneEventListeners();
            }
            this.sounds.destroy();
            _super.prototype.destroy.call(this, fromScene);
        };
        return Trajectory;
    }(Phaser.GameObjects.Container));
    game.Trajectory = Trajectory;
})(game || (game = {}));
var game;
(function (game) {
    var BallKeeper = /** @class */ (function () {
        function BallKeeper(scene, ball, worldBounds) {
            this.justReturned = false;
            this.scene = scene;
            this.ball = ball;
            this.ballBody = this.ball.body;
            this.worldBounds = worldBounds;
            this.positions = [];
            this.velocities = [];
        }
        BallKeeper.prototype.saveInitialPositionAndVelocity = function () {
            this.initialPosition = { x: this.ball.x, y: this.ball.y };
            this.initialVelocity = { x: this.ballBody.velocity.x, y: this.ballBody.velocity.y };
            this.positions = [this.initialPosition];
            this.velocities = [this.initialVelocity];
            this.justReturned = false;
        };
        BallKeeper.prototype.keepInsideWorld = function () {
            var inWorld = this.worldBounds.contains(this.ball.x, this.ball.y);
            if (inWorld) {
                if (this.justReturned) {
                    this.justReturned = false;
                    return;
                }
                this.positions.push({ x: this.ball.x, y: this.ball.y });
                this.velocities.push({ x: this.ballBody.velocity.x, y: this.ballBody.velocity.y });
            }
            else {
                if (this.ball.y > this.worldBounds.bottom) {
                    var margin = 10;
                    var x = Phaser.Math.Clamp(this.ball.x, this.worldBounds.left + margin, this.worldBounds.right - margin);
                    this.ball.setPosition(x, this.worldBounds.bottom - margin);
                    this.ball.setVelocity(0, 0);
                    return;
                }
                this.returnToLastValidPosition();
            }
        };
        BallKeeper.prototype.returnToLastValidPosition = function () {
            var position;
            var velocity;
            if (this.positions.length === 0) {
                position = this.initialPosition;
                velocity = this.initialVelocity;
            }
            else {
                position = this.positions.pop();
                velocity = this.velocities.pop();
                var pushbackDistance = game.Ball.RADIUS;
                if (position.y < this.worldBounds.top) {
                    velocity.y *= -1;
                    position.y = this.worldBounds.top + pushbackDistance;
                }
                if (position.x > this.worldBounds.right) {
                    velocity.x *= -1;
                    velocity.y *= -1;
                    position.x = this.worldBounds.right - pushbackDistance;
                }
                if (position.x < this.worldBounds.left) {
                    velocity.x *= -1;
                    velocity.y *= -1;
                    position.x = this.worldBounds.left + pushbackDistance;
                }
            }
            this.ball.setPosition(position.x, position.y);
            this.ball.setVelocity(velocity.x, velocity.y);
            this.justReturned = true;
        };
        BallKeeper.prototype.onBallLanded = function () {
            this.positions.length = 0;
            this.velocities.length = 0;
        };
        return BallKeeper;
    }());
    game.BallKeeper = BallKeeper;
})(game || (game = {}));
///<reference path='BallKeeper.ts' />
var game;
(function (game) {
    var BallEvent;
    (function (BallEvent) {
        BallEvent["CHARGE"] = "charge";
        BallEvent["DISCHARGE"] = "discharge";
        BallEvent["SPIN"] = "spin";
        BallEvent["DROP"] = "drop";
        BallEvent["THROW"] = "throw";
        BallEvent["LAND"] = "land";
    })(BallEvent = game.BallEvent || (game.BallEvent = {}));
    var BallFrame;
    (function (BallFrame) {
        BallFrame["ORIGINAL"] = "ball_idle_2";
        BallFrame["SURPRISED"] = "ball_surprised";
        BallFrame["CHARGED"] = "ball_lightning_3";
    })(BallFrame = game.BallFrame || (game.BallFrame = {}));
    var Ball = /** @class */ (function (_super) {
        __extends(Ball, _super);
        function Ball(scene, options) {
            var _this = _super.call(this, scene.matter.world, 0, 0, "gameplay", BallFrame.ORIGINAL) || this;
            _this._damage = Ball.INITIAL_DAMAGE;
            _this._isCharged = false;
            _this.isDropping = false;
            _this.isThown = false;
            _this.subDepth = 0;
            _this.savedInertia = 0;
            _this.subDepth = options.subDepth;
            _this.setDepth(options.depth);
            _this.setCircle(Ball.RADIUS, Ball.BODY_CONFIG);
            _this.setCollisionGroup(options.collisionGroup);
            _this.setCollisionCategory(options.collisionCategory);
            _this.saveCollisionFilter();
            _this.setFixedRotation();
            _this.setToSleep();
            _this.body.plugin[game.COLLISION_TAG] = game.CollisionTag.BALL;
            _this.keeper = new game.BallKeeper(_this.scene, _this, options.worldBounds);
            _this.createHorizontalMovementTracker();
            return _this;
        }
        Object.defineProperty(Ball.prototype, "isCharged", {
            get: function () {
                return this._isCharged;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Ball.prototype, "damage", {
            get: function () {
                return this._damage;
            },
            enumerable: false,
            configurable: true
        });
        Ball.prototype.setFixedRotation = function () {
            this.savedInertia = this.body.inertia;
            return _super.prototype.setFixedRotation.call(this);
        };
        Ball.prototype.resetFixedRotation = function () {
            this.scene.matter.body.setInertia(this.body, this.savedInertia);
            return this;
        };
        Ball.prototype.createHorizontalMovementTracker = function () {
            this.movementTracker = {
                positionsY: [],
                timer: 0,
            };
        };
        Ball.prototype.show = function () {
            this.visible = true;
            this.active = true;
            this.alpha = 0;
            this.scene.tweens.add({
                targets: this,
                duration: 50,
                ease: Phaser.Math.Easing.Cubic.Out,
                alpha: 1,
            });
        };
        Ball.prototype.throw = function (rotation) {
            if (this.isThown) {
                return;
            }
            this.isThown = true;
            this.resetMovementTracker();
            this.setAwake();
            this.setVelocityByRotation(rotation, Ball.THROW_FORCE);
            this.keeper.saveInitialPositionAndVelocity();
            this.emit(BallEvent.THROW, this);
        };
        Ball.prototype.resetMovementTracker = function () {
            this.movementTracker.positionsY.length = 0;
            this.movementTracker.timer = 0;
        };
        Ball.prototype.setVelocityByRotation = function (rotation, force) {
            var x = Math.cos(rotation) * force;
            var y = Math.sin(rotation) * force;
            this.setVelocity(x, y);
        };
        Ball.prototype.preUpdate = function (time, delta) {
            this.checkForHorizontalMovement(delta);
            if (this.isThown) {
                this.keeper.keepInsideWorld();
            }
        };
        Ball.prototype.checkForHorizontalMovement = function (delta) {
            if (this.isThown === false) {
                return;
            }
            if (this.isDropping) {
                return;
            }
            this.movementTracker.positionsY.push(this.y);
            this.movementTracker.timer += delta;
            var checkInterval = 1000;
            if (this.movementTracker.timer > checkInterval) {
                var minY = Math.min.apply(Math, this.movementTracker.positionsY);
                var maxY = Math.max.apply(Math, this.movementTracker.positionsY);
                var dy = Math.abs(maxY - minY);
                if (dy < 15) {
                    this.fixHorizontalMovement();
                }
                this.movementTracker.timer -= checkInterval;
                this.movementTracker.positionsY.length = 0;
            }
        };
        Ball.prototype.fixHorizontalMovement = function () {
            var deltaAngle = 3;
            var deltaRotation = Phaser.Math.DegToRad(deltaAngle);
            var currentRotation = this.getVelocityRotation();
            var newRotation = currentRotation + deltaRotation;
            this.setVelocityByRotation(newRotation, Ball.THROW_FORCE);
        };
        Ball.prototype.maintainConstantFlyingSpeed = function (delta) {
            if (this.isThown === false) {
                return;
            }
            if (this.isDropping) {
                return;
            }
            var rotation = this.getVelocityRotation();
            var force = Ball.THROW_FORCE * (delta / 16.6667);
            this.setVelocityByRotation(rotation, force);
            this.rotation = rotation + Math.PI / 2;
        };
        Ball.prototype.getVelocityRotation = function () {
            var x = this.body.velocity.x;
            var y = this.body.velocity.y;
            return Math.atan2(y, x);
        };
        Ball.prototype.onTouchedTheFloor = function () {
            this.setToSleep();
            this.setIgnoreGravity(true);
            this.setFixedRotation();
            this.restoreCollisionFilter();
            this.resetCharge();
            this.keeper.onBallLanded();
            this.isThown = false;
            this.isDropping = false;
            this.visible = false;
            this.active = false;
            this.emit(game.TrailEvent.HIDE, this);
            this.emit(BallEvent.LAND, this);
        };
        Ball.prototype.setCharge = function () {
            if (this._isCharged) {
                return;
            }
            this._isCharged = true;
            this._damage *= 2;
            this.setFrame(BallFrame.CHARGED);
            this.emit(BallEvent.CHARGE, this);
        };
        Ball.prototype.resetCharge = function () {
            this._isCharged = false;
            this._damage = Ball.INITIAL_DAMAGE;
            this.setFrame(BallFrame.ORIGINAL);
            this.emit(BallEvent.DISCHARGE, this);
        };
        Ball.prototype.spin = function () {
            this.setVelocityByRotation(Phaser.Math.RND.rotation(), Ball.THROW_FORCE);
            this.emit(BallEvent.SPIN, this);
            if (this._isCharged === false) {
                this.setSurprisedFrame();
            }
        };
        Ball.prototype.setSurprisedFrame = function () {
            this.setFrame(BallFrame.SURPRISED);
            this.resetFrame();
        };
        Ball.prototype.resetFrame = function (delay) {
            var _this = this;
            if (delay === void 0) { delay = 300; }
            if (this.resetFrameEvent) {
                this.resetFrameEvent.remove();
                this.resetFrameEvent = null;
            }
            this.resetFrameEvent = this.scene.time.delayedCall(delay, function () {
                if (_this._isCharged) {
                    _this.setFrame(BallFrame.CHARGED);
                }
                else {
                    _this.setFrame(BallFrame.ORIGINAL);
                }
            });
        };
        Ball.prototype.dropToFloor = function (collisionCategories) {
            if (this.isThown === false) {
                return;
            }
            if (this.isDropping) {
                return;
            }
            this.isDropping = true;
            this.setIgnoreGravity(false);
            this.saveCollisionFilter();
            this.setCollidesWith(collisionCategories);
            this.resetFixedRotation();
            var angularVelocity = 0.1 * Phaser.Math.Sign(this.body.velocity.x);
            this.setAngularVelocity(angularVelocity);
            var force = Phaser.Math.RND.realInRange(0, 0.05) * Phaser.Math.RND.sign();
            this.applyForce({ x: force, y: 0 });
            this.emit(game.TrailEvent.SHOW, this);
            this.emit(BallEvent.DROP, this);
        };
        Ball.prototype.saveCollisionFilter = function () {
            this.savedCollisionFilter = __assign({}, this.body.collisionFilter);
        };
        Ball.prototype.restoreCollisionFilter = function () {
            if (this.savedCollisionFilter) {
                this.body.collisionFilter = __assign({}, this.savedCollisionFilter);
            }
        };
        Ball.prototype.getTrailSize = function () {
            return Ball.RADIUS - 1;
        };
        Ball.prototype.destroy = function () {
            this.isThown = false;
            this.isDropping = false;
            _super.prototype.destroy.call(this);
        };
        Ball.INITIAL_DAMAGE = 1;
        Ball.THROW_FORCE = 20;
        Ball.RADIUS = 29;
        Ball.BODY_CONFIG = {
            restitution: 1,
            friction: 0,
            frictionAir: 0,
            frictionStatic: 0,
            isStatic: false,
            ignoreGravity: true,
            circleRadius: Ball.RADIUS,
        };
        return Ball;
    }(Phaser.Physics.Matter.Image));
    game.Ball = Ball;
})(game || (game = {}));
var game;
(function (game) {
    var BallChargedEmitter = /** @class */ (function () {
        function BallChargedEmitter(ball, emitter) {
            this.ball = ball;
            this.ball.on(game.BallEvent.CHARGE, this.show, this);
            this.ball.on(game.BallEvent.DISCHARGE, this.hide, this);
            this.emitter = emitter;
        }
        BallChargedEmitter.prototype.show = function () {
            this.emitter.on = true;
        };
        BallChargedEmitter.prototype.hide = function () {
            this.emitter.on = false;
            // this.emitter.killAll()
        };
        return BallChargedEmitter;
    }());
    game.BallChargedEmitter = BallChargedEmitter;
})(game || (game = {}));
var game;
(function (game) {
    var BallSpinnedEmitter = /** @class */ (function () {
        function BallSpinnedEmitter(scene, ball, emitter) {
            this.scene = scene;
            this.ball = ball;
            this.ball.on(game.BallEvent.SPIN, this.show, this);
            this.ball.on(game.BallEvent.LAND, this.onBallLanded, this);
            this.emitter = emitter;
        }
        BallSpinnedEmitter.prototype.show = function () {
            var _this = this;
            this.emitter.on = true;
            this.scene.time.delayedCall(1000, function () {
                _this.hide();
            });
        };
        BallSpinnedEmitter.prototype.onBallLanded = function () {
            this.emitter.killAll();
            this.emitter.on = false;
        };
        BallSpinnedEmitter.prototype.hide = function () {
            this.emitter.on = false;
        };
        return BallSpinnedEmitter;
    }());
    game.BallSpinnedEmitter = BallSpinnedEmitter;
})(game || (game = {}));
var game;
(function (game) {
    var Line = Phaser.Geom.Line;
    var IdleBallsAligner = /** @class */ (function () {
        function IdleBallsAligner(scene) {
            this.scene = scene;
            this.grid = this.scene.grid;
            this.fox = this.scene.fox;
            this.idleBalls = this.scene.idleBalls;
        }
        IdleBallsAligner.prototype.getPoints = function (centerX) {
            var idleBallsNum = this.scene.idleBalls.length;
            var foxOffset = this.fox.displayWidth * 0.33;
            var foxLeft = centerX - foxOffset;
            var foxRight = centerX + foxOffset;
            var gridOffset = game.GameGrid.CELL_SIZE / 2;
            var gridLeft = gridOffset;
            var gridRight = this.grid.getWidth() - gridOffset;
            var leftLineStart = foxLeft < gridLeft ? gridLeft : foxLeft;
            var leftLine = new Phaser.Geom.Line(leftLineStart, 0, gridLeft, 0);
            var leftLineLength = Phaser.Geom.Line.Length(leftLine);
            var rightLineStart = foxRight > gridRight ? gridRight : foxRight;
            var rightLine = new Phaser.Geom.Line(rightLineStart, 0, gridRight, 0);
            var rightLineLength = Phaser.Geom.Line.Length(rightLine);
            var leftBallsNum = Math.round((leftLineLength / (leftLineLength + rightLineLength)) * idleBallsNum);
            var rightBallsNum = idleBallsNum - leftBallsNum;
            var leftPoints = this.getPointsFromLine(leftLine, leftBallsNum);
            var rightPoints = this.getPointsFromLine(rightLine, rightBallsNum);
            var pointsNum = idleBallsNum;
            var points = _.times(pointsNum, function (index) {
                if (index < leftBallsNum) {
                    return leftPoints.shift();
                }
                else {
                    return rightPoints.shift();
                }
            });
            return points;
        };
        IdleBallsAligner.prototype.getPointsFromLine = function (line, ballsNum) {
            if (ballsNum === 0) {
                return [];
            }
            var spacePerBall = 40;
            var spaceRequired = ballsNum * spacePerBall;
            var spaceAvailable = Line.Length(line);
            if (spaceRequired > spaceAvailable) {
                return line.getPoints(ballsNum);
            }
            else {
                return line.getPoints(0, spacePerBall);
            }
        };
        IdleBallsAligner.prototype.placeIdleBallsAround = function (idleBalls, originX) {
            var _this = this;
            Phaser.Math.RND.shuffle(idleBalls);
            this.getPoints(originX).forEach(function (point, index) {
                _this.scene.tweens.add({
                    targets: idleBalls[index],
                    duration: 200,
                    ease: Phaser.Math.Easing.Cubic.Out,
                    x: point.x,
                });
            });
        };
        IdleBallsAligner.prototype.placeIdleBallsAroundInstant = function (idleBalls, originX) {
            Phaser.Math.RND.shuffle(idleBalls);
            this.getPoints(originX).forEach(function (point, index) {
                idleBalls[index].x = point.x;
            });
        };
        return IdleBallsAligner;
    }());
    game.IdleBallsAligner = IdleBallsAligner;
})(game || (game = {}));
var game;
(function (game) {
    var IdleBallEvent;
    (function (IdleBallEvent) {
        IdleBallEvent["SHOW"] = "IdleBall_SHOW";
        IdleBallEvent["HIDE"] = "IdleBall_HIDE";
    })(IdleBallEvent = game.IdleBallEvent || (game.IdleBallEvent = {}));
    var IdleBall = /** @class */ (function (_super) {
        __extends(IdleBall, _super);
        function IdleBall(scene) {
            var _this = _super.call(this, scene, 0, 0, "gameplay", game.BallFrame.ORIGINAL) || this;
            _this._baseY = 0;
            _this.isHiding = false;
            _this.scheduledForLaunch = false;
            _this.setOrigin(0.5, 1);
            _this.updateJumpHeight();
            return _this;
        }
        Object.defineProperty(IdleBall.prototype, "jumpHeight", {
            get: function () {
                return this._jumpHeight;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(IdleBall.prototype, "baseY", {
            get: function () {
                return this._baseY;
            },
            enumerable: false,
            configurable: true
        });
        IdleBall.prototype.show = function () {
            this.visible = true;
            this.active = true;
            this.alpha = 0;
            this._baseY = this.y;
            this.playShowTween();
            this.updateJumpHeight();
            this.playJumpAnimation();
            this.emit(IdleBallEvent.SHOW, this);
        };
        IdleBall.prototype.playShowTween = function () {
            this.scene.tweens.add({
                targets: this,
                duration: 150,
                ease: Phaser.Math.Easing.Cubic.Out,
                alpha: 1,
            });
        };
        IdleBall.prototype.updateJumpHeight = function () {
            this._jumpHeight = Phaser.Math.RND.between(35, 45);
            this.jumpDuration = this._jumpHeight * 5.3;
        };
        IdleBall.prototype.playJumpAnimation = function () {
            var _this = this;
            this.scale = 1;
            var deltaScale = 0.15;
            this.scene.tweens.add({
                targets: this,
                duration: this.jumpDuration * 0.66,
                ease: Phaser.Math.Easing.Sine.InOut,
                scaleX: this.scale + deltaScale,
                scaleY: this.scale - deltaScale,
                yoyo: true,
            });
            this.scene.tweens.add({
                targets: this,
                duration: this.jumpDuration,
                ease: Phaser.Math.Easing.Quadratic.Out,
                y: this.y - this._jumpHeight,
                completeDelay: 33,
                onComplete: function () {
                    _this.scene.tweens.add({
                        targets: _this,
                        duration: _this.jumpDuration,
                        ease: Phaser.Math.Easing.Linear.Linear,
                        y: _this.y + _this._jumpHeight,
                        onComplete: function () {
                            _this.playJumpAnimation();
                        },
                    });
                },
            });
        };
        IdleBall.prototype.hide = function () {
            this.stopJumpAnimation();
            this.playHideTween();
            this.emit(IdleBallEvent.HIDE, this);
        };
        IdleBall.prototype.stopJumpAnimation = function () {
            this.scene.tweens.killTweensOf(this);
        };
        IdleBall.prototype.playHideTween = function () {
            var _this = this;
            this.isHiding = true;
            this.scene.tweens.add({
                targets: this,
                duration: 150,
                ease: Phaser.Math.Easing.Cubic.Out,
                alpha: 0,
                onComplete: function () {
                    _this.isHiding = false;
                    _this.active = false;
                    _this.visible = false;
                },
            });
        };
        IdleBall.prototype.stopHideTween = function () {
            this.scene.tweens.killTweensOf(this);
            this.isHiding = false;
        };
        IdleBall.prototype.kill = function () {
            this.stopJumpAnimation();
            this.emit(IdleBallEvent.HIDE, this);
            _super.prototype.kill.call(this);
        };
        IdleBall.prototype.revive = function () {
            this.y = this._baseY;
            this.playJumpAnimation();
            this.emit(IdleBallEvent.SHOW, this);
            _super.prototype.revive.call(this);
        };
        IdleBall.prototype.slightlyMoveAside = function (originX, grid) {
            var offset = 50;
            var left = offset;
            var right = grid.getWidth() - offset;
            var randomX = originX + Phaser.Math.RND.between(-100, 100);
            var targetX = Phaser.Math.Clamp(randomX, left, right);
            return this.scene.tweens.add({
                targets: this,
                duration: 200,
                ease: Phaser.Math.Easing.Cubic.Out,
                x: targetX,
            });
        };
        IdleBall.prototype.destroy = function () {
            _super.prototype.destroy.call(this, true);
        };
        return IdleBall;
    }(Phaser.GameObjects.Image));
    game.IdleBall = IdleBall;
})(game || (game = {}));
var game;
(function (game) {
    var JumpingBallShadow = /** @class */ (function (_super) {
        __extends(JumpingBallShadow, _super);
        function JumpingBallShadow(scene, ball, atlas, frame) {
            if (atlas === void 0) { atlas = "gameplay"; }
            if (frame === void 0) { frame = "ball_idle_shadow"; }
            var _this = _super.call(this, scene, 0, 0, atlas, frame) || this;
            _this.visible = false;
            _this.active = false;
            _this.ball = ball;
            _this.ball.on(game.IdleBallEvent.SHOW, _this.show, _this);
            _this.ball.on(game.IdleBallEvent.HIDE, _this.hide, _this);
            _this.scene.events.on("postupdate", _this.postUpdate, _this);
            return _this;
        }
        JumpingBallShadow.prototype.show = function () {
            this.visible = true;
            this.active = true;
            this.y = this.ball.baseY;
        };
        JumpingBallShadow.prototype.hide = function () {
            this.visible = false;
            this.active = false;
        };
        JumpingBallShadow.prototype.postUpdate = function () {
            if (!this.visible) {
                return;
            }
            var bottom = this.ball.baseY;
            var top = this.ball.baseY - this.ball.jumpHeight;
            this.x = this.ball.x + 3;
            this.updateScale(bottom, top);
            this.updateAlpha(bottom, top);
        };
        JumpingBallShadow.prototype.updateScale = function (bottom, top) {
            var bottomScale = 1;
            var topScale = 1.5;
            this.scale = Phaser.Math.MapLinear(this.ball.y, bottom, top, bottomScale, topScale);
        };
        JumpingBallShadow.prototype.updateAlpha = function (bottom, top) {
            var bottomAlpha = 0.66;
            var topAlpha = 0.33;
            this.alpha = Phaser.Math.MapLinear(this.ball.y, bottom, top, bottomAlpha, topAlpha);
        };
        JumpingBallShadow.prototype.destroy = function (fromScene) {
            if (this.scene) {
                this.scene.events.removeListener("postupdate", this.postUpdate, this);
            }
            _super.prototype.destroy.call(this, fromScene);
        };
        return JumpingBallShadow;
    }(Phaser.GameObjects.Image));
    game.JumpingBallShadow = JumpingBallShadow;
})(game || (game = {}));
var game;
(function (game) {
    var WinningBallEvent;
    (function (WinningBallEvent) {
        WinningBallEvent["LAUNCH"] = "launch";
        WinningBallEvent["EXPLODE"] = "explode";
    })(WinningBallEvent = game.WinningBallEvent || (game.WinningBallEvent = {}));
    var WinningBall = /** @class */ (function (_super) {
        __extends(WinningBall, _super);
        function WinningBall(scene) {
            return _super.call(this, scene, 0, 0, "gameplay", "ball_idle") || this;
        }
        WinningBall.prototype.launch = function (delay, side) {
            var _this = this;
            var sign = side === Phaser.LEFT ? -1 : 1;
            var cellHeight = game.GameGrid.CELL_SIZE;
            var targetX = this.x + Phaser.Math.RND.between(0, 200) * sign;
            var targetY = this.y - Phaser.Math.RND.between(4 * cellHeight, 7 * cellHeight);
            var distance = Phaser.Math.Distance.Between(this.x, this.y, targetX, targetY);
            var duration = distance * 1.2;
            this.scene.tweens.add({
                delay: delay,
                targets: this,
                x: targetX,
                y: targetY,
                duration: duration,
                ease: Phaser.Math.Easing.Back.Out,
                easeParams: [0.66],
                onStart: function () {
                    _this.emit(WinningBallEvent.LAUNCH);
                },
            });
            this.scene.time.delayedCall(delay + duration * 0.47, function () {
                _this.explode();
            });
        };
        WinningBall.prototype.explode = function (delay) {
            var _this = this;
            if (delay === void 0) { delay = 0; }
            this.scene.tweens.add({
                targets: this,
                delay: delay + 250,
                duration: 50,
                ease: Phaser.Math.Easing.Cubic.Out,
                alpha: 0,
            });
            this.scene.tweens.add({
                targets: this,
                delay: delay,
                duration: 300,
                ease: Phaser.Math.Easing.Back.In,
                scale: 2,
                onComplete: function () {
                    _this.emit(WinningBallEvent.EXPLODE, _this);
                    _this.destroy();
                },
            });
        };
        return WinningBall;
    }(Phaser.GameObjects.Image));
    game.WinningBall = WinningBall;
})(game || (game = {}));
var game;
(function (game) {
    var LosingBall = /** @class */ (function (_super) {
        __extends(LosingBall, _super);
        function LosingBall(scene, idleBall) {
            var _this = _super.call(this, scene.matter.world, 0, 0, idleBall.texture.key, idleBall.frame.name) || this;
            _this.setCircle(game.Ball.RADIUS, __assign(__assign({}, game.Ball.BODY_CONFIG), { ignoreGravity: false, isSensor: true }));
            return _this;
        }
        LosingBall.prototype.throw = function (side) {
            var forceXSign = side === Phaser.LEFT ? -1 : 1;
            var forceX = Phaser.Math.RND.realInRange(0.022, 0.05) * forceXSign;
            var forceY = Phaser.Math.RND.realInRange(-0.38, -0.22);
            var k = 16.66667 / this.scene.game.loop.delta;
            this.applyForce({ x: forceX * k, y: forceY * k });
            this.setAngularVelocity(0.1 * forceXSign);
            this.playScaleTween();
        };
        LosingBall.prototype.playScaleTween = function () {
            this.scene.tweens.add({
                targets: this,
                duration: 600,
                ease: Phaser.Math.Easing.Back.Out,
                scale: 1.2,
            });
        };
        LosingBall.prototype.destroyAfter = function (delay) {
            this.scene.time.delayedCall(delay, this.destroy, null, this);
        };
        return LosingBall;
    }(Phaser.Physics.Matter.Image));
    game.LosingBall = LosingBall;
})(game || (game = {}));
var game;
(function (game) {
    var Cell = /** @class */ (function (_super) {
        __extends(Cell, _super);
        function Cell(scene, texture, frame, column, row) {
            var _this = _super.call(this, scene, 0, 0, texture, frame) || this;
            _this.originalAlpha = 1;
            _this._column = column;
            _this._row = row;
            _this.setData("object_type", "game_cell");
            return _this;
        }
        Object.defineProperty(Cell.prototype, "row", {
            get: function () {
                return this._row;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Cell.prototype, "column", {
            get: function () {
                return this._column;
            },
            enumerable: false,
            configurable: true
        });
        Cell.prototype.destroy = function () {
        };
        Cell.prototype.toString = function () {
            return "[column: " + this._column + ", row: " + this._row + "]";
        };
        return Cell;
    }(Phaser.GameObjects.Image));
    game.Cell = Cell;
})(game || (game = {}));
///<reference path='Cell.ts' />
var game;
(function (game) {
    var GridDirection;
    (function (GridDirection) {
        GridDirection[GridDirection["TOP"] = 0] = "TOP";
        GridDirection[GridDirection["RIGHT"] = 1] = "RIGHT";
        GridDirection[GridDirection["BOTTOM"] = 2] = "BOTTOM";
        GridDirection[GridDirection["LEFT"] = 3] = "LEFT";
    })(GridDirection = game.GridDirection || (game.GridDirection = {}));
    var GameGrid = /** @class */ (function (_super) {
        __extends(GameGrid, _super);
        function GameGrid(scene, columns, rows) {
            var _this = _super.call(this, scene) || this;
            _this.debug = false;
            scene.add.existing(_this);
            _this.name = "grid";
            _this._columns = columns;
            _this._rows = rows;
            _this.testRect = _this.createTestRect();
            _this.addCells();
            _this.addRowLabels();
            return _this;
        }
        Object.defineProperty(GameGrid.prototype, "columns", {
            get: function () {
                return this._columns;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(GameGrid.prototype, "rows", {
            get: function () {
                return this._rows;
            },
            enumerable: false,
            configurable: true
        });
        GameGrid.prototype.createTestRect = function () {
            var size = GameGrid.CELL_SIZE * 0.9;
            return new Phaser.Geom.Rectangle(0, 0, size, size);
        };
        GameGrid.prototype.addCells = function () {
            this.cells = [];
            var startAlpha = 0;
            var deltaAlpha = 0.1 / (this._rows - 1);
            for (var row = 0; row < this._rows; row++) {
                for (var column = 0; column < this._columns; column++) {
                    var cell = new game.Cell(this.scene, "gameplay", "cell", column, row);
                    cell.x = GameGrid.CELL_SIZE / 2 + column * GameGrid.CELL_SIZE;
                    cell.y = this.getRowY(row);
                    cell.alpha = startAlpha + deltaAlpha * row;
                    cell.originalAlpha = cell.alpha;
                    this.cells.push(cell);
                    this.add(cell);
                }
            }
        };
        GameGrid.prototype.addRowLabels = function () {
            var _this = this;
            this.rowLabels = _.times(this._rows, function (rowNumber) {
                var content = rowNumber.toString();
                var label = _this.scene.add.bitmapText(0, 0, game.BitmapGameFont.INGAME_GUI_DIGITS, content, 28, Phaser.RIGHT);
                label.setOrigin(0, 0.5);
                label.setData("row", rowNumber);
                label.visible = _this.debug;
                _this.add(label);
                var cell = _this.getCellAt(rowNumber, 0);
                Phaser.Display.Align.In.BottomLeft(label, cell, -6, 6);
                return label;
            });
        };
        GameGrid.prototype.getRowY = function (row) {
            var reverseRow = this._rows - row - 1;
            return GameGrid.CELL_SIZE / 2 + reverseRow * GameGrid.CELL_SIZE;
        };
        GameGrid.prototype.getRowByY = function (y) {
            var reverseRow = Math.floor(y / GameGrid.CELL_SIZE);
            var row = this._rows - reverseRow - 1;
            return row;
        };
        GameGrid.prototype.getWidth = function () {
            return this._columns * GameGrid.CELL_SIZE;
        };
        GameGrid.prototype.getHeight = function () {
            return this._rows * GameGrid.CELL_SIZE;
        };
        GameGrid.prototype.getCenter = function () {
            return {
                x: this.x + this.getWidth() / 2,
                y: this.y + this.getHeight() / 2,
            };
        };
        GameGrid.prototype.getCellAt = function (row, column) {
            return this.cells.find(function (cell) { return cell.row === row && cell.column === column; });
        };
        GameGrid.prototype.getCellAtXY = function (x, y) {
            var row = this.getRowByY(y);
            var column = Math.floor(x / GameGrid.CELL_SIZE);
            return this.getCellAt(row, column);
        };
        GameGrid.prototype.getCellNeighbour = function (cell, direction) {
            switch (direction) {
                case GridDirection.TOP:
                    return this.getCellAt(cell.row - 1, cell.column);
                case game.GridDirection.RIGHT:
                    return this.getCellAt(cell.row, cell.column + 1);
                case game.GridDirection.BOTTOM:
                    return this.getCellAt(cell.row + 1, cell.column);
                case game.GridDirection.LEFT:
                    return this.getCellAt(cell.row, cell.column - 1);
            }
        };
        GameGrid.prototype.getCellNeighbours = function (cell) {
            return [
                this.getCellNeighbour(cell, GridDirection.TOP),
                this.getCellNeighbour(cell, GridDirection.RIGHT),
                this.getCellNeighbour(cell, GridDirection.BOTTOM),
                this.getCellNeighbour(cell, GridDirection.LEFT),
            ];
        };
        GameGrid.prototype.isCellFree = function (column, row, _bodiesToCheck) {
            var cell = this.getCellAt(row, column);
            if (!cell) {
                return false;
            }
            var size = GameGrid.CELL_SIZE * 0.9;
            this.testRect.x = cell.x - size / 2;
            this.testRect.y = cell.y - size / 2;
            this.testRect.setSize(size);
            var bodiesToCheck = _bodiesToCheck || this.scene.matter.world.getAllBodies().filter(function (body) { return body.isStatic; });
            return this.scene.matter.intersectRect(this.testRect.x, this.testRect.y, this.testRect.width, this.testRect.height, false, bodiesToCheck).length === 0;
        };
        GameGrid.prototype.toggleDebug = function () {
            var _this = this;
            this.debug = !this.debug;
            this.rowLabels.forEach(function (label) { return (label.visible = _this.debug); });
            this.cells.forEach(function (cell) {
                cell.alpha = _this.debug ? 0.33 : cell.originalAlpha;
            });
        };
        GameGrid.prototype.showClearGridFx = function (targetAlpha, initialDelay) {
            var _this = this;
            if (initialDelay === void 0) { initialDelay = 0; }
            var rows = Object.values(_.groupBy(this.cells, "column"));
            rows.forEach(function (row, index) {
                var delay = initialDelay + index * 33;
                _this.scene.tweens.add({
                    delay: delay,
                    targets: row,
                    duration: 300,
                    ease: Phaser.Math.Easing.Sine.InOut,
                    alpha: targetAlpha,
                    yoyo: true,
                });
            });
        };
        GameGrid.prototype.highlightRow = function (row, targetAlpha, initialDelay) {
            var _this = this;
            var cells = this.cells.filter(function (cell) { return cell.row === row; });
            cells.forEach(function (cell) {
                _this.scene.tweens.add({
                    delay: initialDelay,
                    targets: cell,
                    duration: 250,
                    ease: Phaser.Math.Easing.Sine.InOut,
                    alpha: targetAlpha,
                    yoyo: true,
                    hold: 100,
                });
            });
        };
        GameGrid.LOSE_ROW = 2;
        GameGrid.CELL_SIZE = 100;
        GameGrid.COLUMNS = 7;
        GameGrid.ROWS = 9;
        return GameGrid;
    }(Phaser.GameObjects.Container));
    game.GameGrid = GameGrid;
})(game || (game = {}));
var game;
(function (game) {
    var GridWalls = /** @class */ (function () {
        function GridWalls(scene, gridWidth, gridHeight) {
            this.scene = scene;
            this.matter = this.scene.matter;
            this.createWalls(gridWidth, gridHeight);
        }
        GridWalls.prototype.createWalls = function (gridWidth, gridHeight) {
            var wallWidth = gridWidth + GridWalls.THICKNESS * 2;
            var wallHeight = gridHeight + GridWalls.THICKNESS * 2;
            var config = {
                restitution: 1,
                isStatic: true,
                friction: 0,
                frictionAir: 0,
                frictionStatic: 0,
                label: game.CollisionTag.WALL,
            };
            this.top = this.matter.add.rectangle(0, 0, wallWidth, GridWalls.THICKNESS, config);
            this.right = this.matter.add.rectangle(0, 0, GridWalls.THICKNESS, wallHeight, config);
            this.bottom = this.matter.add.rectangle(0, 0, wallWidth, GridWalls.THICKNESS, __assign(__assign({}, config), { label: game.CollisionTag.FLOOR }));
            this.left = this.matter.add.rectangle(0, 0, GridWalls.THICKNESS, wallHeight, config);
            this.all = [this.top, this.right, this.bottom, this.left];
            this.all.forEach(function (wall) {
                wall.plugin[game.COLLISION_TAG] = game.CollisionTag.WALL;
            });
            this.bottom.plugin[game.COLLISION_TAG] = game.CollisionTag.FLOOR;
        };
        GridWalls.prototype.align = function (grid) {
            var padding = GridWalls.THICKNESS / 2;
            var gridCenterX = grid.x + grid.getWidth() / 2;
            var gridCenterY = grid.y + grid.getHeight() / 2;
            this.matter.body.setPosition(this.top, { x: gridCenterX, y: grid.y - padding });
            this.matter.body.setPosition(this.right, { x: grid.getWidth() + padding, y: gridCenterY });
            this.matter.body.setPosition(this.bottom, { x: gridCenterX, y: grid.getHeight() + padding });
            this.matter.body.setPosition(this.left, { x: -padding, y: gridCenterY });
        };
        GridWalls.THICKNESS = 160;
        return GridWalls;
    }());
    game.GridWalls = GridWalls;
})(game || (game = {}));
var game;
(function (game) {
    var GameItemEvent;
    (function (GameItemEvent) {
        GameItemEvent["PRE_DESTROY"] = "GameItem_PRE_DESTROY";
    })(GameItemEvent = game.GameItemEvent || (game.GameItemEvent = {}));
})(game || (game = {}));
var game;
(function (game) {
    var LightningEvent;
    (function (LightningEvent) {
        LightningEvent["KILL_START"] = "kill_start";
        LightningEvent["ACTIVATE"] = "activate";
    })(LightningEvent = game.LightningEvent || (game.LightningEvent = {}));
    var Lightning = /** @class */ (function (_super) {
        __extends(Lightning, _super);
        function Lightning(world, animation) {
            var _this = _super.call(this, world, 0, 0, animation.frames[0].textureKey, animation.frames[0].frame.name) || this;
            _this._wasActivated = false;
            _this.animation = animation;
            _this.setCircle(30, { isStatic: true, isSensor: true });
            _this.body.plugin[game.COLLISION_TAG] = game.CollisionTag.LIGHTNING;
            _this._itemType = game.ItemType.LIGHTNING;
            _this.name = "lightning";
            _this.grid = new game.GridComponent(_this);
            _this.killTweens = new game.KillTweens(_this.scene, _this);
            _this.hideComponent = new game.HideComponent(_this.scene, _this);
            return _this;
        }
        Object.defineProperty(Lightning.prototype, "itemType", {
            get: function () {
                return this._itemType;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Lightning.prototype, "wasActivated", {
            get: function () {
                return this._wasActivated;
            },
            enumerable: false,
            configurable: true
        });
        Lightning.prototype.startIdleTweensAndAnimation = function () {
            var _this = this;
            var delay = Phaser.Math.RND.between(0, 300);
            this.scene.time.delayedCall(delay, function () {
                _this.play(_this.animation.key);
                _this.playIdleTweens();
            });
        };
        Lightning.prototype.playIdleTweens = function () {
            var _this = this;
            var angle = 4 * Phaser.Math.RND.sign();
            var angleTweenDuration = 600;
            this.scene.tweens.add({
                targets: this,
                duration: angleTweenDuration / 2,
                ease: Phaser.Math.Easing.Sine.Out,
                angle: angle,
                onComplete: function () {
                    _this.scene.tweens.add({
                        targets: _this,
                        duration: angleTweenDuration,
                        ease: Phaser.Math.Easing.Sine.InOut,
                        angle: _this.angle * -1,
                        yoyo: true,
                        repeat: -1,
                    });
                },
            });
            this.scene.tweens.add({
                targets: this,
                duration: angleTweenDuration * 1.5,
                ease: Phaser.Math.Easing.Sine.InOut,
                scale: 1.12,
                yoyo: true,
                repeat: -1,
            });
        };
        Lightning.prototype.activate = function () {
            if (this._wasActivated === false) {
                this._wasActivated = true;
                this.emit(LightningEvent.ACTIVATE, this);
            }
            if (this.scaleTween && this.scaleTween.isPlaying()) {
                return;
            }
            this.playScaleAndAlphaTween();
        };
        Lightning.prototype.playScaleAndAlphaTween = function () {
            this.scale = 1;
            this.alpha = 1;
            this.scaleTween = this.scene.tweens.add({
                targets: this,
                duration: 100,
                ease: Phaser.Math.Easing.Sine.InOut,
                scale: 1.4,
                alpha: 0.5,
                yoyo: true,
            });
        };
        Lightning.prototype.kill = function () {
            this.emit(LightningEvent.KILL_START, this);
            this.on(game.KillTweensEvent.COMPLETE, this.destroy, this);
            this.killTweens.play();
        };
        Lightning.prototype.hideOnLevelComplete = function (duration) {
            this.hideComponent.hide(duration);
        };
        Lightning.prototype.destroy = function (fromScene) {
            if (this.scene) {
                this.scene.tweens.killTweensOf(this);
            }
            this.emit(game.GameItemEvent.PRE_DESTROY, this, fromScene);
            _super.prototype.destroy.call(this, fromScene);
            this.grid.destroy();
        };
        return Lightning;
    }(Phaser.Physics.Matter.Sprite));
    game.Lightning = Lightning;
})(game || (game = {}));
var game;
(function (game) {
    var SpinnerEvent;
    (function (SpinnerEvent) {
        SpinnerEvent["KILL_START"] = "kill_start";
        SpinnerEvent["ACTIVATE"] = "activate";
    })(SpinnerEvent = game.SpinnerEvent || (game.SpinnerEvent = {}));
    var Spinner = /** @class */ (function (_super) {
        __extends(Spinner, _super);
        function Spinner(world, animation) {
            var _this = _super.call(this, world, 0, 0, animation.frames[0].textureKey, animation.frames[0].frame.name) || this;
            _this.timeScale = 1;
            _this.initialAngularSpeed = 0.1;
            _this.angularSpeed = 0;
            _this.wasActivated = false;
            _this.name = "spinner";
            _this.animation = animation;
            _this._itemType = game.ItemType.SPINNER;
            _this.setCircle(30, { isStatic: true, isSensor: true });
            _this.body.plugin[game.COLLISION_TAG] = game.CollisionTag.SPINNER;
            _this.spinnedBalls = [];
            _this.angularSpeed = Phaser.Math.RND.sign() * _this.initialAngularSpeed;
            _this.grid = new game.GridComponent(_this);
            _this.killTweens = new game.KillTweens(_this.scene, _this);
            _this.hideComponent = new game.HideComponent(_this.scene, _this);
            return _this;
        }
        Object.defineProperty(Spinner.prototype, "itemType", {
            get: function () {
                return this._itemType;
            },
            enumerable: false,
            configurable: true
        });
        Spinner.prototype.startIdleTweensAndAnimation = function () {
            var _this = this;
            var delay = Phaser.Math.RND.between(0, 500);
            this.scene.time.delayedCall(delay, function () {
                _this.play(_this.animation.key);
                _this.playIdleTween();
            });
        };
        Spinner.prototype.playIdleTween = function () {
            this.scene.tweens.add({
                targets: this,
                duration: 600,
                ease: Phaser.Math.Easing.Sine.InOut,
                scale: 0.9,
                yoyo: true,
                repeat: -1,
            });
        };
        Spinner.prototype.activate = function () {
            if (this.wasActivated === false) {
                this.wasActivated = true;
                this.emit(SpinnerEvent.ACTIVATE, this);
            }
            if (this.scaleTween && this.scaleTween.isPlaying()) {
                return;
            }
            this.playScaleAndAlphaTween();
            this.playAngularSpeedTween();
        };
        Spinner.prototype.playScaleAndAlphaTween = function () {
            this.scale = 1;
            this.alpha = 1;
            this.scaleTween = this.scene.tweens.add({
                targets: this,
                duration: 100,
                ease: Phaser.Math.Easing.Sine.InOut,
                scale: 1.25,
                alpha: 0.5,
                yoyo: true,
            });
        };
        Spinner.prototype.playAngularSpeedTween = function () {
            if (this.angularSpeedTween && this.angularSpeedTween.isPlaying()) {
                return;
            }
            var sign = Phaser.Math.Sign(this.angularSpeed);
            this.angularSpeed = this.initialAngularSpeed * 5 * sign;
            this.scene.tweens.add({
                targets: this,
                delay: 1000,
                duration: 1000,
                ease: Phaser.Math.Easing.Linear.Linear,
                angularSpeed: this.initialAngularSpeed * sign,
            });
        };
        Spinner.prototype.preUpdate = function (time, delta) {
            _super.prototype.preUpdate.call(this, time, delta);
            this.updateSpinnedBalls(time);
            this.angle += this.angularSpeed * delta * this.timeScale;
        };
        Spinner.prototype.updateSpinnedBalls = function (time) {
            if (this.spinnedBalls.length === 0) {
                return;
            }
            this.spinnedBalls = this.spinnedBalls.filter(function (ball) {
                return time - ball.timestamp < 133;
            });
        };
        Spinner.prototype.kill = function () {
            this.emit(SpinnerEvent.KILL_START, this);
            this.once(game.KillTweensEvent.COMPLETE, this.destroy, this);
            this.killTweens.play();
        };
        Spinner.prototype.hideOnLevelComplete = function (duration) {
            this.hideComponent.hide(duration);
        };
        Spinner.prototype.destroy = function (fromScene) {
            if (this.scene) {
                this.scene.tweens.killTweensOf(this);
            }
            this.emit(game.GameItemEvent.PRE_DESTROY, this, fromScene);
            _super.prototype.destroy.call(this, fromScene);
            this.grid.destroy();
            this.spinnedBalls = null;
        };
        return Spinner;
    }(Phaser.Physics.Matter.Sprite));
    game.Spinner = Spinner;
})(game || (game = {}));
var game;
(function (game) {
    var SpinnerIdleEmitter = /** @class */ (function () {
        function SpinnerIdleEmitter(scene, spinner, emitter) {
            this.isDestroyed = false;
            this.scene = scene;
            this.emitter = emitter;
            this.emitter.startFollow(spinner);
            this.spinner = spinner;
            this.spinner.on(game.SpinnerEvent.KILL_START, this.destroy, this);
            this.spinner.on(game.HideEvent.START, this.hide, this);
            this.spinner.on(Phaser.GameObjects.Events.DESTROY, this.destroy, this);
        }
        SpinnerIdleEmitter.prototype.hide = function () {
            this.emitter.killAll();
            this.emitter.on = false;
        };
        SpinnerIdleEmitter.prototype.destroy = function () {
            if (this.isDestroyed) {
                return;
            }
            this.isDestroyed = true;
            this.emitter.remove();
        };
        return SpinnerIdleEmitter;
    }());
    game.SpinnerIdleEmitter = SpinnerIdleEmitter;
})(game || (game = {}));
var game;
(function (game) {
    var StompingEvent;
    (function (StompingEvent) {
        StompingEvent["START"] = "START";
        StompingEvent["STOP"] = "STOP";
    })(StompingEvent = game.StompingEvent || (game.StompingEvent = {}));
    var StompingComponent = /** @class */ (function () {
        function StompingComponent(scene, owner) {
            this._isStomping = false;
            this.originalY = 0;
            this.scene = scene;
            this.owner = owner;
        }
        StompingComponent.prototype.start = function () {
            if (this._isStomping) {
                return;
            }
            this._isStomping = true;
            this.originalY = this.owner.y;
            this.owner.body["isStomping"] = true;
            this.owner.body["originalY"] = this.originalY;
            this.owner.emit(StompingEvent.START, this.owner);
            this.startStompingTween();
        };
        StompingComponent.prototype.startStompingTween = function () {
            var _this = this;
            var stompingHeight = 16;
            this.stompingTween = this.scene.tweens.add({
                targets: this.owner,
                duration: 300,
                ease: Phaser.Math.Easing.Linear.Linear,
                y: this.originalY - stompingHeight,
                onComplete: function () {
                    _this.stompingTween = _this.scene.tweens.add({
                        targets: _this.owner,
                        duration: 500,
                        ease: Phaser.Math.Easing.Elastic.Out,
                        easeParams: [0.1, 0.2],
                        y: _this.originalY,
                        completeDelay: 100,
                        onComplete: _this.startStompingTween.bind(_this),
                    });
                },
            });
        };
        StompingComponent.prototype.stop = function () {
            if (this._isStomping === false) {
                return;
            }
            this._isStomping = false;
            this.owner.body["isStomping"] = false;
            this.owner.emit(StompingEvent.STOP, this.owner);
            this.stopStompingTween();
        };
        StompingComponent.prototype.stopStompingTween = function () {
            if (this.stompingTween) {
                this.stompingTween.stop();
            }
            this.scene.tweens.add({
                targets: this.owner,
                duration: 100,
                ease: Phaser.Math.Easing.Cubic.Out,
                y: this.originalY,
            });
        };
        StompingComponent.prototype.destroy = function () {
            this.owner = null;
        };
        return StompingComponent;
    }());
    game.StompingComponent = StompingComponent;
})(game || (game = {}));
///<reference path='../components/StompingComponent.ts' />
var game;
(function (game) {
    var BasicBlockEvent;
    (function (BasicBlockEvent) {
        BasicBlockEvent["HIDE"] = "block_hide";
        BasicBlockEvent["FORCE_KILL"] = "force_kill";
        BasicBlockEvent["ZAP"] = "zap";
        BasicBlockEvent["HIT_BY_CRACKER"] = "hit_by_cracker";
    })(BasicBlockEvent = game.BasicBlockEvent || (game.BasicBlockEvent = {}));
    var BasicBlock = /** @class */ (function (_super) {
        __extends(BasicBlock, _super);
        function BasicBlock(world, texture, frame, lives, options) {
            var _this = _super.call(this, world, 0, 0, texture, frame, options) || this;
            _this.wasHitByCracker = false;
            _this.isReady = true;
            _this.matterBody = _this.body;
            _this.body.plugin[game.COLLISION_TAG] = game.CollisionTag.BASIC_BLOCK;
            _this._itemType = game.ItemType.BASIC_BLOCK;
            _this.name = "basic_block";
            _this.grid = new game.GridComponent(_this);
            _this.health = new game.HealthComponent(_this, lives);
            _this.stomping = new game.StompingComponent(_this.scene, _this);
            _this.hideComponent = new game.HideComponent(_this.scene, _this);
            _this.on(game.HealthEvent.DAMAGE, _this.onHit, _this);
            _this.on(game.HealthEvent.KILL, _this.kill, _this);
            return _this;
        }
        Object.defineProperty(BasicBlock.prototype, "itemType", {
            get: function () {
                return this._itemType;
            },
            enumerable: false,
            configurable: true
        });
        BasicBlock.prototype.onHit = function () {
            this.playHitTween();
        };
        BasicBlock.prototype.playHitTween = function () {
            if (this.scaleTween && this.scaleTween.isPlaying()) {
                return;
            }
            this.scaleTween = this.scene.tweens.add({
                targets: this,
                duration: 150,
                ease: Phaser.Math.Easing.Sine.InOut,
                scale: { start: 1, from: 1, to: 0.9 },
                yoyo: true,
            });
        };
        BasicBlock.prototype.kill = function () {
            var _this = this;
            this.scene.matter.world.remove(this.matterBody);
            this.scene.tweens.killTweensOf(this);
            var scaleTweenDuration = 270;
            this.scene.tweens.add({
                targets: this,
                duration: scaleTweenDuration,
                ease: Phaser.Math.Easing.Back.In,
                scale: 0.2,
            });
            var alphaTweenDuration = 30;
            var alphaTweenDelay = scaleTweenDuration - alphaTweenDuration;
            this.scene.tweens.add({
                targets: this,
                delay: alphaTweenDelay,
                duration: alphaTweenDuration,
                ease: Phaser.Math.Easing.Cubic.Out,
                alpha: { start: 1, from: 1, to: 0 },
                onComplete: function () {
                    _this.destroy(false);
                },
            });
        };
        BasicBlock.prototype.hideOnLevelComplete = function (duration) {
            this.hideComponent.hide(duration);
        };
        BasicBlock.prototype.forceKill = function () {
            this.emit(BasicBlockEvent.FORCE_KILL, this);
            this.visible = false;
            this.active = false;
        };
        BasicBlock.prototype.zap = function () {
            this.emit(BasicBlockEvent.ZAP, this);
        };
        BasicBlock.prototype.hitByCracker = function () {
            this.wasHitByCracker = true;
            this.emit(BasicBlockEvent.HIT_BY_CRACKER, this);
        };
        BasicBlock.prototype.startStomping = function () {
            this.stomping.start();
        };
        BasicBlock.prototype.stopStomping = function () {
            this.stomping.stop();
        };
        BasicBlock.prototype.destroy = function (fromScene) {
            if (this.scene) {
                this.scene.tweens.killTweensOf(this);
            }
            this.emit(game.GameItemEvent.PRE_DESTROY, this, fromScene);
            _super.prototype.destroy.call(this, fromScene);
            this.stomping.destroy();
            this.health.destroy();
            this.grid.destroy();
        };
        return BasicBlock;
    }(Phaser.Physics.Matter.Image));
    game.BasicBlock = BasicBlock;
})(game || (game = {}));
var game;
(function (game) {
    var BlockShadow = /** @class */ (function (_super) {
        __extends(BlockShadow, _super);
        function BlockShadow(scene, block) {
            var _this = _super.call(this, scene, 0, 0, "gameplay", "blocks/block_ground_shadow") || this;
            _this.block = block;
            _this.scene.events.on(Phaser.Scenes.Events.POST_UPDATE, _this.followBlock, _this);
            return _this;
        }
        BlockShadow.prototype.followBlock = function () {
            this.x = this.block.x + this.block.displayWidth * (0.5 - this.block.originX);
            this.y = this.block.y + this.block.displayHeight * (1 - this.block.originY);
            this.displayWidth = this.getDisplayWidth();
        };
        BlockShadow.prototype.getDisplayWidth = function () {
            if (this.block.itemType === game.ItemType.ICE_RHOMB) {
                return this.block.displayWidth * 1.1;
            }
            return this.block.displayWidth * 1.35;
        };
        BlockShadow.prototype.show = function () {
            this.alpha = 0;
            this.scene.tweens.add({
                targets: this,
                duration: 200,
                ease: Phaser.Math.Easing.Cubic.Out,
                alpha: 1,
            });
        };
        BlockShadow.prototype.destroy = function (fromScene) {
            if (this.scene) {
                this.scene.events.off(Phaser.Scenes.Events.POST_UPDATE, this.followBlock, this);
            }
            _super.prototype.destroy.call(this, fromScene);
        };
        return BlockShadow;
    }(Phaser.GameObjects.Image));
    game.BlockShadow = BlockShadow;
})(game || (game = {}));
var game;
(function (game) {
    var BlockFace = /** @class */ (function (_super) {
        __extends(BlockFace, _super);
        function BlockFace(scene, block) {
            var _this = _super.call(this, scene, 0, 0, "gameplay", block.frame.name + "_face_idle") || this;
            _this.offsetX = 0;
            _this.offsetY = 0;
            _this.scaleOffset = 0;
            _this.idleFrame = block.frame.name + "_face_idle";
            _this.hitFrame = block.frame.name + "_face_hit";
            _this.blinkFrame = block.frame.name + "_face_blink";
            _this.block = block;
            _this.block.on(game.HealthEvent.DAMAGE, _this.onBlockDamage, _this);
            _this.block.on(game.HealthEvent.KILL, _this.onBlockKill, _this);
            _this.block.on(game.BasicBlockEvent.FORCE_KILL, _this.destroy.bind(_this, false));
            _this.block.on(game.BasicBlockEvent.HIT_BY_CRACKER, _this.hitByCracker, _this);
            _this.block.on(game.HideEvent.COMPLETE, _this.destroy.bind(_this, false));
            _this.block.on(Phaser.GameObjects.Events.DESTROY, _this.destroy.bind(_this, false));
            _this.scene.events.on(Phaser.Scenes.Events.POST_UPDATE, _this.followBlock, _this);
            var blockType = _this.block.itemType;
            var floatingTypes = [game.ItemType.BASIC_BLOCK, game.ItemType.ICE_BLOCK, game.ItemType.PINATA_BLOCK];
            if (floatingTypes.includes(blockType)) {
                _this.playFloatAnimation();
            }
            if (blockType === game.ItemType.DYNAMITE_BLOCK) {
                var delays = _.range(0, 1000, 200);
                var delay = Phaser.Math.RND.pick(delays);
                _this.playExplosiveAnimation(delay);
            }
            if (blockType === game.ItemType.TRIANGLE) {
                var frame = block.frame.name;
                if (frame.includes("1") || frame.includes("2")) {
                    _this.playFloatAnimation();
                }
                else if (frame === "blocks/triangle_03") {
                    _this.playFloatAnimation(-3.5, -3.5);
                }
                else {
                    _this.playFloatAnimation(3.5, -3.5);
                }
            }
            return _this;
        }
        BlockFace.getFaceFrames = function (block) {
            return {
                idle: block.frame.name + "_face_idle",
                hit: block.frame.name + "_face_hit",
                blink: block.frame.name + "_face_blink",
            };
        };
        BlockFace.prototype.playExplosiveAnimation = function (delay) {
            var _this = this;
            var _a;
            if (delay === void 0) { delay = 0; }
            (_a = this.scene) === null || _a === void 0 ? void 0 : _a.tweens.add({
                delay: delay,
                targets: this,
                duration: 400,
                ease: Phaser.Math.Easing.Cubic.Out,
                scaleOffset: -0.2,
                onComplete: function () {
                    var _a;
                    (_a = _this.scene) === null || _a === void 0 ? void 0 : _a.tweens.add({
                        targets: _this,
                        duration: 1500,
                        ease: Phaser.Math.Easing.Elastic.Out,
                        scaleOffset: 0,
                        onComplete: function () {
                            _this.playExplosiveAnimation(2500);
                        },
                    });
                },
            });
        };
        BlockFace.prototype.playFloatAnimation = function (dx, dy) {
            if (dx === void 0) { dx = 0; }
            if (dy === void 0) { dy = -7; }
            var delays = _.range(0, 400, 100);
            var delay = Phaser.Math.RND.pick(delays);
            this.scene.tweens.add({
                delay: delay,
                targets: this,
                duration: 600,
                ease: Phaser.Math.Easing.Sine.InOut,
                offsetX: dx,
                offsetY: dy,
                repeat: -1,
                yoyo: true,
            });
        };
        BlockFace.prototype.onBlockDamage = function () {
            if (this.block.itemType === game.ItemType.DYNAMITE_BLOCK) {
                return;
            }
            this.setFrame(this.hitFrame);
            this.resetFrameAfter(300);
        };
        BlockFace.prototype.resetFrameAfter = function (delay) {
            var _this = this;
            if (this.resetFrameEvent) {
                this.resetFrameEvent.remove();
                this.resetFrameEvent = null;
            }
            this.resetFrameEvent = this.scene.time.delayedCall(delay, function () {
                _this.setFrame(_this.idleFrame);
            });
        };
        BlockFace.prototype.onBlockKill = function () {
            if (!this.scene) {
                return;
            }
            if (this.block.wasHitByCracker === false) {
                this.setDepth(game.GameplayDepth.DEAD_BLOCK_FACES);
            }
            this.scene.tweens.killTweensOf(this);
        };
        BlockFace.prototype.hitByCracker = function () {
            this.setDepth(game.GameplayDepth.HIT_BY_CRACKER_FACE);
            this.scene.tweens.killTweensOf(this);
        };
        BlockFace.prototype.followBlock = function () {
            this.x = this.block.x + this.offsetX + this.displayWidth * (this.originX - this.block.originX);
            this.y = this.block.y + this.offsetY + this.displayHeight * (this.originY - this.block.originY);
            this.scale = this.block.scale + this.scaleOffset;
        };
        BlockFace.prototype.destroy = function (fromScene) {
            if (this.scene) {
                this.scene.events.off(Phaser.Scenes.Events.POST_UPDATE, this.followBlock, this);
                this.scene.tweens.killTweensOf(this);
            }
            _super.prototype.destroy.call(this, fromScene);
        };
        return BlockFace;
    }(Phaser.GameObjects.Image));
    game.BlockFace = BlockFace;
})(game || (game = {}));
var game;
(function (game) {
    var BlockWhiteCopy = /** @class */ (function (_super) {
        __extends(BlockWhiteCopy, _super);
        function BlockWhiteCopy(scene) {
            var _this = _super.call(this, scene, 0, 0, "gameplay", "blocks/white_copies/basic_block_01") || this;
            _this.scene.events.on(Phaser.Scenes.Events.POST_UPDATE, _this.postUpdate, _this);
            return _this;
        }
        BlockWhiteCopy.getFrame = function (originalFrame) {
            return "blocks/white_copies/" + originalFrame.split("/")[1];
        };
        BlockWhiteCopy.prototype.postUpdate = function () {
            if (this.visible === false) {
                return;
            }
            if (!this.originalBlock) {
                return;
            }
            this.x = this.originalBlock.x + this.originalBlock.displayWidth * (0.5 - this.originalBlock.originX);
            this.y = this.originalBlock.y + this.originalBlock.displayHeight * (0.5 - this.originalBlock.originY);
            this.scale = this.originalBlock.scale;
            this.angle = this.originalBlock.angle;
        };
        BlockWhiteCopy.prototype.setBlock = function (block) {
            this.active = true;
            this.originalBlock = block;
            this.originalBlock.on(game.BasicBlockEvent.ZAP, this.show, this);
            this.originalBlock.on(game.BasicBlockEvent.FORCE_KILL, this.kill, this);
            this.originalBlock.on(Phaser.GameObjects.Events.DESTROY, this.kill, this);
            this.setFrame(BlockWhiteCopy.getFrame(this.originalBlock.frame.name));
        };
        BlockWhiteCopy.prototype.show = function () {
            var _this = this;
            if (this.visible) {
                return;
            }
            this.visible = true;
            this.alpha = 0;
            this.scene.tweens.killTweensOf(this);
            this.scene.tweens.add({
                targets: this,
                duration: 66,
                ease: Phaser.Math.Easing.Cubic.Out,
                alpha: 0.7,
                onComplete: function () {
                    _this.scene.tweens.add({
                        targets: _this,
                        duration: 400,
                        ease: Phaser.Math.Easing.Quartic.In,
                        alpha: 0,
                        onComplete: function () {
                            _this.visible = false;
                        },
                    });
                },
            });
        };
        BlockWhiteCopy.prototype.kill = function () {
            this.originalBlock.off(game.BasicBlockEvent.ZAP, this.show, this);
            this.originalBlock.off(game.BasicBlockEvent.FORCE_KILL, this.kill, this);
            this.originalBlock.off(Phaser.GameObjects.Events.DESTROY, this.kill, this);
            _super.prototype.kill.call(this);
        };
        BlockWhiteCopy.prototype.destroy = function (fromScene) {
            _super.prototype.destroy.call(this, fromScene);
        };
        return BlockWhiteCopy;
    }(Phaser.GameObjects.Image));
    game.BlockWhiteCopy = BlockWhiteCopy;
})(game || (game = {}));
var game;
(function (game) {
    var BlockRedCopy = /** @class */ (function (_super) {
        __extends(BlockRedCopy, _super);
        function BlockRedCopy(scene) {
            var _this = _super.call(this, scene, 0, 0, "gameplay", "blocks/white_copies/basic_block_01") || this;
            _this.scene.events.on(Phaser.Scenes.Events.POST_UPDATE, _this.followBlock, _this);
            return _this;
        }
        BlockRedCopy.getFrame = function (originalFrame) {
            return "blocks/red_copies/" + originalFrame.split("/")[1];
        };
        BlockRedCopy.prototype.kill = function () {
            this.visible = false;
            this.active = false;
        };
        BlockRedCopy.prototype.revive = function () {
            this.visible = true;
            this.active = true;
        };
        BlockRedCopy.prototype.setBlock = function (block) {
            this.originalBlock = block;
            this.originalBlock.on(game.StompingEvent.STOP, this.hide, this);
            this.originalBlock.on(Phaser.GameObjects.Events.DESTROY, this.destroy, this);
            this.setFrame(game.BlockWhiteCopy.getFrame(this.originalBlock.frame.name));
            this.setTint(0xFF0000);
        };
        BlockRedCopy.prototype.playFadeTween = function () {
            this.alpha = 0.1;
            this.scene.tweens.add({
                targets: this,
                duration: 500,
                ease: Phaser.Math.Easing.Sine.InOut,
                alpha: 0.5,
                yoyo: true,
                repeat: -1,
            });
        };
        BlockRedCopy.prototype.hide = function () {
            var _this = this;
            this.scene.tweens.killTweensOf(this);
            this.scene.tweens.add({
                targets: this,
                duration: 100,
                ease: Phaser.Math.Easing.Cubic.Out,
                alpha: 0,
                onComplete: function () {
                    _this.kill();
                },
            });
        };
        BlockRedCopy.prototype.followBlock = function () {
            if (this.visible === false) {
                return;
            }
            this.x = this.originalBlock.x + this.originalBlock.displayWidth * (0.5 - this.originalBlock.originX);
            this.y = this.originalBlock.y + this.originalBlock.displayHeight * (0.5 - this.originalBlock.originY);
            this.scale = this.originalBlock.scale;
            this.angle = this.originalBlock.angle;
        };
        BlockRedCopy.prototype.destroy = function (fromScene) {
            if (this.scene) {
                this.scene.tweens.killTweensOf(this);
            }
            _super.prototype.destroy.call(this, fromScene);
        };
        return BlockRedCopy;
    }(Phaser.GameObjects.Image));
    game.BlockRedCopy = BlockRedCopy;
})(game || (game = {}));
var game;
(function (game) {
    var BlockHealthCounter = /** @class */ (function (_super) {
        __extends(BlockHealthCounter, _super);
        function BlockHealthCounter(scene) {
            var _this = _super.call(this, scene, 0, 0, game.BitmapGameFont.BLOCK_LIVES, "0", 30) || this;
            _this.setOrigin(0.5, 0.5);
            _this.scene.events.on("postupdate", _this.followBlock, _this);
            return _this;
        }
        BlockHealthCounter.prototype.setBlock = function (block) {
            this.blockOffset = this.getBlockOffset(block);
            this.block = block;
            this.block.on(game.HealthEvent.DAMAGE, this.onBlockHit, this);
            this.block.on(game.HealthEvent.KILL, this.hide, this);
            this.block.on(game.HideEvent.START, this.hide, this);
            this.block.on(Phaser.GameObjects.Events.DESTROY, this.hide, this);
            this.updateLives();
        };
        BlockHealthCounter.prototype.getBlockOffset = function (block) {
            return {
                x: block.displayWidth * (0.5 - block.originX) - 3,
                y: -block.displayHeight * block.originY + 4,
            };
        };
        BlockHealthCounter.prototype.updateLives = function () {
            if (this.block) {
                this.setText(this.block.health.value.toString());
            }
        };
        BlockHealthCounter.prototype.onBlockHit = function () {
            this.updateLives();
        };
        BlockHealthCounter.prototype.hide = function () {
            this.block.off(game.HealthEvent.DAMAGE, this.onBlockHit, this);
            this.block.off(game.HealthEvent.KILL, this.hide, this);
            this.block.off(Phaser.GameObjects.Events.DESTROY, this.hide, this);
            this.kill();
        };
        BlockHealthCounter.prototype.followBlock = function () {
            if (!this.visible) {
                return;
            }
            if (!this.block) {
                return;
            }
            this.x = this.block.x + this.blockOffset.x;
            this.y = this.block.y + this.blockOffset.y;
        };
        BlockHealthCounter.prototype.destroy = function (fromScene) {
            if (this.scene) {
                this.scene.events.on("postupdate", this.followBlock, this);
            }
            _super.prototype.destroy.call(this, fromScene);
        };
        return BlockHealthCounter;
    }(Phaser.GameObjects.BitmapText));
    game.BlockHealthCounter = BlockHealthCounter;
})(game || (game = {}));
var game;
(function (game) {
    var TriangleBlock = /** @class */ (function (_super) {
        __extends(TriangleBlock, _super);
        function TriangleBlock(world, texture, frame, lives, options) {
            var _this = _super.call(this, world, texture, frame, lives, options) || this;
            _this._itemType = game.ItemType.TRIANGLE;
            return _this;
        }
        TriangleBlock.getFrame = function (num) {
            return "blocks/triangle_0" + num;
        };
        TriangleBlock.TOP_LEFT_FRAME = "blocks/triangle_03";
        TriangleBlock.TOP_RIGHT_FRAME = "blocks/triangle_04";
        TriangleBlock.BOTTOM_RIGHT_FRAME = "blocks/triangle_02";
        TriangleBlock.BOTTOM_LEFT_FRAME = "blocks/triangle_01";
        TriangleBlock.ALL_FRAMES = [TriangleBlock.TOP_LEFT_FRAME, TriangleBlock.TOP_RIGHT_FRAME, TriangleBlock.BOTTOM_RIGHT_FRAME, TriangleBlock.BOTTOM_LEFT_FRAME];
        return TriangleBlock;
    }(game.BasicBlock));
    game.TriangleBlock = TriangleBlock;
})(game || (game = {}));
var game;
(function (game) {
    var Direction;
    (function (Direction) {
        Direction[Direction["RIGHT"] = 1] = "RIGHT";
        Direction[Direction["LEFT"] = -1] = "LEFT";
        Direction[Direction["NONE"] = 0] = "NONE";
    })(Direction = game.Direction || (game.Direction = {}));
    var IceBlock = /** @class */ (function (_super) {
        __extends(IceBlock, _super);
        function IceBlock(world, texture, frame, lives, options) {
            var _this = _super.call(this, world, texture, frame, lives, options) || this;
            _this.timeScale = 1;
            _this.isMoving = false;
            _this.velocityK = 1;
            _this.lastDirection = Direction.NONE;
            _this.direction = Direction.NONE;
            _this.updateDirectionTimer = 0;
            _this.gameplay = _this.scene;
            _this.name = "ice_block";
            _this.position = { x: 0, y: 0 };
            _this.velocity = { x: 0, y: 0 };
            _this._itemType = game.ItemType.ICE_BLOCK;
            _this.matterBody.plugin.isMoving = true;
            _this.collisionPoints = [
                { x: 0, y: 0 },
                { x: 0, y: 0 },
                { x: 0, y: 0 },
            ];
            return _this;
        }
        IceBlock.prototype.startMoving = function () {
            this.isMoving = true;
        };
        IceBlock.prototype.preUpdate = function (time, delta) {
            if (this.isMoving) {
                this.updateMovement(time, delta);
            }
        };
        IceBlock.prototype.updateMovement = function (time, delta) {
            this.lastDirection = this.direction;
            this.updateDirection(delta);
            this.updateVelocityAndPosition(delta);
            if (this.direction !== this.lastDirection) {
                this.velocityK = 0;
                this.scene.tweens.add({
                    targets: this,
                    duration: 100,
                    ease: Phaser.Math.Easing.Linear.Linear,
                    velocityK: 1,
                });
            }
        };
        IceBlock.prototype.updateDirection = function (delta) {
            this.updateDirectionTimer += delta;
            if (this.updateDirectionTimer > 60) {
                this.direction = this.getNewDirection(this.direction);
                this.updateDirectionTimer -= 60;
            }
        };
        IceBlock.prototype.updateVelocityAndPosition = function (delta) {
            this.velocity.x = IceBlock.MOVING_SPEED * this.direction * this.timeScale * this.velocityK * delta;
            this.position.x = this.x + this.velocity.x;
            this.position.y = this.y;
            this.scene.matter.body.setPosition(this.matterBody, this.position);
            this.scene.matter.body.setVelocity(this.matterBody, this.velocity);
        };
        IceBlock.prototype.getNewDirection = function (currentDirection) {
            var newDirection = currentDirection;
            if (currentDirection === Direction.NONE) {
                var directions = Phaser.Math.RND.shuffle([Direction.LEFT, Direction.RIGHT]);
                var firstDirection = directions[0];
                var isFirstDirectionFree = this.isDirectionFree(firstDirection);
                if (isFirstDirectionFree) {
                    newDirection = firstDirection;
                }
                else {
                    var secondDirection = directions[1];
                    var isSecondDirectionFree = this.isDirectionFree(secondDirection);
                    if (isSecondDirectionFree) {
                        newDirection = secondDirection;
                    }
                }
                return newDirection;
            }
            var canMoveInSameDirection = this.isDirectionFree(currentDirection);
            if (canMoveInSameDirection === false) {
                var oppositeDirection = this.negateDirection(currentDirection);
                var canChangeDirection = this.isDirectionFree(oppositeDirection);
                if (canChangeDirection) {
                    newDirection = oppositeDirection;
                }
                else {
                    newDirection = Direction.NONE;
                }
            }
            return newDirection;
        };
        IceBlock.prototype.isDirectionFree = function (direction) {
            var _this = this;
            var offsetX = this.width / 2 + 1;
            var pointX = direction === Direction.LEFT ? this.x - offsetX : this.x + offsetX;
            var top = this.y - game.GameGrid.CELL_SIZE / 2 + 5;
            var middle = this.y;
            var bottom = this.y + game.GameGrid.CELL_SIZE / 2 - 5;
            this.collisionPoints[0].x = pointX;
            this.collisionPoints[0].y = top;
            this.collisionPoints[1].x = pointX;
            this.collisionPoints[1].y = middle;
            this.collisionPoints[2].x = pointX;
            this.collisionPoints[2].y = bottom;
            var bodiesToCheck = this.getBodiesToCheck();
            return this.collisionPoints.every(function (point) {
                return _this.scene.matter.intersectPoint(point.x, point.y, bodiesToCheck).length === 0;
            });
        };
        IceBlock.prototype.negateDirection = function (direction) {
            if (direction === Direction.NONE) {
                return Direction.NONE;
            }
            return direction === Direction.LEFT ? Direction.RIGHT : Direction.LEFT;
        };
        IceBlock.prototype.getBodiesToCheck = function () {
            var _this = this;
            var row = this.grid.getRow();
            return this.scene.matter.world.getAllBodies().filter(function (body) {
                var notThisBody = body !== _this.matterBody;
                return notThisBody && body.isStatic && _this.areInSameRow(row, body);
            });
        };
        IceBlock.prototype.areInSameRow = function (currentRow, body) {
            var bodyRow = this.getGridRow(body);
            if (bodyRow === -1) {
                return true;
            }
            return bodyRow === currentRow;
        };
        IceBlock.prototype.getGridRow = function (body) {
            var gameObject = body.gameObject;
            if (!gameObject) {
                return -1;
            }
            var hasGrid = typeof gameObject.grid !== "undefined";
            if (hasGrid === false) {
                return -1;
            }
            return gameObject.grid.getRow();
        };
        IceBlock.prototype.destroy = function (fromScene) {
            _super.prototype.destroy.call(this, fromScene);
        };
        IceBlock.MOVING_SPEED = 0.075;
        return IceBlock;
    }(game.BasicBlock));
    game.IceBlock = IceBlock;
})(game || (game = {}));
var game;
(function (game) {
    var RotatingIceBlock = /** @class */ (function (_super) {
        __extends(RotatingIceBlock, _super);
        function RotatingIceBlock(world, itemType, texture, frame, lives, options) {
            var _this = _super.call(this, world, texture, frame, lives, options) || this;
            _this.angularSpeed = 0.06;
            _this.name = "rotating_ice_block";
            _this.matterBody.plugin.isRotating = true;
            _this._itemType = itemType;
            return _this;
        }
        RotatingIceBlock.prototype.preUpdate = function (time, delta) {
            _super.prototype.preUpdate.call(this, time, delta);
            if (this.isMoving) {
                this.updateRotation(delta);
            }
        };
        RotatingIceBlock.prototype.updateRotation = function (delta) {
            this.angle += this.angularSpeed * this.direction * this.timeScale * this.velocityK * delta;
        };
        return RotatingIceBlock;
    }(game.IceBlock));
    game.RotatingIceBlock = RotatingIceBlock;
})(game || (game = {}));
var game;
(function (game) {
    var DynamiteBlockEvent;
    (function (DynamiteBlockEvent) {
        DynamiteBlockEvent["EXPLODE"] = "explode";
    })(DynamiteBlockEvent = game.DynamiteBlockEvent || (game.DynamiteBlockEvent = {}));
    var DynamiteBlock = /** @class */ (function (_super) {
        __extends(DynamiteBlock, _super);
        function DynamiteBlock(world, texture, frame, lives, options) {
            var _this = _super.call(this, world, texture, frame, lives, options) || this;
            _this._explosionRadius = game.GameGrid.CELL_SIZE * 1.5;
            _this._explosionDamage = 5;
            _this._itemType = game.ItemType.DYNAMITE_BLOCK;
            return _this;
        }
        Object.defineProperty(DynamiteBlock.prototype, "explosionDamage", {
            get: function () {
                return this._explosionDamage;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(DynamiteBlock.prototype, "explosionRadius", {
            get: function () {
                return this._explosionRadius;
            },
            enumerable: false,
            configurable: true
        });
        DynamiteBlock.prototype.kill = function () {
            var _this = this;
            this.scene.matter.world.remove(this.matterBody);
            this.scene.tweens.killTweensOf(this);
            this.scene.tweens.add({
                targets: this,
                duration: 350,
                ease: Phaser.Math.Easing.Back.In,
                scale: 0,
            });
            this.scene.tweens.add({
                targets: this,
                duration: 50,
                delay: 300,
                ease: Phaser.Math.Easing.Cubic.Out,
                alpha: 0,
                onComplete: function () {
                    _this.emit(DynamiteBlockEvent.EXPLODE, _this);
                    _this.destroy();
                },
            });
        };
        DynamiteBlock.prototype.destroy = function (fromScene) {
            _super.prototype.destroy.call(this, fromScene);
        };
        return DynamiteBlock;
    }(game.BasicBlock));
    game.DynamiteBlock = DynamiteBlock;
})(game || (game = {}));
var game;
(function (game) {
    var PinataEvent;
    (function (PinataEvent) {
        PinataEvent["DESTROY"] = "pinata_destroy";
    })(PinataEvent = game.PinataEvent || (game.PinataEvent = {}));
    var PinataBlock = /** @class */ (function (_super) {
        __extends(PinataBlock, _super);
        function PinataBlock(world, texture, frame, lives, options) {
            var _this = _super.call(this, world, texture, frame, lives, options) || this;
            _this.name = "pinata_block";
            _this._itemType = game.ItemType.PINATA_BLOCK;
            return _this;
        }
        PinataBlock.prototype.kill = function () {
            var _this = this;
            this.scene.matter.world.remove(this.matterBody);
            this.scene.tweens.killTweensOf(this);
            var scaleTweenDuration = 300;
            this.scene.tweens.add({
                targets: this,
                duration: scaleTweenDuration,
                ease: Phaser.Math.Easing.Back.In,
                scale: 1.75,
                onComplete: function () {
                    _this.destroy(false);
                }
            });
        };
        PinataBlock.prototype.destroy = function (fromScene) {
            if (fromScene === false) {
                this.emit(PinataEvent.DESTROY, this);
            }
            _super.prototype.destroy.call(this, fromScene);
        };
        return PinataBlock;
    }(game.BasicBlock));
    game.PinataBlock = PinataBlock;
})(game || (game = {}));
var game;
(function (game) {
    var ShatterBlockEvent;
    (function (ShatterBlockEvent) {
        ShatterBlockEvent["SHATTER"] = "shatter";
    })(ShatterBlockEvent = game.ShatterBlockEvent || (game.ShatterBlockEvent = {}));
    var ShatterBlock = /** @class */ (function (_super) {
        __extends(ShatterBlock, _super);
        function ShatterBlock(world, texture, frame, lives, options) {
            var _this = _super.call(this, world, texture, frame, lives, options) || this;
            _this._itemType = game.ItemType.SHATTER_BLOCK;
            return _this;
        }
        ShatterBlock.prototype.kill = function () {
            var _this = this;
            this.emit(ShatterBlockEvent.SHATTER, this);
            this.scene.matter.world.remove(this.matterBody);
            this.scene.tweens.add({
                targets: this,
                duration: 66,
                ease: Phaser.Math.Easing.Cubic.Out,
                alpha: 0,
                onComplete: function () {
                    _this.destroy();
                },
            });
        };
        ShatterBlock.prototype.destroy = function (fromScene) {
            _super.prototype.destroy.call(this, fromScene);
        };
        return ShatterBlock;
    }(game.BasicBlock));
    game.ShatterBlock = ShatterBlock;
})(game || (game = {}));
var game;
(function (game) {
    var ShatterBlockPiece = /** @class */ (function (_super) {
        __extends(ShatterBlockPiece, _super);
        function ShatterBlockPiece(world, texture, frame, lives, options) {
            var _this = _super.call(this, world, texture, frame, lives, options) || this;
            _this._itemType = game.ItemType.SHATTER_BLOCK_PIECE;
            return _this;
        }
        ShatterBlockPiece.getFrame = function (frameNumber) {
            if (frameNumber === 1) {
                return ShatterBlockPiece.UP_FRAME;
            }
            else if (frameNumber === 2) {
                return ShatterBlockPiece.RIGHT_FRAME;
            }
            else if (frameNumber === 3) {
                return ShatterBlockPiece.DOWN_FRAME;
            }
            else if (frameNumber === 4) {
                return ShatterBlockPiece.LEFT_FRAME;
            }
            return ShatterBlockPiece.UP_FRAME;
        };
        ShatterBlockPiece.UP_FRAME = "blocks/shatter_block_02_up";
        ShatterBlockPiece.RIGHT_FRAME = "blocks/shatter_block_02_right";
        ShatterBlockPiece.DOWN_FRAME = "blocks/shatter_block_02_down";
        ShatterBlockPiece.LEFT_FRAME = "blocks/shatter_block_02_left";
        ShatterBlockPiece.ALL_FRAMES = [ShatterBlockPiece.UP_FRAME, ShatterBlockPiece.RIGHT_FRAME, ShatterBlockPiece.DOWN_FRAME, ShatterBlockPiece.LEFT_FRAME];
        return ShatterBlockPiece;
    }(game.BasicBlock));
    game.ShatterBlockPiece = ShatterBlockPiece;
})(game || (game = {}));
var game;
(function (game) {
    var CollectableBallEvent;
    (function (CollectableBallEvent) {
        CollectableBallEvent["START_FALL"] = "start_fall";
        CollectableBallEvent["ACTIVATE"] = "activate";
    })(CollectableBallEvent = game.CollectableBallEvent || (game.CollectableBallEvent = {}));
    var CollectableBall = /** @class */ (function (_super) {
        __extends(CollectableBall, _super);
        function CollectableBall(world, worldBounds) {
            var _a;
            var _this = _super.call(this, world, 0, 0, "gameplay", CollectableBall.ORIGINAL_FRAME) || this;
            _this.isFalling = false;
            _this._isDestroyed = false;
            _this.setCircle(CollectableBall.RADIUS, {
                isStatic: true,
                isSensor: true,
                ignoreGravity: true,
                plugin: (_a = {},
                    _a[game.COLLISION_TAG] = game.CollisionTag.COLLECTABLE_BALL,
                    _a),
            });
            _this._itemType = game.ItemType.COLLECTABLE_BALL;
            _this.name = "collectable_ball";
            _this.grid = new game.GridComponent(_this);
            _this.killTweens = new game.KillTweens(_this.scene, _this);
            _this.hideComponent = new game.HideComponent(_this.scene, _this);
            _this.keeper = new game.BallKeeper(_this.scene, _this, worldBounds);
            return _this;
        }
        Object.defineProperty(CollectableBall.prototype, "itemType", {
            get: function () {
                return this._itemType;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(CollectableBall.prototype, "isDestroyed", {
            get: function () {
                return this._isDestroyed;
            },
            enumerable: false,
            configurable: true
        });
        CollectableBall.prototype.startIdleTweens = function () {
            var _this = this;
            var delay = Phaser.Math.RND.between(0, 300);
            this.state = "activated";
            this.scene.time.delayedCall(delay, function () {
                _this.emit(CollectableBallEvent.ACTIVATE, _this);
            });
            this.scene.tweens.add({
                delay: delay,
                targets: this,
                duration: 600,
                ease: Phaser.Math.Easing.Sine.InOut,
                scale: 1.1,
                yoyo: true,
                repeat: -1,
            });
            var targetAngle = Phaser.Math.RND.sign() * 6;
            var duration = 900;
            this.scene.tweens.add({
                delay: delay,
                targets: this,
                duration: duration / 2,
                ease: Phaser.Math.Easing.Sine.Out,
                angle: targetAngle,
                onComplete: function () {
                    _this.angleTween = _this.scene.tweens.add({
                        duration: duration,
                        targets: _this,
                        ease: Phaser.Math.Easing.Sine.InOut,
                        angle: _this.angle * -1,
                        yoyo: true,
                        repeat: -1,
                    });
                },
            });
        };
        CollectableBall.prototype.startFalling = function () {
            if (this.isFalling) {
                return;
            }
            this.isFalling = true;
            this.scene.tweens.killTweensOf(this);
            this.keeper.saveInitialPositionAndVelocity();
            this.playCollectTween();
            this.setSurprisedFrame();
            this.setSensor(false);
            this.setStatic(false);
            this.setIgnoreGravity(false);
            this.setAngularVelocity(0.15 * Phaser.Math.RND.sign());
            this.setVelocityY(-22 * (this.scene.game.loop.delta / 16.6666667));
            this.setAwake();
            this.emit(CollectableBallEvent.START_FALL, this);
        };
        CollectableBall.prototype.preUpdate = function (time, delta) {
            if (this.isFalling) {
                this.keeper.keepInsideWorld();
            }
        };
        CollectableBall.prototype.playCollectTween = function () {
            var _this = this;
            this.scene.tweens.killTweensOf(this);
            this.scene.tweens.add({
                targets: this,
                duration: 150,
                ease: Phaser.Math.Easing.Cubic.Out,
                angle: 0,
            });
            this.scene.tweens.add({
                targets: this,
                duration: 400,
                ease: Phaser.Math.Easing.Back.Out,
                scale: this.scale * 1.3,
                onComplete: function () {
                    _this.scene.tweens.add({
                        targets: _this,
                        duration: 150,
                        ease: Phaser.Math.Easing.Linear.Linear,
                        scale: 1,
                    });
                },
            });
        };
        CollectableBall.prototype.kill = function () {
            this.scene.tweens.killTweensOf(this);
            this.once(game.KillTweensEvent.COMPLETE, this.destroy, this);
            this.killTweens.play();
        };
        CollectableBall.prototype.setSurprisedFrame = function () {
            this.setFrame(CollectableBall.SURPRISED_FRAME);
            this.resetFrame(400);
        };
        CollectableBall.prototype.resetFrame = function (delay) {
            var _this = this;
            if (this.resetFrameEvent) {
                this.resetFrameEvent.remove();
                this.resetFrameEvent = null;
            }
            this.resetFrameEvent = this.scene.time.delayedCall(delay, function () {
                _this.setFrame(CollectableBall.ORIGINAL_FRAME);
            });
        };
        CollectableBall.prototype.hideOnLevelComplete = function (duration) {
            this.hideComponent.hide(duration);
        };
        CollectableBall.prototype.preDestroy = function () {
            this.scene.tweens.killTweensOf(this);
            if (this.angleTween) {
                this.angleTween.remove();
            }
        };
        CollectableBall.prototype.destroy = function (fromScene) {
            this.emit(game.GameItemEvent.PRE_DESTROY, this, fromScene);
            _super.prototype.destroy.call(this, fromScene);
            this.grid.destroy();
            this._isDestroyed = true;
        };
        CollectableBall.RADIUS = 37;
        CollectableBall.ORIGINAL_FRAME = "ball_collectable";
        CollectableBall.SURPRISED_FRAME = "ball_collectable_surprised";
        return CollectableBall;
    }(Phaser.Physics.Matter.Image));
    game.CollectableBall = CollectableBall;
})(game || (game = {}));
var game;
(function (game) {
    var GridComponent = /** @class */ (function () {
        function GridComponent(owner) {
            this.owner = owner;
        }
        GridComponent.prototype.alignToCell = function (cell) {
            this.owner.x = cell.x;
            this.owner.y = cell.y;
        };
        GridComponent.prototype.getGridPosition = function () {
            return { x: this.getColumn(), y: this.getRow() };
        };
        GridComponent.prototype.getColumn = function () {
            return Math.floor(this.owner.x / game.GameGrid.CELL_SIZE);
        };
        GridComponent.prototype.getRow = function () {
            var row = Math.floor(this.owner.y / game.GameGrid.CELL_SIZE);
            var reverseRow = game.GameGrid.ROWS - row - 1;
            return reverseRow;
        };
        GridComponent.prototype.destroy = function () {
            this.owner = null;
        };
        return GridComponent;
    }());
    game.GridComponent = GridComponent;
})(game || (game = {}));
var game;
(function (game) {
    var HealthEvent;
    (function (HealthEvent) {
        HealthEvent["DAMAGE"] = "damage";
        HealthEvent["KILL"] = "kill";
    })(HealthEvent = game.HealthEvent || (game.HealthEvent = {}));
    var HealthComponent = /** @class */ (function () {
        function HealthComponent(owner, health) {
            this.invincible = false;
            this.owner = owner;
            this._value = health;
        }
        Object.defineProperty(HealthComponent.prototype, "value", {
            get: function () {
                return this._value;
            },
            enumerable: false,
            configurable: true
        });
        HealthComponent.prototype.kill = function () {
            if (this.invincible) {
                return;
            }
            this.damage(this.value);
        };
        HealthComponent.prototype.damage = function (damageValue) {
            if (this.invincible) {
                return;
            }
            if (this.isAlive() === false) {
                return;
            }
            this._value = Phaser.Math.MinSub(this._value, damageValue, 0);
            this.owner.emit(HealthEvent.DAMAGE, this.owner, damageValue);
            if (this._value === 0) {
                this.owner.emit(HealthEvent.KILL, this.owner, damageValue);
            }
        };
        HealthComponent.prototype.isAlive = function () {
            return this._value > 0;
        };
        HealthComponent.prototype.destroy = function () {
            this.owner = null;
        };
        return HealthComponent;
    }());
    game.HealthComponent = HealthComponent;
})(game || (game = {}));
var game;
(function (game) {
    var KillTweensEvent;
    (function (KillTweensEvent) {
        KillTweensEvent["START"] = "start";
        KillTweensEvent["COMPLETE"] = "complete";
    })(KillTweensEvent = game.KillTweensEvent || (game.KillTweensEvent = {}));
    var KillTweens = /** @class */ (function () {
        function KillTweens(scene, owner) {
            this.scene = scene;
            this.owner = owner;
        }
        KillTweens.prototype.play = function () {
            var _this = this;
            this.owner.emit(KillTweensEvent.START, this.owner);
            var scaleTweenDuration = 270;
            this.scene.tweens.add({
                targets: this.owner,
                duration: scaleTweenDuration,
                ease: Phaser.Math.Easing.Back.In,
                scale: 0.33,
            });
            var alphaTweenDuration = 30;
            var alphaTweenDelay = scaleTweenDuration - alphaTweenDuration;
            this.scene.tweens.add({
                targets: this.owner,
                delay: alphaTweenDelay,
                duration: alphaTweenDuration,
                ease: Phaser.Math.Easing.Cubic.Out,
                alpha: 0,
                onComplete: function () {
                    _this.owner.emit(KillTweensEvent.COMPLETE, _this.owner);
                },
            });
        };
        KillTweens.prototype.destroy = function () { };
        return KillTweens;
    }());
    game.KillTweens = KillTweens;
})(game || (game = {}));
var game;
(function (game) {
    var HideEvent;
    (function (HideEvent) {
        HideEvent["START"] = "hide_start";
        HideEvent["COMPLETE"] = "hide_complete";
    })(HideEvent = game.HideEvent || (game.HideEvent = {}));
    var HideComponent = /** @class */ (function () {
        function HideComponent(scene, owner) {
            this.scene = scene;
            this.owner = owner;
        }
        HideComponent.prototype.hide = function (duration) {
            var _this = this;
            this.owner.emit(HideEvent.START, this.owner);
            this.scene.matter.world.remove(this.owner.body);
            this.scene.tweens.killTweensOf(this.owner);
            this.scene.tweens.add({
                targets: this.owner,
                duration: duration,
                ease: Phaser.Math.Easing.Back.In,
                scale: 0,
                onComplete: function () {
                    _this.owner.active = false;
                    _this.owner.visible = false;
                    _this.owner.emit(HideEvent.COMPLETE, _this.owner);
                },
            });
        };
        HideComponent.prototype.destroy = function () {
        };
        return HideComponent;
    }());
    game.HideComponent = HideComponent;
})(game || (game = {}));
var game;
(function (game) {
    game.COLLISION_TAG = "collision_tag";
    var CollisionTag;
    (function (CollisionTag) {
        CollisionTag["CRACKER"] = "cracker";
        CollisionTag["BOMB"] = "bomb";
        CollisionTag["SPINNER"] = "spinner";
        CollisionTag["LIGHTNING"] = "lightning";
        CollisionTag["BASIC_BLOCK"] = "basic_block";
        CollisionTag["BALL"] = "ball";
        CollisionTag["WINNING_BALL"] = "winning_ball";
        CollisionTag["COLLECTABLE_BALL"] = "collectable_ball";
        CollisionTag["WALL"] = "wall";
        CollisionTag["FLOOR"] = "floor";
    })(CollisionTag = game.CollisionTag || (game.CollisionTag = {}));
})(game || (game = {}));
var game;
(function (game) {
    var GameplayDepth;
    (function (GameplayDepth) {
        GameplayDepth[GameplayDepth["GRID"] = 0] = "GRID";
        GameplayDepth[GameplayDepth["BALL_TRAILS"] = 1] = "BALL_TRAILS";
        GameplayDepth[GameplayDepth["IDLE_BALLS_SHADOWS"] = 2] = "IDLE_BALLS_SHADOWS";
        GameplayDepth[GameplayDepth["IDLE_BALLS"] = 3] = "IDLE_BALLS";
        GameplayDepth[GameplayDepth["DEAD_BLOCKS"] = 4] = "DEAD_BLOCKS";
        GameplayDepth[GameplayDepth["DEAD_BLOCK_FACES"] = 5] = "DEAD_BLOCK_FACES";
        GameplayDepth[GameplayDepth["ICE_BLOCK_PARTICLES"] = 6] = "ICE_BLOCK_PARTICLES";
        GameplayDepth[GameplayDepth["SPINNERS"] = 7] = "SPINNERS";
        GameplayDepth[GameplayDepth["LIGHTNINGS"] = 8] = "LIGHTNINGS";
        GameplayDepth[GameplayDepth["BALLS_LIGHTNING_PARTICLES"] = 9] = "BALLS_LIGHTNING_PARTICLES";
        GameplayDepth[GameplayDepth["BALLS"] = 10] = "BALLS";
        GameplayDepth[GameplayDepth["BLOCK_HINT"] = 11] = "BLOCK_HINT";
        GameplayDepth[GameplayDepth["ITEMS"] = 12] = "ITEMS";
        GameplayDepth[GameplayDepth["STOMPING_BLOCKS"] = 13] = "STOMPING_BLOCKS";
        GameplayDepth[GameplayDepth["BLOCK_FACES"] = 14] = "BLOCK_FACES";
        GameplayDepth[GameplayDepth["BLOCK_WHITE_COPIES"] = 15] = "BLOCK_WHITE_COPIES";
        GameplayDepth[GameplayDepth["BLOCK_RED_COPIES"] = 16] = "BLOCK_RED_COPIES";
        GameplayDepth[GameplayDepth["NUDGED_ITEMS"] = 17] = "NUDGED_ITEMS";
        GameplayDepth[GameplayDepth["DROPPED_COLLECTABLE_BALLS"] = 18] = "DROPPED_COLLECTABLE_BALLS";
        GameplayDepth[GameplayDepth["TRAJECTORY"] = 19] = "TRAJECTORY";
        GameplayDepth[GameplayDepth["BLOCK_HEALTH_COUNTER"] = 20] = "BLOCK_HEALTH_COUNTER";
        GameplayDepth[GameplayDepth["BLOCK_DAMAGE_FX"] = 21] = "BLOCK_DAMAGE_FX";
        GameplayDepth[GameplayDepth["HIT_BY_CRACKER"] = 22] = "HIT_BY_CRACKER";
        GameplayDepth[GameplayDepth["HIT_BY_CRACKER_FACE"] = 23] = "HIT_BY_CRACKER_FACE";
        GameplayDepth[GameplayDepth["LOSE_TUTORIAL"] = 24] = "LOSE_TUTORIAL";
        GameplayDepth[GameplayDepth["BOOSTER_BELOW_PARTICLES"] = 25] = "BOOSTER_BELOW_PARTICLES";
        GameplayDepth[GameplayDepth["BOOSTER"] = 26] = "BOOSTER";
        GameplayDepth[GameplayDepth["BOOSTER_ABOVE_PARTICLES"] = 27] = "BOOSTER_ABOVE_PARTICLES";
        GameplayDepth[GameplayDepth["WINNING_BALLS"] = 28] = "WINNING_BALLS";
        GameplayDepth[GameplayDepth["PLUS_DUCK_FX"] = 29] = "PLUS_DUCK_FX";
        GameplayDepth[GameplayDepth["TURN_POINTS_FX"] = 30] = "TURN_POINTS_FX";
        GameplayDepth[GameplayDepth["PARTICLES"] = 31] = "PARTICLES";
        GameplayDepth[GameplayDepth["JUMP_ON_FOX_BLOCK"] = 32] = "JUMP_ON_FOX_BLOCK";
        GameplayDepth[GameplayDepth["JUMP_ON_FOX_BLOCK_DUST"] = 33] = "JUMP_ON_FOX_BLOCK_DUST";
        GameplayDepth[GameplayDepth["FOX_THROWN"] = 34] = "FOX_THROWN";
        GameplayDepth[GameplayDepth["LOSING_BALLS"] = 35] = "LOSING_BALLS";
        GameplayDepth[GameplayDepth["LEVEL_COMPLETE_FX_PARTICLES"] = 36] = "LEVEL_COMPLETE_FX_PARTICLES";
        GameplayDepth[GameplayDepth["LEVEL_COMPLETE_FX"] = 37] = "LEVEL_COMPLETE_FX";
        GameplayDepth[GameplayDepth["EXPLOSION"] = 38] = "EXPLOSION";
    })(GameplayDepth = game.GameplayDepth || (game.GameplayDepth = {}));
})(game || (game = {}));
var game;
(function (game) {
    var BallCharged = /** @class */ (function (_super) {
        __extends(BallCharged, _super);
        function BallCharged(scene, ball) {
            var _this = _super.call(this, scene, 0, 0, "gameplay", "ball_lightning_3") || this;
            _this.subDepth = 0;
            _this.ball = ball;
            // this.ball.on(BallEvent.CHARGE, this.show, this)
            // this.ball.on(BallEvent.DISCHARGE, this.kill, this)
            // this.scene.events.on("postupdate", this.followBall, this)
            _this.kill();
            return _this;
        }
        BallCharged.prototype.show = function () {
            this.revive();
            this.alpha = 0;
            this.scene.tweens.add({
                targets: this,
                duration: 200,
                ease: Phaser.Math.Easing.Cubic.Out,
                alpha: 0.75,
            });
        };
        BallCharged.prototype.kill = function () {
            this.scene.tweens.killTweensOf(this);
            this.visible = false;
            this.active = false;
        };
        BallCharged.prototype.revive = function () {
            this.visible = true;
            this.active = true;
        };
        BallCharged.prototype.followBall = function () {
            if (!this.visible) {
                return;
            }
            this.x = this.ball.x;
            this.y = this.ball.y;
            this.angle = this.ball.angle;
            this.scale = this.ball.scale;
        };
        BallCharged.prototype.destroy = function (fromScene) {
            this.ball = null;
            if (this.scene) {
                this.scene.tweens.killTweensOf(this);
                this.scene.events.off("postupdate", this.followBall, this);
            }
            _super.prototype.destroy.call(this, fromScene);
        };
        return BallCharged;
    }(Phaser.GameObjects.Image));
    game.BallCharged = BallCharged;
})(game || (game = {}));
var game;
(function (game) {
    var LevelGenerator = /** @class */ (function () {
        function LevelGenerator(scene, levelConfig) {
            this.rowPointer = 0;
            this.scene = scene;
            this.levelConfig = levelConfig;
            this.generatorConfig = levelConfig.generator;
            this.itemsGenerator = new game.ItemsGenerator(scene, this.levelConfig);
            var predefinedItems = this.createPredefinedItems(levelConfig.items);
            // let generatedItems = this.createGeneratedItems(levelConfig.items)
            var generatedItems = [];
            this.items = __spreadArrays(predefinedItems, generatedItems);
            this.items = this.items.sort(this.sortByGridPosition.bind(this));
        }
        LevelGenerator.prototype.sortByGridPosition = function (a, b) {
            if (a.row === b.row) {
                return a.column - b.column;
            }
            return a.row - b.row;
        };
        LevelGenerator.prototype.createPredefinedItems = function (predefinedItems) {
            return predefinedItems.map(function (itemConfig) {
                return {
                    type: itemConfig.type,
                    column: itemConfig.column,
                    row: itemConfig.row,
                    config: __assign({}, itemConfig.params),
                };
            });
        };
        LevelGenerator.prototype.getInitialItems = function (rowsNum) {
            this.rowPointer += rowsNum;
            return this.items.filter(function (item) { return item.row < rowsNum; });
        };
        LevelGenerator.prototype.getNextRows = function (rowsNum) {
            var bottomRow = this.rowPointer;
            var topRow = this.rowPointer + rowsNum;
            var items = this.items.filter(function (item) { return item.row >= bottomRow && item.row < topRow; });
            this.rowPointer += rowsNum;
            return items;
        };
        LevelGenerator.prototype.moveRowPointer = function (delta) {
            this.rowPointer += delta;
        };
        return LevelGenerator;
    }());
    game.LevelGenerator = LevelGenerator;
})(game || (game = {}));
var game;
(function (game) {
    var Explosion = /** @class */ (function (_super) {
        __extends(Explosion, _super);
        function Explosion(scene, animation) {
            var _this = _super.call(this, scene, 0, 0, animation.frames[0].textureKey, animation.frames[0].frame.name) || this;
            _this.on("animationcomplete-" + animation.key, _this.destroy, _this);
            _this.play(animation.key);
            return _this;
        }
        Explosion.prototype.playScaleTween = function () {
            this.scene.tweens.add({
                targets: this,
                duration: 500,
                ease: Phaser.Math.Easing.Back.Out,
                scale: this.scale * 1.5,
            });
        };
        Explosion.prototype.destroy = function (fromScene) {
            _super.prototype.destroy.call(this, fromScene);
        };
        return Explosion;
    }(Phaser.GameObjects.Sprite));
    game.Explosion = Explosion;
})(game || (game = {}));
var game;
(function (game) {
    var BlockDamageFx = /** @class */ (function (_super) {
        __extends(BlockDamageFx, _super);
        function BlockDamageFx(scene) {
            var _this = _super.call(this, scene, 0, 0, game.BitmapGameFont.BLOCK_DAMAGE_FX, "0", 30) || this;
            _this.setOrigin(0.5, 0.5);
            return _this;
        }
        BlockDamageFx.prototype.reset = function () {
            this.active = true;
            this.visible = true;
            this.scene.tweens.killTweensOf(this);
        };
        BlockDamageFx.prototype.show = function () {
            this.alpha = 0;
            this.scene.tweens.add({
                targets: this,
                duration: 150,
                ease: Phaser.Math.Easing.Cubic.Out,
                alpha: 1,
                completeDelay: 700,
                onComplete: this.hide.bind(this),
            });
            this.scale = 0.66;
            this.scene.tweens.add({
                targets: this,
                scale: { value: 1, duration: 600, ease: Phaser.Math.Easing.Back.Out },
                x: { value: this.getTargetX(), duration: 500, ease: Phaser.Math.Easing.Back.Out },
                y: { value: "-=20", duration: 1200, ease: Phaser.Math.Easing.Linear.Linear },
            });
        };
        BlockDamageFx.prototype.getTargetX = function () {
            return this.x + Phaser.Math.RND.sign() * Phaser.Math.RND.between(7, 14);
        };
        BlockDamageFx.prototype.hide = function () {
            var _this = this;
            this.scene.tweens.add({
                targets: this,
                duration: 200,
                ease: Phaser.Math.Easing.Cubic.Out,
                alpha: 0,
                onComplete: function () {
                    _this.visible = false;
                    _this.active = false;
                },
            });
        };
        return BlockDamageFx;
    }(Phaser.GameObjects.BitmapText));
    game.BlockDamageFx = BlockDamageFx;
})(game || (game = {}));
var game;
(function (game) {
    var PlusBallFx = /** @class */ (function (_super) {
        __extends(PlusBallFx, _super);
        function PlusBallFx(scene, text) {
            var _this = _super.call(this, scene, 0, 0, text, PlusBallFx.getTextStyle()) || this;
            _this.setOrigin(0.5, 0.5);
            return _this;
        }
        PlusBallFx.getTextStyle = function () {
            return {
                fontFamily: game.GameFont.SOUSES,
                fontStyle: game.FontWeight.BLACK,
                fontSize: "29px",
                color: "#C62324",
                strokeThickness: 8,
                stroke: "#EED898",
                shadow: {
                    blur: 0,
                    offsetY: 4,
                    color: "rgba(0,0,0,0.2)",
                    stroke: true,
                    fill: false,
                },
            };
        };
        PlusBallFx.prototype.show = function () {
            var _this = this;
            this.alpha = 0;
            this.scene.tweens.add({
                targets: this,
                alpha: { value: 1, duration: 150, ease: Phaser.Math.Easing.Cubic.Out },
                completeDelay: 800,
                onComplete: function () {
                    _this.hide();
                },
            });
            this.scale = 0.66;
            this.scene.tweens.add({
                targets: this,
                duration: 1000,
                ease: Phaser.Math.Easing.Elastic.Out,
                easeParams: [0.1, 0.33],
                scale: 1,
            });
            this.angle = Phaser.Math.RND.sign() * 5;
            this.scene.tweens.add({
                targets: this,
                duration: 600,
                ease: Phaser.Math.Easing.Sine.InOut,
                angle: this.angle * -1,
                repeat: -1,
                yoyo: true,
            });
        };
        PlusBallFx.prototype.hide = function () {
            var _this = this;
            this.scene.tweens.add({
                targets: this,
                duration: 200,
                ease: Phaser.Math.Easing.Cubic.Out,
                alpha: 0,
                scale: 1.2,
                onComplete: function () {
                    _this.destroy();
                },
            });
        };
        PlusBallFx.prototype.preUpdate = function (time, delta) {
            this.y -= delta * 0.035;
        };
        return PlusBallFx;
    }(Phaser.GameObjects.Text));
    game.PlusBallFx = PlusBallFx;
})(game || (game = {}));
var game;
(function (game) {
    var LevelCompleteText = /** @class */ (function (_super) {
        __extends(LevelCompleteText, _super);
        function LevelCompleteText(scene, text) {
            var _this = _super.call(this, scene, 0, 0, text, LevelCompleteText.getTextStyle()) || this;
            _this.setLineSpacing(-25);
            _this.setOrigin(0.5, 0.5);
            return _this;
        }
        LevelCompleteText.getTextStyle = function () {
            return {
                fontFamily: game.GameFont.SOUSES,
                fontStyle: game.FontWeight.BLACK,
                fontSize: "80px",
                color: "#C62324",
                strokeThickness: 14,
                stroke: "#EED898",
                align: "center",
                shadow: {
                    blur: 0,
                    offsetY: 10,
                    color: "rgba(0,0,0,0.2)",
                    stroke: true,
                    fill: false,
                },
            };
        };
        LevelCompleteText.prototype.show = function () {
            this.alpha = 0;
            this.scene.tweens.add({
                targets: this,
                alpha: { value: 1, duration: 200, ease: Phaser.Math.Easing.Quintic.In },
            });
            var deltaY = 80;
            this.y += deltaY;
            this.scene.tweens.add({
                targets: this,
                duration: 1500,
                ease: Phaser.Math.Easing.Elastic.Out,
                easeParams: [0.1, 0.5],
                y: this.y - deltaY,
            });
            this.scene.tweens.add({
                targets: this,
                duration: 500,
                ease: Phaser.Math.Easing.Back.Out,
                scale: { from: 2.5, to: 1 },
            });
        };
        return LevelCompleteText;
    }(Phaser.GameObjects.Text));
    game.LevelCompleteText = LevelCompleteText;
})(game || (game = {}));
///<reference path='LevelCompleteText.ts' />
var game;
(function (game) {
    var EasingString = Phaser.Math.EasingString;
    var LevelCompleteFx = /** @class */ (function (_super) {
        __extends(LevelCompleteFx, _super);
        function LevelCompleteFx(scene, isLastLevel) {
            var _this = _super.call(this, scene) || this;
            _this.emitterParticlesNum = 40;
            _this.name = "level_complete";
            _this.addCircleFx();
            _this.addText(isLastLevel);
            _this.addEmitter();
            return _this;
        }
        LevelCompleteFx.prototype.addCircleFx = function () {
            this.circleFx = this.scene.add.image(0, 0, "gameplay", "circle_fx_beige");
            this.circleFx.scale = 0.5;
            this.circleFx.alpha = 0;
            this.add(this.circleFx);
        };
        LevelCompleteFx.prototype.addText = function (isLastLevel) {
            var content = isLastLevel
                ? this.scene.texts.game_complete
                : this.scene.texts.level_complete;
            this.text = new game.LevelCompleteText(this.scene, content);
            this.add(this.text);
        };
        LevelCompleteFx.prototype.addEmitter = function () {
            if (this.scene.game.rendererType === game.RendererType.CANVAS) {
                return;
            }
            var manager = this.scene.add.particles("gameplay").setDepth(game.GameplayDepth.LEVEL_COMPLETE_FX_PARTICLES);
            this.emitter = manager.createEmitter({
                emitZone: this.getEmitZone(),
                frame: "particles_spark_3",
                lifespan: 900,
                radial: true,
                angle: { start: 0, end: 360, steps: this.emitterParticlesNum },
                scale: { start: 0.5, end: 0, ease: EasingString.ExpoEaseIn },
                alpha: { start: 0.8, end: 0 },
                speed: { min: 150, max: 400 },
                on: false,
            });
        };
        LevelCompleteFx.prototype.getEmitZone = function () {
            return {
                source: new Phaser.Geom.Circle(0, 0, 40),
                quantity: this.emitterParticlesNum,
                type: "edge",
            };
        };
        LevelCompleteFx.prototype.show = function () {
            var _this = this;
            this.scene.tweens.add({
                delay: 400,
                targets: this,
                duration: 900,
                ease: Phaser.Math.Easing.Sine.InOut,
                y: "-=30",
                yoyo: true,
                repeat: -1,
            });
            this.scene.tweens.add({
                delay: 300,
                targets: this,
                duration: 266,
                ease: Phaser.Math.Easing.Sine.InOut,
                scale: 1.2,
                yoyo: true,
                onComplete: this.playWiggleTween.bind(this),
            });
            this.text.show();
            this.scene.time.delayedCall(170, function () {
                _this.showCircle();
            });
            this.scene.time.delayedCall(200, function () {
                _this.playCameraZoomTween();
            });
            this.scene.time.delayedCall(200, function () {
                if (_this.emitter) {
                    _this.emitter.explode(_this.emitterParticlesNum, _this.x, _this.y);
                }
            });
        };
        LevelCompleteFx.prototype.playWiggleTween = function () {
            this.scene.tweens.add({
                targets: this,
                duration: 600,
                ease: Phaser.Math.Easing.Sine.InOut,
                scaleX: 1.04,
                scaleY: 0.955,
                yoyo: true,
                repeat: -1,
            });
        };
        LevelCompleteFx.prototype.showCircle = function () {
            var _this = this;
            this.scene.tweens.add({
                targets: this.circleFx,
                duration: 150,
                ease: Phaser.Math.Easing.Expo.In,
                alpha: 1,
                onComplete: function () {
                    _this.scene.tweens.add({
                        delay: 150,
                        targets: _this.circleFx,
                        duration: 350,
                        ease: Phaser.Math.Easing.Cubic.Out,
                        alpha: 0,
                    });
                },
            });
            this.scene.tweens.add({
                targets: this.circleFx,
                duration: 650,
                ease: Phaser.Math.Easing.Linear.Linear,
                scale: 2.1,
            });
        };
        LevelCompleteFx.prototype.playCameraZoomTween = function () {
            var mainCamera = this.scene.cameras.main;
            this.cameraFilter = mainCamera.id;
            var camera = this.createCustomCamera(mainCamera);
            var targetZoom = camera.zoom * 1.3;
            this.scene.tweens.add({
                targets: camera,
                duration: 366,
                ease: Phaser.Math.Easing.Sine.InOut,
                zoom: targetZoom,
                scrollY: camera.scrollY - 70 * targetZoom,
                yoyo: true,
                onComplete: this.onCameraTweenZoomComplete.bind(this, camera),
            });
        };
        LevelCompleteFx.prototype.createCustomCamera = function (mainCamera) {
            var _this = this;
            var camera = this.scene.cameras.add();
            camera.setZoom(mainCamera.zoom);
            camera.setScroll(mainCamera.scrollX, mainCamera.scrollY);
            camera.ignore(this.scene.sys.displayList.list.filter(function (item) { return item !== _this; }));
            return camera;
        };
        LevelCompleteFx.prototype.onCameraTweenZoomComplete = function (camera) {
            this.scene.cameras.remove(camera);
            this.cameraFilter = 0;
        };
        return LevelCompleteFx;
    }(Phaser.GameObjects.Container));
    game.LevelCompleteFx = LevelCompleteFx;
})(game || (game = {}));
var game;
(function (game) {
    var DustCloud = /** @class */ (function (_super) {
        __extends(DustCloud, _super);
        function DustCloud(scene) {
            var _this = _super.call(this, scene, 0, 0, "gameplay", "dust_cloud0001") || this;
            _this.animationKey = "dust";
            _this.createAnimation();
            _this.play(_this.animationKey);
            _this.on("animationcomplete-" + _this.animationKey, _this.destroy, _this);
            return _this;
        }
        DustCloud.prototype.createAnimation = function () {
            this.scene.anims.create({
                key: this.animationKey,
                frames: this.scene.anims.getFrameNames("gameplay", "dust_cloud"),
                frameRate: 20,
            });
        };
        DustCloud.prototype.destroy = function (fromScene) {
            _super.prototype.destroy.call(this, fromScene);
        };
        return DustCloud;
    }(Phaser.GameObjects.Sprite));
    game.DustCloud = DustCloud;
})(game || (game = {}));
var game;
(function (game) {
    var ClearFieldFx = /** @class */ (function (_super) {
        __extends(ClearFieldFx, _super);
        function ClearFieldFx(scene) {
            var _this = _super.call(this, scene) || this;
            _this.name = "clear_field_fx";
            _this.textStyle = _this.createTextStyle();
            _this.addTitle();
            _this.addSubtitle();
            return _this;
        }
        ClearFieldFx.prototype.createTextStyle = function () {
            return {
                fontFamily: game.GameFont.SOUSES,
                fontStyle: game.FontWeight.BLACK,
                fontSize: "22px",
                color: "#FFFFD7",
                align: "center",
                shadow: {
                    blur: 0,
                    offsetY: 4,
                    color: "rgba(0,0,0,0.2)",
                    stroke: false,
                    fill: true,
                },
            };
        };
        ClearFieldFx.prototype.addTitle = function () {
            var content = this.scene.texts.clear_field;
            var style = __assign(__assign({}, this.textStyle), { fontSize: "50px" });
            this.title = this.scene.add.text(0, 0, content, style);
            this.title.setOrigin(0.5, 0.5);
            this.title.y -= 30;
            this.add(this.title);
        };
        ClearFieldFx.prototype.addSubtitle = function () {
            var content = "x2";
            var style = __assign(__assign({}, this.textStyle), { fontSize: "90px" });
            this.subtitle = this.scene.add.text(0, 0, content, style);
            this.subtitle.setOrigin(0.5, 0.5);
            this.subtitle.y += 35;
            this.add(this.subtitle);
        };
        return ClearFieldFx;
    }(Phaser.GameObjects.Container));
    game.ClearFieldFx = ClearFieldFx;
})(game || (game = {}));
var game;
(function (game) {
    var TurnCompleteFxEvent;
    (function (TurnCompleteFxEvent) {
        TurnCompleteFxEvent["CLEAR_BONUS_SHOW"] = "TurnCompleteFx_CLEAR_BONUS_SHOW";
    })(TurnCompleteFxEvent = game.TurnCompleteFxEvent || (game.TurnCompleteFxEvent = {}));
    var TurnCompleteFx = /** @class */ (function (_super) {
        __extends(TurnCompleteFx, _super);
        function TurnCompleteFx(scene) {
            var _this = _super.call(this, scene) || this;
            _this.name = "turn_complete_fx";
            _this.textStyle = _this.createTextStyle();
            _this.addCheer();
            _this.addPoints();
            _this.addClearBonus();
            return _this;
        }
        TurnCompleteFx.prototype.createTextStyle = function () {
            return {
                fontFamily: game.GameFont.SOUSES,
                fontStyle: game.FontWeight.BLACK,
                fontSize: "62px",
                color: "#C62324",
                strokeThickness: 14,
                stroke: "#EED898",
                align: "center",
                shadow: {
                    blur: 0,
                    offsetY: 4,
                    color: "rgba(0,0,0,0.2)",
                    stroke: true,
                    fill: false,
                },
            };
        };
        TurnCompleteFx.prototype.addCheer = function () {
            var content = this.scene.texts.cheers[0];
            this.cheer = this.scene.add.text(0, 0, content, this.textStyle);
            this.cheer.setOrigin(0.5, 0.5);
            this.add(this.cheer);
        };
        TurnCompleteFx.prototype.addPoints = function () {
            var content = "+0";
            var style = __assign(__assign({}, this.textStyle), { strokeThickness: 12 });
            this.points = this.scene.add.text(0, 0, content, style);
            this.points.setOrigin(0.5, 0.5);
            this.points.y = this.cheer.y + 75;
            this.add(this.points);
        };
        TurnCompleteFx.prototype.addClearBonus = function () {
            this.clearBonus = new game.ClearFieldFx(this.scene);
            this.clearBonus.y = this.points.y + 150;
            this.add(this.clearBonus);
        };
        TurnCompleteFx.prototype.reset = function () {
            this.alpha = 1;
            this.cheer.x = 0;
            this.points.x = -12; // -12 because of "+" sign
            this.clearBonus.x = 0;
            this.clearBonus.y = this.points.y + 150;
            this.clearBonus.scale = 1;
            this.clearBonus.alpha = 1;
        };
        TurnCompleteFx.prototype.updateData = function (blocksKilled, points, hasClearBonus) {
            this.updateCheerText(blocksKilled);
            this.updatePoints(points);
            this.clearBonus.visible = hasClearBonus;
        };
        TurnCompleteFx.prototype.updateCheerText = function (blocksKilled) {
            var content = this.getCompleteCheerContent(blocksKilled);
            this.cheer.setText(content);
            this.cheer.visible = blocksKilled >= 3;
        };
        TurnCompleteFx.prototype.getCompleteCheerContent = function (blocksKilled) {
            var cheers = this.scene.texts.cheers;
            var index = Phaser.Math.Clamp(blocksKilled - 3, 0, cheers.length - 1);
            return cheers[index];
        };
        TurnCompleteFx.prototype.updatePoints = function (points) {
            var content = "+" + points.toString();
            this.points.setText(content);
            this.points.visible = points > 0;
        };
        TurnCompleteFx.prototype.show = function () {
            var deltaX = 40;
            this.showText(this.cheer, -deltaX);
            this.showText(this.points, deltaX);
            if (this.clearBonus.visible) {
                this.showClearBonus();
                this.bumpPointsAndCheer(900);
                this.scene.poki.sdk.happyTime(0.33);
            }
            else {
                this.scene.time.delayedCall(1400, this.hide, null, this);
            }
        };
        TurnCompleteFx.prototype.showText = function (text, dx) {
            text.x -= dx;
            this.scene.tweens.add({
                targets: text,
                duration: 1000,
                ease: Phaser.Math.Easing.Elastic.Out,
                easeParams: [0.1, 0.4],
                x: text.x + dx,
            });
            text.alpha = 0;
            this.scene.tweens.add({
                targets: text,
                alpha: { value: 1, duration: 300, ease: Phaser.Math.Easing.Cubic.Out },
            });
        };
        TurnCompleteFx.prototype.hideText = function (text, dx) {
            this.scene.tweens.add({
                targets: text,
                duration: 200,
                ease: Phaser.Math.Easing.Cubic.Out,
                alpha: 0,
                x: {
                    value: text.x + 50 * Phaser.Math.Sign(dx),
                    ease: Phaser.Math.Easing.Cubic.In,
                },
            });
        };
        TurnCompleteFx.prototype.showClearBonus = function () {
            var _this = this;
            var initialDelay = 400;
            this.scene.time.delayedCall(initialDelay, function () {
                _this.emit(TurnCompleteFxEvent.CLEAR_BONUS_SHOW, _this);
            });
            this.clearBonus.alpha = 0;
            this.scene.tweens.add({
                targets: this.clearBonus,
                delay: initialDelay,
                duration: 200,
                ease: Phaser.Math.Easing.Cubic.Out,
                alpha: 1,
            });
            this.clearBonus.scale = 0.8;
            this.scene.tweens.add({
                targets: this.clearBonus,
                delay: initialDelay,
                duration: 400,
                ease: Phaser.Math.Easing.Back.Out,
                easeParams: [0.1, 0.4],
                scale: 1,
            });
        };
        TurnCompleteFx.prototype.bumpPointsAndCheer = function (delay) {
            var _this = this;
            this.scene.tweens.add({
                delay: delay,
                targets: this.points,
                duration: 300,
                ease: Phaser.Math.Easing.Sine.InOut,
                y: "-=35",
                scale: 1.33,
                yoyo: true,
                onStart: function () {
                    var currentPointsStr = _this.points.text.slice(1);
                    var currentPoints = parseInt(currentPointsStr);
                    _this.points.setText("+" + (currentPoints * 2));
                },
            });
            this.scene.tweens.add({
                delay: delay,
                targets: this.cheer,
                duration: 350,
                ease: Phaser.Math.Easing.Sine.InOut,
                y: "-=30",
                yoyo: true,
                onComplete: function () {
                    _this.hide();
                },
            });
        };
        TurnCompleteFx.prototype.hide = function () {
            this.hideText(this.cheer, 50);
            this.hideText(this.points, -50);
            this.hideClearBonus();
            this.scene.time.delayedCall(200, this.kill, null, this);
        };
        TurnCompleteFx.prototype.hideClearBonus = function () {
            this.scene.tweens.add({
                targets: this.clearBonus,
                duration: 200,
                ease: Phaser.Math.Easing.Cubic.Out,
                scale: 0.8,
                alpha: 0,
            });
        };
        TurnCompleteFx.prototype.preUpdate = function (time, delta) {
            if (this.visible === false) {
                return;
            }
            this.y -= delta * 0.035;
        };
        return TurnCompleteFx;
    }(Phaser.GameObjects.Container));
    game.TurnCompleteFx = TurnCompleteFx;
})(game || (game = {}));
var game;
(function (game) {
    var LightningIdleEmitter = /** @class */ (function () {
        function LightningIdleEmitter(scene, lightning, emitter) {
            this.isDestroyed = false;
            this.scene = scene;
            this.emitter = emitter;
            this.emitter.startFollow(lightning);
            this.lightning = lightning;
            this.lightning.on(game.LightningEvent.KILL_START, this.destroy, this);
            this.lightning.on(game.HideEvent.START, this.hide, this);
            this.lightning.on(Phaser.GameObjects.Events.DESTROY, this.destroy, this);
        }
        LightningIdleEmitter.prototype.hide = function () {
            this.emitter.killAll();
            this.emitter.on = false;
        };
        LightningIdleEmitter.prototype.destroy = function () {
            if (this.isDestroyed) {
                return;
            }
            this.isDestroyed = true;
            this.emitter.remove();
        };
        return LightningIdleEmitter;
    }());
    game.LightningIdleEmitter = LightningIdleEmitter;
})(game || (game = {}));
///<reference path='../items/lightning/LightningIdleEmitter.ts' />
var game;
(function (game) {
    var EasingString = Phaser.Math.EasingString;
    var GameplayEmitters = /** @class */ (function () {
        function GameplayEmitters(gameplay) {
            this.scene = gameplay;
            this.isCanvasRenderer = this.scene.game.rendererType === game.RendererType.CANVAS;
            this.allManagers = [];
            this.mainManager = this.createManager();
            this.ballEmittersManager = this.createManager("gameplay", game.GameplayDepth.BALLS_LIGHTNING_PARTICLES);
            this.belowBlocksManager = this.createManager("gameplay", game.GameplayDepth.ICE_BLOCK_PARTICLES);
            if (this.isCanvasRenderer) {
                this.createDummyEmitters();
            }
            else {
                this.createEmitters();
            }
        }
        GameplayEmitters.prototype.createManager = function (texture, depth) {
            if (texture === void 0) { texture = "gameplay"; }
            if (depth === void 0) { depth = game.GameplayDepth.PARTICLES; }
            var manager = this.scene.add.particles(texture);
            manager.setDepth(depth);
            this.allManagers.push(manager);
            return manager;
        };
        GameplayEmitters.prototype.createEmitters = function () {
            this.feathers = this.mainManager.createEmitter({
                gravityY: 100,
                frame: ["particle_feather_1", "particle_feather_2"],
                lifespan: { min: 300, max: 500 },
                radial: true,
                angle: { min: 0, max: 360 },
                rotate: { min: 0, max: 180 },
                scale: { min: 0.1, max: 1 },
                alpha: { start: 1, end: 0, ease: "Power5" },
                speed: { min: 50, max: 100 },
                on: false,
            });
            this.zappedBlock = this.mainManager.createEmitter(__assign(__assign({}, utils.ParticleUtil.getCircleEdgeEmitZone(40, 360)), { frame: "particle_lightning", speed: 200, scale: { start: 0.75, end: 0.2 }, lifespan: 300, alpha: { start: 1, end: 0 }, on: false }));
            this.collectableBallFeathers = this.mainManager.createEmitter(__assign(__assign({}, utils.ParticleUtil.getCircleEdgeEmitZone(40, 360)), { frame: ["particle_feather_1", "particle_feather_2"], scale: { start: 0.25, end: 1.33, random: true }, speed: { start: 120, end: 240, random: true }, lifespan: { start: 250, end: 500, random: true }, alpha: { start: 1, end: 0 }, on: false }));
            this.lightning = this.mainManager.createEmitter(__assign(__assign({}, utils.ParticleUtil.getCircleEdgeEmitZone(40, 360)), { frame: "particle_lightning", speed: 200, scale: { start: 0.4, end: 0.1 }, lifespan: 300, alpha: { start: 1, end: 0 }, on: false }));
            this.spinner = this.mainManager.createEmitter(__assign(__assign({}, utils.ParticleUtil.getCircleEdgeEmitZone(40, 360)), { frame: "particle_spark", speed: 200, scale: { start: 0.33, end: 0.1 }, lifespan: 300, alpha: { start: 1, end: 0 }, on: false }));
            this.pinata = this.mainManager.createEmitter({
                frame: "circle_fx",
                lifespan: 400,
                scale: { start: 0.66, end: 3.5, ease: EasingString.QuintEaseOut },
                alpha: { start: 0.85, end: 0, ease: EasingString.QuadEaseOut },
                on: false,
            });
            this.pinataConfetti = this.createPinataConfettiEmitter();
            this.newPinataItem = this.mainManager.createEmitter({
                emitZone: {
                    source: new Phaser.Geom.Circle(0, 0, game.GameGrid.CELL_SIZE / 2),
                    type: "random",
                },
                speed: 66,
                frame: "particle_star_01",
                lifespan: { min: 500, max: 900 },
                scale: { start: 1, end: 0.5 },
                alpha: { start: 1, end: 0 },
                on: false,
            });
            this.blockKill = this.belowBlocksManager.createEmitter({
                frame: "circle_fx_2",
                lifespan: 200,
                scale: { start: 0.5, end: 1.5, ease: Phaser.Math.EasingString.Cubic },
                alpha: { start: 0.5, end: 0 },
                on: false,
            });
            this.blockKillParticles = this.belowBlocksManager.createEmitter(__assign(__assign({}, utils.ParticleUtil.getCircleEdgeEmitZone(23, 8, false)), { frame: "particle_circle", speed: 240, lifespan: 300, scale: { start: 0.7, end: 0.15, ease: Phaser.Math.EasingString.Cubic }, alpha: { start: 0.5, end: 0 }, on: false }));
        };
        GameplayEmitters.prototype.createPinataConfettiEmitter = function () {
            var onUpdateScaleY = function (particle, key, t, value) {
                if (isNaN(particle.scaleY)) {
                    value = 1;
                    particle.deltaScale = Phaser.Math.RND.sign() * 0.12;
                }
                value += particle.deltaScale;
                if (value < -1) {
                    value = -1;
                    particle.deltaScale *= -1;
                }
                else if (value > 1) {
                    value = 1;
                    particle.deltaScale *= -1;
                }
                return value;
            };
            var emitZone = {
                source: new Phaser.Geom.Circle(0, 0, game.GameGrid.CELL_SIZE * 0.5),
                type: "random",
            };
            return this.mainManager.createEmitter({
                frame: ["red", "blue", "yellow", "green"].map(function (color) { return "confetti_" + color; }),
                lifespan: { min: 600, max: 900 },
                speedX: { min: -350, max: 350 },
                speedY: { min: -600, max: 100 },
                rotate: { min: 0, max: 360 },
                alpha: { start: 1, end: 0, ease: EasingString.ExpoEaseIn },
                gravityY: 1000,
                scaleY: { onUpdate: onUpdateScaleY },
                emitZone: emitZone,
                on: false,
            });
        };
        GameplayEmitters.prototype.createDummyEmitters = function () {
            this.feathers = this.createDummyEmitter();
            this.zappedBlock = this.createDummyEmitter();
            this.collectableBallFeathers = this.createDummyEmitter();
            this.lightning = this.createDummyEmitter();
            this.spinner = this.createDummyEmitter();
            this.pinata = this.createDummyEmitter();
            this.newPinataItem = this.createDummyEmitter();
            this.pinata = this.createDummyEmitter();
            this.pinataConfetti = this.createDummyEmitter();
            this.blockKill = this.createDummyEmitter();
            this.blockKillParticles = this.createDummyEmitter();
        };
        GameplayEmitters.prototype.createLightningIdleEmitter = function () {
            if (this.isCanvasRenderer) {
                return this.createDummyEmitter();
            }
            return this.mainManager.createEmitter(__assign(__assign({}, utils.ParticleUtil.getCircleEdgeEmitZone(26)), { frame: "particle_lightning", speed: 55, scale: { start: 0.3, end: 0.1 }, lifespan: 550, alpha: { start: 1, end: 0 }, frequency: 166, quantity: 1, on: true }));
        };
        GameplayEmitters.prototype.createSpinnerIdleEmitter = function (spinner) {
            if (this.isCanvasRenderer) {
                return this.createDummyEmitter();
            }
            return this.mainManager.createEmitter(__assign(__assign({}, utils.ParticleUtil.getCircleEdgeEmitZone(26)), { frame: "particle_spark", speed: 55, scale: { start: 0.24, end: 0.1 }, lifespan: 550, alpha: { start: 1, end: 0 }, frequency: 166, quantity: 1, on: true }));
        };
        GameplayEmitters.prototype.createBallChargedEmitter = function (ball) {
            if (this.isCanvasRenderer) {
                return this.createDummyEmitter();
            }
            return this.ballEmittersManager.createEmitter({
                frame: "particle_circle",
                speed: 300,
                emitZone: { source: new Phaser.Geom.Circle(0, 0, game.Ball.RADIUS * 0.9), type: "random" },
                scale: 0.8,
                alpha: { start: 1, end: 0 },
                lifespan: { min: 150, max: 300 },
                frequency: 33,
                quantity: 1,
                follow: ball,
                on: false,
            });
        };
        GameplayEmitters.prototype.createIceBlockEmitter = function (iceBlock) {
            if (this.isCanvasRenderer) {
                return this.createDummyEmitter();
            }
            var frames = _.range(1, 4).map(function (num) { return "particle_snowflake_0" + num; });
            return this.belowBlocksManager.createEmitter({
                frame: frames,
                speedX: {
                    onEmit: function (particle) {
                        return Phaser.Math.Sign(iceBlock.matterBody.velocity.x) * -10;
                    },
                },
                speedY: { min: -10, max: 10 },
                rotate: { start: 0, end: 90 * Phaser.Math.RND.sign() },
                emitZone: { source: new Phaser.Geom.Circle(0, 0, 40), type: "random" },
                scale: { start: 0.75, end: 0.3, ease: Phaser.Math.EasingString.Cubic },
                lifespan: { min: 1400, max: 1800 },
                alpha: { start: 1, end: 0 },
                frequency: 100,
                quantity: 1,
                follow: iceBlock,
            });
        };
        GameplayEmitters.prototype.createCollectableBallEmitter = function (ball) {
            if (this.isCanvasRenderer) {
                return this.createDummyEmitter();
            }
            return this.belowBlocksManager.createEmitter({
                emitZone: {
                    source: new Phaser.Geom.Circle(0, 0, game.CollectableBall.RADIUS),
                    type: "random",
                },
                frame: "particle_star_01",
                lifespan: 1000,
                scale: { start: 1.5, end: 0.1 },
                alpha: { start: 0, end: 1, ease: EasingString.ExpoEaseOut },
                rotate: {
                    onEmit: function () {
                        return Phaser.Math.RND.between(0, 360);
                    },
                    onUpdate: function (particle, key, t, value) {
                        return value += 1;
                    },
                },
                follow: ball,
                frequency: 600,
                on: false,
            });
        };
        GameplayEmitters.prototype.setTimescale = function (timescale) {
            this.allManagers.forEach(function (manager) { return (manager.timeScale = timescale); });
        };
        GameplayEmitters.prototype.createDummyEmitter = function () {
            return this.mainManager.createEmitter({
                maxParticles: 0,
                on: false,
                active: false,
                visible: false,
            });
        };
        GameplayEmitters.prototype.destroy = function () {
        };
        return GameplayEmitters;
    }());
    game.GameplayEmitters = GameplayEmitters;
})(game || (game = {}));
var game;
(function (game) {
    var GameplayPhysics = /** @class */ (function () {
        function GameplayPhysics(scene) {
            this.scene = scene;
            this.matter = this.scene.matter;
            this.world = this.scene.matter.world;
            this.world.drawDebug = false;
            this.world.autoUpdate = false;
            this.world.resetCollisionIDs();
            this.initCollisionGroups();
            this.initCollisionCategories();
            this.initCollisionPairs();
            this.addWorldEventListeners();
        }
        GameplayPhysics.prototype.initCollisionGroups = function () {
            this.collisionGroups = {
                balls: this.world.nextGroup(true),
                collectableBalls: this.world.nextGroup(true),
            };
        };
        GameplayPhysics.prototype.initCollisionCategories = function () {
            this.collisionCategories = {
                ceiling: this.world.nextCategory(),
                floor: this.world.nextCategory(),
                walls: this.world.nextCategory(),
                balls: this.world.nextCategory(),
                boosterBomb: this.world.nextCategory(),
                boosterCracker: this.world.nextCategory(),
            };
        };
        GameplayPhysics.prototype.initCollisionPairs = function () {
            this.collisionPairs = [
                {
                    tagA: game.CollisionTag.BALL,
                    tagB: game.CollisionTag.SPINNER,
                    callback: this.scene.onBallSpinnerTouched,
                    callbackContext: this.scene,
                },
                {
                    tagA: game.CollisionTag.BALL,
                    tagB: game.CollisionTag.LIGHTNING,
                    callback: this.scene.onBallLightningTouched,
                    callbackContext: this.scene,
                },
                {
                    tagA: game.CollisionTag.BALL,
                    tagB: game.CollisionTag.FLOOR,
                    callback: this.scene.onBallFloorCollide,
                    callbackContext: this.scene,
                },
                {
                    tagA: game.CollisionTag.BALL,
                    tagB: game.CollisionTag.WALL,
                    callback: this.scene.onBallWallsCollide,
                    callbackContext: this.scene,
                },
                {
                    tagA: game.CollisionTag.BALL,
                    tagB: game.CollisionTag.BASIC_BLOCK,
                    callback: this.scene.onBallBlocksCollide,
                    callbackContext: this.scene,
                },
                {
                    tagA: game.CollisionTag.COLLECTABLE_BALL,
                    tagB: game.CollisionTag.BALL,
                    callback: this.scene.onCollectableBallHit,
                    callbackContext: this.scene,
                },
                {
                    tagA: game.CollisionTag.COLLECTABLE_BALL,
                    tagB: game.CollisionTag.FLOOR,
                    callback: this.scene.onCollectableBallLand,
                    callbackContext: this.scene,
                },
            ];
        };
        GameplayPhysics.prototype.addWorldEventListeners = function () {
            this.world.on("afterupdate", this.onWorldAfterUpdate, this);
            this.world.on("beforeadd", this.onBeforeBodyAdd, this);
            this.world.on("beforeremove", this.onBeforeBodyRemove, this);
            this.world.on("collisionstart", this.onCollisionStart, this);
        };
        GameplayPhysics.prototype.onWorldAfterUpdate = function () {
            var _this = this;
            this.scene.balls.forEach(function (ball) { return ball.maintainConstantFlyingSpeed(_this.scene.game.loop.delta); });
        };
        GameplayPhysics.prototype.onBeforeBodyAdd = function (event) {
            this.scene.worldCopy.addBody(event.object);
        };
        GameplayPhysics.prototype.onBeforeBodyRemove = function (event) {
            this.scene.worldCopy.removeBody(event.object);
        };
        GameplayPhysics.prototype.onCollisionStart = function (event) {
            var _this = this;
            event.pairs.forEach(function (eventPair) {
                var bodyA = eventPair.bodyA;
                var bodyB = eventPair.bodyB;
                var tagA = bodyA.plugin[game.COLLISION_TAG];
                var tagB = bodyB.plugin[game.COLLISION_TAG];
                _this.collisionPairs.some(function (pair) {
                    if (pair.tagA == tagA && pair.tagB === tagB) {
                        _this.executeCollisionCallback(pair, bodyA, bodyB, eventPair, event);
                    }
                    else if (pair.tagB === tagA && pair.tagA === tagB) {
                        _this.executeCollisionCallback(pair, bodyB, bodyA, eventPair, event);
                    }
                });
            });
        };
        GameplayPhysics.prototype.executeCollisionCallback = function (pair, bodyA, bodyB, eventPair, event) {
            var _a, _b;
            var objA = (_a = bodyA["gameObject"]) !== null && _a !== void 0 ? _a : bodyA;
            var objB = (_b = bodyB["gameObject"]) !== null && _b !== void 0 ? _b : bodyB;
            return pair.callback.call(pair.callbackContext, objA, objB, eventPair, event);
        };
        GameplayPhysics.prototype.toggleDebug = function () {
            if (this.matter.config.debug === false) {
                return;
            }
            this.world.drawDebug = !this.world.drawDebug;
            if (this.world.drawDebug === false) {
                this.world.debugGraphic.clear();
            }
        };
        GameplayPhysics.prototype.update = function (delta) {
            for (var i = 0; i < this.scene.fastForward.timeScale; i++) {
                this.world.step(delta);
            }
        };
        return GameplayPhysics;
    }());
    game.GameplayPhysics = GameplayPhysics;
})(game || (game = {}));
var game;
(function (game) {
    var AnimationsPool = utils.AnimationsPool;
    var GameplayAnimationPools = /** @class */ (function () {
        function GameplayAnimationPools(scene) {
            this.scene = scene;
            this.lightnings = this.createLightningAnimations();
            this.spinners = this.createSpinnerAnimations();
            this.explosions = this.createExplosionAnimations();
        }
        GameplayAnimationPools.prototype.createLightningAnimations = function () {
            return new AnimationsPool(this.scene, {
                name: "lightnings",
                initialNum: 10,
                atlas: "gameplay",
                prefix: "lightning/lightning",
                animationConfig: {
                    repeat: -1,
                    repeatDelay: 2000,
                    frameRate: 10,
                },
            });
        };
        GameplayAnimationPools.prototype.createSpinnerAnimations = function () {
            return new AnimationsPool(this.scene, {
                name: "spinners",
                initialNum: 10,
                atlas: "gameplay",
                prefix: "spinner/spinner",
                animationConfig: {
                    repeat: -1,
                    repeatDelay: 2000,
                    frameRate: 10,
                },
            });
        };
        GameplayAnimationPools.prototype.createExplosionAnimations = function () {
            return new AnimationsPool(this.scene, {
                name: "explosions",
                initialNum: 10,
                atlas: "gameplay",
                prefix: "BOOM",
                animationConfig: {
                    frameRate: 30,
                },
            });
        };
        GameplayAnimationPools.prototype.recycle = function () {
            this.spinners.recycleAll();
            this.lightnings.recycleAll();
            this.explosions.recycleAll();
        };
        return GameplayAnimationPools;
    }());
    game.GameplayAnimationPools = GameplayAnimationPools;
})(game || (game = {}));
var game;
(function (game) {
    var GameplayPools = /** @class */ (function () {
        function GameplayPools(scene) {
            this.scene = scene;
            this.levelConfig = this.scene.levelConfig;
            this.createIdleBalls();
            this.createIdleBallsShadows();
            this.createBlockWhiteCopies();
            this.createBlockRedCopies();
            this.createBlockHealthCounters();
            this.createBlockDamageFx();
        }
        GameplayPools.prototype.createIdleBalls = function () {
            var _this = this;
            var initial = this.levelConfig.balls;
            var future = this.levelConfig.items.filter(function (item) { return item.type === game.ItemType.COLLECTABLE_BALL; }).length;
            var total = initial + future;
            this.idleBalls = _.times(total, function () {
                return _this.createNewIdleBall();
            });
        };
        GameplayPools.prototype.createNewIdleBall = function () {
            var idleBall = new game.IdleBall(this.scene);
            idleBall.setDepth(game.GameplayDepth.IDLE_BALLS);
            idleBall.visible = false;
            idleBall.active = false;
            this.scene.add.existing(idleBall);
            return idleBall;
        };
        GameplayPools.prototype.createIdleBallsShadows = function () {
            var _this = this;
            this.idleBallsShadows = _.times(this.idleBalls.length, function (index) {
                var idleBall = _this.idleBalls[index];
                return _this.createNewIdleBallShadow(idleBall);
            });
        };
        GameplayPools.prototype.createNewIdleBallShadow = function (idleBall) {
            var shadow = new game.JumpingBallShadow(this.scene, idleBall);
            shadow.setDepth(game.GameplayDepth.IDLE_BALLS_SHADOWS);
            shadow.visible = false;
            shadow.active = false;
            this.scene.add.existing(shadow);
            return shadow;
        };
        GameplayPools.prototype.createBlockWhiteCopies = function () {
            this.blockWhiteCopies = this.scene.add.group({
                name: "block_white_copies",
                classType: game.BlockWhiteCopy,
                createCallback: function (item) {
                    item.setDepth(game.GameplayDepth.BLOCK_WHITE_COPIES);
                    item.visible = false;
                    item.active = false;
                },
            });
            var num = game.GameGrid.COLUMNS * (game.GameGrid.ROWS - 2);
            var preciseNum = Math.round(num * 0.66);
            for (var i = 0; i < preciseNum; i++) {
                this.blockWhiteCopies.create();
            }
        };
        GameplayPools.prototype.createBlockRedCopies = function () {
            this.blockRedCopies = this.scene.add.group({
                name: "block_red_copies",
                classType: game.BlockRedCopy,
                createCallback: function (item) {
                    item.setDepth(game.GameplayDepth.BLOCK_RED_COPIES);
                    item.kill();
                },
            });
            var total = game.GameGrid.COLUMNS;
            for (var i = 0; i < total; i++) {
                this.blockRedCopies.create();
            }
        };
        GameplayPools.prototype.createBlockHealthCounters = function () {
            this.blockHealthCounters = this.scene.add.group({
                name: "block_health_counters",
                classType: game.BlockHealthCounter,
                createCallback: function (item) {
                    item.setDepth(game.GameplayDepth.BLOCK_HEALTH_COUNTER);
                    item.visible = false;
                    item.active = false;
                },
            });
            var num = game.GameGrid.COLUMNS * (game.GameGrid.ROWS - 2);
            var preciseNum = Math.round(num * 0.66);
            for (var i = 0; i < preciseNum; i++) {
                this.blockHealthCounters.create();
            }
        };
        GameplayPools.prototype.createBlockDamageFx = function () {
            this.blockDamageFXs = this.scene.add.group({
                name: "block_damage_fxs",
                classType: game.BlockDamageFx,
                createCallback: function (item) {
                    item.setDepth(game.GameplayDepth.BLOCK_DAMAGE_FX);
                    item.visible = false;
                    item.active = false;
                },
            });
            var initialBalls = this.scene.balls.length;
            var futureBalls = this.levelConfig.items.filter(function (item) { return item.type === game.ItemType.COLLECTABLE_BALL; }).length;
            var total = (initialBalls + futureBalls) * 2;
            for (var i = 0; i < total; i++) {
                this.blockDamageFXs.create();
            }
        };
        return GameplayPools;
    }());
    game.GameplayPools = GameplayPools;
})(game || (game = {}));
var game;
(function (game) {
    var GameplayItemsFactory = /** @class */ (function () {
        function GameplayItemsFactory(scene) {
            this.scene = scene;
        }
        GameplayItemsFactory.prototype.create = function (options) {
            _.defaults(options, {
                texture: "gameplay",
                frame: this.getDefaultItemFrame(options.itemType),
            });
            var item = this.createItemByType(options);
            this.setupItem(item, options);
            this.scene.add.existing(item);
            this.scene.addItem(item);
            this.alignItemToGrid(item, options.column, options.row);
            return item;
        };
        GameplayItemsFactory.prototype.getDefaultItemFrame = function (itemType) {
            var frame = game.ItemTypeUtil.getFrameName(itemType);
            if (!frame) {
                console.warn("Can't find frame for this item type!", itemType);
            }
            return frame;
        };
        GameplayItemsFactory.prototype.alignItemToGrid = function (item, column, row) {
            var cell = this.scene.grid.getCellAt(row, column);
            var align = this.getAlignPosition(item);
            Phaser.Display.Align.In.QuickSet(item, cell, align);
        };
        GameplayItemsFactory.prototype.getAlignPosition = function (item) {
            var itemType = item.itemType;
            var frame = item.frame.name;
            if (itemType === game.ItemType.TRIANGLE) {
                return this.getTriangleAlign(frame);
            }
            if (itemType === game.ItemType.SHATTER_BLOCK_PIECE) {
                return this.getShatterPieceAlign(frame);
            }
            return Phaser.Display.Align.CENTER;
        };
        GameplayItemsFactory.prototype.getTriangleAlign = function (frame) {
            var _a;
            var Align = Phaser.Display.Align;
            var map = (_a = {},
                _a[game.TriangleBlock.BOTTOM_LEFT_FRAME] = Align.BOTTOM_LEFT,
                _a[game.TriangleBlock.BOTTOM_RIGHT_FRAME] = Align.BOTTOM_RIGHT,
                _a[game.TriangleBlock.TOP_LEFT_FRAME] = Align.TOP_LEFT,
                _a[game.TriangleBlock.TOP_RIGHT_FRAME] = Align.TOP_RIGHT,
                _a);
            return map[frame] || Align.CENTER;
        };
        GameplayItemsFactory.prototype.getShatterPieceAlign = function (frame) {
            var _a;
            var Align = Phaser.Display.Align;
            var map = (_a = {},
                _a[game.ShatterBlockPiece.UP_FRAME] = Align.LEFT_TOP,
                _a[game.ShatterBlockPiece.RIGHT_FRAME] = Align.RIGHT_CENTER,
                _a[game.ShatterBlockPiece.DOWN_FRAME] = Align.BOTTOM_CENTER,
                _a[game.ShatterBlockPiece.LEFT_FRAME] = Align.LEFT_CENTER,
                _a);
            return map[frame] || Align.CENTER;
        };
        GameplayItemsFactory.prototype.createItemByType = function (options) {
            switch (options.itemType) {
                case game.ItemType.BASIC_BLOCK:
                case game.ItemType.TRIANGLE:
                case game.ItemType.DYNAMITE_BLOCK:
                case game.ItemType.ICE_BLOCK:
                case game.ItemType.ICE_RHOMB:
                case game.ItemType.ICE_OCTAGON:
                case game.ItemType.PINATA_BLOCK:
                case game.ItemType.SHATTER_BLOCK:
                case game.ItemType.SHATTER_BLOCK_PIECE:
                    return this.createBlock(options);
                case game.ItemType.COLLECTABLE_BALL:
                    return new game.CollectableBall(this.scene.matter.world, this.scene.getWorldBounds());
                case game.ItemType.LIGHTNING:
                    return new game.Lightning(this.scene.matter.world, this.scene.animsPools.lightnings.getInactive());
                case game.ItemType.SPINNER:
                    return new game.Spinner(this.scene.matter.world, this.scene.animsPools.spinners.getInactive());
                default:
                    console.warn("Unknown item type!", options);
                    return null;
            }
        };
        GameplayItemsFactory.prototype.createBlock = function (options) {
            var defaultBodyConfig = {
                isStatic: true,
                restitution: 1,
                friction: 0,
                frictionAir: 0,
                frictionStatic: 0,
            };
            _.defaults(options, {
                health: Phaser.Math.RND.between(1, 10),
                bodyConfig: __assign({}, defaultBodyConfig),
            });
            var peShape = this.scene.physicsShapes[options.frame];
            if (peShape) {
                var shape = this.convertToPhaserTracer(peShape);
                var spriteOffset = this.getSpriteOffset(shape, options.texture, options.frame);
                options.bodyConfig.shape = __assign({}, shape);
                options.bodyConfig.render = {
                    visible: true,
                    opacity: 1,
                    sprite: {
                        xOffset: spriteOffset.x,
                        yOffset: spriteOffset.y,
                    },
                };
            }
            switch (options.itemType) {
                case game.ItemType.BASIC_BLOCK:
                    return new game.BasicBlock(this.scene.matter.world, options.texture, options.frame, options.health, options.bodyConfig);
                case game.ItemType.TRIANGLE:
                    return new game.TriangleBlock(this.scene.matter.world, options.texture, options.frame, options.health, options.bodyConfig);
                case game.ItemType.SHATTER_BLOCK:
                    return new game.ShatterBlock(this.scene.matter.world, options.texture, options.frame, options.health, options.bodyConfig);
                case game.ItemType.SHATTER_BLOCK_PIECE:
                    return new game.ShatterBlockPiece(this.scene.matter.world, options.texture, options.frame, options.health, options.bodyConfig);
                case game.ItemType.ICE_BLOCK:
                    return new game.IceBlock(this.scene.matter.world, options.texture, options.frame, options.health, options.bodyConfig);
                case game.ItemType.ICE_RHOMB:
                case game.ItemType.ICE_OCTAGON:
                    return new game.RotatingIceBlock(this.scene.matter.world, options.itemType, options.texture, options.frame, options.health, options.bodyConfig);
                case game.ItemType.DYNAMITE_BLOCK:
                    return new game.DynamiteBlock(this.scene.matter.world, options.texture, options.frame, options.health, options.bodyConfig);
                case game.ItemType.PINATA_BLOCK:
                    return new game.PinataBlock(this.scene.matter.world, options.texture, options.frame, options.health, options.bodyConfig);
                default:
                    console.warn("Unknown block type!", options);
                    return null;
            }
        };
        GameplayItemsFactory.prototype.convertToPhaserTracer = function (item) {
            var vertices = item.fixtures.flatMap(function (fixture) { return fixture.vertices; });
            return {
                type: "fromPhysicsTracer",
                label: item.label,
                vertices: vertices,
            };
        };
        GameplayItemsFactory.prototype.getSpriteOffset = function (shape, texture, frame) {
            var vertices = shape.vertices.flat();
            var left = _.minBy(vertices, "x").x;
            var top = _.minBy(vertices, "y").y;
            var frameData = this.scene.textures.getFrame(texture, frame);
            return { x: left / frameData.width * frameData.pivotX, y: top / frameData.height * frameData.pivotY };
        };
        GameplayItemsFactory.prototype.setupItem = function (item, options) {
            switch (options.itemType) {
                case game.ItemType.BASIC_BLOCK:
                case game.ItemType.TRIANGLE:
                case game.ItemType.SHATTER_BLOCK_PIECE:
                    this.setupBlock(item, options);
                    break;
                case game.ItemType.ICE_BLOCK:
                case game.ItemType.ICE_RHOMB:
                case game.ItemType.ICE_OCTAGON:
                    this.setupBlock(item, options);
                    this.setupIceBlock(item, options);
                    break;
                case game.ItemType.PINATA_BLOCK:
                    this.setupBlock(item, options);
                    this.setupPinataBlock(item, options);
                    break;
                case game.ItemType.DYNAMITE_BLOCK:
                    this.setupBlock(item, options);
                    this.setupDynamiteBlock(item, options);
                    break;
                case game.ItemType.SHATTER_BLOCK:
                    this.setupBlock(item, options);
                    this.setupShatterBlock(item);
                    return;
                case game.ItemType.SPINNER:
                    this.setupSpinner(item, options);
                    break;
                case game.ItemType.LIGHTNING:
                    this.setupLightning(item, options);
                    break;
                case game.ItemType.COLLECTABLE_BALL:
                    this.setupCollectableBall(item, options);
                    break;
                default:
                    break;
            }
            return item;
        };
        GameplayItemsFactory.prototype.setupBlock = function (block, options) {
            block.on(game.BasicBlockEvent.ZAP, this.scene.onBlockZap, this.scene);
            block.on(game.StompingEvent.START, this.scene.onBlockStartStomping, this.scene);
            block.on(game.StompingEvent.STOP, this.scene.onBlockStopStomping, this.scene);
            block.on(game.HealthEvent.DAMAGE, this.scene.onBlockDamage, this.scene);
            block.on(game.HealthEvent.KILL, this.scene.onBlockKill, this.scene);
            block.setDepth(game.GameplayDepth.ITEMS);
            // block.ignoreCollisionCategory(this.scene._physics.collisionCategories.balls)
            this.scene.addBlockWhiteCopy(block);
            this.scene.addBlockHealthCounter(block);
            this.scene.addBlockFace(block);
            return block;
        };
        GameplayItemsFactory.prototype.setupIceBlock = function (iceBlock, options) {
            // iceBlock.startMoving()
            iceBlock.once(Phaser.GameObjects.Events.DESTROY, this.scene.fastForward.removeItem, this.scene.fastForward);
            this.scene.addIceBlockEmitter(iceBlock);
            this.scene.fastForward.addItem(iceBlock);
        };
        GameplayItemsFactory.prototype.setupPinataBlock = function (pinata, options) {
            pinata.on(game.PinataEvent.DESTROY, this.scene.onPinataDestroyed, this.scene);
        };
        GameplayItemsFactory.prototype.setupDynamiteBlock = function (dynamite, options) {
            dynamite.on(game.DynamiteBlockEvent.EXPLODE, this.scene.onDynamiteBlockExplode, this.scene);
        };
        GameplayItemsFactory.prototype.setupShatterBlock = function (shatterBlock) {
            shatterBlock.on(game.ShatterBlockEvent.SHATTER, this.scene.onShatterBlockShatter, this.scene);
        };
        GameplayItemsFactory.prototype.setupSpinner = function (spinner, options) {
            spinner.setDepth(game.GameplayDepth.SPINNERS);
            spinner.once(Phaser.GameObjects.Events.DESTROY, this.scene.fastForward.removeItem, this.scene.fastForward);
            spinner.once(Phaser.GameObjects.Events.DESTROY, this.recycleSpinnerAnimation, this);
            this.scene.addSpinnerIdleEmitter(spinner);
            this.scene.fastForward.addItem(spinner);
        };
        GameplayItemsFactory.prototype.recycleSpinnerAnimation = function (spinner) {
            this.scene.animsPools.spinners.recycleActive(spinner.animation);
        };
        GameplayItemsFactory.prototype.setupLightning = function (lightning, options) {
            lightning.setDepth(game.GameplayDepth.LIGHTNINGS);
            lightning.once(Phaser.GameObjects.Events.DESTROY, this.scene.onLightningDestroy, this.scene);
            this.scene.addLightningIdleEmitter(lightning);
        };
        GameplayItemsFactory.prototype.setupCollectableBall = function (ball, options) {
            // so they won't collide with each other during the fall
            ball.setCollisionGroup(this.scene._physics.collisionGroups.collectableBalls);
            this.scene.addCollectableBallEmitter(ball);
        };
        GameplayItemsFactory.prototype.postCreationCallback = function (item) {
            var itemType = item.itemType;
            if (typeof itemType === "undefined") {
                console.warn("Set ITEM_TYPE for this item!", item);
                return;
            }
            switch (itemType) {
                case game.ItemType.ICE_BLOCK:
                case game.ItemType.ICE_RHOMB:
                case game.ItemType.ICE_OCTAGON:
                    ;
                    item.startMoving();
                    break;
                case game.ItemType.LIGHTNING:
                    ;
                    item.startIdleTweensAndAnimation();
                    break;
                case game.ItemType.SPINNER:
                    ;
                    item.startIdleTweensAndAnimation();
                    break;
                case game.ItemType.COLLECTABLE_BALL:
                    ;
                    item.startIdleTweens();
                    break;
                default:
                    break;
            }
        };
        return GameplayItemsFactory;
    }());
    game.GameplayItemsFactory = GameplayItemsFactory;
})(game || (game = {}));
var game;
(function (game) {
    var GameplayCamera = /** @class */ (function () {
        function GameplayCamera(scene) {
            this.scene = scene;
            this.camera = this.scene.cameras.main;
        }
        GameplayCamera.prototype.resize = function () {
            var scale = this.calculateScale();
            var cameraWidth = this.scene.getFieldWidth();
            var cameraHeight = this.scene.getFieldHeight();
            this.camera.setViewport(0, 0, game.Config.GAME_WIDTH, game.Config.GAME_HEIGHT);
            this.camera.setZoom(scale);
            this.camera.scrollX = -(game.Config.GAME_WIDTH - cameraWidth) / 2;
            this.camera.scrollY = -(game.Config.GAME_HEIGHT - cameraHeight) / 2;
        };
        GameplayCamera.prototype.calculateScale = function () {
            var maxWidth = game.Config.GAME_WIDTH * 0.9;
            var maxHeight = this.getGameplayMaxHeight();
            var scaleX = maxWidth / this.scene.getFieldWidth();
            var scaleY = maxHeight / this.scene.getFieldHeight();
            return Math.min(scaleX, scaleY);
        };
        GameplayCamera.prototype.getGameplayMaxHeight = function () {
            var top = this.scene.gui.topPanel.getDisplayHeight();
            var bottom = game.Config.GAME_HEIGHT - top;
            var height = bottom - top;
            return height * 0.96;
        };
        Object.defineProperty(GameplayCamera.prototype, "zoom", {
            get: function () {
                return this.camera.zoom;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(GameplayCamera.prototype, "x", {
            get: function () {
                return this.camera.x;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(GameplayCamera.prototype, "y", {
            get: function () {
                return this.camera.y;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(GameplayCamera.prototype, "height", {
            get: function () {
                return this.camera.height;
            },
            enumerable: false,
            configurable: true
        });
        GameplayCamera.prototype.getPadding = function () {
            var x = ((game.Config.GAME_WIDTH - this.scene.getFieldWidth() * this.zoom) / 2);
            var y = ((game.Config.GAME_HEIGHT - this.scene.getFieldHeight() * this.zoom) / 2);
            return { x: x, y: y };
        };
        return GameplayCamera;
    }());
    game.GameplayCamera = GameplayCamera;
})(game || (game = {}));
var game;
(function (game) {
    var MatterLib = Phaser.Physics.Matter.Matter;
    var Body = MatterLib.Body;
    var Bodies = MatterLib.Bodies;
    var Resolver = MatterLib.Resolver;
    var Plugin = MatterLib.Plugin;
    var Events = MatterLib.Events;
    var Sleeping = MatterLib.Sleeping;
    var GameplayWorldCopy = /** @class */ (function () {
        function GameplayWorldCopy(scene) {
            this.ballSpeed = game.Ball.THROW_FORCE / 5;
            this.scene = scene;
            this.enableCollisionEventsPlugin();
            this.setupResolver();
            this.addWorld();
            this.removeUpdateEventListeners();
            this.addBall();
            this.bodies = [];
            this.ballCollisionPoints = [];
        }
        GameplayWorldCopy.prototype.enableCollisionEventsPlugin = function () {
            var collisionEventsPlugin = MatterLib.uses[0];
            Plugin.register(collisionEventsPlugin);
            Plugin.use(MatterLib, collisionEventsPlugin);
        };
        GameplayWorldCopy.prototype.setupResolver = function () {
            Resolver._restingThresh = 0;
            Resolver._restingThreshTangent = 0;
        };
        GameplayWorldCopy.prototype.addWorld = function () {
            var config = __assign(__assign({}, game.GameplayRoot.getPhysicsConfig().matter), { positionIterations: 2, velocityIterations: 2 });
            this.world = new Phaser.Physics.Matter.World(this.scene, config);
            this.world.autoUpdate = false;
            this.world.drawDebug = false;
            this.scene.events.on(Phaser.Scenes.Events.UPDATE, this.world.update, this.world);
            this.scene.events.on(Phaser.Scenes.Events.POST_UPDATE, this.world["postUpdate"], this.world);
        };
        GameplayWorldCopy.prototype.removeUpdateEventListeners = function () {
            // we don't need this events so we turn them off
            Events.off(this.world.engine, "beforeUpdate");
            Events.off(this.world.engine, "afterUpdate");
            Events.off(this.world.engine, "collisionActive");
            Events.off(this.world.engine, "collisionEnd");
        };
        GameplayWorldCopy.prototype.addBall = function () {
            this.ball = Bodies.circle(0, 0, game.Ball.RADIUS, game.Ball.BODY_CONFIG);
            this.ball.onCollideCallback = this.onBallCollide.bind(this);
            this.world.add(this.ball);
            Body.setInertia(this.ball, Infinity); // the same as setFixedRotation
            this.ballSpeed = game.Ball.THROW_FORCE * 0.1;
            this.ballVelocity = { x: 0, y: 0 };
        };
        GameplayWorldCopy.prototype.onBallCollide = function (pair) {
            if (this.ballCollidedNum++ > 0) {
                return;
            }
            this.ballCollisionPoints.push({ x: this.ball.position.x, y: this.ball.position.y });
            var labelA = pair.bodyA.label;
            var labelB = pair.bodyB.label;
            if (labelA === game.CollisionTag.FLOOR || labelB === game.CollisionTag.FLOOR) {
                this.endSimulation = true;
                return;
            }
            if (labelA !== game.CollisionTag.WALL && labelB !== game.CollisionTag.WALL) {
                this.endSimulation = true;
                return;
            }
        };
        GameplayWorldCopy.prototype.addBody = function (body) {
            if (body.isStatic === false || body.isSensor) {
                return;
            }
            var newBody = Bodies.fromVertices(body.position.x, body.position.y, body.vertices, {
                restitution: body.restitution,
                isStatic: body.isStatic,
                friction: body.friction,
                frictionAir: body.frictionAir,
                frictionStatic: body.frictionStatic,
                circleRadius: body.circleRadius,
                scale: body.scale,
                chamfer: body.chamfer,
                label: body.label,
            });
            newBody.originalBody = body;
            this.world.add(newBody);
            this.bodies.push(newBody);
        };
        GameplayWorldCopy.prototype.removeBody = function (originalBody) {
            var index = this.bodies.findIndex(function (body) { return body.originalBody === originalBody; });
            if (index > -1) {
                this.world.remove(this.bodies[index]);
                this.bodies[index].originalBody = null;
                this.bodies.splice(index, 1);
            }
        };
        GameplayWorldCopy.prototype.getTrajectoryPoints = function (startX, startY, rotation, bounces) {
            Body.setPosition(this.ball, { x: startX, y: startY });
            Body.setVelocity(this.ball, { x: Math.cos(rotation) * this.ballSpeed, y: Math.sin(rotation) * this.ballSpeed });
            this.endSimulation = false;
            this.ballCollisionPoints.length = 0;
            this.sync();
            this.wakeBodies();
            var safeCounter = 10000;
            while (--safeCounter > 0) {
                this.ballCollidedNum = 0; // don't allow ball collide more than one time during the step
                this.world.step();
                // this.maintainBallVelocity()
                if (this.endSimulation) {
                    break;
                }
                if (this.ballCollisionPoints.length >= bounces) {
                    break;
                }
            }
            return this.ballCollisionPoints;
        };
        GameplayWorldCopy.prototype.sync = function () {
            var _this = this;
            this.bodies.forEach(function (body) {
                var originalBody = body.originalBody;
                var hasPositionChanged = _this.areVectorsEqual(originalBody.position, body.position) === false;
                if (hasPositionChanged) {
                    if (originalBody["isStomping"]) {
                        Body.setPosition(body, { x: originalBody.position.x, y: originalBody["originalY"] });
                    }
                    else {
                        Body.setPosition(body, originalBody.position);
                    }
                }
                if (originalBody.plugin.isMoving) {
                    Body.setVelocity(body, originalBody.velocity);
                }
                if (originalBody.plugin.isRotating) {
                    Body.setAngle(body, originalBody.angle);
                }
            });
        };
        GameplayWorldCopy.prototype.areVectorsEqual = function (a, b) {
            return Phaser.Math.Fuzzy.Equal(a.x, b.x) && Phaser.Math.Fuzzy.Equal(a.y, b.y);
        };
        GameplayWorldCopy.prototype.wakeBodies = function () {
            this.bodies.forEach(function (body) { return Sleeping.set(body, false); });
        };
        GameplayWorldCopy.prototype.maintainBallVelocity = function () {
            var velocityRotation = Math.atan2(this.ball.velocity.y, this.ball.velocity.x);
            this.ballVelocity.x = Math.cos(velocityRotation) * this.ballSpeed;
            this.ballVelocity.y = Math.sin(velocityRotation) * this.ballSpeed;
            Body.setVelocity(this.ball, this.ballVelocity);
        };
        GameplayWorldCopy.prototype.toggleSimulation = function () {
            if (this.world.autoUpdate) {
                this.stopSimulation();
            }
            else {
                var start = this.scene.fox.getHandsPosition();
                var end = this.scene.input.activePointer.positionToCamera(this.scene.camera.camera);
                var rotation = Phaser.Math.Angle.BetweenPoints(start, end);
                this.startSimulation(start.x, start.y, rotation);
            }
        };
        GameplayWorldCopy.prototype.startSimulation = function (x, y, rotation) {
            var velocity = {
                x: Math.cos(rotation) * this.ballSpeed,
                y: Math.sin(rotation) * this.ballSpeed,
            };
            Body.setPosition(this.ball, { x: x, y: y });
            Body.setVelocity(this.ball, velocity);
            this.world.autoUpdate = true;
            this.world.drawDebug = true;
        };
        GameplayWorldCopy.prototype.stopSimulation = function () {
            this.world.autoUpdate = false;
            this.world.drawDebug = false;
            this.world.debugGraphic.clear();
        };
        GameplayWorldCopy.prototype.destroy = function () {
            this.scene.events.off(Phaser.Scenes.Events.UPDATE, this.world.update, this.world);
            this.scene.events.off(Phaser.Scenes.Events.POST_UPDATE, this.world["postUpdate"], this.world);
            this.world.destroy();
        };
        return GameplayWorldCopy;
    }());
    game.GameplayWorldCopy = GameplayWorldCopy;
})(game || (game = {}));
var game;
(function (game) {
    var GameplayAudio = /** @class */ (function () {
        function GameplayAudio(scene) {
            this.scene = scene;
            this.sound = this.scene.sound;
            this.audioCache = this.scene.cache.audio;
            this.isEnabled = this.scene.game.audioType === game.SoundManagerType.WEB_AUDIO;
            this.ballHitSounds = this.getBallHitSoundKeys();
            this.initThrottledSounds();
        }
        GameplayAudio.prototype.getBallHitSoundKeys = function () {
            var _this = this;
            var keys = [game.GameSoundKey.BALL_HIT_1, game.GameSoundKey.BALL_HIT_2, game.GameSoundKey.BALL_HIT_3];
            return keys.filter(function (key) { return _this.scene.cache.audio.has(key); });
        };
        GameplayAudio.prototype.initThrottledSounds = function () {
            this.ballThrow = this.throttleSound(game.GameSoundKey.BALL_THROW, { volume: 0.33 });
            this.ballHit = _.throttle(this.playBallHit.bind(this), 100, { trailing: false });
            this.collectableBallHit = this.throttleSound(game.GameSoundKey.NEW_BALL_HIT, { volume: 0.33 });
            this.collectableBallLand = this.throttleSound(game.GameSoundKey.NEW_BALL_LANDED, { volume: 0.33 });
            this.blockHit = this.throttleSound(game.GameSoundKey.BLOCK_HIT, { volume: 0.66 }, { wait: 200 });
            this.blockZap = this.throttleSound(game.GameSoundKey.BLOCK_ZAPPED, { volume: 0.22 });
            this.blockCollectWhoosh = this.throttleSound(game.GameSoundKey.BLOCK_COLLECTED_WHOOSH, { volume: 0.4 });
            this.blockCollectComplete = this.throttleSound(game.GameSoundKey.BLOCK_COLLECTED, { volume: 0.15 });
            this.pinata = this.throttleSound(game.GameSoundKey.PINATA, { volume: 1.33 });
            this.explosion = this.throttleSound(game.GameSoundKey.EXPLOSION, { volume: 0.7 });
            this.spinner = this.throttleSound(game.GameSoundKey.SPINNER, { volume: 0.33 });
            this.lightning = this.throttleSound(game.GameSoundKey.LIGHTNING, { volume: 0.33 });
            this.winningBallExplode = this.throttleSound(game.GameSoundKey.POP_1, { volume: 1 }, { trailing: true });
            this.crackerPunch = this.throttleSound(game.GameSoundKey.BOOSTER_CRACKER_PUNCH, { volume: 0.5 });
        };
        GameplayAudio.prototype.playBallHit = function () {
            if (this.isEnabled === false) {
                return;
            }
            if (this.ballHitSounds.length === 0) {
                return;
            }
            var key = Phaser.Math.RND.pick(this.ballHitSounds);
            this.sound.play(key, { volume: 0.66 });
        };
        GameplayAudio.prototype.throttleSound = function (key, soundOptions, throttleOptions) {
            var _this = this;
            if (this.isEnabled === false) {
                return _.noop;
            }
            throttleOptions = __assign({ wait: 100, trailing: false }, throttleOptions);
            return _.throttle(function () {
                _this.playSound(key, soundOptions);
            }, throttleOptions.wait, throttleOptions);
        };
        GameplayAudio.prototype.playSound = function (key, options) {
            var isSoundAvailable = this.audioCache.has(key);
            if (isSoundAvailable) {
                this.sound.play(key, options);
            }
        };
        GameplayAudio.prototype.destroy = function () {
        };
        return GameplayAudio;
    }());
    game.GameplayAudio = GameplayAudio;
})(game || (game = {}));
var game;
(function (game) {
    var EasingString = Phaser.Math.EasingString;
    var CrackerEvent;
    (function (CrackerEvent) {
        CrackerEvent["COMPLETE"] = "Cracker_COMPLETE";
    })(CrackerEvent = game.CrackerEvent || (game.CrackerEvent = {}));
    var Cracker = /** @class */ (function (_super) {
        __extends(Cracker, _super);
        function Cracker(scene) {
            var _this = _super.call(this, scene.matter.world, 0, 0, "gameplay", "booster_cracker_big") || this;
            _this.isLaunched = false;
            _this.hasHitSomething = false;
            _this.name = "cracker";
            _this.gameplay = _this.scene;
            _this.hittedItems = [];
            _this.setupBody();
            _this.addParticles();
            var collisionCategories = _this.gameplay._physics.collisionCategories;
            _this.ignoreCollisionCategory(collisionCategories.balls);
            _this.ignoreCollisionCategory(collisionCategories.walls);
            return _this;
        }
        Cracker.prototype.setupBody = function () {
            var radius = 30;
            this.setCircle(radius, {
                isSensor: true,
                ignoreGravity: true,
                friction: 0,
                frictionAir: 0,
                frictionStatic: 0,
                render: {
                    sprite: {
                        xOffset: -this.originX + (radius / this.width),
                    },
                },
            });
        };
        Cracker.prototype.addParticles = function () {
            this.particles = this.scene.add.particles("gameplay");
            this.particles.setDepth(game.GameplayDepth.BOOSTER_ABOVE_PARTICLES);
            if (this.scene.game.rendererType === game.RendererType.CANVAS) {
                this.sparksEmitter = this.gameplay.emitters.createDummyEmitter();
                this.smokeEmitter = this.gameplay.emitters.createDummyEmitter();
                return;
            }
            this.sparksEmitter = this.particles.createEmitter({
                frame: ["bomb_spark"],
                lifespan: { min: 300, max: 500 },
                scale: { start: 2, end: 0, ease: EasingString.Linear },
                alpha: { start: 1, end: 0, ease: EasingString.ExpoEaseIn },
                quantity: 3,
                frequency: 16,
                speedX: { min: 300, max: 500 },
                speedY: { min: -300, max: 300 },
                on: false,
            });
            this.smokeEmitter = this.particles.createEmitter({
                frame: ["craker_smoke"],
                lifespan: 1000,
                scale: { start: 0.4, end: 1, ease: EasingString.Linear },
                alpha: { start: 1, end: 0, ease: EasingString.CubicEaseOut },
                quantity: 1,
                rotate: { min: 0, max: 360 },
                frequency: 33,
                speedX: { min: 100, max: 150 },
                speedY: { min: -133, max: 133 },
            });
            this.smokeEmitter.startFollow(this, this.width * 0.66);
            // this.sparksEmitter.startFollow(this, this.width * 0.66)
        };
        Cracker.prototype.launch = function () {
            this.isLaunched = true;
            this.originalY = this.y;
            var k = 16.66667 / this.scene.game.loop.delta;
            this.setVelocityX(-20 / k);
            this.startFloat();
        };
        Cracker.prototype.startFloat = function () {
            var dy = 10;
            this.y -= dy;
            this.scene.tweens.add({
                targets: this,
                duration: 200,
                ease: Phaser.Math.Easing.Sine.InOut,
                y: this.y + dy * 2,
                yoyo: true,
                repeat: -1,
            });
        };
        Cracker.prototype.preUpdate = function (time, delta) {
            var _this = this;
            if (this.isLaunched === false) {
                return;
            }
            this.sparksEmitter.explode(1, this.x + this.displayWidth / 2, this.y);
            if (this.x < -this.gameplay.camera.getPadding().x - 100) {
                this.smokeEmitter.on = false;
                this.smokeEmitter.stopFollow();
                this.isLaunched = false;
                this.emit(CrackerEvent.COMPLETE, this);
                this.scene.time.delayedCall(800, function () {
                    _this.destroy();
                });
            }
        };
        Cracker.prototype.destroy = function (fromScene) {
            if (this.scene) {
                this.scene.tweens.killTweensOf(this);
            }
            this.particles.destroy(fromScene);
            this.hittedItems.length = 0;
            _super.prototype.destroy.call(this, fromScene);
        };
        return Cracker;
    }(Phaser.Physics.Matter.Image));
    game.Cracker = Cracker;
})(game || (game = {}));
var game;
(function (game) {
    var EasingString = Phaser.Math.EasingString;
    var BombEvent;
    (function (BombEvent) {
        BombEvent["LANDED"] = "Bomb_LANDED";
    })(BombEvent = game.BombEvent || (game.BombEvent = {}));
    var Bomb = /** @class */ (function (_super) {
        __extends(Bomb, _super);
        function Bomb(scene) {
            var _this = _super.call(this, scene.matter.world, 0, 0, "gameplay", "booster_bomb_big") || this;
            _this.isLaunched = false;
            _this.explosionRadius = game.GameGrid.CELL_SIZE * 1.75;
            _this.gameplay = _this.scene;
            _this.name = "cracker";
            _this.setupBody();
            _this.addParticles();
            return _this;
        }
        Bomb.prototype.setupBody = function () {
            var _a;
            var radius = 36;
            this.setCircle(radius, {
                plugin: (_a = {}, _a[game.COLLISION_TAG] = game.CollisionTag.BOMB, _a),
                collisionFilter: {
                    mask: this.gameplay._physics.collisionCategories.boosterBomb,
                },
                friction: 0,
                frictionAir: 0,
                frictionStatic: 0,
                render: {
                    sprite: {
                        xOffset: -this.originX + 0.465,
                        yOffset: this.originY - (radius / this.height) - 0.01,
                    },
                },
            });
        };
        Bomb.prototype.addParticles = function () {
            this.particles = this.scene.add.particles("gameplay");
            this.sparksEmitter = this.particles.createEmitter({
                frame: ["bomb_spark"],
                lifespan: 400,
                scale: { start: 2, end: 0, ease: EasingString.Linear },
                alpha: { start: 1, end: 0, ease: EasingString.ExpoEaseIn },
                quantity: 1,
                frequency: 33,
                speed: 300,
                on: false,
            });
            this.particlesContainer = this.scene.add.container(0, 0, [this.particles]);
            this.particlesContainer.setDepth(game.GameplayDepth.BOOSTER_ABOVE_PARTICLES);
        };
        Bomb.prototype.launchAt = function (x, y) {
            this.isLaunched = true;
            this.target = { x: x, y: y };
            this.safetyTimer = 0;
            this.updateEmitterPosition();
            this.sparksEmitter.on = true;
            this.playAlphaTween();
            this.launchBody();
        };
        Bomb.prototype.playAlphaTween = function () {
            this.alpha = 0;
            this.scene.tweens.add({
                targets: this,
                duration: 100,
                ease: Phaser.Math.Easing.Linear.Linear,
                alpha: 1,
            });
        };
        Bomb.prototype.launchBody = function () {
            var angleSign = Phaser.Math.RND.sign();
            this.setAngularVelocity(-0.05 * angleSign);
            this.setAngle(150 * angleSign);
            var k = 16.66667 / this.scene.game.loop.delta;
            this.applyForce({ x: 0, y: -0.75 * k });
        };
        Bomb.prototype.preUpdate = function (time, delta) {
            if (this.isLaunched === false) {
                return;
            }
            this.updateScale();
            this.updateEmitterPosition();
            this.checkIfReachTarget();
            this.updateSafetyTimer(delta);
        };
        Bomb.prototype.updateScale = function () {
            var minScale = 1.2;
            var maxScale = 3;
            this.scale = Phaser.Math.MapLinear(this.body.velocity.y, -40, 0, maxScale, minScale);
            this.scale = Phaser.Math.Clamp(this.scale, minScale, maxScale);
        };
        Bomb.prototype.updateEmitterPosition = function () {
            var offset = 58 * this.scale;
            var rotation = Phaser.Math.DegToRad(this.angle - 48);
            var dx = offset * Math.cos(rotation);
            var dy = offset * Math.sin(rotation);
            var emitX = this.x + dx;
            var emitY = this.y + dy;
            this.particlesContainer.x = emitX;
            this.particlesContainer.y = emitY;
            this.particlesContainer.scale = this.scale;
        };
        Bomb.prototype.checkIfReachTarget = function () {
            if (this.y > this.target.y && this.body.velocity.y > 0) {
                this.isLaunched = false;
                this.emit(BombEvent.LANDED, this);
                this.destroy();
            }
        };
        Bomb.prototype.updateSafetyTimer = function (delta) {
            this.safetyTimer += delta;
            if (this.safetyTimer > 1000) {
                this.isLaunched = false;
                this.emit(BombEvent.LANDED, this);
                this.destroy();
            }
        };
        Bomb.prototype.destroy = function (fromScene) {
            if (this.scene) {
                this.scene.tweens.killTweensOf(this);
            }
            this.particles.destroy(fromScene);
            _super.prototype.destroy.call(this, fromScene);
        };
        return Bomb;
    }(Phaser.Physics.Matter.Image));
    game.Bomb = Bomb;
})(game || (game = {}));
var game;
(function (game) {
    var Stopper = /** @class */ (function (_super) {
        __extends(Stopper, _super);
        function Stopper(scene) {
            var _this = _super.call(this, scene) || this;
            _this.turnsLeft = 3;
            _this.name = "stop";
            _this.addCircleFx();
            _this.addIcon();
            _this.addText();
            return _this;
        }
        Stopper.prototype.addCircleFx = function () {
            this.circleFx = this.scene.add.image(0, 0, "gameplay", "circle_fx");
            this.add(this.circleFx);
        };
        Stopper.prototype.showCircleFx = function () {
            var _this = this;
            this.circleFx.revive();
            this.circleFx.scale = 0.5;
            this.circleFx.alpha = 1;
            this.scene.tweens.add({
                targets: this.circleFx,
                duration: 1000,
                alpha: { value: 0, ease: Phaser.Math.Easing.Expo.Out },
                scale: { value: 1.8, ease: Phaser.Math.Easing.Expo.Out },
                onComplete: function () {
                    _this.circleFx.kill();
                },
            });
        };
        Stopper.prototype.addIcon = function () {
            this.icon = this.scene.add.image(0, 0, "gameplay", "booster_stop_big");
            this.add(this.icon);
        };
        Stopper.prototype.addText = function () {
            var content = this.turnsLeft.toString();
            this.text = this.scene.add.bitmapText(0, 0, game.BitmapGameFont.GAMEPLAY_BOOSTERS, content, 32);
            this.text.setOrigin(0.5, 0.5);
            this.text.x = this.icon.right + 1;
            this.text.y = this.icon.bottom - 12;
            this.text.originalY = this.text.y;
            this.add(this.text);
        };
        Stopper.prototype.updateTurnsNum = function (turnsNum) {
            this.turnsLeft = turnsNum;
            this.playUpdateTween();
            this.playTextUpdateTween();
        };
        Stopper.prototype.playUpdateTween = function () {
            var _this = this;
            this.scene.tweens.add({
                targets: this,
                duration: 300,
                ease: Phaser.Math.Easing.Sine.InOut,
                scale: 1.3,
                yoyo: true,
                onComplete: function () {
                    _this.showCircleFx();
                },
            });
        };
        Stopper.prototype.playTextUpdateTween = function () {
            var _this = this;
            this.scene.tweens.add({
                targets: this.text,
                duration: 150,
                ease: Phaser.Math.Easing.Linear.Linear,
                alpha: 0,
                completeDelay: 400,
                onComplete: function () {
                    _this.text.setText(_this.turnsLeft.toString());
                    _this.text.scale = 0.66;
                    _this.scene.tweens.add({
                        targets: _this.text,
                        duration: 500,
                        ease: Phaser.Math.Easing.Back.Out,
                        scale: 1,
                    });
                    _this.scene.tweens.add({
                        targets: _this.text,
                        duration: 200,
                        ease: Phaser.Math.Easing.Linear.Linear,
                        alpha: 1,
                    });
                },
            });
        };
        Stopper.prototype.show = function () {
            this.scale = 0.75;
            this.alpha = 0;
            this.angle = Phaser.Math.RND.sign() * 10;
            this.scene.tweens.add({
                targets: this,
                duration: 1000,
                ease: Phaser.Math.Easing.Elastic.Out,
                easeParams: [0.1, 0.4],
                scale: 1,
                angle: 0,
            });
            this.scene.tweens.add({
                targets: this,
                duration: 150,
                ease: Phaser.Math.Easing.Linear.Linear,
                alpha: 1,
            });
            this.showCircleFx();
        };
        Stopper.prototype.flyTo = function (targetPosition, delay) {
            var _this = this;
            var distance = Phaser.Math.Distance.Between(this.x, this.y, targetPosition.x, targetPosition.y);
            var duration = Math.max(700, distance / game.Config.ASSETS_SCALE);
            this.scene.tweens.add({
                targets: this,
                delay: delay,
                duration: duration,
                ease: Phaser.Math.Easing.Back.InOut,
                easeParams: [1],
                x: targetPosition.x,
                y: targetPosition.y,
                onComplete: function () {
                    _this.onFlyComplete();
                },
            });
            this.playWhooshSound(delay, duration);
        };
        Stopper.prototype.playWhooshSound = function (delay, duration) {
            if (this.scene.cache.audio.has(game.GameSoundKey.BLOCK_COLLECTED_WHOOSH)) {
                var whooshDelay = (delay + duration * 0.25) / 1000;
                this.scene.sound.play(game.GameSoundKey.BLOCK_COLLECTED_WHOOSH, { volume: 1, delay: whooshDelay });
            }
        };
        Stopper.prototype.onFlyComplete = function () {
            this.scene.tweens.add({
                targets: this.list,
                duration: 800,
                ease: Phaser.Math.Easing.Sine.InOut,
                y: "+=10",
                yoyo: true,
                repeat: -1,
                delay: this.scene.tweens.stagger(100),
            });
        };
        Stopper.prototype.hide = function () {
            var _this = this;
            this.scene.tweens.add({
                targets: this,
                duration: 150,
                ease: Phaser.Math.Easing.Linear.Linear,
                alpha: 0,
                scale: 1.33,
                onComplete: function () {
                    _this.destroy();
                },
            });
        };
        Stopper.prototype.preDestroy = function () {
            this.scene.tweens.killTweensOf(this.list);
            _super.prototype.preDestroy.call(this);
        };
        return Stopper;
    }(Phaser.GameObjects.Container));
    game.Stopper = Stopper;
})(game || (game = {}));
var game;
(function (game) {
    var BombAimSpot = /** @class */ (function (_super) {
        __extends(BombAimSpot, _super);
        function BombAimSpot(scene) {
            var _this = _super.call(this, scene) || this;
            _this.name = "bomb_aim_spot";
            _this.addCircles();
            _this.addTimerEvent();
            return _this;
        }
        BombAimSpot.prototype.addCircles = function () {
            var _this = this;
            this.circles = _.times(10, function () {
                var circle = _this.scene.add.image(0, 0, "gameplay", "circle_fx");
                circle.kill();
                return circle;
            });
            this.add(this.circles);
        };
        BombAimSpot.prototype.addTimerEvent = function () {
            this.showCirclesTimerEvent = this.scene.time.addEvent({
                loop: true,
                delay: 300,
                startAt: 280,
                callback: this.showCircle.bind(this),
                paused: true,
            });
        };
        BombAimSpot.prototype.show = function () {
            this.revive();
            this.showCirclesTimerEvent.paused = false;
        };
        BombAimSpot.prototype.hide = function () {
            this.kill();
            this.showCirclesTimerEvent.paused = true;
        };
        BombAimSpot.prototype.showCircle = function () {
            var circle = this.circles.find(function (circle) { return circle.visible === false; });
            if (circle) {
                circle.revive();
                circle.scale = 2;
                circle.alpha = 0;
                this.scene.tweens.add({
                    targets: circle,
                    duration: 700,
                    alpha: { value: 0.85, ease: Phaser.Math.Easing.Expo.Out },
                    scale: { value: 0, ease: Phaser.Math.Easing.Linear.Linear },
                    onComplete: function () {
                        circle.kill();
                    },
                });
            }
        };
        BombAimSpot.prototype.destroy = function (fromScene) {
            this.showCirclesTimerEvent.destroy();
            _super.prototype.destroy.call(this, fromScene);
        };
        return BombAimSpot;
    }(Phaser.GameObjects.Container));
    game.BombAimSpot = BombAimSpot;
})(game || (game = {}));
///<reference path='Cracker.ts' />
///<reference path='Bomb.ts' />
///<reference path='Stopper.ts' />
///<reference path='BombAimSpot.ts' />
var game;
(function (game) {
    var EventEmitter = Phaser.Events.EventEmitter;
    var EasingString = Phaser.Math.EasingString;
    var ButtonEvent = Phaser.GameObjects.ButtonEvent;
    var GameplayBoostersEvent;
    (function (GameplayBoostersEvent) {
        GameplayBoostersEvent["SELECT"] = "GameplayBoosters_SELECT";
        GameplayBoostersEvent["CANCEL"] = "GameplayBoosters_CANCEL";
        GameplayBoostersEvent["ACTIVATE"] = "GameplayBoosters_ACTIVATE";
        GameplayBoostersEvent["COMPLETE"] = "GameplayBoosters_COMPLETE";
        GameplayBoostersEvent["GET_FREE_BOOSTER"] = "GameplayBoosters_GET_FREE_BOOSTER";
    })(GameplayBoostersEvent = game.GameplayBoostersEvent || (game.GameplayBoostersEvent = {}));
    var GameplayBoosters = /** @class */ (function (_super) {
        __extends(GameplayBoosters, _super);
        function GameplayBoosters(scene, gui) {
            var _this = _super.call(this) || this;
            _this.foxHitNum = 0;
            _this.isCanvasRenderer = scene.game.rendererType === game.RendererType.CANVAS;
            _this.scene = scene;
            _this.gui = gui;
            _this.gui.events.on(GameplayBoostersEvent.SELECT, _this.onBoosterSelect, _this);
            _this.gui.events.on(GameplayBoostersEvent.CANCEL, _this.onBoosterCancel, _this);
            _this.gui.events.on(GameplayBoostersEvent.GET_FREE_BOOSTER, _this.onGetFreeBoostersClick, _this);
            _this.freeBoostersScreen = _this.gui.freeBoostersScreen;
            _this.boosterHint = _this.gui.boosterHintScreen;
            _this.boostersPanel = _this.gui.boostersPanel;
            _this.addBombAimSpot();
            _this.addParticles();
            return _this;
            // this.testBooster(BoosterType.BOMB, { x: 3, y: 5 })
            // this.testBoosterByClick(BoosterType.BOMB)
        }
        GameplayBoosters.prototype.testBooster = function (boosterType, gridPosition) {
            var _this = this;
            gridPosition = gridPosition !== null && gridPosition !== void 0 ? gridPosition : {
                x: Phaser.Math.RND.between(0, game.GameGrid.COLUMNS),
                y: Phaser.Math.RND.between(0, game.GameGrid.ROWS),
            };
            var cell = this.scene.grid.getCellAt(gridPosition.y, gridPosition.x);
            if (cell) {
                this.scene.time.delayedCall(100, function () {
                    _this.activateBooster(_this.getBooster(boosterType), cell.x, cell.y);
                });
            }
        };
        GameplayBoosters.prototype.testBoosterByClick = function (type) {
            var _this = this;
            this.scene.removePointerCallbacks();
            this.scene.input.on(Phaser.Input.Events.POINTER_DOWN, function (pointer) {
                var cell = _this.scene.grid.getCellAtXY(pointer.worldX, pointer.worldY);
                if (cell) {
                    _this.activateBooster(_this.getBooster(type), cell.x, cell.y);
                }
            });
        };
        GameplayBoosters.prototype.addBombAimSpot = function () {
            this.bombAimSpot = new game.BombAimSpot(this.scene);
            this.bombAimSpot.setDepth(game.GameplayDepth.BOOSTER_BELOW_PARTICLES);
            this.scene.add.existing(this.bombAimSpot);
        };
        GameplayBoosters.prototype.addParticles = function () {
            this.particles = this.scene.add.particles("gameplay");
            this.particles.setDepth(game.GameplayDepth.BOOSTER_BELOW_PARTICLES);
            this.bombShockwave = this.isCanvasRenderer
                ? this.scene.emitters.createDummyEmitter()
                : this.createBombShockwaveEmitter();
        };
        GameplayBoosters.prototype.createBombShockwaveEmitter = function () {
            return this.particles.createEmitter({
                frame: "circle_fx",
                lifespan: 800,
                alpha: { start: 1, end: 0, ease: EasingString.ExpoEaseOut },
                scale: { start: 0.5, end: 6, ease: EasingString.ExpoEaseOut },
                on: false,
            });
        };
        GameplayBoosters.prototype.showBombAimSpot = function (x, y) {
            this.bombAimSpot.setPosition(x, y);
            this.bombAimSpot.show();
        };
        GameplayBoosters.prototype.hideBombAimSpot = function () {
            this.bombAimSpot.hide();
        };
        GameplayBoosters.prototype.onBoosterSelect = function (booster) {
            this.addPointerDownCallback(booster);
            this.scene.removePointerCallbacks();
            this.boosterHint.updateData(booster);
            this.boosterHint.show();
            this.gui.topPanel.hide();
            this.gui.pauseButton.kill();
            this.boostersPanel.highlight(booster.type);
        };
        GameplayBoosters.prototype.addPointerDownCallback = function (booster) {
            this.onPointerDownCallback = this.onFieldClick.bind(this, booster);
            this.scene.input.on(Phaser.Input.Events.POINTER_DOWN, this.onPointerDownCallback);
        };
        GameplayBoosters.prototype.removePointerDownCallback = function () {
            if (this.onPointerDownCallback) {
                this.scene.input.off(Phaser.Input.Events.POINTER_DOWN, this.onPointerDownCallback);
                this.onPointerDownCallback = null;
            }
        };
        GameplayBoosters.prototype.onFieldClick = function (booster, pointer) {
            var clickInsideGrid = this.scene.grid.getBounds().contains(pointer.worldX, pointer.worldY);
            if (clickInsideGrid) {
                this.removePointerDownCallback();
                this.activateBooster(booster, pointer.worldX, pointer.worldY);
            }
        };
        GameplayBoosters.prototype.activateBooster = function (booster, x, y) {
            this.scene.analytics.sendBoosterUseEvent(this.scene.levelNumber, booster.type);
            this.scene.raven.addExtraContext({
                lastBooster: booster.type,
                lastBoosterCell: this.scene.grid.getCellAtXY(x, y).toString(),
            });
            this.onBoosterActivate(booster);
            switch (booster.type) {
                case game.BoosterType.STOP:
                    this.activateStop(booster, x, y);
                    break;
                case game.BoosterType.BOMB:
                    this.activateBomb(booster, x, y);
                    break;
                case game.BoosterType.CRACKER:
                    this.activateCracker(booster, x, y);
                    break;
                default:
                    break;
            }
        };
        GameplayBoosters.prototype.onBoosterActivate = function (booster) {
            booster.num -= 1;
            this.boosterHint.hide();
            this.gui.topPanel.show();
            this.gui.pauseButton.revive();
            this.boostersPanel.resetHighlight();
            if (booster.type === game.BoosterType.CRACKER || booster.type === game.BoosterType.BOMB) {
                this.boostersPanel.disableInput();
                this.boostersPanel.hide();
                this.scene.turn.start();
                this.scene.stopStomping();
                this.scene.hideWarningLine();
                this.scene.wakeItems();
            }
            else {
                this.boostersPanel.getIconByType(game.BoosterType.STOP).lock();
                this.scene.addPointerCallbacks();
            }
            this.emit(GameplayBoostersEvent.ACTIVATE, booster);
        };
        GameplayBoosters.prototype.activateStop = function (booster, x, y) {
            var stop = new game.Stopper(this.scene);
            stop.setDepth(game.GameplayDepth.BOOSTER);
            stop.x = x;
            stop.y = y;
            stop.show();
            stop.flyTo({ x: 15, y: 10 }, 500);
            this.scene.add.existing(stop);
            this.playStopRevealSound();
            this.addTurnCompleteCallback(stop);
        };
        GameplayBoosters.prototype.addTurnCompleteCallback = function (stop) {
            this.onTurnCompleteCallback = this.onTurnComplete.bind(this, stop);
            this.scene.events.on(game.GameplayEvent.TURN_FULLY_COMPLETE, this.onTurnCompleteCallback);
        };
        GameplayBoosters.prototype.removeTurnCompleteCallback = function () {
            if (this.onTurnCompleteCallback) {
                this.scene.events.off(game.GameplayEvent.TURN_FULLY_COMPLETE, this.onTurnCompleteCallback);
                this.onTurnCompleteCallback = null;
            }
        };
        GameplayBoosters.prototype.playStopRevealSound = function () {
            if (this.scene.cache.audio.has(game.GameSoundKey.FANCY_TAP)) {
                this.scene.sound.play(game.GameSoundKey.FANCY_TAP, { volume: 0.66 });
            }
        };
        GameplayBoosters.prototype.onTurnComplete = function (stop) {
            var isComplete = --stop.turnsLeft === 0;
            if (isComplete) {
                stop.hide();
                this.onBoosterComplete(this.getBooster(game.BoosterType.STOP));
                this.removeTurnCompleteCallback();
            }
            else {
                stop.updateTurnsNum(stop.turnsLeft);
            }
        };
        GameplayBoosters.prototype.activateBomb = function (booster, x, y) {
            var _this = this;
            this.playIgniteSound();
            var cell = this.scene.grid.getCellAtXY(x, y);
            this.showBombAimSpot(cell.x, cell.y);
            this.scene.time.delayedCall(300, function () {
                _this.playBombWhooshSound();
                _this.throwBomb(booster, cell.x, cell.y);
            });
        };
        GameplayBoosters.prototype.playIgniteSound = function () {
            if (this.scene.cache.audio.has(game.GameSoundKey.BOOSTER_BOMB_IGNITE)) {
                this.scene.sound.play(game.GameSoundKey.BOOSTER_BOMB_IGNITE, { volume: 1 });
            }
        };
        GameplayBoosters.prototype.throwBomb = function (booster, x, y) {
            var bomb = new game.Bomb(this.scene);
            bomb.x = x;
            bomb.y = y + game.GameGrid.CELL_SIZE * 4;
            bomb.setDepth(game.GameplayDepth.BOOSTER);
            bomb.on(game.BombEvent.LANDED, this.onBombLanded.bind(this, bomb, booster));
            bomb.launchAt(x, y);
            this.scene.add.existing(bomb);
            this.scene.turn.pendingBoosters.push(bomb);
        };
        GameplayBoosters.prototype.playBombWhooshSound = function () {
            if (this.scene.cache.audio.has(game.GameSoundKey.WINNING_BALL_WHOOSH)) {
                this.scene.sound.play(game.GameSoundKey.WINNING_BALL_WHOOSH, { volume: 1 });
            }
        };
        GameplayBoosters.prototype.onBombLanded = function (bomb, booster) {
            // on low fps bomb can go throw destination point so we put it back and explode where it should
            bomb.x = bomb.target.x;
            bomb.y = bomb.target.y;
            this.scene.showExplosion(bomb.x, bomb.y, 1.5);
            this.scene.damageNearbyBlocks(bomb);
            this.scene.destroyNearbyItems(bomb);
            this.scene.audio.explosion();
            this.scene.cameras.main.shake(600, 0.014, true);
            this.checkBombFoxOverlap(bomb);
            this.hideBombAimSpot();
            this.bombShockwave.explode(1, bomb.x, bomb.y);
            var index = this.scene.turn.pendingBoosters.indexOf(bomb);
            if (index > -1) {
                this.scene.turn.pendingBoosters.splice(index, 1);
                if (this.scene.turn.pendingBoosters.length === 0) {
                    this.onBoosterComplete(booster);
                    if (this.scene.turn.checkComplete()) {
                        this.scene.onTurnComplete();
                    }
                }
            }
        };
        GameplayBoosters.prototype.checkBombFoxOverlap = function (bomb) {
            var fox = this.scene.fox;
            var distance = Phaser.Math.Distance.Between(bomb.x, bomb.y, fox.x, fox.y);
            if (distance < game.GameGrid.CELL_SIZE * 2) {
                this.onFoxHit();
            }
        };
        GameplayBoosters.prototype.onFoxHit = function () {
            this.scene.showFoxTalkBubble();
            this.scene.fox.showWorriedFrame();
            this.foxHitNum++;
            if (this.foxHitNum % 2 === 0) {
                this.playCatchYouShout();
            }
            else {
                this.playStopShout();
            }
        };
        GameplayBoosters.prototype.playCatchYouShout = function () {
            if (this.scene.cache.audio.has(game.GameSoundKey.CATCH_YOU_SHOUT)) {
                this.scene.sound.play(game.GameSoundKey.CATCH_YOU_SHOUT, { volume: 1 });
            }
        };
        GameplayBoosters.prototype.playStopShout = function () {
            if (this.scene.cache.audio.has(game.GameSoundKey.STOP_SHOUT)) {
                this.scene.sound.play(game.GameSoundKey.STOP_SHOUT, { volume: 1 });
            }
        };
        GameplayBoosters.prototype.activateCracker = function (booster, x, y) {
            var _this = this;
            this.playIgniteSound();
            this.scene.time.delayedCall(300, function () {
                _this.playCrackerSound();
                _this.launchCracker(booster, x, y);
                _this.scene.camera.camera.shake(2000, 0.005, true);
            });
        };
        GameplayBoosters.prototype.playCrackerSound = function () {
            if (this.scene.cache.audio.has(game.GameSoundKey.BOOSTER_CRACKER)) {
                this.scene.sound.play(game.GameSoundKey.BOOSTER_CRACKER, { volume: 1 });
            }
        };
        GameplayBoosters.prototype.launchCracker = function (booster, x, y) {
            var cell = this.scene.grid.getCellAtXY(x, y);
            var cracker = new game.Cracker(this.scene);
            cracker.x = this.scene.getFieldWidth() + this.scene.camera.getPadding().x;
            cracker.y = cell.y;
            cracker.setDepth(game.GameplayDepth.BOOSTER);
            cracker.setOnCollide(this.onCrackerCollide.bind(this));
            cracker.once(game.CrackerEvent.COMPLETE, this.onCrackerOutOfWorld.bind(this, booster));
            cracker.launch();
            this.scene.add.existing(cracker);
            this.scene.turn.pendingBoosters.push(cracker);
            this.scene.grid.highlightRow(cell.row, 0.77, 0);
            if (cell.row < 2) {
                this.onFoxHit();
            }
        };
        GameplayBoosters.prototype.onCrackerCollide = function (pair) {
            var item = pair.bodyA.gameObject;
            var cracker = pair.bodyB.gameObject;
            if (cracker && item) {
                var wasHitAlready = cracker.hittedItems.includes(item);
                if (wasHitAlready) {
                    return;
                }
                cracker.hasHitSomething = true;
                cracker.hittedItems.push(item);
                this.moveItemByCracker(item);
            }
        };
        GameplayBoosters.prototype.moveItemByCracker = function (item) {
            var _this = this;
            var dx = Phaser.Math.RND.between(60, 100);
            var targetX = Math.max(0, item.x - dx);
            var dy = game.GameGrid.CELL_SIZE / 2;
            var dySign = item.grid.getColumn() % 2 === 0 ? -1 : 1;
            var maxY = (game.GameGrid.ROWS - game.GameGrid.LOSE_ROW) * game.GameGrid.CELL_SIZE;
            var targetY = Phaser.Math.Clamp(item.y + dy * dySign, 0, maxY);
            this.scene.tweens.add({
                targets: item,
                duration: 300,
                ease: Phaser.Math.Easing.Back.Out,
                x: targetX,
                y: targetY,
                onStart: function () {
                    _this.onMoveByCrackerStart(item);
                },
                onComplete: function () {
                    _this.onMoveByCrackerComplete(item);
                },
            });
        };
        GameplayBoosters.prototype.onMoveByCrackerStart = function (item) {
            item.setDepth(game.GameplayDepth.HIT_BY_CRACKER);
            var isBlock = game.ItemTypeUtil.isBlockType(item.itemType);
            if (isBlock) {
                var block = item;
                block.hitByCracker();
                this.scene.audio.crackerPunch();
            }
        };
        GameplayBoosters.prototype.onMoveByCrackerComplete = function (item) {
            var isBlock = game.ItemTypeUtil.isBlockType(item.itemType);
            if (isBlock) {
                var block = item;
                block.health.kill();
            }
            else {
                item.once(game.HideEvent.COMPLETE, function () {
                    item.destroy();
                });
                item.hideOnLevelComplete(300);
            }
        };
        GameplayBoosters.prototype.onCrackerOutOfWorld = function (booster, cracker) {
            var _this = this;
            this.scene.camera.camera.shakeEffect.reset();
            if (cracker.hasHitSomething === false) {
                this.onBoosterComplete(booster);
                this.scene.turn.pendingBoosters.length = 0;
                this.scene.onTurnComplete();
            }
            else {
                cracker.once(Phaser.GameObjects.Events.DESTROY, function () {
                    _this.onBoosterComplete(booster);
                    _this.scene.turn.pendingBoosters.length = 0;
                    if (_this.scene.turn.checkComplete()) {
                        _this.scene.onTurnComplete();
                    }
                });
            }
        };
        GameplayBoosters.prototype.onBoosterComplete = function (booster) {
            this.emit(GameplayBoostersEvent.COMPLETE, booster);
            if (booster.type === game.BoosterType.STOP) {
                this.boostersPanel.getIconByType(game.BoosterType.STOP).unlock();
            }
            else {
                this.boostersPanel.enableInput();
                this.scene.addPointerCallbacks();
            }
        };
        GameplayBoosters.prototype.onBoosterCancel = function (booster) {
            this.removePointerDownCallback();
            this.scene.addPointerCallbacks();
            this.boosterHint.hide();
            this.gui.topPanel.show();
            this.gui.pauseButton.revive();
            this.boostersPanel.resetHighlight();
        };
        GameplayBoosters.prototype.onGetFreeBoostersClick = function (booster) {
            if (!this.freeBoostersScreen) {
                return;
            }
            this.onFreeBoostersScreenShow(booster.type);
            this.freeBoostersScreen.closeButton.on(ButtonEvent.PRESS, this.onFreeBoosterScreenClose.bind(this, booster.type));
            this.freeBoostersScreen.playButton.on(ButtonEvent.PRESS, this.showRewardAd, this);
            this.freeBoostersScreen.once(game.FreeBoostersScreenEvent.HIDE_START, this.onFreeBoostersScreenHide, this);
            this.freeBoostersScreen.updateData(booster.type, this.getBoosterRewardNum());
            this.freeBoostersScreen.revive();
            this.freeBoostersScreen.show();
        };
        GameplayBoosters.prototype.getBoosterRewardNum = function () {
            var valueStr = this.scene.game.analytics.getRemoteConfigValue(game.RemoteConfigKey.BOOSTERS_NUM, "1");
            return parseInt(valueStr);
        };
        GameplayBoosters.prototype.onFreeBoostersScreenShow = function (type) {
            this.scene.removePointerCallbacks();
            this.gui.bottomPanel.disableInput();
        };
        GameplayBoosters.prototype.showRewardAd = function () {
            var _this = this;
            var boosterType = this.freeBoostersScreen.currentBooster;
            var boosterNum = this.getBoosterRewardNum();
            this.scene.analytics.sendRewardedAd("free_booster", boosterType, "request");
            this.scene.poki
                .rewardedBreak("Booster:" + boosterType, {
                onSuccess: function () {
                    _this.scene.time.delayedCall(200, function () {
                        _this.onRewardAdSuccess(boosterType, boosterNum);
                        _this.freeBoostersScreen.hide();
                        _this.scene.analytics.sendRewardedAd("free_booster", boosterType, "receive");
                    });
                },
                onFail: function () {
                    _this.scene.analytics.sendRewardedAd("free_booster", boosterType, "fail");
                },
            })
                .catch(function () {
            });
        };
        GameplayBoosters.prototype.onRewardAdSuccess = function (boosterType, boosterNum) {
            this.boostersPanel.getIconByType(boosterType).onGiftArrive(boosterNum);
            this.scene.boosters.getBooster(boosterType).num += boosterNum;
            this.scene.analytics.sendRewardedAd("free_booster", boosterType, "receive");
        };
        GameplayBoosters.prototype.onFreeBoosterScreenClose = function (boosterType) {
            this.gui.freeBoostersScreen.hide();
        };
        GameplayBoosters.prototype.onFreeBoostersScreenHide = function () {
            this.scene.addPointerCallbacks();
            this.gui.bottomPanel.enableInput();
            this.freeBoostersScreen.closeButton.off(ButtonEvent.PRESS, this.onFreeBoosterScreenClose, this);
            this.freeBoostersScreen.playButton.off(ButtonEvent.PRESS, this.showRewardAd, this);
        };
        GameplayBoosters.prototype.getBooster = function (type) {
            return this.scene.game.boosters.getByType(type);
        };
        GameplayBoosters.prototype.destroy = function () {
            this.particles.destroy();
            this.removeTurnCompleteCallback();
            this.removePointerDownCallback();
            this.scene.events.off(GameplayBoostersEvent.ACTIVATE, this.onBoosterActivate, this);
            this.scene.events.off(GameplayBoostersEvent.COMPLETE, this.onBoosterComplete, this);
            this.gui.events.off(GameplayBoostersEvent.SELECT, this.onBoosterSelect, this);
            this.gui.events.off(GameplayBoostersEvent.CANCEL, this.onBoosterCancel, this);
            this.gui.events.off(GameplayBoostersEvent.GET_FREE_BOOSTER, this.onGetFreeBoostersClick, this);
        };
        return GameplayBoosters;
    }(EventEmitter));
    game.GameplayBoosters = GameplayBoosters;
})(game || (game = {}));
var game;
(function (game) {
    var EventEmitter = Phaser.Events.EventEmitter;
    var SecondChanceEvent;
    (function (SecondChanceEvent) {
        SecondChanceEvent["COMPLETE"] = "SecondChance_COMPLETE";
    })(SecondChanceEvent = game.SecondChanceEvent || (game.SecondChanceEvent = {}));
    var SecondChance = /** @class */ (function (_super) {
        __extends(SecondChance, _super);
        function SecondChance(scene) {
            var _this = _super.call(this) || this;
            _this.wasUsed = false;
            _this.scene = scene;
            return _this;
        }
        SecondChance.prototype.apply = function () {
            var _this = this;
            this.wasUsed = true;
            this.removeBlockKing();
            var initialDelay = 100;
            this.scene.time.delayedCall(initialDelay + 100, function () {
                _this.reviveFox();
                _this.reviveBalls();
            });
            this.scene.time.delayedCall(initialDelay + 300, function () {
                _this.destroyTopItems();
            });
        };
        SecondChance.prototype.removeBlockKing = function () {
            var blockKing = this.scene.sys.displayList.getByName(game.BlockKing.NAME);
            if (blockKing) {
                this.scene.tweens.add({
                    targets: blockKing,
                    duration: 100,
                    ease: Phaser.Math.Easing.Linear.Linear,
                    alpha: 0,
                    onComplete: function () {
                        blockKing.destroy();
                    },
                });
            }
        };
        SecondChance.prototype.reviveFox = function () {
            var fox = this.scene.fox;
            fox.playIdleAnimation();
            fox.revive();
            fox.alpha = 0;
            fox.scale = 0.8;
            this.scene.tweens.add({
                targets: fox,
                duration: 150,
                ease: Phaser.Math.Easing.Linear.Linear,
                alpha: 1,
            });
            this.scene.tweens.add({
                targets: fox,
                duration: 400,
                ease: Phaser.Math.Easing.Back.Out,
                scale: 1,
            });
        };
        SecondChance.prototype.reviveBalls = function () {
            this.scene.idleBalls.forEach(function (ball) { return ball.revive(); });
        };
        SecondChance.prototype.destroyTopItems = function () {
            var _this = this;
            var itemsToDestroy = this.scene.items.filter(function (item) { return item.grid.getRow() >= (game.GameGrid.ROWS - SecondChance.ROWS - 1); });
            var itemsNum = itemsToDestroy.length;
            if (itemsNum === 0) {
                this.moveItemsUp(SecondChance.ROWS);
                return;
            }
            itemsToDestroy.forEach(function (item) {
                item.on(Phaser.GameObjects.Events.DESTROY, function () {
                    if (--itemsNum === 0) {
                        _this.moveItemsUp(SecondChance.ROWS);
                    }
                });
                item.on(game.HideEvent.COMPLETE, function () {
                    item.destroy();
                });
                item.hideOnLevelComplete(150);
            });
        };
        SecondChance.prototype.moveItemsUp = function (counter) {
            var _this = this;
            this.playMoveItemsUpSound();
            this.scene.tweens.add({
                targets: this.scene.items,
                duration: 200,
                ease: Phaser.Math.Easing.Cubic.Out,
                y: "-=" + game.GameGrid.CELL_SIZE,
                completeDelay: 66,
            }).once(Phaser.Tweens.Events.TIMELINE_COMPLETE, function () {
                if (--counter === 0) {
                    _this.onMoveUpComplete();
                }
                else {
                    _this.moveItemsUp(counter);
                }
            });
        };
        SecondChance.prototype.playMoveItemsUpSound = function () {
            if (this.scene.cache.audio.has(game.GameSoundKey.MOVE_ITEMS_UP)) {
                this.scene.sound.play(game.GameSoundKey.MOVE_ITEMS_UP, { volume: 0.66 });
            }
        };
        SecondChance.prototype.onMoveUpComplete = function () {
            this.scene.completeTurn();
            this.adjustLevelGenerator();
            this.emit(SecondChanceEvent.COMPLETE, this);
        };
        SecondChance.prototype.adjustLevelGenerator = function () {
            this.scene.generator.moveRowPointer(-SecondChance.ROWS);
        };
        SecondChance.ROWS = 3;
        return SecondChance;
    }(EventEmitter));
    game.SecondChance = SecondChance;
})(game || (game = {}));
var game;
(function (game) {
    var FastForward = /** @class */ (function () {
        function FastForward(scene) {
            this._timeScale = 1;
            this.isEnabled = false;
            this.scene = scene;
            this.items = [];
        }
        Object.defineProperty(FastForward.prototype, "timeScale", {
            get: function () {
                return this._timeScale;
            },
            enumerable: false,
            configurable: true
        });
        FastForward.prototype.addItem = function (item) {
            this.items.push(item);
        };
        FastForward.prototype.removeItem = function (item) {
            var index = this.items.indexOf(item);
            if (index > -1) {
                this.items.splice(index, 1);
            }
        };
        FastForward.prototype.enable = function () {
            if (this.scene.turn.inProgress() === false) {
                return;
            }
            if (this.isEnabled) {
                return;
            }
            this.scene.turn.fastForwarded = true;
            var timeScale = 3;
            this._timeScale = timeScale;
            this.isEnabled = true;
            this.scene.anims.globalTimeScale = timeScale;
            this.scene.tweens.timeScale = timeScale;
            this.scene.time.timeScale = timeScale;
            this.scene.emitters.setTimescale(timeScale);
            this.items.forEach(function (item) { return (item.timeScale = timeScale); });
            this.scene.gui.tweens.timeScale = timeScale;
            this.scene.gui.fastForwardButton.disable();
            this.scene.gui.fastForwardButton.playAnimation();
            this.scene.gui.fastForward.show();
            this.scene.sound.setRate(timeScale);
            this.playSound();
            this.scene.game.store.saveValue(game.GameStoreKey.FAST_FORWARD_WAS_USED, true);
            this.scene.events.emit(game.GameplayEvent.FAST_FORWARD_START, this);
        };
        FastForward.prototype.playSound = function () {
            if (this.sound) {
                this.sound.play();
                return;
            }
            if (this.scene.cache.audio.has(game.GameSoundKey.FAST_FORWARD)) {
                this.sound = this.scene.sound.add(game.GameSoundKey.FAST_FORWARD, { volume: 1 });
                this.sound.play();
            }
        };
        FastForward.prototype.disable = function () {
            if (this.isEnabled === false) {
                return;
            }
            this._timeScale = 1;
            this.isEnabled = false;
            this.scene.anims.globalTimeScale = 1;
            this.scene.tweens.timeScale = 1;
            this.scene.time.timeScale = 1;
            this.scene.emitters.setTimescale(1);
            this.items.forEach(function (item) { return (item.timeScale = 1); });
            this.scene.gui.tweens.timeScale = 1;
            this.scene.gui.fastForwardButton.stopAnimation();
            this.scene.gui.fastForward.hide();
            this.scene.sound.setRate(1);
            if (this.sound) {
                this.sound.stop();
            }
        };
        FastForward.prototype.destroy = function () {
            if (this.scene.sound.rate !== 1) {
                this.scene.sound.setRate(1);
            }
            this.scene.anims.globalTimeScale = 1;
            this.items = null;
        };
        return FastForward;
    }());
    game.FastForward = FastForward;
})(game || (game = {}));
var game;
(function (game) {
    var Turn = /** @class */ (function () {
        function Turn(scene) {
            this.isStarted = false;
            this.scene = scene;
        }
        Turn.prototype.start = function () {
            this.isStarted = true;
            this.startTimestamp = Date.now();
            this.ballsDropped = false;
            this.fastForwarded = false;
            this.points = 0;
            this.blocksKilledNum = 0;
            this.lightningsActivated = [];
            this.spinnersActivated = [];
            this.collectableBallsActivated = [];
            this.futureItems = [];
            this.pendingDestroyBlocks = [];
            this.pendingBoosters = [];
            this.ballsThrownNum = 0;
            this.ballsLandedNum = 0;
            this.firstLandedBall = null;
        };
        Turn.prototype.inProgress = function () {
            return this.isStarted === true;
        };
        Turn.prototype.checkComplete = function () {
            var report = this.getCompleteReport();
            return Object.values(report).every(function (value) { return value === true; });
        };
        Turn.prototype.getCompleteReport = function () {
            if (!this.isStarted) {
                return null;
            }
            var allBallsLanded = this.ballsLandedNum === this.ballsThrownNum;
            var allCollectablesLanded = this.collectableBallsActivated.every(function (ball) { return ball.isDestroyed; });
            var allFutureItemsReady = this.futureItems.length === 0;
            var allBlocksDestroyed = this.pendingDestroyBlocks.length === 0;
            var allBoostersComplete = this.pendingBoosters.length === 0;
            return {
                allBallsLanded: allBallsLanded,
                allCollectablesLanded: allCollectablesLanded,
                allFutureItemsReady: allFutureItemsReady,
                allBlocksDestroyed: allBlocksDestroyed,
                allBoostersComplete: allBoostersComplete,
            };
        };
        Turn.prototype.complete = function () {
            this.isStarted = false;
        };
        return Turn;
    }());
    game.Turn = Turn;
})(game || (game = {}));
var game;
(function (game) {
    var TutorialHand = /** @class */ (function (_super) {
        __extends(TutorialHand, _super);
        function TutorialHand(scene) {
            var _this = _super.call(this, scene, 0, 0) || this;
            _this.addLine();
            _this.addHand();
            _this.scene.events.once(game.GameplayEvent.TURN_START, _this.hide, _this);
            _this.scene.events.once(game.GameplayEvent.TURN_COMPLETE, _this.hide, _this);
            return _this;
        }
        TutorialHand.prototype.addLine = function () {
            this.line = this.scene.add.image(0, 0, "gameplay", "tutorial_line");
            this.add(this.line);
        };
        TutorialHand.prototype.addHand = function () {
            this.hand = this.scene.add.image(0, 0, "gameplay", "tutorial_hand");
            this.hand.y = this.line.y + this.hand.height * this.hand.originY - 4;
            this.hand.originalX = this.hand.x;
            this.hand.originalY = this.hand.y;
            this.hand.alpha = 0;
            this.add(this.hand);
        };
        TutorialHand.prototype.show = function (delay) {
            this.scene.tweens.add({
                targets: this,
                delay: delay,
                alpha: { start: 0, from: 0, to: 1, ease: Phaser.Math.Easing.Cubic.Out, duration: 200 },
                scale: { from: 0.8, to: 1, ease: Phaser.Math.Easing.Back.Out, duration: 400 },
                y: { from: this.y + 40, to: this.y, ease: Phaser.Math.Easing.Back.Out, duration: 500 },
            });
            this.playHandMoving(delay + 300);
        };
        TutorialHand.prototype.playHandMoving = function (initialDelay) {
            var _this = this;
            if (initialDelay === void 0) { initialDelay = 0; }
            if (!this.scene) {
                return;
            }
            var targetBlock = this.scene.items.find(function (item) { return game.ItemTypeUtil.isBlockType(item.itemType); });
            if (!targetBlock) {
                return;
            }
            this.hand.x = this.hand.originalX;
            this.hand.y = this.hand.originalY;
            this.hand.alpha = 0;
            this.hand.scale = 1;
            var rotation = Phaser.Math.Angle.BetweenPoints(targetBlock.getWorldPosition(), this.hand.getWorldPosition());
            var targetRotation = rotation - Math.PI / 2;
            var targetAngle = Phaser.Math.RadToDeg(targetRotation);
            this.hand.angle = targetAngle > 0 ? -35 : 44;
            this.handMoveTimeline = this.scene.tweens.timeline({
                tweens: [
                    {
                        delay: initialDelay,
                        targets: this.hand,
                        duration: 100,
                        ease: Phaser.Math.Easing.Linear.Linear,
                        alpha: 1,
                        completeDelay: 100,
                    },
                    {
                        targets: this.hand,
                        duration: 500,
                        ease: Phaser.Math.Easing.Linear.Linear,
                        rotation: targetRotation,
                        completeDelay: 100,
                    },
                    {
                        targets: this.hand,
                        duration: 300,
                        ease: Phaser.Math.Easing.Sine.InOut,
                        x: function () { return _this.getHandX(); },
                        y: function () { return _this.getHandY(); },
                        yoyo: true,
                        completeDelay: 200,
                    },
                    {
                        targets: this.hand,
                        duration: 200,
                        ease: Phaser.Math.Easing.Linear.Linear,
                        scale: 1.33,
                        alpha: 0,
                        completeDelay: 500,
                    },
                ],
                onComplete: this.playHandMoving.bind(this),
            });
        };
        TutorialHand.prototype.getTargetHandPosition = function () {
            var distance = 30;
            var angle = this.hand.rotation - Math.PI / 2;
            var targetX = this.hand.x + Math.cos(angle) * distance;
            var targetY = this.hand.y + Math.sin(angle) * distance;
            return { x: targetX, y: targetY };
        };
        TutorialHand.prototype.getHandX = function () {
            return this.getTargetHandPosition().x;
        };
        TutorialHand.prototype.getHandY = function () {
            return this.getTargetHandPosition().y;
        };
        TutorialHand.prototype.hide = function () {
            var _this = this;
            if (!this.scene) {
                return;
            }
            this.scene.tweens.add({
                targets: this,
                duration: 200,
                ease: Phaser.Math.Easing.Cubic.Out,
                alpha: 0,
                onComplete: function () {
                    _this.destroy();
                },
            });
        };
        TutorialHand.prototype.destroy = function (fromScene) {
            if (this.scene) {
                this.scene.tweens.killTweensOf(this);
                this.scene.tweens.killTweensOf(this.hand);
                this.scene.events.off(game.GameplayEvent.TURN_START, this.hide, this);
                this.scene.events.off(game.GameplayEvent.TURN_COMPLETE, this.hide, this);
            }
            if (this.handMoveTimeline) {
                this.handMoveTimeline.destroy();
                this.handMoveTimeline = null;
            }
            _super.prototype.destroy.call(this, fromScene);
        };
        return TutorialHand;
    }(Phaser.GameObjects.Container));
    game.TutorialHand = TutorialHand;
})(game || (game = {}));
var game;
(function (game) {
    var BlockHint = /** @class */ (function (_super) {
        __extends(BlockHint, _super);
        function BlockHint(scene) {
            var _this = _super.call(this, scene) || this;
            _this.scene = scene;
            _this.block = _this.scene.items.find(function (item) { return game.ItemTypeUtil.isBlockType(item.itemType); });
            _this.block.once(game.HealthEvent.KILL, _this.hide, _this);
            _this.addCircles();
            _this.show();
            return _this;
        }
        BlockHint.prototype.addCircles = function () {
            var _this = this;
            this.circles = _.times(10, function () {
                var circle = _this.scene.add.image(0, 0, "gameplay", "circle_fx");
                circle.kill();
                _this.add(circle);
                return circle;
            });
        };
        BlockHint.prototype.show = function () {
            this.showCircleEvent = this.scene.time.addEvent({
                loop: true,
                delay: 600,
                startAt: 400,
                callback: this.showCircle.bind(this),
            });
        };
        BlockHint.prototype.showCircle = function () {
            var circle = this.circles.find(function (circle) { return circle.visible === false; });
            if (circle) {
                circle.revive();
                circle.scale = 2;
                circle.alpha = 0;
                this.scene.tweens.add({
                    targets: circle,
                    duration: 1200,
                    alpha: { value: 0.4, ease: Phaser.Math.Easing.Expo.Out },
                    scale: { value: 0, ease: Phaser.Math.Easing.Linear },
                    onComplete: function () {
                        circle.kill();
                    },
                });
            }
        };
        BlockHint.prototype.hide = function () {
            this.block = null;
            this.destroy();
        };
        BlockHint.prototype.preUpdate = function (time, delta) {
            if (this.block) {
                this.x = this.block.x;
                this.y = this.block.y;
            }
        };
        BlockHint.prototype.destroy = function () {
            if (this.showCircleEvent) {
                this.showCircleEvent.destroy();
            }
        };
        return BlockHint;
    }(Phaser.GameObjects.Container));
    game.BlockHint = BlockHint;
})(game || (game = {}));
var game;
(function (game) {
    var PinataItemsFactoryEvent;
    (function (PinataItemsFactoryEvent) {
        PinataItemsFactoryEvent["ITEMS_READY"] = "PinataItemsFactory_ITEMS_READY";
    })(PinataItemsFactoryEvent = game.PinataItemsFactoryEvent || (game.PinataItemsFactoryEvent = {}));
    var PinataItemsFactory = /** @class */ (function (_super) {
        __extends(PinataItemsFactory, _super);
        function PinataItemsFactory(scene, grid, emitter) {
            var _this = _super.call(this) || this;
            _this.scene = scene;
            _this.grid = grid;
            _this.world = _this.scene.matter.world;
            _this.emitter = emitter;
            return _this;
        }
        PinataItemsFactory.prototype.createFromPinata = function (pinata) {
            var availableCells = this.getAvailableCells(pinata);
            var items = this.createItems(availableCells);
            if (items.length === 0) {
                this.emit(PinataItemsFactoryEvent.ITEMS_READY, []);
            }
            else {
                this.showItems(items);
            }
        };
        PinataItemsFactory.prototype.getAvailableCells = function (pinata) {
            var centerCell = this.grid.getCellAtXY(pinata.x, pinata.y);
            var neighbourCells = this.grid.getCellNeighbours(centerCell);
            return this.filterCells(neighbourCells);
        };
        PinataItemsFactory.prototype.filterCells = function (cells) {
            var _this = this;
            var bodiesToCheck = this.world.getAllBodies().filter(function (body) { return body.isStatic; });
            var notBusyByBodies = function (cell) { return cell && _this.grid.isCellFree(cell.column, cell.row, bodiesToCheck); };
            var notOnEdgeRows = function (cell) { return cell.row > 2; };
            var notBusyByFutureItems = function (cell) { return !_this.scene.turn.futureItems.some(function (item) { return item.column === cell.column && item.row === cell.row; }); };
            return cells
                .filter(notBusyByBodies)
                .filter(notOnEdgeRows)
                .filter(notBusyByFutureItems);
        };
        PinataItemsFactory.prototype.createItems = function (availableCells) {
            var _this = this;
            return availableCells.map(function (cell) {
                var item = _this.createItem(cell);
                _this.onItemCreate(item, cell);
                return item;
            });
        };
        PinataItemsFactory.prototype.showItems = function (items) {
            var _this = this;
            this.scene.tweens.add({
                targets: items,
                alpha: { from: 0, to: 1, ease: Phaser.Math.Easing.Cubic.Out, duration: 100 },
                scale: { from: 0.75, to: 1, ease: Phaser.Math.Easing.Back.Out, duration: 200 },
            }).on(Phaser.Tweens.Events.TWEEN_COMPLETE, function () {
                _this.onAllItemsReady(items);
            });
        };
        PinataItemsFactory.prototype.onAllItemsReady = function (items) {
            var _this = this;
            items.forEach(function (item) { return _this.onItemReady(item); });
            this.emit(PinataItemsFactoryEvent.ITEMS_READY, items.map(function (item) { return item.itemType; }));
        };
        PinataItemsFactory.prototype.createItem = function (cell) {
            var itemsGenerator = this.scene.generator.itemsGenerator;
            var itemType = itemsGenerator.getItemTypeForPinata();
            var itemParams = itemsGenerator.getItemParams(itemType, this.scene.levelConfig.generator.startRow, cell.row);
            return this.scene.factory.create(__assign({ itemType: itemType, column: cell.column, row: cell.row }, itemParams));
        };
        PinataItemsFactory.prototype.emitParticles = function (item) {
            this.emitter.explode(10, item.x, item.y);
        };
        PinataItemsFactory.prototype.onItemCreate = function (item, cell) {
            this.world.remove(item.body);
            this.addToFutureItems(item, cell);
            this.emitParticles(item);
            if (game.ItemTypeUtil.isBlock(item)) {
                item.health.invincible = true;
            }
        };
        PinataItemsFactory.prototype.addToFutureItems = function (item, cell) {
            this.scene.turn.futureItems.push({
                item: item,
                column: cell.column,
                row: cell.row,
            });
        };
        PinataItemsFactory.prototype.onItemReady = function (item) {
            this.removeFromFutureItems(item);
            this.world.add(item.body);
            this.scene.factory.postCreationCallback(item);
            if (game.ItemTypeUtil.isBlock(item)) {
                item.health.invincible = false;
            }
        };
        PinataItemsFactory.prototype.removeFromFutureItems = function (readyItem) {
            var index = this.scene.turn.futureItems.findIndex(function (futureItem) { return futureItem.item === readyItem; });
            if (index > -1) {
                this.scene.turn.futureItems.splice(index, 1);
            }
        };
        return PinataItemsFactory;
    }(Phaser.Events.EventEmitter));
    game.PinataItemsFactory = PinataItemsFactory;
})(game || (game = {}));
var game;
(function (game) {
    var ShatterPiecesFactoryEvent;
    (function (ShatterPiecesFactoryEvent) {
        ShatterPiecesFactoryEvent["ITEMS_READY"] = "ShatterPiecesFactoryEvent_ITEMS_READY";
    })(ShatterPiecesFactoryEvent = game.ShatterPiecesFactoryEvent || (game.ShatterPiecesFactoryEvent = {}));
    var ShatterPiecesFactory = /** @class */ (function (_super) {
        __extends(ShatterPiecesFactory, _super);
        function ShatterPiecesFactory(scene, grid) {
            var _this = _super.call(this) || this;
            _this.scene = scene;
            _this.grid = grid;
            _this.world = _this.scene.matter.world;
            return _this;
        }
        ShatterPiecesFactory.prototype.createFromParent = function (parentBlock) {
            var frames = game.ShatterBlockPiece.ALL_FRAMES;
            var cells = this.getAvailableCellsAround(parentBlock, frames);
            var pieces = this.createPieces(cells, frames);
            if (pieces.length > 0) {
                this.showPieces(parentBlock, pieces);
            }
            else {
                this.onAllPiecesReady(0);
            }
        };
        ShatterPiecesFactory.prototype.getAvailableCellsAround = function (parentBlock, frames) {
            var _this = this;
            var parentBlockColumn = parentBlock.grid.getColumn();
            var parentBlockRow = parentBlock.grid.getRow();
            return frames.map(function (frame) {
                var _a = _this.getPieceGridPositionByFrame(frame, parentBlockColumn, parentBlockRow), column = _a.x, row = _a.y;
                if (row < 3) {
                    return null;
                }
                var busyByFutureItem = _this.scene.turn.futureItems.findIndex(function (item) { return item.column === column && item.row === row; }) > -1;
                if (busyByFutureItem) {
                    return null;
                }
                var isCellFree = _this.grid.isCellFree(column, row);
                if (isCellFree === false) {
                    return null;
                }
                return _this.grid.getCellAt(row, column);
            });
        };
        ShatterPiecesFactory.prototype.getPieceGridPositionByFrame = function (frame, column, row) {
            var _a;
            var map = (_a = {},
                _a[game.ShatterBlockPiece.UP_FRAME] = { x: column, y: row + 1 },
                _a[game.ShatterBlockPiece.RIGHT_FRAME] = { x: column + 1, y: row },
                _a[game.ShatterBlockPiece.DOWN_FRAME] = { x: column, y: row - 1 },
                _a[game.ShatterBlockPiece.LEFT_FRAME] = { x: column - 1, y: row },
                _a);
            return map[frame];
        };
        ShatterPiecesFactory.prototype.createPieces = function (cells, frames) {
            var _this = this;
            var pieces = [];
            cells.forEach(function (cell, index) {
                if (!cell) {
                    return;
                }
                var piece = _this.createPiece(frames[index], cell.column, cell.row);
                _this.world.remove(piece.body);
                _this.addToFutureItems(piece, cell.row, cell.column);
                pieces.push(piece);
            });
            return pieces;
        };
        ShatterPiecesFactory.prototype.createPiece = function (frame, column, row) {
            var itemType = game.ItemType.SHATTER_BLOCK_PIECE;
            var itemParams = this.scene.generator.itemsGenerator.getItemParams(itemType, this.scene.levelConfig.generator.startRow, row);
            return this.scene.factory.create(__assign({ itemType: itemType,
                frame: frame,
                column: column,
                row: row }, itemParams));
        };
        ShatterPiecesFactory.prototype.showPieces = function (parentBlock, pieces) {
            var _this = this;
            var piecesReadyNum = 0;
            pieces.forEach(function (piece) {
                piece.alpha = 0;
                _this.scene.tweens.add({
                    targets: piece,
                    duration: 200,
                    alpha: 1,
                    ease: Phaser.Math.Easing.Cubic.Out,
                });
                var originalX = piece.x;
                var originalY = piece.y;
                _this.scene.factory.alignItemToGrid(piece, parentBlock.grid.getColumn(), parentBlock.grid.getRow());
                _this.scene.tweens.add({
                    targets: piece,
                    duration: 300,
                    ease: Phaser.Math.Easing.Back.Out,
                    x: originalX,
                    y: originalY,
                    onComplete: function () {
                        _this.onPieceReady(piece);
                        if (++piecesReadyNum === pieces.length) {
                            _this.onAllPiecesReady(pieces.length);
                        }
                    },
                });
            });
        };
        ShatterPiecesFactory.prototype.onPieceReady = function (piece) {
            this.removeFromFutureItems(piece);
            this.world.add(piece.body);
        };
        ShatterPiecesFactory.prototype.onAllPiecesReady = function (piecesNum) {
            this.emit(ShatterPiecesFactoryEvent.ITEMS_READY, Array(piecesNum).fill(game.ItemType.SHATTER_BLOCK));
        };
        ShatterPiecesFactory.prototype.addToFutureItems = function (item, row, column) {
            this.scene.turn.futureItems.push({
                item: item,
                column: column,
                row: row,
            });
        };
        ShatterPiecesFactory.prototype.removeFromFutureItems = function (readyItem) {
            var index = this.scene.turn.futureItems.findIndex(function (futureItem) { return futureItem.item === readyItem; });
            if (index > -1) {
                this.scene.turn.futureItems.splice(index, 1);
            }
        };
        return ShatterPiecesFactory;
    }(Phaser.Events.EventEmitter));
    game.ShatterPiecesFactory = ShatterPiecesFactory;
})(game || (game = {}));
var game;
(function (game) {
    var BlockKingEvent;
    (function (BlockKingEvent) {
        BlockKingEvent["JUMP_ON_FOX_COMPLETE"] = "BlockKing_JUMP_ON_FOX_COMPLETE";
    })(BlockKingEvent = game.BlockKingEvent || (game.BlockKingEvent = {}));
    var BlockKing = /** @class */ (function (_super) {
        __extends(BlockKing, _super);
        function BlockKing(scene) {
            var _this = _super.call(this, scene) || this;
            _this.name = BlockKing.NAME;
            _this.addBlock();
            _this.addFace();
            _this.addWhite();
            _this.addShadow();
            _this.addCrown();
            return _this;
        }
        BlockKing.prototype.addBlock = function () {
            this.block = this.scene.add.image(0, 0, "gameplay", "block_king/basic_block_01");
            this.block.setOrigin(0.5, 1);
            this.add(this.block);
        };
        BlockKing.prototype.addFace = function () {
            this.face = this.scene.add.image(0, 0, "gameplay", "block_king/basic_block_01_face_idle");
            this.face.setOrigin(0.5, 1);
            this.add(this.face);
        };
        BlockKing.prototype.addWhite = function () {
            this.blockWhite = this.scene.add.image(0, 0, "gameplay", "block_king/white_basic_block_01");
            this.blockWhite.setOrigin(0.5, 1);
            this.add(this.blockWhite);
        };
        BlockKing.prototype.addShadow = function () {
            this.shadow = this.scene.add.image(0, 0, "gameplay", "block_king/block_ground_shadow");
            this.shadow.x = 3;
            this.shadow.y = this.block.bottom;
            this.shadow.scaleX = 1.66;
            this.shadow.kill();
            this.addAt(this.shadow, 0);
        };
        BlockKing.prototype.addCrown = function () {
            this.crown = this.scene.add.image(0, 0, "gameplay", "block_king/crown");
            this.crown.setOrigin(0.5, 1);
            this.crown.y = this.block.top - 14;
            this.crown.kill();
            this.add(this.crown);
        };
        BlockKing.prototype.jumpOnFox = function (foxX, foxY) {
            var _this = this;
            this.alpha = 0;
            this.scale = 1.5;
            this.blockWhite.alpha = 0.77;
            this.scene.tweens.add({
                targets: this.blockWhite,
                duration: 1000,
                ease: Phaser.Math.Easing.Cubic.Out,
                alpha: 0,
            });
            this.scene.tweens.add({
                targets: this,
                duration: 200,
                ease: Phaser.Math.Easing.Cubic.Out,
                alpha: 1,
            });
            this.scene.tweens.add({
                targets: this,
                duration: 400,
                ease: Phaser.Math.Easing.Back.Out,
                scale: 1,
                y: this.y - 250,
                completeDelay: 100,
                onComplete: function () {
                    _this.doJumpOnFox(foxX, foxY);
                },
            });
        };
        BlockKing.prototype.doJumpOnFox = function (foxX, foxY) {
            if (this.scene.cache.audio.has(game.GameSoundKey.BLOCK_STOMP_WHOOSH)) {
                this.scene.sound.play(game.GameSoundKey.BLOCK_STOMP_WHOOSH, { volume: 0.75, delay: 0.24 });
            }
            this.scene.tweens.add({
                targets: this,
                duration: 200,
                ease: Phaser.Math.Easing.Sine.InOut,
                angle: this.angle - 15,
                yoyo: true,
            });
            this.scene.tweens.add({
                targets: this,
                duration: 500,
                ease: Phaser.Math.Easing.Back.In,
                x: foxX,
                y: foxY,
                onComplete: this.onJumpComplete.bind(this),
            });
        };
        BlockKing.prototype.onJumpComplete = function () {
            this.shadow.revive();
            this.playIdleTweens();
            this.showBlinkFrame();
            this.showCrown(500);
            this.emit(BlockKingEvent.JUMP_ON_FOX_COMPLETE, this);
        };
        BlockKing.prototype.playIdleTweens = function () {
            if (!this.scene) {
                return;
            }
            this.scene.tweens.add({
                targets: [this.block, this.face],
                duration: 600,
                ease: Phaser.Math.Easing.Sine.InOut,
                scaleX: 1.04,
                scaleY: 0.9,
                yoyo: true,
                repeat: -1,
            });
            this.scene.tweens.add({
                targets: this.crown,
                duration: 600,
                ease: Phaser.Math.Easing.Sine.InOut,
                y: "+=12",
                yoyo: true,
                repeat: -1,
            });
        };
        BlockKing.prototype.showBlinkFrame = function () {
            var _this = this;
            this.face.setFrame("block_king/basic_block_01_face_blink");
            this.face.setOrigin(0.5, 1);
            this.scene.time.delayedCall(600, function () {
                _this.face.setFrame("block_king/basic_block_01_face_idle");
                _this.face.setOrigin(0.5, 1);
            });
        };
        BlockKing.prototype.showCrown = function (delay) {
            this.crown.revive();
            this.crown.alpha = 0;
            this.crown.scale = 0.8;
            this.scene.tweens.add({
                delay: delay,
                targets: this.crown,
                duration: 150,
                ease: Phaser.Math.Easing.Cubic.Out,
                alpha: 1,
            });
            this.scene.tweens.add({
                delay: delay,
                targets: this.crown,
                duration: 1000,
                ease: Phaser.Math.Easing.Elastic.Out,
                easeParams: [0.1, 0.4],
                scale: 1,
            });
        };
        BlockKing.prototype.destroy = function (fromScene) {
            if (this.scene) {
                this.scene.tweens.killTweensOf([this.crown, this.block, this.face]);
            }
            _super.prototype.destroy.call(this, fromScene);
        };
        BlockKing.NAME = "block_king";
        return BlockKing;
    }(Phaser.GameObjects.Container));
    game.BlockKing = BlockKing;
})(game || (game = {}));
var game;
(function (game) {
    var LoseTutorialPopover = /** @class */ (function (_super) {
        __extends(LoseTutorialPopover, _super);
        function LoseTutorialPopover(scene) {
            var _this = _super.call(this, scene) || this;
            _this.name = "lose_tutorial_popover";
            _this.addBack();
            _this.addSign();
            _this.addText();
            return _this;
        }
        LoseTutorialPopover.prototype.addBack = function () {
            this.back = this.scene.add.image(0, 0, "gameplay", "warning_popover");
            this.add(this.back);
        };
        LoseTutorialPopover.prototype.addSign = function () {
            this.sign = this.scene.add.image(0, 0, "gameplay", "warning_sign");
            this.sign.x = this.back.left + 16;
            this.sign.y = this.back.top + 12;
            this.add(this.sign);
        };
        LoseTutorialPopover.prototype.addText = function () {
            var content = this.scene.texts.lose_warning;
            var style = {
                fontFamily: game.GameFont.DEFAULT,
                fontStyle: game.FontWeight.BOLD,
                fontSize: "24px",
                color: "#205466",
                align: "center",
            };
            var maxHeight = 100;
            this.text = this.scene.add.text(0, 0, content, style);
            this.text.setWordWrapWidth(265);
            this.text.setOrigin(0.5, 0.5);
            this.text.scale = Math.min(1, maxHeight / this.text.height);
            this.text.y = -74;
            this.add(this.text);
        };
        return LoseTutorialPopover;
    }(Phaser.GameObjects.Container));
    game.LoseTutorialPopover = LoseTutorialPopover;
})(game || (game = {}));
///<reference path='LoseTutorialPopover.ts' />
var game;
(function (game) {
    var LoseTutorial = /** @class */ (function (_super) {
        __extends(LoseTutorial, _super);
        function LoseTutorial(scene) {
            var _this = _super.call(this) || this;
            _this.scene = scene;
            _this.addPopover();
            _this.showPopover();
            _this.timerEvent = _this.scene.time.delayedCall(2000, _this.addPointerListeners, null, _this);
            _this.scene.events.once(Phaser.Scenes.Events.SHUTDOWN, _this.onSceneShutdown, _this);
            _this.scene.events.once(game.GameplayEvent.TURN_START, _this.onTurnStart, _this);
            return _this;
        }
        LoseTutorial.prototype.addPopover = function () {
            this.popover = new game.LoseTutorialPopover(this.scene);
            this.popover.x = this.scene.getFieldWidth() / 2;
            this.popover.y = this.scene.warningLine.y - 10;
            this.popover.setDepth(game.GameplayDepth.LOSE_TUTORIAL);
            this.scene.add.existing(this.popover);
        };
        LoseTutorial.prototype.showPopover = function () {
            this.popover.alpha = 0;
            this.scene.tweens.add({
                targets: this.popover,
                duration: 150,
                ease: Phaser.Math.Easing.Cubic.Out,
                alpha: 1,
            });
            this.popover.scale = 0.8;
            this.scene.tweens.add({
                targets: this.popover,
                duration: 400,
                ease: Phaser.Math.Easing.Back.Out,
                easeParams: [1.6],
                scale: 1,
            });
        };
        LoseTutorial.prototype.hideTutorial = function () {
            var _this = this;
            this.scene.game.store.saveValue(game.GameStoreKey.LOSE_TUTORIAL_COMPLETE, true);
            this.scene.tweens.killTweensOf(this.popover);
            this.scene.tweens.add({
                targets: this.popover,
                y: "-15",
                duration: 200,
                ease: Phaser.Math.Easing.Cubic.Out,
                alpha: 0,
                onComplete: function () {
                    _this.popover.destroy();
                },
            });
        };
        LoseTutorial.prototype.onPointerDown = function () {
            this.scene.events.off(game.GameplayEvent.TURN_START, this.onTurnStart, this);
            this.removePointerListeners();
            this.hideTutorial();
        };
        LoseTutorial.prototype.onPointerMove = function (pointer) {
            if (pointer.isDown) {
                this.scene.events.off(game.GameplayEvent.TURN_START, this.onTurnStart, this);
                this.removePointerListeners();
                this.hideTutorial();
            }
        };
        LoseTutorial.prototype.addPointerListeners = function () {
            this.scene.input.once(Phaser.Input.Events.POINTER_DOWN, this.onPointerDown, this);
            this.scene.input.once(Phaser.Input.Events.POINTER_MOVE, this.onPointerMove, this);
        };
        LoseTutorial.prototype.removePointerListeners = function () {
            this.scene.input.off(Phaser.Input.Events.POINTER_DOWN, this.onPointerDown, this);
            this.scene.input.off(Phaser.Input.Events.POINTER_MOVE, this.onPointerMove, this);
        };
        LoseTutorial.prototype.onTurnStart = function () {
            this.timerEvent.remove();
            this.removePointerListeners();
            this.hideTutorial();
        };
        LoseTutorial.prototype.onSceneShutdown = function () {
            this.removePointerListeners();
            this.scene.events.off(game.GameplayEvent.TURN_START, this.onTurnStart, this);
            this.timerEvent.remove();
            this.scene = null;
        };
        return LoseTutorial;
    }(Phaser.Events.EventEmitter));
    game.LoseTutorial = LoseTutorial;
})(game || (game = {}));
///<reference path='../../robowhale/phaser3/gameObjects/trail/Trail.ts' />
///<reference path='../../robowhale/phaser3/gameObjects/trail/TrailsCanvas.ts' />
///<reference path='fox/Fox.ts' />
///<reference path='fox/FoxTalkBubble.ts' />
///<reference path='fox/ThrownFox.ts' />
///<reference path='trajectory/Trajectory.ts' />
///<reference path='ball/Ball.ts' />
///<reference path='ball/BallChargedEmitter.ts' />
///<reference path='ball/BallSpinnedEmitter.ts' />
///<reference path='ball/idleBall/IdleBallsAligner.ts' />
///<reference path='ball/idleBall/IdleBall.ts' />
///<reference path='ball/idleBall/IdleBallShadow.ts' />
///<reference path='ball/WinningBall.ts' />
///<reference path='ball/LosingBall.ts' />
///<reference path='grid/GameGrid.ts' />
///<reference path='grid/GridWalls.ts' />
///<reference path='items/GameItem.ts' />
///<reference path='items/lightning/Lightning.ts' />
///<reference path='items/spinner/Spinner.ts' />
///<reference path='items/spinner/SpinnerIdleEmitter.ts' />
///<reference path='items/blocks/BasicBlock.ts' />
///<reference path='items/blocks/common/BlockShadow.ts' />
///<reference path='items/blocks/common/BlockFace.ts' />
///<reference path='items/blocks/common/BlockWhiteCopy.ts' />
///<reference path='items/blocks/common/BlockRedCopy.ts' />
///<reference path='items/blocks/common/BlockHealthCounter.ts' />
///<reference path='items/blocks/TriangleBlock.ts' />
///<reference path='items/blocks/IceBlock.ts' />
///<reference path='items/blocks/RotatingIceBlock.ts' />
///<reference path='items/blocks/DynamiteBlock.ts' />
///<reference path='items/blocks/PinataBlock.ts' />
///<reference path='items/blocks/ShatterBlock.ts' />
///<reference path='items/blocks/ShatterBlockPiece.ts' />
///<reference path='items/ItemType.ts' />
///<reference path='items/CollectableBall.ts' />
///<reference path='items/components/GridComponent.ts' />
///<reference path='items/components/HealthComponent.ts' />
///<reference path='items/components/KillTweens.ts' />
///<reference path='items/components/IActiveable.ts' />
///<reference path='items/components/HideComponent.ts' />
///<reference path='CollisionTag.ts' />
///<reference path='GameplayDepth.ts' />
///<reference path='ball/BallCharged.ts' />
///<reference path='generator/LevelGenerator.ts' />
///<reference path='fx/Explosion.ts' />
///<reference path='fx/BlockDamageFx.ts' />
///<reference path='fx/PlusBallFx.ts' />
///<reference path='fx/levelComplete/LevelCompleteFx.ts' />
///<reference path='fx/DustCloud.ts' />
///<reference path='fx/ClearFieldFx.ts' />
///<reference path='fx/TurnCompleteFx.ts' />
///<reference path='systems/GameplayEmitters.ts' />
///<reference path='systems/GameplayPhysics.ts' />
///<reference path='systems/GameplayAnimationPools.ts' />
///<reference path='systems/GameplayPools.ts' />
///<reference path='systems/GameplayItemsFactory.ts' />
///<reference path='systems/GameplayCamera.ts' />
///<reference path='systems/GameplayWorldCopy.ts' />
///<reference path='systems/GameplayAudio.ts' />
///<reference path='boosters/GameplayBoosters.ts' />
///<reference path='systems/SecondChance.ts' />
///<reference path='FastForward.ts' />
///<reference path='Turn.ts' />
///<reference path='tutorial/TutorialHand.ts' />
///<reference path='tutorial/BlockHint.ts' />
///<reference path='PinataItemsFactory.ts' />
///<reference path='ShatterPiecesFactory.ts' />
///<reference path='BlockKing.ts' />
///<reference path='tutorial/LoseTutorial.ts' />
var game;
(function (game) {
    var Distance = Phaser.Math.Distance;
    var ButtonEvent = Phaser.GameObjects.ButtonEvent;
    var GameplayEvent;
    (function (GameplayEvent) {
        GameplayEvent["TURN_START"] = "Gameplay_TURN_START";
        GameplayEvent["TURN_COMPLETE"] = "Gameplay_TURN_COMPLETE";
        GameplayEvent["TURN_FULLY_COMPLETE"] = "Gameplay_TURN_FULLY_COMPLETE";
        GameplayEvent["FAST_FORWARD_START"] = "Gameplay_FAST_FORWARD_START";
    })(GameplayEvent = game.GameplayEvent || (game.GameplayEvent = {}));
    var Gameplay = /** @class */ (function (_super) {
        __extends(Gameplay, _super);
        function Gameplay() {
            return _super.call(this, {
                physics: game.GameplayRoot.getPhysicsConfig(),
            }) || this;
        }
        Gameplay.prototype.init = function (levelConfig) {
            this.levelConfig = levelConfig;
            this.levelNumber = this.levelConfig.levelNumber;
            this.isPointerDown = false;
            this.isMoveDownLocked = false;
            this.isGameplayStopped = false;
            this.physicsShapes = this.cache.json.get("physics");
            this.balls = [];
            this.items = [];
            this.levelData = this.createLevelData();
            this.initAnimationPools();
            this.gui = null;
            this.camera = null;
            this.worldCopy = null;
            this.audio = null;
            this.boosters = null;
            this.secondChance = null;
            this.events.once("shutdown", this.shutdown, this);
            this.analytics.sendLevelStart(this.levelNumber);
            this.poki.sdk.gameplayStart();
            this.game.raven.addExtraContext({ level: this.levelNumber });
        };
        Gameplay.prototype.create = function () {
            this.generator = new game.LevelGenerator(this, this.levelConfig);
            this.camera = new game.GameplayCamera(this);
            this.factory = new game.GameplayItemsFactory(this);
            this._physics = new game.GameplayPhysics(this);
            this.pools = new game.GameplayPools(this);
            this.emitters = new game.GameplayEmitters(this);
            this.fastForward = new game.FastForward(this);
            this.turn = new game.Turn(this);
            this.worldCopy = new game.GameplayWorldCopy(this);
            this.audio = new game.GameplayAudio(this);
            this.secondChance = new game.SecondChance(this);
            this.addGrid();
            this.addGridWalls();
            this.addInitialItems();
            this.addFox();
            this.addFoxTalkBubble();
            this.addBallTrails();
            this.addIdleBalls(this.levelConfig.balls);
            this.addBalls(this.levelConfig.balls);
            this.addTrajectory();
            this.addTutorial();
            this.addWarningLine();
            this.addTurnCompleteFx();
            this.addLevelCompleteFx();
            this.idleBallsAligner = new game.IdleBallsAligner(this);
            this.idleBallsAligner.placeIdleBallsAroundInstant(this.idleBalls, this.fox.x);
            this.sleepItems();
            this.autoThrow();
        };
        Gameplay.prototype.testTurnCompleteAnimations = function () {
            var _this = this;
            this.hideRemainingItems();
            this.time.addEvent({
                loop: true,
                delay: 4000,
                startAt: 3700,
                callback: function () {
                    var blocksKilled = Phaser.Math.RND.between(3, 10);
                    var points = Phaser.Math.RND.between(100, 10000);
                    var clearBonus = Phaser.Math.RND.bool();
                    _this.showTurnCompleteFx(blocksKilled, points, clearBonus);
                },
            });
        };
        Gameplay.prototype.addItem = function (item) {
            item.on(game.GameItemEvent.PRE_DESTROY, this.onItemPreDestroy, this);
            this.items.push(item);
        };
        Gameplay.prototype.onItemPreDestroy = function (item, fromScene) {
            if (fromScene === true) {
                // scene was shutdown so we don't have handle this event
                return;
            }
            _.pull(this.items, item);
            this.tryToDropBalls();
        };
        Gameplay.prototype.onDynamiteBlockExplode = function (explosive) {
            this.showExplosion(explosive.x, explosive.y, 1.5);
            this.damageNearbyBlocks(explosive);
            this.audio.explosion();
            this.cameras.main.shake(500, 0.011, true);
        };
        Gameplay.prototype.onLightningDestroy = function (lightning) {
            // this.emitters.lightning.explode(10, lightning.x, lightning.y)
            this.animsPools.lightnings.recycleActive(lightning.animation);
        };
        Gameplay.prototype.onBlockDamage = function (block, damage) {
            this.showDamageValueFx(damage, block);
            this.turn.points += damage;
            if (this.levelNumber === 1) {
                this.audio.blockHit();
            }
        };
        Gameplay.prototype.onBlockKill = function (block) {
            block.once(Phaser.GameObjects.Events.DESTROY, this.onBlockDestroy, this);
            block.setDepth(block.wasHitByCracker ? game.GameplayDepth.HIT_BY_CRACKER : game.GameplayDepth.DEAD_BLOCKS);
            this.turn.pendingDestroyBlocks.push(block);
            this.turn.blocksKilledNum++;
            var isTargetItemType = this.isTargetItemType(block.itemType);
            if (isTargetItemType) {
                this.levelData.targetBlocksKilled++;
                this.showCollectedBlockFx(block);
            }
        };
        Gameplay.prototype.onBlockDestroy = function (block) {
            var index = this.turn.pendingDestroyBlocks.indexOf(block);
            if (index > -1) {
                this.turn.pendingDestroyBlocks.splice(index, 1);
                if (this.turn.pendingDestroyBlocks.length === 0) {
                    this.checkTurnComplete();
                }
            }
            var blockType = block.itemType;
            if (blockType === game.ItemType.PINATA_BLOCK || blockType === game.ItemType.DYNAMITE_BLOCK) {
                return;
            }
            var isTargetItemType = this.isTargetItemType(blockType);
            if (isTargetItemType) {
                if (blockType === game.ItemType.SHATTER_BLOCK) {
                    this.showItemDestroyFx(block.x, block.y);
                }
                return;
            }
            this.showItemDestroyFx(block.x, block.y);
        };
        Gameplay.prototype.showItemDestroyFx = function (x, y) {
            this.emitters.blockKill.explode(1, x, y);
            this.emitters.blockKillParticles.setPosition(x, y);
            this.emitters.blockKillParticles.explode(8, x, y);
        };
        Gameplay.prototype.addBlockWhiteCopy = function (block) {
            var copy = this.pools.blockWhiteCopies.getFirstDead(true);
            copy.setBlock(block);
            return copy;
        };
        Gameplay.prototype.addBlockHealthCounter = function (block) {
            var counter = this.pools.blockHealthCounters.getFirstDead(true);
            counter.revive();
            counter.setBlock(block);
            return counter;
        };
        Gameplay.prototype.onBallSpinnerTouched = function (ball, spinner) {
            var ballWasSpinned = spinner.spinnedBalls.some(function (spinnedBall) { return spinnedBall.ball === ball; });
            if (ballWasSpinned) {
                return;
            }
            spinner.spinnedBalls.push({ ball: ball, timestamp: this.game.getTime() });
            spinner.activate();
            ball.spin();
            this.audio.spinner();
            this.emitters.spinner.setPosition(spinner.x, spinner.y);
            this.emitters.spinner.explode(10, spinner.x, spinner.y);
            this.turn.spinnersActivated.push(spinner);
            this.tryToDropBalls();
        };
        Gameplay.prototype.onBallLightningTouched = function (ball, lightning) {
            if (lightning.wasActivated === false) {
                this.turn.lightningsActivated.push(lightning);
            }
            if (ball.isCharged === false) {
                ball.setCharge();
                this.emitters.lightning.setPosition(lightning.x, lightning.y);
                this.emitters.lightning.explode(10, lightning.x, lightning.y);
                this.audio.lightning();
            }
            lightning.activate();
            this.tryToDropBalls();
        };
        Gameplay.prototype.onBallFloorCollide = function (ball, floor) {
            ball.onTouchedTheFloor();
            this.showIdleBall(ball.x);
            this.audio.ballHit();
            if (this.turn.firstLandedBall === null) {
                this.turn.firstLandedBall = ball;
                this.turn.firstLandedBallMark = ball.x;
            }
        };
        Gameplay.prototype.onBallWallsCollide = function (ball, wall, pair) {
            var contactPoint = this._physics.world.getContactPoint(pair);
            this.emitFeathers(1, contactPoint.x, contactPoint.y);
            this.audio.ballHit();
        };
        Gameplay.prototype.onBallBlocksCollide = function (ball, block, pair) {
            this.audio.ballHit();
            block.health.damage(ball.damage);
            if (ball.isCharged) {
                block.zap();
            }
            else {
                var contactPoint = this._physics.world.getContactPoint(pair);
                this.emitFeathers(2, contactPoint.x, contactPoint.y);
            }
        };
        Gameplay.prototype.onBlockZap = function (block) {
            this.emitters.zappedBlock.setPosition(block.x, block.y);
            this.emitters.zappedBlock.explode(4, block.x, block.y);
            this.audio.blockZap();
        };
        Gameplay.prototype.onCollectableBallHit = function (collectable, ball, pair) {
            collectable.state = "hit_by_ball";
            collectable.setDepth(game.GameplayDepth.DROPPED_COLLECTABLE_BALLS);
            collectable.startFalling();
            collectable.setCollidesWith([this._physics.collisionCategories.floor, this._physics.collisionCategories.walls]);
            collectable.setVelocityX(ball.body.velocity.x / 2);
            var contactPoint = this._physics.world.getContactPoint(pair);
            this.emitters.collectableBallFeathers.setPosition(contactPoint.x, contactPoint.y);
            this.emitters.collectableBallFeathers.explode(25, contactPoint.x, contactPoint.y);
            this.turn.collectableBallsActivated.push(collectable);
            this.audio.collectableBallHit();
        };
        Gameplay.prototype.onCollectableBallLand = function (collectable, floor, pair) {
            collectable.state = "landed";
            var contactPoint = this._physics.world.getContactPoint(pair);
            this.emitters.feathers.explode(6, contactPoint.x, contactPoint.y);
            this.addIdleBall(collectable.x);
            this.showPlusBallFx(collectable);
            collectable.destroy();
            this.addBall();
            this.gui.ballsLabel.updateNum(this.balls.length);
            this.audio.collectableBallLand();
            this.checkTurnComplete();
        };
        Gameplay.prototype.removePointerCallbacks = function () {
            this.input.off("pointerdown", this.onPointerDown, this);
            this.input.off("pointerup", this.onPointerUp, this);
            this.input.off(Phaser.Input.Events.POINTER_UP_OUTSIDE, this.onPointerUp, this);
            this.gui.input.off("pointerup", this.onPointerUp, this);
        };
        Gameplay.prototype.addPointerCallbacks = function () {
            this.input.on("pointerdown", this.onPointerDown, this);
            this.input.on("pointerup", this.onPointerUp, this);
            this.input.on(Phaser.Input.Events.POINTER_UP_OUTSIDE, this.onPointerUp, this);
            this.gui.input.on("pointerup", this.onPointerUp, this);
        };
        Gameplay.prototype.getThrowRotation = function (startPosition, endPosition) {
            return Phaser.Math.Angle.Between(startPosition.x, startPosition.y, endPosition.x, endPosition.y);
        };
        Gameplay.prototype.doResize = function () {
            // we can't properly resize gameplay until gui is ready
            if (this.gui && this.camera) {
                this.camera.resize();
            }
        };
        Gameplay.prototype.getFieldWidth = function () {
            return game.GameGrid.CELL_SIZE * game.GameGrid.COLUMNS;
        };
        Gameplay.prototype.getFieldHeight = function () {
            return game.GameGrid.CELL_SIZE * (game.GameGrid.ROWS + 1) - game.GameGrid.CELL_SIZE / 2;
        };
        Gameplay.prototype.onGuiCreated = function () {
            this.gui.fastForwardButton.kill();
            this.gui.fastForwardButton.on(Phaser.GameObjects.ButtonEvent.PRESS, this.onFastForwardButtonClick, this);
            this.gui.dropBallsButton.kill();
            this.gui.dropBallsButton.on(Phaser.GameObjects.ButtonEvent.PRESS, this.dropBallsToFloorByKey, this);
            this.addBoosters();
            this.addPointerCallbacks();
            this.addKeyboardCallbacks();
        };
        Gameplay.prototype.addBoosters = function () {
            this.boosters = new game.GameplayBoosters(this, this.gui);
            this.boosters.on(game.GameplayBoostersEvent.ACTIVATE, this.onBoosterActivate, this);
            this.boosters.on(game.GameplayBoostersEvent.COMPLETE, this.onBoosterComplete, this);
        };
        Gameplay.prototype.onBoosterActivate = function (booster) {
            if (booster.type === game.BoosterType.STOP) {
                this.isMoveDownLocked = true;
            }
        };
        Gameplay.prototype.onBoosterComplete = function (booster) {
            if (booster.type === game.BoosterType.STOP) {
                this.isMoveDownLocked = false;
            }
        };
        Gameplay.prototype.onPinataDestroyed = function (pinata) {
            var factory = new game.PinataItemsFactory(this, this.grid, this.emitters.newPinataItem);
            factory.once(game.PinataItemsFactoryEvent.ITEMS_READY, this.onPinataItemsReady, this);
            factory.createFromPinata(pinata);
            this.emitters.pinataConfetti.explode(40, pinata.x, pinata.y);
            this.emitters.pinata.explode(1, pinata.x, pinata.y);
            this.audio.pinata();
            this.cameras.main.shake(300, 0.006, true);
        };
        Gameplay.prototype.onPinataItemsReady = function (newItemTypes) {
            this.adjustTargetItemsNum(newItemTypes);
            this.checkTurnComplete();
        };
        Gameplay.prototype.onShatterBlockShatter = function (shatterBlock) {
            var factory = new game.ShatterPiecesFactory(this, this.grid);
            factory.once(game.ShatterPiecesFactoryEvent.ITEMS_READY, this.onShatterPiecesReady, this);
            factory.createFromParent(shatterBlock);
            if (this.cache.audio.has(game.GameSoundKey.BLOCK_COLLECTED_WHOOSH)) {
                this.sound.play(game.GameSoundKey.BLOCK_COLLECTED_WHOOSH, { volume: 1 });
            }
        };
        Gameplay.prototype.onShatterPiecesReady = function (newItemTypes) {
            this.adjustTargetItemsNum(newItemTypes);
            this.checkTurnComplete();
        };
        Gameplay.prototype.update = function (time, delta) {
            this._physics.update(delta);
            this.updateTrajectory();
            this.updateWarningLine(delta);
        };
        Gameplay.prototype.updateTrajectory = function () {
            if (this.isPointerDown) {
                if (this.trajectory.visible === false && this.turn.inProgress() === false) {
                    this.fox.play(game.FoxAnimation.AIM, true);
                    this.trajectory.show();
                }
            }
            else {
                if (this.trajectory.visible) {
                    if (this.fox.anims.getCurrentKey() !== game.FoxAnimation.SHOT) {
                        this.fox.play(game.FoxAnimation.IDLE, true);
                    }
                    this.trajectory.hide();
                }
            }
        };
        Gameplay.prototype.updateWarningLine = function (delta) {
            if (this.warningLine.visible) {
                this.warningLine.tilePositionX -= delta * 0.035;
            }
        };
        Gameplay.prototype.addBlockFace = function (block) {
            var facelessBlocks = [game.ItemType.SHATTER_BLOCK, game.ItemType.SHATTER_BLOCK_PIECE];
            if (facelessBlocks.includes(block.itemType)) {
                return;
            }
            var face = new game.BlockFace(this, block);
            face.setDepth(game.GameplayDepth.BLOCK_FACES);
            this.add.existing(face);
        };
        Gameplay.prototype.addLightningIdleEmitter = function (lightning) {
            var actualEmitter = this.emitters.createLightningIdleEmitter();
            var emitter = new game.LightningIdleEmitter(this, lightning, actualEmitter);
        };
        Gameplay.prototype.addSpinnerIdleEmitter = function (spinner) {
            var actualEmitter = this.emitters.createSpinnerIdleEmitter(spinner);
            var emitter = new game.SpinnerIdleEmitter(this, spinner, actualEmitter);
        };
        Gameplay.prototype.addIceBlockEmitter = function (iceBlock) {
            var emitter = this.emitters.createIceBlockEmitter(iceBlock);
            iceBlock.on(game.HideEvent.START, emitter.remove, emitter);
            iceBlock.on(game.HealthEvent.KILL, function () {
                emitter.remove();
            });
            iceBlock.on(Phaser.GameObjects.Events.DESTROY, function () {
                emitter.remove();
            });
        };
        Gameplay.prototype.addCollectableBallEmitter = function (ball) {
            var emitter = this.emitters.createCollectableBallEmitter(ball);
            ball.on(game.CollectableBallEvent.ACTIVATE, function () {
                emitter.on = true;
            });
            ball.on(game.HideEvent.START, function () {
                emitter.remove();
            });
            ball.on(game.CollectableBallEvent.START_FALL, function () {
                emitter.remove();
            });
            ball.on(Phaser.GameObjects.Events.DESTROY, function () {
                emitter.remove();
            });
        };
        Gameplay.prototype.onBlockStartStomping = function (block) {
            block.setDepth(game.GameplayDepth.STOMPING_BLOCKS);
            this.showRedCopy(block);
        };
        Gameplay.prototype.onBlockStopStomping = function (block) {
            block.setDepth(game.GameplayDepth.ITEMS);
        };
        Gameplay.prototype.createLevelData = function () {
            return {
                turnsNum: 0,
                points: 0,
                targetBlocksKilled: 0,
                targetBlocksRequired: this.levelConfig.generator.targetItemsNum,
            };
        };
        Gameplay.prototype.initAnimationPools = function () {
            if (!this.animsPools) {
                this.animsPools = new game.GameplayAnimationPools(this);
            }
        };
        Gameplay.prototype.addGrid = function () {
            this.grid = new game.GameGrid(this, game.GameGrid.COLUMNS, game.GameGrid.ROWS);
            this.grid.alpha = 0.5;
            this.grid.setDepth(game.GameplayDepth.GRID);
        };
        Gameplay.prototype.addGridWalls = function () {
            this.gridWalls = new game.GridWalls(this, this.grid.getWidth(), this.grid.getHeight());
            this.gridWalls.top.collisionFilter.category = this._physics.collisionCategories.ceiling;
            this.gridWalls.right.collisionFilter.category = this._physics.collisionCategories.walls;
            this.gridWalls.bottom.collisionFilter.category = this._physics.collisionCategories.floor;
            this.gridWalls.left.collisionFilter.category = this._physics.collisionCategories.walls;
            this.gridWalls.align(this.grid);
        };
        Gameplay.prototype.addInitialItems = function () {
            var _this = this;
            this.generator.getInitialItems(game.GameGrid.ROWS - 1).map(function (itemConfig) {
                var newItem = _this.factory.create(__assign({ itemType: itemConfig.type, row: itemConfig.row, column: itemConfig.column }, itemConfig.config));
                _this.factory.postCreationCallback(newItem);
            });
        };
        Gameplay.prototype.addFox = function () {
            this.fox = new game.Fox(this);
            this.fox.x = this.grid.x + this.grid.getWidth() / 2;
            this.fox.y = this.grid.y + this.grid.getHeight();
            this.add.existing(this.fox);
        };
        Gameplay.prototype.addFoxTalkBubble = function () {
            this.foxTalkBubble = new game.FoxTalkBubble(this);
            this.foxTalkBubble.kill();
            this.add.existing(this.foxTalkBubble);
        };
        Gameplay.prototype.showFoxTalkBubble = function () {
            this.foxTalkBubble.x = this.fox.x - 66;
            this.foxTalkBubble.y = this.fox.y - 134;
            this.foxTalkBubble.revive();
            this.foxTalkBubble.show();
        };
        Gameplay.prototype.addBallTrails = function () {
            var options = {
                color: 0xfaf1bf,
                alpha: 0.44,
                length: 8,
                accuracy: 12,
            };
            this.ballTrails = new game.TrailsCanvas(this, options);
            this.ballTrails.setDepth(game.GameplayDepth.BALL_TRAILS);
            this.ballTrails.kill();
            this.add.existing(this.ballTrails);
        };
        Gameplay.prototype.addIdleBalls = function (ballsNum) {
            var _this = this;
            this.idleBalls = _.times(ballsNum, function () {
                var idleBall = _this.pools.idleBalls.pop();
                idleBall.y = _this.getIdleBallPositionY();
                idleBall.show();
                return idleBall;
            });
        };
        Gameplay.prototype.addBalls = function (ballsNum) {
            var _this = this;
            _.times(ballsNum, function () {
                _this.addBall();
            });
        };
        Gameplay.prototype.addBall = function () {
            var options = {
                depth: game.GameplayDepth.BALLS,
                subDepth: this.balls.length,
                worldBounds: this.getWorldBounds(),
                collisionGroup: this._physics.collisionGroups.balls,
                collisionCategory: this._physics.collisionCategories.balls,
            };
            var ball = new game.Ball(this, options);
            ball.kill();
            ball.setPosition(this.grid.getWidth() / 2, this.grid.getHeight());
            this.add.existing(ball);
            this.balls.push(ball);
            this.createBallChargedEmitter(ball);
            // this.createBallSpinnedEmitter(ball)
            this.ballTrails.addTrail(ball);
            return ball;
        };
        Gameplay.prototype.getWorldBounds = function () {
            return new Phaser.Geom.Rectangle(0, 0, this.grid.getWidth(), this.grid.getHeight());
        };
        Gameplay.prototype.addTrajectory = function () {
            var bouncesNum = this.getTrajectoryBounces();
            this.trajectory = new game.Trajectory(this);
            this.trajectory.setBounces(bouncesNum);
            this.trajectory.setDepth(game.GameplayDepth.TRAJECTORY);
            this.add.existing(this.trajectory);
        };
        Gameplay.prototype.getTrajectoryBounces = function () {
            var bouncesNum = utils.NetUtil.getParam("trajectory");
            if (bouncesNum !== null) {
                return parseInt(bouncesNum) || 1;
            }
            if (this.levelNumber < 5) {
                return 2;
            }
            return 1;
        };
        Gameplay.prototype.addTutorial = function () {
            if (this.levelNumber !== 1) {
                return;
            }
            var tutorial = new game.TutorialHand(this);
            tutorial.x = this.getFieldWidth() / 2;
            tutorial.y = this.fox.y - game.GameGrid.CELL_SIZE * 4.5;
            tutorial.show(370);
            this.add.existing(tutorial);
            var blockHint = new game.BlockHint(this);
            this.add.existing(blockHint);
        };
        Gameplay.prototype.addWarningLine = function () {
            this.warningLine = this.add.tileSprite(0, 0, 0, 0, "gameplay", "warning_line");
            this.warningLine.x = this.getFieldWidth() / 2;
            this.warningLine.y = game.GameGrid.CELL_SIZE * 7;
            this.warningLine.setDepth(game.GameplayDepth.LOSE_TUTORIAL);
            this.warningLine.kill();
            this.add.existing(this.warningLine);
        };
        Gameplay.prototype.addTurnCompleteFx = function () {
            this.turnCompleteFx = new game.TurnCompleteFx(this);
            this.turnCompleteFx.setDepth(game.GameplayDepth.TURN_POINTS_FX);
            this.turnCompleteFx.kill();
            this.turnCompleteFx.on(game.TurnCompleteFxEvent.CLEAR_BONUS_SHOW, this.onClearBonusShow, this);
            this.add.existing(this.turnCompleteFx);
        };
        Gameplay.prototype.onClearBonusShow = function () {
            var worldIndexStr = this.levelConfig.background.split("_").pop();
            var worldIndex = parseInt(worldIndexStr) || 1;
            var targetAlpha = worldIndex === 3 ? 0.33 : 0.5;
            this.grid.showClearGridFx(targetAlpha, 0);
            if (this.cache.audio.has(game.GameSoundKey.CLEAR_FIELD)) {
                this.sound.play(game.GameSoundKey.CLEAR_FIELD, { volume: 0.33 });
            }
        };
        Gameplay.prototype.addLevelCompleteFx = function () {
            this.levelCompleteFx = new game.LevelCompleteFx(this, this.isLastLevel());
            this.levelCompleteFx.setDepth(game.GameplayDepth.LEVEL_COMPLETE_FX);
            this.levelCompleteFx.kill();
            this.add.existing(this.levelCompleteFx);
        };
        Gameplay.prototype.isLastLevel = function () {
            var levelNumbers = this.game.levelConfigs.getLevelNumbers();
            return levelNumbers.indexOf(this.levelNumber) === levelNumbers.length - 1;
        };
        Gameplay.prototype.autoThrow = function () {
            var _this = this;
            if (!game.Main.development) {
                return;
            }
            var autoThrowConfig = this.levelConfig.autoThrow;
            if (autoThrowConfig.enabled === false) {
                return;
            }
            this.time.delayedCall(autoThrowConfig.delay, function () {
                var x = autoThrowConfig.x;
                var y = _this.grid.getHeight() + autoThrowConfig.y;
                _this.startTurn({ x: x, y: y });
                if (autoThrowConfig.fastForward) {
                    _this.time.delayedCall(100, function () {
                        _this.fastForward.enable();
                    });
                }
            });
        };
        Gameplay.prototype.tryToDropBalls = function () {
            var hasBallsInAir = this.balls.some(function (ball) { return ball.isThown; });
            if (hasBallsInAir === false) {
                return;
            }
            var areItemsLeft = this.items.length > 0;
            if (areItemsLeft === false) {
                this.dropBallsToFloor();
                return;
            }
            var noCollectableBalls = this.getItemsByType(game.ItemType.COLLECTABLE_BALL).length === 0;
            var noBlocks = this.items.every(function (item) { return game.ItemTypeUtil.isBlockType(item.itemType) === false; });
            if (noCollectableBalls && noBlocks) {
                var activeable = this.items.filter(function (item) { return item.itemType === game.ItemType.LIGHTNING || item.itemType === game.ItemType.SPINNER; });
                var allActivated = activeable.every(function (item) { return item.wasActivated; });
                if (allActivated) {
                    this.dropBallsToFloor();
                }
            }
        };
        Gameplay.prototype.getItemsByType = function (itemType) {
            return this.items.filter(function (item) { return item.itemType === itemType; });
        };
        Gameplay.prototype.showExplosion = function (x, y, initialScale) {
            var _this = this;
            var animation = this.animsPools.explosions.getInactive();
            var explosion = new game.Explosion(this, animation);
            explosion.once("destroy", function () { return _this.animsPools.explosions.recycleActive(animation); });
            explosion.x = x;
            explosion.y = y;
            explosion.scale = initialScale;
            explosion.setDepth(game.GameplayDepth.EXPLOSION);
            explosion.playScaleTween();
            this.add.existing(explosion);
        };
        Gameplay.prototype.damageNearbyBlocks = function (source) {
            var _this = this;
            this.items
                .filter(function (item) { return game.ItemTypeUtil.isBlockType(item.itemType); })
                .filter(function (item) { return Distance.Between(source.x, source.y, item.x, item.y) <= source.explosionRadius; })
                .forEach(function (block) {
                var isFutureBlock = _this.turn.futureItems.some(function (futureItem) { return futureItem.item === block; });
                if (isFutureBlock) {
                    return;
                }
                block.health.kill();
            });
        };
        Gameplay.prototype.destroyNearbyItems = function (bomb) {
            this.items
                .filter(function (item) { return game.ItemTypeUtil.isBlockType(item.itemType) === false; })
                .filter(function (item) { return Distance.Between(bomb.x, bomb.y, item.x, item.y) <= bomb.explosionRadius; })
                .forEach(function (item) {
                item.destroy();
            });
        };
        Gameplay.prototype.showDamageValueFx = function (damage, block) {
            var fx = this.pools.blockDamageFXs.getFirstDead(true);
            if (fx) {
                fx.setText(damage.toString());
                fx.x = block.x;
                fx.y = Phaser.Display.Bounds.GetTop(block);
                fx.reset();
                fx.show();
            }
        };
        Gameplay.prototype.showCollectedBlockFx = function (block) {
            var _this = this;
            var nonCollectables = [game.ItemType.SHATTER_BLOCK, game.ItemType.PINATA_BLOCK, game.ItemType.DYNAMITE_BLOCK];
            var isNonCollectable = nonCollectables.includes(block.itemType);
            if (isNonCollectable) {
                this.gui.blocksLabel.incrementCurrent();
                return;
            }
            this.time.delayedCall(200, function () {
                _this.gui.onTargetBlockKilled(block);
                block.forceKill();
            });
        };
        Gameplay.prototype.isTargetItemType = function (itemType) {
            var targetItemType = this.levelConfig.generator.targetItemType;
            if (targetItemType === game.ItemType.SHATTER_BLOCK) {
                return itemType === game.ItemType.SHATTER_BLOCK || itemType === game.ItemType.SHATTER_BLOCK_PIECE;
            }
            return itemType === targetItemType;
        };
        Gameplay.prototype.checkTurnComplete = function () {
            if (this.turn.checkComplete()) {
                this.onTurnComplete();
            }
        };
        Gameplay.prototype.onTurnComplete = function () {
            var _this = this;
            if (this.isSceneShutdown()) {
                return;
            }
            this.fastForward.disable();
            this.gui.bottomPanel.hideTurnButtons();
            this.events.emit(GameplayEvent.TURN_COMPLETE);
            var hasBlocksOnLoseRow = this.getBlocks().some(function (block) { return block.grid.getRow() === game.GameGrid.LOSE_ROW; });
            var lastRowItems = this.isMoveDownLocked || hasBlocksOnLoseRow
                ? []
                : this.clearLastRow();
            // noinspection TypeScriptValidateTypes
            var pendingDestroyItems = _.uniq(__spreadArrays(lastRowItems, this.turn.lightningsActivated, this.turn.spinnersActivated));
            if (pendingDestroyItems.length === 0) {
                this.onTurnFullyComplete();
                return;
            }
            var destroyedItemsNum = 0;
            pendingDestroyItems.forEach(function (item) {
                item.kill();
                item.once(Phaser.GameObjects.Events.DESTROY, function () {
                    if (++destroyedItemsNum === pendingDestroyItems.length) {
                        _this.onTurnFullyComplete();
                    }
                });
            });
        };
        Gameplay.prototype.getBlocks = function () {
            return this.items.filter(function (item) { return game.ItemTypeUtil.isBlockType(item.itemType); });
        };
        Gameplay.prototype.onTurnFullyComplete = function () {
            if (this.isSceneShutdown()) {
                return;
            }
            var clearFieldBonus = this.turn.blocksKilledNum >= 3 && this.isGridEmpty();
            var totalPoints = this.turn.points * (clearFieldBonus ? 2 : 1);
            this.levelData.points += totalPoints;
            this.gui.pointsLabel.updatePoints(this.levelData.points);
            this.showTurnCompleteFx(this.turn.blocksKilledNum, this.turn.points, clearFieldBonus);
            var turnCompleteAnimationsDelay = clearFieldBonus ? 1800 : 400;
            this.time.delayedCall(turnCompleteAnimationsDelay, this.onTurnCompleteAnimationsComplete, null, this);
        };
        Gameplay.prototype.isSceneShutdown = function () {
            return this.scene.settings.status === Phaser.Scenes.SHUTDOWN;
        };
        Gameplay.prototype.onTurnCompleteAnimationsComplete = function () {
            var _this = this;
            var isGameOver = this.isMoveDownLocked === false && this.checkForGameOver();
            if (isGameOver) {
                this.onLevelFailed();
                return;
            }
            var isGameComplete = this.checkGameComplete();
            if (isGameComplete) {
                this.onLevelComplete();
                return;
            }
            this.adjustFirstLandedBallMark();
            this.fox.moveTo(this.turn.firstLandedBallMark);
            this.idleBallsAligner.placeIdleBallsAround(this.idleBalls, this.turn.firstLandedBallMark);
            if (this.isMoveDownLocked) {
                var isFieldClear = this.isGridEmpty();
                if (isFieldClear) {
                    var moveDownRows = this.calculateMoveDownShift();
                    this.generateNewItems(moveDownRows);
                    this.completeTurn();
                }
                else {
                    this.playStopActiveTween();
                    this.playStopActiveSound();
                    this.completeTurn();
                }
            }
            else {
                var moveDownRows_1 = this.calculateMoveDownShift();
                var moveDownDuration = 300;
                this.playMoveItemsDownSound();
                this.moveItemsDown(moveDownRows_1, moveDownDuration);
                this.time.delayedCall(moveDownDuration, function () {
                    _this.playAlarmSound();
                    _this.generateNewItems(moveDownRows_1);
                    _this.completeTurn();
                });
            }
        };
        Gameplay.prototype.playStopActiveTween = function () {
            this.tweens.add({
                targets: this.items,
                duration: 200,
                ease: Phaser.Math.Easing.Sine.InOut,
                y: "+=30",
                yoyo: true,
            });
        };
        Gameplay.prototype.playStopActiveSound = function () {
            if (this.cache.audio.has(game.GameSoundKey.BOOSTER_STOP_ACTIVE)) {
                this.sound.play(game.GameSoundKey.BOOSTER_STOP_ACTIVE, { volume: 0.33, delay: 0.33 });
            }
        };
        Gameplay.prototype.completeTurn = function () {
            this.sleepItems();
            this.turn.complete();
            this.gui.showBoostersPanel();
            this.events.emit(GameplayEvent.TURN_FULLY_COMPLETE, this);
        };
        Gameplay.prototype.adjustFirstLandedBallMark = function () {
            // if we force drop balls before any of them landed
            if (this.turn.firstLandedBall === null) {
                this.turn.firstLandedBallMark = this.fox.x;
                return;
            }
            var margin = game.Ball.RADIUS * 2;
            var left = this.grid.x + margin;
            var right = this.grid.x + this.grid.getWidth() - margin;
            this.turn.firstLandedBallMark = Phaser.Math.Clamp(this.turn.firstLandedBallMark, left, right);
        };
        Gameplay.prototype.checkForGameOver = function () {
            return this.items
                .filter(function (item) { return game.ItemTypeUtil.isBlockType(item.itemType); })
                .some(function (item) { return item.grid.getRow() === game.GameGrid.LOSE_ROW; });
        };
        Gameplay.prototype.checkGameComplete = function () {
            return this.levelData.targetBlocksKilled >= this.levelData.targetBlocksRequired;
        };
        Gameplay.prototype.onLevelFailed = function () {
            var _this = this;
            var initialDelay = 390;
            this.time.delayedCall(initialDelay + 50, function () {
                _this.showFoxWorried();
            });
            this.time.delayedCall(initialDelay, function () {
                _this.playBlockJumpOnFox();
            });
            this.time.delayedCall(initialDelay + 2400, function () {
                if (game.Main.areRewardAdsEnabled === false || _this.secondChance.wasUsed) {
                    _this.showLevelFailedScreen();
                    _this.analytics.sendLevelFail(_this.levelNumber, _this.levelData.targetBlocksRequired - _this.levelData.targetBlocksKilled);
                }
                else {
                    _this.gui.secondChanceScreen.closeButton.once(ButtonEvent.PRESS, _this.showLevelFailedScreen, _this);
                    _this.gui.showSecondChanceScreen(_this.levelData.targetBlocksKilled, _this.levelData.targetBlocksRequired);
                }
            });
            this.time.delayedCall(initialDelay + 3000, function () {
                _this.scene.pause();
            });
        };
        Gameplay.prototype.showFoxWorried = function () {
            if (this.cache.audio.has(game.GameSoundKey.FOX_OOH)) {
                this.sound.play(game.GameSoundKey.FOX_OOH, { volume: 1 });
            }
            this.fox.showLoseFrame();
        };
        Gameplay.prototype.playBlockJumpOnFox = function () {
            var block = new game.BlockKing(this);
            block.x = this.fox.x;
            block.y = this.fox.y;
            block.setDepth(game.GameplayDepth.JUMP_ON_FOX_BLOCK);
            block.once(game.BlockKingEvent.JUMP_ON_FOX_COMPLETE, this.onJumpOnFoxComplete, this);
            block.jumpOnFox(this.fox.x, this.fox.y);
            this.add.existing(block);
            if (this.cache.audio.has(game.GameSoundKey.BLOCK_COLLECTED_WHOOSH)) {
                this.sound.play(game.GameSoundKey.BLOCK_COLLECTED_WHOOSH, { volume: 0.66, delay: 0 });
            }
        };
        Gameplay.prototype.onJumpOnFoxComplete = function (block) {
            if (this.cache.audio.has(game.GameSoundKey.DUCK_SCREAM)) {
                this.sound.play(game.GameSoundKey.DUCK_SCREAM, { volume: 0.66 });
            }
            if (this.cache.audio.has(game.GameSoundKey.BLOCK_STOMP_HIT)) {
                this.sound.play(game.GameSoundKey.BLOCK_STOMP_HIT, { volume: 0.8 });
            }
            this.cameras.main.shake(433, 0.018, true);
            this.showDustCloud(block);
            this.throwFox(block);
            this.throwLosingBalls(block.x);
        };
        Gameplay.prototype.showDustCloud = function (block) {
            var dust = new game.DustCloud(this);
            dust.x = block.x + block.displayWidth * (0.5 - block.originX);
            dust.y = block.y + block.displayHeight * (1 - block.originY) - 20;
            dust.setDepth(game.GameplayDepth.JUMP_ON_FOX_BLOCK_DUST);
            this.add.existing(dust);
        };
        Gameplay.prototype.throwFox = function (block) {
            this.fox.kill();
            var thrownFoxFrame = this.textures.getFrame("gameplay", "fox_lost");
            var thrownFox = new game.ThrownFox(this.matter.world, thrownFoxFrame);
            thrownFox.x = block.x;
            thrownFox.y = block.y;
            thrownFox.setCollidesWith(0);
            thrownFox.setDepth(game.GameplayDepth.FOX_THROWN);
            thrownFox.throw();
            thrownFox.destroyAfter(1300);
            this.add.existing(thrownFox);
        };
        Gameplay.prototype.throwLosingBalls = function (stompX) {
            var _this = this;
            this.idleBalls.forEach(function (ball, index) {
                ball.kill();
                var throwDirection = ball.x > stompX ? Phaser.RIGHT : Phaser.LEFT;
                var losingBall = new game.LosingBall(_this, ball);
                losingBall.x = ball.x;
                losingBall.y = ball.y - ball.height / 2;
                losingBall.setCollidesWith(0);
                losingBall.setDepth(game.GameplayDepth.LOSING_BALLS);
                losingBall.throw(throwDirection);
                losingBall.destroyAfter(1300);
                _this.add.existing(losingBall);
            });
        };
        Gameplay.prototype.showLevelFailedScreen = function () {
            var data = this.getLevelFailedData();
            this.gui.onLevelFailed(data);
            this.isGameplayStopped = true;
            this.poki.sdk.gameplayStop();
        };
        Gameplay.prototype.getLevelFailedData = function () {
            return {
                levelNumber: this.levelNumber,
                targetBlocksType: this.levelConfig.generator.targetItemType,
                blocksRequired: this.levelData.targetBlocksRequired,
                blocksKilled: this.levelData.targetBlocksKilled,
                score: this.levelData.points,
            };
        };
        Gameplay.prototype.onLevelComplete = function () {
            var _this = this;
            this.isGameplayStopped = true;
            this.poki.sdk.gameplayStop();
            this.analytics.sendLevelComplete(this.levelNumber, this.getEarnedStarsNum(this.levelData.points, this.levelConfig.stars));
            this.saveLevelResult();
            this.hideRemainingItems();
            this.gui.boostersPanel.disableInput();
            var animationsDelay = 220;
            this.time.delayedCall(0, function () {
                _this.fox.playHappyAnimation();
                _this.idleBallsAligner.placeIdleBallsAround(_this.idleBalls, _this.fox.x);
            });
            this.time.delayedCall(animationsDelay, function () {
                _this.launchWinningBalls();
            });
            var winningBallsDelay = 500 + Math.min(5, this.idleBalls.length) * 133;
            var levelCompleteDelay = animationsDelay + winningBallsDelay;
            this.time.delayedCall(levelCompleteDelay, function () {
                _this.showLevelCompleteFx();
                _this.poki.sdk.happyTime(1);
            });
            this.time.delayedCall(levelCompleteDelay + 1600, function () {
                _this.showLevelCompleteScreen();
            });
            this.time.delayedCall(levelCompleteDelay + 2500, function () {
                _this.scene.pause();
            });
        };
        Gameplay.prototype.hideRemainingItems = function () {
            var _this = this;
            this.items.forEach(function (item) {
                item.on(game.HideEvent.COMPLETE, _this.showItemDestroyFx.bind(_this, item.x, item.y));
                item.hideOnLevelComplete(300);
            });
        };
        Gameplay.prototype.launchWinningBalls = function () {
            var _this = this;
            this.idleBalls.slice(0).forEach(function (idleBall, index) {
                var launchDelay = index * 133;
                var launchSide = idleBall.x > _this.grid.getWidth() / 2 ? Phaser.LEFT : Phaser.RIGHT;
                var winningBall = new game.WinningBall(_this);
                winningBall.x = idleBall.x;
                winningBall.y = idleBall.y - idleBall.height / 2;
                winningBall.alpha = 0;
                winningBall.once(game.WinningBallEvent.LAUNCH, _this.onWinningBallLaunch.bind(_this, idleBall, winningBall));
                winningBall.once(game.WinningBallEvent.EXPLODE, _this.onWinningBallExplode, _this);
                winningBall.setDepth(game.GameplayDepth.WINNING_BALLS);
                winningBall.launch(launchDelay, launchSide);
                _this.add.existing(winningBall);
            });
        };
        Gameplay.prototype.onWinningBallLaunch = function (idleBall, winningBall) {
            idleBall.kill();
            winningBall.alpha = 1;
            if (this.cache.audio.has(game.GameSoundKey.WINNING_BALL_WHOOSH)) {
                this.sound.play(game.GameSoundKey.WINNING_BALL_WHOOSH, { volume: 0.66, rate: 0.82 });
            }
        };
        Gameplay.prototype.onWinningBallExplode = function (ball) {
            this.emitters.collectableBallFeathers.setPosition(ball.x, ball.y);
            this.emitters.collectableBallFeathers.explode(25, ball.x, ball.y);
            this.audio.winningBallExplode();
        };
        Gameplay.prototype.showLevelCompleteFx = function () {
            this.levelCompleteFx.x = this.grid.getWidth() / 2;
            this.levelCompleteFx.y = this.grid.y + this.grid.getHeight() * 0.2;
            this.levelCompleteFx.revive();
            this.levelCompleteFx.show();
            if (this.cache.audio.has(game.GameSoundKey.LEVEL_COMPLETE_TEXT)) {
                this.sound.play(game.GameSoundKey.LEVEL_COMPLETE_TEXT, { volume: 1, delay: 0.1 });
            }
        };
        Gameplay.prototype.saveLevelResult = function () {
            var prevHighscore = this.getLevelHighscore(this.levelNumber);
            var newHighscore = Math.max(prevHighscore, this.levelData.points);
            var newResult = {
                complete: true,
                stars: this.getEarnedStarsNum(this.levelData.points, this.levelConfig.stars),
                highscore: newHighscore,
            };
            this.game.store.saveLevelResult(this.levelNumber, newResult);
        };
        Gameplay.prototype.getEarnedStarsNum = function (points, starPoints) {
            return _.findLastIndex(starPoints, function (star) { return (points >= star); }) + 1;
        };
        Gameplay.prototype.getLevelHighscore = function (levelNumber) {
            var levelResult = this.game.store.getLevelResult(levelNumber);
            if (levelResult) {
                return levelResult.highscore;
            }
            return 0;
        };
        Gameplay.prototype.showLevelCompleteScreen = function () {
            var data = {
                levelNumber: this.levelNumber,
                stars: this.getEarnedStarsNum(this.levelData.points, this.levelConfig.stars),
                score: this.levelData.points,
                highscore: this.getLevelHighscore(this.levelNumber),
                blocksType: this.levelConfig.generator.targetItemType,
                blocksNum: this.levelData.targetBlocksKilled,
            };
            this.gui.onLevelComplete(data);
        };
        Gameplay.prototype.clearLastRow = function () {
            var itemTypesToRemove = [game.ItemType.SPINNER, game.ItemType.LIGHTNING, game.ItemType.COLLECTABLE_BALL];
            return this.items.filter(function (item) { return itemTypesToRemove
                .includes(item.itemType); })
                .filter(function (item) { return item.grid.getRow() === game.GameGrid.LOSE_ROW; });
        };
        Gameplay.prototype.calculateMoveDownShift = function () {
            var maxShift = 4;
            var isGridEmpty = this.isGridEmpty();
            if (isGridEmpty) {
                return maxShift;
            }
            var areBlocksLeft = this.items.some(function (item) { return game.ItemTypeUtil.isBlockType(item.itemType); });
            if (areBlocksLeft) {
                return 1;
            }
            var bottomItem = this.getVeryBottomItem();
            var bottomOccupiedRow = bottomItem.grid.getRow();
            var shift = bottomOccupiedRow - game.GameGrid.LOSE_ROW;
            return Math.min(maxShift, shift);
        };
        Gameplay.prototype.getVeryTopItem = function () {
            return _.maxBy(this.items, (function (item) {
                return item.grid.getRow();
            }));
        };
        Gameplay.prototype.getVeryBottomItem = function () {
            return _.minBy(this.items, (function (item) {
                return item.grid.getRow();
            }));
        };
        Gameplay.prototype.playMoveItemsDownSound = function () {
            if (this.isGridEmpty()) {
                return;
            }
            if (this.cache.audio.has(game.GameSoundKey.MOVE_ITEMS_DOWN)) {
                this.sound.play(game.GameSoundKey.MOVE_ITEMS_DOWN, { volume: 1 });
            }
        };
        Gameplay.prototype.moveItemsDown = function (rows, moveDownDuration) {
            var _this = this;
            var onMoveDownComplete = _.once(function () {
                _this.showWarningLine();
                _this.addLoseTutorial();
            });
            this.items
                .sort(this.sortGridItems.bind(this))
                .reverse()
                .forEach(function (item) {
                var newRow = item.grid.getRow() - rows;
                _this.tweens.add({
                    targets: item,
                    duration: moveDownDuration,
                    ease: Phaser.Math.Easing.Cubic.Out,
                    y: item.y + game.GameGrid.CELL_SIZE * rows,
                    onComplete: function () {
                        _this.onItemMoveDownComplete(item, newRow, onMoveDownComplete);
                    },
                });
            });
        };
        Gameplay.prototype.sortGridItems = function (itemA, itemB) {
            var rowA = itemA.grid.getRow();
            var rowB = itemB.grid.getRow();
            if (rowA === rowB) {
                return itemA.grid.getColumn() - itemB.grid.getColumn();
            }
            return rowA - rowB;
        };
        Gameplay.prototype.onItemMoveDownComplete = function (item, row, onMoveDownComplete) {
            var isLastRow = row === 2;
            if (isLastRow === false) {
                return;
            }
            var isBlock = game.ItemTypeUtil.isBlockType(item.itemType);
            if (isBlock === false) {
                return;
            }
            ;
            item.startStomping();
            onMoveDownComplete();
        };
        Gameplay.prototype.showWarningLine = function () {
            this.warningLine.revive();
            this.warningLine.alpha = 0;
            this.tweens.add({
                targets: this.warningLine,
                duration: 300,
                ease: Phaser.Math.Easing.Cubic.Out,
                alpha: 1,
            });
        };
        Gameplay.prototype.addLoseTutorial = function () {
            var isLoseTutorialComplete = this.game.store.getBoolean(game.GameStoreKey.LOSE_TUTORIAL_COMPLETE);
            if (isLoseTutorialComplete) {
                return;
            }
            var loseTutorial = new game.LoseTutorial(this);
        };
        Gameplay.prototype.playAlarmSound = function () {
            var blocks = this.items.filter(function (item) { return game.ItemTypeUtil.isBlockType(item.itemType); });
            var onBottomRow = blocks.some(function (block) { return block.grid.getRow() === game.GameGrid.LOSE_ROW; });
            if (onBottomRow) {
                if (this.cache.audio.has(game.GameSoundKey.FOX_UH_OH_1)) {
                    this.sound.play(game.GameSoundKey.FOX_UH_OH_1, { volume: 1 });
                }
            }
        };
        Gameplay.prototype.generateNewItems = function (rowsToGenerate) {
            var _this = this;
            var isTopRowBusy = this.items.some(function (item) { return (item.grid.getRow() === game.GameGrid.ROWS - 2); });
            if (isTopRowBusy) {
                return;
            }
            var topEmptyRows = this.getTopEmptyRowsNum();
            var rowsToFill = Math.min(topEmptyRows, rowsToGenerate);
            var newItemsConfigs = this.generator.getNextRows(rowsToFill);
            if (newItemsConfigs.length === 0) {
                return;
            }
            // noinspection TypeScriptValidateTypes
            var startRow = _.minBy(newItemsConfigs, "row").row;
            newItemsConfigs.map(function (itemConfig) {
                var newRowOffset = itemConfig.row - startRow;
                var newRow = game.GameGrid.ROWS - 1 - rowsToFill + newRowOffset;
                var newItem = _this.factory.create(__assign({ itemType: itemConfig.type, column: itemConfig.column, row: newRow }, itemConfig.config));
                _this.showNewlyGeneratedItem(newItem);
                return newItem;
            });
        };
        Gameplay.prototype.getTopEmptyRowsNum = function () {
            var topItem = this.getVeryTopItem();
            if (topItem) {
                var topRow = topItem.grid.getRow();
                return game.GameGrid.ROWS - 2 - topRow;
            }
            return game.GameGrid.ROWS - 2;
        };
        Gameplay.prototype.showNewlyGeneratedItem = function (newItem) {
            var _this = this;
            newItem.alpha = 0;
            newItem.scale = 0.66;
            this.tweens.add({
                targets: newItem,
                scale: { value: 1, duration: 300, ease: Phaser.Math.Easing.Back.Out },
                alpha: { value: 1, duration: 150, ease: Phaser.Math.Easing.Cubic.Out },
                onComplete: function () {
                    _this.factory.postCreationCallback(newItem);
                },
            });
        };
        Gameplay.prototype.isGridEmpty = function () {
            return this.items.length === 0;
        };
        Gameplay.prototype.sleepItems = function () {
            this.items.forEach(function (item) { return item.setToSleep(); });
        };
        Gameplay.prototype.showIdleBall = function (x) {
            var idleBall = this.idleBalls.find(function (idleBall) { return idleBall.active === false && idleBall.scheduledForLaunch === false; });
            if (!idleBall) {
                idleBall = this.idleBalls.find(function (ball) { return ball.isHiding; });
                if (idleBall) {
                    idleBall.stopHideTween();
                }
                else {
                    this.addTurnStateToRavenExtraContext();
                }
            }
            idleBall.setPosition(x, this.getIdleBallPositionY());
            idleBall.show();
            idleBall.slightlyMoveAside(x, this.grid)
                .on(Phaser.Tweens.Events.TWEEN_COMPLETE, this.onIdleBallReady, this);
        };
        Gameplay.prototype.addTurnStateToRavenExtraContext = function () {
            var turnState = {
                inProgress: this.turn.inProgress(),
                idleBallsTotal: this.idleBalls.length,
                idleBallsActive: this.idleBalls.filter(function (ball) { return ball.active; }).length,
                idleBallsScheduled: this.idleBalls.filter(function (ball) { return ball.scheduledForLaunch; }).length,
                ballsThrown: this.turn.ballsThrownNum,
                ballsLanded: this.turn.ballsLandedNum,
                fastForward: this.turn.fastForwarded,
                dropBalls: this.turn.ballsDropped,
            };
            this.raven.addExtraContext({ turnState: turnState });
        };
        Gameplay.prototype.onIdleBallReady = function () {
            this.turn.ballsLandedNum++;
            this.checkTurnComplete();
        };
        Gameplay.prototype.emitFeathers = function (num, x, y) {
            this.emitters.feathers.explode(num, x, y);
        };
        Gameplay.prototype.addIdleBall = function (x) {
            var idleBall = this.getIdleBall();
            idleBall.x = x;
            idleBall.y = this.getIdleBallPositionY();
            idleBall.show();
            this.add.existing(idleBall);
            this.idleBalls.push(idleBall);
        };
        Gameplay.prototype.getIdleBall = function () {
            var isPoolEmtpy = this.pools.idleBalls.length === 0;
            if (isPoolEmtpy) {
                var newBall = this.pools.createNewIdleBall();
                var newShadow = this.pools.createNewIdleBallShadow(newBall);
                return newBall;
            }
            return this.pools.idleBalls.pop();
        };
        Gameplay.prototype.getIdleBallPositionY = function () {
            return this.grid.getHeight() + 5;
        };
        Gameplay.prototype.showPlusBallFx = function (collectable) {
            var _a;
            var text = (_a = this.game.texts.texts.plus_ball) !== null && _a !== void 0 ? _a : "+DUCK";
            var fx = new game.PlusBallFx(this, text);
            fx.x = collectable.x - 5;
            fx.y = this.fox.y - 80;
            fx.setDepth(game.GameplayDepth.PLUS_DUCK_FX);
            fx.show();
            this.add.existing(fx);
        };
        Gameplay.prototype.onPointerDown = function (pointer, objects) {
            if (objects.length > 0) {
                return;
            }
            this.isPointerDown = true;
        };
        Gameplay.prototype.onPointerUp = function (pointer) {
            if (this.isPointerDown === false) {
                return;
            }
            this.isPointerDown = false;
            if (this.turn.inProgress()) {
                return;
            }
            this.startTurn(this.trajectory.trajectoryEnd);
        };
        Gameplay.prototype.startTurn = function (ballsTarget) {
            var throwPosition = this.fox.getHandsPosition();
            var throwRotation = this.getThrowRotation(throwPosition, ballsTarget);
            if (throwRotation >= 0) {
                return;
            }
            this.events.emit(GameplayEvent.TURN_START);
            this.levelData.turnsNum++;
            this.turn.start();
            this.stopStomping();
            this.hideWarningLine();
            this.wakeItems();
            this.startThrowingBalls(throwPosition, throwRotation);
            this.gui.onTurnStart();
        };
        Gameplay.prototype.stopStomping = function () {
            this.items
                .filter(function (item) { return game.ItemTypeUtil.isBlockType(item.itemType); })
                .forEach(function (block) {
                block.stopStomping();
            });
        };
        Gameplay.prototype.hideWarningLine = function () {
            var _this = this;
            this.tweens.killTweensOf(this.warningLine);
            this.tweens.add({
                targets: this.warningLine,
                duration: 150,
                ease: Phaser.Math.Easing.Cubic.Out,
                alpha: 0,
                onComplete: function () {
                    _this.warningLine.kill();
                },
            });
        };
        Gameplay.prototype.wakeItems = function () {
            this.items.forEach(function (item) {
                item.setAwake();
            });
        };
        Gameplay.prototype.startThrowingBalls = function (start, rotation) {
            var _this = this;
            this.idleBalls.forEach(function (idleBall, index) {
                idleBall.scheduledForLaunch = true;
                // throw balls in reverse order to display them in right depth order
                var ball = _this.balls[_this.balls.length - 1 - index];
                var delay = (index + 1) * 55;
                _this.time.delayedCall(delay, function () {
                    // launch can be canceled when we force drop balls to floor
                    if (idleBall.scheduledForLaunch === false) {
                        return;
                    }
                    _this.doThrowBall(idleBall, ball, start, rotation);
                    _this.turn.ballsThrownNum++;
                    _this.fox.playShotAnimation();
                });
            });
        };
        Gameplay.prototype.doThrowBall = function (idleBall, ball, start, rotation) {
            this.audio.ballThrow();
            idleBall.scheduledForLaunch = false;
            idleBall.hide();
            ball.setPosition(start.x, start.y);
            ball.show();
            ball.throw(rotation);
        };
        Gameplay.prototype.addKeyboardCallbacks = function () {
            this.input.keyboard.on("keydown-SPACE", this.fastForward.enable.bind(this.fastForward));
            this.input.keyboard.on("keydown-DOWN", this.dropBallsToFloorByKey, this);
            if (game.Main.development) {
                this.input.keyboard.on("keydown-PAGE_DOWN", this.moveItemsDownByKey, this);
                this.input.keyboard.on("keydown-D", this._physics.toggleDebug, this._physics);
                this.input.keyboard.on("keydown-G", this.grid.toggleDebug, this.grid);
                this.input.keyboard.on("keydown-C", this.testLevelCompleteScreen, this);
                this.input.keyboard.on("keydown-F", this.testLevelFailedScreen, this);
                this.input.keyboard.on("keydown-X", this.testCompleteAnimations, this);
                this.input.keyboard.on("keydown-Z", this.testFailAnimations, this);
                this.input.keyboard.on("keydown-S", this.worldCopy.toggleSimulation, this.worldCopy);
                this.input.keyboard.on("keydown-FORWARD_SLASH", this.getTurnCompleteReport, this);
                this.input.keyboard.on("keydown-UP", this.applySecondChance, this);
                this.input.keyboard.on("keydown-ONE", this.trajectory.setBounces.bind(this.trajectory, 1));
                this.input.keyboard.on("keydown-TWO", this.trajectory.setBounces.bind(this.trajectory, 2));
                this.input.keyboard.on("keydown-THREE", this.trajectory.setBounces.bind(this.trajectory, 3));
                this.input.keyboard.on("keydown-N", this.putBallsOutsideWorld, this);
            }
        };
        Gameplay.prototype.putBallsOutsideWorld = function () {
            if (this.turn.inProgress() === false) {
                return;
            }
            var bounds = this.getWorldBounds();
            this.balls.forEach(function (ball) {
                if (ball.isThown === false) {
                    return;
                }
                var velocity = ball.body.velocity;
                ball.x = bounds.centerX + 1000 * Phaser.Math.Sign(velocity.x);
                ball.y = bounds.centerY + 1200 * Phaser.Math.Sign(velocity.y);
            });
        };
        Gameplay.prototype.getTurnCompleteReport = function () {
            console.log(this.turn.getCompleteReport(), this.turn.futureItems);
        };
        Gameplay.prototype.moveItemsDownByKey = function () {
            if (this.turn.inProgress()) {
                return;
            }
            if (this.canMoveItemsDown()) {
                this.moveItemsDown(1, 300);
            }
        };
        Gameplay.prototype.canMoveItemsDown = function () {
            // noinspection TypeScriptValidateTypes
            var bottomItem = _.minBy(this.items, function (item) {
                return item.grid.getRow();
            });
            return bottomItem.grid.getRow() > 2;
        };
        Gameplay.prototype.testFailAnimations = function () {
            this.onLevelFailed();
        };
        Gameplay.prototype.testCompleteAnimations = function () {
            this.onLevelComplete();
        };
        Gameplay.prototype.dropBallsToFloor = function () {
            var _this = this;
            if (this.turn.inProgress() === false) {
                return false;
            }
            this.turn.ballsDropped = true;
            this.idleBalls.forEach(function (idleBall) {
                idleBall.scheduledForLaunch = false;
            });
            this.balls.forEach(function (ball) {
                ball.dropToFloor([_this._physics.collisionCategories.floor, _this._physics.collisionCategories.walls, _this._physics.collisionCategories.ceiling]);
            });
            return true;
        };
        Gameplay.prototype.onFastForwardButtonClick = function (fastForwardButton) {
            this.fastForward.enable();
        };
        Gameplay.prototype.dropBallsToFloorByKey = function () {
            var wereDropped = this.dropBallsToFloor();
            if (wereDropped) {
                this.gui.dropBallsButton.disable();
                if (this.cache.audio.has(game.GameSoundKey.DROP_BALLS_DOWN)) {
                    this.sound.play(game.GameSoundKey.DROP_BALLS_DOWN, { volume: 1.25, delay: 0 });
                }
            }
        };
        Gameplay.prototype.adjustTargetItemsNum = function (newItemTypes) {
            var targetItemType = this.levelConfig.generator.targetItemType;
            var additionalTargetItems = newItemTypes.filter(function (itemType) { return itemType === targetItemType; }).length;
            this.updateTargetBlockNum(additionalTargetItems);
        };
        Gameplay.prototype.updateTargetBlockNum = function (delta) {
            if (delta === 0) {
                return;
            }
            this.levelData.targetBlocksRequired += delta;
            this.gui.blocksLabel.updateTotal(this.levelData.targetBlocksRequired);
        };
        Gameplay.prototype.showTurnCompleteFx = function (blocksKilled, points, clearBonus) {
            if (points === 0) {
                return;
            }
            this.turnCompleteFx.x = this.grid.getWidth() / 2;
            this.turnCompleteFx.y = game.GameGrid.CELL_SIZE * 4;
            this.turnCompleteFx.revive();
            this.turnCompleteFx.reset();
            this.turnCompleteFx.updateData(blocksKilled, points, clearBonus);
            this.turnCompleteFx.show();
            if (this.cache.audio.has(game.GameSoundKey.TURN_COMPLETE_TEXT)) {
                this.sound.play(game.GameSoundKey.TURN_COMPLETE_TEXT, { volume: 0.5, delay: 0.2 });
            }
        };
        Gameplay.prototype.createBallChargedEmitter = function (ball) {
            var actualEmitter = this.emitters.createBallChargedEmitter(ball);
            var emitter = new game.BallChargedEmitter(ball, actualEmitter);
        };
        Gameplay.prototype.showRedCopy = function (block) {
            var redCopy = this.pools.blockRedCopies.getFirstDead(true);
            redCopy.setBlock(block);
            redCopy.revive();
            redCopy.playFadeTween();
        };
        Gameplay.prototype.testLevelCompleteScreen = function () {
            var data = {
                levelNumber: this.levelNumber,
                blocksNum: Phaser.Math.RND.between(5, 100),
                blocksType: this.levelConfig.generator.targetItemType,
                score: Phaser.Math.RND.between(1, 10000),
                highscore: Phaser.Math.RND.between(1, 100000),
                stars: Phaser.Math.RND.between(0, 3),
            };
            this.scene.pause();
            this.gui.onLevelComplete(data);
        };
        Gameplay.prototype.testLevelFailedScreen = function () {
            var targetBlocksNum = Phaser.Math.RND.between(5, 100);
            var data = {
                levelNumber: this.levelNumber,
                targetBlocksType: this.levelConfig.generator.targetItemType,
                blocksKilled: Phaser.Math.RND.between(0, targetBlocksNum - 1),
                blocksRequired: targetBlocksNum,
                score: Phaser.Math.RND.between(0, 100000),
            };
            this.scene.pause();
            this.gui.onLevelFailed(data);
        };
        Gameplay.prototype.applySecondChance = function () {
            this.secondChance.once(game.SecondChanceEvent.COMPLETE, this.onSecondChanceComplete, this);
            this.secondChance.apply();
        };
        Gameplay.prototype.onSecondChanceComplete = function () {
            this.analytics.sendDesignEvent("SecondChance:Level_" + _.padStart(this.levelNumber.toString(), 3, "0"));
        };
        Gameplay.prototype.onPause = function () {
            this.scene.pause();
            this.isGameplayStopped = true;
            this.poki.sdk.gameplayStop();
        };
        Gameplay.prototype.onResume = function () {
            this.scene.resume();
            this.isGameplayStopped = true;
            this.poki.sdk.gameplayStart();
        };
        Gameplay.prototype.shutdown = function () {
            if (this.isGameplayStopped === false) {
                this.poki.sdk.gameplayStop();
            }
            if (this.boosters) {
                this.boosters.destroy();
                this.boosters = null;
            }
            if (this.worldCopy) {
                this.worldCopy.destroy();
            }
            if (this.audio) {
                this.audio.destroy();
            }
            if (this.fastForward) {
                this.fastForward.destroy();
            }
            this.animsPools.recycle();
        };
        return Gameplay;
    }(Phaser.Scene));
    game.Gameplay = Gameplay;
})(game || (game = {}));
var game;
(function (game) {
    var IngamePanel = /** @class */ (function (_super) {
        __extends(IngamePanel, _super);
        function IngamePanel(scene) {
            var _this = _super.call(this, scene) || this;
            _this.verticalMargin = 1;
            _this.strokeThickness = 6;
            _this.padding = 24;
            _this.scene.add.existing(_this);
            _this.addBackground();
            _this.addContainer();
            return _this;
        }
        IngamePanel.prototype.addBackground = function () {
            this.background = this.scene.add.image(0, 0, "gameplay_gui", "up_panel");
            this.background.setOrigin(0.5, 0);
            this.add(this.background);
        };
        IngamePanel.prototype.addContainer = function () {
            this.container = this.scene.add.image(0, 0, "gameplay_gui", "white_rect");
            this.container.displayWidth = this.background.displayWidth;
            this.container.displayHeight = this.background.displayHeight;
            this.container.alpha = 0;
            this.add(this.container);
        };
        IngamePanel.prototype.getWidth = function () {
            return this.background.width;
        };
        IngamePanel.prototype.getHeight = function () {
            return this.background.height;
        };
        IngamePanel.prototype.getDisplayHeight = function () {
            return this.getHeight() * this.scaleY;
        };
        IngamePanel.prototype.getVeticalOffset = function () {
            return this.container.displayHeight + this.strokeThickness - this.verticalMargin;
        };
        return IngamePanel;
    }(Phaser.GameObjects.Container));
    game.IngamePanel = IngamePanel;
})(game || (game = {}));
var game;
(function (game) {
    var LevelLabel = /** @class */ (function (_super) {
        __extends(LevelLabel, _super);
        function LevelLabel(scene, levelNumber) {
            var _this = _super.call(this, scene) || this;
            _this.baseFontSize = 24;
            _this.name = "level_label";
            _this.style = _this.createTextStyle();
            _this.addTitle();
            _this.addNumber(levelNumber);
            return _this;
        }
        LevelLabel.prototype.createTextStyle = function () {
            return {
                fontFamily: game.GameFont.SOUSES,
                fontStyle: game.FontWeight.BLACK,
                fontSize: this.baseFontSize + "px",
                color: game.GameplayGui.FONT_COLOR_STR,
                align: "center",
            };
        };
        LevelLabel.prototype.addTitle = function () {
            var _a, _b;
            var titleContent = (_b = (_a = this.scene.texts.level) === null || _a === void 0 ? void 0 : _a.toUpperCase()) !== null && _b !== void 0 ? _b : "LEVEL";
            this.levelTitle = this.scene.add.text(0, 0, titleContent, this.style);
            this.levelTitle.setOrigin(0);
            this.add(this.levelTitle);
            var maxWidth = 90;
            this.levelTitle.scale = Math.min(1, maxWidth / this.levelTitle.width);
        };
        LevelLabel.prototype.addNumber = function (levelNumber) {
            var fontSize = Math.round(this.baseFontSize * 1.7);
            var numberStyle = __assign(__assign({}, this.style), { fontSize: fontSize + "px" });
            this.levelNumber = this.scene.add.text(0, 0, levelNumber.toString(), numberStyle);
            this.levelNumber.setOrigin(0.5, 0);
            this.levelNumber.x = this.levelTitle.getCenter().x;
            this.levelNumber.y = this.levelTitle.y + this.levelTitle.getBounds().height / 2 + 8;
            this.add(this.levelNumber);
        };
        return LevelLabel;
    }(Phaser.GameObjects.Container));
    game.LevelLabel = LevelLabel;
})(game || (game = {}));
var game;
(function (game) {
    var BasicBallsLabel = /** @class */ (function (_super) {
        __extends(BasicBallsLabel, _super);
        function BasicBallsLabel(scene) {
            var _this = _super.call(this, scene) || this;
            _this.name = "balls_label";
            _this.addBalIcon();
            _this.addText();
            return _this;
        }
        BasicBallsLabel.prototype.addBalIcon = function () {
            this.ballIcon = this.scene.add.image(0, 0, "gameplay_gui", "ball_icon");
            this.add(this.ballIcon);
        };
        BasicBallsLabel.prototype.addText = function () {
            var content = "0";
            this.text = this.scene.add.bitmapText(0, 0, game.BitmapGameFont.BLOCKS_LABEL, content, 22);
            this.text.setTint(game.GameplayGui.FONT_COLOR);
            this.text.setOrigin(0.5, 0.5);
            this.text.x = 0;
            this.text.y = this.ballIcon.y + 42;
            this.add(this.text);
        };
        BasicBallsLabel.prototype.updateNum = function (num) {
            this.text.setText(num.toString());
        };
        return BasicBallsLabel;
    }(Phaser.GameObjects.Container));
    game.BasicBallsLabel = BasicBallsLabel;
})(game || (game = {}));
///<reference path='LevelLabel.ts' />
///<reference path='BasicBallsLabel.ts' />
var game;
(function (game) {
    var MainLabel = /** @class */ (function (_super) {
        __extends(MainLabel, _super);
        function MainLabel(scene, levelConfig) {
            var _this = _super.call(this, scene) || this;
            _this.padding = { x: 22, y: 0 };
            _this.name = "main_label";
            _this.levelConfig = levelConfig;
            _this.addBackground();
            _this.addLevelLabel(levelConfig.levelNumber);
            _this.addFirstSeparator();
            _this.addBlocksLabel(levelConfig.generator.targetItemType, levelConfig.generator.targetItemsNum);
            _this.addSecondSeparator();
            _this.addBallsLabel(levelConfig.balls);
            _this.alignItems();
            _this.bringToTop(_this.levelLabel);
            return _this;
        }
        MainLabel.prototype.addBackground = function () {
            this.back = this.scene.add.image(0, 0, "gameplay_gui", "main_label_back");
            this.add(this.back);
        };
        MainLabel.prototype.addLevelLabel = function (levelNumber) {
            this.levelLabel = new game.LevelLabel(this.scene, levelNumber);
            this.add(this.levelLabel);
        };
        MainLabel.prototype.addFirstSeparator = function () {
            this.firstSeparator = this.scene.add.image(0, 0, "gameplay_gui", "main_label_separator");
            this.add(this.firstSeparator);
        };
        MainLabel.prototype.addBlocksLabel = function (targetBlocksType, targetBlocksNum) {
            this.blocksLabel = new game.BasicBlocksLabel(this.scene, targetBlocksType, targetBlocksNum);
            this.add(this.blocksLabel);
        };
        MainLabel.prototype.addSecondSeparator = function () {
            this.secondSeparator = this.scene.add.image(0, 0, "gameplay_gui", "main_label_separator");
            this.add(this.secondSeparator);
        };
        MainLabel.prototype.addBallsLabel = function (ballsNum) {
            this.ballsLabel = new game.BasicBallsLabel(this.scene);
            this.ballsLabel.updateNum(ballsNum);
            this.add(this.ballsLabel);
        };
        MainLabel.prototype.alignItems = function () {
            this.alignLevelLabel();
            this.alignBallsLabel();
            this.alignBlocksLabel();
            this.alignFirstSeparator();
            this.alignSecondSeparator();
            this.blocksLabel.x += 5;
            this.ballsLabel.x += 11;
        };
        MainLabel.prototype.alignLevelLabel = function () {
            this.levelLabel.x = this.back.left + this.padding.x;
            this.levelLabel.y = this.back.y - this.levelLabel.getBounds().height / 2;
        };
        MainLabel.prototype.alignBallsLabel = function () {
            var bounds = this.ballsLabel.getBounds();
            this.ballsLabel.x = this.back.right - bounds.width - this.padding.x / 2;
            this.ballsLabel.y = -13;
        };
        MainLabel.prototype.alignBlocksLabel = function () {
            var left = this.levelLabel.getBounds().right;
            var right = this.ballsLabel.getBounds().left;
            var width = right - left;
            this.blocksLabel.x = left + width / 2;
            this.blocksLabel.y = -14;
        };
        MainLabel.prototype.alignFirstSeparator = function () {
            var left = this.levelLabel.x + this.levelLabel.getBounds().width;
            var right = this.blocksLabel.x - this.blocksLabel.getBounds().width / 2;
            var width = right - left;
            this.firstSeparator.x = left + width / 2;
            this.firstSeparator.y -= 3;
        };
        MainLabel.prototype.alignSecondSeparator = function () {
            var left = this.blocksLabel.x + this.blocksLabel.getBounds().width;
            var right = this.ballsLabel.x - this.ballsLabel.getBounds().width / 2;
            var width = right - left;
            this.secondSeparator.x = left + width / 2 - 2;
            this.secondSeparator.y -= 3;
        };
        MainLabel.prototype.getWidth = function () {
            return this.back.displayWidth;
        };
        return MainLabel;
    }(Phaser.GameObjects.Container));
    game.MainLabel = MainLabel;
})(game || (game = {}));
var game;
(function (game) {
    var ProgressBarStarEvent;
    (function (ProgressBarStarEvent) {
        ProgressBarStarEvent["SHOW_START"] = "ProgressBarStar_SHOW_START";
        ProgressBarStarEvent["SHOW_COMPLETE"] = "ProgressBarStar_SHOW_COMPLETE";
    })(ProgressBarStarEvent = game.ProgressBarStarEvent || (game.ProgressBarStarEvent = {}));
    var ProgressBarStar = /** @class */ (function (_super) {
        __extends(ProgressBarStar, _super);
        function ProgressBarStar(scene, atlas, activeFrame, inactiveFrame) {
            var _this = _super.call(this, scene) || this;
            _this._isActive = true;
            _this.name = "star";
            _this.inactiveStar = _this.scene.add.image(0, 0, atlas, inactiveFrame);
            _this.activeStar = _this.scene.add.image(0, 0, atlas, activeFrame);
            _this.circleFx = _this.scene.add.image(0, 2, atlas, "star_circle_fx").setVisible(false);
            _this.hideActiveStar();
            _this.add(_this.inactiveStar);
            _this.add(_this.circleFx);
            _this.add(_this.activeStar);
            return _this;
        }
        Object.defineProperty(ProgressBarStar.prototype, "isActive", {
            get: function () {
                return this._isActive;
            },
            enumerable: false,
            configurable: true
        });
        ProgressBarStar.prototype.showActiveStar = function () {
            this.activeStar.visible = true;
            this.activeStar.active = true;
            this._isActive = true;
        };
        ProgressBarStar.prototype.hideActiveStar = function () {
            this.activeStar.visible = false;
            this.activeStar.active = false;
            this._isActive = false;
        };
        ProgressBarStar.prototype.tweenActiveStar = function (delay) {
            var _this = this;
            this.scene.tweens.killTweensOf(this.activeStar);
            this.activeStar.alpha = 0;
            this.scene.tweens.add({
                targets: this.activeStar,
                delay: delay,
                duration: 200,
                ease: Phaser.Math.Easing.Cubic.Out,
                alpha: 1,
                onComplete: function () {
                    _this.inactiveStar.visible = false;
                },
            });
            this.activeStar.scale = 1;
            this.scene.tweens.add({
                targets: this.activeStar,
                delay: delay,
                duration: 500,
                ease: Phaser.Math.Easing.Back.Out,
                scale: 1.5,
                onComplete: function () {
                    _this.scene.tweens.add({
                        targets: _this.activeStar,
                        duration: 100,
                        ease: Phaser.Math.Easing.Linear.Linear,
                        scale: 1,
                        onComplete: function () {
                            _this.showCircleFx();
                            _this.emit(ProgressBarStarEvent.SHOW_COMPLETE, _this);
                        },
                    });
                },
            });
            this.emit(ProgressBarStarEvent.SHOW_START, this);
        };
        ProgressBarStar.prototype.showCircleFx = function () {
            this.circleFx.visible = true;
            this.circleFx.alpha = 0.4;
            this.circleFx.scale = 0.4;
            this.scene.tweens.add({
                targets: this.circleFx,
                duration: 400,
                ease: Phaser.Math.Easing.Quadratic.Out,
                scale: 1.75,
            });
            this.scene.tweens.add({
                targets: this.circleFx,
                delay: 150,
                duration: 250,
                ease: Phaser.Math.Easing.Quadratic.Out,
                alpha: 0,
            });
        };
        return ProgressBarStar;
    }(Phaser.GameObjects.Container));
    game.ProgressBarStar = ProgressBarStar;
})(game || (game = {}));
///<reference path='ProgressBarStar.ts' />
var game;
(function (game) {
    var PointsProgressBar = /** @class */ (function (_super) {
        __extends(PointsProgressBar, _super);
        function PointsProgressBar(scene, props) {
            var _this = _super.call(this, scene) || this;
            _this.currentPoints = 0;
            _this.name = "stars_progress_bar";
            _this.props = props;
            _this.initTwinkleSounds();
            _this.addBack();
            _this.addProgressBar();
            _this.addStarLines();
            _this.addStars();
            return _this;
        }
        PointsProgressBar.prototype.initTwinkleSounds = function () {
            var _this = this;
            this.twinkleStartThrottled = _.throttle(function () {
                if (_this.scene.cache.audio.has(game.GameSoundKey.STAR_TWINKLE_1)) {
                    _this.scene.sound.play(game.GameSoundKey.STAR_TWINKLE_1, { volume: 0.33 });
                }
            }, 100, { trailing: false });
            this.twinkleCompleteThrottled = _.throttle(function () {
                if (_this.scene.cache.audio.has(game.GameSoundKey.STAR_TWINKLE_2)) {
                    _this.scene.sound.play(game.GameSoundKey.STAR_TWINKLE_2, { volume: 0.16 });
                }
            }, 100, { trailing: false });
        };
        PointsProgressBar.prototype.addBack = function () {
            this.back = this.scene.add.image(0, 0, "gameplay_gui", "stars_progress_bar_outer");
            this.back.setOrigin(0, 0.5);
            this.add(this.back);
        };
        PointsProgressBar.prototype.addProgressBar = function () {
            this.progressBar = this.scene.add.image(0, 0, "gameplay_gui", "stars_progress_bar_inner");
            this.progressBar.setOrigin(0, 0.5);
            this.add(this.progressBar);
            if (game.Main.development) {
                this.progressBar.setInteractive();
                this.progressBar.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.onClick, this);
            }
            Phaser.Display.Align.In.Center(this.progressBar, this.back, 0, 0);
        };
        PointsProgressBar.prototype.onClick = function (pointer, x, y) {
            var percent = Phaser.Math.Percent(x, 0, this.progressBar.width);
            this.emit("update_points", percent);
        };
        PointsProgressBar.prototype.addStarLines = function () {
            var _this = this;
            var offsetX = Phaser.Display.Bounds.GetLeft(this.progressBar);
            var linesY = this.progressBar.getCenter().y;
            this.starLines = this.props.starsPoints.map(function (points) {
                var line = _this.scene.add.image(0, 0, "gameplay_gui", "star_line");
                line.x = offsetX + _this.getPositionByPoints(points);
                line.y = linesY;
                _this.add(line);
                return line;
            });
        };
        PointsProgressBar.prototype.addStars = function () {
            var _this = this;
            var offsetX = Phaser.Display.Bounds.GetLeft(this.progressBar);
            var starsY = Phaser.Display.Bounds.GetTop(this.progressBar) - 10;
            this.stars = this.props.starsPoints.map(function (points) {
                var star = new game.ProgressBarStar(_this.scene, "gameplay_gui", "star", "star_inactive");
                star.x = offsetX + _this.getPositionByPoints(points);
                star.y = starsY;
                star.setData("points", points);
                star.on(game.ProgressBarStarEvent.SHOW_START, _this.twinkleStartThrottled, _this);
                star.on(game.ProgressBarStarEvent.SHOW_COMPLETE, _this.twinkleCompleteThrottled, _this);
                _this.add(star);
                return star;
            });
        };
        PointsProgressBar.prototype.getPositionByPoints = function (points) {
            var percent = Phaser.Math.Percent(points, 0, this.props.totalPoints);
            return this.progressBar.width * percent;
        };
        PointsProgressBar.prototype.getPercentFromPoints = function (points) {
            return Phaser.Math.Percent(points, 0, this.props.totalPoints);
        };
        PointsProgressBar.prototype.updateProgressInstant = function (points) {
            this.updateProgressBarCrop(this.getPercentFromPoints(points));
            this.updateStars(points);
        };
        PointsProgressBar.prototype.updateProgress = function (points, tweenDuration) {
            var _this = this;
            this.scene.tweens.add({
                targets: this,
                currentPoints: points,
                duration: tweenDuration,
                ease: Phaser.Math.Easing.Circular.Out,
                onUpdate: function () {
                    _this.updateProgressBarCrop(_this.getPercentFromPoints(_this.currentPoints));
                    _this.updateStars(_this.currentPoints);
                },
            });
        };
        PointsProgressBar.prototype.updateProgressBarCrop = function (percent) {
            percent = Math.max(0.001, percent); // because canvas renderer fails when crop.width is zero
            this.progressBar.setCrop(0, 0, this.progressBar.width * percent, this.progressBar.height);
        };
        PointsProgressBar.prototype.updateStars = function (points) {
            this.stars.forEach(function (star) {
                var wasActive = star.isActive;
                var active = points >= star.getData("points");
                if (active) {
                    star.showActiveStar();
                    if (wasActive === false && active) {
                        star.tweenActiveStar(0);
                    }
                }
                else {
                    star.hideActiveStar();
                }
            });
        };
        PointsProgressBar.prototype.getWidth = function () {
            return this.back.width;
        };
        PointsProgressBar.prototype.getHeight = function () {
            return this.back.height;
        };
        return PointsProgressBar;
    }(Phaser.GameObjects.Container));
    game.PointsProgressBar = PointsProgressBar;
})(game || (game = {}));
///<reference path='PointsProgressBar.ts' />
var game;
(function (game) {
    var PointsLabel = /** @class */ (function (_super) {
        __extends(PointsLabel, _super);
        function PointsLabel(scene, levelConfig) {
            var _this = _super.call(this, scene) || this;
            _this.padding = { x: 18, y: 0 };
            _this.points = 0;
            _this.name = "points_label";
            _this.levelConfig = levelConfig;
            _this.addBack();
            _this.addProgressBar();
            _this.addPointsText();
            return _this;
        }
        PointsLabel.prototype.addBack = function () {
            this.back = this.scene.add.image(0, 0, "gameplay_gui", "points_label_back");
            this.back.setOrigin(0);
            this.add(this.back);
        };
        PointsLabel.prototype.addProgressBar = function () {
            var _this = this;
            var totalPoints = this.levelConfig.stars[2];
            var props = {
                totalPoints: totalPoints,
                starsPoints: this.levelConfig.stars.slice(0),
            };
            this.starsProgressBar = new game.PointsProgressBar(this.scene, props);
            this.starsProgressBar.x = this.back.left + this.padding.x;
            this.starsProgressBar.y = Phaser.Display.Bounds.GetCenterY(this.back) - 3;
            this.starsProgressBar.updateProgressInstant(0);
            this.starsProgressBar.on("update_points", function (percent) {
                _this.updatePoints(totalPoints * percent);
            });
            this.add(this.starsProgressBar);
        };
        PointsLabel.prototype.addPointsText = function () {
            var content = "0";
            this.pointsText = this.scene.add.bitmapText(0, 0, game.BitmapGameFont.INGAME_GUI_DIGITS, content, 28);
            this.pointsText.setTint(game.GameplayGui.FONT_COLOR);
            this.pointsText.setOrigin(1, 0.5);
            this.pointsText.x = this.back.right - this.padding.x - 4;
            this.pointsText.y = this.back.getCenter().y;
            this.add(this.pointsText);
        };
        PointsLabel.prototype.updatePoints = function (value, instant) {
            if (instant === void 0) { instant = false; }
            if (instant) {
                this.points = value;
                this.updatePointsText(this.points);
                this.starsProgressBar.updateProgressInstant(this.points);
                return;
            }
            var tweenDuration = 800;
            this.budgePointsText();
            this.tweenPointsValue(value, tweenDuration);
            this.starsProgressBar.updateProgress(value, tweenDuration);
        };
        PointsLabel.prototype.tweenPointsValue = function (value, tweenDuration) {
            var _this = this;
            this.scene.tweens.killTweensOf(this);
            this.scene.tweens.add({
                targets: this,
                duration: tweenDuration,
                ease: Phaser.Math.Easing.Circular.Out,
                points: value,
                onUpdate: function () {
                    _this.updatePointsText(Math.round(_this.points));
                },
            });
        };
        PointsLabel.prototype.budgePointsText = function () {
            this.scene.tweens.killTweensOf(this.pointsText);
            this.scene.tweens.add({
                targets: this.pointsText,
                duration: 166,
                ease: Phaser.Math.Easing.Sine.InOut,
                x: "-=8",
                yoyo: true,
            });
        };
        PointsLabel.prototype.updatePointsText = function (value) {
            this.pointsText.setText(value.toLocaleString());
        };
        PointsLabel.prototype.getWidth = function () {
            return this.back.width;
        };
        PointsLabel.prototype.getHeight = function () {
            return this.back.height;
        };
        return PointsLabel;
    }(Phaser.GameObjects.Container));
    game.PointsLabel = PointsLabel;
})(game || (game = {}));
///<reference path='MainLabel.ts' />
///<reference path='pointsLabel/PointsLabel.ts' />
var game;
(function (game) {
    var TopPanel = /** @class */ (function (_super) {
        __extends(TopPanel, _super);
        function TopPanel(scene, levelConfig) {
            var _this = _super.call(this, scene) || this;
            _this.labelsY = 0;
            _this.originalY = 0;
            _this.levelConfig = levelConfig;
            _this.name = "top_panel";
            Phaser.Display.Align.In.TopCenter(_this.container, _this.background, 0, 0);
            _this.labelsY = _this.background.height / 2 - 4;
            _this.addShadow();
            _this.addMainLabel();
            _this.addPointsLabel();
            _this.alignItems();
            return _this;
        }
        TopPanel.prototype.addShadow = function () {
            this.shadow = this.scene.add.image(0, 0, "gameplay_gui", "up_panel_shadow");
            this.shadow.setOrigin(0.5, 0);
            this.shadow.alpha = 0.08;
            this.shadow.y = 10;
            this.addAt(this.shadow, 0);
        };
        TopPanel.prototype.addMainLabel = function () {
            this.mainLabel = new game.MainLabel(this.scene, this.levelConfig);
            this.add(this.mainLabel);
        };
        TopPanel.prototype.addPointsLabel = function () {
            this.pointsLabel = new game.PointsLabel(this.scene, this.levelConfig);
            this.add(this.pointsLabel);
        };
        TopPanel.prototype.alignItems = function () {
            var mainLabelWidth = this.mainLabel.getWidth();
            var pointsLabelWidth = this.pointsLabel.getWidth();
            var labelsGap = 30;
            var totalContentWidth = mainLabelWidth + pointsLabelWidth + labelsGap;
            var padding = (this.background.width - totalContentWidth) / 2;
            this.pointsLabel.x = this.background.left + padding;
            this.pointsLabel.y = this.labelsY - this.pointsLabel.getHeight() / 2;
            this.mainLabel.x = this.background.right - mainLabelWidth / 2 - padding;
            this.mainLabel.y = this.labelsY;
        };
        TopPanel.prototype.show = function () {
            this.revive();
            this.scene.tweens.killTweensOf(this);
            this.scene.tweens.add({
                targets: this,
                duration: 200,
                ease: Phaser.Math.Easing.Cubic.Out,
                alpha: 1,
                y: this.originalY,
            });
        };
        TopPanel.prototype.hide = function () {
            this.scene.tweens.killTweensOf(this);
            this.scene.tweens.add({
                targets: this,
                duration: 150,
                ease: Phaser.Math.Easing.Cubic.Out,
                alpha: 0,
                y: this.originalY - 10,
                onComplete: this.kill.bind(this),
            });
        };
        return TopPanel;
    }(game.IngamePanel));
    game.TopPanel = TopPanel;
})(game || (game = {}));
var game;
(function (game) {
    var BottomPanelButton = /** @class */ (function (_super) {
        __extends(BottomPanelButton, _super);
        function BottomPanelButton(scene, texture, frame, parent) {
            var _this = _super.call(this, scene, texture, frame, parent) || this;
            _this.originalY = 0;
            _this.checkIfOver = false;
            return _this;
        }
        BottomPanelButton.prototype.enable = function () {
            this.setInteractive();
            // this.tweenAlpha(1)
        };
        BottomPanelButton.prototype.disable = function () {
            this.disableInteractive();
            // this.tweenAlpha(0.5)
        };
        BottomPanelButton.prototype.tweenAlpha = function (alpha) {
            if (this.alphaTween) {
                this.alphaTween.stop();
            }
            this.alphaTween = this.scene.tweens.add({
                targets: this,
                alpha: { value: alpha, ease: Phaser.Math.Easing.Cubic.Out, duration: 150 },
            });
        };
        return BottomPanelButton;
    }(Phaser.GameObjects.Button));
    game.BottomPanelButton = BottomPanelButton;
})(game || (game = {}));
var game;
(function (game) {
    var FastForwardButton = /** @class */ (function (_super) {
        __extends(FastForwardButton, _super);
        function FastForwardButton(scene, texture, frame, parent) {
            var _this = _super.call(this, scene, texture, frame, parent) || this;
            _this.areTweensEnabled = false;
            return _this;
        }
        FastForwardButton.prototype.playAnimation = function () {
            this.scaleTween = this.scene.tweens.add({
                targets: this,
                duration: 300,
                ease: Phaser.Math.Easing.Sine.InOut,
                scale: 1.1,
                yoyo: true,
                repeat: -1,
            });
        };
        FastForwardButton.prototype.stopAnimation = function () {
            if (this.scaleTween) {
                this.scaleTween.stop();
                this.scene.tweens.add({
                    targets: this,
                    duration: 150,
                    ease: Phaser.Math.Easing.Cubic.Out,
                    scale: 1,
                });
            }
        };
        return FastForwardButton;
    }(game.BottomPanelButton));
    game.FastForwardButton = FastForwardButton;
})(game || (game = {}));
var game;
(function (game) {
    var IngameBoosterNumLabel = /** @class */ (function (_super) {
        __extends(IngameBoosterNumLabel, _super);
        function IngameBoosterNumLabel(scene) {
            var _this = _super.call(this, scene) || this;
            _this.name = "num_label";
            _this.addBack();
            _this.addText();
            return _this;
        }
        IngameBoosterNumLabel.prototype.addBack = function () {
            this.back = this.scene.add.image(0, 0, "gameplay_gui", "boosters/booster_label_num");
            this.add(this.back);
        };
        IngameBoosterNumLabel.prototype.addText = function () {
            this.text = this.scene.add.bitmapText(0, 0, game.BitmapGameFont.BLOCKS_LABEL, "0", 25);
            this.text.setOrigin(0.5, 0.5);
            this.text.y += 2;
            this.text.alpha = 0.9;
            this.add(this.text);
        };
        IngameBoosterNumLabel.prototype.updateNum = function (value) {
            this.text.setText(value.toString());
        };
        return IngameBoosterNumLabel;
    }(Phaser.GameObjects.Container));
    game.IngameBoosterNumLabel = IngameBoosterNumLabel;
})(game || (game = {}));
///<reference path='IngameBoosterNumLabel.ts' />
var game;
(function (game) {
    var Rectangle = Phaser.Geom.Rectangle;
    var EasingString = Phaser.Math.EasingString;
    var IngameBoosterIcon = /** @class */ (function (_super) {
        __extends(IngameBoosterIcon, _super);
        function IngameBoosterIcon(scene, booster) {
            var _this = _super.call(this, scene) || this;
            _this._isSelected = false;
            _this.isLocked = false;
            _this.originalY = 0;
            _this.name = "booster_" + booster.type;
            _this._booster = booster;
            _this._booster.on(game.BoosterEvent.NUM_CHANGED, _this.onBoosterNumChanged, _this);
            _this.addParticles();
            _this.addBack();
            _this.addBackShadow();
            _this.addIcon();
            _this.addNumLabel();
            _this.addPlusButton();
            _this.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, _this.onInputDown, _this);
            _this.scene.input.on(Phaser.Input.Events.POINTER_UP, _this.onInputUp, _this);
            _this.enableInteractive();
            _this.updateView();
            return _this;
        }
        Object.defineProperty(IngameBoosterIcon.prototype, "isSelected", {
            get: function () {
                return this._isSelected;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(IngameBoosterIcon.prototype, "booster", {
            get: function () {
                return this._booster;
            },
            enumerable: false,
            configurable: true
        });
        IngameBoosterIcon.prototype.onBoosterNumChanged = function () {
            this.updateView();
        };
        IngameBoosterIcon.prototype.updateView = function () {
            if (game.Main.areRewardAdsEnabled === false) {
                this.plusButton.kill();
                return;
            }
            if (this._booster.num > 0) {
                this.numLabel.revive();
                this.plusButton.kill();
            }
            else {
                this.numLabel.kill();
                this.plusButton.revive();
            }
        };
        IngameBoosterIcon.prototype.enableInteractive = function () {
            this.setInteractive(this.backBounds, Rectangle.Contains);
            this.input.cursor = "pointer";
        };
        IngameBoosterIcon.prototype.onInputDown = function (pointer) {
            this.currentPointer = pointer;
            this.scene.tweens.add({
                targets: this,
                scale: this.scale * 0.9,
                ease: Phaser.Math.Easing.Cubic.Out,
                duration: 50,
            });
            if (this.scene.cache.audio.has(game.GameSoundKey.TAP)) {
                this.scene.sound.play(game.GameSoundKey.TAP, { volume: 1 });
            }
        };
        IngameBoosterIcon.prototype.onInputUp = function (pointer) {
            if (this.currentPointer && this.currentPointer === pointer) {
                this.currentPointer = null;
                this.scene.tweens.add({
                    targets: this,
                    scale: 1,
                    ease: Phaser.Math.Easing.Back.Out,
                    duration: 300,
                });
            }
        };
        IngameBoosterIcon.prototype.addParticles = function () {
            this.particles = this.scene.add.particles("gameplay_gui");
            this.emitter = this.particles.createEmitter({
                frame: ["boosters/circle_fx"],
                scale: { start: 0.5, end: 2, ease: EasingString.ExpoEaseOut },
                alpha: { start: 1, end: 0, ease: EasingString.ExpoEaseOut },
                lifespan: 2000,
                frequency: 500,
                on: false,
            });
            this.add(this.particles);
        };
        IngameBoosterIcon.prototype.addBack = function () {
            this.back = this.scene.add.image(0, 0, "gameplay_gui", "boosters/booster_back");
            this.add(this.back);
            this.backBounds = this.back.getBounds();
        };
        IngameBoosterIcon.prototype.addBackShadow = function () {
            this.backShadow = this.scene.add.image(0, 0, "gameplay_gui", "boosters/booster_back_shadow");
            this.backShadow.alpha = 0.15;
            this.backShadow.y += 6;
            this.addAt(this.backShadow, 0);
        };
        IngameBoosterIcon.prototype.addIcon = function () {
            var frameName = "boosters/booster_" + this._booster.type;
            this.icon = this.scene.add.image(0, 0, "gameplay_gui", frameName);
            this.add(this.icon);
        };
        IngameBoosterIcon.prototype.addNumLabel = function () {
            var offset = this.back.width / 2 - 15;
            this.numLabel = new game.IngameBoosterNumLabel(this.scene);
            this.numLabel.updateNum(this._booster.num);
            this.numLabel.x = offset;
            this.numLabel.y = offset;
            this.add(this.numLabel);
        };
        IngameBoosterIcon.prototype.addPlusButton = function () {
            this.plusButton = this.scene.add.image(0, 0, "gameplay_gui", "boosters/plus_button");
            this.plusButton.x = this.numLabel.x;
            this.plusButton.y = this.numLabel.y;
            this.add(this.plusButton);
        };
        IngameBoosterIcon.prototype.getWidth = function () {
            return this.back.width;
        };
        IngameBoosterIcon.prototype.getHeight = function () {
            return this.back.height;
        };
        IngameBoosterIcon.prototype.onGiftArrive = function (num) {
            if (this.scene.cache.audio.has(game.GameSoundKey.BLOCK_COLLECTED)) {
                this.scene.sound.play(game.GameSoundKey.BLOCK_COLLECTED, { volume: 0.3 });
            }
            this.numLabel.updateNum(this.booster.num + num);
            this.emitter.explode(1, 0, 0);
            this.scene.tweens.add({
                targets: [this.back, this.icon],
                duration: 233,
                ease: Phaser.Math.Easing.Sine.InOut,
                scale: 1.33,
                yoyo: true,
                delay: this.scene.tweens.stagger(50),
            });
        };
        IngameBoosterIcon.prototype.highlight = function () {
            this._isSelected = true;
            this.emitter.flow(800);
        };
        IngameBoosterIcon.prototype.dim = function () {
            this.alpha = 0.4;
            this.disableInteractive();
        };
        IngameBoosterIcon.prototype.resetHighlight = function () {
            this._isSelected = false;
            this.emitter.on = false;
            this.emitter.killAll();
        };
        IngameBoosterIcon.prototype.resetDim = function () {
            this.alpha = 1;
            if (this.isLocked === false) {
                this.enableInteractive();
            }
        };
        IngameBoosterIcon.prototype.lock = function () {
            if (this.isLocked) {
                return;
            }
            this.isLocked = true;
            // this.disableInteractive()
        };
        IngameBoosterIcon.prototype.unlock = function () {
            if (this.isLocked === false) {
                return;
            }
            this.isLocked = false;
            // this.enableInteractive()
        };
        IngameBoosterIcon.prototype.preDestroy = function () {
            this.scene.input.off(Phaser.Input.Events.POINTER_UP, this.onInputUp, this);
            this._booster.off(game.BoosterEvent.NUM_CHANGED, this.onBoosterNumChanged, this);
            _super.prototype.preDestroy.call(this);
        };
        return IngameBoosterIcon;
    }(Phaser.GameObjects.Container));
    game.IngameBoosterIcon = IngameBoosterIcon;
})(game || (game = {}));
///<reference path='IngameBoosterIcon.ts' />
var game;
(function (game) {
    var IngameBoostersPanel = /** @class */ (function (_super) {
        __extends(IngameBoostersPanel, _super);
        function IngameBoostersPanel(scene, boosters) {
            var _this = _super.call(this, scene) || this;
            _this.originalY = 0;
            _this.name = "boosters_panel";
            _this.addIcons(boosters);
            _this.alignIcons();
            _this.addOverlay();
            return _this;
        }
        IngameBoostersPanel.prototype.addIcons = function (boosters) {
            var _this = this;
            this.icons = boosters.map(function (booster) {
                var icon = new game.IngameBoosterIcon(_this.scene, booster);
                icon.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, _this.onIconClick.bind(_this, icon));
                _this.add(icon);
                return icon;
            });
            this.iconsReversed = this.icons.slice().reverse();
        };
        IngameBoostersPanel.prototype.onIconClick = function (icon) {
            if (icon.booster.num === 0) {
                if (game.Main.areRewardAdsEnabled) {
                    this.scene.events.emit(game.GameplayBoostersEvent.GET_FREE_BOOSTER, icon.booster);
                }
                return;
            }
            if (icon.isLocked) {
                return;
            }
            if (icon.isSelected) {
                this.scene.events.emit(game.GameplayBoostersEvent.CANCEL, icon.booster);
            }
            else {
                this.scene.events.emit(game.GameplayBoostersEvent.SELECT, icon.booster);
            }
        };
        IngameBoostersPanel.prototype.alignIcons = function () {
            var cellSize = 140;
            this.gridAlign({
                cellWidth: cellSize,
                cellHeight: cellSize,
                x: cellSize / 2,
                position: Phaser.Display.Align.CENTER,
                height: 1,
            });
            this.icons.forEach(function (icon) {
                icon.originalY = icon.y;
            });
        };
        IngameBoostersPanel.prototype.addOverlay = function () {
            var bounds = this.getBounds();
            this.overlay = this.scene.add.image(0, 0, "gameplay_gui", "white_rect");
            this.overlay.displayWidth = bounds.width;
            this.overlay.displayHeight = bounds.height;
            this.overlay.x = bounds.centerX;
            this.overlay.y = bounds.centerY;
            this.add(this.overlay);
            this.overlay.alpha = 0.001;
            this.overlay.visible = false;
            this.overlay.setInteractive();
        };
        IngameBoostersPanel.prototype.show = function () {
            var _this = this;
            this.revive();
            this.iconsReversed.forEach(function (icon) {
                icon.alpha = 0;
                icon.y = icon.originalY - 10;
                _this.scene.tweens.add({
                    delay: 150,
                    targets: icon,
                    duration: 150,
                    ease: Phaser.Math.Easing.Cubic.Out,
                    alpha: 1,
                    y: icon.originalY,
                });
            });
        };
        IngameBoostersPanel.prototype.hide = function () {
            var _this = this;
            this.scene.tweens.add({
                targets: this.icons,
                duration: 100,
                ease: Phaser.Math.Easing.Linear.Linear,
                alpha: 0,
                y: "+=10",
            }).on(Phaser.Tweens.Events.TIMELINE_COMPLETE, function () {
                _this.kill();
            });
        };
        IngameBoostersPanel.prototype.enableInput = function () {
            this.overlay.visible = false;
        };
        IngameBoostersPanel.prototype.disableInput = function () {
            this.overlay.visible = true;
        };
        IngameBoostersPanel.prototype.getIconByType = function (boosterType) {
            return this.icons.find(function (icon) { return icon.booster.type === boosterType; });
        };
        IngameBoostersPanel.prototype.highlight = function (boosterType) {
            this.icons.forEach(function (icon) {
                if (icon.booster.type === boosterType) {
                    icon.highlight();
                }
                else {
                    icon.dim();
                }
            });
        };
        IngameBoostersPanel.prototype.resetHighlight = function () {
            this.icons.forEach(function (icon) {
                if (icon.isSelected) {
                    icon.resetHighlight();
                }
                else {
                    icon.resetDim();
                }
            });
        };
        return IngameBoostersPanel;
    }(Phaser.GameObjects.Container));
    game.IngameBoostersPanel = IngameBoostersPanel;
})(game || (game = {}));
var game;
(function (game) {
    var FastForwardPopoverEvent;
    (function (FastForwardPopoverEvent) {
        FastForwardPopoverEvent["SHOW"] = "FastForwardPopover_SHOw";
    })(FastForwardPopoverEvent = game.FastForwardPopoverEvent || (game.FastForwardPopoverEvent = {}));
    var FastForwardPopover = /** @class */ (function (_super) {
        __extends(FastForwardPopover, _super);
        function FastForwardPopover(scene, gameplay) {
            var _this = _super.call(this, scene) || this;
            _this.originalY = 0;
            _this.turnTimer = 0;
            _this.isTurnStarted = false;
            _this.fastForwardWasUsed = false;
            _this.name = "fast_forward_popover";
            _this.addBack();
            _this.addTip();
            _this.addText();
            _this.adjustTextSize();
            _this.alignItems();
            _this.gameplay = gameplay;
            _this.gameplay.events.on(game.GameplayEvent.TURN_START, _this.onTurnStart, _this);
            _this.gameplay.events.on(game.GameplayEvent.TURN_COMPLETE, _this.onTurnComplete, _this);
            _this.gameplay.events.once(game.GameplayEvent.FAST_FORWARD_START, _this.onFastForwardUse, _this);
            return _this;
        }
        FastForwardPopover.prototype.addBack = function () {
            this.back = this.scene.add.image(0, 0, "gameplay_gui", "booster_hint_screen/booster_info_popover");
            this.back.scaleY = 0.75;
            this.back.setOrigin(0.5, 1);
            this.add(this.back);
        };
        FastForwardPopover.prototype.addTip = function () {
            this.tip = this.scene.add.image(0, 0, "gameplay_gui", "booster_hint_screen/booster_info_popover_tip");
            this.tip.setOrigin(0.5, 0);
            this.tip.y = this.back.y - 10;
            this.add(this.tip);
        };
        FastForwardPopover.prototype.addText = function () {
            var content = this.scene.texts.fast_forward_hint;
            var style = {
                fontFamily: game.GameFont.SOUSES,
                fontStyle: game.FontWeight.BOLD,
                fontSize: "30px",
                color: "#205466",
                align: "center",
            };
            this.text = this.scene.add.text(0, 0, content, style);
            this.text.setOrigin(0.5, 0.5);
            this.text.setWordWrapWidth(this.back.width * 0.8);
            this.text.lineSpacing = -3;
            this.text.y = -this.back.displayHeight / 2;
            this.add(this.text);
        };
        FastForwardPopover.prototype.adjustTextSize = function () {
            var maxHeight = this.back.height * 0.8;
            this.text.scale = Math.min(1, maxHeight / this.text.height);
        };
        FastForwardPopover.prototype.alignItems = function () {
            var _this = this;
            this.list.forEach(function (item) {
                item.y -= _this.tip.height;
            });
        };
        FastForwardPopover.prototype.getWidth = function () {
            return this.back.width;
        };
        FastForwardPopover.prototype.offsetTip = function (offset) {
            this.tip.x = -offset / this.scale;
        };
        FastForwardPopover.prototype.onTurnStart = function () {
            if (this.fastForwardWasUsed) {
                return;
            }
            this.turnTimer = 0;
            this.isTurnStarted = true;
        };
        FastForwardPopover.prototype.onTurnComplete = function () {
            this.isTurnStarted = false;
            this.hide();
        };
        FastForwardPopover.prototype.preUpdate = function (time, delta) {
            if (this.visible || this.fastForwardWasUsed || this.isTurnStarted === false) {
                return;
            }
            this.turnTimer += delta;
            if (this.turnTimer > 3500) {
                this.revive();
                this.show();
            }
        };
        FastForwardPopover.prototype.show = function () {
            this.emit(FastForwardPopoverEvent.SHOW, this);
            this.alpha = 0;
            this.y = this.originalY - 12 * this.scale;
            this.scene.tweens.add({
                targets: this,
                duration: 150,
                ease: Phaser.Math.Easing.Linear.Linear,
                alpha: 1,
            });
            this.scene.tweens.add({
                targets: this,
                duration: 500,
                ease: Phaser.Math.Easing.Sine.InOut,
                y: this.originalY,
                yoyo: true,
                repeat: -1,
            });
        };
        FastForwardPopover.prototype.hide = function () {
            var _this = this;
            this.scene.tweens.killTweensOf(this);
            this.scene.tweens.add({
                targets: this,
                duration: 66,
                ease: Phaser.Math.Easing.Linear.Linear,
                alpha: 0,
                onComplete: function () {
                    _this.kill();
                }
            });
        };
        FastForwardPopover.prototype.onFastForwardUse = function () {
            this.fastForwardWasUsed = true;
            this.destroy();
        };
        FastForwardPopover.prototype.destroy = function (fromScene) {
            this.gameplay.events.off(game.GameplayEvent.TURN_START, this.onTurnStart, this);
            this.gameplay.events.off(game.GameplayEvent.TURN_COMPLETE, this.onTurnComplete, this);
            this.gameplay.events.off(game.GameplayEvent.FAST_FORWARD_START, this.onFastForwardUse, this);
            _super.prototype.destroy.call(this, fromScene);
        };
        return FastForwardPopover;
    }(Phaser.GameObjects.Container));
    game.FastForwardPopover = FastForwardPopover;
})(game || (game = {}));
///<reference path='BottomPanelButton.ts' />
///<reference path='FastForwardButton.ts' />
///<reference path='boosters/IngameBoostersPanel.ts' />
///<reference path='../FastForwardPopover.ts' />
var game;
(function (game) {
    var BottomPanel = /** @class */ (function (_super) {
        __extends(BottomPanel, _super);
        function BottomPanel(scene) {
            var _this = _super.call(this, scene) || this;
            _this.name = "bottom_panel";
            _this.background.setOrigin(0.5, 0.5);
            _this.background.scaleY = -1;
            _this.background.y += _this.background.height / 2 + 4;
            _this.background.visible = false;
            Phaser.Display.Align.In.TopCenter(_this.container, _this.background, 0, -_this.strokeThickness - _this.verticalMargin);
            _this.padding = 30;
            _this.buttonsY = _this.background.height / 2 - 5;
            _this.addPauseButton();
            _this.addFastForwardButton();
            _this.addDropBallsButton();
            _this.addBoostersPanel();
            _this.container.alpha = 0.001;
            _this.container.visible = false;
            _this.container.setInteractive();
            _this.bringToTop(_this.container);
            _this.turnButtons = [_this.dropBallsButton, _this.fastForwardButton];
            return _this;
        }
        BottomPanel.prototype.addPauseButton = function () {
            this.pauseButton = this.scene.add.button("gameplay_gui", "button_pause", this);
            this.pauseButton.x = this.background.left + this.pauseButton.width / 2 + this.padding;
            this.pauseButton.y = this.buttonsY + 4;
        };
        BottomPanel.prototype.addFastForwardButton = function () {
            this.fastForwardButton = new game.FastForwardButton(this.scene, "gameplay_gui", "button_fast_forward_2", this);
            this.fastForwardButton.x = this.background.right - this.fastForwardButton.width / 2 - this.padding;
            this.fastForwardButton.y = this.buttonsY - 2;
            this.fastForwardButton.originalY = this.fastForwardButton.y;
            this.add(this.fastForwardButton);
        };
        BottomPanel.prototype.addDropBallsButton = function () {
            this.dropBallsButton = new game.BottomPanelButton(this.scene, "gameplay_gui", "button_drop_balls_2", this);
            this.dropBallsButton.x = this.fastForwardButton.left - this.dropBallsButton.width / 2 - 32;
            this.dropBallsButton.y = this.fastForwardButton.y;
            this.dropBallsButton.originalY = this.dropBallsButton.y;
            this.add(this.dropBallsButton);
        };
        BottomPanel.prototype.addBoostersPanel = function () {
            this.boostersPanel = new game.IngameBoostersPanel(this.scene, this.scene.game.boosters.boosters);
            this.boostersPanel.x = this.background.right - this.boostersPanel.getBounds().width - this.padding;
            this.boostersPanel.y = this.buttonsY - 1;
            this.boostersPanel.originalY = this.boostersPanel.y;
            this.add(this.boostersPanel);
        };
        BottomPanel.prototype.disableInput = function () {
            this.container.visible = true;
        };
        BottomPanel.prototype.enableInput = function () {
            this.container.visible = false;
        };
        BottomPanel.prototype.showTurnButtons = function () {
            var _this = this;
            this.turnButtons.forEach(function (button) {
                button.revive();
                button.enable();
                button.alpha = 0;
                button.y = button.originalY - 10;
                _this.scene.tweens.add({
                    delay: 170,
                    targets: button,
                    duration: 150,
                    ease: Phaser.Math.Easing.Cubic.Out,
                    alpha: 1,
                    y: button.originalY,
                });
            });
        };
        BottomPanel.prototype.hideTurnButtons = function () {
            var _this = this;
            this.scene.tweens.add({
                targets: this.turnButtons,
                duration: 150,
                ease: Phaser.Math.Easing.Linear.Linear,
                y: "+=10",
                alpha: 0,
            }).on(Phaser.Tweens.Events.TIMELINE_COMPLETE, function () {
                _this.turnButtons.forEach(function (button) { return button.kill(); });
            }).on(Phaser.Tweens.Events.TWEEN_START, function () {
                _this.turnButtons.forEach(function (button) { return button.disable(); });
            });
        };
        return BottomPanel;
    }(game.IngamePanel));
    game.BottomPanel = BottomPanel;
})(game || (game = {}));
var game;
(function (game) {
    var BasicBlocksLabel = /** @class */ (function (_super) {
        __extends(BasicBlocksLabel, _super);
        function BasicBlocksLabel(scene, targetItemsType, targetItemsNum) {
            var _this = _super.call(this, scene) || this;
            _this.blockOriginalScale = 0.42;
            _this.currentItemsNum = 0;
            _this.totalItemsNum = 0;
            _this.name = "ducks_label";
            _this.addBlock(targetItemsType);
            _this.addBlockWhiteCopies();
            _this.addText();
            _this.updateTotal(targetItemsNum);
            return _this;
        }
        BasicBlocksLabel.prototype.addBlock = function (targetItemsType) {
            var frame = game.ItemTypeUtil.getFrameName(targetItemsType);
            this.block = this.scene.add.image(0, 0, "gameplay_gui", frame);
            this.block.scale = this.blockOriginalScale;
            this.add(this.block);
        };
        BasicBlocksLabel.prototype.addBlockWhiteCopies = function () {
            var _this = this;
            this.blockWhiteCopies = this.scene.add.group({
                defaultKey: "gameplay_gui",
                defaultFrame: this.getWhiteBlockFrame(this.block.frame.name),
                name: "white_copies",
                createCallback: function (item) {
                    item.x = _this.block.x;
                    item.y = _this.block.y;
                    item.scale = _this.blockOriginalScale;
                    item.active = false;
                    item.visible = false;
                    _this.add(item);
                },
            });
            for (var i = 0; i < 5; i++) {
                this.blockWhiteCopies.create();
            }
        };
        BasicBlocksLabel.prototype.getWhiteBlockFrame = function (originalFrame) {
            var splitIndex = originalFrame.lastIndexOf("/");
            var whiteFrame = originalFrame.substring(0, splitIndex + 1) + "white" + originalFrame.substring(splitIndex, originalFrame.length);
            return whiteFrame;
        };
        BasicBlocksLabel.prototype.addText = function () {
            var content = "0";
            this.text = this.scene.add.bitmapText(0, 0, game.BitmapGameFont.BLOCKS_LABEL, content, 22);
            this.text.setTint(game.GameplayGui.FONT_COLOR);
            this.text.setOrigin(0.5, 0.5);
            this.text.y = this.block.y + 43;
            this.add(this.text);
        };
        BasicBlocksLabel.prototype.incrementCurrent = function () {
            this.currentItemsNum++;
            this.setTextContent(this.currentItemsNum, this.totalItemsNum);
        };
        BasicBlocksLabel.prototype.updateTotal = function (num) {
            this.totalItemsNum = num;
            this.setTextContent(this.currentItemsNum, this.totalItemsNum);
        };
        BasicBlocksLabel.prototype.setTextContent = function (current, total) {
            var content = current + "/" + total;
            this.text.setText(content);
        };
        BasicBlocksLabel.prototype.showWhiteCopy = function () {
            var whiteCopy = this.blockWhiteCopies.getFirstDead(true);
            whiteCopy.revive();
            whiteCopy.scale = this.block.scale;
            whiteCopy.alpha = 0.5;
            this.scene.tweens.add({
                targets: whiteCopy,
                duration: 500,
                ease: Phaser.Math.Easing.Quadratic.Out,
                alpha: 0,
                scale: whiteCopy.scale * 2.66,
                onComplete: function () {
                    whiteCopy.kill();
                },
            });
        };
        BasicBlocksLabel.prototype.tweenBlockIcon = function () {
            this.block.scale = this.blockOriginalScale;
            this.scene.tweens.killTweensOf(this.block);
            this.scene.tweens.add({
                targets: this.block,
                duration: 250,
                ease: Phaser.Math.Easing.Sine.InOut,
                scale: this.blockOriginalScale * 1.33,
                yoyo: true,
            });
        };
        return BasicBlocksLabel;
    }(Phaser.GameObjects.Container));
    game.BasicBlocksLabel = BasicBlocksLabel;
})(game || (game = {}));
var game;
(function (game) {
    var ComplexBlocksLabel = /** @class */ (function (_super) {
        __extends(ComplexBlocksLabel, _super);
        function ComplexBlocksLabel(scene, props) {
            var _this = _super.call(this, scene) || this;
            _this.props = props;
            _this.name = "blocks_label";
            _this.addBack();
            _this.addBlock();
            _this.addText();
            _this.addTick();
            _this.bringToTop(_this.text);
            return _this;
        }
        ComplexBlocksLabel.prototype.addBack = function () {
            this.back = this.scene.add.image(0, 0, "gameplay_gui", this.props.backFrame);
            this.back.setOrigin(0.5, 0);
            this.add(this.back);
        };
        ComplexBlocksLabel.prototype.addBlock = function () {
            this.block = this.scene.add.image(0, 0, "gameplay_gui", game.ItemTypeUtil.getFrameName(game.ItemType.BASIC_BLOCK));
            this.block.scale = 0.94;
            this.block.y = this.back.top + this.block.displayHeight / 2 + 18;
            this.add(this.block);
        };
        ComplexBlocksLabel.prototype.addText = function () {
            var content = "0/0";
            var style = {
                fontFamily: game.GameFont.SOUSES,
                fontStyle: game.FontWeight.BOLD,
                fontSize: "37px",
                color: "#" + this.props.textColor.toString(16),
                align: "center",
            };
            this.text = this.scene.add.text(0, 0, content, style);
            this.text.setOrigin(0.5, 1);
            this.text.y = this.back.bottom - 8;
            this.add(this.text);
        };
        ComplexBlocksLabel.prototype.addTick = function () {
            var offset = -15;
            this.tick = this.scene.add.image(0, 0, "gameplay_gui", this.props.iconFrame);
            this.tick.x = this.back.right + offset;
            this.tick.y = this.back.bottom + offset;
            this.add(this.tick);
        };
        ComplexBlocksLabel.prototype.getHeight = function () {
            return this.back.displayHeight;
        };
        ComplexBlocksLabel.prototype.getDisplayHeight = function () {
            return this.back.displayHeight * this.scaleY;
        };
        ComplexBlocksLabel.prototype.updateData = function (blocksType, currentBlocksNum, totalBlocksNum) {
            this.block.setFrame(game.ItemTypeUtil.getFrameName(blocksType));
            this.text.setText(currentBlocksNum + "/" + totalBlocksNum);
        };
        return ComplexBlocksLabel;
    }(Phaser.GameObjects.Container));
    game.ComplexBlocksLabel = ComplexBlocksLabel;
})(game || (game = {}));
var game;
(function (game) {
    var LevelCompleteBall = /** @class */ (function (_super) {
        __extends(LevelCompleteBall, _super);
        function LevelCompleteBall(scene) {
            var _this = _super.call(this, scene) || this;
            _this.name = "ball_with_shadow";
            _this._jumpHeight = 80;
            _this.jumpDuration = _this._jumpHeight * 3.8;
            _this.addBall();
            _this.addShadow();
            _this.ball.emit(game.IdleBallEvent.SHOW);
            return _this;
        }
        LevelCompleteBall.prototype.addBall = function () {
            this.ball = this.scene.add.image(0, 0, "gameplay_gui", "level_complete/ball_complete");
            this.ball.baseY = 0;
            this.ball.jumpHeight = this._jumpHeight;
            this.ball.setOrigin(0.5, 1);
            this.add(this.ball);
        };
        LevelCompleteBall.prototype.addShadow = function () {
            this.shadow = new game.JumpingBallShadow(this.scene, this.ball, "gameplay_gui", "level_complete/ball_complete_shadow");
            this.add(this.shadow);
        };
        LevelCompleteBall.prototype.playJumpAnimation = function () {
            var _this = this;
            this.ball.scale = 1;
            var deltaScale = 0.15;
            this.scene.tweens.add({
                targets: this.ball,
                duration: this.jumpDuration * 0.66,
                ease: Phaser.Math.Easing.Sine.InOut,
                scaleX: this.ball.scale + deltaScale,
                scaleY: this.ball.scale - deltaScale,
                yoyo: true,
            });
            this.scene.tweens.add({
                targets: this.ball,
                duration: this.jumpDuration,
                ease: Phaser.Math.Easing.Quadratic.Out,
                y: this.ball.y - this._jumpHeight,
                completeDelay: 33,
                onComplete: function () {
                    _this.scene.tweens.add({
                        targets: _this.ball,
                        duration: _this.jumpDuration,
                        ease: Phaser.Math.Easing.Linear.Linear,
                        y: _this.ball.y + _this._jumpHeight,
                        onComplete: function () {
                            _this.playJumpAnimation();
                        },
                    });
                },
            });
        };
        return LevelCompleteBall;
    }(Phaser.GameObjects.Container));
    game.LevelCompleteBall = LevelCompleteBall;
})(game || (game = {}));
///<reference path='LevelCompleteBall.ts' />
var game;
(function (game) {
    var LevelCompletePopup = /** @class */ (function (_super) {
        __extends(LevelCompletePopup, _super);
        function LevelCompletePopup(scene) {
            var _this = _super.call(this, scene) || this;
            _this.name = "popup";
            _this.addBack();
            _this.addBanner();
            _this.addBlocksLabel();
            _this.addSeparator();
            _this.addTexts();
            _this.addFox();
            _this.addJumpingDucks();
            _this.align();
            _this.bringToTop(_this.blocksLabel);
            _this.bringToTop(_this.texts);
            _this.bringToTop(_this.bannerText);
            return _this;
        }
        LevelCompletePopup.prototype.addBack = function () {
            this.back = this.scene.add.image(0, 0, "gameplay_gui", "level_complete/popup_back");
            this.add(this.back);
        };
        LevelCompletePopup.prototype.addBanner = function () {
            this.bannerBack = this.scene.add.image(0, 0, "gameplay_gui", "level_complete/banner");
            this.add(this.bannerBack);
            var maxWidth = 360;
            this.bannerText = this.createBannerText();
            this.bannerText.setOrigin(0.5, 0.5);
            this.bannerText.scale = Math.min(1, maxWidth / this.bannerText.width);
            this.add(this.bannerText);
        };
        LevelCompletePopup.prototype.createBannerText = function () {
            var content = _.compact(this.scene.texts.level_complete_titles);
            var text = this.scene.make.text({
                add: false,
                text: _.sample(content),
                style: {
                    fontFamily: game.GameFont.SOUSES,
                    fontStyle: game.FontWeight.BLACK,
                    fontSize: "55px",
                    color: "#FAD353",
                    align: "center",
                },
            });
            text.setShadow(0, 4, "rgba(0,0,0,0.15)");
            return text;
        };
        LevelCompletePopup.prototype.addBlocksLabel = function () {
            var props = {
                backFrame: "level_complete/blocks_label_back",
                iconFrame: "level_complete/tick",
                textColor: 0xba3339,
            };
            this.blocksLabel = new game.ComplexBlocksLabel(this.scene, props);
            this.add(this.blocksLabel);
        };
        LevelCompletePopup.prototype.addSeparator = function () {
            this.separator = this.scene.add.image(0, 0, "gameplay_gui", "level_complete/separator");
            this.separator.scaleY = 0.75;
            this.add(this.separator);
        };
        LevelCompletePopup.prototype.addTexts = function () {
            var texts = this.createTexts();
            texts.forEach(function (text) { return text.setOrigin(0.5, 0.5); });
            this.texts = this.scene.add.container(0, 0, texts);
            this.texts.name = "texts";
            this.texts.gridAlign({
                position: Phaser.Display.Align.TOP_CENTER,
                width: 1,
                cellWidth: this.back.displayWidth,
                cellHeight: 45,
            });
            this.score.y += 6;
            this.add(this.texts);
        };
        LevelCompletePopup.prototype.createTexts = function () {
            var style = {
                fontFamily: game.GameFont.SOUSES,
                fontStyle: game.FontWeight.BOLD,
                fontSize: "22px",
                color: "#ffffff",
                align: "center",
            };
            this.levelNumber = this.scene.make.text({
                text: this.getLevelNumberTextContent(1),
                style: __assign(__assign({}, style), { fontSize: "42px", color: "#AE6334" }),
                add: false,
            });
            this.score = this.scene.make.text({
                text: this.getScoreTextContent(0),
                style: __assign(__assign({}, style), { fontSize: "33px", color: "#B62C35" }),
                add: false,
            });
            this.highscore = this.scene.make.text({
                text: this.getHighscoreTextContent(0),
                style: __assign(__assign({}, style), { fontSize: "33px", color: "#B62C35" }),
                add: false,
            });
            return [this.levelNumber, this.score, this.highscore];
        };
        LevelCompletePopup.prototype.getLevelNumberTextContent = function (levelNumber) {
            var template = this.scene.texts.level_end.level;
            return template.replace("#", levelNumber.toString());
        };
        LevelCompletePopup.prototype.getScoreTextContent = function (score) {
            var template = this.scene.texts.level_end.score;
            return template.replace("#", score.toLocaleString());
        };
        LevelCompletePopup.prototype.getHighscoreTextContent = function (highscore) {
            var template = this.scene.texts.level_end.highscore;
            return template.replace("#", highscore.toLocaleString());
        };
        LevelCompletePopup.prototype.addFox = function () {
            this.fox = this.scene.add.image(0, 0, "gameplay_gui", "level_complete/fox_win");
            this.add(this.fox);
        };
        LevelCompletePopup.prototype.addJumpingDucks = function () {
            var _this = this;
            this.jumpingDucks = _.times(3, function () {
                var duck = new game.LevelCompleteBall(_this.scene);
                _this.add(duck);
                return duck;
            });
            var centerDuck = this.jumpingDucks[1];
            var rightDuck = this.jumpingDucks[2];
            this.swap(centerDuck, rightDuck);
        };
        LevelCompletePopup.prototype.align = function () {
            this.alignBanner();
            this.alignSeparator();
            this.alignBlocksLabel();
            this.alignTexts();
            this.alignFox();
            this.alignDucks();
        };
        LevelCompletePopup.prototype.alignBanner = function () {
            this.bannerBack.y = this.back.top - 3;
            this.bannerText.y = this.bannerBack.y - 34;
        };
        LevelCompletePopup.prototype.alignSeparator = function () {
            this.separator.y = this.back.y + 16;
        };
        LevelCompletePopup.prototype.alignBlocksLabel = function () {
            var top = this.bannerBack.y;
            var bottom = this.separator.y;
            var height = bottom - top;
            this.blocksLabel.x = this.back.getCenter().x + 2;
            this.blocksLabel.y = top + height / 2 - this.blocksLabel.getHeight() / 2 + 15;
        };
        LevelCompletePopup.prototype.alignTexts = function () {
            var top = this.separator.y;
            var bottom = this.back.bottom;
            var height = bottom - top;
            this.texts.y = top + height / 2 - this.texts.getBounds().height / 2 + 12;
        };
        LevelCompletePopup.prototype.alignFox = function () {
            this.fox.x = this.back.displayWidth * 0.32;
            this.fox.y = this.back.bottom - 70;
        };
        LevelCompletePopup.prototype.alignDucks = function () {
            var baseX = -this.back.displayWidth * 0.33;
            var baseY = this.fox.y;
            var dx = 55;
            var leftDuck = this.jumpingDucks[0];
            leftDuck.x = baseX - dx;
            leftDuck.y = baseY - 20;
            leftDuck.scale = 0.8;
            var centerDuck = this.jumpingDucks[1];
            centerDuck.x = baseX;
            centerDuck.y = baseY;
            centerDuck.scale = 1.05;
            var rightDuck = this.jumpingDucks[2];
            rightDuck.x = baseX + dx;
            rightDuck.y = baseY - 30;
            rightDuck.scale = 0.9;
        };
        LevelCompletePopup.prototype.updateData = function (data) {
            this.blocksLabel.updateData(data.blocksType, data.blocksNum, data.blocksNum);
            this.updateTexts(data.levelNumber, data.score, data.highscore);
        };
        LevelCompletePopup.prototype.updateTexts = function (levelNumber, score, highscore) {
            this.levelNumber.text = this.getLevelNumberTextContent(levelNumber);
            this.score.text = this.getScoreTextContent(score);
            this.highscore.text = this.getHighscoreTextContent(highscore);
        };
        LevelCompletePopup.prototype.resize = function () {
            this.back.displayWidth = (game.Config.GAME_WIDTH + 2) / this.scale;
            this.separator.displayWidth = this.back.displayWidth * 0.8;
            this.alignFox();
            this.alignDucks();
        };
        LevelCompletePopup.prototype.show = function (initialDelay) {
            var dy = 60;
            var originalScale = this.scale;
            this.y += dy;
            this.scale = originalScale * 0.75;
            this.alpha = 0;
            this.scene.tweens.add({
                targets: this,
                delay: initialDelay,
                y: { value: this.y - dy, duration: 600, ease: Phaser.Math.Easing.Back.Out },
                scale: { value: originalScale, duration: 500, ease: Phaser.Math.Easing.Back.Out },
                alpha: { value: 1, duration: 200, ease: Phaser.Math.Easing.Cubic.Out },
            });
            this.showBanner(initialDelay + 200);
            this.showFox(initialDelay + 350);
            this.showDucks();
        };
        LevelCompletePopup.prototype.showBanner = function (delay) {
            this.bannerBack.alpha = 0;
            this.bannerText.alpha = 0;
            this.scene.tweens.add({
                targets: [this.bannerBack, this.bannerText],
                delay: delay,
                duration: 200,
                ease: Phaser.Math.Easing.Cubic.Out,
                alpha: 1,
            });
            this.bannerBack.scale = 1.2;
            this.bannerText.scale = 1.2;
            this.scene.tweens.add({
                targets: [this.bannerBack, this.bannerText],
                delay: delay,
                duration: 500,
                ease: Phaser.Math.Easing.Back.Out,
                scale: 1,
            });
            var deltaY = -30;
            this.bannerBack.y += deltaY;
            this.bannerText.y += deltaY;
            this.scene.tweens.add({
                targets: [this.bannerBack, this.bannerText],
                delay: delay,
                duration: 600,
                ease: Phaser.Math.Easing.Back.Out,
                y: "-=" + deltaY,
            });
        };
        LevelCompletePopup.prototype.showFox = function (delay) {
            this.fox.alpha = 0;
            this.scene.tweens.add({
                targets: this.fox,
                delay: delay,
                alpha: { value: 1, duration: 150, ease: Phaser.Math.Easing.Cubic.Out },
            });
            this.fox.scale = 0.6;
            this.scene.tweens.add({
                targets: this.fox,
                duration: 800,
                delay: delay,
                ease: Phaser.Math.Easing.Elastic.Out,
                easeParams: [0.1, 0.33],
                scale: 1,
                onComplete: this.animateFox.bind(this),
            });
        };
        LevelCompletePopup.prototype.animateFox = function () {
            this.scene.tweens.add({
                targets: this.fox,
                duration: 550,
                ease: Phaser.Math.Easing.Sine.InOut,
                scaleY: 0.97,
                scaleX: 1.02,
                yoyo: true,
                repeat: -1,
            });
        };
        LevelCompletePopup.prototype.showDucks = function () {
            var _this = this;
            this.jumpingDucks.forEach(function (duck, index) {
                var delay = index * 150;
                _this.scene.time.delayedCall(delay, function () {
                    duck.playJumpAnimation();
                });
            });
        };
        LevelCompletePopup.prototype.getWidth = function () {
            return 750;
        };
        LevelCompletePopup.prototype.getHeight = function () {
            return this.back.displayHeight;
        };
        return LevelCompletePopup;
    }(Phaser.GameObjects.Container));
    game.LevelCompletePopup = LevelCompletePopup;
})(game || (game = {}));
var game;
(function (game) {
    var LevelCompleteButtons = /** @class */ (function (_super) {
        __extends(LevelCompleteButtons, _super);
        function LevelCompleteButtons(scene) {
            var _this = _super.call(this, scene) || this;
            _this.cellWidth = 190;
            _this.name = "buttons";
            _this.restartButton = _this.scene.add.button("gameplay_gui", "level_complete/button_restart", _this);
            _this.nextLevelButton = _this.scene.add.button("gameplay_gui", "level_complete/button_play", _this);
            _this.homeButton = _this.scene.add.button("gameplay_gui", "level_complete/button_menu", _this);
            _this.buttons = [_this.restartButton, _this.nextLevelButton, _this.homeButton];
            _this.add(_this.buttons);
            var cellHeight = _this.nextLevelButton.height;
            _this.gridAlign({
                position: Phaser.Display.Align.CENTER,
                cellWidth: _this.cellWidth,
                cellHeight: cellHeight,
                width: 3,
                x: _this.cellWidth / 2,
            });
            return _this;
        }
        LevelCompleteButtons.prototype.getWidth = function () {
            return this.length * this.cellWidth;
        };
        LevelCompleteButtons.prototype.show = function (initialDelay) {
            var _this = this;
            this.list.forEach(function (button, index) {
                var deltaY = 60;
                button.alpha = 0;
                button.scale = 0.66;
                button.y += deltaY;
                _this.scene.tweens.add({
                    targets: button,
                    delay: initialDelay + index * 133,
                    alpha: { value: 1, duration: 150, ease: Phaser.Math.Easing.Cubic.Out },
                    scale: { value: 1, duration: 400, ease: Phaser.Math.Easing.Back.Out },
                    y: { value: button.y - deltaY, duration: 500, ease: Phaser.Math.Easing.Back.Out },
                });
            });
        };
        LevelCompleteButtons.prototype.animatePlayButton = function () {
            this.scene.time.addEvent({
                repeat: -1,
                delay: 3000,
                callback: this.shakePlayButton,
                callbackScope: this,
            });
        };
        LevelCompleteButtons.prototype.shakePlayButton = function () {
            this.scene.tweens.add({
                targets: this.nextLevelButton,
                duration: 266,
                ease: Phaser.Math.Easing.Sine.InOut,
                scaleX: 1.1,
                scaleY: 1.1,
                repeat: 2,
                yoyo: true,
            });
        };
        return LevelCompleteButtons;
    }(Phaser.GameObjects.Container));
    game.LevelCompleteButtons = LevelCompleteButtons;
})(game || (game = {}));
var game;
(function (game) {
    var ConfettiParticle = /** @class */ (function (_super) {
        __extends(ConfettiParticle, _super);
        function ConfettiParticle(scene, frame) {
            var _this = _super.call(this, scene, 0, 0, "gameplay_gui", frame) || this;
            _this.angularVelocity = 0;
            _this.deltaScale = 0;
            _this.speedX = 0;
            _this.speedY = 0;
            return _this;
        }
        ConfettiParticle.prototype.onEmit = function () {
            this.active = true;
            this.visible = true;
            this.scaleY = 1;
            this.angularVelocity = Phaser.Math.RND.realInRange(0.1, 0.15) * Phaser.Math.RND.sign();
            this.deltaScale = this.angularVelocity / 20;
            this.speedX = Phaser.Math.RND.realInRange(-0.08, 0.08);
            this.speedY = Phaser.Math.RND.realInRange(0.18, 0.3);
        };
        ConfettiParticle.prototype.preUpdate = function (time, delta) {
            if (!this.visible) {
                return;
            }
            this.x += this.speedX * delta;
            this.y += this.speedY * delta;
            this.angle += this.angularVelocity * delta;
            this.updateScale(delta);
            this.checkOutOfBounds();
        };
        ConfettiParticle.prototype.updateScale = function (delta) {
            this.scaleY += this.deltaScale * delta;
            if (this.scaleY < -1) {
                this.scaleY = -1;
                this.deltaScale *= -1;
            }
            else if (this.scaleY > 1) {
                this.scaleY = 1;
                this.deltaScale *= -1;
            }
        };
        ConfettiParticle.prototype.checkOutOfBounds = function () {
            var offset = 50;
            if (this.y > game.Config.GAME_HEIGHT + offset || this.x < -offset || this.x > game.Config.GAME_WIDTH + offset) {
                this.visible = false;
                this.active = false;
            }
        };
        return ConfettiParticle;
    }(Phaser.GameObjects.Image));
    game.ConfettiParticle = ConfettiParticle;
})(game || (game = {}));
///<reference path='ConfettiParticle.ts' />
var game;
(function (game) {
    var LevelCompleteConfetti = /** @class */ (function () {
        function LevelCompleteConfetti(scene, particlesNum) {
            if (particlesNum === void 0) { particlesNum = 100; }
            this.timer = 0;
            this.frequency = 66;
            this.amount = 1;
            this.scene = scene;
            this.frames = [1, 2, 3].map(function (num) { return "level_complete/confetti/particle_Confetti_" + num; });
            this.createParticles(particlesNum);
        }
        LevelCompleteConfetti.prototype.createParticles = function (particlesNum) {
            var _this = this;
            this.particles = _.times(particlesNum, function (index) { return _this.createNewParticle(); });
        };
        LevelCompleteConfetti.prototype.createNewParticle = function () {
            var frame = Phaser.Math.RND.pick(this.frames);
            var p = new game.ConfettiParticle(this.scene, frame);
            p.setDepth(game.GameplayGuiDepth.COMPLETE_SCREEN_CONFETTI);
            p.kill();
            this.scene.add.existing(p);
            return p;
        };
        LevelCompleteConfetti.prototype.update = function (delta) {
            this.emit(delta);
        };
        LevelCompleteConfetti.prototype.emit = function (delta) {
            this.timer += delta;
            if (this.timer > this.frequency) {
                this.timer -= this.frequency;
                this.doEmit();
            }
        };
        LevelCompleteConfetti.prototype.doEmit = function () {
            for (var i = 0; i < this.amount; i++) {
                var p = this.particles.find(function (p) { return p.active === false; });
                if (!p) {
                    p = this.createNewParticle();
                    this.particles.push(p);
                }
                p.x = Phaser.Math.RND.between(0, game.Config.GAME_WIDTH);
                p.y = 0;
                p.onEmit();
            }
        };
        LevelCompleteConfetti.prototype.destroy = function (fromScene) {
            this.particles.forEach(function (p) { return p.destroy(fromScene); });
            this.particles.length = 0;
        };
        return LevelCompleteConfetti;
    }());
    game.LevelCompleteConfetti = LevelCompleteConfetti;
})(game || (game = {}));
///<reference path='stars/LevelCompleteStars.ts' />
///<reference path='LevelCompletePopup.ts' />
///<reference path='LevelCompleteButtons.ts' />
///<reference path='confetti/LevelCompleteConfetti.ts' />
var game;
(function (game) {
    var LevelCompleteScreen = /** @class */ (function (_super) {
        __extends(LevelCompleteScreen, _super);
        function LevelCompleteScreen(scene) {
            var _this = _super.call(this, scene) || this;
            _this.backgroundAlpha = 0.75;
            _this.name = "complete_screen";
            _this.addBack();
            _this.addStars();
            _this.addPopup();
            _this.addButtons();
            _this.bringToTop(_this.popup);
            return _this;
        }
        LevelCompleteScreen.prototype.addBack = function () {
            this.background = this.scene.add.image(0, 0, "gameplay_gui", "black_rect");
            this.background.alpha = this.backgroundAlpha;
            this.add(this.background);
        };
        LevelCompleteScreen.prototype.addStars = function () {
            var props = {
                atlas: "gameplay_gui",
                activeStarFrame: "level_complete/star_with_glow",
                inactiveStarFrame: "level_complete/star_inactive",
                whiteStarFrame: "level_complete/star_white",
            };
            this.stars = new game.LevelCompleteStars(this.scene, props);
            this.stars.addEmitter("gameplay_gui", "level_complete/particle_star_4", game.GameplayGuiDepth.COMPLETE_SCREEN_PARTICLES);
            this.add(this.stars);
        };
        LevelCompleteScreen.prototype.addPopup = function () {
            this.popup = new game.LevelCompletePopup(this.scene);
            this.add(this.popup);
        };
        LevelCompleteScreen.prototype.addButtons = function () {
            this.buttons = new game.LevelCompleteButtons(this.scene);
            this.add(this.buttons);
        };
        LevelCompleteScreen.prototype.resize = function () {
            this.resizeBackground();
            this.alignPopup();
            this.alignStars();
            this.alignButtons();
        };
        LevelCompleteScreen.prototype.resizeBackground = function () {
            this.background.setDisplaySize(game.Config.GAME_WIDTH + 4, game.Config.GAME_HEIGHT + 4);
            this.background.x = game.Config.HALF_GAME_WIDTH;
            this.background.y = game.Config.HALF_GAME_HEIGHT;
        };
        LevelCompleteScreen.prototype.alignPopup = function () {
            var maxWidth = game.Config.GAME_WIDTH;
            var maxHeight = game.Config.GAME_HEIGHT * 0.35;
            var scaleX = maxWidth / this.popup.getWidth();
            var scaleY = maxHeight / this.popup.getHeight();
            this.popup.scale = Math.min(scaleX, scaleY);
            this.popup.resize();
            this.popup.x = game.Config.HALF_GAME_WIDTH;
            this.popup.y = game.Config.HALF_GAME_HEIGHT;
        };
        LevelCompleteScreen.prototype.alignStars = function () {
            var popupTop = this.popup.y - (this.popup.getHeight() * this.popup.scale) / 2;
            this.stars.scale = this.popup.scale;
            this.stars.x = game.Config.HALF_GAME_WIDTH;
            this.stars.y = popupTop - 225 * this.popup.scale;
        };
        LevelCompleteScreen.prototype.alignButtons = function () {
            var popupBottom = this.popup.y + (this.popup.getHeight() * this.popup.scale) / 2;
            this.buttons.scale = this.popup.scale;
            this.buttons.x = (game.Config.GAME_WIDTH - this.buttons.getWidth() * this.buttons.scale) / 2;
            this.buttons.y = popupBottom + this.buttons.getBounds().height / 2 + 100 * this.buttons.scale;
        };
        LevelCompleteScreen.prototype.updateData = function (data) {
            this.stars.updateData(data.stars);
            this.popup.updateData(data);
        };
        LevelCompleteScreen.prototype.show = function () {
            this.revive();
            this.resize();
            this.playSound();
            var delay = 100;
            this.showBackground();
            this.showPopup(delay + 200);
            this.showButtons(delay + 400);
            this.showStars(delay + 450);
            this.fadeOutSound(delay + 450);
            this.showConfetti();
        };
        LevelCompleteScreen.prototype.playSound = function () {
            if (this.scene.cache.audio.has(game.GameSoundKey.LEVEL_COMPLETE)) {
                this.sound = this.scene.sound.add(game.GameSoundKey.LEVEL_COMPLETE);
                this.sound.play("", { volume: 1, delay: 0.45 });
            }
        };
        LevelCompleteScreen.prototype.showBackground = function () {
            this.background.alpha = 0;
            this.scene.tweens.add({
                targets: this.background,
                duration: 100,
                ease: Phaser.Math.Easing.Cubic.Out,
                alpha: this.backgroundAlpha,
            });
        };
        LevelCompleteScreen.prototype.showPopup = function (initialDelay) {
            this.popup.show(initialDelay);
        };
        LevelCompleteScreen.prototype.showStars = function (initialDelay) {
            var _this = this;
            this.stars.alpha = 0;
            this.scene.tweens.add({
                targets: this.stars,
                delay: initialDelay,
                duration: 150,
                ease: Phaser.Math.Easing.Cubic.Out,
                alpha: 1,
            });
            var deltaY = 50;
            this.stars.y -= deltaY;
            this.scene.tweens.add({
                targets: this.stars,
                delay: initialDelay,
                duration: 400,
                ease: Phaser.Math.Easing.Back.Out,
                y: this.stars.y + deltaY,
                onComplete: function () {
                    _this.stars.startFloating();
                    _this.stars.showActiveStars(0);
                },
            });
        };
        LevelCompleteScreen.prototype.fadeOutSound = function (initialDelay) {
            if (!this.sound || this.stars.activeStarsNum === 0) {
                return;
            }
            this.scene.tweens.add({
                targets: this.sound,
                delay: initialDelay + 350,
                duration: 200,
                ease: Phaser.Math.Easing.Cubic.Out,
                volume: 0.5,
            });
        };
        LevelCompleteScreen.prototype.showButtons = function (initialDelay) {
            this.buttons.show(initialDelay);
            this.buttons.animatePlayButton();
        };
        LevelCompleteScreen.prototype.showConfetti = function () {
            this.confetti = new game.LevelCompleteConfetti(this.scene);
        };
        LevelCompleteScreen.prototype.preUpdate = function (time, delta) {
            if (this.confetti) {
                this.confetti.update(delta);
            }
        };
        LevelCompleteScreen.prototype.destroy = function (fromScene) {
            _super.prototype.destroy.call(this, fromScene);
            if (this.sound) {
                this.sound.stop();
                this.sound = null;
            }
            if (this.confetti) {
                this.confetti.destroy(fromScene);
                this.confetti = null;
            }
        };
        return LevelCompleteScreen;
    }(Phaser.GameObjects.Container));
    game.LevelCompleteScreen = LevelCompleteScreen;
})(game || (game = {}));
var game;
(function (game) {
    var LevelFailedPopup = /** @class */ (function (_super) {
        __extends(LevelFailedPopup, _super);
        function LevelFailedPopup(scene) {
            var _this = _super.call(this, scene) || this;
            _this.name = "popup";
            _this.addBack();
            _this.addBanner();
            _this.addBlocksLabel();
            _this.addSeparator();
            _this.addTexts();
            _this.addButtons();
            _this.align();
            _this.bringToTop(_this.texts);
            _this.bringToTop(_this.banner);
            return _this;
        }
        LevelFailedPopup.prototype.addBack = function () {
            this.back = this.scene.add.image(0, 0, "gameplay_gui", "level_failed/popup_back");
            this.add(this.back);
        };
        LevelFailedPopup.prototype.addBanner = function () {
            var bannerBack = this.scene.make.image({
                key: "gameplay_gui",
                frame: "level_failed/banner",
                add: false,
            });
            var maxWidth = 360;
            var bannerText = this.createBannerText();
            bannerText.setOrigin(0.5, 0.5);
            bannerText.scale = Math.min(1, maxWidth / bannerText.width);
            bannerText.y = -60;
            this.banner = this.scene.add.container(0, 0, [bannerBack, bannerText]);
            this.add(this.banner);
        };
        LevelFailedPopup.prototype.createBannerText = function () {
            var content = this.scene.texts.level_failed_titles;
            var text = this.scene.make.text({
                add: false,
                text: _.sample(content),
                style: {
                    fontFamily: game.GameFont.SOUSES,
                    fontStyle: game.FontWeight.BLACK,
                    fontSize: "55px",
                    color: "#B8B8B8",
                    align: "center",
                },
            });
            text.setShadow(0, 4, "rgba(0,0,0,0.15)");
            return text;
        };
        LevelFailedPopup.prototype.addBlocksLabel = function () {
            var props = {
                backFrame: "level_failed/blocks_label_back_gray",
                iconFrame: "level_failed/cross",
                textColor: 0x474e52,
            };
            this.blocksLabel = new game.ComplexBlocksLabel(this.scene, props);
            this.add(this.blocksLabel);
        };
        LevelFailedPopup.prototype.addSeparator = function () {
            this.separator = this.scene.add.image(0, 0, "gameplay_gui", "level_failed/separator");
            this.separator.scaleY = 0.75;
            this.add(this.separator);
        };
        LevelFailedPopup.prototype.addTexts = function () {
            var texts = this.createTexts();
            texts.forEach(function (text) { return text.setOrigin(0.5, 0.5); });
            this.texts = this.scene.add.container(0, 0, texts);
            this.texts.name = "texts";
            this.texts.gridAlign({
                position: Phaser.Display.Align.TOP_CENTER,
                width: 1,
                cellWidth: this.back.displayWidth,
                cellHeight: 45,
            });
            this.score.y += 6;
            this.add(this.texts);
        };
        LevelFailedPopup.prototype.createTexts = function () {
            var style = {
                fontFamily: game.GameFont.SOUSES,
                fontStyle: game.FontWeight.BOLD,
                fontSize: "22px",
                color: "#ffffff",
                align: "center",
            };
            this.levelNumber = this.scene.make.text({
                text: this.getLevelNumberTextContent(1),
                style: __assign(__assign({}, style), { fontSize: "42px", color: "#444B4F" }),
                add: false,
            });
            this.score = this.scene.make.text({
                text: this.getScoreTextContent(0),
                style: __assign(__assign({}, style), { fontSize: "33px", color: "#676B6E" }),
                add: false,
            });
            return [this.levelNumber, this.score];
        };
        LevelFailedPopup.prototype.getLevelNumberTextContent = function (levelNumber) {
            var template = this.scene.texts.level_end.level;
            return template.replace("#", levelNumber.toString());
        };
        LevelFailedPopup.prototype.getScoreTextContent = function (score) {
            var template = this.scene.texts.level_end.score;
            return template.replace("#", score.toLocaleString());
        };
        LevelFailedPopup.prototype.addButtons = function () {
            this.homeButton = this.scene.add.button("gameplay_gui", "level_failed/button_menu", this);
            this.restartButton = this.scene.add.button("gameplay_gui", "level_failed/button_restart", this);
        };
        LevelFailedPopup.prototype.align = function () {
            this.alignBanner();
            this.alignSeparator();
            this.alignBlocksLabel();
            this.alignTexts();
            this.alignButtons();
        };
        LevelFailedPopup.prototype.alignBanner = function () {
            this.banner.x = -9;
            this.banner.y = this.back.top + 20;
        };
        LevelFailedPopup.prototype.alignSeparator = function () {
            this.separator.y = this.back.y + 54;
        };
        LevelFailedPopup.prototype.alignBlocksLabel = function () {
            var top = Phaser.Display.Bounds.GetBottom(this.banner);
            var bottom = this.separator.y;
            var height = bottom - top;
            this.blocksLabel.x = this.back.getCenter().x;
            this.blocksLabel.y = top + height / 2 - this.blocksLabel.getHeight() / 2;
        };
        LevelFailedPopup.prototype.alignTexts = function () {
            var top = this.separator.y;
            var bottom = this.back.bottom;
            var height = bottom - top;
            this.texts.y = top + height / 2 - this.texts.getBounds().height / 2 + 15;
        };
        LevelFailedPopup.prototype.alignButtons = function () {
            var offsetX = this.back.displayWidth * 0.3;
            var y = this.back.bottom;
            this.homeButton.x = -offsetX;
            this.homeButton.y = y;
            this.restartButton.x = offsetX;
            this.restartButton.y = y;
        };
        LevelFailedPopup.prototype.updateData = function (data) {
            this.blocksLabel.updateData(data.targetBlocksType, data.blocksKilled, data.blocksRequired);
            this.updateTexts(data.levelNumber, data.score);
        };
        LevelFailedPopup.prototype.updateTexts = function (levelNumber, score) {
            this.levelNumber.text = this.getLevelNumberTextContent(levelNumber);
            this.score.text = this.getScoreTextContent(score);
        };
        LevelFailedPopup.prototype.resize = function () {
            this.back.displayWidth = game.Config.GAME_WIDTH / this.scaleX;
            this.separator.displayWidth = this.back.displayWidth * 0.8;
            this.alignButtons();
        };
        LevelFailedPopup.prototype.show = function (initialDelay) {
            var dy = 50;
            this.y += dy;
            this.alpha = 0;
            this.scene.tweens.add({
                targets: this,
                delay: initialDelay,
                y: { value: this.y - dy, duration: 700, ease: Phaser.Math.Easing.Back.Out },
                alpha: { value: 1, duration: 200, ease: Phaser.Math.Easing.Cubic.Out },
            });
            this.showButtons(initialDelay + 600);
        };
        LevelFailedPopup.prototype.showButtons = function (initialDelay) {
            var _this = this;
            var buttons = [this.homeButton, this.restartButton];
            buttons.forEach(function (button) {
                button.alpha = 0;
                button.scale = 1.33;
            });
            this.scene.tweens.add({
                targets: buttons,
                delay: initialDelay,
                alpha: { value: 1, duration: 200, ease: Phaser.Math.EasingString.Cubic },
                scale: { value: 1, duration: 560, ease: Phaser.Math.EasingString.Cubic },
            }).on(Phaser.Tweens.Events.TWEEN_COMPLETE, function () {
                _this.animateRestartButton();
            });
        };
        LevelFailedPopup.prototype.animateRestartButton = function () {
            this.scene.time.addEvent({
                repeat: -1,
                delay: 3500,
                startAt: 3000,
                callback: this.shakeRestartButton,
                callbackScope: this,
            });
        };
        LevelFailedPopup.prototype.shakeRestartButton = function () {
            this.scene.tweens.add({
                targets: this.restartButton,
                duration: 320,
                ease: Phaser.Math.Easing.Sine.InOut,
                scaleX: 1.15,
                scaleY: 1.15,
                repeat: 2,
                yoyo: true,
            });
        };
        LevelFailedPopup.prototype.getWidth = function () {
            return 750;
        };
        LevelFailedPopup.prototype.getHeight = function () {
            return this.back.displayHeight;
        };
        return LevelFailedPopup;
    }(Phaser.GameObjects.Container));
    game.LevelFailedPopup = LevelFailedPopup;
})(game || (game = {}));
///<reference path='LevelFailedPopup.ts' />
var game;
(function (game) {
    var EasingString = Phaser.Math.EasingString;
    var LevelFailedScreen = /** @class */ (function (_super) {
        __extends(LevelFailedScreen, _super);
        function LevelFailedScreen(scene) {
            var _this = _super.call(this, scene) || this;
            _this.backgroundAlpha = 0.75;
            _this.name = "failed_screen";
            _this.addBack();
            _this.addShine();
            _this.addCryingFox();
            _this.addPopup();
            _this.addTears();
            _this.createRainEmitter();
            _this.buttons = [_this.restartButton, _this.homeButton];
            return _this;
        }
        Object.defineProperty(LevelFailedScreen.prototype, "restartButton", {
            get: function () {
                return this.popup.restartButton;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(LevelFailedScreen.prototype, "homeButton", {
            get: function () {
                return this.popup.homeButton;
            },
            enumerable: false,
            configurable: true
        });
        LevelFailedScreen.prototype.addBack = function () {
            this.background = this.scene.add.image(0, 0, "gameplay_gui", "black_rect");
            this.background.alpha = this.backgroundAlpha;
            this.add(this.background);
        };
        LevelFailedScreen.prototype.addShine = function () {
            this.shine = this.scene.add.image(0, 0, "gameplay_gui", "level_failed/gray");
            this.add(this.shine);
        };
        LevelFailedScreen.prototype.addCryingFox = function () {
            this.fox = this.scene.add.image(0, 0, "gameplay_gui", "level_failed/crying_fox");
            this.add(this.fox);
        };
        LevelFailedScreen.prototype.addPopup = function () {
            this.popup = new game.LevelFailedPopup(this.scene);
            this.add(this.popup);
        };
        LevelFailedScreen.prototype.addTears = function () {
            this.particles = this.scene.add.particles("gameplay_gui");
            this.tearsEmitter = this.createTearEmitter();
            this.rainEmitter = this.createRainEmitter();
            this.add(this.particles);
            this.particles.visible = false;
            this.particles.active = false;
        };
        LevelFailedScreen.prototype.createTearEmitter = function () {
            var _this = this;
            var sign = 1;
            var lifespan = 1500;
            return this.particles.createEmitter({
                frame: "level_failed/particle_tear",
                lifespan: lifespan,
                speedY: 50,
                gravityY: 50,
                frequency: 700,
                quantity: 1,
                x: {
                    onEmit: function () {
                        sign *= -1;
                        return _this.fox.x + sign * 18 * _this.fox.scaleX;
                    },
                },
                y: {
                    onEmit: function () {
                        return _this.fox.y - 138 * _this.fox.scaleY;
                    },
                },
                emitCallback: function (particle) {
                    var fadeOutDuration = 400;
                    _this.scene.tweens.add({
                        targets: particle,
                        duration: fadeOutDuration,
                        ease: Phaser.Math.Easing.Cubic.Out,
                        alpha: 0,
                        delay: lifespan - fadeOutDuration,
                    });
                },
                on: false,
            });
        };
        LevelFailedScreen.prototype.createRainEmitter = function () {
            return this.particles.createEmitter({
                frame: "level_failed/particle_rain",
                lifespan: {
                    onEmit: function () {
                        return game.Config.GAME_HEIGHT * 2.5;
                    },
                },
                scale: { min: 0.66, max: 1 },
                alpha: { start: 1, end: 0.2, ease: EasingString.Cubic },
                gravityY: 1500,
                frequency: 100,
                quantity: 1,
                y: -938,
                x: {
                    onEmit: function () {
                        return Phaser.Math.RND.between(0, game.Config.GAME_WIDTH);
                    },
                },
            });
        };
        LevelFailedScreen.prototype.resize = function () {
            this.resizeBackground();
            this.alignPopup();
            this.alignFox();
            this.alignShine();
        };
        LevelFailedScreen.prototype.resizeBackground = function () {
            this.background.setDisplaySize(game.Config.GAME_WIDTH + 4, game.Config.GAME_HEIGHT + 4);
            this.background.x = game.Config.HALF_GAME_WIDTH;
            this.background.y = game.Config.HALF_GAME_HEIGHT;
        };
        LevelFailedScreen.prototype.alignPopup = function () {
            var maxWidth = game.Config.GAME_WIDTH;
            var maxHeight = game.Config.GAME_HEIGHT * 0.31;
            var scaleX = maxWidth / this.popup.getWidth();
            var scaleY = maxHeight / this.popup.getHeight();
            this.popup.scale = Math.min(scaleX, scaleY);
            this.popup.resize();
            this.popup.x = game.Config.HALF_GAME_WIDTH;
            this.popup.y = game.Config.GAME_HEIGHT * 0.6;
        };
        LevelFailedScreen.prototype.alignFox = function () {
            var isTweening = this.scene.tweens.getTweensOf(this.fox).length > 0;
            if (isTweening) {
                this.scene.tweens.killTweensOf(this.fox);
            }
            this.fox.scale = this.popup.scale;
            this.fox.x = game.Config.HALF_GAME_WIDTH;
            this.fox.y = this.popup.y - ((this.popup.getHeight() + 40) * this.popup.scale) / 2;
            if (isTweening) {
                this.animateFox(this.fox.scale);
            }
        };
        LevelFailedScreen.prototype.alignShine = function () {
            this.shine.scale = (game.Config.GAME_WIDTH * 1.2) / this.shine.width;
            this.shine.x = this.fox.x;
            this.shine.y = this.fox.getTopCenter().y + 70 * this.fox.scale;
        };
        LevelFailedScreen.prototype.updateData = function (data) {
            this.popup.updateData(data);
        };
        LevelFailedScreen.prototype.show = function () {
            this.revive();
            this.resize();
            this.playSound();
            this.showBackground();
            this.showPopup(200);
            this.showFox(400);
            this.showShine(500);
            this.particles.visible = true;
            this.particles.active = true;
        };
        LevelFailedScreen.prototype.playSound = function () {
            if (this.scene.cache.audio.has(game.GameSoundKey.LEVEL_FAILED)) {
                this.sound = this.scene.sound.add(game.GameSoundKey.LEVEL_FAILED);
                this.sound.play("", { delay: 0.33 });
            }
        };
        LevelFailedScreen.prototype.showBackground = function () {
            this.background.alpha = 0;
            this.scene.tweens.add({
                targets: this.background,
                duration: 100,
                ease: Phaser.Math.Easing.Cubic.Out,
                alpha: this.backgroundAlpha,
            });
        };
        LevelFailedScreen.prototype.showPopup = function (initialDelay) {
            this.popup.show(initialDelay);
        };
        LevelFailedScreen.prototype.showFox = function (initialDelay) {
            var _this = this;
            var originalScale = this.fox.scale;
            this.fox.alpha = 0;
            this.fox.scale = originalScale * 0.75;
            this.scene.tweens.add({
                targets: this.fox,
                delay: initialDelay,
                alpha: { value: 1, duration: 150, ease: Phaser.Math.Easing.Cubic.Out },
                scale: { value: originalScale, duration: 800, ease: Phaser.Math.Easing.Back.Out },
                onComplete: function () {
                    _this.tearsEmitter.on = true;
                    _this.animateFox(originalScale);
                },
            });
        };
        LevelFailedScreen.prototype.animateFox = function (originalScale) {
            this.scene.tweens.add({
                targets: this.fox,
                duration: 600,
                ease: Phaser.Math.Easing.Sine.InOut,
                scaleX: originalScale * 1.01,
                scaleY: originalScale * 0.97,
                yoyo: true,
                repeat: -1,
            });
        };
        LevelFailedScreen.prototype.showShine = function (initialDelay) {
            this.shine.alpha = 0;
            this.scene.tweens.add({
                targets: this.shine,
                duration: 1000,
                ease: Phaser.Math.Easing.Cubic.Out,
                alpha: 1,
                delay: initialDelay,
            });
        };
        LevelFailedScreen.prototype.destroy = function (fromScene) {
            if (this.sound) {
                this.sound.stop();
            }
            _super.prototype.destroy.call(this, fromScene);
        };
        return LevelFailedScreen;
    }(Phaser.GameObjects.Container));
    game.LevelFailedScreen = LevelFailedScreen;
})(game || (game = {}));
var game;
(function (game) {
    var GameplayGuiDepth;
    (function (GameplayGuiDepth) {
        GameplayGuiDepth[GameplayGuiDepth["COLLECTED_BLOCKS"] = 1] = "COLLECTED_BLOCKS";
        GameplayGuiDepth[GameplayGuiDepth["GIFT_SCREEN"] = 2] = "GIFT_SCREEN";
        GameplayGuiDepth[GameplayGuiDepth["BOTTOM_PANEL"] = 3] = "BOTTOM_PANEL";
        GameplayGuiDepth[GameplayGuiDepth["TUTORIAL_SCREEN"] = 4] = "TUTORIAL_SCREEN";
        GameplayGuiDepth[GameplayGuiDepth["PAUSE_SCREEN"] = 5] = "PAUSE_SCREEN";
        GameplayGuiDepth[GameplayGuiDepth["FREE_BOOSTERS_SCREEN"] = 6] = "FREE_BOOSTERS_SCREEN";
        GameplayGuiDepth[GameplayGuiDepth["SECOND_CHANCE_SCREEN"] = 7] = "SECOND_CHANCE_SCREEN";
        GameplayGuiDepth[GameplayGuiDepth["COMPLETE_SCREEN"] = 8] = "COMPLETE_SCREEN";
        GameplayGuiDepth[GameplayGuiDepth["COMPLETE_SCREEN_PARTICLES"] = 9] = "COMPLETE_SCREEN_PARTICLES";
        GameplayGuiDepth[GameplayGuiDepth["COMPLETE_SCREEN_CONFETTI"] = 10] = "COMPLETE_SCREEN_CONFETTI";
        GameplayGuiDepth[GameplayGuiDepth["FAILED_SCREEN"] = 11] = "FAILED_SCREEN";
    })(GameplayGuiDepth = game.GameplayGuiDepth || (game.GameplayGuiDepth = {}));
})(game || (game = {}));
var game;
(function (game) {
    var TutorialText = /** @class */ (function (_super) {
        __extends(TutorialText, _super);
        function TutorialText(scene, textContent) {
            var _this = _super.call(this, scene) || this;
            _this.backShadowOffset = 6;
            _this.name = "tutorial_text";
            _this.addFox();
            _this.addBack();
            _this.addFoxPaws();
            _this.addCloseButton();
            _this.addText(textContent);
            _this.align();
            return _this;
        }
        TutorialText.prototype.addFox = function () {
            this.fox = this.scene.add.image(0, 0, "gameplay_gui", "tutorial/fox");
            this.add(this.fox);
        };
        TutorialText.prototype.addBack = function () {
            this.back = this.scene.add.image(0, 0, "gameplay_gui", "tutorial/back");
            this.add(this.back);
        };
        TutorialText.prototype.addFoxPaws = function () {
            this.foxPaws = this.scene.add.image(0, 0, "gameplay_gui", "tutorial/fox_paws");
            this.add(this.foxPaws);
        };
        TutorialText.prototype.addText = function (content) {
            var style = {
                fontFamily: game.GameFont.SOUSES,
                fontStyle: game.FontWeight.BOLD,
                fontSize: "32px",
                color: "#B72C35",
                align: "center",
            };
            this.text = this.scene.add.text(0, 0, content, style);
            this.text.setOrigin(0.5, 0.5);
            this.text.setWordWrapWidth(this.back.width * 0.85);
            this.text.setLineSpacing(-3);
            this.text.y -= this.backShadowOffset / 2;
            this.add(this.text);
        };
        TutorialText.prototype.addCloseButton = function () {
            this.closeButton = this.scene.add.button("gameplay_gui", "tutorial/button_close", this);
        };
        TutorialText.prototype.align = function () {
            this.fox.x = this.back.left + 110;
            this.fox.y = this.back.top;
            this.foxPaws.x = this.fox.x;
            this.foxPaws.y = this.fox.y + 6;
            this.closeButton.x = this.back.right;
            this.closeButton.y = this.back.top;
            this.alignText();
        };
        TutorialText.prototype.alignText = function () {
            var maxHeight = this.back.height * 0.7;
            this.text.scale = 1;
            this.text.scale = Math.min(1, maxHeight / this.text.height);
        };
        TutorialText.prototype.show = function (initialDelay) {
            var textOriginalScale = this.text.scale;
            this.text.scale *= 0.8;
            this.scene.tweens.add({
                targets: this.text,
                scale: { value: textOriginalScale, ease: Phaser.Math.Easing.Back.Out, duration: 500 },
                alpha: { start: 0, to: 1, ease: Phaser.Math.Easing.Cubic.Out, duration: 150 },
                delay: initialDelay,
            });
            this.playWhooshSound();
        };
        TutorialText.prototype.playWhooshSound = function () {
            if (this.scene.cache.audio.has(game.GameSoundKey.WINNING_BALL_WHOOSH)) {
                this.scene.sound.play(game.GameSoundKey.WINNING_BALL_WHOOSH, { volume: 0.66, delay: 0.33 });
            }
        };
        TutorialText.prototype.getWidth = function () {
            return this.back.width;
        };
        TutorialText.prototype.getHeight = function () {
            return this.back.height;
        };
        return TutorialText;
    }(Phaser.GameObjects.Container));
    game.TutorialText = TutorialText;
})(game || (game = {}));
///<reference path='TutorialText.ts' />
var game;
(function (game) {
    var ButtonEvent = Phaser.GameObjects.ButtonEvent;
    var TutorialEvent;
    (function (TutorialEvent) {
        TutorialEvent["COMPLETE"] = "tutorial_complete";
    })(TutorialEvent = game.TutorialEvent || (game.TutorialEvent = {}));
    var TutorialScreen = /** @class */ (function (_super) {
        __extends(TutorialScreen, _super);
        function TutorialScreen(scene, config) {
            var _this = _super.call(this, scene) || this;
            _this.name = "tutorial";
            _this.config = config;
            _this.addBackdrop();
            _this.addWindow();
            _this.addText();
            var isCanvasRenderer = _this.scene.game.rendererType === game.RendererType.CANVAS;
            if (isCanvasRenderer === false) {
                _this.backdrop.mask = _this.window.createGeometryMask();
                _this.backdrop.mask.invertAlpha = true;
            }
            else {
                _this.backdrop.kill();
                _this.window.kill();
            }
            return _this;
        }
        TutorialScreen.prototype.addBackdrop = function () {
            this.backdrop = this.scene.add.image(0, 0, "gameplay_gui", "black_rect");
            this.backdrop.alpha = 0.8;
            this.add(this.backdrop);
        };
        TutorialScreen.prototype.addWindow = function () {
            this.window = this.scene.make.graphics({
                fillStyle: { color: 0xff0000, alpha: 1 },
            });
            var width = this.config.width;
            var height = this.config.height;
            this.window.fillRoundedRect(-width / 2, -height / 2, width, height);
        };
        TutorialScreen.prototype.addText = function () {
            var textContent = this.scene.texts.tutorial[this.config.textKey];
            if (!textContent) {
                console.warn("Add text for this tutorial! [tutorialKey = " + this.config.textKey + "]");
                textContent = this.config.text;
            }
            this.popup = new game.TutorialText(this.scene, textContent);
            this.popup.closeButton.once(ButtonEvent.PRESS, this.onCloseButtonClick, this);
            this.add(this.popup);
        };
        TutorialScreen.prototype.onCloseButtonClick = function () {
            this.emit(TutorialEvent.COMPLETE, this);
            this.hide();
        };
        TutorialScreen.prototype.show = function (initialDelay) {
            this.showText(initialDelay);
            this.animateWindow();
        };
        TutorialScreen.prototype.showText = function (initialDelay) {
            var deltaY = 250;
            this.popup.y += deltaY;
            this.scene.tweens.add({
                targets: this.popup,
                delay: initialDelay,
                duration: 500,
                ease: Phaser.Math.Easing.Back.Out,
                y: this.popup.y - deltaY,
            });
            var originalScale = this.popup.scale;
            this.popup.scale *= 0.8;
            this.scene.tweens.add({
                delay: initialDelay,
                targets: this.popup,
                duration: 400,
                scale: originalScale,
                ease: Phaser.Math.Easing.Back.Out,
            });
            this.popup.alpha = 0;
            this.scene.tweens.add({
                delay: initialDelay,
                targets: this.popup,
                duration: 200,
                ease: Phaser.Math.Easing.Cubic.Out,
                alpha: 1,
            });
            this.popup.show(initialDelay + 150);
        };
        TutorialScreen.prototype.animateWindow = function () {
            if (!this.config.tweenMask) {
                return;
            }
            this.scene.tweens.add({
                targets: this.window,
                duration: 600,
                ease: Phaser.Math.Easing.Sine.InOut,
                scale: this.window.scale * this.config.tweenScale,
                repeat: -1,
                yoyo: true,
            });
        };
        TutorialScreen.prototype.hide = function () {
            this.scene.tweens.add({
                targets: this.popup,
                duration: 500,
                ease: Phaser.Math.Easing.Back.In,
                scale: 0.33,
            });
            this.scene.tweens.add({
                targets: this.popup,
                duration: 500,
                ease: Phaser.Math.Easing.Back.In,
                y: "+=250",
            });
            this.scene.tweens.add({
                targets: this.popup,
                duration: 200,
                delay: 250,
                ease: Phaser.Math.Easing.Cubic.In,
                alpha: 0,
                onComplete: this.onHideComplete.bind(this),
            });
            this.scene.tweens.add({
                targets: this.backdrop,
                duration: 200,
                delay: 300,
                ease: Phaser.Math.Easing.Cubic.Out,
                alpha: 0,
            });
        };
        TutorialScreen.prototype.onHideComplete = function () {
            this.visible = false;
            this.active = false;
            this.scene.tweens.killTweensOf(this.window);
        };
        TutorialScreen.prototype.resize = function (field) {
            this.resizeBackdrop();
            this.resizeWindow(field);
            this.resizeText(field);
        };
        TutorialScreen.prototype.resizeBackdrop = function () {
            this.backdrop.setDisplaySize(game.Config.GAME_WIDTH + 2, game.Config.GAME_HEIGHT + 2);
            this.backdrop.x = game.Config.HALF_GAME_WIDTH;
            this.backdrop.y = game.Config.HALF_GAME_HEIGHT;
        };
        TutorialScreen.prototype.resizeWindow = function (field) {
            var camera = field.camera;
            var cameraPadding = camera.getPadding();
            this.window.x = cameraPadding.x + this.config.x * camera.zoom;
            this.window.y = cameraPadding.y + this.config.y * camera.zoom;
            this.window.scale = camera.zoom;
        };
        TutorialScreen.prototype.resizeText = function (field) {
            this.popup.scale = field.cameras.main.zoom;
            this.popup.x = game.Config.HALF_GAME_WIDTH;
            this.popup.y = game.Config.GAME_HEIGHT - (this.popup.getHeight() / 2) * this.popup.scale - 35;
        };
        TutorialScreen.prototype.destroy = function (fromScene) {
            this.window.destroy(fromScene);
            _super.prototype.destroy.call(this, fromScene);
        };
        return TutorialScreen;
    }(Phaser.GameObjects.Container));
    game.TutorialScreen = TutorialScreen;
})(game || (game = {}));
var game;
(function (game) {
    var PauseScreenEvent;
    (function (PauseScreenEvent) {
        PauseScreenEvent["SHOW"] = "PauseScreen_SHOW";
        PauseScreenEvent["HIDE"] = "PauseScreen_HIDE";
    })(PauseScreenEvent = game.PauseScreenEvent || (game.PauseScreenEvent = {}));
    var PauseScreen = /** @class */ (function (_super) {
        __extends(PauseScreen, _super);
        function PauseScreen(scene) {
            var _this = _super.call(this, scene, {
                backgroundAlpha: 0.85,
                backgroundKey: "gameplay_gui",
                backgroundFrame: "black_rect",
            }) || this;
            _this.name = "pause_screen";
            _this.background.name = "pause_screen_back";
            _this.addResumeButton();
            _this.addOtherButtons();
            _this.buttons = [_this.resumeButton, _this.soundButton, _this.homeButton, _this.restartButton];
            _this.buttonsContainer = _this.scene.add.container(0, 0, _this.buttons);
            _this.buttonsContainer.setName("buttons_container");
            _this.add(_this.buttonsContainer);
            _this.align();
            return _this;
        }
        PauseScreen.prototype.addResumeButton = function () {
            this.resumeButton = this.scene.add.button("gameplay_gui", "pause_screen/button_resume", this.buttonsContainer);
        };
        PauseScreen.prototype.addOtherButtons = function () {
            this.soundButton = this.scene.add.soundButton("gameplay_gui", "pause_screen/button_sound_on", "pause_screen/button_sound_off", this.buttonsContainer);
            this.homeButton = this.scene.add.button("gameplay_gui", "pause_screen/button_home", this.buttonsContainer);
            this.restartButton = this.scene.add.button("gameplay_gui", "pause_screen/button_restart", this.buttonsContainer);
        };
        PauseScreen.prototype.align = function () {
            var dy = 100;
            var dx = 175;
            this.resumeButton.y = -dy;
            var bottomButtonsY = dy;
            this.homeButton.y = bottomButtonsY;
            this.soundButton.x = -dx;
            this.soundButton.y = bottomButtonsY;
            this.restartButton.x = dx;
            this.restartButton.y = bottomButtonsY;
        };
        PauseScreen.prototype.resize = function () {
            this.background.displayHeight = (game.Config.GAME_HEIGHT + 4) / this.scale;
        };
        PauseScreen.prototype.show = function () {
            this.revive();
            this.emit(PauseScreenEvent.SHOW, this);
            this.alpha = 1;
            this.scene.tweens.add({
                targets: this.background,
                duration: 150,
                ease: Phaser.Math.Easing.Cubic.Out,
                alpha: { from: 0, to: this.options.backgroundAlpha },
            });
            this.scene.tweens.add({
                targets: this.buttons,
                duration: 900,
                alpha: { start: 0, from: 0, to: 1, ease: Phaser.Math.Easing.Cubic.Out, duration: 200 },
                scale: { from: 0.75, to: 1 },
                ease: Phaser.Math.Easing.Elastic.Out,
                easeParams: [0.1, 0.4],
                delay: this.scene.tweens.stagger(80),
            });
        };
        PauseScreen.prototype.hide = function () {
            var _this = this;
            this.scene.tweens.add({
                targets: this,
                duration: 100,
                ease: Phaser.Math.Easing.Cubic.Out,
                alpha: 0,
                onComplete: function () {
                    _this.kill();
                    _this.emit(PauseScreenEvent.HIDE, _this);
                },
            });
        };
        return PauseScreen;
    }(Phaser.GameObjects.Screen));
    game.PauseScreen = PauseScreen;
})(game || (game = {}));
var game;
(function (game) {
    var CollectedBlockEvent;
    (function (CollectedBlockEvent) {
        CollectedBlockEvent["MOVE_IN_MIDDLE"] = "CollectedBlock_MOVE_IN_MIDDLE";
        CollectedBlockEvent["MOVE_COMPLETE"] = "CollectedBlock_MOVE_COMPLETE";
    })(CollectedBlockEvent = game.CollectedBlockEvent || (game.CollectedBlockEvent = {}));
    var CollectedBlock = /** @class */ (function (_super) {
        __extends(CollectedBlock, _super);
        function CollectedBlock(scene) {
            return _super.call(this, scene, 0, 0, "gameplay_gui", "blocks/basic_block_01") || this;
        }
        CollectedBlock.prototype.updateFrame = function (originalBlock) {
            this.setFrame(originalBlock.frame.name);
            this.setOrigin(originalBlock.originX, originalBlock.originY);
        };
        CollectedBlock.prototype.moveTo = function (targetPosition, targetScale) {
            var _this = this;
            var distance = Phaser.Math.Distance.Between(this.x, this.y, targetPosition.x, targetPosition.y);
            var duration = Math.max(350, (distance / game.Config.ASSETS_SCALE) * 0.8);
            this.scene.time.delayedCall(duration * 0.75, function () {
                _this.emit(CollectedBlockEvent.MOVE_IN_MIDDLE, _this);
            });
            this.scene.tweens.add({
                targets: this,
                duration: duration,
                ease: Phaser.Math.Easing.Back.In,
                easeParams: [1.1],
                x: targetPosition.x,
                y: targetPosition.y,
                scale: targetScale,
                onComplete: function () {
                    _this.emit(CollectedBlockEvent.MOVE_COMPLETE, _this);
                    _this.kill();
                },
            });
        };
        CollectedBlock.prototype.destroy = function (fromScene) {
            _super.prototype.destroy.call(this, fromScene);
        };
        return CollectedBlock;
    }(Phaser.GameObjects.Image));
    game.CollectedBlock = CollectedBlock;
})(game || (game = {}));
var game;
(function (game) {
    var FastForwardFx = /** @class */ (function (_super) {
        __extends(FastForwardFx, _super);
        function FastForwardFx(scene) {
            var _this = _super.call(this, scene) || this;
            _this.name = "fast_forward";
            _this.addLines();
            return _this;
        }
        FastForwardFx.prototype.addLines = function () {
            var _this = this;
            var linesNum = 4;
            var lineFrames = this.getLineFrames();
            this.lines = _.times(linesNum, function () {
                var frame = Phaser.Math.RND.pick(lineFrames);
                var line = _this.scene.add.image(0, 0, "gameplay_gui", frame);
                _this.add(line);
                return line;
            });
        };
        FastForwardFx.prototype.getLineFrames = function () {
            return [1, 2, 3].map(function (num) { return "fast_forward/fast_forward_line_" + num; });
        };
        FastForwardFx.prototype.resize = function () {
            var dy = game.Config.GAME_HEIGHT / (this.lines.length + 1);
            this.lines.forEach(function (line, index) {
                line.scale = game.Config.GAME_WIDTH / line.width;
                line.x = game.Config.HALF_GAME_WIDTH;
                line.y = dy * (index + 1);
                line.setData("originalY", line.y);
            });
        };
        FastForwardFx.prototype.show = function () {
            this.resize();
            this.revive();
            this.tweenLines();
            this.alpha = 0;
            this.scene.tweens.add({
                targets: this,
                duration: 100,
                ease: Phaser.Math.Easing.Cubic.Out,
                alpha: 1,
            });
        };
        FastForwardFx.prototype.tweenLines = function () {
            var _this = this;
            this.lines.forEach(function (line) {
                line.alpha = 0.66;
                _this.scene.tweens.add({
                    targets: line,
                    delay: Phaser.Math.RND.between(0, 150),
                    duration: 300,
                    ease: Phaser.Math.Easing.Sine.InOut,
                    alpha: 0.3,
                    yoyo: true,
                    repeat: -1,
                });
                _this.tweenLine(line);
            });
        };
        FastForwardFx.prototype.tweenLine = function (line) {
            var _this = this;
            var targetY = line.getData("originalY") + Phaser.Math.RND.sign() * Phaser.Math.RND.between(0, 30);
            var distance = targetY - this.y;
            var duration = distance / 4;
            this.scene.tweens.add({
                targets: line,
                duration: duration,
                ease: Phaser.Math.Easing.Linear.Linear,
                y: targetY,
                onStart: function () {
                    line.scaleX = line.scaleX * Phaser.Math.RND.sign();
                    line.scaleY = line.scaleY * Phaser.Math.RND.sign();
                },
                onComplete: function () {
                    _this.tweenLine(line);
                },
            });
        };
        FastForwardFx.prototype.hide = function () {
            this.scene.tweens.add({
                targets: this,
                duration: 150,
                ease: Phaser.Math.Easing.Cubic.In,
                alpha: 0,
                onComplete: this.onHideComplete.bind(this),
            });
        };
        FastForwardFx.prototype.onHideComplete = function () {
            this.stopLineTweens();
            this.kill();
        };
        FastForwardFx.prototype.stopLineTweens = function () {
            this.scene.tweens.killTweensOf(this.lines);
        };
        return FastForwardFx;
    }(Phaser.GameObjects.Container));
    game.FastForwardFx = FastForwardFx;
})(game || (game = {}));
var game;
(function (game) {
    var GiftedBoosterEvent;
    (function (GiftedBoosterEvent) {
        GiftedBoosterEvent["MOVE_COMPLETE"] = "GiftedBooster_MOVE_COMPLETE";
    })(GiftedBoosterEvent = game.GiftedBoosterEvent || (game.GiftedBoosterEvent = {}));
    var GiftedBooster = /** @class */ (function (_super) {
        __extends(GiftedBooster, _super);
        function GiftedBooster(scene, atlas, boosterType, num) {
            var _this = _super.call(this, scene) || this;
            _this.name = "booster_" + boosterType;
            _this.atlasKey = atlas;
            _this.boosterType = boosterType;
            _this.num = num;
            _this.addIcon(boosterType);
            _this.addText(num);
            return _this;
        }
        GiftedBooster.prototype.addIcon = function (boosterType) {
            this.icon = this.scene.add.image(0, 0, this.atlasKey, this.getIconFrame(boosterType));
            this.add(this.icon);
        };
        GiftedBooster.prototype.getIconFrame = function (boosterType) {
            return "gift_screen/" + boosterType;
        };
        GiftedBooster.prototype.addText = function (num) {
            var content = "+" + num;
            this.text = this.scene.add.bitmapText(0, 0, game.BitmapGameFont.GAMEPLAY_GUI_BOOSTERS, content, 46);
            this.text.setOrigin(0.5, 0.5);
            this.text.y = this.icon.bottom + 38;
            this.add(this.text);
        };
        GiftedBooster.prototype.updateData = function (boosterType, boostersNum) {
            this.icon.setFrame(this.getIconFrame(boosterType));
            this.text.setText("+" + boostersNum.toString());
            this.text.y = this.icon.bottom + 38;
        };
        GiftedBooster.prototype.startFloat = function (initialDelay) {
            this.scene.tweens.add({
                targets: this.list,
                duration: 600,
                ease: Phaser.Math.Easing.Sine.InOut,
                y: "-=18",
                delay: this.scene.tweens.stagger(100, { start: initialDelay }),
                yoyo: true,
                repeat: -1,
            });
        };
        GiftedBooster.prototype.stopFloat = function () {
            this.scene.tweens.killTweensOf(this.list);
            this.icon.y = 0;
            this.text.y = this.icon.bottom + 38;
        };
        GiftedBooster.prototype.moveToIcon = function (icon, delay) {
            var _this = this;
            this.hideText(delay);
            var target = icon.getWorldPosition();
            var localTarget = this.parentContainer.pointToContainer(target);
            var distance = Phaser.Math.Distance.Between(localTarget.x, localTarget.y, this.x, this.y);
            var duration = Math.min(450, distance * 0.8);
            this.scene.tweens.add({
                targets: this,
                delay: delay,
                duration: duration,
                ease: Phaser.Math.Easing.Back.In,
                easeParams: [1.1],
                x: localTarget.x,
                y: localTarget.y,
                scale: 0.33,
                onStart: function () {
                    _this.scene.tweens.killTweensOf(_this.list);
                },
                onComplete: function () {
                    _this.emit(GiftedBoosterEvent.MOVE_COMPLETE, _this);
                    _this.kill();
                    icon.onGiftArrive(_this.num);
                },
            });
            var whooshDelay = delay + duration * 0.6;
            this.playWhooshSound(whooshDelay);
        };
        GiftedBooster.prototype.hideText = function (delay) {
            this.scene.tweens.add({
                targets: this.text,
                delay: delay,
                duration: 100,
                ease: Phaser.Math.Easing.Linear.Linear,
                alpha: 0,
            });
        };
        GiftedBooster.prototype.playWhooshSound = function (delay) {
            if (this.scene.cache.audio.has(game.GameSoundKey.WINNING_BALL_WHOOSH)) {
                this.scene.sound.play(game.GameSoundKey.WINNING_BALL_WHOOSH, { volume: 0.5, delay: delay / 1000 });
            }
        };
        GiftedBooster.prototype.destroy = function (fromScene) {
            if (this.scene) {
                this.scene.tweens.killTweensOf([this, this.text, this.icon]);
            }
            _super.prototype.destroy.call(this, fromScene);
        };
        return GiftedBooster;
    }(Phaser.GameObjects.Container));
    game.GiftedBooster = GiftedBooster;
})(game || (game = {}));
///<reference path='GiftedBooster.ts' />
var game;
(function (game) {
    var EasingString = Phaser.Math.EasingString;
    var GiftScreenEvent;
    (function (GiftScreenEvent) {
        GiftScreenEvent["BOOSTERS_SHOW_COMPLETE"] = "GiftScreen_BOOSTERS_SHOW_COMPLETE";
        GiftScreenEvent["HIDE_COMPLETE"] = "GiftScreen_HIDE_COMPLETE";
    })(GiftScreenEvent = game.GiftScreenEvent || (game.GiftScreenEvent = {}));
    var GiftScreen = /** @class */ (function (_super) {
        __extends(GiftScreen, _super);
        function GiftScreen(scene, atlas, content, boostersPanel) {
            var _this = _super.call(this, scene) || this;
            _this.boostersCollected = 0;
            _this.autoPlay = false;
            _this.name = "gift_screen";
            _this.atlasKey = atlas;
            _this.content = content;
            _this.boostersPanel = boostersPanel;
            _this.addBackground();
            _this.addBoosters();
            _this.addGift();
            _this.addHintText();
            _this.addParticlesContainer();
            _this.addGlowParticles();
            _this.addCircleParticles();
            _this.bringToTop(_this.gift);
            _this.bringToTop(_this.giftWhite);
            _this.bringToTop(_this.hintText);
            return _this;
        }
        GiftScreen.prototype.addBackground = function () {
            this.backgroundAlpha = 0.8;
            this.background = this.scene.add.image(0, 0, this.atlasKey, "black_rect");
            this.background.alpha = this.backgroundAlpha;
            this.background.displayWidth = game.Config.SOURCE_GAME_WIDTH;
            this.background.displayHeight = game.Config.SOURCE_GAME_HEIGHT;
            this.add(this.background);
        };
        GiftScreen.prototype.addBoosters = function () {
            var _this = this;
            var dx = 180;
            var contentArr = Object
                .entries(this.content)
                .map(function (value) { return ({ type: value[0], num: value[1] }); })
                .filter(function (value) { return value.num > 0; });
            this.boosters = contentArr.map(function (entry, index) {
                var icon = new game.GiftedBooster(_this.scene, _this.atlasKey, entry.type, entry.num);
                icon.x = index * dx - ((contentArr.length - 1) * dx) / 2;
                icon.y = 0;
                icon.kill();
                _this.add(icon);
                return icon;
            });
        };
        GiftScreen.prototype.addGift = function () {
            this.gift = this.scene.add.image(0, 0, this.atlasKey, "gift_screen/gift");
            this.gift.y = 200;
            this.add(this.gift);
            this.giftWhite = this.scene.add.image(0, 0, this.atlasKey, "gift_screen/gift_white");
            this.giftWhite.x = this.gift.x;
            this.giftWhite.y = this.gift.y + 10;
            this.giftWhite.setOrigin(this.gift.originX, this.gift.originY);
            this.giftWhite.kill();
            this.add(this.giftWhite);
        };
        GiftScreen.prototype.addHintText = function () {
            var content = this.scene.texts.open_gift;
            var style = {
                fontFamily: game.GameFont.SOUSES,
                fontStyle: game.FontWeight.BOLD,
                fontSize: "40px",
                color: "#ffffff",
                align: "center",
            };
            var wordWrapWidth = game.Config.SOURCE_GAME_WIDTH * 0.75;
            this.hintText = this.scene.add.text(0, 0, content, style);
            this.hintText.setOrigin(0.5, 0.5);
            this.hintText.y = this.gift.bottom + 80;
            this.hintText.setWordWrapWidth(wordWrapWidth, true);
            this.add(this.hintText);
        };
        GiftScreen.prototype.addParticlesContainer = function () {
            this.particlesContainer = this.scene.add.container(0, 0);
            this.particlesContainer.name = "particles_container";
            this.particlesContainer.x = -2;
            this.particlesContainer.y = this.gift.y - 90;
            this.add(this.particlesContainer);
        };
        GiftScreen.prototype.addGlowParticles = function () {
            this.glowParticles = this.scene.add.particles("gameplay_gui");
            this.giftWell = this.glowParticles.createGravityWell({
                power: 10,
                epsilon: 250,
                gravity: 200,
            });
            var emitCircle = new Phaser.Geom.Circle(0, 0, this.giftWhite.displayWidth);
            this.giftAttractEmitter = this.glowParticles.createEmitter({
                frame: ["gift_screen/gift_particle_1"],
                lifespan: 800,
                alpha: { start: 0, end: 1, ease: EasingString.ExpoEaseOut },
                scale: { start: 1.33, end: 0.33 },
                quantity: 2,
                on: false,
            }).setDeathZone({
                source: new Phaser.Geom.Circle(0, 0, emitCircle.radius * 0.25),
                type: "onEnter",
            }).setEmitZone({
                source: emitCircle,
                type: "random",
            });
            this.giftExplodeEmitter = this.glowParticles.createEmitter({
                frame: ["gift_screen/gift_particle_1"],
                lifespan: 3000,
                speed: { min: 10, max: 1200 },
                alpha: { start: 1, end: 0, ease: EasingString.ExpoEaseOut },
                scale: { start: 1.33, end: 0 },
                on: false,
            });
            this.particlesContainer.add(this.glowParticles);
        };
        GiftScreen.prototype.addCircleParticles = function () {
            this.circleParticles = this.scene.add.particles("gameplay_gui");
            this.circlesEmitter = this.circleParticles.createEmitter({
                frame: ["gift_screen/circle_fx"],
                scale: { start: 0.5, end: 1.5, ease: EasingString.ExpoEaseOut },
                alpha: { start: 1, end: 0, ease: EasingString.ExpoEaseOut },
                lifespan: 2000,
                frequency: 500,
                on: false,
            });
            this.particlesContainer.add(this.circleParticles);
        };
        GiftScreen.prototype.resize = function () {
            this.background.displayHeight = (game.Config.GAME_HEIGHT + 4) / this.scale;
        };
        GiftScreen.prototype.show = function () {
            this.showGift(200);
            this.showHintText(400);
        };
        GiftScreen.prototype.showGift = function (initialDelay) {
            var _this = this;
            this.gift.alpha = 0;
            this.gift.scale = 0.8;
            this.scene.tweens.add({
                delay: initialDelay,
                targets: this.gift,
                duration: 200,
                ease: Phaser.Math.Easing.Cubic.Out,
                alpha: 1,
            });
            this.scene.tweens.add({
                delay: initialDelay,
                targets: this.gift,
                duration: 400,
                ease: Phaser.Math.Easing.Back.Out,
                scale: 1,
                onComplete: function () {
                    _this.onGiftShowComplete();
                },
            });
            this.scene.time.delayedCall(200, function () {
                _this.circlesEmitter.flow(1000);
            });
            this.playGiftRevealSound(initialDelay);
        };
        GiftScreen.prototype.playGiftRevealSound = function (initialDelay) {
            if (this.scene.cache.audio.has(game.GameSoundKey.GIFT_REVEAL)) {
                var delay = initialDelay / 1000 + 0.2;
                this.scene.sound.play(game.GameSoundKey.GIFT_REVEAL, { volume: 0.5, delay: delay });
            }
        };
        GiftScreen.prototype.onGiftShowComplete = function () {
            var _this = this;
            if (this.autoPlay) {
                this.scene.time.delayedCall(300, function () {
                    _this.onGiftClick();
                });
            }
            else {
                this.gift.setInteractive();
                this.gift.input.cursor = "pointer";
                this.gift.once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.onGiftClick, this);
            }
            this.scene.tweens.add({
                targets: this.gift,
                duration: 600,
                ease: Phaser.Math.Easing.Sine.InOut,
                scaleX: 1.06,
                scaleY: 0.94,
                yoyo: true,
                repeat: -1,
            });
        };
        GiftScreen.prototype.onGiftClick = function () {
            var _this = this;
            this.hideHintText();
            this.playFancyTapSound();
            this.playGiftChargeSound();
            this.giftAttractEmitter.on = true;
            this.circlesEmitter.setLifespan(500);
            this.circlesEmitter.setAlpha({ start: 0, end: 0.33, ease: EasingString.ExpoEaseOut });
            this.circlesEmitter.setScale({ start: 1.66, end: 0.5, ease: EasingString.Linear });
            this.circlesEmitter.flow(333);
            this.gift.disableInteractive();
            this.scene.tweens.killTweensOf(this.gift);
            this.giftWhite.scaleX = this.gift.scaleX;
            this.giftWhite.scaleY = this.gift.scaleY;
            this.giftWhite.alpha = 0;
            this.giftWhite.revive();
            var duration = 1333;
            this.scene.tweens.add({
                targets: this.giftWhite,
                duration: duration,
                ease: Phaser.Math.Easing.Quadratic.Out,
                alpha: 1,
            });
            this.scene.tweens.add({
                targets: [this.giftWhite, this.gift],
                duration: duration,
                ease: Phaser.Math.Easing.Linear.Linear,
                scale: this.gift.scale * 0.66,
            }).on(Phaser.Tweens.Events.TIMELINE_COMPLETE, function () {
                _this.circlesEmitter.killAll();
                _this.circlesEmitter.setLifespan(900);
                _this.circlesEmitter.setAlpha({ start: 1, end: 0, ease: EasingString.ExpoEaseOut });
                _this.circlesEmitter.setScale({ start: 0.5, end: 3, ease: EasingString.ExpoEaseOut });
                _this.circlesEmitter.explode(1, 0, 0);
                _this.stopChargeSound();
                _this.disableAttractEmitter();
                _this.emitExplosionParticles();
                _this.explodeGift();
                _this.showBoosters();
            });
            this.scene.tweens.add({
                targets: [this.giftWhite, this.gift],
                duration: 33,
                ease: Phaser.Math.Easing.Sine.InOut,
                x: "-=14",
                repeat: -1,
                yoyo: true,
            });
        };
        GiftScreen.prototype.playFancyTapSound = function () {
            if (this.scene.cache.audio.has(game.GameSoundKey.FANCY_TAP)) {
                this.scene.sound.play(game.GameSoundKey.FANCY_TAP, { volume: 1 });
            }
        };
        GiftScreen.prototype.playGiftChargeSound = function () {
            if (this.scene.cache.audio.has(game.GameSoundKey.GIFT_CHARGE)) {
                this.chargeSound = this.scene.sound.add(game.GameSoundKey.GIFT_CHARGE, { volume: 0.5 });
                this.chargeSound.play();
            }
        };
        GiftScreen.prototype.stopChargeSound = function () {
            if (this.chargeSound) {
                this.chargeSound.stop();
            }
        };
        GiftScreen.prototype.disableAttractEmitter = function () {
            this.giftWell.active = false;
            this.giftAttractEmitter.active = false;
            this.giftAttractEmitter.on = false;
            this.giftAttractEmitter.killAll();
        };
        GiftScreen.prototype.emitExplosionParticles = function () {
            this.giftExplodeEmitter.setEmitZone({
                source: new Phaser.Geom.Circle(0, 0, 100),
                type: "random",
            });
            this.giftExplodeEmitter.explode(100, this.giftWell.x, this.giftWell.y - 100);
        };
        GiftScreen.prototype.explodeGift = function () {
            var _this = this;
            this.gift.kill();
            this.playGiftExplodeSound();
            this.scene.tweens.killTweensOf([this.gift, this.giftWhite]);
            var targetOriginY = 0.7;
            this.giftWhite.y -= (this.giftWhite.originY - targetOriginY) * this.giftWhite.displayHeight;
            this.giftWhite.setOrigin(0.5, targetOriginY);
            this.scene.tweens.add({
                targets: this.giftWhite,
                duration: 200,
                ease: Phaser.Math.Easing.Linear.Linear,
                scale: 3,
            });
            this.scene.tweens.add({
                targets: this.giftWhite,
                duration: 500,
                ease: Phaser.Math.Easing.Quintic.Out,
                alpha: 0,
                onComplete: function () {
                    _this.giftWhite.kill();
                },
            });
        };
        GiftScreen.prototype.playGiftExplodeSound = function () {
            if (this.scene.cache.audio.has(game.GameSoundKey.GIFT_EXPLODE)) {
                this.scene.sound.play(game.GameSoundKey.GIFT_EXPLODE, { volume: 1 });
            }
        };
        GiftScreen.prototype.showBoosters = function () {
            var _this = this;
            this.boosters.forEach(function (booster, index) {
                var x = booster.x;
                var y = booster.y;
                booster.revive();
                booster.startFloat(index * 150);
                booster.x = _this.giftWhite.x;
                booster.y = _this.giftWhite.y;
                booster.scale = 0.25;
                booster.alpha = 0;
                _this.scene.tweens.add({
                    targets: booster,
                    duration: 200,
                    ease: Phaser.Math.Easing.Cubic.Out,
                    alpha: 1,
                });
                _this.scene.tweens.add({
                    targets: booster,
                    duration: 1000,
                    ease: Phaser.Math.Easing.Elastic.Out,
                    easeParams: [0.1, 0.4],
                    scale: 1,
                });
                _this.scene.tweens.add({
                    targets: booster,
                    duration: 1200,
                    ease: Phaser.Math.Easing.Elastic.Out,
                    easeParams: [0.1, 0.4],
                    x: x,
                    y: y,
                });
            });
            this.scene.time.delayedCall(600, function () {
                _this.onBoostersShowComplete();
            });
        };
        GiftScreen.prototype.onBoostersShowComplete = function () {
            var _this = this;
            this.emit(GiftScreenEvent.BOOSTERS_SHOW_COMPLETE, this);
            if (this.autoPlay) {
                this.scene.time.delayedCall(200, function () {
                    _this.onBoostersClick();
                });
            }
            else {
                this.background.setInteractive();
                this.background.once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.onBoostersClick, this);
            }
        };
        GiftScreen.prototype.onBoostersClick = function () {
            this.background.disableInteractive();
            this.playFancyTapSound();
            this.collectBoosters();
        };
        GiftScreen.prototype.collectBoosters = function () {
            var _this = this;
            this.boostersCollected = 0;
            this.boosters.forEach(function (booster, index) {
                var delay = index * 133;
                var icon = _this.boostersPanel.getIconByType(booster.boosterType);
                booster.on(game.GiftedBoosterEvent.MOVE_COMPLETE, _this.onBoosterCollectComplete, _this);
                booster.moveToIcon(icon, delay);
            });
        };
        GiftScreen.prototype.onBoosterCollectComplete = function () {
            if (++this.boostersCollected < this.boosters.length) {
                return;
            }
            this.onAllBoostersCollected();
        };
        GiftScreen.prototype.onAllBoostersCollected = function () {
            this.hide();
        };
        GiftScreen.prototype.hide = function () {
            var _this = this;
            this.scene.tweens.add({
                targets: this,
                duration: 300,
                ease: Phaser.Math.Easing.Linear.Linear,
                alpha: 0,
                onComplete: function () {
                    _this.emit(GiftScreenEvent.HIDE_COMPLETE, _this);
                    _this.destroy();
                },
            });
        };
        GiftScreen.prototype.showHintText = function (initialDelay) {
            this.hintText.alpha = 0;
            this.scene.tweens.add({
                targets: this.hintText,
                delay: initialDelay,
                duration: 600,
                ease: Phaser.Math.Easing.Quadratic.Out,
                alpha: 1,
            });
            this.scene.tweens.add({
                targets: this.hintText,
                duration: 600,
                ease: Phaser.Math.Easing.Sine.InOut,
                scale: 1.14,
                yoyo: true,
                repeat: -1,
            });
        };
        GiftScreen.prototype.hideHintText = function () {
            var _this = this;
            this.scene.tweens.killTweensOf(this.hintText);
            this.scene.tweens.add({
                targets: this.hintText,
                duration: 150,
                ease: Phaser.Math.Easing.Cubic.Out,
                alpha: 0,
                y: "+=15",
                onComplete: function () {
                    _this.hintText.kill();
                },
            });
        };
        GiftScreen.prototype.destroy = function (fromScene) {
            this.circleParticles.destroy(fromScene);
            this.glowParticles.destroy(fromScene);
            if (this.chargeSound) {
                this.chargeSound.destroy();
            }
            _super.prototype.destroy.call(this, fromScene);
        };
        return GiftScreen;
    }(Phaser.GameObjects.Container));
    game.GiftScreen = GiftScreen;
})(game || (game = {}));
var game;
(function (game) {
    var BoosterInfoPopover = /** @class */ (function (_super) {
        __extends(BoosterInfoPopover, _super);
        function BoosterInfoPopover(scene) {
            var _this = _super.call(this, scene) || this;
            _this.originalY = 0;
            _this.name = "booster_info_popover";
            _this.booster = _this.scene.game.boosters.getRandom();
            _this.addBack();
            _this.addTip();
            _this.addText();
            _this.alignItems();
            return _this;
        }
        BoosterInfoPopover.prototype.addBack = function () {
            this.back = this.scene.add.image(0, 0, "gameplay_gui", "booster_hint_screen/booster_info_popover");
            this.back.setOrigin(0.5, 1);
            this.add(this.back);
        };
        BoosterInfoPopover.prototype.addTip = function () {
            this.tip = this.scene.add.image(0, 0, "gameplay_gui", "booster_hint_screen/booster_info_popover_tip");
            this.tip.setOrigin(0.5, 0);
            this.tip.y = this.back.y - 10;
            this.add(this.tip);
        };
        BoosterInfoPopover.prototype.addText = function () {
            var content = this.booster.hint;
            var style = {
                fontFamily: game.GameFont.SOUSES,
                fontStyle: game.FontWeight.BOLD,
                fontSize: "24px",
                color: "#205466",
                align: "center",
            };
            this.text = this.scene.add.text(0, 0, content, style);
            this.text.setOrigin(0.5, 0.5);
            this.text.setWordWrapWidth(this.back.width * 0.8);
            this.text.lineSpacing = -3;
            this.text.y = -this.back.height / 2;
            this.add(this.text);
        };
        BoosterInfoPopover.prototype.updateText = function (content) {
            this.text.setText(content);
            this.adjustTextSize();
        };
        BoosterInfoPopover.prototype.adjustTextSize = function () {
            var maxHeight = this.back.height * 0.8;
            this.text.scale = Math.min(1, maxHeight / this.text.height);
        };
        BoosterInfoPopover.prototype.alignItems = function () {
            var _this = this;
            this.list.forEach(function (item) {
                item.y -= _this.tip.height;
            });
        };
        BoosterInfoPopover.prototype.getWidth = function () {
            return this.back.width;
        };
        BoosterInfoPopover.prototype.offsetTip = function (offset) {
            this.tip.x = -offset / this.scale;
        };
        return BoosterInfoPopover;
    }(Phaser.GameObjects.Container));
    game.BoosterInfoPopover = BoosterInfoPopover;
})(game || (game = {}));
///<reference path='BoosterInfoPopover.ts' />
var game;
(function (game) {
    var BoosterHintScreen = /** @class */ (function (_super) {
        __extends(BoosterHintScreen, _super);
        function BoosterHintScreen(scene, bottomPanel) {
            var _this = _super.call(this, scene) || this;
            _this.backgroundAlpha = 0.85;
            _this.name = "booster_hint_screen";
            _this.bottomPanel = bottomPanel;
            _this.boostersPanel = bottomPanel.boostersPanel;
            _this.addWindow();
            _this.addBackground();
            _this.addPopover();
            _this.addHintText();
            var isCanvasRenderer = _this.scene.game.rendererType === game.RendererType.CANVAS;
            if (isCanvasRenderer) {
                _this.background.kill();
                _this.window.kill();
                _this.hintText.setStroke("rgba(0,0,0,0.66)", 10);
            }
            return _this;
        }
        BoosterHintScreen.prototype.addWindow = function () {
            this.window = this.scene.make.graphics({
                fillStyle: { color: 0xff0000, alpha: 1 },
            });
            var width = 100;
            var height = 100;
            this.window.fillRoundedRect(-width / 2, -height / 2, width, height);
        };
        BoosterHintScreen.prototype.addBackground = function () {
            this.background = this.scene.add.image(0, 0, "gameplay_gui", "black_rect");
            this.background.alpha = this.backgroundAlpha;
            this.background.mask = this.window.createGeometryMask();
            this.background.mask.invertAlpha = true;
            this.background.name = "booster_hint_screen_back";
            this.add(this.background);
        };
        BoosterHintScreen.prototype.addPopover = function () {
            this.popover = new game.BoosterInfoPopover(this.scene);
            this.add(this.popover);
        };
        BoosterHintScreen.prototype.addHintText = function () {
            var content = this.scene.texts.booster_hint;
            var style = {
                fontFamily: game.GameFont.SOUSES,
                fontStyle: game.FontWeight.BOLD,
                fontSize: "33px",
                color: "#ffffff",
                align: "center",
            };
            this.hintText = this.scene.add.text(0, 0, content, style);
            this.hintText.setOrigin(0.5, 0.5);
            this.hintText.setLineSpacing(-6);
            this.add(this.hintText);
        };
        BoosterHintScreen.prototype.resize = function (gameplay) {
            this.resizeBackground();
            this.resizeWindow(gameplay);
            this.alignWindow(gameplay);
            this.alignPopover();
            this.alignHintText();
        };
        BoosterHintScreen.prototype.resizeBackground = function () {
            this.background.displayWidth = game.Config.GAME_WIDTH + 4;
            this.background.displayHeight = game.Config.GAME_HEIGHT + 4;
            this.background.x = game.Config.HALF_GAME_WIDTH;
            this.background.y = game.Config.HALF_GAME_HEIGHT;
        };
        BoosterHintScreen.prototype.resizeWindow = function (gameplay) {
            var padding = 30;
            var width = gameplay.grid.getWidth() + padding;
            var height = gameplay.grid.getHeight() + padding;
            this.window.fillRoundedRect(-width / 2, -height / 2, width, height);
            this.window.width = width;
            this.window.height = height;
        };
        BoosterHintScreen.prototype.alignWindow = function (field) {
            var camera = field.camera;
            var cameraPadding = camera.getPadding();
            this.window.x = cameraPadding.x + camera.zoom * field.grid.getWidth() / 2;
            this.window.y = cameraPadding.y + camera.zoom * field.grid.getHeight() / 2;
            this.window.scale = camera.zoom;
        };
        BoosterHintScreen.prototype.alignPopover = function () {
            var scale = this.bottomPanel.scale;
            var icon = this.boostersPanel.getIconByType(this.popover.booster.type);
            var position = icon.getWorldPosition();
            this.popover.scale = scale;
            this.popover.y = position.y - 65 * scale;
            this.popover.originalY = this.popover.y;
            var right = game.Config.GAME_WIDTH - 20 * scale;
            var maxX = right - ((this.popover.getWidth() - 20) * scale) / 2;
            if (position.x > maxX) {
                this.popover.x = maxX;
                this.popover.offsetTip(maxX - position.x);
            }
            else {
                this.popover.x = position.x;
                this.popover.offsetTip(0);
            }
        };
        BoosterHintScreen.prototype.alignHintText = function () {
            var top = 0;
            var bottom = this.window.y - (this.window.height * this.window.scale) / 2;
            var height = bottom - top;
            var maxHeight = height * 0.6;
            var maxWidth = (this.window.width * this.window.scale) * 0.85;
            this.hintText.x = game.Config.HALF_GAME_WIDTH;
            this.hintText.y = top + height / 2;
            this.hintText.setWordWrapWidth(maxWidth);
            this.hintText.scale = Math.min(1, maxHeight / this.hintText.height);
            this.hintText.originalY = this.hintText.y;
            this.hintText.originalScale = this.hintText.scale;
        };
        BoosterHintScreen.prototype.updateData = function (booster) {
            this.updatePopover(booster);
        };
        BoosterHintScreen.prototype.updatePopover = function (booster) {
            this.popover.booster = booster;
            this.popover.updateText(booster.hint);
            this.alignPopover();
        };
        BoosterHintScreen.prototype.show = function () {
            this.revive();
            this.alpha = 1;
            this.showBackground(0);
            this.showPopover(0);
            this.showText(200);
        };
        BoosterHintScreen.prototype.showBackground = function (delay) {
            this.background.alpha = 0;
            this.scene.tweens.add({
                targets: this.background,
                duration: 200,
                ease: Phaser.Math.Easing.Linear.Linear,
                alpha: this.backgroundAlpha,
            });
        };
        BoosterHintScreen.prototype.showPopover = function (delay) {
            this.popover.revive();
            this.popover.alpha = 0;
            this.popover.y = this.popover.originalY - 20;
            this.scene.tweens.add({
                delay: delay,
                targets: this.popover,
                duration: 150,
                ease: Phaser.Math.Easing.Cubic.Out,
                alpha: 1,
            });
            this.scene.tweens.add({
                delay: delay,
                targets: this.popover,
                duration: 400,
                ease: Phaser.Math.Easing.Back.Out,
                y: this.popover.originalY,
            });
        };
        BoosterHintScreen.prototype.showText = function (delay) {
            var _this = this;
            this.hintText.alpha = 0;
            this.hintText.scale = this.hintText.originalScale * 0.8;
            this.hintText.y = this.hintText.originalY - 30;
            this.scene.tweens.add({
                delay: delay,
                targets: this.hintText,
                duration: 200,
                ease: Phaser.Math.Easing.Cubic.Out,
                alpha: 1,
            });
            this.scene.tweens.add({
                delay: delay,
                targets: this.hintText,
                duration: 500,
                ease: Phaser.Math.Easing.Back.Out,
                y: this.hintText.originalY,
            });
            this.scene.tweens.add({
                delay: delay,
                targets: this.hintText,
                duration: 400,
                ease: Phaser.Math.Easing.Back.Out,
                scale: this.hintText.originalScale,
                onComplete: function () {
                    _this.scene.tweens.add({
                        targets: _this.hintText,
                        duration: 666,
                        ease: Phaser.Math.Easing.Sine.InOut,
                        scale: _this.hintText.originalScale * 0.9,
                        yoyo: true,
                        repeat: -1,
                    });
                },
            });
        };
        BoosterHintScreen.prototype.hide = function () {
            var _this = this;
            this.popover.kill();
            this.scene.tweens.killTweensOf(this.hintText);
            this.scene.tweens.add({
                targets: this,
                duration: 150,
                ease: Phaser.Math.Easing.Linear.Linear,
                alpha: 0,
                onComplete: function () {
                    _this.kill();
                },
            });
        };
        BoosterHintScreen.prototype.destroy = function (fromScene) {
            this.window.destroy(fromScene);
            _super.prototype.destroy.call(this, fromScene);
        };
        return BoosterHintScreen;
    }(Phaser.GameObjects.Container));
    game.BoosterHintScreen = BoosterHintScreen;
})(game || (game = {}));
var game;
(function (game) {
    var Flash = /** @class */ (function (_super) {
        __extends(Flash, _super);
        function Flash(scene, atlas, frame) {
            return _super.call(this, scene, 0, 0, atlas, frame) || this;
        }
        Flash.prototype.show = function (options) {
            var _this = this;
            this.revive();
            this.scene.tweens.killTweensOf(this);
            this.alpha = 0;
            this.scene.tweens.add({
                targets: this,
                duration: options.fadeInDuration,
                ease: Phaser.Math.Easing.Linear.Linear,
                alpha: options.targetAlpha,
                onComplete: function () {
                    _this.scene.tweens.add({
                        targets: _this,
                        duration: options.fadeOutDuration,
                        ease: Phaser.Math.Easing.Quadratic.In,
                        alpha: 0,
                        onComplete: function () {
                            _this.kill();
                        },
                    });
                },
            });
        };
        Flash.prototype.resize = function () {
            this.displayWidth = game.Config.GAME_WIDTH + 4;
            this.displayHeight = game.Config.GAME_HEIGHT + 4;
            this.x = game.Config.HALF_GAME_WIDTH;
            this.y = game.Config.HALF_GAME_HEIGHT;
        };
        Flash.prototype.destroy = function (fromScene) {
            _super.prototype.destroy.call(this, fromScene);
        };
        return Flash;
    }(Phaser.GameObjects.Image));
    game.Flash = Flash;
})(game || (game = {}));
var game;
(function (game) {
    var SecondChancePopup = /** @class */ (function (_super) {
        __extends(SecondChancePopup, _super);
        function SecondChancePopup(scene, atlas) {
            var _this = _super.call(this, scene) || this;
            _this.name = "popup";
            _this.atlas = atlas;
            _this.addBack();
            _this.addFox();
            _this.addTitle();
            _this.addSubtitle();
            _this.addBlocksLabel();
            _this.alignBlocksLabel();
            _this.sendToBack(_this.fox);
            _this.bringToTop(_this.title);
            _this.bringToTop(_this.subtitle);
            return _this;
        }
        SecondChancePopup.prototype.addBack = function () {
            this.back = this.scene.add.image(0, 0, this.atlas, "second_chance/popup_back");
            this.add(this.back);
        };
        SecondChancePopup.prototype.addFox = function () {
            this.fox = this.scene.add.image(0, 0, this.atlas, "second_chance/fox");
            this.fox.x = -3;
            this.fox.y = this.back.top - 10;
            this.add(this.fox);
            this.foxPaws = this.scene.add.image(0, 0, this.atlas, "second_chance/fox_paws");
            this.foxPaws.x = this.fox.x + 4;
            this.foxPaws.y = this.fox.y + 19;
            this.add(this.foxPaws);
            this.foxBubble = this.scene.add.image(0, 0, this.atlas, "second_chance/fox_bubble");
            this.foxBubble.x = this.fox.x - 100;
            this.foxBubble.y = this.fox.y - 116;
            this.add(this.foxBubble);
        };
        SecondChancePopup.prototype.addTitle = function () {
            var content = this.scene.texts.second_chance.title;
            var style = {
                fontFamily: game.GameFont.SOUSES,
                fontStyle: game.FontWeight.BOLD,
                fontSize: "44px",
                color: "#B62D35",
            };
            this.title = this.scene.add.text(0, 0, content, style);
            this.title.setOrigin(0.5, 0.5);
            this.title.y = this.back.top + this.title.height / 2 + 20;
            this.add(this.title);
        };
        SecondChancePopup.prototype.addBlocksLabel = function () {
            var props = {
                backFrame: "level_complete/blocks_label_back",
                iconFrame: "level_complete/tick",
                textColor: 0xba3339,
            };
            this.blocksLabel = new game.ComplexBlocksLabel(this.scene, props);
            this.blocksLabel.tick.kill();
            this.add(this.blocksLabel);
        };
        SecondChancePopup.prototype.addSubtitle = function () {
            var content = this.getSubtitleContent();
            var style = {
                fontFamily: game.GameFont.SOUSES,
                fontStyle: game.FontWeight.BOLD,
                fontSize: "32px",
                color: "#B62D35",
                align: "center",
            };
            this.subtitle = this.scene.add.text(0, 0, content, style);
            this.subtitle.setOrigin(0.5, 0.5);
            this.subtitle.setWordWrapWidth(this.back.width * 0.85);
            this.subtitle.setLineSpacing(-6);
            this.subtitle.bottom = this.back.bottom - 28;
            this.add(this.subtitle);
        };
        SecondChancePopup.prototype.getSubtitleContent = function () {
            return this.scene.texts.second_chance.subtitle.replace("#", game.SecondChance.ROWS.toString());
        };
        SecondChancePopup.prototype.alignBlocksLabel = function () {
            var top = this.title.bottom;
            var bottom = this.subtitle.top;
            var height = bottom - top;
            var maxHeight = height * 0.9;
            this.blocksLabel.scale = Math.min(1, maxHeight / this.blocksLabel.getHeight());
            this.blocksLabel.y = top + height / 2 - this.blocksLabel.getDisplayHeight() / 2;
        };
        SecondChancePopup.prototype.updateData = function (levelNumber, blocksType, killedBlocksNum, requiredBlocksNum) {
            this.blocksLabel.updateData(blocksType, killedBlocksNum, requiredBlocksNum);
            this.subtitle.text = levelNumber === 1
                ? this.scene.texts.start_level_popup.task.replace("#", requiredBlocksNum.toString())
                : this.scene.texts.second_chance.subtitle.replace("#", game.SecondChance.ROWS.toString());
        };
        SecondChancePopup.prototype.getHeight = function () {
            return this.back.height;
        };
        return SecondChancePopup;
    }(Phaser.GameObjects.Container));
    game.SecondChancePopup = SecondChancePopup;
})(game || (game = {}));
///<reference path='SecondChancePopup.ts' />
var game;
(function (game) {
    var Screen = Phaser.GameObjects.Screen;
    var EasingString = Phaser.Math.EasingString;
    var SecondChanceScreenEvent;
    (function (SecondChanceScreenEvent) {
        SecondChanceScreenEvent["HIDE_START"] = "SecondChanceScreen_HIDE_START";
        SecondChanceScreenEvent["HIDE_COMPLETE"] = "SecondChanceScreen_HIDE_COMPLETE";
    })(SecondChanceScreenEvent = game.SecondChanceScreenEvent || (game.SecondChanceScreenEvent = {}));
    var SecondChanceScreen = /** @class */ (function (_super) {
        __extends(SecondChanceScreen, _super);
        function SecondChanceScreen(scene, atlas) {
            var _this = _super.call(this, scene, {
                backgroundKey: atlas,
                backgroundFrame: "black_rect",
                backgroundAlpha: 0.85,
            }) || this;
            _this.name = "second_chance";
            _this.atlas = atlas;
            _this.background.name = "second_chance_screen_back";
            _this.addPopup();
            _this.addCloseButton();
            _this.addPlayButton();
            _this.bringToTop(_this.popup);
            return _this;
        }
        SecondChanceScreen.prototype.addPopup = function () {
            this.popup = new game.SecondChancePopup(this.scene, this.atlas);
            this.add(this.popup);
        };
        SecondChanceScreen.prototype.addCloseButton = function () {
            this.closeButton = this.scene.add.button(this.atlas, "second_chance/button_close", this);
        };
        SecondChanceScreen.prototype.addPlayButton = function () {
            this.playButton = this.scene.add.button(this.atlas, "second_chance/button_video", this);
            this.playButton.y = this.popup.y + this.popup.getHeight() / 2 + this.playButton.height / 2 + 50;
            this.playButton.areTweensEnabled = false;
        };
        SecondChanceScreen.prototype.resize = function () {
            this.background.displayHeight = (game.Config.GAME_HEIGHT + 4) / this.scale;
            this.alignPlayButton();
            this.alignCloseButton();
        };
        SecondChanceScreen.prototype.alignPlayButton = function () {
            var top = this.popup.y + this.popup.getHeight() / 2;
            var bottom = this.background.displayHeight / 2;
            var height = bottom - top;
            this.playButton.y = top + height / 2;
        };
        SecondChanceScreen.prototype.alignCloseButton = function () {
            var margin = 70;
            this.closeButton.x = game.Config.SOURCE_GAME_WIDTH / 2 - margin;
            this.closeButton.y = -this.background.displayHeight / 2 + margin;
        };
        SecondChanceScreen.prototype.updateData = function (levelNumber, blocksType, killedBlocksNum, requiredBlocksNum) {
            this.popup.updateData(levelNumber, blocksType, killedBlocksNum, requiredBlocksNum);
        };
        SecondChanceScreen.prototype.show = function () {
            var _this = this;
            this.alpha = 1;
            var items = [this.popup, this.playButton, this.popup.foxBubble, this.closeButton];
            items.forEach(function (item) {
                item.alpha = 0;
                item.scale = 0.8;
            });
            this.scene.tweens.add({
                targets: items,
                alpha: { value: 1, duration: 200, ease: EasingString.Cubic },
                scale: { value: 1, duration: 500, ease: EasingString.Back },
                delay: this.scene.tweens.stagger(100),
            }).on(Phaser.Tweens.Events.TIMELINE_COMPLETE, function () {
                _this.animatePlayButton();
            });
            this.playRevealSound();
        };
        SecondChanceScreen.prototype.animatePlayButton = function () {
            this.animatePlayButtonEvent = this.scene.time.addEvent({
                repeat: -1,
                startAt: 2999,
                delay: 3000,
                callback: this.shakePlayButton,
                callbackScope: this,
            });
        };
        SecondChanceScreen.prototype.shakePlayButton = function () {
            this.scene.tweens.add({
                targets: this.playButton,
                duration: 266,
                ease: Phaser.Math.Easing.Sine.InOut,
                scaleX: 1.1,
                scaleY: 1.1,
                repeat: 2,
                yoyo: true,
            });
        };
        SecondChanceScreen.prototype.playRevealSound = function () {
            if (this.scene.cache.audio.has(game.GameSoundKey.GIFT_REVEAL)) {
                this.scene.sound.play(game.GameSoundKey.GIFT_REVEAL, { volume: 0.66 });
            }
        };
        SecondChanceScreen.prototype.hide = function () {
            var _this = this;
            if (this.animatePlayButtonEvent) {
                this.animatePlayButtonEvent.remove();
                this.animatePlayButtonEvent = null;
            }
            this.scene.tweens.killTweensOf(this.playButton);
            this.scene.tweens.add({
                targets: this,
                duration: 150,
                ease: Phaser.Math.Easing.Linear.Linear,
                alpha: 0,
                onStart: function () {
                    _this.emit(SecondChanceScreenEvent.HIDE_START, _this);
                    _this.scene.game.toasts.dismissAll();
                },
                onComplete: function () {
                    _this.emit(SecondChanceScreenEvent.HIDE_COMPLETE, _this);
                    _this.destroy();
                },
            });
        };
        SecondChanceScreen.prototype.shakeCloseButton = function () {
            this.closeButton.scale = 1;
            this.scene.tweens.killTweensOf(this.closeButton);
            this.scene.tweens.add({
                targets: this.closeButton,
                duration: 200,
                ease: Phaser.Math.Easing.Sine.InOut,
                scale: 1.25,
                yoyo: true,
                repeat: 1,
            });
        };
        return SecondChanceScreen;
    }(Screen));
    game.SecondChanceScreen = SecondChanceScreen;
})(game || (game = {}));
var game;
(function (game) {
    var EasingString = Phaser.Math.EasingString;
    var FreeBoostersScreenEvent;
    (function (FreeBoostersScreenEvent) {
        FreeBoostersScreenEvent["HIDE_START"] = "FreeBoostersScreen_HIDE_START";
        FreeBoostersScreenEvent["HIDE_COMPLETE"] = "FreeBoostersScreen_HIDE_COMPLETE";
    })(FreeBoostersScreenEvent = game.FreeBoostersScreenEvent || (game.FreeBoostersScreenEvent = {}));
    var FreeBoostersScreen = /** @class */ (function (_super) {
        __extends(FreeBoostersScreen, _super);
        function FreeBoostersScreen(scene) {
            var _this = _super.call(this, scene, {
                backgroundKey: "gameplay_gui",
                backgroundFrame: "black_rect",
                backgroundAlpha: 0.85,
            }) || this;
            _this.name = "free_booster_screen";
            _this.addBoosters();
            _this.addTitle();
            _this.addPlayButton();
            _this.addCloseButton();
            _this.bringToTop(_this.title);
            return _this;
        }
        FreeBoostersScreen.prototype.addBoosters = function () {
            this.boosters = new game.GiftedBooster(this.scene, "gameplay_gui", game.BoosterType.BOMB, 1);
            this.boosters.y = -30;
            this.add(this.boosters);
        };
        FreeBoostersScreen.prototype.addTitle = function () {
            var content = this.scene.texts.free_boosters;
            var style = {
                fontFamily: game.GameFont.SOUSES,
                fontStyle: game.FontWeight.BOLD,
                fontSize: "45px",
                color: "#ffffff",
                align: "center",
            };
            this.title = this.scene.add.text(0, 0, content, style);
            this.title.setOrigin(0.5, 1);
            this.title.setWordWrapWidth(game.Config.SOURCE_GAME_WIDTH * 0.66);
            this.title.y = this.boosters.y - 160;
            this.add(this.title);
        };
        FreeBoostersScreen.prototype.addPlayButton = function () {
            this.playButton = this.scene.add.button("gameplay_gui", "boosters/button_video", this);
            this.playButton.top = this.boosters.y + 205;
            this.playButton.areTweensEnabled = false;
        };
        FreeBoostersScreen.prototype.addCloseButton = function () {
            this.closeButton = this.scene.add.button("gameplay_gui", "second_chance/button_close", this);
        };
        FreeBoostersScreen.prototype.resize = function () {
            this.background.displayHeight = (game.Config.GAME_HEIGHT + 4) / this.scale;
            this.alignCloseButton();
        };
        FreeBoostersScreen.prototype.alignCloseButton = function () {
            var margin = 70;
            this.closeButton.x = game.Config.SOURCE_GAME_WIDTH / 2 - margin;
            this.closeButton.y = -this.background.displayHeight / 2 + margin;
        };
        FreeBoostersScreen.prototype.updateData = function (boosterType, boostersNum) {
            this.boosters.updateData(boosterType, boostersNum);
            this.currentBooster = boosterType;
        };
        FreeBoostersScreen.prototype.show = function () {
            this.alpha = 1;
            this.playButton.scale = 1;
            this.boosters.startFloat(0);
            this.showContent();
        };
        FreeBoostersScreen.prototype.showContent = function () {
            var items = [this.title, this.boosters, this.playButton, this.closeButton];
            items.forEach(function (item) {
                item.alpha = 0;
                item.scale = 0.8;
            });
            this.scene.tweens.add({
                targets: items,
                alpha: { value: 1, duration: 200, ease: EasingString.Cubic },
                scale: { value: 1, duration: 400, ease: EasingString.Back },
            }).on(Phaser.Tweens.Events.TIMELINE_COMPLETE, this.onShowComplete, this);
        };
        FreeBoostersScreen.prototype.onShowComplete = function () {
            this.animatePlayButton();
        };
        FreeBoostersScreen.prototype.animatePlayButton = function () {
            this.animatePlayButtonEvent = this.scene.time.addEvent({
                repeat: -1,
                startAt: 2999,
                delay: 3000,
                callback: this.shakePlayButton,
                callbackScope: this,
            });
        };
        FreeBoostersScreen.prototype.shakePlayButton = function () {
            this.scene.tweens.add({
                targets: this.playButton,
                duration: 266,
                ease: Phaser.Math.Easing.Sine.InOut,
                scaleX: 1.1,
                scaleY: 1.1,
                repeat: 2,
                yoyo: true,
            });
        };
        FreeBoostersScreen.prototype.hide = function () {
            var _this = this;
            this.emit(FreeBoostersScreenEvent.HIDE_START, this);
            if (this.animatePlayButtonEvent) {
                this.animatePlayButtonEvent.remove();
                this.animatePlayButtonEvent = null;
            }
            this.scene.tweens.add({
                targets: this,
                duration: 100,
                ease: Phaser.Math.Easing.Linear.Linear,
                alpha: 0,
                onComplete: function () {
                    _this.boosters.stopFloat();
                    _this.scene.game.toasts.dismissAll();
                    _this.emit(FreeBoostersScreenEvent.HIDE_COMPLETE, _this);
                    _this.kill();
                },
            });
        };
        return FreeBoostersScreen;
    }(Phaser.GameObjects.Screen));
    game.FreeBoostersScreen = FreeBoostersScreen;
})(game || (game = {}));
///<reference path='IngamePanel.ts' />
///<reference path='topPanel/TopPanel.ts' />
///<reference path='bottomPanel/BottomPanel.ts' />
///<reference path='topPanel/BasicBlocksLabel.ts' />
///<reference path='ComplexBlocksLabel.ts' />
///<reference path='levelComplete/LevelCompleteScreen.ts' />
///<reference path='levelFailed/LevelFailedScreen.ts' />
///<reference path='GameplayGuiDepth.ts' />
///<reference path='tutorial/TutorialScreen.ts' />
///<reference path='PauseScreen.ts' />
///<reference path='CollectedBlock.ts' />
///<reference path='FastForwardFx.ts' />
///<reference path='gift/GiftScreen.ts' />
///<reference path='boosterHintScreen/BoosterHintScreen.ts' />
///<reference path='Flash.ts' />
///<reference path='secondChanceScreen/SecondChanceScreen.ts' />
///<reference path='FreeBoostersScreen.ts' />
///<reference path='FastForwardPopover.ts' />
var game;
(function (game) {
    var ButtonEvent = Phaser.GameObjects.ButtonEvent;
    var GameplayGuiEvent;
    (function (GameplayGuiEvent) {
        GameplayGuiEvent["PAUSE"] = "GUI_PAUSE";
        GameplayGuiEvent["RESUME"] = "GUI_RESUME";
        GameplayGuiEvent["GOTO_LEVEL"] = "GOTO_LEVEL";
        GameplayGuiEvent["GOTO_LEVELS_MAP"] = "GOTO_LEVELS_MAP";
    })(GameplayGuiEvent = game.GameplayGuiEvent || (game.GameplayGuiEvent = {}));
    var GameplayGui = /** @class */ (function (_super) {
        __extends(GameplayGui, _super);
        function GameplayGui() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Object.defineProperty(GameplayGui.prototype, "boostersPanel", {
            get: function () {
                return this.bottomPanel.boostersPanel;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(GameplayGui.prototype, "pauseButton", {
            get: function () {
                return this.bottomPanel.pauseButton;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(GameplayGui.prototype, "fastForwardButton", {
            get: function () {
                return this.bottomPanel.fastForwardButton;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(GameplayGui.prototype, "dropBallsButton", {
            get: function () {
                return this.bottomPanel.dropBallsButton;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(GameplayGui.prototype, "blocksLabel", {
            get: function () {
                return this.topPanel.mainLabel.blocksLabel;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(GameplayGui.prototype, "pointsLabel", {
            get: function () {
                return this.topPanel.pointsLabel;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(GameplayGui.prototype, "ballsLabel", {
            get: function () {
                return this.topPanel.mainLabel.ballsLabel;
            },
            enumerable: false,
            configurable: true
        });
        GameplayGui.prototype.init = function (data) {
            _super.prototype.init.call(this);
            this.levelConfig = data.levelConfig;
            this.gameField = data.gameplay;
            this.tutorial = null;
            this.giftScreen = null;
        };
        GameplayGui.prototype.create = function () {
            this.addFlash();
            this.addTopPanel();
            this.addBottomPanel();
            this.addFastForwardPopover();
            this.addCollectedBlocks();
            this.addFastForward();
            this.addGiftScreen();
            this.addTutorial();
            this.addBoosterHintScreen();
            this.addFreeBoostersScreen();
            this.addSecondChanceScreen();
            this.addPauseScreen();
            this.addCompleteScreen();
            this.addFailedScreen();
            this.addKeyboardCallbacks();
            this.cameras.main.visible = !utils.NetUtil.getParamBool("hideGui");
        };
        GameplayGui.prototype.addFlash = function () {
            this.flash = new game.Flash(this, "gameplay_gui", "white_rect");
            this.flash.kill();
            this.add.existing(this.flash);
        };
        GameplayGui.prototype.addTopPanel = function () {
            this.topPanel = new game.TopPanel(this, this.levelConfig);
        };
        GameplayGui.prototype.addBottomPanel = function () {
            this.bottomPanel = new game.BottomPanel(this);
            this.bottomPanel.setDepth(game.GameplayGuiDepth.BOTTOM_PANEL);
            this.bottomPanel.pauseButton.on(ButtonEvent.PRESS, this.onPauseButtonClick, this);
        };
        GameplayGui.prototype.onPauseButtonClick = function () {
            this.events.emit(GameplayGuiEvent.PAUSE, this);
        };
        GameplayGui.prototype.addFastForwardPopover = function () {
            var wasFastForwardUsed = this.game.store.getBoolean(game.GameStoreKey.FAST_FORWARD_WAS_USED);
            if (wasFastForwardUsed) {
                return;
            }
            this.fastForwardPopover = new game.FastForwardPopover(this, this.gameField);
            this.fastForwardPopover.on(game.FastForwardPopoverEvent.SHOW, this.alignFastForwardPopover, this);
            this.fastForwardPopover.kill();
            this.add.existing(this.fastForwardPopover);
        };
        GameplayGui.prototype.addCollectedBlocks = function () {
            var _this = this;
            this.collectedBlocks = this.add.group({
                classType: game.CollectedBlock,
                createCallback: function (block) {
                    block.kill();
                    block.setDepth(game.GameplayGuiDepth.COLLECTED_BLOCKS);
                },
            });
            var blocksInitialNum = 5;
            _.times(blocksInitialNum, function () {
                _this.collectedBlocks.create();
            });
        };
        GameplayGui.prototype.addFastForward = function () {
            this.fastForward = new game.FastForwardFx(this);
            this.fastForward.kill();
            this.add.existing(this.fastForward);
        };
        GameplayGui.prototype.addCompleteScreen = function () {
            this.completeScreen = new game.LevelCompleteScreen(this);
            this.completeScreen.buttons.restartButton.once(ButtonEvent.PRESS, this.onRestartButtonClick, this);
            this.completeScreen.buttons.nextLevelButton.once(ButtonEvent.PRESS, this.onNextLevelButtonClick, this);
            this.completeScreen.buttons.homeButton.once(ButtonEvent.PRESS, this.onMenuButtonClick, this);
            this.completeScreen.kill();
            this.completeScreen.setDepth(game.GameplayGuiDepth.COMPLETE_SCREEN);
            this.add.existing(this.completeScreen);
        };
        GameplayGui.prototype.addFailedScreen = function () {
            this.failedScreen = new game.LevelFailedScreen(this);
            this.failedScreen.restartButton.once(Phaser.GameObjects.ButtonEvent.PRESS, this.onRestartButtonClick, this);
            this.failedScreen.homeButton.once(Phaser.GameObjects.ButtonEvent.PRESS, this.onMenuButtonClick, this);
            this.failedScreen.setDepth(game.GameplayGuiDepth.FAILED_SCREEN);
            this.failedScreen.kill();
            this.add.existing(this.failedScreen);
        };
        GameplayGui.prototype.onRestartButtonClick = function () {
            var _this = this;
            this.poki.commercialBreak("Restart")
                .catch(function () {
            })
                .finally(function () {
                _this.gotoLevel(_this.levelConfig.levelNumber);
            });
        };
        GameplayGui.prototype.onNextLevelButtonClick = function () {
            var _this = this;
            this.poki.commercialBreak("NextLevelButton")
                .catch(function () {
            })
                .finally(function () {
                var nextLevel = _this.levelConfig.levelNumber + 1;
                var nextLevelExist = _this.game.levelConfigs.check(nextLevel);
                if (nextLevelExist === false) {
                    _this.gotoLevelsMap();
                }
                _this.gotoLevel(nextLevel);
            });
        };
        GameplayGui.prototype.onMenuButtonClick = function () {
            this.gotoLevelsMap();
        };
        GameplayGui.prototype.gotoLevelsMap = function () {
            this.events.emit(GameplayGuiEvent.GOTO_LEVELS_MAP);
        };
        GameplayGui.prototype.gotoLevel = function (levelNumber) {
            this.events.emit(GameplayGuiEvent.GOTO_LEVEL, levelNumber);
        };
        GameplayGui.prototype.addGiftScreen = function () {
            if (!this.levelConfig.gift) {
                return;
            }
            var hasGifts = Object.values(this.levelConfig.gift).some(function (value) { return value > 0; });
            if (hasGifts === false) {
                return;
            }
            var giftsSaveData = this.game.store.getValue(game.GameStoreKey.LEVEL_GIFTS);
            var wereCollected = giftsSaveData[this.levelConfig.levelNumber] === true;
            if (wereCollected) {
                return;
            }
            var skipGifts = utils.NetUtil.getParamBool("skipGifts");
            if (skipGifts) {
                return;
            }
            this.giftScreen = new game.GiftScreen(this, "gameplay_gui", this.levelConfig.gift, this.bottomPanel.boostersPanel);
            this.giftScreen.on(game.GiftScreenEvent.BOOSTERS_SHOW_COMPLETE, this.onGiftBoostersShowComplete, this);
            this.giftScreen.on(game.GiftScreenEvent.HIDE_COMPLETE, this.onGiftScreenHideComplete, this);
            this.giftScreen.setDepth(game.GameplayGuiDepth.GIFT_SCREEN);
            this.add.existing(this.giftScreen);
            this.giftScreen.autoPlay = utils.NetUtil.getParamBool("giftAutoPlay");
            this.giftScreen.show();
            this.onGiftScreenShow();
        };
        GameplayGui.prototype.onGiftScreenShow = function () {
            var _this = this;
            this.time.delayedCall(100, function () {
                _this.gameField.scene.pause();
                _this.gameField.removePointerCallbacks();
            });
            this.bottomPanel.disableInput();
            this.bottomPanel.kill();
        };
        GameplayGui.prototype.onGiftBoostersShowComplete = function () {
            this.bottomPanel.revive();
            this.bottomPanel.pauseButton.visible = false;
            this.boostersPanel.alpha = 0;
            this.tweens.add({
                targets: this.boostersPanel,
                duration: 266,
                ease: Phaser.Math.Easing.Cubic.Out,
                alpha: 1,
            });
        };
        GameplayGui.prototype.onGiftScreenHideComplete = function (screen) {
            this.saveGifts(screen.content);
            this.gameField.scene.resume();
            this.gameField.addPointerCallbacks();
            this.bottomPanel.enableInput();
            this.bottomPanel.pauseButton.visible = true;
        };
        GameplayGui.prototype.saveGifts = function (giftContent) {
            var _a;
            this.game.boosters.updateFromGift(giftContent);
            var giftsSaveData = this.game.store.getValue(game.GameStoreKey.LEVEL_GIFTS);
            var newSaveData = __assign(__assign({}, giftsSaveData), (_a = {}, _a[this.levelConfig.levelNumber] = true, _a));
            this.game.store.saveValue(game.GameStoreKey.LEVEL_GIFTS, newSaveData);
        };
        GameplayGui.prototype.addTutorial = function () {
            if (!this.levelConfig.tutorial) {
                return;
            }
            var skipTutorial = utils.NetUtil.getParamBool("skipTutorial");
            if (skipTutorial) {
                return;
            }
            this.tutorial = new game.TutorialScreen(this, this.levelConfig.tutorial);
            this.tutorial.setDepth(game.GameplayGuiDepth.TUTORIAL_SCREEN);
            this.add.existing(this.tutorial);
        };
        GameplayGui.prototype.showTutorial = function () {
            this.onTutorialStart();
            this.tutorial.once(game.TutorialEvent.COMPLETE, this.onTutorialComplete, this);
            this.tutorial.show(400);
        };
        GameplayGui.prototype.onTutorialStart = function () {
            this.gameField.removePointerCallbacks();
            this.bottomPanel.kill();
        };
        GameplayGui.prototype.onTutorialComplete = function () {
            this.gameField.addPointerCallbacks();
            this.bottomPanel.revive();
        };
        GameplayGui.prototype.addBoosterHintScreen = function () {
            this.boosterHintScreen = new game.BoosterHintScreen(this, this.bottomPanel);
            this.boosterHintScreen.kill();
            this.add.existing(this.boosterHintScreen);
        };
        GameplayGui.prototype.addFreeBoostersScreen = function () {
            if (game.Main.areRewardAdsEnabled === false) {
                return;
            }
            this.freeBoostersScreen = new game.FreeBoostersScreen(this);
            this.freeBoostersScreen.kill();
            this.freeBoostersScreen.setDepth(game.GameplayGuiDepth.FREE_BOOSTERS_SCREEN);
            this.add.existing(this.freeBoostersScreen);
        };
        GameplayGui.prototype.addSecondChanceScreen = function () {
            if (game.Main.areRewardAdsEnabled === false) {
                return;
            }
            this.secondChanceScreen = new game.SecondChanceScreen(this, "gameplay_gui");
            this.secondChanceScreen.kill();
            this.secondChanceScreen.setDepth(game.GameplayGuiDepth.SECOND_CHANCE_SCREEN);
            this.add.existing(this.secondChanceScreen);
        };
        GameplayGui.prototype.addPauseScreen = function () {
            this.pauseScreen = new game.PauseScreen(this);
            this.pauseScreen.kill();
            this.pauseScreen.setDepth(game.GameplayGuiDepth.PAUSE_SCREEN);
            this.pauseScreen.resumeButton.on(ButtonEvent.PRESS, this.onResumeButtonClick, this);
            this.pauseScreen.restartButton.once(ButtonEvent.PRESS, this.onRestartButtonClick, this);
            this.pauseScreen.homeButton.once(ButtonEvent.PRESS, this.gotoLevelsMap, this);
            this.add.existing(this.pauseScreen);
        };
        GameplayGui.prototype.onResumeButtonClick = function () {
            this.events.emit(GameplayGuiEvent.RESUME, this);
        };
        GameplayGui.prototype.addKeyboardCallbacks = function () {
        };
        GameplayGui.prototype.resizeTutorial = function (field) {
            if (this.tutorial) {
                this.tutorial.resize(field);
            }
        };
        GameplayGui.prototype.doResize = function () {
            this.flash.resize();
            this.alignTopPanel();
            this.alignBottomPanel();
            this.alignFastForwardPopover();
            this.resizeGiftScreen();
            this.resizeSecondChanceScreen();
            this.resizeFreeBoostersScreen();
            this.fastForward.resize();
            this.completeScreen.resize();
            this.failedScreen.resize();
            this.resizePauseScreen();
        };
        GameplayGui.prototype.resizePauseScreen = function () {
            this.pauseScreen.scale = (game.Config.GAME_WIDTH + 4) / game.Config.SOURCE_GAME_WIDTH;
            this.pauseScreen.x = game.Config.HALF_GAME_WIDTH;
            this.pauseScreen.y = game.Config.HALF_GAME_HEIGHT;
            this.pauseScreen.resize();
        };
        GameplayGui.prototype.alignTopPanel = function () {
            var minWidth = game.Config.GAME_WIDTH * 0.5;
            var maxWidth = game.Config.GAME_WIDTH - 14;
            var minAspectRatio = 0.6;
            var maxAspectRatio = 1;
            var width = Phaser.Math.MapLinear(game.Config.ASPECT_RATIO, maxAspectRatio, minAspectRatio, minWidth, maxWidth);
            width = Phaser.Math.Clamp(width, minWidth, maxWidth);
            this.topPanel.scale = width / this.topPanel.getWidth();
            this.topPanel.x = game.Config.HALF_GAME_WIDTH;
            this.topPanel.y = 0;
            this.topPanel.originalY = this.topPanel.y;
        };
        GameplayGui.prototype.alignBottomPanel = function () {
            this.bottomPanel.scale = this.topPanel.scale;
            this.bottomPanel.x = game.Config.HALF_GAME_WIDTH;
            this.bottomPanel.y = game.Config.GAME_HEIGHT - this.bottomPanel.getVeticalOffset() * this.bottomPanel.scale;
        };
        GameplayGui.prototype.alignFastForwardPopover = function () {
            if (!this.fastForwardPopover) {
                return;
            }
            var scale = this.bottomPanel.scale;
            var button = this.bottomPanel.fastForwardButton;
            var position = button.getWorldPosition();
            this.fastForwardPopover.scale = scale;
            this.fastForwardPopover.y = position.y - (button.height / 2) * scale;
            this.fastForwardPopover.originalY = this.fastForwardPopover.y;
            var right = game.Config.GAME_WIDTH - 20 * scale;
            var maxX = right - ((this.fastForwardPopover.getWidth() - 20) * scale) / 2;
            if (position.x > maxX) {
                this.fastForwardPopover.x = maxX;
                this.fastForwardPopover.offsetTip(maxX - position.x);
            }
            else {
                this.fastForwardPopover.x = position.x;
                this.fastForwardPopover.offsetTip(0);
            }
        };
        GameplayGui.prototype.resizeGiftScreen = function () {
            if (!this.giftScreen) {
                return;
            }
            this.giftScreen.scale = (game.Config.GAME_WIDTH + 4) / game.Config.SOURCE_GAME_WIDTH;
            this.giftScreen.x = game.Config.HALF_GAME_WIDTH;
            this.giftScreen.y = game.Config.HALF_GAME_HEIGHT;
            this.giftScreen.resize();
        };
        GameplayGui.prototype.resizeSecondChanceScreen = function () {
            if (!this.secondChanceScreen) {
                return;
            }
            this.secondChanceScreen.scale = (game.Config.GAME_WIDTH + 4) / game.Config.SOURCE_GAME_WIDTH;
            this.secondChanceScreen.x = game.Config.HALF_GAME_WIDTH;
            this.secondChanceScreen.y = game.Config.HALF_GAME_HEIGHT;
            this.secondChanceScreen.resize();
        };
        GameplayGui.prototype.resizeFreeBoostersScreen = function () {
            if (!this.freeBoostersScreen) {
                return;
            }
            this.freeBoostersScreen.scale = (game.Config.GAME_WIDTH + 4) / game.Config.SOURCE_GAME_WIDTH;
            this.freeBoostersScreen.x = game.Config.HALF_GAME_WIDTH;
            this.freeBoostersScreen.y = game.Config.HALF_GAME_HEIGHT;
            this.freeBoostersScreen.resize();
        };
        GameplayGui.prototype.resizeBoosterHintScreen = function (gameplay) {
            this.boosterHintScreen.resize(gameplay);
        };
        GameplayGui.prototype.onTurnStart = function () {
            this.hideBoostersPanel();
            this.bottomPanel.showTurnButtons();
        };
        GameplayGui.prototype.showBoostersPanel = function () {
            this.bottomPanel.boostersPanel.enableInput();
            this.bottomPanel.boostersPanel.show();
        };
        GameplayGui.prototype.hideBoostersPanel = function () {
            this.bottomPanel.boostersPanel.disableInput();
            this.bottomPanel.boostersPanel.hide();
        };
        GameplayGui.prototype.onLevelComplete = function (data) {
            this.input.keyboard.once("keydown-SPACE", this.onNextLevelButtonClick, this);
            this.bottomPanel.disableInput();
            this.completeScreen.updateData(data);
            this.completeScreen.show();
        };
        GameplayGui.prototype.onLevelFailed = function (data) {
            this.input.keyboard.once("keydown-SPACE", this.onRestartButtonClick, this);
            this.bottomPanel.disableInput();
            this.failedScreen.updateData(data);
            this.failedScreen.show();
        };
        GameplayGui.prototype.onPause = function () {
            this.bottomPanel.disableInput();
            this.pauseScreen.show();
        };
        GameplayGui.prototype.onResume = function () {
            this.bottomPanel.enableInput();
            this.pauseScreen.hide();
        };
        GameplayGui.prototype.onTargetBlockKilled = function (killedBlock) {
            var startPosition = this.getBlockGlobalPosition(killedBlock);
            var targetPosition = this.blocksLabel.getWorldPosition();
            var block = this.collectedBlocks.getFirstDead(true);
            block.x = startPosition.x;
            block.y = startPosition.y;
            block.scale = this.gameField.camera.zoom;
            block.updateFrame(killedBlock);
            block.revive();
            block.once(game.CollectedBlockEvent.MOVE_IN_MIDDLE, this.playBlockCollectedWhooshSound, this);
            block.once(game.CollectedBlockEvent.MOVE_COMPLETE, this.playBlockCollectedCompleteSound, this);
            block.once(game.CollectedBlockEvent.MOVE_COMPLETE, this.onTargetBlockMoveComplete, this);
            block.moveTo(targetPosition, this.blocksLabel.blockOriginalScale);
        };
        GameplayGui.prototype.getBlockGlobalPosition = function (block) {
            var camera = this.gameField.camera;
            var padding = camera.getPadding();
            var zoom = camera.zoom;
            var x = camera.x + padding.x + block.x * zoom;
            var y = camera.y + padding.y + block.y * zoom;
            return { x: x, y: y };
        };
        GameplayGui.prototype.playBlockCollectedWhooshSound = function () {
            this.gameField.audio.blockCollectWhoosh();
        };
        GameplayGui.prototype.playBlockCollectedCompleteSound = function () {
            this.gameField.audio.blockCollectComplete();
        };
        GameplayGui.prototype.onTargetBlockMoveComplete = function () {
            this.blocksLabel.incrementCurrent();
            this.blocksLabel.showWhiteCopy();
            this.blocksLabel.tweenBlockIcon();
        };
        GameplayGui.prototype.showSecondChanceScreen = function (blocksKilled, blocksRequired) {
            if (this.levelConfig.levelNumber === 1) {
                this.secondChanceScreen.playButton.on(ButtonEvent.PRESS, this.onSecondChanceSuccess, this);
            }
            else {
                this.secondChanceScreen.playButton.on(ButtonEvent.PRESS, this.showSecondChanceVideoAd, this);
            }
            this.secondChanceScreen.closeButton.once(ButtonEvent.PRESS, this.onSecondChanceScreenClose, this);
            this.secondChanceScreen.updateData(this.levelConfig.levelNumber, this.levelConfig.generator.targetItemType, blocksKilled, blocksRequired);
            this.secondChanceScreen.revive();
            this.secondChanceScreen.show();
        };
        GameplayGui.prototype.onSecondChanceScreenClose = function () {
            this.secondChanceScreen.playButton.off(ButtonEvent.PRESS, this.showSecondChanceVideoAd, this);
            this.secondChanceScreen.hide();
        };
        GameplayGui.prototype.showSecondChanceVideoAd = function () {
            var _this = this;
            this.analytics.sendRewardedAd("second_chance", "screen", "request");
            this.poki.rewardedBreak("SecondChance", {
                onSuccess: function () {
                    _this.onSecondChanceSuccess();
                    _this.analytics.sendRewardedAd("second_chance", "screen", "receive");
                },
                onFail: function () {
                    _this.analytics.sendRewardedAd("second_chance", "screen", "fail");
                },
            }).catch(function (error) {
                if (error === "AdBlock") {
                    _this.secondChanceScreen.shakeCloseButton();
                }
            });
        };
        GameplayGui.prototype.onSecondChanceSuccess = function () {
            this.gameField.applySecondChance();
            this.gameField.scene.resume();
            this.secondChanceScreen.closeButton.off(ButtonEvent.PRESS, this.onSecondChanceScreenClose, this);
            this.secondChanceScreen.playButton.off(ButtonEvent.PRESS, this.showSecondChanceVideoAd, this);
            this.secondChanceScreen.hide();
        };
        GameplayGui.prototype.update = function (time, delta) {
            _super.prototype.update.call(this, time, delta);
            if (this.fastForwardPopover) {
                this.fastForwardPopover.preUpdate(time, delta);
            }
        };
        GameplayGui.prototype.shutdown = function () {
        };
        GameplayGui.FONT_COLOR_STR = "#E9EBEC";
        GameplayGui.FONT_COLOR = 0xe9ebec;
        return GameplayGui;
    }(game.BaseScene));
    game.GameplayGui = GameplayGui;
})(game || (game = {}));
var game;
(function (game) {
    var GameplayRootBackground = /** @class */ (function () {
        function GameplayRootBackground(scene, worldIndex) {
            this.scene = scene;
            this.worldIndex = worldIndex;
            this.addSky();
            this.addGround();
            this.addBottomGrass();
        }
        GameplayRootBackground.prototype.addSky = function () {
            this.sky = this.scene.add.image(0, 0, "backgrounds", "sky_" + this.worldIndex);
            this.sky.setOrigin(0.5, 1);
        };
        GameplayRootBackground.prototype.addGround = function () {
            this.ground = this.scene.add.image(0, 0, "backgrounds", "ground_" + this.worldIndex);
        };
        GameplayRootBackground.prototype.addBottomGrass = function () {
            this.bottomGrass = this.scene.add.image(0, 0, "backgrounds", "bottom_grass_" + this.worldIndex);
            this.bottomGrass.setOrigin(0.5, 1);
        };
        GameplayRootBackground.prototype.resize = function (field) {
            if (!field || !field.camera) {
                return;
            }
            this.resizeGround(field);
            this.resizeSky();
            this.resizeBottomGrass();
        };
        GameplayRootBackground.prototype.resizeGround = function (field) {
            this.ground.scale = game.Config.GAME_WIDTH / this.ground.width;
            this.ground.x = game.Config.HALF_GAME_WIDTH;
            this.ground.y = this.getFieldBottom(field.camera);
        };
        GameplayRootBackground.prototype.getFieldBottom = function (gameplayCamera) {
            return gameplayCamera.height - gameplayCamera.getPadding().y;
        };
        GameplayRootBackground.prototype.resizeSky = function () {
            var top = 0;
            var bottom = this.ground.y;
            var height = bottom - top;
            this.sky.displayWidth = game.Config.GAME_WIDTH;
            this.sky.displayHeight = height;
            this.sky.x = game.Config.HALF_GAME_WIDTH;
            this.sky.y = bottom;
        };
        GameplayRootBackground.prototype.resizeBottomGrass = function () {
            this.bottomGrass.scale = game.Config.GAME_WIDTH / this.bottomGrass.width;
            this.bottomGrass.x = game.Config.HALF_GAME_WIDTH;
            this.bottomGrass.y = Math.max(game.Config.GAME_HEIGHT, this.ground.y + this.bottomGrass.displayHeight * 0.9);
        };
        return GameplayRootBackground;
    }());
    game.GameplayRootBackground = GameplayRootBackground;
})(game || (game = {}));
///<reference path='Gameplay.ts' />
///<reference path='gui/GameplayGui.ts' />
///<reference path='GameplayRootBackground.ts' />
var game;
(function (game) {
    var GameplayRoot = /** @class */ (function (_super) {
        __extends(GameplayRoot, _super);
        function GameplayRoot() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        GameplayRoot.getPhysicsConfig = function () {
            return {
                matter: {
                    debug: game.Main.development,
                    enableSleeping: true,
                    runner: { isFixed: true },
                    gravity: { x: 0, y: 7 },
                    positionIterations: 6,
                    velocityIterations: 4,
                    constraintIterations: 0,
                    broadphase: {
                        bucketWidth: game.GameGrid.CELL_SIZE,
                        bucketHeight: game.GameGrid.CELL_SIZE,
                    },
                },
            };
        };
        GameplayRoot.prototype.init = function (data) {
            this.initData = data || this.getDefaultInitData();
            this.levelNumber = this.initData.levelNumber;
            this.levelConfig = this.game.levelConfigs.get(this.levelNumber);
            this.gameplay = null;
            this.gui = null;
            this.background = null;
            this.events.once("shutdown", this.shutdown, this);
            console.group("Level " + data.levelNumber);
        };
        GameplayRoot.prototype.getDefaultInitData = function () {
            return {
                levelNumber: 1,
                fromEditor: false,
            };
        };
        GameplayRoot.prototype.preload = function () {
            var loader = this.game.globalScene.delayedLoader;
            var areAssetsReady = loader.areGameplayAssetsLoaded;
            if (areAssetsReady) {
                return;
            }
            this.analytics.sendLoadingEvent("gameplay", "start");
            this.waitForGameplayAssets(loader);
        };
        GameplayRoot.prototype.waitForGameplayAssets = function (loader) {
            var _this = this;
            this.game.loadingOverlay.fadeIn();
            this.load.rexAwait(Phaser.Math.RND.uuid(), {
                callback: function (onSuccess) {
                    loader.once(game.DelayedLoaderEvent.GAMEPLAY_ASSETS_READY, function () {
                        _this.analytics.sendLoadingEvent("gameplay", "complete");
                        onSuccess();
                    });
                },
            });
        };
        GameplayRoot.prototype.create = function () {
            if (!this.levelConfig) {
                console.warn("Config for level " + this.levelNumber + " doesn't exist!");
                this.gotoLevelsMap();
                return;
            }
            console.log("Config", _.omit(this.levelConfig, "items", "generator"));
            this.launchGameplayScene();
            this.addBackground();
            this.addKeyboardCallbacks();
        };
        GameplayRoot.prototype.launchGameplayScene = function () {
            this.gameplay = this.launchScene(game.SceneKey.GAMEPLAY, this.levelConfig);
            this.gameplay.events.once(Phaser.Scenes.Events.CREATE, this.launchGameplayGuiScene, this);
            this.game.raven.trackSceneInput(this.gameplay.scene.key);
        };
        GameplayRoot.prototype.launchGameplayGuiScene = function () {
            this.gui = this.launchScene(game.SceneKey.GAMEPLAY_GUI, {
                levelConfig: this.levelConfig,
                gameplay: this.gameplay,
            });
            this.gui.events.once(Phaser.Scenes.Events.CREATE, this.onGuiCreated, this);
            this.gui.events.once(game.GameplayGuiEvent.GOTO_LEVELS_MAP, this.gotoLevelsMap, this);
            this.gui.events.once(game.GameplayGuiEvent.GOTO_LEVEL, this.gotoLevel, this);
            this.gui.events.on(game.GameplayGuiEvent.PAUSE, this.pause, this);
            this.gui.events.on(game.GameplayGuiEvent.RESUME, this.resume, this);
            this.game.raven.trackSceneInput(this.gui.scene.key);
        };
        GameplayRoot.prototype.onGuiCreated = function () {
            this.gameplay.gui = this.gui;
            this.gameplay.onGuiCreated();
            this.resize();
            if (this.gui.tutorial) {
                this.gui.showTutorial();
            }
            this.game.loadingOverlay.fadeOut();
        };
        GameplayRoot.prototype.launchScene = function (key, data) {
            return this.scene.launch(key, data).get(key);
        };
        GameplayRoot.prototype.addBackground = function () {
            var worldIndexStr = this.levelConfig.background.split("_").pop();
            var worldIndex = parseInt(worldIndexStr) || 1;
            this.background = new game.GameplayRootBackground(this, worldIndex);
        };
        GameplayRoot.prototype.addKeyboardCallbacks = function () {
            if (game.Main.development) {
                this.input.keyboard.on("keydown-P", this.togglePause, this);
                this.input.keyboard.once("keydown-R", this.restart, this);
                this.input.keyboard.once("keydown-ESC", this.onEscKeyDown, this);
                this.input.keyboard.once("keydown-RIGHT", this.gotoNextLevel, this);
                this.input.keyboard.once("keydown-LEFT", this.gotoPrevLevel, this);
            }
            if (game.Main.editorEnabled) {
                this.input.keyboard.once("keydown-E", this.gotoEditor, this);
                // this.input.keyboard.on("keydown-T", this.gotoTutorialEditor, this)
            }
        };
        GameplayRoot.prototype.gotoPrevLevel = function () {
            var prevLevelNumber = this.levelNumber - 1;
            var prevLevelExist = this.game.levelConfigs.check(prevLevelNumber);
            if (prevLevelExist === false) {
                return;
            }
            this.gotoLevel(prevLevelNumber);
        };
        GameplayRoot.prototype.gotoNextLevel = function () {
            var nextLevelNumber = this.levelNumber + 1;
            var nextLevelExist = this.game.levelConfigs.check(nextLevelNumber);
            if (nextLevelExist === false) {
                return;
            }
            this.gotoLevel(nextLevelNumber);
        };
        GameplayRoot.prototype.gotoLevel = function (levelNumber) {
            this.game.changeScene(this.scene.key, game.SceneKey.GAMEPLAY_ROOT, { levelNumber: levelNumber });
        };
        GameplayRoot.prototype.onEscKeyDown = function () {
            if (this.initData.fromEditor) {
                this.gotoEditor();
            }
            else {
                this.gotoLevelsMap();
            }
        };
        GameplayRoot.prototype.gotoEditor = function () {
            this.scene.start(game.SceneKey.LEVEL_EDITOR_ROOT, { levelNumber: this.levelNumber });
        };
        GameplayRoot.prototype.gotoTutorialEditor = function () {
            this.scene.start(game.SceneKey.TUTORIAL_EDITOR, { levelNumber: this.levelNumber });
        };
        GameplayRoot.prototype.gotoLevelsMap = function () {
            this.game.changeScene(this.scene.key, game.SceneKey.LEVELS_MAP);
        };
        GameplayRoot.prototype.restart = function () {
            this.game.changeScene(this.scene.key, game.SceneKey.GAMEPLAY_ROOT, { levelNumber: this.levelNumber });
        };
        GameplayRoot.prototype.togglePause = function () {
            var _a;
            if ((_a = this.gameplay) === null || _a === void 0 ? void 0 : _a.scene.isPaused()) {
                this.resume();
            }
            else {
                this.pause();
            }
        };
        GameplayRoot.prototype.resize = function () {
            var _a, _b, _c, _d, _e;
            (_a = this.gui) === null || _a === void 0 ? void 0 : _a.doResize();
            (_b = this.gameplay) === null || _b === void 0 ? void 0 : _b.doResize();
            (_c = this.background) === null || _c === void 0 ? void 0 : _c.resize(this.gameplay);
            (_d = this.gui) === null || _d === void 0 ? void 0 : _d.resizeTutorial(this.gameplay);
            (_e = this.gui) === null || _e === void 0 ? void 0 : _e.resizeBoosterHintScreen(this.gameplay);
        };
        GameplayRoot.prototype.pause = function () {
            this.gameplay.onPause();
            this.gui.onPause();
        };
        GameplayRoot.prototype.resume = function () {
            this.gameplay.onResume();
            this.gui.onResume();
        };
        GameplayRoot.prototype.shutdown = function () {
            this.stopChildScenes();
            console.groupEnd();
        };
        GameplayRoot.prototype.stopChildScenes = function () {
            this.getChildScenes().forEach(function (childScene) {
                if (childScene) {
                    childScene.scene.stop();
                }
            });
            if (this.gameplay) {
                this.gameplay.events.off(Phaser.Scenes.Events.CREATE, this.launchGameplayGuiScene, this);
            }
            if (this.gui) {
                this.gui.events.off(Phaser.Scenes.Events.CREATE, this.onGuiCreated, this);
                this.gui.events.off(game.GameplayGuiEvent.GOTO_LEVELS_MAP, this.gotoLevelsMap, this);
                this.gui.events.off(game.GameplayGuiEvent.GOTO_LEVEL, this.gotoLevel, this);
                this.gui.events.off(game.GameplayGuiEvent.PAUSE, this.pause, this);
                this.gui.events.off(game.GameplayGuiEvent.RESUME, this.resume, this);
            }
        };
        GameplayRoot.prototype.getChildScenes = function () {
            return [this.gameplay, this.gui];
        };
        return GameplayRoot;
    }(Phaser.Scene));
    game.GameplayRoot = GameplayRoot;
})(game || (game = {}));
var game;
(function (game) {
    var EditorTutorialText = /** @class */ (function (_super) {
        __extends(EditorTutorialText, _super);
        function EditorTutorialText(scene) {
            var _this = _super.call(this, scene) || this;
            _this.name = "tutorial_text";
            _this.addBackground();
            _this.addText();
            return _this;
        }
        EditorTutorialText.prototype.addBackground = function () {
            this.background = this.scene.add.image(0, 0, "editor", "back");
            this.add(this.background);
        };
        EditorTutorialText.prototype.addText = function () {
            var content = "Tutorial";
            var style = {
                fontFamily: game.GameFont.SOUSES,
                fontStyle: game.FontWeight.BOLD,
                fontSize: "30px",
                color: "#B72C35",
                align: "center",
            };
            this.text = this.scene.add.text(0, 0, content, style);
            this.text.setWordWrapWidth(this.background.width * 0.9);
            this.text.setOrigin(0.5, 0.5);
            // this.text.y += 3
            this.add(this.text);
        };
        EditorTutorialText.prototype.updateText = function (content) {
            this.text.setText(content);
            var maxHeight = this.background.height * 0.7;
            this.text.scale = 1;
            this.text.scale = Math.min(1, maxHeight / this.text.height);
        };
        EditorTutorialText.prototype.getWidth = function () {
            return this.background.width;
        };
        EditorTutorialText.prototype.getHeight = function () {
            return this.background.height;
        };
        EditorTutorialText.prototype.getDisplayHeight = function () {
            return this.getHeight() * this.scaleY;
        };
        return EditorTutorialText;
    }(Phaser.GameObjects.Container));
    game.EditorTutorialText = EditorTutorialText;
})(game || (game = {}));
var game;
(function (game) {
    var Rectangle = Phaser.Geom.Rectangle;
    var EditorTutorialArea = /** @class */ (function (_super) {
        __extends(EditorTutorialArea, _super);
        function EditorTutorialArea(scene) {
            var _this = _super.call(this, scene, {
                x: 0,
                y: 0,
                fillStyle: { color: 0, alpha: 0.5 },
                lineStyle: { width: 0 },
            }) || this;
            _this.width = 0;
            _this.height = 0;
            _this.setInteractive(_this.getHitArea(), Rectangle.Contains);
            _this.setSize(EditorTutorialArea.INITIAL_WIDTH, EditorTutorialArea.INITIAL_HEIGHT);
            _this.input.cursor = "pointer";
            return _this;
        }
        EditorTutorialArea.prototype.getHitArea = function () {
            return new Rectangle(-this.width / 2, -this.height / 2, this.width, this.height);
        };
        EditorTutorialArea.prototype.changeSize = function (deltaWidth, deltaHeight) {
            this.setSize(this.width + deltaWidth, this.height + deltaHeight);
        };
        EditorTutorialArea.prototype.setSize = function (width, height) {
            this.width = Math.max(EditorTutorialArea.INITIAL_WIDTH, width);
            this.height = Math.max(EditorTutorialArea.INITIAL_HEIGHT, height);
            this.clear();
            this.fillRoundedRect(-width / 2, -height / 2, width, height);
            this.input.hitArea = this.getHitArea();
        };
        EditorTutorialArea.prototype.destroy = function (fromScene) {
            _super.prototype.destroy.call(this, fromScene);
        };
        EditorTutorialArea.INITIAL_WIDTH = game.GameGrid.CELL_SIZE * 1.5;
        EditorTutorialArea.INITIAL_HEIGHT = game.GameGrid.CELL_SIZE * 1.5;
        return EditorTutorialArea;
    }(Phaser.GameObjects.Graphics));
    game.EditorTutorialArea = EditorTutorialArea;
})(game || (game = {}));
var game;
(function (game) {
    var TutorialConfigPanelEvent;
    (function (TutorialConfigPanelEvent) {
        TutorialConfigPanelEvent["TEXT_CHANGE"] = "TEXT_CHANGE";
    })(TutorialConfigPanelEvent = game.TutorialConfigPanelEvent || (game.TutorialConfigPanelEvent = {}));
    var TutorialConfigPanel = /** @class */ (function (_super) {
        __extends(TutorialConfigPanel, _super);
        function TutorialConfigPanel(scene, levelNumber, tutorialConfig) {
            var _this = _super.call(this, scene, "Level " + levelNumber) || this;
            _this.tutorialConfig = tutorialConfig;
            _this.panel.addInput(_this.tutorialConfig, "text").on("change", _this.onTextChange.bind(_this));
            _this.panel.addInput(_this.tutorialConfig, "textKey");
            _this.panel.addSeparator();
            _this.panel.addInput(_this.tutorialConfig, "tweenMask");
            _this.panel.addInput(_this.tutorialConfig, "tweenScale", { min: 1, max: 1.3, step: 0.01 });
            _this.panel.addSeparator();
            _this.panel.addInput(_this.tutorialConfig, "snapping");
            _this.panel.addSeparator();
            _this.addButtons();
            return _this;
        }
        TutorialConfigPanel.prototype.onTextChange = function (text) {
            this.events.emit(TutorialConfigPanelEvent.TEXT_CHANGE, text);
        };
        TutorialConfigPanel.prototype.addButtons = function () {
            this.editorButton = this.panel.addButton({ title: "Editor" });
            this.deleteButton = this.panel.addButton({ title: "Delete" });
            this.saveButton = this.panel.addButton({ title: "Save" });
            this.testButton = this.panel.addButton({ title: "Test" });
        };
        return TutorialConfigPanel;
    }(game.EditorPanel));
    game.TutorialConfigPanel = TutorialConfigPanel;
})(game || (game = {}));
///<reference path='EditorTutorialText.ts' />
///<reference path='EditorTutorialArea.ts' />
///<reference path='panels/TutorialConfigPanel.ts' />
var game;
(function (game) {
    var ButtonEvent = Phaser.GameObjects.ButtonEvent;
    var TutorialEditor = /** @class */ (function (_super) {
        __extends(TutorialEditor, _super);
        function TutorialEditor() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.lastPointerDownTime = 0;
            return _this;
        }
        TutorialEditor.prototype.init = function (data) {
            this.levelNumber = data ? data.levelNumber : 1;
            this.levelConfig = this.game.levelConfigs.get(this.levelNumber);
            this.tutorialConfig = _.cloneDeep(this.levelConfig.tutorial) || this.getDefaultTutorialConfig();
            console.group("Tutorial Editor - Level " + this.levelNumber);
            console.log(this.tutorialConfig);
            this.getDefaultTutorialConfig();
            this.lastPointerDownTime = 0;
            this.tutorialArea = null;
            this.events.once("shutdown", this.shutdown, this);
        };
        TutorialEditor.prototype.getDefaultTutorialConfig = function () {
            var defaultConfig = {
                autoGenerated: true,
                tweenMask: false,
                tweenScale: 1.15,
                width: 0,
                height: 0,
                x: 0,
                y: 0,
                snapping: true,
                text: "",
                textKey: "",
            };
            return defaultConfig;
        };
        TutorialEditor.prototype.preload = function () {
            // we have to preload this for grid
            this.load.atlas("gameplay", "assets/graphics/gameplay.png", "assets/graphics/gameplay.json");
            this.load.atlas("gameplay_gui", "assets/graphics/gameplay_gui.png", "assets/graphics/gameplay_gui.json");
            this.load.bitmapFontFromAtlas(game.BitmapGameFont.INGAME_GUI_DIGITS, "gameplay_gui", "ingame_gui_digits", "assets/fonts/bitmap/ingame_gui_digits.fnt");
        };
        TutorialEditor.prototype.create = function () {
            this.addEditorsPanels();
            this.addBackground();
            this.addLevelLabel();
            this.addGrid();
            this.addItemsLayer();
            this.loadFromConfig();
            this.addKeyboardCallbacks();
            this.addPointerCallbacks();
            this.resize();
        };
        TutorialEditor.prototype.addEditorsPanels = function () {
            var _this = this;
            this.panelsContainer = document.getElementById("editor-panels");
            this.panelsContainer.style.visibility = "visible";
            this.time.delayedCall(100, function () {
                _this.panelsContainer.style.visibility = "visible";
            });
            this.panel = new game.TutorialConfigPanel(this, this.levelConfig.levelNumber, this.tutorialConfig);
            this.panel.events.on(game.TutorialConfigPanelEvent.TEXT_CHANGE, this.onTutorialTextChange, this);
            this.panel.editorButton.on("click", this.gotoLevelEditor.bind(this));
            this.panel.deleteButton.on("click", this.onDeleteButtonClick.bind(this));
            this.panel.testButton.on("click", this.onTestButtonClick.bind(this));
            this.panel.saveButton.on("click", this.onSaveButtonClick.bind(this));
        };
        TutorialEditor.prototype.gotoLevelEditor = function () {
            this.scene.start(game.SceneKey.LEVEL_EDITOR_ROOT, { levelNumber: this.levelNumber });
        };
        TutorialEditor.prototype.onTutorialTextChange = function (text) {
            if (!this.tutorialText) {
                return;
            }
            this.tutorialText.updateText(text);
        };
        TutorialEditor.prototype.onDeleteButtonClick = function () {
            var _this = this;
            if (!this.tutorialArea) {
                console.warn("Nothing to delete!");
                return;
            }
            var isConfirmed = window.confirm("Delete tutorial for level " + this.levelConfig.levelNumber + "?");
            if (!isConfirmed) {
                return;
            }
            this.tutorialArea.destroy();
            this.tutorialArea = null;
            this.tutorialText.destroy();
            this.tutorialText = null;
            Object.assign(this.tutorialConfig, this.getDefaultTutorialConfig());
            this.panel.refresh();
            delete this.levelConfig.tutorial;
            this.panel.disableInput();
            console.log("Deleting tutorial for level " + this.levelConfig.levelNumber + "...");
            this.game.levelConfigs.saveLocally();
            this.game.levelConfigs.saveRemotely()
                .then(function () {
                console.log("Delete complete! ✔");
            })
                .catch(function (xhr) {
                console.warn("Delete failed!");
            })
                .finally(function () {
                _this.panel.enableInput();
            });
        };
        TutorialEditor.prototype.onTestButtonClick = function () {
            if (!this.tutorialArea) {
                console.warn("Add tutorial area first!");
                return;
            }
            Object.assign(this.tutorialConfig, this.createTutorialConfig());
            this.levelConfig.tutorial = this.tutorialConfig;
            this.game.changeScene(this.scene.key, game.SceneKey.GAMEPLAY_ROOT, { levelNumber: this.levelNumber });
        };
        TutorialEditor.prototype.onSaveButtonClick = function () {
            var _this = this;
            if (!this.tutorialArea) {
                console.warn("Add tutorial area first!");
                return;
            }
            if (!this.tutorialConfig.textKey) {
                console.warn("Please set textKey!");
                return;
            }
            Object.assign(this.tutorialConfig, this.createTutorialConfig());
            this.levelConfig.tutorial = this.tutorialConfig;
            this.panel.disableInput();
            console.log("Uploading tutorial for level " + this.levelConfig.levelNumber + "...", this.tutorialConfig);
            this.game.levelConfigs
                .saveLocally()
                .then(function () {
                console.log("Local save complete! ✔");
            })
                .catch(function (xhr) {
                console.warn("Local save failed!");
            });
            this.game.levelConfigs
                .saveRemotely()
                .then(function () {
                console.log("Upload complete! ✔");
            })
                .catch(function (xhr) {
                console.warn("Upload failed!");
            })
                .finally(function () {
                _this.panel.enableInput();
            });
        };
        TutorialEditor.prototype.createTutorialConfig = function () {
            return __assign(__assign({}, this.tutorialConfig), { x: this.tutorialArea.x, y: this.tutorialArea.y, width: this.tutorialArea.width, height: this.tutorialArea.height, autoGenerated: false });
        };
        TutorialEditor.prototype.addBackground = function () {
            this.background = this.add.image(0, 0, "editor", this.levelConfig.background);
            this.background.setOrigin(0.5, 1);
        };
        TutorialEditor.prototype.addLevelLabel = function () {
            this.levelLabel = new game.EditorLevelLabel(this, this.levelNumber);
            this.levelLabel.prevLevelButton.once(ButtonEvent.PRESS, this.gotoPrevLevel, this);
            this.levelLabel.nextLevelButton.once(ButtonEvent.PRESS, this.gotoNextLevel, this);
            this.add.existing(this.levelLabel);
        };
        TutorialEditor.prototype.gotoPrevLevel = function () {
            this.gotoLevel(this.levelNumber - 1);
        };
        TutorialEditor.prototype.gotoNextLevel = function () {
            this.gotoLevel(this.levelNumber + 1);
        };
        TutorialEditor.prototype.gotoLevel = function (levelNumber) {
            var isLevelExist = this.game.levelConfigs.check(levelNumber);
            if (isLevelExist === false) {
                console.warn("Level " + levelNumber + " doesn't exist!");
                return;
            }
            this.scene.start(game.SceneKey.TUTORIAL_EDITOR, { levelNumber: levelNumber });
        };
        TutorialEditor.prototype.addGrid = function () {
            this.grid = new game.GameGrid(this, game.GameGrid.COLUMNS, game.GameGrid.ROWS);
            this.add.existing(this.grid);
        };
        TutorialEditor.prototype.addItemsLayer = function () {
            this.itemsContainer = this.add.container(0, 0);
        };
        TutorialEditor.prototype.loadFromConfig = function () {
            this.loadItems();
            this.loadTutorial();
        };
        TutorialEditor.prototype.loadItems = function () {
            var _this = this;
            this.items = [];
            this.levelConfig.items
                .filter(function (itemConfig) { return itemConfig.row < game.GameGrid.ROWS; })
                .forEach(function (itemConfig) {
                var cell = _this.grid.getCellAt(itemConfig.row, itemConfig.column);
                var item = new game.EditorItem(_this, "editor", itemConfig.type);
                item.x = cell.x;
                item.y = cell.y;
                item.column = cell.column;
                item.row = cell.row;
                item.disableInteractive();
                _this.itemsContainer.add(item);
                _this.items.push(item);
            });
        };
        TutorialEditor.prototype.loadTutorial = function () {
            if (this.tutorialConfig.autoGenerated) {
                return;
            }
            this.addTutorialArea(this.tutorialConfig.x, this.tutorialConfig.y);
            this.tutorialArea.setSize(this.tutorialConfig.width, this.tutorialConfig.height);
            this.addTutorialText();
            this.tutorialText.updateText(this.tutorialConfig.text);
        };
        TutorialEditor.prototype.addKeyboardCallbacks = function () {
            var _this = this;
            this.shiftKey = this.input.keyboard.addKey("shift");
            this.input.keyboard.once("keydown-PLUS", function () {
                _this.addTutorialArea(_this.input.activePointer.x, _this.input.activePointer.y);
            });
            this.input.keyboard.once("keydown-ESC", this.gotoLevelsMapDev, this);
        };
        TutorialEditor.prototype.gotoLevelsMapDev = function () {
            this.scene.start(game.SceneKey.LEVELS_MAP_DEV);
        };
        TutorialEditor.prototype.addPointerCallbacks = function () {
            this.input.on(Phaser.Input.Events.POINTER_DOWN, this.onPointerDown, this);
            this.input.on("drag", function (pointer, gameObject, dragX, dragY) {
                gameObject.x = dragX;
                gameObject.y = dragY;
            });
        };
        TutorialEditor.prototype.onPointerDown = function (pointer) {
            var now = Date.now();
            var deltaTime = now - this.lastPointerDownTime;
            if (deltaTime < 300) {
                if (this.tutorialArea) {
                    return;
                }
                this.tutorialConfig.autoGenerated = false;
                this.addTutorialArea(pointer.x, pointer.y);
                this.addTutorialText();
                this.alignTutorialText();
                if (this.tutorialConfig.snapping) {
                    this.snapToGrid(this.tutorialArea);
                }
            }
            this.lastPointerDownTime = now;
        };
        TutorialEditor.prototype.addTutorialArea = function (x, y) {
            var localPosition = this.itemsContainer.pointToContainer({ x: x, y: y });
            this.tutorialArea = new game.EditorTutorialArea(this);
            this.tutorialArea.x = localPosition.x;
            this.tutorialArea.y = localPosition.y;
            this.tutorialArea.on(Phaser.Input.Events.GAMEOBJECT_POINTER_WHEEL, this.onTutorialAreaWheel, this);
            this.tutorialArea.on(Phaser.Input.Events.GAMEOBJECT_DRAG_END, this.onTutorialAreaDragEnd, this);
            this.itemsContainer.add(this.tutorialArea);
            this.input.setDraggable(this.tutorialArea);
        };
        TutorialEditor.prototype.onTutorialAreaWheel = function (pointer, dx, dy) {
            var deltaWidth = 0;
            var deltaHeight = 0;
            var sign = Phaser.Math.Sign(dy) * -1;
            var deltaSize = game.GameGrid.CELL_SIZE / 2;
            if (this.shiftKey.isDown) {
                deltaWidth = deltaSize * sign;
            }
            else {
                deltaHeight = deltaSize * sign;
            }
            this.tutorialArea.changeSize(deltaWidth, deltaHeight);
        };
        TutorialEditor.prototype.onTutorialAreaDragEnd = function (pointer, x, y) {
            if (this.tutorialConfig.snapping) {
                this.snapToGrid(this.tutorialArea);
            }
        };
        TutorialEditor.prototype.snapToGrid = function (object) {
            var cell = this.grid.getCellAtXY(object.x, object.y);
            if (cell) {
                object.x = cell.x;
                object.y = cell.y;
            }
            else {
                var getDistance = function (cell) { return Phaser.Math.Distance.Between(cell.x, cell.y, object.x, object.y); };
                var nearestCell = _.sortBy(this.grid.cells, getDistance)[0];
                object.x = nearestCell.x;
                object.y = nearestCell.y;
            }
        };
        TutorialEditor.prototype.addTutorialText = function () {
            this.tutorialText = new game.EditorTutorialText(this);
            this.tutorialText.updateText(this.tutorialConfig.text);
            this.add.existing(this.tutorialText);
        };
        TutorialEditor.prototype.resize = function () {
            this.resizeBackground();
            this.alignLevelLabel();
            this.resizeGrid();
            this.resizeItemsContainer();
            this.alignTutorialText();
        };
        TutorialEditor.prototype.resizeBackground = function () {
            this.background.envelop(game.Config.GAME_WIDTH, game.Config.GAME_HEIGHT);
            this.background.x = game.Config.HALF_GAME_WIDTH;
            this.background.y = game.Config.GAME_HEIGHT;
        };
        TutorialEditor.prototype.alignLevelLabel = function () {
            this.levelLabel.scale = 0.66;
            this.levelLabel.x = game.Config.HALF_GAME_WIDTH;
            this.levelLabel.y = this.levelLabel.getBounds().height / 2 + 20;
        };
        TutorialEditor.prototype.resizeGrid = function () {
            var maxWidth = game.Config.GAME_WIDTH * 0.85;
            var maxHeight = game.Config.GAME_HEIGHT * 0.8;
            var scaleX = maxWidth / this.grid.getWidth();
            var scaleY = maxHeight / this.grid.getHeight();
            var scale = Math.min(scaleX, scaleY);
            this.grid.scale = scale;
            this.grid.x = (game.Config.GAME_WIDTH - this.grid.getWidth() * scale) / 2;
            this.grid.y = (game.Config.GAME_HEIGHT - this.grid.getHeight() * scale) / 2;
        };
        TutorialEditor.prototype.resizeItemsContainer = function () {
            this.itemsContainer.scale = this.grid.scale;
            this.itemsContainer.x = this.grid.x;
            this.itemsContainer.y = this.grid.y;
        };
        TutorialEditor.prototype.alignTutorialText = function () {
            if (!this.tutorialText) {
                return;
            }
            var maxWidth = game.Config.GAME_WIDTH * 0.8;
            this.tutorialText.scale = maxWidth / this.tutorialText.getWidth();
            this.tutorialText.x = game.Config.HALF_GAME_WIDTH;
            this.tutorialText.y = game.Config.GAME_HEIGHT - this.tutorialText.getDisplayHeight() / 2 - 20;
        };
        TutorialEditor.prototype.shutdown = function () {
            this.destroyPanels();
            console.groupEnd();
        };
        TutorialEditor.prototype.destroyPanels = function () {
            this.panelsContainer.style.visibility = "hidden";
            this.panelsContainer = null;
            if (this.panel) {
                this.panel.destroy();
            }
        };
        return TutorialEditor;
    }(Phaser.Scene));
    game.TutorialEditor = TutorialEditor;
})(game || (game = {}));
var game;
(function (game) {
    var LevelConfigsManager = /** @class */ (function () {
        function LevelConfigsManager(allConfigs) {
            this.allConfigs = allConfigs;
            // this.fixConfigs()
        }
        LevelConfigsManager.prototype.fixConfigs = function () {
            // this.fixStars()
            // this.fixBackgrounds()
            this.saveLocally();
            this.saveRemotely()
                .then(function () {
                console.log("Configs were fixed!");
            })
                .catch(function () {
                console.warn("Can't fix configs!");
            });
        };
        LevelConfigsManager.prototype.fixBackgrounds = function () {
            this.getAll().forEach(function (levelConfig) {
                if (levelConfig.levelNumber <= 13) {
                    levelConfig.background = "background_1";
                }
                else if (levelConfig.levelNumber >= 14 && levelConfig.levelNumber <= 27) {
                    levelConfig.background = "background_2";
                }
                else {
                    levelConfig.background = "background_3";
                }
            });
        };
        LevelConfigsManager.prototype.fixStars = function () {
            var _this = this;
            Object.keys(this.allConfigs).forEach(function (configKey) {
                var levelConfig = _this.allConfigs[configKey];
                levelConfig.stars = game.Editor.createStarsConfig(levelConfig.levelNumber, levelConfig.items);
            });
        };
        LevelConfigsManager.prototype.getAll = function () {
            return Object.values(this.allConfigs);
        };
        LevelConfigsManager.prototype.get = function (levelNumber) {
            return this.allConfigs[levelNumber];
        };
        LevelConfigsManager.prototype.remove = function (levelNumber) {
            delete this.allConfigs[levelNumber.toString()];
        };
        LevelConfigsManager.prototype.check = function (levelNumber) {
            return this.allConfigs.hasOwnProperty(levelNumber.toString());
        };
        LevelConfigsManager.prototype.add = function (config) {
            this.allConfigs[config.levelNumber] = config;
        };
        LevelConfigsManager.prototype.create = function (levelNumber, add) {
            if (add === void 0) { add = true; }
            var config = this.createDefaultLevelConfig(levelNumber);
            if (add) {
                this.allConfigs[levelNumber] = config;
            }
            return config;
        };
        LevelConfigsManager.prototype.createDefaultLevelConfig = function (levelNumber) {
            return {
                levelNumber: levelNumber,
                background: "background_001",
                balls: 5,
                autoThrow: this.createDefaultAutoThrowConfig(),
                generator: this.createDefaultGeneratorConfig(),
                stars: [100, 200, 300],
                items: [],
            };
        };
        LevelConfigsManager.prototype.createDefaultAutoThrowConfig = function () {
            return {
                enabled: false,
                fastForward: true,
                snapping: false,
                delay: 300,
                x: 0,
                y: 0,
            };
        };
        LevelConfigsManager.prototype.createDefaultGeneratorConfig = function () {
            return {
                seed: Date.now().toString(),
                general: 50,
                startRow: 5,
                targetItemsNum: 10,
                targetItemType: game.ItemType.BASIC_BLOCK,
                minHealth: 2,
                maxHealth: 30,
                deltaHealth: 0,
                incrementHealth: 1,
                itemTypes: this.getDefaultItemTypes(),
                weights: this.getDefaultWeights(),
                sides: 0,
            };
        };
        LevelConfigsManager.prototype.getDefaultItemTypes = function () {
            var defaultEnabled = [game.ItemType.COLLECTABLE_BALL, game.ItemType.BASIC_BLOCK];
            var keys = this.getGeneratorItemTypes();
            var values = keys.map(function (key) { return defaultEnabled.includes(key); });
            return _.zipObject(keys, values);
        };
        LevelConfigsManager.prototype.getDefaultWeights = function () {
            var keys = this.getGeneratorItemTypes();
            var values = keys.map(function (key) {
                return 100;
            });
            return _.zipObject(keys, values);
        };
        LevelConfigsManager.prototype.getGeneratorItemTypes = function () {
            var allTypes = game.ItemTypeUtil.getAllTypes();
            var typesToRemove = [game.ItemType.SHATTER_BLOCK_PIECE];
            return _.without.apply(_, __spreadArrays([allTypes], typesToRemove));
        };
        LevelConfigsManager.prototype.saveLocally = function () {
            var isBrowserSyncAvailable = typeof window["___browserSync___"] !== "undefined";
            if (isBrowserSyncAvailable === false) {
                return Promise.resolve(false);
            }
            var url = location.protocol + "//" + location.host + "/files";
            var path = "dev/assets/configs/";
            return this.doSave(url, path);
        };
        LevelConfigsManager.prototype.saveRemotely = function () {
            var url = game.Config.SERVER_URL + "upload.php";
            return this.doSave(url, "");
        };
        /*public save(): Promise<any>[] {
            return [
                this.saveLocally(),
                this.saveRemotely(),
            ]
        }*/
        LevelConfigsManager.prototype.doSave = function (url, filepath) {
            var _this = this;
            return new Promise(function (resolve, reject) {
                var _a;
                var filename = (_a = utils.NetUtil.getParam("levelsFile")) !== null && _a !== void 0 ? _a : "levels";
                var data = {
                    filename: filepath + filename + ".json",
                    content: JSON.stringify(_this.allConfigs),
                };
                var xhr = new XMLHttpRequest();
                xhr.open("POST", url, true);
                xhr.onload = function () {
                    resolve(xhr);
                };
                xhr.onerror = function () {
                    reject(xhr);
                };
                xhr.send(_this.convertObjectToURLSearchParams(data));
            });
        };
        LevelConfigsManager.prototype.convertObjectToURLSearchParams = function (obj) {
            return new URLSearchParams(obj);
        };
        LevelConfigsManager.prototype.getLevelNumbers = function () {
            var levelNumbers = Object.keys(this.allConfigs);
            return levelNumbers.map(function (num) {
                return parseInt(num);
            });
        };
        return LevelConfigsManager;
    }());
    game.LevelConfigsManager = LevelConfigsManager;
})(game || (game = {}));
var game;
(function (game) {
    var IngamePreloader = /** @class */ (function (_super) {
        __extends(IngamePreloader, _super);
        function IngamePreloader(scene) {
            var _this = _super.call(this, scene) || this;
            _this.isSimulating = false;
            _this.updateTimer = 0;
            _this.updateInterval = 0;
            _this.progress = 0;
            _this.scene.scale.on(Phaser.Scale.Events.RESIZE, _this.resize, _this);
            _this.scene.events.on(Phaser.Scenes.Events.UPDATE, _this.customUpdate, _this);
            _this.name = "preloader";
            _this.addBackground();
            _this.addLogo();
            return _this;
        }
        IngamePreloader.prototype.reset = function () {
            this.visible = true;
            this.active = true;
            this.alpha = 1;
            this.updateTimer = 0;
            this.progress = 0;
            this.isSimulating = false;
            this.logo.setProgressInstant(0);
        };
        IngamePreloader.prototype.addBackground = function () {
            this.background = this.scene.add.image(0, 0, "preloader", "bg");
            this.add(this.background);
        };
        IngamePreloader.prototype.addLogo = function () {
            this.logo = new game.LoadingLogo(this.scene);
            this.add(this.logo);
        };
        IngamePreloader.prototype.resize = function (gameSize) {
            var _a, _b;
            var width = (_a = gameSize === null || gameSize === void 0 ? void 0 : gameSize.width) !== null && _a !== void 0 ? _a : game.Config.GAME_WIDTH;
            var height = (_b = gameSize === null || gameSize === void 0 ? void 0 : gameSize.height) !== null && _b !== void 0 ? _b : game.Config.GAME_HEIGHT;
            this.resizeBackground(width, height);
            this.alignLogo(width, height);
        };
        IngamePreloader.prototype.resizeBackground = function (width, height) {
            this.background.envelop(width, height);
            this.background.x = width / 2;
            this.background.y = height / 2;
        };
        IngamePreloader.prototype.alignLogo = function (width, height) {
            var maxWidth = width * 0.45;
            this.logo.scale = Math.min(1, maxWidth / this.logo.getWidth());
            this.logo.x = width / 2;
            this.logo.y = height / 2;
        };
        IngamePreloader.prototype.simulateLoading = function () {
            this.isSimulating = true;
        };
        IngamePreloader.prototype.customUpdate = function (time, delta) {
            if (this.isSimulating === false) {
                return;
            }
            if (this.progress >= 99) {
                return;
            }
            this.updateTimer += delta;
            if (this.updateTimer > this.updateInterval) {
                this.updateTimer -= this.updateInterval;
                this.updateInterval = Phaser.Math.RND.between(300, 800);
                this.progress += Phaser.Math.RND.between(1, 3);
                if (this.progress >= 99) {
                    this.progress = 99;
                }
                this.logo.setProgress(this.progress / 100);
            }
        };
        IngamePreloader.prototype.setComplete = function () {
            this.isSimulating = false;
            this.progress = 100;
            this.logo.setProgress(1);
        };
        IngamePreloader.prototype.hide = function () {
            this.scene.tweens.add({
                targets: this,
                delay: 150,
                duration: 200,
                ease: Phaser.Math.Easing.Cubic.Out,
                alpha: 0,
                onComplete: this.onHideComplete.bind(this),
            });
        };
        IngamePreloader.prototype.onHideComplete = function () {
            this.kill();
        };
        IngamePreloader.prototype.destroy = function (fromScene) {
            if (this.scene) {
                this.scene.scale.off(Phaser.Scale.Events.RESIZE, this.resize, this);
                this.scene.events.off(Phaser.Scenes.Events.UPDATE, this.customUpdate, this);
            }
            _super.prototype.destroy.call(this, fromScene);
        };
        return IngamePreloader;
    }(Phaser.GameObjects.Container));
    game.IngamePreloader = IngamePreloader;
})(game || (game = {}));
var game;
(function (game) {
    var BoosterType;
    (function (BoosterType) {
        BoosterType["BOMB"] = "bomb";
        BoosterType["CRACKER"] = "cracker";
        BoosterType["STOP"] = "stop";
    })(BoosterType = game.BoosterType || (game.BoosterType = {}));
})(game || (game = {}));
var game;
(function (game) {
    var EventEmitter = Phaser.Events.EventEmitter;
    var BoosterEvent;
    (function (BoosterEvent) {
        BoosterEvent["NUM_CHANGED"] = "IngameBooster_NUM_CHANGED";
    })(BoosterEvent = game.BoosterEvent || (game.BoosterEvent = {}));
    var Booster = /** @class */ (function (_super) {
        __extends(Booster, _super);
        function Booster(type, num) {
            var _this = _super.call(this) || this;
            _this._type = type;
            _this._num = num;
            return _this;
        }
        Object.defineProperty(Booster.prototype, "num", {
            get: function () {
                return this._num;
            },
            set: function (value) {
                this._num = Math.max(0, value);
                this.emit(BoosterEvent.NUM_CHANGED, this);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Booster.prototype, "type", {
            get: function () {
                return this._type;
            },
            enumerable: false,
            configurable: true
        });
        return Booster;
    }(EventEmitter));
    game.Booster = Booster;
})(game || (game = {}));
///<reference path='BoosterType.ts' />
///<reference path='Booster.ts' />
var game;
(function (game_4) {
    var BoostersManager = /** @class */ (function () {
        function BoostersManager(game) {
            this.game = game;
            this.store = this.game.store;
            this.store.on(game_4.GameStoreEvent.CLEAR, this.onSaveDataCleared, this);
            this.texts = this.game.texts;
            this.texts.on(game_4.GameTextsEvent.LANGUAGE_CHANGE, this.onLanguageChange, this);
            this.initBoosters();
        }
        BoostersManager.prototype.onSaveDataCleared = function () {
            this.boosters.forEach(function (booster) {
                booster.num = 0;
            });
        };
        BoostersManager.prototype.onLanguageChange = function () {
            var allTexts = this.game.texts.texts.ingame_boosters;
            this.boosters.forEach(function (booster) {
                var texts = allTexts[booster.type];
                booster.title = texts.title;
                booster.hint = texts.hint;
            });
        };
        BoostersManager.prototype.initBoosters = function () {
            var _this = this;
            var allTexts = this.game.texts.texts.ingame_boosters;
            var saveData = this.store.getValue(game_4.GameStoreKey.INGAME_BOOSTERS);
            var types = [game_4.BoosterType.BOMB, game_4.BoosterType.CRACKER, game_4.BoosterType.STOP];
            this.boosters = types.map(function (type) {
                var _a;
                var num = (_a = saveData[type]) !== null && _a !== void 0 ? _a : 0;
                var texts = allTexts[type];
                var booster = new game_4.Booster(type, num);
                booster.title = texts.title;
                booster.hint = texts.hint;
                booster.on(game_4.BoosterEvent.NUM_CHANGED, _this.onBoosterNumChanged, _this);
                return booster;
            });
        };
        BoostersManager.prototype.onBoosterNumChanged = function (booster) {
            var _a;
            var currentData = this.store.getValue(game_4.GameStoreKey.INGAME_BOOSTERS);
            var newData = __assign(__assign({}, currentData), (_a = {}, _a[booster.type] = booster.num, _a));
            this.store.saveValue(game_4.GameStoreKey.INGAME_BOOSTERS, newData);
        };
        BoostersManager.prototype.getByType = function (type) {
            return this.boosters.find(function (booster) { return booster.type === type; });
        };
        BoostersManager.prototype.getRandom = function () {
            return Phaser.Math.RND.pick(this.boosters);
        };
        BoostersManager.prototype.updateFromGift = function (gift) {
            var _this = this;
            Object.entries(gift).forEach(function (entry) {
                var type = entry[0];
                var num = entry[1];
                _this.getByType(type).num += num;
            });
        };
        return BoostersManager;
    }());
    game_4.BoostersManager = BoostersManager;
})(game || (game = {}));
var game;
(function (game_5) {
    var GA = gameanalytics.GameAnalytics;
    var EGAProgressionStatus = gameanalytics.EGAProgressionStatus;
    var EGAErrorSeverity = gameanalytics.EGAErrorSeverity;
    var RemoteConfigKey;
    (function (RemoteConfigKey) {
        RemoteConfigKey["BOOSTERS_NUM"] = "boosters_num";
    })(RemoteConfigKey = game_5.RemoteConfigKey || (game_5.RemoteConfigKey = {}));
    var GameAnalyticsWrapper = /** @class */ (function () {
        function GameAnalyticsWrapper(game) {
            this.isEnabled = false;
            var disableAnalytics = this.disableAnalytics();
            if (disableAnalytics) {
                this.isEnabled = false;
                return;
            }
            this.game = game;
            this.isEnabled = true;
            this.loadingTimes = {};
            this.setLog();
            this.setCustomDimensions();
            this.endSessionOnUnload();
            GA.configureBuild(window.game.config.build_version.toString());
            GA.initialize("3646a9cdd69f7984bf5ae9413a451f80", "311c306197a6aa747e3ac552ba7fdeb1adb7c100");
            GA.addDesignEvent("Startup");
            this.sendAvifEvent();
            this.sendWebpEvent();
        }
        GameAnalyticsWrapper.prototype.disableAnalytics = function () {
            var forceAnalytics = utils.NetUtil.getParamBool("analytics");
            if (forceAnalytics) {
                return false;
            }
            return game_5.Main.development || typeof GA === "undefined" || this.isRobowhale();
        };
        GameAnalyticsWrapper.prototype.isRobowhale = function () {
            var _a;
            return (_a = location.hostname) === null || _a === void 0 ? void 0 : _a.includes("robowhale");
        };
        GameAnalyticsWrapper.prototype.setLog = function () {
            var logLevel = utils.NetUtil.getParamInt("analyticsLog");
            if (logLevel === 1) {
                GA.setEnabledInfoLog(true);
            }
            else if (logLevel === 2) {
                GA.setEnabledVerboseLog(true);
            }
        };
        GameAnalyticsWrapper.prototype.setCustomDimensions = function () {
            GA.configureAvailableCustomDimensions01(["poki", "yandex", "game-distribution", "worker-bee", "orange-fr"]);
            GA.setCustomDimension01("poki");
            GA.configureAvailableCustomDimensions02([game_5.RendererType.CANVAS, game_5.RendererType.WEBGL, game_5.RendererType.HEADLESS]);
            GA.setCustomDimension02(this.game.rendererType);
            var browsers = ["chrome", "edge", "firefox", "ie", "mobileSafari", "opera", "safari", "silk", "trident", "other"];
            var currentBrowser = this.getCurrentBrowser(browsers);
            GA.configureAvailableCustomDimensions03(browsers);
            GA.setCustomDimension03(currentBrowser);
        };
        GameAnalyticsWrapper.prototype.getCurrentBrowser = function (browsers) {
            var _this = this;
            var currentBrowser = browsers.find(function (browser) { return _this.game.device.browser[browser] === true; });
            return currentBrowser !== null && currentBrowser !== void 0 ? currentBrowser : "other";
        };
        GameAnalyticsWrapper.prototype.endSessionOnUnload = function () {
            window.addEventListener("unload", function () {
                GA.endSession();
            }, { once: true });
        };
        GameAnalyticsWrapper.prototype.sendLevelStart = function (level) {
            this.sendProgressionEvent(EGAProgressionStatus.Start, level);
        };
        GameAnalyticsWrapper.prototype.sendLevelComplete = function (level, starsNum) {
            this.sendProgressionEvent(EGAProgressionStatus.Complete, level, starsNum);
        };
        GameAnalyticsWrapper.prototype.sendLevelFail = function (level, blocksLeft) {
            this.sendProgressionEvent(EGAProgressionStatus.Fail, level, blocksLeft);
        };
        GameAnalyticsWrapper.prototype.sendProgressionEvent = function (type, level, score) {
            if (this.isEnabled === false) {
                return;
            }
            var levelKey = "level_" + _.padStart(level.toString(), 3, "0");
            GA.addProgressionEvent(type, levelKey, "", "", score);
        };
        GameAnalyticsWrapper.prototype.sendBoosterUseEvent = function (level, type) {
            if (this.isEnabled === false) {
                return;
            }
            var levelKey = "Level_" + _.padStart(level.toString(), 3, "0");
            GA.addDesignEvent(levelKey + ":Booster:" + type);
        };
        GameAnalyticsWrapper.prototype.sendAdEvent = function (action, type, placement, adProvider) {
            if (this.isEnabled === false) {
                return;
            }
            GA.addAdEvent(action, type, adProvider, placement);
        };
        GameAnalyticsWrapper.prototype.sendRewardedAd = function (placement, type, action) {
            if (this.isEnabled === false) {
                return;
            }
            GA.addDesignEvent("Rewarded_Ad:" + placement + ":" + type + ":" + action);
        };
        GameAnalyticsWrapper.prototype.sendLoadingEvent = function (place, type) {
            if (this.isEnabled === false) {
                return;
            }
            if (type === "start") {
                this.loadingTimes[place] = Date.now();
                GA.addDesignEvent("Loading:" + place + ":" + type);
            }
            if (type === "complete") {
                var durationMs = Date.now() - this.loadingTimes[place];
                var duration = Phaser.Math.RoundTo(durationMs / 1000, -1);
                GA.addDesignEvent("Loading:" + place + ":" + type, duration);
            }
        };
        GameAnalyticsWrapper.prototype.sendDesignEvent = function (event, value) {
            if (this.isEnabled === false) {
                return;
            }
            GA.addDesignEvent(event, value);
        };
        GameAnalyticsWrapper.prototype.sendError = function (message, severity) {
            if (severity === void 0) { severity = EGAErrorSeverity.Error; }
            if (this.isEnabled === false) {
                return;
            }
            GA.addErrorEvent(severity, message);
        };
        GameAnalyticsWrapper.prototype.sendAvifEvent = function () {
            var event = this.game.avif
                ? "avif:supported"
                : "avif:not_supported";
            this.sendDesignEvent(event, this.game.avif ? 1 : 0);
        };
        GameAnalyticsWrapper.prototype.sendWebpEvent = function () {
            var event = this.game.webp
                ? "webp:supported"
                : "webp:not_supported";
            this.sendDesignEvent(event, this.game.webp ? 1 : 0);
        };
        GameAnalyticsWrapper.prototype.getRemoteConfigValue = function (key, defaultValue) {
            if (this.isEnabled === false) {
                return defaultValue;
            }
            return GA.getRemoteConfigsValueAsString(key, defaultValue);
        };
        return GameAnalyticsWrapper;
    }());
    game_5.GameAnalyticsWrapper = GameAnalyticsWrapper;
})(game || (game = {}));
var game;
(function (game) {
    var EGAAdAction = gameanalytics.EGAAdAction;
    var EGAAdType = gameanalytics.EGAAdType;
    var PokiDummySdk = /** @class */ (function () {
        function PokiDummySdk() {
        }
        PokiDummySdk.prototype.init = function () {
            return Promise.resolve();
        };
        PokiDummySdk.prototype.setDebug = function (value) {
        };
        PokiDummySdk.prototype.gameLoadingStart = function () {
        };
        PokiDummySdk.prototype.gameLoadingProgress = function (progress) {
        };
        PokiDummySdk.prototype.gameLoadingFinished = function () {
        };
        PokiDummySdk.prototype.gameplayStart = function () {
        };
        PokiDummySdk.prototype.gameplayStop = function () {
        };
        PokiDummySdk.prototype.commercialBreak = function () {
            return Promise.resolve(undefined);
        };
        PokiDummySdk.prototype.rewardedBreak = function () {
            return Promise.resolve(undefined);
        };
        PokiDummySdk.prototype.happyTime = function (scale) {
        };
        return PokiDummySdk;
    }());
    game.PokiDummySdk = PokiDummySdk;
    var PokiSdkWrapper = /** @class */ (function () {
        function PokiSdkWrapper(_game) {
            this.isEnabled = false;
            this.wasMuted = false;
            this.isAdBlockEnabled = false;
            this.game = _game;
            this.isEnabled = typeof PokiSDK !== "undefined";
            this.sdk = this.isEnabled ? PokiSDK : new PokiDummySdk();
            this.sdk.setDebug(utils.NetUtil.getParamBool("pokiDev"));
        }
        PokiSdkWrapper.prototype.init = function () {
            var _this = this;
            return this.sdk.init()
                .then(function () {
                _this.game.analytics.sendDesignEvent("AdBlock:disabled");
            })
                .catch(function () {
                _this.game.analytics.sendDesignEvent("AdBlock:enabled", true);
                _this.isAdBlockEnabled = true;
            })
                .finally(function () {
                var _a;
                (_a = _this.game.raven) === null || _a === void 0 ? void 0 : _a.addExtraContext({
                    adblock: _this.isAdBlockEnabled,
                });
            });
        };
        PokiSdkWrapper.prototype.injectIntoScenes = function () {
            var _this = this;
            this.game.scene.scenes.forEach(function (scene) { return (scene.poki = _this); });
        };
        PokiSdkWrapper.prototype.commercialBreak = function (placement) {
            var _this = this;
            var _a;
            if (this.isAdBlockEnabled) {
                return Promise.reject("AdBlock");
            }
            (_a = this.game.analytics) === null || _a === void 0 ? void 0 : _a.sendAdEvent(EGAAdAction.Clicked, EGAAdType.Interstitial, placement, "poki");
            return this.onBreakStart()
                .finally(function () {
                _this.sdk.commercialBreak()
                    .then(function () {
                    var _a;
                    (_a = _this.game.analytics) === null || _a === void 0 ? void 0 : _a.sendAdEvent(EGAAdAction.Show, EGAAdType.Interstitial, placement, "poki");
                })
                    .catch(function () {
                    var _a;
                    (_a = _this.game.analytics) === null || _a === void 0 ? void 0 : _a.sendAdEvent(EGAAdAction.FailedShow, EGAAdType.Interstitial, placement, "poki");
                })
                    .finally(function () {
                    _this.onBreakComplete();
                });
            });
        };
        PokiSdkWrapper.prototype.rewardedBreak = function (placement, callbacks) {
            var _this = this;
            var _a;
            if (this.isAdBlockEnabled) {
                this.game.toasts.showNoRewardedAdsWarning();
                return Promise.reject("AdBlock");
            }
            (_a = this.game.analytics) === null || _a === void 0 ? void 0 : _a.sendAdEvent(EGAAdAction.Clicked, EGAAdType.RewardedVideo, placement, "poki");
            return this.onBreakStart()
                .finally(function () {
                _this.sdk.rewardedBreak()
                    .then(function (success) {
                    var _a;
                    (_a = _this.game.analytics) === null || _a === void 0 ? void 0 : _a.sendAdEvent(EGAAdAction.Show, EGAAdType.RewardedVideo, placement, "poki");
                    if (success) {
                        callbacks.onSuccess();
                    }
                    else {
                        callbacks.onCancel && callbacks.onCancel();
                        _this.game.toasts.showRewardedAdsDontSkipWarning();
                    }
                })
                    .catch(function () {
                    var _a;
                    callbacks.onFail && callbacks.onFail();
                    _this.game.toasts.showNoRewardedAdsWarning();
                    (_a = _this.game.analytics) === null || _a === void 0 ? void 0 : _a.sendAdEvent(EGAAdAction.FailedShow, EGAAdType.RewardedVideo, placement, "poki");
                })
                    .finally(function () {
                    _this.onBreakComplete();
                });
            });
        };
        PokiSdkWrapper.prototype.onBreakStart = function () {
            this.wasMuted = this.game.sound.mute;
            this.game.sound.mute = true;
            this.game.canvas.style.pointerEvents = "none";
            this.game.input.keyboard.enabled = false;
            return this.game.audio.suspendAudioContext();
        };
        PokiSdkWrapper.prototype.onBreakComplete = function () {
            this.game.sound.mute = this.wasMuted;
            this.game.canvas.style.pointerEvents = "auto";
            this.game.input.keyboard.enabled = true;
            this.game.audio.resumeAudioContext();
        };
        return PokiSdkWrapper;
    }());
    game.PokiSdkWrapper = PokiSdkWrapper;
})(game || (game = {}));
var game;
(function (game) {
    var RegistryKey;
    (function (RegistryKey) {
        RegistryKey["GAMEPLAY_LOADED"] = "GAMEPLAY_LOADED";
    })(RegistryKey = game.RegistryKey || (game.RegistryKey = {}));
})(game || (game = {}));
var game;
(function (game) {
    var LoadingOverlay = /** @class */ (function () {
        function LoadingOverlay() {
            this.element = document.getElementById("loading-spinner-container");
        }
        LoadingOverlay.prototype.fadeIn = function () {
            this.element.style.display = "flex";
            this.element.style.opacity = "1";
            this.element.classList.remove("spinner-fadeout");
            this.element.classList.add("spinner-fadein");
        };
        LoadingOverlay.prototype.fadeOut = function () {
            var _this = this;
            this.element.classList.remove("spinner-fadein");
            this.element.classList.add("spinner-fadeout");
            setTimeout(function () {
                _this.element.style.display = "none";
            }, 150);
        };
        LoadingOverlay.prototype.isVisible = function () {
            return this.element.style.display === "flex";
        };
        return LoadingOverlay;
    }());
    game.LoadingOverlay = LoadingOverlay;
})(game || (game = {}));
///<reference path='Config.ts' />
///<reference path='GameConfigCreator.ts' />
///<reference path='RavenWrapper.ts' />
///<reference path='GameFonts.ts' />
///<reference path='GameTexts.ts' />
///<reference path='GameStore.ts' />
///<reference path='audio/GameAudio.ts' />
///<reference path='robowhale/phaser3/gameObjects/toast/ToastsManager.ts' />
///<reference path='robowhale/phaser3/gameObjects/container/Screen.ts' />
///<reference path='robowhale/phaser3/gameObjects/buttons/Button.ts' />
///<reference path='robowhale/phaser3/gameObjects/buttons/ToggleButton.ts' />
///<reference path='robowhale/phaser3/gameObjects/buttons/SoundButton.ts' />
///<reference path='robowhale/phaser3/gameObjects/buttons/ComplexButton.ts' />
///<reference path='robowhale/phaser3/camera/KineticScroll.ts' />
///<reference path='robowhale/phaser3/particles/ParticleUtil.ts' />
///<reference path='robowhale/phaser3/AnimationsPool.ts' />
///<reference path='robowhale/utils/NetUtil.ts' />
///<reference path='robowhale/Polyfills.ts' />
///<reference path='robowhale/phaser3/Phaser3Extensions.ts' />
///<reference path='robowhale/phaser3/MatterExtensions.ts' />
///<reference path='robowhale/utils/DeviceUtil.ts' />
///<reference path='robowhale/phaser3/Easing.ts' />
///<reference path='robowhale/phaser3/scenes/BaseScene.ts' />
///<reference path='scenes/SceneKey.ts' />
///<reference path='scenes/Boot.ts' />
///<reference path='scenes/preloader/Preloader.ts' />
///<reference path='scenes/levelsEditor/EditorRoot.ts' />
///<reference path='scenes/levelsMapEditor/LevelsMapEditor.ts' />
///<reference path='scenes/levelsMapDev/LevelsMapDev.ts' />
///<reference path='scenes/levelsMap/LevelsMap.ts' />
///<reference path='scenes/gameplay/GameplayRoot.ts' />
///<reference path='scenes/tutorialEditor/TutorialEditor.ts' />
///<reference path='LevelConfigsManager.ts' />
///<reference path='scenes/global/IngamePreloader.ts' />
///<reference path='boosters/BoostersManager.ts' />
///<reference path='GameAnalyticsWrapper.ts' />
///<reference path='PokiSdkWrapper.ts' />
///<reference path='RegistryKey.ts' />
///<reference path='LoadingOverlay.ts' />
var game;
(function (game) {
    var RendererType;
    (function (RendererType) {
        RendererType["WEBGL"] = "webgl";
        RendererType["CANVAS"] = "canvas";
        RendererType["HEADLESS"] = "headless";
    })(RendererType = game.RendererType || (game.RendererType = {}));
    var Main = /** @class */ (function (_super) {
        __extends(Main, _super);
        function Main() {
            var _this = this;
            Main.detectDevMode();
            Main.detectEditorMode();
            utils.Polyfills.polyfill();
            utils.Phaser3Extensions.extend();
            utils.MatterExtensions.extend();
            // noinspection JSAnnotator
            _this = _super.call(this, game.GameConfigCreator.create()) || this;
            _this.webp = false;
            _this.avif = false;
            _this.fonts = new game.GameFonts(_this);
            _this.store = new game.GameStore(_this, "BouncyWoods");
            _this.loadingOverlay = new game.LoadingOverlay();
            _this.decoratePage();
            _this.addScenes();
            return _this;
        }
        Main.detectDevMode = function () {
            Main.development = utils.NetUtil.getParamBool("dev");
            if (Main.development) {
                console.info("Developer mode is ON");
            }
        };
        Main.detectEditorMode = function () {
            var allowedHosts = ["localhost", "192.168", "robowhale"];
            var isHostAllowed = allowedHosts.some(function (host) { return location.hostname.includes(host); });
            if (isHostAllowed && utils.NetUtil.getParamBool("editor")) {
                Main.editorEnabled = true;
                document.title = document.title + " + Editor";
                console.info("Editor is enabled");
            }
        };
        Main.prototype.decoratePage = function () {
            var isDesktopScaling = this.config.scaleMode === Phaser.Scale.FIT;
            if (isDesktopScaling === false) {
                return;
            }
            this.surroundCanvasWithSidebars(this.canvas);
            this.canvas.style.boxShadow = "0px 0px 5px 5px rgba(0, 0, 0, 0.1)";
            this.scale.updateBounds();
        };
        Main.prototype.getDefaultImageFormat = function (defaultFormat) {
            if (this.avif) {
                return "avif";
            }
            else if (this.webp) {
                return "webp";
            }
            else {
                return defaultFormat;
            }
        };
        Main.prototype.surroundCanvasWithSidebars = function (canvas) {
            var leftSidebar = document.createElement("div");
            leftSidebar.className = "sidebar";
            leftSidebar.id = "left-sidebar";
            canvas.parentNode.insertBefore(leftSidebar, canvas);
            var rightSidebar = document.createElement("div");
            rightSidebar.className = "sidebar";
            rightSidebar.id = "right-sidebar";
            canvas.parentNode.insertBefore(rightSidebar, canvas.nextSibling);
        };
        Main.prototype.addScenes = function () {
            this.scene.add(game.SceneKey.GLOBAL, game.GlobalScene);
            this.scene.add(game.SceneKey.BOOT, game.Boot, true);
            this.scene.add(game.SceneKey.PRELOADER, game.Preloader);
            this.scene.add(game.SceneKey.LEVELS_MAP, game.LevelsMap);
            this.scene.add(game.SceneKey.LEVELS_MAP_DEV, game.LevelsMapDev);
            this.scene.add(game.SceneKey.GAMEPLAY_ROOT, game.GameplayRoot);
            this.scene.add(game.SceneKey.GAMEPLAY, game.Gameplay);
            this.scene.add(game.SceneKey.GAMEPLAY_GUI, game.GameplayGui);
            if (Main.editorEnabled) {
                this.scene.add(game.SceneKey.LEVELS_MAP_EDITOR, game.LevelsMapEditor);
                this.scene.add(game.SceneKey.LEVEL_EDITOR_ROOT, game.EditorRoot);
                this.scene.add(game.SceneKey.LEVEL_EDITOR, game.Editor);
                this.scene.add(game.SceneKey.LEVEL_EDITOR_GUI, game.EditorGui);
                this.scene.add(game.SceneKey.TUTORIAL_EDITOR, game.TutorialEditor);
            }
        };
        Main.prototype.changeScene = function (currentSceneKey, newSceneKey, newSceneData) {
            this.globalScene.sceneTransition.changeScene(currentSceneKey, newSceneKey, newSceneData);
        };
        Main.prototype.restartScene = function (currentScene, data) {
            this.globalScene.sceneTransition.changeScene(currentScene, currentScene, data);
        };
        Main.prototype.injectIntoScenes = function (obj, key) {
            this.scene.scenes.forEach(function (scene) {
                var isKeyTaken = scene.hasOwnProperty(key);
                if (isKeyTaken) {
                    console.warn("Key " + key + " is taken in " + scene.scene.key + " scene!");
                    return;
                }
                scene[key] = obj;
            });
        };
        Main.editorEnabled = false;
        Main.development = false;
        Main.areRewardAdsEnabled = true;
        return Main;
    }(Phaser.Game));
    game.Main = Main;
})(game || (game = {}));
var GameEnvironment;
(function (GameEnvironment) {
    GameEnvironment["DEVELOP"] = "develop";
    GameEnvironment["DEPLOY_WEB"] = "deploy-web";
    GameEnvironment["DEPLOY_POKI"] = "deploy-poki";
})(GameEnvironment || (GameEnvironment = {}));
// @ts-nocheck
var game;
(function (game) {
    function sitelock() {
        if (window.environment !== GameEnvironment.DEPLOY_POKI) {
            return;
        }
        var isIgnoreSitelock = utils.NetUtil.getParamBool("sitelock", "0");
        if (isIgnoreSitelock) {
            return;
        }
        var _0x1918 = ["top", "indexOf", "aHR0cHM6Ly9wb2tpLmNvbS9zaXRlbG9jaw==", "hostname", "length", "location", "LnBva2ktZ2RuLmNvbQ==", "href"];
        (function (_0x4a02b5, _0x5c0c3d) {
            var _0x56a85d = function (_0x375c0e) {
                while (--_0x375c0e) {
                    _0x4a02b5.push(_0x4a02b5.shift());
                }
            };
            _0x56a85d(++_0x5c0c3d);
        }(_0x1918, 0x1ae));
        var _0xcdc9 = function (_0x4a02b5, _0x5c0c3d) {
            _0x4a02b5 -= 0x0;
            var _0x56a85d = _0x1918[_0x4a02b5];
            return _0x56a85d;
        };
        (function checkInit() {
            var _0x151adb = ["bG9jYWxob3N0", "LnBva2kuY29t", _0xcdc9("0x0")];
            var _0x219654 = ![];
            var _0x558823 = window[_0xcdc9("0x7")][_0xcdc9("0x5")];
            for (var _0x220888 = 0x0; _0x220888 < _0x151adb[_0xcdc9('0x6')]; _0x220888++) {
                var _0x4a2f49 = atob(_0x151adb[_0x220888]);
                if (_0x558823[_0xcdc9("0x3")](_0x4a2f49, _0x558823.length - _0x4a2f49.length) !== -0x1) {
                    _0x219654 = !![];
                    break;
                }
            }
            if (!_0x219654) {
                var _0xcff8e8 = _0xcdc9("0x4");
                var _0x3296f7 = atob(_0xcff8e8);
                window.location[_0xcdc9("0x1")] = _0x3296f7;
                window[_0xcdc9("0x2")][_0xcdc9("0x7")] !== window[_0xcdc9("0x7")] && (window[_0xcdc9("0x2")][_0xcdc9("0x7")] = window[_0xcdc9("0x7")]);
            }
        }());
    }
    game.sitelock = sitelock;
})(game || (game = {}));
///<reference path="Main.ts"/>
///<reference path="GameEnvironment.ts"/>
///<reference path='Sitelock.ts' />
window.addEventListener("load", function () {
    game.sitelock();
    game.loadErudaConsole();
    game.startPhaser();
});
var game;
(function (game) {
    function loadErudaConsole() {
        var erudaValue = utils.NetUtil.getParamInt("console");
        if (erudaValue <= 0) {
            logBuildInfo();
            return;
        }
        doLoadErudaConsole(erudaValue);
    }
    game.loadErudaConsole = loadErudaConsole;
    function logBuildInfo() {
        console.info("Build #" + window.game.config.build_version, window.game.config.build_time);
    }
    function doLoadErudaConsole(erudaValue) {
        var body = document.getElementsByTagName("body")[0];
        var script = document.createElement("script");
        script.src = "//cdn.jsdelivr.net/npm/eruda";
        script.type = "text/javascript";
        script.onload = onErudaConsoleLoad.bind(this, erudaValue);
        body.appendChild(script);
    }
    function onErudaConsoleLoad(value) {
        eruda.init({
            tool: ["console", "elements", "info"],
        });
        logBuildInfo();
        if (value === 2) {
            eruda.show();
        }
    }
    function startPhaser() {
        var environment = window.environment;
        var forceRaven = utils.NetUtil.getParamBool("raven");
        if (forceRaven || environment !== GameEnvironment.DEVELOP) {
            setupRaven(environment, forceRaven);
        }
        else {
            createGame();
        }
    }
    game.startPhaser = startPhaser;
    function setupRaven(environment, forceRaven) {
        var options = {
            environment: environment.toString(),
            release: window.game.config.build_version,
            whitelistUrls: ["poki-gdn.com", "robowhale.com"],
            ignoreErrors: ["freed script", "out of memory", "This SourceBuffer has been removed from the parent media source"],
            captureUnhandledRejections: true,
            tags: {
                channel: window.game.config.channel,
            },
        };
        if (forceRaven) {
            options.whitelistUrls.push(location.hostname);
        }
        Raven.config("https://b40f604d5759459ab112987df609ffdc@sentry.io/1883892", options).install();
        Raven.context(function () {
            createGame();
        });
    }
    function createGame() {
        try {
            window["gameInstance"] = new game.Main();
        }
        catch (error) {
            var webgErrors = [
                "WebGL unsupported",
                "Framebuffer status",
                "Vertex Shader failed",
                "Fragment Shader failed",
                "Link Program failed",
            ];
            var isWebglError = webgErrors.some(function (error) { return error.toString().includes(error); });
            var forcedCanvas = location.search.includes("forceCanvas=1");
            if (isWebglError && forcedCanvas === false) {
                console.warn("WebGL Error", error.toString());
                // when webgl renderer has failed we force game to use canvas renderer and reload the page
                if (location.search.indexOf("?") === 0) {
                    location.replace(location.href + "&forceCanvas=1");
                }
                else {
                    location.replace(location.href + "?forceCanvas=1");
                }
            }
            else {
                throw error;
            }
        }
    }
})(game || (game = {}));
//# sourceMappingURL=game.js.map